export default [
  {
    "text": "'Aiea",
    "value": "'aiea"
  },
  {
    "text": "'Ele'ele",
    "value": "'ele'ele"
  },
  {
    "text": "'Ewa Beach",
    "value": "'ewa beach"
  },
  {
    "text": "Aaronsburg",
    "value": "aaronsburg"
  },
  {
    "text": "Abbeville",
    "value": "abbeville"
  },
  {
    "text": "Abbot",
    "value": "abbot"
  },
  {
    "text": "Abbot Village",
    "value": "abbot village"
  },
  {
    "text": "Abbotsford",
    "value": "abbotsford"
  },
  {
    "text": "Abbott",
    "value": "abbott"
  },
  {
    "text": "Abbottstown",
    "value": "abbottstown"
  },
  {
    "text": "Abbyville",
    "value": "abbyville"
  },
  {
    "text": "Abell",
    "value": "abell"
  },
  {
    "text": "Abercrombie",
    "value": "abercrombie"
  },
  {
    "text": "Aberdeen",
    "value": "aberdeen"
  },
  {
    "text": "Aberdeen Proving Ground",
    "value": "aberdeen proving ground"
  },
  {
    "text": "Abernathy",
    "value": "abernathy"
  },
  {
    "text": "Abilene",
    "value": "abilene"
  },
  {
    "text": "Abingdon",
    "value": "abingdon"
  },
  {
    "text": "Abington",
    "value": "abington"
  },
  {
    "text": "Abiquiu",
    "value": "abiquiu"
  },
  {
    "text": "Abita Springs",
    "value": "abita springs"
  },
  {
    "text": "Abrams",
    "value": "abrams"
  },
  {
    "text": "Absaraka",
    "value": "absaraka"
  },
  {
    "text": "Absarokee",
    "value": "absarokee"
  },
  {
    "text": "Absecon",
    "value": "absecon"
  },
  {
    "text": "Acampo",
    "value": "acampo"
  },
  {
    "text": "Accident",
    "value": "accident"
  },
  {
    "text": "Accokeek",
    "value": "accokeek"
  },
  {
    "text": "Accomac",
    "value": "accomac"
  },
  {
    "text": "Accord",
    "value": "accord"
  },
  {
    "text": "Accoville",
    "value": "accoville"
  },
  {
    "text": "Ace",
    "value": "ace"
  },
  {
    "text": "Achille",
    "value": "achille"
  },
  {
    "text": "Ackerly",
    "value": "ackerly"
  },
  {
    "text": "Ackerman",
    "value": "ackerman"
  },
  {
    "text": "Ackley",
    "value": "ackley"
  },
  {
    "text": "Ackworth",
    "value": "ackworth"
  },
  {
    "text": "Acme",
    "value": "acme"
  },
  {
    "text": "Acoma Pueblo",
    "value": "acoma pueblo"
  },
  {
    "text": "Acra",
    "value": "acra"
  },
  {
    "text": "Acton",
    "value": "acton"
  },
  {
    "text": "Acushnet",
    "value": "acushnet"
  },
  {
    "text": "Acworth",
    "value": "acworth"
  },
  {
    "text": "Ada",
    "value": "ada"
  },
  {
    "text": "Adah",
    "value": "adah"
  },
  {
    "text": "Adair",
    "value": "adair"
  },
  {
    "text": "Adairsville",
    "value": "adairsville"
  },
  {
    "text": "Adairville",
    "value": "adairville"
  },
  {
    "text": "Adak",
    "value": "adak"
  },
  {
    "text": "Adamant",
    "value": "adamant"
  },
  {
    "text": "Adams",
    "value": "adams"
  },
  {
    "text": "Adams Center",
    "value": "adams center"
  },
  {
    "text": "Adams Run",
    "value": "adams run"
  },
  {
    "text": "Adamsburg",
    "value": "adamsburg"
  },
  {
    "text": "Adamstown",
    "value": "adamstown"
  },
  {
    "text": "Adamsville",
    "value": "adamsville"
  },
  {
    "text": "Addieville",
    "value": "addieville"
  },
  {
    "text": "Addington",
    "value": "addington"
  },
  {
    "text": "Addis",
    "value": "addis"
  },
  {
    "text": "Addison",
    "value": "addison"
  },
  {
    "text": "Addy",
    "value": "addy"
  },
  {
    "text": "Addyston",
    "value": "addyston"
  },
  {
    "text": "Adel",
    "value": "adel"
  },
  {
    "text": "Adelanto",
    "value": "adelanto"
  },
  {
    "text": "Adell",
    "value": "adell"
  },
  {
    "text": "Adelphi",
    "value": "adelphi"
  },
  {
    "text": "Adelphia",
    "value": "adelphia"
  },
  {
    "text": "Adena",
    "value": "adena"
  },
  {
    "text": "Adger",
    "value": "adger"
  },
  {
    "text": "Adin",
    "value": "adin"
  },
  {
    "text": "Adirondack",
    "value": "adirondack"
  },
  {
    "text": "Adkins",
    "value": "adkins"
  },
  {
    "text": "Admire",
    "value": "admire"
  },
  {
    "text": "Adna",
    "value": "adna"
  },
  {
    "text": "Adolphus",
    "value": "adolphus"
  },
  {
    "text": "Adona",
    "value": "adona"
  },
  {
    "text": "Adrian",
    "value": "adrian"
  },
  {
    "text": "Advance",
    "value": "advance"
  },
  {
    "text": "Advance Mills",
    "value": "advance mills"
  },
  {
    "text": "Adwolf",
    "value": "adwolf"
  },
  {
    "text": "Affton",
    "value": "affton"
  },
  {
    "text": "Afton",
    "value": "afton"
  },
  {
    "text": "Agar",
    "value": "agar"
  },
  {
    "text": "Agate",
    "value": "agate"
  },
  {
    "text": "Agawam",
    "value": "agawam"
  },
  {
    "text": "Agency",
    "value": "agency"
  },
  {
    "text": "Agenda",
    "value": "agenda"
  },
  {
    "text": "Ages",
    "value": "ages"
  },
  {
    "text": "Agness",
    "value": "agness"
  },
  {
    "text": "Agoura",
    "value": "agoura"
  },
  {
    "text": "Agoura Hills",
    "value": "agoura hills"
  },
  {
    "text": "Agra",
    "value": "agra"
  },
  {
    "text": "Agua Dulce",
    "value": "agua dulce"
  },
  {
    "text": "Aguanga",
    "value": "aguanga"
  },
  {
    "text": "Aguila",
    "value": "aguila"
  },
  {
    "text": "Aguilar",
    "value": "aguilar"
  },
  {
    "text": "Ahmeek",
    "value": "ahmeek"
  },
  {
    "text": "Ahoskie",
    "value": "ahoskie"
  },
  {
    "text": "Ahsahka",
    "value": "ahsahka"
  },
  {
    "text": "Ahwahnee",
    "value": "ahwahnee"
  },
  {
    "text": "Aiea",
    "value": "aiea"
  },
  {
    "text": "Aiken",
    "value": "aiken"
  },
  {
    "text": "Ailey",
    "value": "ailey"
  },
  {
    "text": "Ainaloa",
    "value": "ainaloa"
  },
  {
    "text": "Ainsworth",
    "value": "ainsworth"
  },
  {
    "text": "Air Force Academy",
    "value": "air force academy"
  },
  {
    "text": "Airmont",
    "value": "airmont"
  },
  {
    "text": "Airville",
    "value": "airville"
  },
  {
    "text": "Airway Heights",
    "value": "airway heights"
  },
  {
    "text": "Aitkin",
    "value": "aitkin"
  },
  {
    "text": "Ajo",
    "value": "ajo"
  },
  {
    "text": "Akeley",
    "value": "akeley"
  },
  {
    "text": "Akiachak",
    "value": "akiachak"
  },
  {
    "text": "Akiak",
    "value": "akiak"
  },
  {
    "text": "Akron",
    "value": "akron"
  },
  {
    "text": "Akutan",
    "value": "akutan"
  },
  {
    "text": "Alabama",
    "value": "alabama"
  },
  {
    "text": "Alabaster",
    "value": "alabaster"
  },
  {
    "text": "Alachua",
    "value": "alachua"
  },
  {
    "text": "Aladdin",
    "value": "aladdin"
  },
  {
    "text": "Alafaya",
    "value": "alafaya"
  },
  {
    "text": "Alakanuk",
    "value": "alakanuk"
  },
  {
    "text": "Alamance",
    "value": "alamance"
  },
  {
    "text": "Alameda",
    "value": "alameda"
  },
  {
    "text": "Alamo",
    "value": "alamo"
  },
  {
    "text": "Alamo Heights",
    "value": "alamo heights"
  },
  {
    "text": "Alamogordo",
    "value": "alamogordo"
  },
  {
    "text": "Alamosa",
    "value": "alamosa"
  },
  {
    "text": "Alanson",
    "value": "alanson"
  },
  {
    "text": "Alapaha",
    "value": "alapaha"
  },
  {
    "text": "Alba",
    "value": "alba"
  },
  {
    "text": "Albany",
    "value": "albany"
  },
  {
    "text": "Albemarle",
    "value": "albemarle"
  },
  {
    "text": "Albers",
    "value": "albers"
  },
  {
    "text": "Albert",
    "value": "albert"
  },
  {
    "text": "Albert City",
    "value": "albert city"
  },
  {
    "text": "Albert Lea",
    "value": "albert lea"
  },
  {
    "text": "Alberta",
    "value": "alberta"
  },
  {
    "text": "Alberton",
    "value": "alberton"
  },
  {
    "text": "Albertson",
    "value": "albertson"
  },
  {
    "text": "Albertville",
    "value": "albertville"
  },
  {
    "text": "Albia",
    "value": "albia"
  },
  {
    "text": "Albin",
    "value": "albin"
  },
  {
    "text": "Albion",
    "value": "albion"
  },
  {
    "text": "Alborn",
    "value": "alborn"
  },
  {
    "text": "Albright",
    "value": "albright"
  },
  {
    "text": "Albrightsville",
    "value": "albrightsville"
  },
  {
    "text": "Albuquerque",
    "value": "albuquerque"
  },
  {
    "text": "Alburg",
    "value": "alburg"
  },
  {
    "text": "Alburnett",
    "value": "alburnett"
  },
  {
    "text": "Alburtis",
    "value": "alburtis"
  },
  {
    "text": "Alcalde",
    "value": "alcalde"
  },
  {
    "text": "Alcester",
    "value": "alcester"
  },
  {
    "text": "Alcoa",
    "value": "alcoa"
  },
  {
    "text": "Alcolu",
    "value": "alcolu"
  },
  {
    "text": "Alcova",
    "value": "alcova"
  },
  {
    "text": "Alda",
    "value": "alda"
  },
  {
    "text": "Alden",
    "value": "alden"
  },
  {
    "text": "Alder",
    "value": "alder"
  },
  {
    "text": "Alder Creek",
    "value": "alder creek"
  },
  {
    "text": "Alderpoint",
    "value": "alderpoint"
  },
  {
    "text": "Alderson",
    "value": "alderson"
  },
  {
    "text": "Alderton",
    "value": "alderton"
  },
  {
    "text": "Aldie",
    "value": "aldie"
  },
  {
    "text": "Aldine",
    "value": "aldine"
  },
  {
    "text": "Aldrich",
    "value": "aldrich"
  },
  {
    "text": "Aledo",
    "value": "aledo"
  },
  {
    "text": "Aleppo",
    "value": "aleppo"
  },
  {
    "text": "Alex",
    "value": "alex"
  },
  {
    "text": "Alexander",
    "value": "alexander"
  },
  {
    "text": "Alexander City",
    "value": "alexander city"
  },
  {
    "text": "Alexandria",
    "value": "alexandria"
  },
  {
    "text": "Alexandria Bay",
    "value": "alexandria bay"
  },
  {
    "text": "Alexis",
    "value": "alexis"
  },
  {
    "text": "Alford",
    "value": "alford"
  },
  {
    "text": "Alfred",
    "value": "alfred"
  },
  {
    "text": "Alfred Station",
    "value": "alfred station"
  },
  {
    "text": "Alger",
    "value": "alger"
  },
  {
    "text": "Algodones",
    "value": "algodones"
  },
  {
    "text": "Algoma",
    "value": "algoma"
  },
  {
    "text": "Algona",
    "value": "algona"
  },
  {
    "text": "Algonac",
    "value": "algonac"
  },
  {
    "text": "Algonquin",
    "value": "algonquin"
  },
  {
    "text": "Algood",
    "value": "algood"
  },
  {
    "text": "Alhambra",
    "value": "alhambra"
  },
  {
    "text": "Alice",
    "value": "alice"
  },
  {
    "text": "Aliceville",
    "value": "aliceville"
  },
  {
    "text": "Alicia",
    "value": "alicia"
  },
  {
    "text": "Alief",
    "value": "alief"
  },
  {
    "text": "Aliquippa",
    "value": "aliquippa"
  },
  {
    "text": "Aliso Viejo",
    "value": "aliso viejo"
  },
  {
    "text": "Alkol",
    "value": "alkol"
  },
  {
    "text": "Allamuchy",
    "value": "allamuchy"
  },
  {
    "text": "Alledonia",
    "value": "alledonia"
  },
  {
    "text": "Allegan",
    "value": "allegan"
  },
  {
    "text": "Allegany",
    "value": "allegany"
  },
  {
    "text": "Alleman",
    "value": "alleman"
  },
  {
    "text": "Allen",
    "value": "allen"
  },
  {
    "text": "Allen City",
    "value": "allen city"
  },
  {
    "text": "Allen Park",
    "value": "allen park"
  },
  {
    "text": "Allendale",
    "value": "allendale"
  },
  {
    "text": "Allenhurst",
    "value": "allenhurst"
  },
  {
    "text": "Allenport",
    "value": "allenport"
  },
  {
    "text": "Allenspark",
    "value": "allenspark"
  },
  {
    "text": "Allensville",
    "value": "allensville"
  },
  {
    "text": "Allensworth",
    "value": "allensworth"
  },
  {
    "text": "Allenton",
    "value": "allenton"
  },
  {
    "text": "Allentown",
    "value": "allentown"
  },
  {
    "text": "Allenwood",
    "value": "allenwood"
  },
  {
    "text": "Allerton",
    "value": "allerton"
  },
  {
    "text": "Alleyton",
    "value": "alleyton"
  },
  {
    "text": "Alliance",
    "value": "alliance"
  },
  {
    "text": "Alligator",
    "value": "alligator"
  },
  {
    "text": "Allison",
    "value": "allison"
  },
  {
    "text": "Allison Park",
    "value": "allison park"
  },
  {
    "text": "Allons",
    "value": "allons"
  },
  {
    "text": "Allouez",
    "value": "allouez"
  },
  {
    "text": "Alloway",
    "value": "alloway"
  },
  {
    "text": "Alloy",
    "value": "alloy"
  },
  {
    "text": "Allport",
    "value": "allport"
  },
  {
    "text": "Allston",
    "value": "allston"
  },
  {
    "text": "Allyn",
    "value": "allyn"
  },
  {
    "text": "Alma",
    "value": "alma"
  },
  {
    "text": "Alma Center",
    "value": "alma center"
  },
  {
    "text": "Almena",
    "value": "almena"
  },
  {
    "text": "Almira",
    "value": "almira"
  },
  {
    "text": "Almo",
    "value": "almo"
  },
  {
    "text": "Almond",
    "value": "almond"
  },
  {
    "text": "Almont",
    "value": "almont"
  },
  {
    "text": "Almyra",
    "value": "almyra"
  },
  {
    "text": "Alna",
    "value": "alna"
  },
  {
    "text": "Aloha",
    "value": "aloha"
  },
  {
    "text": "Alondra Park",
    "value": "alondra park"
  },
  {
    "text": "Alorton",
    "value": "alorton"
  },
  {
    "text": "Alpaugh",
    "value": "alpaugh"
  },
  {
    "text": "Alpena",
    "value": "alpena"
  },
  {
    "text": "Alpha",
    "value": "alpha"
  },
  {
    "text": "Alpharetta",
    "value": "alpharetta"
  },
  {
    "text": "Alpine",
    "value": "alpine"
  },
  {
    "text": "Alplaus",
    "value": "alplaus"
  },
  {
    "text": "Alsea",
    "value": "alsea"
  },
  {
    "text": "Alsen",
    "value": "alsen"
  },
  {
    "text": "Alsey",
    "value": "alsey"
  },
  {
    "text": "Alsip",
    "value": "alsip"
  },
  {
    "text": "Alstead",
    "value": "alstead"
  },
  {
    "text": "Alston",
    "value": "alston"
  },
  {
    "text": "Alta",
    "value": "alta"
  },
  {
    "text": "Alta Loma",
    "value": "alta loma"
  },
  {
    "text": "Alta Sierra",
    "value": "alta sierra"
  },
  {
    "text": "Alta Vista",
    "value": "alta vista"
  },
  {
    "text": "Altadena",
    "value": "altadena"
  },
  {
    "text": "Altair",
    "value": "altair"
  },
  {
    "text": "Altamahaw",
    "value": "altamahaw"
  },
  {
    "text": "Altamont",
    "value": "altamont"
  },
  {
    "text": "Altamonte Springs",
    "value": "altamonte springs"
  },
  {
    "text": "Altaville",
    "value": "altaville"
  },
  {
    "text": "Altavista",
    "value": "altavista"
  },
  {
    "text": "Altenburg",
    "value": "altenburg"
  },
  {
    "text": "Altha",
    "value": "altha"
  },
  {
    "text": "Altheimer",
    "value": "altheimer"
  },
  {
    "text": "Altmar",
    "value": "altmar"
  },
  {
    "text": "Alto",
    "value": "alto"
  },
  {
    "text": "Alto Pass",
    "value": "alto pass"
  },
  {
    "text": "Alton",
    "value": "alton"
  },
  {
    "text": "Alton Bay",
    "value": "alton bay"
  },
  {
    "text": "Altona",
    "value": "altona"
  },
  {
    "text": "Altonah",
    "value": "altonah"
  },
  {
    "text": "Altoona",
    "value": "altoona"
  },
  {
    "text": "Altura",
    "value": "altura"
  },
  {
    "text": "Alturas",
    "value": "alturas"
  },
  {
    "text": "Altus",
    "value": "altus"
  },
  {
    "text": "Altus Air Force Base",
    "value": "altus air force base"
  },
  {
    "text": "Alum Bank",
    "value": "alum bank"
  },
  {
    "text": "Alum Creek",
    "value": "alum creek"
  },
  {
    "text": "Alum Rock",
    "value": "alum rock"
  },
  {
    "text": "Alva",
    "value": "alva"
  },
  {
    "text": "Alvada",
    "value": "alvada"
  },
  {
    "text": "Alvarado",
    "value": "alvarado"
  },
  {
    "text": "Alvaton",
    "value": "alvaton"
  },
  {
    "text": "Alverda",
    "value": "alverda"
  },
  {
    "text": "Alverton",
    "value": "alverton"
  },
  {
    "text": "Alvin",
    "value": "alvin"
  },
  {
    "text": "Alviso",
    "value": "alviso"
  },
  {
    "text": "Alvo",
    "value": "alvo"
  },
  {
    "text": "Alvord",
    "value": "alvord"
  },
  {
    "text": "Alvordton",
    "value": "alvordton"
  },
  {
    "text": "Alzada",
    "value": "alzada"
  },
  {
    "text": "Ama",
    "value": "ama"
  },
  {
    "text": "Amado",
    "value": "amado"
  },
  {
    "text": "Amador City",
    "value": "amador city"
  },
  {
    "text": "Amagansett",
    "value": "amagansett"
  },
  {
    "text": "Amalia",
    "value": "amalia"
  },
  {
    "text": "Amana",
    "value": "amana"
  },
  {
    "text": "Amanda",
    "value": "amanda"
  },
  {
    "text": "Amanda Park",
    "value": "amanda park"
  },
  {
    "text": "Amargosa Valley",
    "value": "amargosa valley"
  },
  {
    "text": "Amarillo",
    "value": "amarillo"
  },
  {
    "text": "Amasa",
    "value": "amasa"
  },
  {
    "text": "Amawalk",
    "value": "amawalk"
  },
  {
    "text": "Amazonia",
    "value": "amazonia"
  },
  {
    "text": "Amber",
    "value": "amber"
  },
  {
    "text": "Amberg",
    "value": "amberg"
  },
  {
    "text": "Amberley",
    "value": "amberley"
  },
  {
    "text": "Amberson",
    "value": "amberson"
  },
  {
    "text": "Ambia",
    "value": "ambia"
  },
  {
    "text": "Ambler",
    "value": "ambler"
  },
  {
    "text": "Amboy",
    "value": "amboy"
  },
  {
    "text": "Ambridge",
    "value": "ambridge"
  },
  {
    "text": "Ambrose",
    "value": "ambrose"
  },
  {
    "text": "Amelia",
    "value": "amelia"
  },
  {
    "text": "Amelia Court House",
    "value": "amelia court house"
  },
  {
    "text": "Amenia",
    "value": "amenia"
  },
  {
    "text": "American Canyon",
    "value": "american canyon"
  },
  {
    "text": "American Falls",
    "value": "american falls"
  },
  {
    "text": "American Fork",
    "value": "american fork"
  },
  {
    "text": "Americus",
    "value": "americus"
  },
  {
    "text": "Amery",
    "value": "amery"
  },
  {
    "text": "Ames",
    "value": "ames"
  },
  {
    "text": "Ames Lake",
    "value": "ames lake"
  },
  {
    "text": "Amesbury",
    "value": "amesbury"
  },
  {
    "text": "Amesville",
    "value": "amesville"
  },
  {
    "text": "Amherst",
    "value": "amherst"
  },
  {
    "text": "Amherst Junction",
    "value": "amherst junction"
  },
  {
    "text": "Amherstdale",
    "value": "amherstdale"
  },
  {
    "text": "Amidon",
    "value": "amidon"
  },
  {
    "text": "Amissville",
    "value": "amissville"
  },
  {
    "text": "Amistad",
    "value": "amistad"
  },
  {
    "text": "Amite",
    "value": "amite"
  },
  {
    "text": "Amity",
    "value": "amity"
  },
  {
    "text": "Amityville",
    "value": "amityville"
  },
  {
    "text": "Amma",
    "value": "amma"
  },
  {
    "text": "Ammon",
    "value": "ammon"
  },
  {
    "text": "Amo",
    "value": "amo"
  },
  {
    "text": "Amoret",
    "value": "amoret"
  },
  {
    "text": "Amorita",
    "value": "amorita"
  },
  {
    "text": "Amory",
    "value": "amory"
  },
  {
    "text": "Amsterdam",
    "value": "amsterdam"
  },
  {
    "text": "Amston",
    "value": "amston"
  },
  {
    "text": "Anabel",
    "value": "anabel"
  },
  {
    "text": "Anacoco",
    "value": "anacoco"
  },
  {
    "text": "Anaconda",
    "value": "anaconda"
  },
  {
    "text": "Anacortes",
    "value": "anacortes"
  },
  {
    "text": "Anadarko",
    "value": "anadarko"
  },
  {
    "text": "Anaheim",
    "value": "anaheim"
  },
  {
    "text": "Anahola",
    "value": "anahola"
  },
  {
    "text": "Anahuac",
    "value": "anahuac"
  },
  {
    "text": "Anaktuvuk Pass",
    "value": "anaktuvuk pass"
  },
  {
    "text": "Analomink",
    "value": "analomink"
  },
  {
    "text": "Anamoose",
    "value": "anamoose"
  },
  {
    "text": "Anamosa",
    "value": "anamosa"
  },
  {
    "text": "Anatone",
    "value": "anatone"
  },
  {
    "text": "Anchor",
    "value": "anchor"
  },
  {
    "text": "Anchor Point",
    "value": "anchor point"
  },
  {
    "text": "Anchorage",
    "value": "anchorage"
  },
  {
    "text": "Ancona",
    "value": "ancona"
  },
  {
    "text": "Ancram",
    "value": "ancram"
  },
  {
    "text": "Ancramdale",
    "value": "ancramdale"
  },
  {
    "text": "Andale",
    "value": "andale"
  },
  {
    "text": "Andalusia",
    "value": "andalusia"
  },
  {
    "text": "Anderson",
    "value": "anderson"
  },
  {
    "text": "Anderson Island",
    "value": "anderson island"
  },
  {
    "text": "Andersonville",
    "value": "andersonville"
  },
  {
    "text": "Andes",
    "value": "andes"
  },
  {
    "text": "Andover",
    "value": "andover"
  },
  {
    "text": "Andreas",
    "value": "andreas"
  },
  {
    "text": "Andrew",
    "value": "andrew"
  },
  {
    "text": "Andrews",
    "value": "andrews"
  },
  {
    "text": "Andrews Air Force Base",
    "value": "andrews air force base"
  },
  {
    "text": "Andrews Air Force Base Census Designated Place",
    "value": "andrews air force base census designated place"
  },
  {
    "text": "Aneta",
    "value": "aneta"
  },
  {
    "text": "Angel Fire",
    "value": "angel fire"
  },
  {
    "text": "Angelica",
    "value": "angelica"
  },
  {
    "text": "Angels Camp",
    "value": "angels camp"
  },
  {
    "text": "Angelus Oaks",
    "value": "angelus oaks"
  },
  {
    "text": "Angie",
    "value": "angie"
  },
  {
    "text": "Angier",
    "value": "angier"
  },
  {
    "text": "Angle Inlet",
    "value": "angle inlet"
  },
  {
    "text": "Angleton",
    "value": "angleton"
  },
  {
    "text": "Angola",
    "value": "angola"
  },
  {
    "text": "Angoon",
    "value": "angoon"
  },
  {
    "text": "Angora",
    "value": "angora"
  },
  {
    "text": "Anguilla",
    "value": "anguilla"
  },
  {
    "text": "Angus",
    "value": "angus"
  },
  {
    "text": "Angwin",
    "value": "angwin"
  },
  {
    "text": "Aniak",
    "value": "aniak"
  },
  {
    "text": "Animas",
    "value": "animas"
  },
  {
    "text": "Anita",
    "value": "anita"
  },
  {
    "text": "Aniwa",
    "value": "aniwa"
  },
  {
    "text": "Ankeny",
    "value": "ankeny"
  },
  {
    "text": "Anmoore",
    "value": "anmoore"
  },
  {
    "text": "Ann Arbor",
    "value": "ann arbor"
  },
  {
    "text": "Anna",
    "value": "anna"
  },
  {
    "text": "Anna Maria",
    "value": "anna maria"
  },
  {
    "text": "Annabella",
    "value": "annabella"
  },
  {
    "text": "Annandale",
    "value": "annandale"
  },
  {
    "text": "Annandale-on-Hudson",
    "value": "annandale-on-hudson"
  },
  {
    "text": "Annapolis",
    "value": "annapolis"
  },
  {
    "text": "Annapolis Junction",
    "value": "annapolis junction"
  },
  {
    "text": "Annawan",
    "value": "annawan"
  },
  {
    "text": "Annetta",
    "value": "annetta"
  },
  {
    "text": "Anniston",
    "value": "anniston"
  },
  {
    "text": "Annona",
    "value": "annona"
  },
  {
    "text": "Annville",
    "value": "annville"
  },
  {
    "text": "Anoka",
    "value": "anoka"
  },
  {
    "text": "Anselmo",
    "value": "anselmo"
  },
  {
    "text": "Ansley",
    "value": "ansley"
  },
  {
    "text": "Anson",
    "value": "anson"
  },
  {
    "text": "Ansonia",
    "value": "ansonia"
  },
  {
    "text": "Ansonville",
    "value": "ansonville"
  },
  {
    "text": "Ansted",
    "value": "ansted"
  },
  {
    "text": "Antelope",
    "value": "antelope"
  },
  {
    "text": "Anthem",
    "value": "anthem"
  },
  {
    "text": "Anthon",
    "value": "anthon"
  },
  {
    "text": "Anthony",
    "value": "anthony"
  },
  {
    "text": "Antigo",
    "value": "antigo"
  },
  {
    "text": "Antimony",
    "value": "antimony"
  },
  {
    "text": "Antioch",
    "value": "antioch"
  },
  {
    "text": "Antler",
    "value": "antler"
  },
  {
    "text": "Antlers",
    "value": "antlers"
  },
  {
    "text": "Anton",
    "value": "anton"
  },
  {
    "text": "Anton Chico",
    "value": "anton chico"
  },
  {
    "text": "Antonito",
    "value": "antonito"
  },
  {
    "text": "Antrim",
    "value": "antrim"
  },
  {
    "text": "Antwerp",
    "value": "antwerp"
  },
  {
    "text": "Anvik",
    "value": "anvik"
  },
  {
    "text": "Anza",
    "value": "anza"
  },
  {
    "text": "Apache",
    "value": "apache"
  },
  {
    "text": "Apache Junction",
    "value": "apache junction"
  },
  {
    "text": "Apalachicola",
    "value": "apalachicola"
  },
  {
    "text": "Apalachin",
    "value": "apalachin"
  },
  {
    "text": "Apex",
    "value": "apex"
  },
  {
    "text": "Apison",
    "value": "apison"
  },
  {
    "text": "Aplington",
    "value": "aplington"
  },
  {
    "text": "Apollo",
    "value": "apollo"
  },
  {
    "text": "Apollo Beach",
    "value": "apollo beach"
  },
  {
    "text": "Apopka",
    "value": "apopka"
  },
  {
    "text": "Appalachia",
    "value": "appalachia"
  },
  {
    "text": "Apple Creek",
    "value": "apple creek"
  },
  {
    "text": "Apple Grove",
    "value": "apple grove"
  },
  {
    "text": "Apple River",
    "value": "apple river"
  },
  {
    "text": "Apple Springs",
    "value": "apple springs"
  },
  {
    "text": "Apple Valley",
    "value": "apple valley"
  },
  {
    "text": "Applegate",
    "value": "applegate"
  },
  {
    "text": "Appleton",
    "value": "appleton"
  },
  {
    "text": "Appleton City",
    "value": "appleton city"
  },
  {
    "text": "Appling",
    "value": "appling"
  },
  {
    "text": "Appomattox",
    "value": "appomattox"
  },
  {
    "text": "Aptos",
    "value": "aptos"
  },
  {
    "text": "Aquasco",
    "value": "aquasco"
  },
  {
    "text": "Aquebogue",
    "value": "aquebogue"
  },
  {
    "text": "Aquilla",
    "value": "aquilla"
  },
  {
    "text": "Arab",
    "value": "arab"
  },
  {
    "text": "Arabi",
    "value": "arabi"
  },
  {
    "text": "Arago",
    "value": "arago"
  },
  {
    "text": "Aragon",
    "value": "aragon"
  },
  {
    "text": "Aransas Pass",
    "value": "aransas pass"
  },
  {
    "text": "Arapaho",
    "value": "arapaho"
  },
  {
    "text": "Arapahoe",
    "value": "arapahoe"
  },
  {
    "text": "Ararat",
    "value": "ararat"
  },
  {
    "text": "Arbela",
    "value": "arbela"
  },
  {
    "text": "Arboles",
    "value": "arboles"
  },
  {
    "text": "Arbon",
    "value": "arbon"
  },
  {
    "text": "Arbovale",
    "value": "arbovale"
  },
  {
    "text": "Arbuckle",
    "value": "arbuckle"
  },
  {
    "text": "Arbutus",
    "value": "arbutus"
  },
  {
    "text": "Arbyrd",
    "value": "arbyrd"
  },
  {
    "text": "Arcade",
    "value": "arcade"
  },
  {
    "text": "Arcadia",
    "value": "arcadia"
  },
  {
    "text": "Arcanum",
    "value": "arcanum"
  },
  {
    "text": "Arcata",
    "value": "arcata"
  },
  {
    "text": "Arch Cape",
    "value": "arch cape"
  },
  {
    "text": "Archbald",
    "value": "archbald"
  },
  {
    "text": "Archbold",
    "value": "archbold"
  },
  {
    "text": "Archdale",
    "value": "archdale"
  },
  {
    "text": "Archer",
    "value": "archer"
  },
  {
    "text": "Archer City",
    "value": "archer city"
  },
  {
    "text": "Archer Lodge",
    "value": "archer lodge"
  },
  {
    "text": "Archibald",
    "value": "archibald"
  },
  {
    "text": "Archie",
    "value": "archie"
  },
  {
    "text": "Arco",
    "value": "arco"
  },
  {
    "text": "Arcola",
    "value": "arcola"
  },
  {
    "text": "Arctic Village",
    "value": "arctic village"
  },
  {
    "text": "Ardara",
    "value": "ardara"
  },
  {
    "text": "Arden",
    "value": "arden"
  },
  {
    "text": "Arden Hills",
    "value": "arden hills"
  },
  {
    "text": "Ardenvoir",
    "value": "ardenvoir"
  },
  {
    "text": "Ardmore",
    "value": "ardmore"
  },
  {
    "text": "Ardsley",
    "value": "ardsley"
  },
  {
    "text": "Ardsley-on-Hudson",
    "value": "ardsley-on-hudson"
  },
  {
    "text": "Arena",
    "value": "arena"
  },
  {
    "text": "Arenas Valley",
    "value": "arenas valley"
  },
  {
    "text": "Arendtsville",
    "value": "arendtsville"
  },
  {
    "text": "Arenzville",
    "value": "arenzville"
  },
  {
    "text": "Argenta",
    "value": "argenta"
  },
  {
    "text": "Argillite",
    "value": "argillite"
  },
  {
    "text": "Argonia",
    "value": "argonia"
  },
  {
    "text": "Argonne",
    "value": "argonne"
  },
  {
    "text": "Argos",
    "value": "argos"
  },
  {
    "text": "Argusville",
    "value": "argusville"
  },
  {
    "text": "Argyle",
    "value": "argyle"
  },
  {
    "text": "Arial",
    "value": "arial"
  },
  {
    "text": "Ariel",
    "value": "ariel"
  },
  {
    "text": "Arimo",
    "value": "arimo"
  },
  {
    "text": "Arion",
    "value": "arion"
  },
  {
    "text": "Aripeka",
    "value": "aripeka"
  },
  {
    "text": "Arispe",
    "value": "arispe"
  },
  {
    "text": "Ariton",
    "value": "ariton"
  },
  {
    "text": "Arivaca",
    "value": "arivaca"
  },
  {
    "text": "Arizona City",
    "value": "arizona city"
  },
  {
    "text": "Arjay",
    "value": "arjay"
  },
  {
    "text": "Ark",
    "value": "ark"
  },
  {
    "text": "Arkadelphia",
    "value": "arkadelphia"
  },
  {
    "text": "Arkansas City",
    "value": "arkansas city"
  },
  {
    "text": "Arkansaw",
    "value": "arkansaw"
  },
  {
    "text": "Arkdale",
    "value": "arkdale"
  },
  {
    "text": "Arkoma",
    "value": "arkoma"
  },
  {
    "text": "Arkport",
    "value": "arkport"
  },
  {
    "text": "Arkville",
    "value": "arkville"
  },
  {
    "text": "Arlee",
    "value": "arlee"
  },
  {
    "text": "Arley",
    "value": "arley"
  },
  {
    "text": "Arlington",
    "value": "arlington"
  },
  {
    "text": "Arlington Heights",
    "value": "arlington heights"
  },
  {
    "text": "Arma",
    "value": "arma"
  },
  {
    "text": "Armada",
    "value": "armada"
  },
  {
    "text": "Armagh",
    "value": "armagh"
  },
  {
    "text": "Armington",
    "value": "armington"
  },
  {
    "text": "Armona",
    "value": "armona"
  },
  {
    "text": "Armonk",
    "value": "armonk"
  },
  {
    "text": "Armorel",
    "value": "armorel"
  },
  {
    "text": "Armour",
    "value": "armour"
  },
  {
    "text": "Armstrong",
    "value": "armstrong"
  },
  {
    "text": "Armstrong Creek",
    "value": "armstrong creek"
  },
  {
    "text": "Armuchee",
    "value": "armuchee"
  },
  {
    "text": "Arnaudville",
    "value": "arnaudville"
  },
  {
    "text": "Arnegard",
    "value": "arnegard"
  },
  {
    "text": "Arnett",
    "value": "arnett"
  },
  {
    "text": "Arnold",
    "value": "arnold"
  },
  {
    "text": "Arnold Air Force Base",
    "value": "arnold air force base"
  },
  {
    "text": "Arnolds Park",
    "value": "arnolds park"
  },
  {
    "text": "Arnoldsburg",
    "value": "arnoldsburg"
  },
  {
    "text": "Arnoldsville",
    "value": "arnoldsville"
  },
  {
    "text": "Aroda",
    "value": "aroda"
  },
  {
    "text": "Aroma Park",
    "value": "aroma park"
  },
  {
    "text": "Aromas",
    "value": "aromas"
  },
  {
    "text": "Arp",
    "value": "arp"
  },
  {
    "text": "Arpin",
    "value": "arpin"
  },
  {
    "text": "Arrey",
    "value": "arrey"
  },
  {
    "text": "Arriba",
    "value": "arriba"
  },
  {
    "text": "Arrington",
    "value": "arrington"
  },
  {
    "text": "Arrow Rock",
    "value": "arrow rock"
  },
  {
    "text": "Arrowsmith",
    "value": "arrowsmith"
  },
  {
    "text": "Arroyo Grande",
    "value": "arroyo grande"
  },
  {
    "text": "Arroyo Hondo",
    "value": "arroyo hondo"
  },
  {
    "text": "Arroyo Seco",
    "value": "arroyo seco"
  },
  {
    "text": "Artemas",
    "value": "artemas"
  },
  {
    "text": "Artemus",
    "value": "artemus"
  },
  {
    "text": "Artesia",
    "value": "artesia"
  },
  {
    "text": "Artesia Wells",
    "value": "artesia wells"
  },
  {
    "text": "Artesian",
    "value": "artesian"
  },
  {
    "text": "Arthur",
    "value": "arthur"
  },
  {
    "text": "Arthur City",
    "value": "arthur city"
  },
  {
    "text": "Arthurdale",
    "value": "arthurdale"
  },
  {
    "text": "Artois",
    "value": "artois"
  },
  {
    "text": "Arundel",
    "value": "arundel"
  },
  {
    "text": "Arvada",
    "value": "arvada"
  },
  {
    "text": "Arverne",
    "value": "arverne"
  },
  {
    "text": "Arvilla",
    "value": "arvilla"
  },
  {
    "text": "Arvin",
    "value": "arvin"
  },
  {
    "text": "Arvonia",
    "value": "arvonia"
  },
  {
    "text": "Ary",
    "value": "ary"
  },
  {
    "text": "Asbury",
    "value": "asbury"
  },
  {
    "text": "Asbury Park",
    "value": "asbury park"
  },
  {
    "text": "Ascutney",
    "value": "ascutney"
  },
  {
    "text": "Ash",
    "value": "ash"
  },
  {
    "text": "Ash Flat",
    "value": "ash flat"
  },
  {
    "text": "Ash Fork",
    "value": "ash fork"
  },
  {
    "text": "Ash Grove",
    "value": "ash grove"
  },
  {
    "text": "Ashaway",
    "value": "ashaway"
  },
  {
    "text": "Ashburn",
    "value": "ashburn"
  },
  {
    "text": "Ashburnham",
    "value": "ashburnham"
  },
  {
    "text": "Ashby",
    "value": "ashby"
  },
  {
    "text": "Ashcamp",
    "value": "ashcamp"
  },
  {
    "text": "Ashdown",
    "value": "ashdown"
  },
  {
    "text": "Asheboro",
    "value": "asheboro"
  },
  {
    "text": "Asher",
    "value": "asher"
  },
  {
    "text": "Asherton",
    "value": "asherton"
  },
  {
    "text": "Asheville",
    "value": "asheville"
  },
  {
    "text": "Ashfield",
    "value": "ashfield"
  },
  {
    "text": "Ashford",
    "value": "ashford"
  },
  {
    "text": "Ashkum",
    "value": "ashkum"
  },
  {
    "text": "Ashland",
    "value": "ashland"
  },
  {
    "text": "Ashland City",
    "value": "ashland city"
  },
  {
    "text": "Ashley",
    "value": "ashley"
  },
  {
    "text": "Ashley Falls",
    "value": "ashley falls"
  },
  {
    "text": "Ashmore",
    "value": "ashmore"
  },
  {
    "text": "Ashtabula",
    "value": "ashtabula"
  },
  {
    "text": "Ashton",
    "value": "ashton"
  },
  {
    "text": "Ashuelot",
    "value": "ashuelot"
  },
  {
    "text": "Ashville",
    "value": "ashville"
  },
  {
    "text": "Ashwaubenon",
    "value": "ashwaubenon"
  },
  {
    "text": "Askov",
    "value": "askov"
  },
  {
    "text": "Asotin",
    "value": "asotin"
  },
  {
    "text": "Aspen",
    "value": "aspen"
  },
  {
    "text": "Aspermont",
    "value": "aspermont"
  },
  {
    "text": "Aspers",
    "value": "aspers"
  },
  {
    "text": "Aspinwall",
    "value": "aspinwall"
  },
  {
    "text": "Assaria",
    "value": "assaria"
  },
  {
    "text": "Assawoman",
    "value": "assawoman"
  },
  {
    "text": "Assonet",
    "value": "assonet"
  },
  {
    "text": "Assumption",
    "value": "assumption"
  },
  {
    "text": "Astatula",
    "value": "astatula"
  },
  {
    "text": "Aston",
    "value": "aston"
  },
  {
    "text": "Aston Mills",
    "value": "aston mills"
  },
  {
    "text": "Astor",
    "value": "astor"
  },
  {
    "text": "Astoria",
    "value": "astoria"
  },
  {
    "text": "Atalissa",
    "value": "atalissa"
  },
  {
    "text": "Atascadero",
    "value": "atascadero"
  },
  {
    "text": "Atascocita",
    "value": "atascocita"
  },
  {
    "text": "Atascosa",
    "value": "atascosa"
  },
  {
    "text": "Atchison",
    "value": "atchison"
  },
  {
    "text": "Atco",
    "value": "atco"
  },
  {
    "text": "Atglen",
    "value": "atglen"
  },
  {
    "text": "Athelstane",
    "value": "athelstane"
  },
  {
    "text": "Athena",
    "value": "athena"
  },
  {
    "text": "Athens",
    "value": "athens"
  },
  {
    "text": "Atherton",
    "value": "atherton"
  },
  {
    "text": "Athol",
    "value": "athol"
  },
  {
    "text": "Athol Springs",
    "value": "athol springs"
  },
  {
    "text": "Atkins",
    "value": "atkins"
  },
  {
    "text": "Atkinson",
    "value": "atkinson"
  },
  {
    "text": "Atlanta",
    "value": "atlanta"
  },
  {
    "text": "Atlantic",
    "value": "atlantic"
  },
  {
    "text": "Atlantic Beach",
    "value": "atlantic beach"
  },
  {
    "text": "Atlantic City",
    "value": "atlantic city"
  },
  {
    "text": "Atlantic Highlands",
    "value": "atlantic highlands"
  },
  {
    "text": "Atlantic Mine",
    "value": "atlantic mine"
  },
  {
    "text": "Atlantis",
    "value": "atlantis"
  },
  {
    "text": "Atlasburg",
    "value": "atlasburg"
  },
  {
    "text": "Atmore",
    "value": "atmore"
  },
  {
    "text": "Atoka",
    "value": "atoka"
  },
  {
    "text": "Atqasuk",
    "value": "atqasuk"
  },
  {
    "text": "Attalla",
    "value": "attalla"
  },
  {
    "text": "Attapulgus",
    "value": "attapulgus"
  },
  {
    "text": "Attica",
    "value": "attica"
  },
  {
    "text": "Attleboro",
    "value": "attleboro"
  },
  {
    "text": "Attleboro Falls",
    "value": "attleboro falls"
  },
  {
    "text": "Atwater",
    "value": "atwater"
  },
  {
    "text": "Atwood",
    "value": "atwood"
  },
  {
    "text": "Au Gres",
    "value": "au gres"
  },
  {
    "text": "Au Sable",
    "value": "au sable"
  },
  {
    "text": "Au Sable Forks",
    "value": "au sable forks"
  },
  {
    "text": "Au Train",
    "value": "au train"
  },
  {
    "text": "Auberry",
    "value": "auberry"
  },
  {
    "text": "Aubrey",
    "value": "aubrey"
  },
  {
    "text": "Auburn",
    "value": "auburn"
  },
  {
    "text": "Auburn Hills",
    "value": "auburn hills"
  },
  {
    "text": "Auburndale",
    "value": "auburndale"
  },
  {
    "text": "Auburntown",
    "value": "auburntown"
  },
  {
    "text": "Audubon",
    "value": "audubon"
  },
  {
    "text": "August",
    "value": "august"
  },
  {
    "text": "Augusta",
    "value": "augusta"
  },
  {
    "text": "Aulander",
    "value": "aulander"
  },
  {
    "text": "Ault",
    "value": "ault"
  },
  {
    "text": "Ault Field",
    "value": "ault field"
  },
  {
    "text": "Aumsville",
    "value": "aumsville"
  },
  {
    "text": "Aurelia",
    "value": "aurelia"
  },
  {
    "text": "Aurora",
    "value": "aurora"
  },
  {
    "text": "Austell",
    "value": "austell"
  },
  {
    "text": "Austerlitz",
    "value": "austerlitz"
  },
  {
    "text": "Austin",
    "value": "austin"
  },
  {
    "text": "Austinburg",
    "value": "austinburg"
  },
  {
    "text": "Austintown",
    "value": "austintown"
  },
  {
    "text": "Austinville",
    "value": "austinville"
  },
  {
    "text": "Autaugaville",
    "value": "autaugaville"
  },
  {
    "text": "Autryville",
    "value": "autryville"
  },
  {
    "text": "Auxier",
    "value": "auxier"
  },
  {
    "text": "Auxvasse",
    "value": "auxvasse"
  },
  {
    "text": "Ava",
    "value": "ava"
  },
  {
    "text": "Avalon",
    "value": "avalon"
  },
  {
    "text": "Avant",
    "value": "avant"
  },
  {
    "text": "Avawam",
    "value": "avawam"
  },
  {
    "text": "Avella",
    "value": "avella"
  },
  {
    "text": "Avenal",
    "value": "avenal"
  },
  {
    "text": "Avenel",
    "value": "avenel"
  },
  {
    "text": "Aventura",
    "value": "aventura"
  },
  {
    "text": "Avenue",
    "value": "avenue"
  },
  {
    "text": "Avera",
    "value": "avera"
  },
  {
    "text": "Averill",
    "value": "averill"
  },
  {
    "text": "Averill Park",
    "value": "averill park"
  },
  {
    "text": "Avery",
    "value": "avery"
  },
  {
    "text": "Avery Creek",
    "value": "avery creek"
  },
  {
    "text": "Avery Island",
    "value": "avery island"
  },
  {
    "text": "Avila Beach",
    "value": "avila beach"
  },
  {
    "text": "Avilla",
    "value": "avilla"
  },
  {
    "text": "Avinger",
    "value": "avinger"
  },
  {
    "text": "Avis",
    "value": "avis"
  },
  {
    "text": "Aviston",
    "value": "aviston"
  },
  {
    "text": "Avoca",
    "value": "avoca"
  },
  {
    "text": "Avocado Heights",
    "value": "avocado heights"
  },
  {
    "text": "Avon",
    "value": "avon"
  },
  {
    "text": "Avon Lake",
    "value": "avon lake"
  },
  {
    "text": "Avon Park",
    "value": "avon park"
  },
  {
    "text": "Avon-by-the-Sea",
    "value": "avon-by-the-sea"
  },
  {
    "text": "Avondale",
    "value": "avondale"
  },
  {
    "text": "Avondale Estates",
    "value": "avondale estates"
  },
  {
    "text": "Avonmore",
    "value": "avonmore"
  },
  {
    "text": "Awendaw",
    "value": "awendaw"
  },
  {
    "text": "Axis",
    "value": "axis"
  },
  {
    "text": "Axson",
    "value": "axson"
  },
  {
    "text": "Axtell",
    "value": "axtell"
  },
  {
    "text": "Axton",
    "value": "axton"
  },
  {
    "text": "Ayden",
    "value": "ayden"
  },
  {
    "text": "Aydlett",
    "value": "aydlett"
  },
  {
    "text": "Ayer",
    "value": "ayer"
  },
  {
    "text": "Aylett",
    "value": "aylett"
  },
  {
    "text": "Aynor",
    "value": "aynor"
  },
  {
    "text": "Ayr",
    "value": "ayr"
  },
  {
    "text": "Ayrshire",
    "value": "ayrshire"
  },
  {
    "text": "Azalea",
    "value": "azalea"
  },
  {
    "text": "Azle",
    "value": "azle"
  },
  {
    "text": "Aztec",
    "value": "aztec"
  },
  {
    "text": "Azusa",
    "value": "azusa"
  },
  {
    "text": "Babb",
    "value": "babb"
  },
  {
    "text": "Babbitt",
    "value": "babbitt"
  },
  {
    "text": "Babcock",
    "value": "babcock"
  },
  {
    "text": "Babson Park",
    "value": "babson park"
  },
  {
    "text": "Babylon",
    "value": "babylon"
  },
  {
    "text": "Backus",
    "value": "backus"
  },
  {
    "text": "Bacliff",
    "value": "bacliff"
  },
  {
    "text": "Baconton",
    "value": "baconton"
  },
  {
    "text": "Bacova",
    "value": "bacova"
  },
  {
    "text": "Bad Axe",
    "value": "bad axe"
  },
  {
    "text": "Baden",
    "value": "baden"
  },
  {
    "text": "Badger",
    "value": "badger"
  },
  {
    "text": "Badin",
    "value": "badin"
  },
  {
    "text": "Bagdad",
    "value": "bagdad"
  },
  {
    "text": "Baggs",
    "value": "baggs"
  },
  {
    "text": "Bagley",
    "value": "bagley"
  },
  {
    "text": "Bagwell",
    "value": "bagwell"
  },
  {
    "text": "Bahama",
    "value": "bahama"
  },
  {
    "text": "Bailey",
    "value": "bailey"
  },
  {
    "text": "Bailey Island",
    "value": "bailey island"
  },
  {
    "text": "Baileys Crossroads",
    "value": "baileys crossroads"
  },
  {
    "text": "Baileys Harbor",
    "value": "baileys harbor"
  },
  {
    "text": "Baileyton",
    "value": "baileyton"
  },
  {
    "text": "Baileyville",
    "value": "baileyville"
  },
  {
    "text": "Bainbridge",
    "value": "bainbridge"
  },
  {
    "text": "Bainbridge Island",
    "value": "bainbridge island"
  },
  {
    "text": "Bainville",
    "value": "bainville"
  },
  {
    "text": "Baird",
    "value": "baird"
  },
  {
    "text": "Bairdford",
    "value": "bairdford"
  },
  {
    "text": "Bairoil",
    "value": "bairoil"
  },
  {
    "text": "Baisden",
    "value": "baisden"
  },
  {
    "text": "Baiting Hollow",
    "value": "baiting hollow"
  },
  {
    "text": "Baker",
    "value": "baker"
  },
  {
    "text": "Baker City",
    "value": "baker city"
  },
  {
    "text": "Bakers Mills",
    "value": "bakers mills"
  },
  {
    "text": "Bakersfield",
    "value": "bakersfield"
  },
  {
    "text": "Bakersville",
    "value": "bakersville"
  },
  {
    "text": "Bal Harbour",
    "value": "bal harbour"
  },
  {
    "text": "Bala Cynwyd",
    "value": "bala cynwyd"
  },
  {
    "text": "Bala-Cynwyd",
    "value": "bala-cynwyd"
  },
  {
    "text": "Balaton",
    "value": "balaton"
  },
  {
    "text": "Balch Springs",
    "value": "balch springs"
  },
  {
    "text": "Balcones Heights",
    "value": "balcones heights"
  },
  {
    "text": "Bald Knob",
    "value": "bald knob"
  },
  {
    "text": "Baldwin",
    "value": "baldwin"
  },
  {
    "text": "Baldwin City",
    "value": "baldwin city"
  },
  {
    "text": "Baldwin Park",
    "value": "baldwin park"
  },
  {
    "text": "Baldwin Place",
    "value": "baldwin place"
  },
  {
    "text": "Baldwinsville",
    "value": "baldwinsville"
  },
  {
    "text": "Baldwinville",
    "value": "baldwinville"
  },
  {
    "text": "Baldwyn",
    "value": "baldwyn"
  },
  {
    "text": "Balfour",
    "value": "balfour"
  },
  {
    "text": "Balko",
    "value": "balko"
  },
  {
    "text": "Ball",
    "value": "ball"
  },
  {
    "text": "Ball Ground",
    "value": "ball ground"
  },
  {
    "text": "Ballantine",
    "value": "ballantine"
  },
  {
    "text": "Ballard",
    "value": "ballard"
  },
  {
    "text": "Ballico",
    "value": "ballico"
  },
  {
    "text": "Ballinger",
    "value": "ballinger"
  },
  {
    "text": "Ballston Lake",
    "value": "ballston lake"
  },
  {
    "text": "Ballston Spa",
    "value": "ballston spa"
  },
  {
    "text": "Ballville",
    "value": "ballville"
  },
  {
    "text": "Ballwin",
    "value": "ballwin"
  },
  {
    "text": "Bally",
    "value": "bally"
  },
  {
    "text": "Balmorhea",
    "value": "balmorhea"
  },
  {
    "text": "Balsam",
    "value": "balsam"
  },
  {
    "text": "Balsam Grove",
    "value": "balsam grove"
  },
  {
    "text": "Balsam Lake",
    "value": "balsam lake"
  },
  {
    "text": "Balta",
    "value": "balta"
  },
  {
    "text": "Baltic",
    "value": "baltic"
  },
  {
    "text": "Baltimore",
    "value": "baltimore"
  },
  {
    "text": "Bamberg",
    "value": "bamberg"
  },
  {
    "text": "Bancroft",
    "value": "bancroft"
  },
  {
    "text": "Bandera",
    "value": "bandera"
  },
  {
    "text": "Bandon",
    "value": "bandon"
  },
  {
    "text": "Bandy",
    "value": "bandy"
  },
  {
    "text": "Bangall",
    "value": "bangall"
  },
  {
    "text": "Bangor",
    "value": "bangor"
  },
  {
    "text": "Bangs",
    "value": "bangs"
  },
  {
    "text": "Banks",
    "value": "banks"
  },
  {
    "text": "Banner",
    "value": "banner"
  },
  {
    "text": "Banner Elk",
    "value": "banner elk"
  },
  {
    "text": "Banning",
    "value": "banning"
  },
  {
    "text": "Bannister",
    "value": "bannister"
  },
  {
    "text": "Bannockburn",
    "value": "bannockburn"
  },
  {
    "text": "Banquete",
    "value": "banquete"
  },
  {
    "text": "Banta",
    "value": "banta"
  },
  {
    "text": "Bantam",
    "value": "bantam"
  },
  {
    "text": "Bantry",
    "value": "bantry"
  },
  {
    "text": "Bapchule",
    "value": "bapchule"
  },
  {
    "text": "Baptistown",
    "value": "baptistown"
  },
  {
    "text": "Bar Harbor",
    "value": "bar harbor"
  },
  {
    "text": "Bar Mills",
    "value": "bar mills"
  },
  {
    "text": "Bar Nunn",
    "value": "bar nunn"
  },
  {
    "text": "Baraboo",
    "value": "baraboo"
  },
  {
    "text": "Baraga",
    "value": "baraga"
  },
  {
    "text": "Barataria",
    "value": "barataria"
  },
  {
    "text": "Barbeau",
    "value": "barbeau"
  },
  {
    "text": "Barberton",
    "value": "barberton"
  },
  {
    "text": "Barboursville",
    "value": "barboursville"
  },
  {
    "text": "Barbourville",
    "value": "barbourville"
  },
  {
    "text": "Barclay",
    "value": "barclay"
  },
  {
    "text": "Barco",
    "value": "barco"
  },
  {
    "text": "Bard",
    "value": "bard"
  },
  {
    "text": "Bardolph",
    "value": "bardolph"
  },
  {
    "text": "Bardonia",
    "value": "bardonia"
  },
  {
    "text": "Bardstown",
    "value": "bardstown"
  },
  {
    "text": "Bardwell",
    "value": "bardwell"
  },
  {
    "text": "Bargersville",
    "value": "bargersville"
  },
  {
    "text": "Barhamsville",
    "value": "barhamsville"
  },
  {
    "text": "Baring",
    "value": "baring"
  },
  {
    "text": "Bark River",
    "value": "bark river"
  },
  {
    "text": "Barker",
    "value": "barker"
  },
  {
    "text": "Barkhamsted",
    "value": "barkhamsted"
  },
  {
    "text": "Barksdale",
    "value": "barksdale"
  },
  {
    "text": "Barksdale Air Force Base",
    "value": "barksdale air force base"
  },
  {
    "text": "Barling",
    "value": "barling"
  },
  {
    "text": "Barlow",
    "value": "barlow"
  },
  {
    "text": "Barnard",
    "value": "barnard"
  },
  {
    "text": "Barnardsville",
    "value": "barnardsville"
  },
  {
    "text": "Barnegat",
    "value": "barnegat"
  },
  {
    "text": "Barnegat Light",
    "value": "barnegat light"
  },
  {
    "text": "Barnes",
    "value": "barnes"
  },
  {
    "text": "Barnes City",
    "value": "barnes city"
  },
  {
    "text": "Barnesboro",
    "value": "barnesboro"
  },
  {
    "text": "Barneston",
    "value": "barneston"
  },
  {
    "text": "Barnesville",
    "value": "barnesville"
  },
  {
    "text": "Barnet",
    "value": "barnet"
  },
  {
    "text": "Barnett",
    "value": "barnett"
  },
  {
    "text": "Barneveld",
    "value": "barneveld"
  },
  {
    "text": "Barney",
    "value": "barney"
  },
  {
    "text": "Barnhart",
    "value": "barnhart"
  },
  {
    "text": "Barnhill",
    "value": "barnhill"
  },
  {
    "text": "Barnsdall",
    "value": "barnsdall"
  },
  {
    "text": "Barnstable",
    "value": "barnstable"
  },
  {
    "text": "Barnstead",
    "value": "barnstead"
  },
  {
    "text": "Barnum",
    "value": "barnum"
  },
  {
    "text": "Barnwell",
    "value": "barnwell"
  },
  {
    "text": "Baroda",
    "value": "baroda"
  },
  {
    "text": "Barrackville",
    "value": "barrackville"
  },
  {
    "text": "Barre",
    "value": "barre"
  },
  {
    "text": "Barren Springs",
    "value": "barren springs"
  },
  {
    "text": "Barrett",
    "value": "barrett"
  },
  {
    "text": "Barrington",
    "value": "barrington"
  },
  {
    "text": "Barrington Hills",
    "value": "barrington hills"
  },
  {
    "text": "Barron",
    "value": "barron"
  },
  {
    "text": "Barronett",
    "value": "barronett"
  },
  {
    "text": "Barrow",
    "value": "barrow"
  },
  {
    "text": "Barry",
    "value": "barry"
  },
  {
    "text": "Barryton",
    "value": "barryton"
  },
  {
    "text": "Barrytown",
    "value": "barrytown"
  },
  {
    "text": "Barryville",
    "value": "barryville"
  },
  {
    "text": "Barstow",
    "value": "barstow"
  },
  {
    "text": "Bart",
    "value": "bart"
  },
  {
    "text": "Bartelso",
    "value": "bartelso"
  },
  {
    "text": "Bartlesville",
    "value": "bartlesville"
  },
  {
    "text": "Bartlett",
    "value": "bartlett"
  },
  {
    "text": "Bartley",
    "value": "bartley"
  },
  {
    "text": "Barto",
    "value": "barto"
  },
  {
    "text": "Barton",
    "value": "barton"
  },
  {
    "text": "Barton City",
    "value": "barton city"
  },
  {
    "text": "Barton Creek",
    "value": "barton creek"
  },
  {
    "text": "Bartonsville",
    "value": "bartonsville"
  },
  {
    "text": "Bartonville",
    "value": "bartonville"
  },
  {
    "text": "Bartow",
    "value": "bartow"
  },
  {
    "text": "Barview",
    "value": "barview"
  },
  {
    "text": "Barwick",
    "value": "barwick"
  },
  {
    "text": "Basalt",
    "value": "basalt"
  },
  {
    "text": "Bascom",
    "value": "bascom"
  },
  {
    "text": "Basehor",
    "value": "basehor"
  },
  {
    "text": "Basile",
    "value": "basile"
  },
  {
    "text": "Basin",
    "value": "basin"
  },
  {
    "text": "Basin City",
    "value": "basin city"
  },
  {
    "text": "Baskerville",
    "value": "baskerville"
  },
  {
    "text": "Baskin",
    "value": "baskin"
  },
  {
    "text": "Basking Ridge",
    "value": "basking ridge"
  },
  {
    "text": "Basom",
    "value": "basom"
  },
  {
    "text": "Bass Harbor",
    "value": "bass harbor"
  },
  {
    "text": "Bass Lake",
    "value": "bass lake"
  },
  {
    "text": "Bassett",
    "value": "bassett"
  },
  {
    "text": "Bassfield",
    "value": "bassfield"
  },
  {
    "text": "Bastian",
    "value": "bastian"
  },
  {
    "text": "Bastrop",
    "value": "bastrop"
  },
  {
    "text": "Basye",
    "value": "basye"
  },
  {
    "text": "Batavia",
    "value": "batavia"
  },
  {
    "text": "Batchelor",
    "value": "batchelor"
  },
  {
    "text": "Batchtown",
    "value": "batchtown"
  },
  {
    "text": "Bates City",
    "value": "bates city"
  },
  {
    "text": "Batesburg",
    "value": "batesburg"
  },
  {
    "text": "Batesburg-Leesville",
    "value": "batesburg-leesville"
  },
  {
    "text": "Batesland",
    "value": "batesland"
  },
  {
    "text": "Batesville",
    "value": "batesville"
  },
  {
    "text": "Bath",
    "value": "bath"
  },
  {
    "text": "Bath Springs",
    "value": "bath springs"
  },
  {
    "text": "Bathgate",
    "value": "bathgate"
  },
  {
    "text": "Baton Rouge",
    "value": "baton rouge"
  },
  {
    "text": "Batson",
    "value": "batson"
  },
  {
    "text": "Battery Park",
    "value": "battery park"
  },
  {
    "text": "Battiest",
    "value": "battiest"
  },
  {
    "text": "Battle Creek",
    "value": "battle creek"
  },
  {
    "text": "Battle Ground",
    "value": "battle ground"
  },
  {
    "text": "Battle Lake",
    "value": "battle lake"
  },
  {
    "text": "Battle Mountain",
    "value": "battle mountain"
  },
  {
    "text": "Battleboro",
    "value": "battleboro"
  },
  {
    "text": "Battlefield",
    "value": "battlefield"
  },
  {
    "text": "Battlement Mesa",
    "value": "battlement mesa"
  },
  {
    "text": "Battletown",
    "value": "battletown"
  },
  {
    "text": "Baudette",
    "value": "baudette"
  },
  {
    "text": "Bausman",
    "value": "bausman"
  },
  {
    "text": "Bauxite",
    "value": "bauxite"
  },
  {
    "text": "Baxley",
    "value": "baxley"
  },
  {
    "text": "Baxter",
    "value": "baxter"
  },
  {
    "text": "Baxter Springs",
    "value": "baxter springs"
  },
  {
    "text": "Bay",
    "value": "bay"
  },
  {
    "text": "Bay Center",
    "value": "bay center"
  },
  {
    "text": "Bay City",
    "value": "bay city"
  },
  {
    "text": "Bay Harbor Islands",
    "value": "bay harbor islands"
  },
  {
    "text": "Bay Minette",
    "value": "bay minette"
  },
  {
    "text": "Bay Point",
    "value": "bay point"
  },
  {
    "text": "Bay Port",
    "value": "bay port"
  },
  {
    "text": "Bay Saint Louis",
    "value": "bay saint louis"
  },
  {
    "text": "Bay Shore",
    "value": "bay shore"
  },
  {
    "text": "Bay Springs",
    "value": "bay springs"
  },
  {
    "text": "Bay St. Louis",
    "value": "bay st. louis"
  },
  {
    "text": "Bay Village",
    "value": "bay village"
  },
  {
    "text": "Bayard",
    "value": "bayard"
  },
  {
    "text": "Bayboro",
    "value": "bayboro"
  },
  {
    "text": "Bayfield",
    "value": "bayfield"
  },
  {
    "text": "Baylis",
    "value": "baylis"
  },
  {
    "text": "Bayonet Point",
    "value": "bayonet point"
  },
  {
    "text": "Bayonne",
    "value": "bayonne"
  },
  {
    "text": "Bayou Cane",
    "value": "bayou cane"
  },
  {
    "text": "Bayou La Batre",
    "value": "bayou la batre"
  },
  {
    "text": "Bayou Vista",
    "value": "bayou vista"
  },
  {
    "text": "Bayport",
    "value": "bayport"
  },
  {
    "text": "Bayshore",
    "value": "bayshore"
  },
  {
    "text": "Bayshore Gardens",
    "value": "bayshore gardens"
  },
  {
    "text": "Bayside",
    "value": "bayside"
  },
  {
    "text": "Baytown",
    "value": "baytown"
  },
  {
    "text": "Bayview",
    "value": "bayview"
  },
  {
    "text": "Bayville",
    "value": "bayville"
  },
  {
    "text": "Baywood Park",
    "value": "baywood park"
  },
  {
    "text": "Bazine",
    "value": "bazine"
  },
  {
    "text": "Beach",
    "value": "beach"
  },
  {
    "text": "Beach City",
    "value": "beach city"
  },
  {
    "text": "Beach Haven",
    "value": "beach haven"
  },
  {
    "text": "Beach Lake",
    "value": "beach lake"
  },
  {
    "text": "Beach Park",
    "value": "beach park"
  },
  {
    "text": "Beachwood",
    "value": "beachwood"
  },
  {
    "text": "Beacon",
    "value": "beacon"
  },
  {
    "text": "Beacon Falls",
    "value": "beacon falls"
  },
  {
    "text": "Beale Air Force Base",
    "value": "beale air force base"
  },
  {
    "text": "Bealeton",
    "value": "bealeton"
  },
  {
    "text": "Beallsville",
    "value": "beallsville"
  },
  {
    "text": "Beals",
    "value": "beals"
  },
  {
    "text": "Beaman",
    "value": "beaman"
  },
  {
    "text": "Bean Station",
    "value": "bean station"
  },
  {
    "text": "Bear",
    "value": "bear"
  },
  {
    "text": "Bear Branch",
    "value": "bear branch"
  },
  {
    "text": "Bear Creek",
    "value": "bear creek"
  },
  {
    "text": "Bear Creek Village",
    "value": "bear creek village"
  },
  {
    "text": "Bear Lake",
    "value": "bear lake"
  },
  {
    "text": "Bear Mountain",
    "value": "bear mountain"
  },
  {
    "text": "Bear River City",
    "value": "bear river city"
  },
  {
    "text": "Bear Valley",
    "value": "bear valley"
  },
  {
    "text": "Bear Valley Springs",
    "value": "bear valley springs"
  },
  {
    "text": "Bearden",
    "value": "bearden"
  },
  {
    "text": "Beardsley",
    "value": "beardsley"
  },
  {
    "text": "Beardstown",
    "value": "beardstown"
  },
  {
    "text": "Bearsville",
    "value": "bearsville"
  },
  {
    "text": "Beasley",
    "value": "beasley"
  },
  {
    "text": "Beason",
    "value": "beason"
  },
  {
    "text": "Beatrice",
    "value": "beatrice"
  },
  {
    "text": "Beattie",
    "value": "beattie"
  },
  {
    "text": "Beatty",
    "value": "beatty"
  },
  {
    "text": "Beattystown",
    "value": "beattystown"
  },
  {
    "text": "Beattyville",
    "value": "beattyville"
  },
  {
    "text": "Beaufort",
    "value": "beaufort"
  },
  {
    "text": "Beaumont",
    "value": "beaumont"
  },
  {
    "text": "Beaver",
    "value": "beaver"
  },
  {
    "text": "Beaver Bay",
    "value": "beaver bay"
  },
  {
    "text": "Beaver City",
    "value": "beaver city"
  },
  {
    "text": "Beaver Creek",
    "value": "beaver creek"
  },
  {
    "text": "Beaver Crossing",
    "value": "beaver crossing"
  },
  {
    "text": "Beaver Dam",
    "value": "beaver dam"
  },
  {
    "text": "Beaver Dams",
    "value": "beaver dams"
  },
  {
    "text": "Beaver Falls",
    "value": "beaver falls"
  },
  {
    "text": "Beaver Island",
    "value": "beaver island"
  },
  {
    "text": "Beaver Meadows",
    "value": "beaver meadows"
  },
  {
    "text": "Beaver Springs",
    "value": "beaver springs"
  },
  {
    "text": "Beavercreek",
    "value": "beavercreek"
  },
  {
    "text": "Beaverdale",
    "value": "beaverdale"
  },
  {
    "text": "Beaverdam",
    "value": "beaverdam"
  },
  {
    "text": "Beaverton",
    "value": "beaverton"
  },
  {
    "text": "Beavertown",
    "value": "beavertown"
  },
  {
    "text": "Beaverville",
    "value": "beaverville"
  },
  {
    "text": "Bechtelsville",
    "value": "bechtelsville"
  },
  {
    "text": "Beckemeyer",
    "value": "beckemeyer"
  },
  {
    "text": "Becker",
    "value": "becker"
  },
  {
    "text": "Becket",
    "value": "becket"
  },
  {
    "text": "Beckett",
    "value": "beckett"
  },
  {
    "text": "Beckett Ridge",
    "value": "beckett ridge"
  },
  {
    "text": "Beckley",
    "value": "beckley"
  },
  {
    "text": "Beckville",
    "value": "beckville"
  },
  {
    "text": "Beckwourth",
    "value": "beckwourth"
  },
  {
    "text": "Bedford",
    "value": "bedford"
  },
  {
    "text": "Bedford Heights",
    "value": "bedford heights"
  },
  {
    "text": "Bedford Hills",
    "value": "bedford hills"
  },
  {
    "text": "Bedford Park",
    "value": "bedford park"
  },
  {
    "text": "Bedias",
    "value": "bedias"
  },
  {
    "text": "Bedminster",
    "value": "bedminster"
  },
  {
    "text": "Bedrock",
    "value": "bedrock"
  },
  {
    "text": "Bee",
    "value": "bee"
  },
  {
    "text": "Bee Branch",
    "value": "bee branch"
  },
  {
    "text": "Bee Cave",
    "value": "bee cave"
  },
  {
    "text": "Bee Spring",
    "value": "bee spring"
  },
  {
    "text": "Beebe",
    "value": "beebe"
  },
  {
    "text": "Beebe Plain",
    "value": "beebe plain"
  },
  {
    "text": "Beech Bluff",
    "value": "beech bluff"
  },
  {
    "text": "Beech Creek",
    "value": "beech creek"
  },
  {
    "text": "Beech Grove",
    "value": "beech grove"
  },
  {
    "text": "Beech Island",
    "value": "beech island"
  },
  {
    "text": "Beecher",
    "value": "beecher"
  },
  {
    "text": "Beecher City",
    "value": "beecher city"
  },
  {
    "text": "Beecher Falls",
    "value": "beecher falls"
  },
  {
    "text": "Beechgrove",
    "value": "beechgrove"
  },
  {
    "text": "Beechmont",
    "value": "beechmont"
  },
  {
    "text": "Beechwood",
    "value": "beechwood"
  },
  {
    "text": "Beechwood Village",
    "value": "beechwood village"
  },
  {
    "text": "Beedeville",
    "value": "beedeville"
  },
  {
    "text": "Beeler",
    "value": "beeler"
  },
  {
    "text": "Beemer",
    "value": "beemer"
  },
  {
    "text": "Beersheba Springs",
    "value": "beersheba springs"
  },
  {
    "text": "Beeville",
    "value": "beeville"
  },
  {
    "text": "Beggs",
    "value": "beggs"
  },
  {
    "text": "Bejou",
    "value": "bejou"
  },
  {
    "text": "Bel Air",
    "value": "bel air"
  },
  {
    "text": "Bel Air South",
    "value": "bel air south"
  },
  {
    "text": "Bel Alton",
    "value": "bel alton"
  },
  {
    "text": "Bel-Ridge",
    "value": "bel-ridge"
  },
  {
    "text": "Belcamp",
    "value": "belcamp"
  },
  {
    "text": "Belcher",
    "value": "belcher"
  },
  {
    "text": "Belchertown",
    "value": "belchertown"
  },
  {
    "text": "Belcourt",
    "value": "belcourt"
  },
  {
    "text": "Belden",
    "value": "belden"
  },
  {
    "text": "Beldenville",
    "value": "beldenville"
  },
  {
    "text": "Belding",
    "value": "belding"
  },
  {
    "text": "Belen",
    "value": "belen"
  },
  {
    "text": "Belews Creek",
    "value": "belews creek"
  },
  {
    "text": "Belfair",
    "value": "belfair"
  },
  {
    "text": "Belfast",
    "value": "belfast"
  },
  {
    "text": "Belfield",
    "value": "belfield"
  },
  {
    "text": "Belford",
    "value": "belford"
  },
  {
    "text": "Belfry",
    "value": "belfry"
  },
  {
    "text": "Belgium",
    "value": "belgium"
  },
  {
    "text": "Belgrade",
    "value": "belgrade"
  },
  {
    "text": "Belhaven",
    "value": "belhaven"
  },
  {
    "text": "Belington",
    "value": "belington"
  },
  {
    "text": "Belk",
    "value": "belk"
  },
  {
    "text": "Belknap",
    "value": "belknap"
  },
  {
    "text": "Bell",
    "value": "bell"
  },
  {
    "text": "Bell Arthur",
    "value": "bell arthur"
  },
  {
    "text": "Bell Buckle",
    "value": "bell buckle"
  },
  {
    "text": "Bell City",
    "value": "bell city"
  },
  {
    "text": "Bell Gardens",
    "value": "bell gardens"
  },
  {
    "text": "Bella Vista",
    "value": "bella vista"
  },
  {
    "text": "Bellaire",
    "value": "bellaire"
  },
  {
    "text": "Bellbrook",
    "value": "bellbrook"
  },
  {
    "text": "Belle",
    "value": "belle"
  },
  {
    "text": "Belle Center",
    "value": "belle center"
  },
  {
    "text": "Belle Chasse",
    "value": "belle chasse"
  },
  {
    "text": "Belle Fourche",
    "value": "belle fourche"
  },
  {
    "text": "Belle Glade",
    "value": "belle glade"
  },
  {
    "text": "Belle Haven",
    "value": "belle haven"
  },
  {
    "text": "Belle Isle",
    "value": "belle isle"
  },
  {
    "text": "Belle Mead",
    "value": "belle mead"
  },
  {
    "text": "Belle Meade",
    "value": "belle meade"
  },
  {
    "text": "Belle Mina",
    "value": "belle mina"
  },
  {
    "text": "Belle Plaine",
    "value": "belle plaine"
  },
  {
    "text": "Belle Rive",
    "value": "belle rive"
  },
  {
    "text": "Belle Rose",
    "value": "belle rose"
  },
  {
    "text": "Belle Valley",
    "value": "belle valley"
  },
  {
    "text": "Belle Vernon",
    "value": "belle vernon"
  },
  {
    "text": "Belleair",
    "value": "belleair"
  },
  {
    "text": "Belleair Beach",
    "value": "belleair beach"
  },
  {
    "text": "Belleair Bluffs",
    "value": "belleair bluffs"
  },
  {
    "text": "Bellefontaine",
    "value": "bellefontaine"
  },
  {
    "text": "Bellefonte",
    "value": "bellefonte"
  },
  {
    "text": "Bellemont",
    "value": "bellemont"
  },
  {
    "text": "Bellerose",
    "value": "bellerose"
  },
  {
    "text": "Belleview",
    "value": "belleview"
  },
  {
    "text": "Belleville",
    "value": "belleville"
  },
  {
    "text": "Bellevue",
    "value": "bellevue"
  },
  {
    "text": "Bellflower",
    "value": "bellflower"
  },
  {
    "text": "Bellingham",
    "value": "bellingham"
  },
  {
    "text": "Bellmawr",
    "value": "bellmawr"
  },
  {
    "text": "Bellmead",
    "value": "bellmead"
  },
  {
    "text": "Bellmont",
    "value": "bellmont"
  },
  {
    "text": "Bellmore",
    "value": "bellmore"
  },
  {
    "text": "Bellows Falls",
    "value": "bellows falls"
  },
  {
    "text": "Bellport",
    "value": "bellport"
  },
  {
    "text": "Bells",
    "value": "bells"
  },
  {
    "text": "Bellview",
    "value": "bellview"
  },
  {
    "text": "Bellville",
    "value": "bellville"
  },
  {
    "text": "Bellvue",
    "value": "bellvue"
  },
  {
    "text": "Bellwood",
    "value": "bellwood"
  },
  {
    "text": "Belmar",
    "value": "belmar"
  },
  {
    "text": "Belmond",
    "value": "belmond"
  },
  {
    "text": "Belmont",
    "value": "belmont"
  },
  {
    "text": "Beloit",
    "value": "beloit"
  },
  {
    "text": "Belpre",
    "value": "belpre"
  },
  {
    "text": "Belsano",
    "value": "belsano"
  },
  {
    "text": "Belspring",
    "value": "belspring"
  },
  {
    "text": "Belt",
    "value": "belt"
  },
  {
    "text": "Belton",
    "value": "belton"
  },
  {
    "text": "Beltrami",
    "value": "beltrami"
  },
  {
    "text": "Beltsville",
    "value": "beltsville"
  },
  {
    "text": "Belva",
    "value": "belva"
  },
  {
    "text": "Belvedere",
    "value": "belvedere"
  },
  {
    "text": "Belvedere Tiburon",
    "value": "belvedere tiburon"
  },
  {
    "text": "Belvidere",
    "value": "belvidere"
  },
  {
    "text": "Belvidere Center",
    "value": "belvidere center"
  },
  {
    "text": "Belview",
    "value": "belview"
  },
  {
    "text": "Belville",
    "value": "belville"
  },
  {
    "text": "Belvue",
    "value": "belvue"
  },
  {
    "text": "Belzoni",
    "value": "belzoni"
  },
  {
    "text": "Bement",
    "value": "bement"
  },
  {
    "text": "Bemidji",
    "value": "bemidji"
  },
  {
    "text": "Bemus Point",
    "value": "bemus point"
  },
  {
    "text": "Ben Hur",
    "value": "ben hur"
  },
  {
    "text": "Ben Lomond",
    "value": "ben lomond"
  },
  {
    "text": "Ben Wheeler",
    "value": "ben wheeler"
  },
  {
    "text": "Bena",
    "value": "bena"
  },
  {
    "text": "Benavides",
    "value": "benavides"
  },
  {
    "text": "Benbrook",
    "value": "benbrook"
  },
  {
    "text": "Bend",
    "value": "bend"
  },
  {
    "text": "Bendena",
    "value": "bendena"
  },
  {
    "text": "Bendersville",
    "value": "bendersville"
  },
  {
    "text": "Benedict",
    "value": "benedict"
  },
  {
    "text": "Benedicta",
    "value": "benedicta"
  },
  {
    "text": "Benet Lake",
    "value": "benet lake"
  },
  {
    "text": "Benezette",
    "value": "benezette"
  },
  {
    "text": "Benge",
    "value": "benge"
  },
  {
    "text": "Benham",
    "value": "benham"
  },
  {
    "text": "Benicia",
    "value": "benicia"
  },
  {
    "text": "Benjamin",
    "value": "benjamin"
  },
  {
    "text": "Benkelman",
    "value": "benkelman"
  },
  {
    "text": "Benld",
    "value": "benld"
  },
  {
    "text": "Bennet",
    "value": "bennet"
  },
  {
    "text": "Bennett",
    "value": "bennett"
  },
  {
    "text": "Bennettsville",
    "value": "bennettsville"
  },
  {
    "text": "Bennington",
    "value": "bennington"
  },
  {
    "text": "Benoit",
    "value": "benoit"
  },
  {
    "text": "Bensalem",
    "value": "bensalem"
  },
  {
    "text": "Bensenville",
    "value": "bensenville"
  },
  {
    "text": "Bensley",
    "value": "bensley"
  },
  {
    "text": "Benson",
    "value": "benson"
  },
  {
    "text": "Bent Mountain",
    "value": "bent mountain"
  },
  {
    "text": "Bentley",
    "value": "bentley"
  },
  {
    "text": "Bentley Creek",
    "value": "bentley creek"
  },
  {
    "text": "Bentleyville",
    "value": "bentleyville"
  },
  {
    "text": "Benton",
    "value": "benton"
  },
  {
    "text": "Benton City",
    "value": "benton city"
  },
  {
    "text": "Benton Harbor",
    "value": "benton harbor"
  },
  {
    "text": "Benton Heights",
    "value": "benton heights"
  },
  {
    "text": "Benton Ridge",
    "value": "benton ridge"
  },
  {
    "text": "Bentonia",
    "value": "bentonia"
  },
  {
    "text": "Bentonville",
    "value": "bentonville"
  },
  {
    "text": "Benwood",
    "value": "benwood"
  },
  {
    "text": "Benzonia",
    "value": "benzonia"
  },
  {
    "text": "Berea",
    "value": "berea"
  },
  {
    "text": "Beresford",
    "value": "beresford"
  },
  {
    "text": "Bergen",
    "value": "bergen"
  },
  {
    "text": "Bergenfield",
    "value": "bergenfield"
  },
  {
    "text": "Berger",
    "value": "berger"
  },
  {
    "text": "Bergheim",
    "value": "bergheim"
  },
  {
    "text": "Bergholz",
    "value": "bergholz"
  },
  {
    "text": "Bergland",
    "value": "bergland"
  },
  {
    "text": "Bergman",
    "value": "bergman"
  },
  {
    "text": "Bergoo",
    "value": "bergoo"
  },
  {
    "text": "Bergton",
    "value": "bergton"
  },
  {
    "text": "Berkeley",
    "value": "berkeley"
  },
  {
    "text": "Berkeley Heights",
    "value": "berkeley heights"
  },
  {
    "text": "Berkeley Lake",
    "value": "berkeley lake"
  },
  {
    "text": "Berkeley Springs",
    "value": "berkeley springs"
  },
  {
    "text": "Berkey",
    "value": "berkey"
  },
  {
    "text": "Berkley",
    "value": "berkley"
  },
  {
    "text": "Berkshire",
    "value": "berkshire"
  },
  {
    "text": "Berlin",
    "value": "berlin"
  },
  {
    "text": "Berlin Center",
    "value": "berlin center"
  },
  {
    "text": "Berlin Corners",
    "value": "berlin corners"
  },
  {
    "text": "Berlin Heights",
    "value": "berlin heights"
  },
  {
    "text": "Bermuda Dunes",
    "value": "bermuda dunes"
  },
  {
    "text": "Bermuda Run",
    "value": "bermuda run"
  },
  {
    "text": "Bern",
    "value": "bern"
  },
  {
    "text": "Bernalillo",
    "value": "bernalillo"
  },
  {
    "text": "Bernard",
    "value": "bernard"
  },
  {
    "text": "Bernardston",
    "value": "bernardston"
  },
  {
    "text": "Bernardsville",
    "value": "bernardsville"
  },
  {
    "text": "Berne",
    "value": "berne"
  },
  {
    "text": "Bernhards Bay",
    "value": "bernhards bay"
  },
  {
    "text": "Bernice",
    "value": "bernice"
  },
  {
    "text": "Bernie",
    "value": "bernie"
  },
  {
    "text": "Bernville",
    "value": "bernville"
  },
  {
    "text": "Berrien Center",
    "value": "berrien center"
  },
  {
    "text": "Berrien Springs",
    "value": "berrien springs"
  },
  {
    "text": "Berry",
    "value": "berry"
  },
  {
    "text": "Berry Creek",
    "value": "berry creek"
  },
  {
    "text": "Berry Hill",
    "value": "berry hill"
  },
  {
    "text": "Berrysburg",
    "value": "berrysburg"
  },
  {
    "text": "Berryton",
    "value": "berryton"
  },
  {
    "text": "Berryville",
    "value": "berryville"
  },
  {
    "text": "Bertha",
    "value": "bertha"
  },
  {
    "text": "Berthold",
    "value": "berthold"
  },
  {
    "text": "Berthoud",
    "value": "berthoud"
  },
  {
    "text": "Bertram",
    "value": "bertram"
  },
  {
    "text": "Bertrand",
    "value": "bertrand"
  },
  {
    "text": "Berwick",
    "value": "berwick"
  },
  {
    "text": "Berwind",
    "value": "berwind"
  },
  {
    "text": "Berwyn",
    "value": "berwyn"
  },
  {
    "text": "Berwyn Heights",
    "value": "berwyn heights"
  },
  {
    "text": "Beryl",
    "value": "beryl"
  },
  {
    "text": "Bessemer",
    "value": "bessemer"
  },
  {
    "text": "Bessemer City",
    "value": "bessemer city"
  },
  {
    "text": "Bessie",
    "value": "bessie"
  },
  {
    "text": "Bethalto",
    "value": "bethalto"
  },
  {
    "text": "Bethania",
    "value": "bethania"
  },
  {
    "text": "Bethany",
    "value": "bethany"
  },
  {
    "text": "Bethany Beach",
    "value": "bethany beach"
  },
  {
    "text": "Bethel",
    "value": "bethel"
  },
  {
    "text": "Bethel Acres",
    "value": "bethel acres"
  },
  {
    "text": "Bethel Heights",
    "value": "bethel heights"
  },
  {
    "text": "Bethel Island",
    "value": "bethel island"
  },
  {
    "text": "Bethel Park",
    "value": "bethel park"
  },
  {
    "text": "Bethel Springs",
    "value": "bethel springs"
  },
  {
    "text": "Bethelridge",
    "value": "bethelridge"
  },
  {
    "text": "Bethesda",
    "value": "bethesda"
  },
  {
    "text": "Bethlehem",
    "value": "bethlehem"
  },
  {
    "text": "Bethpage",
    "value": "bethpage"
  },
  {
    "text": "Bethune",
    "value": "bethune"
  },
  {
    "text": "Betsy Layne",
    "value": "betsy layne"
  },
  {
    "text": "Bettendorf",
    "value": "bettendorf"
  },
  {
    "text": "Betterton",
    "value": "betterton"
  },
  {
    "text": "Bettsville",
    "value": "bettsville"
  },
  {
    "text": "Beulah",
    "value": "beulah"
  },
  {
    "text": "Beulaville",
    "value": "beulaville"
  },
  {
    "text": "Beverly",
    "value": "beverly"
  },
  {
    "text": "Beverly Hills",
    "value": "beverly hills"
  },
  {
    "text": "Beverly Shores",
    "value": "beverly shores"
  },
  {
    "text": "Bevier",
    "value": "bevier"
  },
  {
    "text": "Bevington",
    "value": "bevington"
  },
  {
    "text": "Bevinsville",
    "value": "bevinsville"
  },
  {
    "text": "Bexley",
    "value": "bexley"
  },
  {
    "text": "Bickleton",
    "value": "bickleton"
  },
  {
    "text": "Bickmore",
    "value": "bickmore"
  },
  {
    "text": "Bicknell",
    "value": "bicknell"
  },
  {
    "text": "Biddeford",
    "value": "biddeford"
  },
  {
    "text": "Biddle",
    "value": "biddle"
  },
  {
    "text": "Bidwell",
    "value": "bidwell"
  },
  {
    "text": "Bieber",
    "value": "bieber"
  },
  {
    "text": "Bienville",
    "value": "bienville"
  },
  {
    "text": "Big Arm",
    "value": "big arm"
  },
  {
    "text": "Big Bar",
    "value": "big bar"
  },
  {
    "text": "Big Bay",
    "value": "big bay"
  },
  {
    "text": "Big Bear",
    "value": "big bear"
  },
  {
    "text": "Big Bear City",
    "value": "big bear city"
  },
  {
    "text": "Big Bear Lake",
    "value": "big bear lake"
  },
  {
    "text": "Big Beaver",
    "value": "big beaver"
  },
  {
    "text": "Big Bend",
    "value": "big bend"
  },
  {
    "text": "Big Cabin",
    "value": "big cabin"
  },
  {
    "text": "Big Clifty",
    "value": "big clifty"
  },
  {
    "text": "Big Cove Tannery",
    "value": "big cove tannery"
  },
  {
    "text": "Big Creek",
    "value": "big creek"
  },
  {
    "text": "Big Falls",
    "value": "big falls"
  },
  {
    "text": "Big Flat",
    "value": "big flat"
  },
  {
    "text": "Big Flats",
    "value": "big flats"
  },
  {
    "text": "Big Horn",
    "value": "big horn"
  },
  {
    "text": "Big Indian",
    "value": "big indian"
  },
  {
    "text": "Big Island",
    "value": "big island"
  },
  {
    "text": "Big Lake",
    "value": "big lake"
  },
  {
    "text": "Big Laurel",
    "value": "big laurel"
  },
  {
    "text": "Big Oak Flat",
    "value": "big oak flat"
  },
  {
    "text": "Big Pine",
    "value": "big pine"
  },
  {
    "text": "Big Pine Key",
    "value": "big pine key"
  },
  {
    "text": "Big Piney",
    "value": "big piney"
  },
  {
    "text": "Big Pool",
    "value": "big pool"
  },
  {
    "text": "Big Prairie",
    "value": "big prairie"
  },
  {
    "text": "Big Rapids",
    "value": "big rapids"
  },
  {
    "text": "Big Rock",
    "value": "big rock"
  },
  {
    "text": "Big Run",
    "value": "big run"
  },
  {
    "text": "Big Sandy",
    "value": "big sandy"
  },
  {
    "text": "Big Sky",
    "value": "big sky"
  },
  {
    "text": "Big Spring",
    "value": "big spring"
  },
  {
    "text": "Big Springs",
    "value": "big springs"
  },
  {
    "text": "Big Stone City",
    "value": "big stone city"
  },
  {
    "text": "Big Stone Gap",
    "value": "big stone gap"
  },
  {
    "text": "Big Sur",
    "value": "big sur"
  },
  {
    "text": "Big Timber",
    "value": "big timber"
  },
  {
    "text": "Big Wells",
    "value": "big wells"
  },
  {
    "text": "Bigelow",
    "value": "bigelow"
  },
  {
    "text": "Bigfoot",
    "value": "bigfoot"
  },
  {
    "text": "Bigfork",
    "value": "bigfork"
  },
  {
    "text": "Biggers",
    "value": "biggers"
  },
  {
    "text": "Biggs",
    "value": "biggs"
  },
  {
    "text": "Biggsville",
    "value": "biggsville"
  },
  {
    "text": "Bigler",
    "value": "bigler"
  },
  {
    "text": "Biglerville",
    "value": "biglerville"
  },
  {
    "text": "Billerica",
    "value": "billerica"
  },
  {
    "text": "Billings",
    "value": "billings"
  },
  {
    "text": "Billingsley",
    "value": "billingsley"
  },
  {
    "text": "Biloxi",
    "value": "biloxi"
  },
  {
    "text": "Biltmore Forest",
    "value": "biltmore forest"
  },
  {
    "text": "Bim",
    "value": "bim"
  },
  {
    "text": "Bimble",
    "value": "bimble"
  },
  {
    "text": "Binford",
    "value": "binford"
  },
  {
    "text": "Bingen",
    "value": "bingen"
  },
  {
    "text": "Binger",
    "value": "binger"
  },
  {
    "text": "Bingham",
    "value": "bingham"
  },
  {
    "text": "Bingham Canyon",
    "value": "bingham canyon"
  },
  {
    "text": "Bingham Farms",
    "value": "bingham farms"
  },
  {
    "text": "Bingham Lake",
    "value": "bingham lake"
  },
  {
    "text": "Binghamton",
    "value": "binghamton"
  },
  {
    "text": "Biola",
    "value": "biola"
  },
  {
    "text": "Birch Harbor",
    "value": "birch harbor"
  },
  {
    "text": "Birch River",
    "value": "birch river"
  },
  {
    "text": "Birch Run",
    "value": "birch run"
  },
  {
    "text": "Birch Tree",
    "value": "birch tree"
  },
  {
    "text": "Birchleaf",
    "value": "birchleaf"
  },
  {
    "text": "Birchwood",
    "value": "birchwood"
  },
  {
    "text": "Birchwood Lakes",
    "value": "birchwood lakes"
  },
  {
    "text": "Bird City",
    "value": "bird city"
  },
  {
    "text": "Bird Island",
    "value": "bird island"
  },
  {
    "text": "Bird in Hand",
    "value": "bird in hand"
  },
  {
    "text": "Birds Landing",
    "value": "birds landing"
  },
  {
    "text": "Birdsboro",
    "value": "birdsboro"
  },
  {
    "text": "Birdseye",
    "value": "birdseye"
  },
  {
    "text": "Birdsnest",
    "value": "birdsnest"
  },
  {
    "text": "Birkenfeld",
    "value": "birkenfeld"
  },
  {
    "text": "Birmingham",
    "value": "birmingham"
  },
  {
    "text": "Birnamwood",
    "value": "birnamwood"
  },
  {
    "text": "Bisbee",
    "value": "bisbee"
  },
  {
    "text": "Biscoe",
    "value": "biscoe"
  },
  {
    "text": "Bishop",
    "value": "bishop"
  },
  {
    "text": "Bishop Hill",
    "value": "bishop hill"
  },
  {
    "text": "Bishopville",
    "value": "bishopville"
  },
  {
    "text": "Bismarck",
    "value": "bismarck"
  },
  {
    "text": "Bison",
    "value": "bison"
  },
  {
    "text": "Bitely",
    "value": "bitely"
  },
  {
    "text": "Bivalve",
    "value": "bivalve"
  },
  {
    "text": "Bivins",
    "value": "bivins"
  },
  {
    "text": "Biwabik",
    "value": "biwabik"
  },
  {
    "text": "Bixby",
    "value": "bixby"
  },
  {
    "text": "Blachly",
    "value": "blachly"
  },
  {
    "text": "Black",
    "value": "black"
  },
  {
    "text": "Black Canyon City",
    "value": "black canyon city"
  },
  {
    "text": "Black Creek",
    "value": "black creek"
  },
  {
    "text": "Black Diamond",
    "value": "black diamond"
  },
  {
    "text": "Black Eagle",
    "value": "black eagle"
  },
  {
    "text": "Black Earth",
    "value": "black earth"
  },
  {
    "text": "Black Forest",
    "value": "black forest"
  },
  {
    "text": "Black Hawk",
    "value": "black hawk"
  },
  {
    "text": "Black Jack",
    "value": "black jack"
  },
  {
    "text": "Black Lick",
    "value": "black lick"
  },
  {
    "text": "Black Mountain",
    "value": "black mountain"
  },
  {
    "text": "Black Oak",
    "value": "black oak"
  },
  {
    "text": "Black River",
    "value": "black river"
  },
  {
    "text": "Black River Falls",
    "value": "black river falls"
  },
  {
    "text": "Black Rock",
    "value": "black rock"
  },
  {
    "text": "Blackburn",
    "value": "blackburn"
  },
  {
    "text": "Blackduck",
    "value": "blackduck"
  },
  {
    "text": "Blackey",
    "value": "blackey"
  },
  {
    "text": "Blackfoot",
    "value": "blackfoot"
  },
  {
    "text": "Blackhawk",
    "value": "blackhawk"
  },
  {
    "text": "Blacklick",
    "value": "blacklick"
  },
  {
    "text": "Blackmont",
    "value": "blackmont"
  },
  {
    "text": "Blacksburg",
    "value": "blacksburg"
  },
  {
    "text": "Blackshear",
    "value": "blackshear"
  },
  {
    "text": "Blackstock",
    "value": "blackstock"
  },
  {
    "text": "Blackstone",
    "value": "blackstone"
  },
  {
    "text": "Blacksville",
    "value": "blacksville"
  },
  {
    "text": "Blackville",
    "value": "blackville"
  },
  {
    "text": "Blackwater",
    "value": "blackwater"
  },
  {
    "text": "Blackwell",
    "value": "blackwell"
  },
  {
    "text": "Blackwood",
    "value": "blackwood"
  },
  {
    "text": "Bladen",
    "value": "bladen"
  },
  {
    "text": "Bladenboro",
    "value": "bladenboro"
  },
  {
    "text": "Bladensburg",
    "value": "bladensburg"
  },
  {
    "text": "Blades",
    "value": "blades"
  },
  {
    "text": "Blain",
    "value": "blain"
  },
  {
    "text": "Blaine",
    "value": "blaine"
  },
  {
    "text": "Blair",
    "value": "blair"
  },
  {
    "text": "Blairs",
    "value": "blairs"
  },
  {
    "text": "Blairs Mills",
    "value": "blairs mills"
  },
  {
    "text": "Blairsburg",
    "value": "blairsburg"
  },
  {
    "text": "Blairsden-Graeagle",
    "value": "blairsden-graeagle"
  },
  {
    "text": "Blairstown",
    "value": "blairstown"
  },
  {
    "text": "Blairsville",
    "value": "blairsville"
  },
  {
    "text": "Blakely",
    "value": "blakely"
  },
  {
    "text": "Blakesburg",
    "value": "blakesburg"
  },
  {
    "text": "Blakeslee",
    "value": "blakeslee"
  },
  {
    "text": "Blanch",
    "value": "blanch"
  },
  {
    "text": "Blanchard",
    "value": "blanchard"
  },
  {
    "text": "Blanchardville",
    "value": "blanchardville"
  },
  {
    "text": "Blanchester",
    "value": "blanchester"
  },
  {
    "text": "Blanco",
    "value": "blanco"
  },
  {
    "text": "Bland",
    "value": "bland"
  },
  {
    "text": "Blandburg",
    "value": "blandburg"
  },
  {
    "text": "Blandford",
    "value": "blandford"
  },
  {
    "text": "Blanding",
    "value": "blanding"
  },
  {
    "text": "Blandinsville",
    "value": "blandinsville"
  },
  {
    "text": "Blandon",
    "value": "blandon"
  },
  {
    "text": "Blanford",
    "value": "blanford"
  },
  {
    "text": "Blanket",
    "value": "blanket"
  },
  {
    "text": "Blasdell",
    "value": "blasdell"
  },
  {
    "text": "Blauvelt",
    "value": "blauvelt"
  },
  {
    "text": "Blawenburg",
    "value": "blawenburg"
  },
  {
    "text": "Blawnox",
    "value": "blawnox"
  },
  {
    "text": "Bledsoe",
    "value": "bledsoe"
  },
  {
    "text": "Bleiblerville",
    "value": "bleiblerville"
  },
  {
    "text": "Blencoe",
    "value": "blencoe"
  },
  {
    "text": "Blenheim",
    "value": "blenheim"
  },
  {
    "text": "Blenker",
    "value": "blenker"
  },
  {
    "text": "Blessing",
    "value": "blessing"
  },
  {
    "text": "Blevins",
    "value": "blevins"
  },
  {
    "text": "Bliss",
    "value": "bliss"
  },
  {
    "text": "Bliss Corner",
    "value": "bliss corner"
  },
  {
    "text": "Blissfield",
    "value": "blissfield"
  },
  {
    "text": "Block Island",
    "value": "block island"
  },
  {
    "text": "Blocksburg",
    "value": "blocksburg"
  },
  {
    "text": "Blockton",
    "value": "blockton"
  },
  {
    "text": "Blodgett",
    "value": "blodgett"
  },
  {
    "text": "Blodgett Mills",
    "value": "blodgett mills"
  },
  {
    "text": "Blomkest",
    "value": "blomkest"
  },
  {
    "text": "Bloomburg",
    "value": "bloomburg"
  },
  {
    "text": "Bloomdale",
    "value": "bloomdale"
  },
  {
    "text": "Bloomer",
    "value": "bloomer"
  },
  {
    "text": "Bloomery",
    "value": "bloomery"
  },
  {
    "text": "Bloomfield",
    "value": "bloomfield"
  },
  {
    "text": "Bloomfield Hills",
    "value": "bloomfield hills"
  },
  {
    "text": "Bloomfield Township",
    "value": "bloomfield township"
  },
  {
    "text": "Blooming Glen",
    "value": "blooming glen"
  },
  {
    "text": "Blooming Grove",
    "value": "blooming grove"
  },
  {
    "text": "Blooming Prairie",
    "value": "blooming prairie"
  },
  {
    "text": "Bloomingburg",
    "value": "bloomingburg"
  },
  {
    "text": "Bloomingdale",
    "value": "bloomingdale"
  },
  {
    "text": "Bloomingrose",
    "value": "bloomingrose"
  },
  {
    "text": "Bloomington",
    "value": "bloomington"
  },
  {
    "text": "Bloomsburg",
    "value": "bloomsburg"
  },
  {
    "text": "Bloomsbury",
    "value": "bloomsbury"
  },
  {
    "text": "Bloomsdale",
    "value": "bloomsdale"
  },
  {
    "text": "Bloomville",
    "value": "bloomville"
  },
  {
    "text": "Blossburg",
    "value": "blossburg"
  },
  {
    "text": "Blossom",
    "value": "blossom"
  },
  {
    "text": "Blossvale",
    "value": "blossvale"
  },
  {
    "text": "Blount",
    "value": "blount"
  },
  {
    "text": "Blounts Creek",
    "value": "blounts creek"
  },
  {
    "text": "Blountstown",
    "value": "blountstown"
  },
  {
    "text": "Blountsville",
    "value": "blountsville"
  },
  {
    "text": "Blountville",
    "value": "blountville"
  },
  {
    "text": "Blowing Rock",
    "value": "blowing rock"
  },
  {
    "text": "Bloxom",
    "value": "bloxom"
  },
  {
    "text": "Blue",
    "value": "blue"
  },
  {
    "text": "Blue Ash",
    "value": "blue ash"
  },
  {
    "text": "Blue Ball",
    "value": "blue ball"
  },
  {
    "text": "Blue Bell",
    "value": "blue bell"
  },
  {
    "text": "Blue Creek",
    "value": "blue creek"
  },
  {
    "text": "Blue Diamond",
    "value": "blue diamond"
  },
  {
    "text": "Blue Earth",
    "value": "blue earth"
  },
  {
    "text": "Blue Eye",
    "value": "blue eye"
  },
  {
    "text": "Blue Gap",
    "value": "blue gap"
  },
  {
    "text": "Blue Grass",
    "value": "blue grass"
  },
  {
    "text": "Blue Hill",
    "value": "blue hill"
  },
  {
    "text": "Blue Island",
    "value": "blue island"
  },
  {
    "text": "Blue Jay",
    "value": "blue jay"
  },
  {
    "text": "Blue Lake",
    "value": "blue lake"
  },
  {
    "text": "Blue Mound",
    "value": "blue mound"
  },
  {
    "text": "Blue Mounds",
    "value": "blue mounds"
  },
  {
    "text": "Blue Mountain",
    "value": "blue mountain"
  },
  {
    "text": "Blue Mountain Lake",
    "value": "blue mountain lake"
  },
  {
    "text": "Blue Point",
    "value": "blue point"
  },
  {
    "text": "Blue Rapids",
    "value": "blue rapids"
  },
  {
    "text": "Blue Ridge",
    "value": "blue ridge"
  },
  {
    "text": "Blue Ridge Summit",
    "value": "blue ridge summit"
  },
  {
    "text": "Blue River",
    "value": "blue river"
  },
  {
    "text": "Blue Rock",
    "value": "blue rock"
  },
  {
    "text": "Blue Springs",
    "value": "blue springs"
  },
  {
    "text": "Bluebell",
    "value": "bluebell"
  },
  {
    "text": "Bluefield",
    "value": "bluefield"
  },
  {
    "text": "Bluejacket",
    "value": "bluejacket"
  },
  {
    "text": "Bluemont",
    "value": "bluemont"
  },
  {
    "text": "Bluewater",
    "value": "bluewater"
  },
  {
    "text": "Bluff",
    "value": "bluff"
  },
  {
    "text": "Bluff City",
    "value": "bluff city"
  },
  {
    "text": "Bluff Dale",
    "value": "bluff dale"
  },
  {
    "text": "Bluffdale",
    "value": "bluffdale"
  },
  {
    "text": "Bluffs",
    "value": "bluffs"
  },
  {
    "text": "Bluffton",
    "value": "bluffton"
  },
  {
    "text": "Bluford",
    "value": "bluford"
  },
  {
    "text": "Blum",
    "value": "blum"
  },
  {
    "text": "Blunt",
    "value": "blunt"
  },
  {
    "text": "Bly",
    "value": "bly"
  },
  {
    "text": "Blythe",
    "value": "blythe"
  },
  {
    "text": "Blythedale",
    "value": "blythedale"
  },
  {
    "text": "Blytheville",
    "value": "blytheville"
  },
  {
    "text": "Blythewood",
    "value": "blythewood"
  },
  {
    "text": "Boalsburg",
    "value": "boalsburg"
  },
  {
    "text": "Boardman",
    "value": "boardman"
  },
  {
    "text": "Boaz",
    "value": "boaz"
  },
  {
    "text": "Bobtown",
    "value": "bobtown"
  },
  {
    "text": "Boca Grande",
    "value": "boca grande"
  },
  {
    "text": "Boca Raton",
    "value": "boca raton"
  },
  {
    "text": "Bock",
    "value": "bock"
  },
  {
    "text": "Bode",
    "value": "bode"
  },
  {
    "text": "Bodega",
    "value": "bodega"
  },
  {
    "text": "Bodega Bay",
    "value": "bodega bay"
  },
  {
    "text": "Bodfish",
    "value": "bodfish"
  },
  {
    "text": "Boelus",
    "value": "boelus"
  },
  {
    "text": "Boerne",
    "value": "boerne"
  },
  {
    "text": "Bogalusa",
    "value": "bogalusa"
  },
  {
    "text": "Bogard",
    "value": "bogard"
  },
  {
    "text": "Bogart",
    "value": "bogart"
  },
  {
    "text": "Bogata",
    "value": "bogata"
  },
  {
    "text": "Boggstown",
    "value": "boggstown"
  },
  {
    "text": "Bogota",
    "value": "bogota"
  },
  {
    "text": "Bogue Chitto",
    "value": "bogue chitto"
  },
  {
    "text": "Bohannon",
    "value": "bohannon"
  },
  {
    "text": "Bohemia",
    "value": "bohemia"
  },
  {
    "text": "Bohners Lake",
    "value": "bohners lake"
  },
  {
    "text": "Boiceville",
    "value": "boiceville"
  },
  {
    "text": "Boiling Spring Lakes",
    "value": "boiling spring lakes"
  },
  {
    "text": "Boiling Springs",
    "value": "boiling springs"
  },
  {
    "text": "Bois D'Arc",
    "value": "bois d'arc"
  },
  {
    "text": "Boise",
    "value": "boise"
  },
  {
    "text": "Boise City",
    "value": "boise city"
  },
  {
    "text": "Bokchito",
    "value": "bokchito"
  },
  {
    "text": "Bokeelia",
    "value": "bokeelia"
  },
  {
    "text": "Bokoshe",
    "value": "bokoshe"
  },
  {
    "text": "Bolckow",
    "value": "bolckow"
  },
  {
    "text": "Boles",
    "value": "boles"
  },
  {
    "text": "Boley",
    "value": "boley"
  },
  {
    "text": "Boligee",
    "value": "boligee"
  },
  {
    "text": "Bolinas",
    "value": "bolinas"
  },
  {
    "text": "Boling",
    "value": "boling"
  },
  {
    "text": "Bolingbroke",
    "value": "bolingbroke"
  },
  {
    "text": "Bolingbrook",
    "value": "bolingbrook"
  },
  {
    "text": "Bolivar",
    "value": "bolivar"
  },
  {
    "text": "Bolivia",
    "value": "bolivia"
  },
  {
    "text": "Bolt",
    "value": "bolt"
  },
  {
    "text": "Bolton",
    "value": "bolton"
  },
  {
    "text": "Bolton Landing",
    "value": "bolton landing"
  },
  {
    "text": "Bombay",
    "value": "bombay"
  },
  {
    "text": "Bomont",
    "value": "bomont"
  },
  {
    "text": "Bomoseen",
    "value": "bomoseen"
  },
  {
    "text": "Bon Air",
    "value": "bon air"
  },
  {
    "text": "Bon Aqua",
    "value": "bon aqua"
  },
  {
    "text": "Bon Aqua Junction",
    "value": "bon aqua junction"
  },
  {
    "text": "Bon Secour",
    "value": "bon secour"
  },
  {
    "text": "Bon Wier",
    "value": "bon wier"
  },
  {
    "text": "Bonaire",
    "value": "bonaire"
  },
  {
    "text": "Bonanza",
    "value": "bonanza"
  },
  {
    "text": "Bonaparte",
    "value": "bonaparte"
  },
  {
    "text": "Boncarbo",
    "value": "boncarbo"
  },
  {
    "text": "Bond",
    "value": "bond"
  },
  {
    "text": "Bondsville",
    "value": "bondsville"
  },
  {
    "text": "Bonduel",
    "value": "bonduel"
  },
  {
    "text": "Bondurant",
    "value": "bondurant"
  },
  {
    "text": "Bondville",
    "value": "bondville"
  },
  {
    "text": "Bone Gap",
    "value": "bone gap"
  },
  {
    "text": "Bonesteel",
    "value": "bonesteel"
  },
  {
    "text": "Boneville",
    "value": "boneville"
  },
  {
    "text": "Bonfield",
    "value": "bonfield"
  },
  {
    "text": "Bonham",
    "value": "bonham"
  },
  {
    "text": "Bonifay",
    "value": "bonifay"
  },
  {
    "text": "Bonita",
    "value": "bonita"
  },
  {
    "text": "Bonita Springs",
    "value": "bonita springs"
  },
  {
    "text": "Bonlee",
    "value": "bonlee"
  },
  {
    "text": "Bonne Terre",
    "value": "bonne terre"
  },
  {
    "text": "Bonneau",
    "value": "bonneau"
  },
  {
    "text": "Bonneauville",
    "value": "bonneauville"
  },
  {
    "text": "Bonner",
    "value": "bonner"
  },
  {
    "text": "Bonner Springs",
    "value": "bonner springs"
  },
  {
    "text": "Bonner-West Riverside",
    "value": "bonner-west riverside"
  },
  {
    "text": "Bonnerdale",
    "value": "bonnerdale"
  },
  {
    "text": "Bonners Ferry",
    "value": "bonners ferry"
  },
  {
    "text": "Bonney Lake",
    "value": "bonney lake"
  },
  {
    "text": "Bonnie",
    "value": "bonnie"
  },
  {
    "text": "Bonnieville",
    "value": "bonnieville"
  },
  {
    "text": "Bonnots Mill",
    "value": "bonnots mill"
  },
  {
    "text": "Bonnyman",
    "value": "bonnyman"
  },
  {
    "text": "Bono",
    "value": "bono"
  },
  {
    "text": "Bonsall",
    "value": "bonsall"
  },
  {
    "text": "Boody",
    "value": "boody"
  },
  {
    "text": "Booker",
    "value": "booker"
  },
  {
    "text": "Boomer",
    "value": "boomer"
  },
  {
    "text": "Boon",
    "value": "boon"
  },
  {
    "text": "Boone",
    "value": "boone"
  },
  {
    "text": "Boone Grove",
    "value": "boone grove"
  },
  {
    "text": "Boones Mill",
    "value": "boones mill"
  },
  {
    "text": "Booneville",
    "value": "booneville"
  },
  {
    "text": "Boons Camp",
    "value": "boons camp"
  },
  {
    "text": "Boonsboro",
    "value": "boonsboro"
  },
  {
    "text": "Boonton",
    "value": "boonton"
  },
  {
    "text": "Boonville",
    "value": "boonville"
  },
  {
    "text": "Booth",
    "value": "booth"
  },
  {
    "text": "Boothbay",
    "value": "boothbay"
  },
  {
    "text": "Boothbay Harbor",
    "value": "boothbay harbor"
  },
  {
    "text": "Boothville",
    "value": "boothville"
  },
  {
    "text": "Boothwyn",
    "value": "boothwyn"
  },
  {
    "text": "Borden",
    "value": "borden"
  },
  {
    "text": "Bordentown",
    "value": "bordentown"
  },
  {
    "text": "Borger",
    "value": "borger"
  },
  {
    "text": "Boring",
    "value": "boring"
  },
  {
    "text": "Boron",
    "value": "boron"
  },
  {
    "text": "Borough Park",
    "value": "borough park"
  },
  {
    "text": "Borrego Springs",
    "value": "borrego springs"
  },
  {
    "text": "Borup",
    "value": "borup"
  },
  {
    "text": "Boscawen",
    "value": "boscawen"
  },
  {
    "text": "Boscobel",
    "value": "boscobel"
  },
  {
    "text": "Bosque",
    "value": "bosque"
  },
  {
    "text": "Bosque Farms",
    "value": "bosque farms"
  },
  {
    "text": "Boss",
    "value": "boss"
  },
  {
    "text": "Bossier City",
    "value": "bossier city"
  },
  {
    "text": "Bostic",
    "value": "bostic"
  },
  {
    "text": "Boston",
    "value": "boston"
  },
  {
    "text": "Boston Heights",
    "value": "boston heights"
  },
  {
    "text": "Boswell",
    "value": "boswell"
  },
  {
    "text": "Bosworth",
    "value": "bosworth"
  },
  {
    "text": "Bothell",
    "value": "bothell"
  },
  {
    "text": "Botkins",
    "value": "botkins"
  },
  {
    "text": "Bottineau",
    "value": "bottineau"
  },
  {
    "text": "Bouckville",
    "value": "bouckville"
  },
  {
    "text": "Boulder",
    "value": "boulder"
  },
  {
    "text": "Boulder City",
    "value": "boulder city"
  },
  {
    "text": "Boulder Creek",
    "value": "boulder creek"
  },
  {
    "text": "Boulder Junction",
    "value": "boulder junction"
  },
  {
    "text": "Boulder Town",
    "value": "boulder town"
  },
  {
    "text": "Boulevard",
    "value": "boulevard"
  },
  {
    "text": "Bound Brook",
    "value": "bound brook"
  },
  {
    "text": "Bountiful",
    "value": "bountiful"
  },
  {
    "text": "Bourbon",
    "value": "bourbon"
  },
  {
    "text": "Bourbonnais",
    "value": "bourbonnais"
  },
  {
    "text": "Bourg",
    "value": "bourg"
  },
  {
    "text": "Bourne",
    "value": "bourne"
  },
  {
    "text": "Bourneville",
    "value": "bourneville"
  },
  {
    "text": "Bouse",
    "value": "bouse"
  },
  {
    "text": "Bouton",
    "value": "bouton"
  },
  {
    "text": "Boutte",
    "value": "boutte"
  },
  {
    "text": "Bovard",
    "value": "bovard"
  },
  {
    "text": "Bovey",
    "value": "bovey"
  },
  {
    "text": "Bovina",
    "value": "bovina"
  },
  {
    "text": "Bovina Center",
    "value": "bovina center"
  },
  {
    "text": "Bow",
    "value": "bow"
  },
  {
    "text": "Bowbells",
    "value": "bowbells"
  },
  {
    "text": "Bowden",
    "value": "bowden"
  },
  {
    "text": "Bowdle",
    "value": "bowdle"
  },
  {
    "text": "Bowdoin",
    "value": "bowdoin"
  },
  {
    "text": "Bowdoin Center",
    "value": "bowdoin center"
  },
  {
    "text": "Bowdoinham",
    "value": "bowdoinham"
  },
  {
    "text": "Bowdon",
    "value": "bowdon"
  },
  {
    "text": "Bowen",
    "value": "bowen"
  },
  {
    "text": "Bowerston",
    "value": "bowerston"
  },
  {
    "text": "Bowersville",
    "value": "bowersville"
  },
  {
    "text": "Bowie",
    "value": "bowie"
  },
  {
    "text": "Bowlegs",
    "value": "bowlegs"
  },
  {
    "text": "Bowler",
    "value": "bowler"
  },
  {
    "text": "Bowleys Quarters",
    "value": "bowleys quarters"
  },
  {
    "text": "Bowling Green",
    "value": "bowling green"
  },
  {
    "text": "Bowlus",
    "value": "bowlus"
  },
  {
    "text": "Bowman",
    "value": "bowman"
  },
  {
    "text": "Bowmansville",
    "value": "bowmansville"
  },
  {
    "text": "Box Elder",
    "value": "box elder"
  },
  {
    "text": "Box Springs",
    "value": "box springs"
  },
  {
    "text": "Boxborough",
    "value": "boxborough"
  },
  {
    "text": "Boxford",
    "value": "boxford"
  },
  {
    "text": "Boxholm",
    "value": "boxholm"
  },
  {
    "text": "Boyce",
    "value": "boyce"
  },
  {
    "text": "Boyceville",
    "value": "boyceville"
  },
  {
    "text": "Boyd",
    "value": "boyd"
  },
  {
    "text": "Boyden",
    "value": "boyden"
  },
  {
    "text": "Boyds",
    "value": "boyds"
  },
  {
    "text": "Boydton",
    "value": "boydton"
  },
  {
    "text": "Boyers",
    "value": "boyers"
  },
  {
    "text": "Boyertown",
    "value": "boyertown"
  },
  {
    "text": "Boyes Hot Springs",
    "value": "boyes hot springs"
  },
  {
    "text": "Boykins",
    "value": "boykins"
  },
  {
    "text": "Boyle",
    "value": "boyle"
  },
  {
    "text": "Boyle Heights",
    "value": "boyle heights"
  },
  {
    "text": "Boylston",
    "value": "boylston"
  },
  {
    "text": "Boyne City",
    "value": "boyne city"
  },
  {
    "text": "Boyne Falls",
    "value": "boyne falls"
  },
  {
    "text": "Boynton",
    "value": "boynton"
  },
  {
    "text": "Boynton Beach",
    "value": "boynton beach"
  },
  {
    "text": "Boys Ranch",
    "value": "boys ranch"
  },
  {
    "text": "Boys Town",
    "value": "boys town"
  },
  {
    "text": "Bozeman",
    "value": "bozeman"
  },
  {
    "text": "Bozman",
    "value": "bozman"
  },
  {
    "text": "Bozrah",
    "value": "bozrah"
  },
  {
    "text": "Braceville",
    "value": "braceville"
  },
  {
    "text": "Bracey",
    "value": "bracey"
  },
  {
    "text": "Brackenridge",
    "value": "brackenridge"
  },
  {
    "text": "Brackettville",
    "value": "brackettville"
  },
  {
    "text": "Brackney",
    "value": "brackney"
  },
  {
    "text": "Bradbury",
    "value": "bradbury"
  },
  {
    "text": "Braddock",
    "value": "braddock"
  },
  {
    "text": "Braddock Heights",
    "value": "braddock heights"
  },
  {
    "text": "Braddyville",
    "value": "braddyville"
  },
  {
    "text": "Bradenton",
    "value": "bradenton"
  },
  {
    "text": "Bradenton Beach",
    "value": "bradenton beach"
  },
  {
    "text": "Bradenville",
    "value": "bradenville"
  },
  {
    "text": "Bradford",
    "value": "bradford"
  },
  {
    "text": "Bradford Woods",
    "value": "bradford woods"
  },
  {
    "text": "Bradfordsville",
    "value": "bradfordsville"
  },
  {
    "text": "Bradgate",
    "value": "bradgate"
  },
  {
    "text": "Bradley",
    "value": "bradley"
  },
  {
    "text": "Bradley Beach",
    "value": "bradley beach"
  },
  {
    "text": "Bradley Junction",
    "value": "bradley junction"
  },
  {
    "text": "Bradleyville",
    "value": "bradleyville"
  },
  {
    "text": "Bradner",
    "value": "bradner"
  },
  {
    "text": "Bradshaw",
    "value": "bradshaw"
  },
  {
    "text": "Brady",
    "value": "brady"
  },
  {
    "text": "Brady Lake",
    "value": "brady lake"
  },
  {
    "text": "Bradyville",
    "value": "bradyville"
  },
  {
    "text": "Bragg City",
    "value": "bragg city"
  },
  {
    "text": "Braggadocio",
    "value": "braggadocio"
  },
  {
    "text": "Braggs",
    "value": "braggs"
  },
  {
    "text": "Braham",
    "value": "braham"
  },
  {
    "text": "Braidwood",
    "value": "braidwood"
  },
  {
    "text": "Brainard",
    "value": "brainard"
  },
  {
    "text": "Brainerd",
    "value": "brainerd"
  },
  {
    "text": "Braintree",
    "value": "braintree"
  },
  {
    "text": "Braithwaite",
    "value": "braithwaite"
  },
  {
    "text": "Braman",
    "value": "braman"
  },
  {
    "text": "Brambleton",
    "value": "brambleton"
  },
  {
    "text": "Bramwell",
    "value": "bramwell"
  },
  {
    "text": "Branch",
    "value": "branch"
  },
  {
    "text": "Branch Township",
    "value": "branch township"
  },
  {
    "text": "Branchland",
    "value": "branchland"
  },
  {
    "text": "Branchport",
    "value": "branchport"
  },
  {
    "text": "Branchville",
    "value": "branchville"
  },
  {
    "text": "Brandamore",
    "value": "brandamore"
  },
  {
    "text": "Brandeis",
    "value": "brandeis"
  },
  {
    "text": "Brandenburg",
    "value": "brandenburg"
  },
  {
    "text": "Brandermill",
    "value": "brandermill"
  },
  {
    "text": "Brandon",
    "value": "brandon"
  },
  {
    "text": "Brandsville",
    "value": "brandsville"
  },
  {
    "text": "Brandt",
    "value": "brandt"
  },
  {
    "text": "Brandy Station",
    "value": "brandy station"
  },
  {
    "text": "Brandywine",
    "value": "brandywine"
  },
  {
    "text": "Branford",
    "value": "branford"
  },
  {
    "text": "Branson",
    "value": "branson"
  },
  {
    "text": "Branson West",
    "value": "branson west"
  },
  {
    "text": "Brant",
    "value": "brant"
  },
  {
    "text": "Brant Lake",
    "value": "brant lake"
  },
  {
    "text": "Brant Rock",
    "value": "brant rock"
  },
  {
    "text": "Brantingham",
    "value": "brantingham"
  },
  {
    "text": "Brantley",
    "value": "brantley"
  },
  {
    "text": "Brantwood",
    "value": "brantwood"
  },
  {
    "text": "Braselton",
    "value": "braselton"
  },
  {
    "text": "Brashear",
    "value": "brashear"
  },
  {
    "text": "Brasher Falls",
    "value": "brasher falls"
  },
  {
    "text": "Brass Castle",
    "value": "brass castle"
  },
  {
    "text": "Brasstown",
    "value": "brasstown"
  },
  {
    "text": "Bratenahl",
    "value": "bratenahl"
  },
  {
    "text": "Brattleboro",
    "value": "brattleboro"
  },
  {
    "text": "Brave",
    "value": "brave"
  },
  {
    "text": "Brawley",
    "value": "brawley"
  },
  {
    "text": "Braxton",
    "value": "braxton"
  },
  {
    "text": "Bray",
    "value": "bray"
  },
  {
    "text": "Braymer",
    "value": "braymer"
  },
  {
    "text": "Brayton",
    "value": "brayton"
  },
  {
    "text": "Brazil",
    "value": "brazil"
  },
  {
    "text": "Brazoria",
    "value": "brazoria"
  },
  {
    "text": "Brea",
    "value": "brea"
  },
  {
    "text": "Breaks",
    "value": "breaks"
  },
  {
    "text": "Breaux Bridge",
    "value": "breaux bridge"
  },
  {
    "text": "Breckenridge",
    "value": "breckenridge"
  },
  {
    "text": "Breckenridge Hills",
    "value": "breckenridge hills"
  },
  {
    "text": "Brecksville",
    "value": "brecksville"
  },
  {
    "text": "Breda",
    "value": "breda"
  },
  {
    "text": "Breeden",
    "value": "breeden"
  },
  {
    "text": "Breeding",
    "value": "breeding"
  },
  {
    "text": "Breese",
    "value": "breese"
  },
  {
    "text": "Breezewood",
    "value": "breezewood"
  },
  {
    "text": "Breezy Point",
    "value": "breezy point"
  },
  {
    "text": "Breinigsville",
    "value": "breinigsville"
  },
  {
    "text": "Bremen",
    "value": "bremen"
  },
  {
    "text": "Bremerton",
    "value": "bremerton"
  },
  {
    "text": "Bremo Bluff",
    "value": "bremo bluff"
  },
  {
    "text": "Bremond",
    "value": "bremond"
  },
  {
    "text": "Brenham",
    "value": "brenham"
  },
  {
    "text": "Brent",
    "value": "brent"
  },
  {
    "text": "Brentford",
    "value": "brentford"
  },
  {
    "text": "Brenton",
    "value": "brenton"
  },
  {
    "text": "Brentwood",
    "value": "brentwood"
  },
  {
    "text": "Brethren",
    "value": "brethren"
  },
  {
    "text": "Bretton Woods",
    "value": "bretton woods"
  },
  {
    "text": "Bretz",
    "value": "bretz"
  },
  {
    "text": "Brevard",
    "value": "brevard"
  },
  {
    "text": "Brevig Mission",
    "value": "brevig mission"
  },
  {
    "text": "Brewer",
    "value": "brewer"
  },
  {
    "text": "Brewerton",
    "value": "brewerton"
  },
  {
    "text": "Brewster",
    "value": "brewster"
  },
  {
    "text": "Brewton",
    "value": "brewton"
  },
  {
    "text": "Brian Head",
    "value": "brian head"
  },
  {
    "text": "Briarcliff",
    "value": "briarcliff"
  },
  {
    "text": "Briarcliff Manor",
    "value": "briarcliff manor"
  },
  {
    "text": "Bricelyn",
    "value": "bricelyn"
  },
  {
    "text": "Briceville",
    "value": "briceville"
  },
  {
    "text": "Brick",
    "value": "brick"
  },
  {
    "text": "Brickeys",
    "value": "brickeys"
  },
  {
    "text": "Bridge City",
    "value": "bridge city"
  },
  {
    "text": "Bridgehampton",
    "value": "bridgehampton"
  },
  {
    "text": "Bridgeport",
    "value": "bridgeport"
  },
  {
    "text": "Bridger",
    "value": "bridger"
  },
  {
    "text": "Bridgeton",
    "value": "bridgeton"
  },
  {
    "text": "Bridgetown",
    "value": "bridgetown"
  },
  {
    "text": "Bridgeview",
    "value": "bridgeview"
  },
  {
    "text": "Bridgeville",
    "value": "bridgeville"
  },
  {
    "text": "Bridgewater",
    "value": "bridgewater"
  },
  {
    "text": "Bridgewater Corners",
    "value": "bridgewater corners"
  },
  {
    "text": "Bridgman",
    "value": "bridgman"
  },
  {
    "text": "Bridgton",
    "value": "bridgton"
  },
  {
    "text": "Bridport",
    "value": "bridport"
  },
  {
    "text": "Brielle",
    "value": "brielle"
  },
  {
    "text": "Brier",
    "value": "brier"
  },
  {
    "text": "Brier Hill",
    "value": "brier hill"
  },
  {
    "text": "Brierfield",
    "value": "brierfield"
  },
  {
    "text": "Brigantine",
    "value": "brigantine"
  },
  {
    "text": "Briggs",
    "value": "briggs"
  },
  {
    "text": "Briggsdale",
    "value": "briggsdale"
  },
  {
    "text": "Briggsville",
    "value": "briggsville"
  },
  {
    "text": "Brigham City",
    "value": "brigham city"
  },
  {
    "text": "Bright",
    "value": "bright"
  },
  {
    "text": "Brighton",
    "value": "brighton"
  },
  {
    "text": "Brightwaters",
    "value": "brightwaters"
  },
  {
    "text": "Brightwood",
    "value": "brightwood"
  },
  {
    "text": "Brill",
    "value": "brill"
  },
  {
    "text": "Brilliant",
    "value": "brilliant"
  },
  {
    "text": "Brillion",
    "value": "brillion"
  },
  {
    "text": "Brimfield",
    "value": "brimfield"
  },
  {
    "text": "Brimley",
    "value": "brimley"
  },
  {
    "text": "Brimson",
    "value": "brimson"
  },
  {
    "text": "Bringhurst",
    "value": "bringhurst"
  },
  {
    "text": "Brinkhaven",
    "value": "brinkhaven"
  },
  {
    "text": "Brinkley",
    "value": "brinkley"
  },
  {
    "text": "Brinklow",
    "value": "brinklow"
  },
  {
    "text": "Brinnon",
    "value": "brinnon"
  },
  {
    "text": "Brinson",
    "value": "brinson"
  },
  {
    "text": "Brisbane",
    "value": "brisbane"
  },
  {
    "text": "Briscoe",
    "value": "briscoe"
  },
  {
    "text": "Bristol",
    "value": "bristol"
  },
  {
    "text": "Bristolville",
    "value": "bristolville"
  },
  {
    "text": "Bristow",
    "value": "bristow"
  },
  {
    "text": "Britt",
    "value": "britt"
  },
  {
    "text": "Britton",
    "value": "britton"
  },
  {
    "text": "Broad Brook",
    "value": "broad brook"
  },
  {
    "text": "Broad Run",
    "value": "broad run"
  },
  {
    "text": "Broad Top",
    "value": "broad top"
  },
  {
    "text": "Broad Top City",
    "value": "broad top city"
  },
  {
    "text": "Broadalbin",
    "value": "broadalbin"
  },
  {
    "text": "Broadbent",
    "value": "broadbent"
  },
  {
    "text": "Broaddus",
    "value": "broaddus"
  },
  {
    "text": "Broadford",
    "value": "broadford"
  },
  {
    "text": "Broadlands",
    "value": "broadlands"
  },
  {
    "text": "Broadus",
    "value": "broadus"
  },
  {
    "text": "Broadview",
    "value": "broadview"
  },
  {
    "text": "Broadview Heights",
    "value": "broadview heights"
  },
  {
    "text": "Broadway",
    "value": "broadway"
  },
  {
    "text": "Brock",
    "value": "brock"
  },
  {
    "text": "Brocket",
    "value": "brocket"
  },
  {
    "text": "Brockport",
    "value": "brockport"
  },
  {
    "text": "Brockton",
    "value": "brockton"
  },
  {
    "text": "Brockway",
    "value": "brockway"
  },
  {
    "text": "Brockwell",
    "value": "brockwell"
  },
  {
    "text": "Brocton",
    "value": "brocton"
  },
  {
    "text": "Broderick",
    "value": "broderick"
  },
  {
    "text": "Brodhead",
    "value": "brodhead"
  },
  {
    "text": "Brodheadsville",
    "value": "brodheadsville"
  },
  {
    "text": "Brodnax",
    "value": "brodnax"
  },
  {
    "text": "Brogan",
    "value": "brogan"
  },
  {
    "text": "Brogden",
    "value": "brogden"
  },
  {
    "text": "Brogue",
    "value": "brogue"
  },
  {
    "text": "Brohard",
    "value": "brohard"
  },
  {
    "text": "Brokaw",
    "value": "brokaw"
  },
  {
    "text": "Broken Arrow",
    "value": "broken arrow"
  },
  {
    "text": "Broken Bow",
    "value": "broken bow"
  },
  {
    "text": "Bromide",
    "value": "bromide"
  },
  {
    "text": "Bronaugh",
    "value": "bronaugh"
  },
  {
    "text": "Bronson",
    "value": "bronson"
  },
  {
    "text": "Bronston",
    "value": "bronston"
  },
  {
    "text": "Bronte",
    "value": "bronte"
  },
  {
    "text": "Bronwood",
    "value": "bronwood"
  },
  {
    "text": "Bronx",
    "value": "bronx"
  },
  {
    "text": "Bronxville",
    "value": "bronxville"
  },
  {
    "text": "Brook",
    "value": "brook"
  },
  {
    "text": "Brook Highland",
    "value": "brook highland"
  },
  {
    "text": "Brook Park",
    "value": "brook park"
  },
  {
    "text": "Brookdale",
    "value": "brookdale"
  },
  {
    "text": "Brookeland",
    "value": "brookeland"
  },
  {
    "text": "Brooker",
    "value": "brooker"
  },
  {
    "text": "Brookeville",
    "value": "brookeville"
  },
  {
    "text": "Brookfield",
    "value": "brookfield"
  },
  {
    "text": "Brookhaven",
    "value": "brookhaven"
  },
  {
    "text": "Brookings",
    "value": "brookings"
  },
  {
    "text": "Brookland",
    "value": "brookland"
  },
  {
    "text": "Brooklandville",
    "value": "brooklandville"
  },
  {
    "text": "Brooklawn",
    "value": "brooklawn"
  },
  {
    "text": "Brooklet",
    "value": "brooklet"
  },
  {
    "text": "Brooklin",
    "value": "brooklin"
  },
  {
    "text": "Brookline",
    "value": "brookline"
  },
  {
    "text": "Brookline Village",
    "value": "brookline village"
  },
  {
    "text": "Brooklyn",
    "value": "brooklyn"
  },
  {
    "text": "Brooklyn Center",
    "value": "brooklyn center"
  },
  {
    "text": "Brooklyn Heights",
    "value": "brooklyn heights"
  },
  {
    "text": "Brooklyn Park",
    "value": "brooklyn park"
  },
  {
    "text": "Brookneal",
    "value": "brookneal"
  },
  {
    "text": "Brookport",
    "value": "brookport"
  },
  {
    "text": "Brooks",
    "value": "brooks"
  },
  {
    "text": "Brookshire",
    "value": "brookshire"
  },
  {
    "text": "Brookside",
    "value": "brookside"
  },
  {
    "text": "Brookston",
    "value": "brookston"
  },
  {
    "text": "Brooksville",
    "value": "brooksville"
  },
  {
    "text": "Brookton",
    "value": "brookton"
  },
  {
    "text": "Brooktondale",
    "value": "brooktondale"
  },
  {
    "text": "Brookville",
    "value": "brookville"
  },
  {
    "text": "Brookwood",
    "value": "brookwood"
  },
  {
    "text": "Broomall",
    "value": "broomall"
  },
  {
    "text": "Broomes Island",
    "value": "broomes island"
  },
  {
    "text": "Broomfield",
    "value": "broomfield"
  },
  {
    "text": "Brooten",
    "value": "brooten"
  },
  {
    "text": "Broseley",
    "value": "broseley"
  },
  {
    "text": "Brosville",
    "value": "brosville"
  },
  {
    "text": "Brothers",
    "value": "brothers"
  },
  {
    "text": "Broughton",
    "value": "broughton"
  },
  {
    "text": "Broussard",
    "value": "broussard"
  },
  {
    "text": "Browerville",
    "value": "browerville"
  },
  {
    "text": "Brown City",
    "value": "brown city"
  },
  {
    "text": "Brown Deer",
    "value": "brown deer"
  },
  {
    "text": "Brownell",
    "value": "brownell"
  },
  {
    "text": "Brownfield",
    "value": "brownfield"
  },
  {
    "text": "Browning",
    "value": "browning"
  },
  {
    "text": "Browns Mills",
    "value": "browns mills"
  },
  {
    "text": "Browns Summit",
    "value": "browns summit"
  },
  {
    "text": "Browns Valley",
    "value": "browns valley"
  },
  {
    "text": "Brownsboro",
    "value": "brownsboro"
  },
  {
    "text": "Brownsburg",
    "value": "brownsburg"
  },
  {
    "text": "Brownsdale",
    "value": "brownsdale"
  },
  {
    "text": "Brownstown",
    "value": "brownstown"
  },
  {
    "text": "Brownsville",
    "value": "brownsville"
  },
  {
    "text": "Brownton",
    "value": "brownton"
  },
  {
    "text": "Browntown",
    "value": "browntown"
  },
  {
    "text": "Brownville",
    "value": "brownville"
  },
  {
    "text": "Brownwood",
    "value": "brownwood"
  },
  {
    "text": "Broxton",
    "value": "broxton"
  },
  {
    "text": "Bruce",
    "value": "bruce"
  },
  {
    "text": "Bruce Crossing",
    "value": "bruce crossing"
  },
  {
    "text": "Bruceton",
    "value": "bruceton"
  },
  {
    "text": "Bruceton Mills",
    "value": "bruceton mills"
  },
  {
    "text": "Bruceville",
    "value": "bruceville"
  },
  {
    "text": "Bruceville-Eddy",
    "value": "bruceville-eddy"
  },
  {
    "text": "Bruin",
    "value": "bruin"
  },
  {
    "text": "Bruington",
    "value": "bruington"
  },
  {
    "text": "Brule",
    "value": "brule"
  },
  {
    "text": "Brumley",
    "value": "brumley"
  },
  {
    "text": "Brundidge",
    "value": "brundidge"
  },
  {
    "text": "Bruneau",
    "value": "bruneau"
  },
  {
    "text": "Bruner",
    "value": "bruner"
  },
  {
    "text": "Bruni",
    "value": "bruni"
  },
  {
    "text": "Bruning",
    "value": "bruning"
  },
  {
    "text": "Bruno",
    "value": "bruno"
  },
  {
    "text": "Brunson",
    "value": "brunson"
  },
  {
    "text": "Brunswick",
    "value": "brunswick"
  },
  {
    "text": "Brush",
    "value": "brush"
  },
  {
    "text": "Brush Creek",
    "value": "brush creek"
  },
  {
    "text": "Brush Fork",
    "value": "brush fork"
  },
  {
    "text": "Brush Prairie",
    "value": "brush prairie"
  },
  {
    "text": "Brush Valley",
    "value": "brush valley"
  },
  {
    "text": "Brushton",
    "value": "brushton"
  },
  {
    "text": "Brusly",
    "value": "brusly"
  },
  {
    "text": "Brussels",
    "value": "brussels"
  },
  {
    "text": "Brutus",
    "value": "brutus"
  },
  {
    "text": "Bryan",
    "value": "bryan"
  },
  {
    "text": "Bryans Road",
    "value": "bryans road"
  },
  {
    "text": "Bryant",
    "value": "bryant"
  },
  {
    "text": "Bryant Pond",
    "value": "bryant pond"
  },
  {
    "text": "Bryantown",
    "value": "bryantown"
  },
  {
    "text": "Bryantsville",
    "value": "bryantsville"
  },
  {
    "text": "Bryce",
    "value": "bryce"
  },
  {
    "text": "Bryce Canyon City",
    "value": "bryce canyon city"
  },
  {
    "text": "Bryceville",
    "value": "bryceville"
  },
  {
    "text": "Bryn Athyn",
    "value": "bryn athyn"
  },
  {
    "text": "Bryn Mawr",
    "value": "bryn mawr"
  },
  {
    "text": "Bryson",
    "value": "bryson"
  },
  {
    "text": "Bryson City",
    "value": "bryson city"
  },
  {
    "text": "Buchanan",
    "value": "buchanan"
  },
  {
    "text": "Buchanan Dam",
    "value": "buchanan dam"
  },
  {
    "text": "Buck Creek",
    "value": "buck creek"
  },
  {
    "text": "Buck Hill Falls",
    "value": "buck hill falls"
  },
  {
    "text": "Buckatunna",
    "value": "buckatunna"
  },
  {
    "text": "Buckeye",
    "value": "buckeye"
  },
  {
    "text": "Buckeye Lake",
    "value": "buckeye lake"
  },
  {
    "text": "Buckeystown",
    "value": "buckeystown"
  },
  {
    "text": "Buckfield",
    "value": "buckfield"
  },
  {
    "text": "Buckhall",
    "value": "buckhall"
  },
  {
    "text": "Buckhannon",
    "value": "buckhannon"
  },
  {
    "text": "Buckhead",
    "value": "buckhead"
  },
  {
    "text": "Buckhead Ridge",
    "value": "buckhead ridge"
  },
  {
    "text": "Buckholts",
    "value": "buckholts"
  },
  {
    "text": "Buckhorn",
    "value": "buckhorn"
  },
  {
    "text": "Buckingham",
    "value": "buckingham"
  },
  {
    "text": "Buckland",
    "value": "buckland"
  },
  {
    "text": "Buckley",
    "value": "buckley"
  },
  {
    "text": "Bucklin",
    "value": "bucklin"
  },
  {
    "text": "Buckner",
    "value": "buckner"
  },
  {
    "text": "Bucks",
    "value": "bucks"
  },
  {
    "text": "Bucksport",
    "value": "bucksport"
  },
  {
    "text": "Bucyrus",
    "value": "bucyrus"
  },
  {
    "text": "Buda",
    "value": "buda"
  },
  {
    "text": "Budd Lake",
    "value": "budd lake"
  },
  {
    "text": "Bude",
    "value": "bude"
  },
  {
    "text": "Buellton",
    "value": "buellton"
  },
  {
    "text": "Buena",
    "value": "buena"
  },
  {
    "text": "Buena Park",
    "value": "buena park"
  },
  {
    "text": "Buena Vista",
    "value": "buena vista"
  },
  {
    "text": "Buffalo",
    "value": "buffalo"
  },
  {
    "text": "Buffalo (historical)",
    "value": "buffalo (historical)"
  },
  {
    "text": "Buffalo Center",
    "value": "buffalo center"
  },
  {
    "text": "Buffalo City",
    "value": "buffalo city"
  },
  {
    "text": "Buffalo Creek",
    "value": "buffalo creek"
  },
  {
    "text": "Buffalo Gap",
    "value": "buffalo gap"
  },
  {
    "text": "Buffalo Grove",
    "value": "buffalo grove"
  },
  {
    "text": "Buffalo Junction",
    "value": "buffalo junction"
  },
  {
    "text": "Buffalo Lake",
    "value": "buffalo lake"
  },
  {
    "text": "Buffalo Mills",
    "value": "buffalo mills"
  },
  {
    "text": "Buffalo Prairie",
    "value": "buffalo prairie"
  },
  {
    "text": "Buffalo Valley",
    "value": "buffalo valley"
  },
  {
    "text": "Buford",
    "value": "buford"
  },
  {
    "text": "Buhl",
    "value": "buhl"
  },
  {
    "text": "Buhler",
    "value": "buhler"
  },
  {
    "text": "Buies Creek",
    "value": "buies creek"
  },
  {
    "text": "Bulan",
    "value": "bulan"
  },
  {
    "text": "Bulger",
    "value": "bulger"
  },
  {
    "text": "Bull Shoals",
    "value": "bull shoals"
  },
  {
    "text": "Bull Valley",
    "value": "bull valley"
  },
  {
    "text": "Bullard",
    "value": "bullard"
  },
  {
    "text": "Bullhead",
    "value": "bullhead"
  },
  {
    "text": "Bullhead City",
    "value": "bullhead city"
  },
  {
    "text": "Bullock",
    "value": "bullock"
  },
  {
    "text": "Bulls Gap",
    "value": "bulls gap"
  },
  {
    "text": "Bullville",
    "value": "bullville"
  },
  {
    "text": "Bulpitt",
    "value": "bulpitt"
  },
  {
    "text": "Bulverde",
    "value": "bulverde"
  },
  {
    "text": "Bumpass",
    "value": "bumpass"
  },
  {
    "text": "Bumpus Mills",
    "value": "bumpus mills"
  },
  {
    "text": "Buna",
    "value": "buna"
  },
  {
    "text": "Bunceton",
    "value": "bunceton"
  },
  {
    "text": "Bunch",
    "value": "bunch"
  },
  {
    "text": "Buncombe",
    "value": "buncombe"
  },
  {
    "text": "Bunker",
    "value": "bunker"
  },
  {
    "text": "Bunker Hill",
    "value": "bunker hill"
  },
  {
    "text": "Bunkie",
    "value": "bunkie"
  },
  {
    "text": "Bunn",
    "value": "bunn"
  },
  {
    "text": "Bunnell",
    "value": "bunnell"
  },
  {
    "text": "Bunnlevel",
    "value": "bunnlevel"
  },
  {
    "text": "Buras",
    "value": "buras"
  },
  {
    "text": "Burbank",
    "value": "burbank"
  },
  {
    "text": "Burchard",
    "value": "burchard"
  },
  {
    "text": "Burden",
    "value": "burden"
  },
  {
    "text": "Burdett",
    "value": "burdett"
  },
  {
    "text": "Burdette",
    "value": "burdette"
  },
  {
    "text": "Burfordville",
    "value": "burfordville"
  },
  {
    "text": "Burgaw",
    "value": "burgaw"
  },
  {
    "text": "Burgess",
    "value": "burgess"
  },
  {
    "text": "Burgettstown",
    "value": "burgettstown"
  },
  {
    "text": "Burghill",
    "value": "burghill"
  },
  {
    "text": "Burgin",
    "value": "burgin"
  },
  {
    "text": "Burgoon",
    "value": "burgoon"
  },
  {
    "text": "Burien",
    "value": "burien"
  },
  {
    "text": "Burkburnett",
    "value": "burkburnett"
  },
  {
    "text": "Burke",
    "value": "burke"
  },
  {
    "text": "Burkes Garden",
    "value": "burkes garden"
  },
  {
    "text": "Burkesville",
    "value": "burkesville"
  },
  {
    "text": "Burkett",
    "value": "burkett"
  },
  {
    "text": "Burkettsville",
    "value": "burkettsville"
  },
  {
    "text": "Burkeville",
    "value": "burkeville"
  },
  {
    "text": "Burkittsville",
    "value": "burkittsville"
  },
  {
    "text": "Burleson",
    "value": "burleson"
  },
  {
    "text": "Burley",
    "value": "burley"
  },
  {
    "text": "Burlingame",
    "value": "burlingame"
  },
  {
    "text": "Burlingham",
    "value": "burlingham"
  },
  {
    "text": "Burlington",
    "value": "burlington"
  },
  {
    "text": "Burlington Flats",
    "value": "burlington flats"
  },
  {
    "text": "Burlington Junction",
    "value": "burlington junction"
  },
  {
    "text": "Burlison",
    "value": "burlison"
  },
  {
    "text": "Burna",
    "value": "burna"
  },
  {
    "text": "Burnet",
    "value": "burnet"
  },
  {
    "text": "Burnett",
    "value": "burnett"
  },
  {
    "text": "Burnettown",
    "value": "burnettown"
  },
  {
    "text": "Burnettsville",
    "value": "burnettsville"
  },
  {
    "text": "Burney",
    "value": "burney"
  },
  {
    "text": "Burneyville",
    "value": "burneyville"
  },
  {
    "text": "Burnham",
    "value": "burnham"
  },
  {
    "text": "Burns",
    "value": "burns"
  },
  {
    "text": "Burns Flat",
    "value": "burns flat"
  },
  {
    "text": "Burns Harbor",
    "value": "burns harbor"
  },
  {
    "text": "Burnside",
    "value": "burnside"
  },
  {
    "text": "Burnsville",
    "value": "burnsville"
  },
  {
    "text": "Burnt Cabins",
    "value": "burnt cabins"
  },
  {
    "text": "Burnt Hills",
    "value": "burnt hills"
  },
  {
    "text": "Burnt Prairie",
    "value": "burnt prairie"
  },
  {
    "text": "Burnt Ranch",
    "value": "burnt ranch"
  },
  {
    "text": "Burnwell",
    "value": "burnwell"
  },
  {
    "text": "Burr",
    "value": "burr"
  },
  {
    "text": "Burr Oak",
    "value": "burr oak"
  },
  {
    "text": "Burr Ridge",
    "value": "burr ridge"
  },
  {
    "text": "Burrel",
    "value": "burrel"
  },
  {
    "text": "Burrows",
    "value": "burrows"
  },
  {
    "text": "Burrton",
    "value": "burrton"
  },
  {
    "text": "Burson",
    "value": "burson"
  },
  {
    "text": "Burt",
    "value": "burt"
  },
  {
    "text": "Burton",
    "value": "burton"
  },
  {
    "text": "Burtonsville",
    "value": "burtonsville"
  },
  {
    "text": "Burtrum",
    "value": "burtrum"
  },
  {
    "text": "Burwell",
    "value": "burwell"
  },
  {
    "text": "Busby",
    "value": "busby"
  },
  {
    "text": "Bush",
    "value": "bush"
  },
  {
    "text": "Bushkill",
    "value": "bushkill"
  },
  {
    "text": "Bushland",
    "value": "bushland"
  },
  {
    "text": "Bushnell",
    "value": "bushnell"
  },
  {
    "text": "Bushton",
    "value": "bushton"
  },
  {
    "text": "Bushwick",
    "value": "bushwick"
  },
  {
    "text": "Bushwood",
    "value": "bushwood"
  },
  {
    "text": "Buskirk",
    "value": "buskirk"
  },
  {
    "text": "Bussey",
    "value": "bussey"
  },
  {
    "text": "Bustins Island",
    "value": "bustins island"
  },
  {
    "text": "Busy",
    "value": "busy"
  },
  {
    "text": "Butler",
    "value": "butler"
  },
  {
    "text": "Butlerville",
    "value": "butlerville"
  },
  {
    "text": "Butner",
    "value": "butner"
  },
  {
    "text": "Butte",
    "value": "butte"
  },
  {
    "text": "Butte City",
    "value": "butte city"
  },
  {
    "text": "Butte Falls",
    "value": "butte falls"
  },
  {
    "text": "Butte des Morts",
    "value": "butte des morts"
  },
  {
    "text": "Butterfield",
    "value": "butterfield"
  },
  {
    "text": "Butternut",
    "value": "butternut"
  },
  {
    "text": "Buttonwillow",
    "value": "buttonwillow"
  },
  {
    "text": "Buxton",
    "value": "buxton"
  },
  {
    "text": "Buzzards Bay",
    "value": "buzzards bay"
  },
  {
    "text": "Byars",
    "value": "byars"
  },
  {
    "text": "Bybee",
    "value": "bybee"
  },
  {
    "text": "Byers",
    "value": "byers"
  },
  {
    "text": "Byesville",
    "value": "byesville"
  },
  {
    "text": "Byfield",
    "value": "byfield"
  },
  {
    "text": "Bygland",
    "value": "bygland"
  },
  {
    "text": "Byhalia",
    "value": "byhalia"
  },
  {
    "text": "Bylas",
    "value": "bylas"
  },
  {
    "text": "Bynum",
    "value": "bynum"
  },
  {
    "text": "Bynumville",
    "value": "bynumville"
  },
  {
    "text": "Bypro",
    "value": "bypro"
  },
  {
    "text": "Byram",
    "value": "byram"
  },
  {
    "text": "Byrdstown",
    "value": "byrdstown"
  },
  {
    "text": "Byrnedale",
    "value": "byrnedale"
  },
  {
    "text": "Byrnes Mill",
    "value": "byrnes mill"
  },
  {
    "text": "Byromville",
    "value": "byromville"
  },
  {
    "text": "Byron",
    "value": "byron"
  },
  {
    "text": "Byron Center",
    "value": "byron center"
  },
  {
    "text": "Caballo",
    "value": "caballo"
  },
  {
    "text": "Cabazon",
    "value": "cabazon"
  },
  {
    "text": "Cabery",
    "value": "cabery"
  },
  {
    "text": "Cabin Creek",
    "value": "cabin creek"
  },
  {
    "text": "Cabin John",
    "value": "cabin john"
  },
  {
    "text": "Cabins",
    "value": "cabins"
  },
  {
    "text": "Cable",
    "value": "cable"
  },
  {
    "text": "Cabool",
    "value": "cabool"
  },
  {
    "text": "Cabot",
    "value": "cabot"
  },
  {
    "text": "Cache",
    "value": "cache"
  },
  {
    "text": "Cactus",
    "value": "cactus"
  },
  {
    "text": "Caddo",
    "value": "caddo"
  },
  {
    "text": "Caddo Gap",
    "value": "caddo gap"
  },
  {
    "text": "Caddo Mills",
    "value": "caddo mills"
  },
  {
    "text": "Cade",
    "value": "cade"
  },
  {
    "text": "Cades",
    "value": "cades"
  },
  {
    "text": "Cadet",
    "value": "cadet"
  },
  {
    "text": "Cadillac",
    "value": "cadillac"
  },
  {
    "text": "Cadiz",
    "value": "cadiz"
  },
  {
    "text": "Cadogan",
    "value": "cadogan"
  },
  {
    "text": "Cadott",
    "value": "cadott"
  },
  {
    "text": "Cadwell",
    "value": "cadwell"
  },
  {
    "text": "Cahaba Heights",
    "value": "cahaba heights"
  },
  {
    "text": "Cahokia",
    "value": "cahokia"
  },
  {
    "text": "Cahone",
    "value": "cahone"
  },
  {
    "text": "Cainsville",
    "value": "cainsville"
  },
  {
    "text": "Cairnbrook",
    "value": "cairnbrook"
  },
  {
    "text": "Cairo",
    "value": "cairo"
  },
  {
    "text": "Cal-Nev-Ari",
    "value": "cal-nev-ari"
  },
  {
    "text": "Calabasas",
    "value": "calabasas"
  },
  {
    "text": "Calabash",
    "value": "calabash"
  },
  {
    "text": "Calais",
    "value": "calais"
  },
  {
    "text": "Calamus",
    "value": "calamus"
  },
  {
    "text": "Calcium",
    "value": "calcium"
  },
  {
    "text": "Calcutta",
    "value": "calcutta"
  },
  {
    "text": "Caldwell",
    "value": "caldwell"
  },
  {
    "text": "Caledonia",
    "value": "caledonia"
  },
  {
    "text": "Calera",
    "value": "calera"
  },
  {
    "text": "Calexico",
    "value": "calexico"
  },
  {
    "text": "Calhan",
    "value": "calhan"
  },
  {
    "text": "Calhoun",
    "value": "calhoun"
  },
  {
    "text": "Calhoun City",
    "value": "calhoun city"
  },
  {
    "text": "Calhoun Falls",
    "value": "calhoun falls"
  },
  {
    "text": "Calico Rock",
    "value": "calico rock"
  },
  {
    "text": "Caliente",
    "value": "caliente"
  },
  {
    "text": "Califon",
    "value": "califon"
  },
  {
    "text": "California",
    "value": "california"
  },
  {
    "text": "California City",
    "value": "california city"
  },
  {
    "text": "California Hot Springs",
    "value": "california hot springs"
  },
  {
    "text": "Calimesa",
    "value": "calimesa"
  },
  {
    "text": "Calion",
    "value": "calion"
  },
  {
    "text": "Calipatria",
    "value": "calipatria"
  },
  {
    "text": "Calistoga",
    "value": "calistoga"
  },
  {
    "text": "Call",
    "value": "call"
  },
  {
    "text": "Callahan",
    "value": "callahan"
  },
  {
    "text": "Callands",
    "value": "callands"
  },
  {
    "text": "Callao",
    "value": "callao"
  },
  {
    "text": "Callaway",
    "value": "callaway"
  },
  {
    "text": "Callender",
    "value": "callender"
  },
  {
    "text": "Callensburg",
    "value": "callensburg"
  },
  {
    "text": "Callicoon",
    "value": "callicoon"
  },
  {
    "text": "Callicoon Center",
    "value": "callicoon center"
  },
  {
    "text": "Calliham",
    "value": "calliham"
  },
  {
    "text": "Calmar",
    "value": "calmar"
  },
  {
    "text": "Caln",
    "value": "caln"
  },
  {
    "text": "Calpella",
    "value": "calpella"
  },
  {
    "text": "Calpine",
    "value": "calpine"
  },
  {
    "text": "Calumet",
    "value": "calumet"
  },
  {
    "text": "Calumet City",
    "value": "calumet city"
  },
  {
    "text": "Calumet Park",
    "value": "calumet park"
  },
  {
    "text": "Calvary",
    "value": "calvary"
  },
  {
    "text": "Calvert",
    "value": "calvert"
  },
  {
    "text": "Calvert City",
    "value": "calvert city"
  },
  {
    "text": "Calverton",
    "value": "calverton"
  },
  {
    "text": "Calverton Park",
    "value": "calverton park"
  },
  {
    "text": "Calvin",
    "value": "calvin"
  },
  {
    "text": "Calypso",
    "value": "calypso"
  },
  {
    "text": "Camak",
    "value": "camak"
  },
  {
    "text": "Camanche",
    "value": "camanche"
  },
  {
    "text": "Camano",
    "value": "camano"
  },
  {
    "text": "Camano Island",
    "value": "camano island"
  },
  {
    "text": "Camargo",
    "value": "camargo"
  },
  {
    "text": "Camarillo",
    "value": "camarillo"
  },
  {
    "text": "Camas",
    "value": "camas"
  },
  {
    "text": "Camas Valley",
    "value": "camas valley"
  },
  {
    "text": "Cambria",
    "value": "cambria"
  },
  {
    "text": "Cambria Heights",
    "value": "cambria heights"
  },
  {
    "text": "Cambridge",
    "value": "cambridge"
  },
  {
    "text": "Cambridge City",
    "value": "cambridge city"
  },
  {
    "text": "Cambridge Springs",
    "value": "cambridge springs"
  },
  {
    "text": "Camby",
    "value": "camby"
  },
  {
    "text": "Camden",
    "value": "camden"
  },
  {
    "text": "Camden Point",
    "value": "camden point"
  },
  {
    "text": "Camden Wyoming",
    "value": "camden wyoming"
  },
  {
    "text": "Camden on Gauley",
    "value": "camden on gauley"
  },
  {
    "text": "Camdenton",
    "value": "camdenton"
  },
  {
    "text": "Cameron",
    "value": "cameron"
  },
  {
    "text": "Cameron Mills",
    "value": "cameron mills"
  },
  {
    "text": "Cameron Park",
    "value": "cameron park"
  },
  {
    "text": "Camilla",
    "value": "camilla"
  },
  {
    "text": "Camillus",
    "value": "camillus"
  },
  {
    "text": "Camino",
    "value": "camino"
  },
  {
    "text": "Camp",
    "value": "camp"
  },
  {
    "text": "Camp Dennison",
    "value": "camp dennison"
  },
  {
    "text": "Camp Douglas",
    "value": "camp douglas"
  },
  {
    "text": "Camp H. M. Smith",
    "value": "camp h. m. smith"
  },
  {
    "text": "Camp Hill",
    "value": "camp hill"
  },
  {
    "text": "Camp Lejeune",
    "value": "camp lejeune"
  },
  {
    "text": "Camp Meeker",
    "value": "camp meeker"
  },
  {
    "text": "Camp Murray",
    "value": "camp murray"
  },
  {
    "text": "Camp Pendleton",
    "value": "camp pendleton"
  },
  {
    "text": "Camp Pendleton North",
    "value": "camp pendleton north"
  },
  {
    "text": "Camp Point",
    "value": "camp point"
  },
  {
    "text": "Camp Sherman",
    "value": "camp sherman"
  },
  {
    "text": "Camp Springs",
    "value": "camp springs"
  },
  {
    "text": "Camp Swift",
    "value": "camp swift"
  },
  {
    "text": "Camp Verde",
    "value": "camp verde"
  },
  {
    "text": "Camp Wood",
    "value": "camp wood"
  },
  {
    "text": "Campbell",
    "value": "campbell"
  },
  {
    "text": "Campbell Hall",
    "value": "campbell hall"
  },
  {
    "text": "Campbell Hill",
    "value": "campbell hill"
  },
  {
    "text": "Campbellsburg",
    "value": "campbellsburg"
  },
  {
    "text": "Campbellsport",
    "value": "campbellsport"
  },
  {
    "text": "Campbellsville",
    "value": "campbellsville"
  },
  {
    "text": "Campbellton",
    "value": "campbellton"
  },
  {
    "text": "Campbelltown",
    "value": "campbelltown"
  },
  {
    "text": "Campion",
    "value": "campion"
  },
  {
    "text": "Campo",
    "value": "campo"
  },
  {
    "text": "Campo Seco",
    "value": "campo seco"
  },
  {
    "text": "Campobello",
    "value": "campobello"
  },
  {
    "text": "Campti",
    "value": "campti"
  },
  {
    "text": "Campton",
    "value": "campton"
  },
  {
    "text": "Campton Lower Village",
    "value": "campton lower village"
  },
  {
    "text": "Camptonville",
    "value": "camptonville"
  },
  {
    "text": "Campus",
    "value": "campus"
  },
  {
    "text": "Cana",
    "value": "cana"
  },
  {
    "text": "Canaan",
    "value": "canaan"
  },
  {
    "text": "Canada",
    "value": "canada"
  },
  {
    "text": "Canadensis",
    "value": "canadensis"
  },
  {
    "text": "Canadian",
    "value": "canadian"
  },
  {
    "text": "Canajoharie",
    "value": "canajoharie"
  },
  {
    "text": "Canal Fulton",
    "value": "canal fulton"
  },
  {
    "text": "Canal Point",
    "value": "canal point"
  },
  {
    "text": "Canal Winchester",
    "value": "canal winchester"
  },
  {
    "text": "Canalou",
    "value": "canalou"
  },
  {
    "text": "Canandaigua",
    "value": "canandaigua"
  },
  {
    "text": "Canaseraga",
    "value": "canaseraga"
  },
  {
    "text": "Canastota",
    "value": "canastota"
  },
  {
    "text": "Canby",
    "value": "canby"
  },
  {
    "text": "Candia",
    "value": "candia"
  },
  {
    "text": "Candler",
    "value": "candler"
  },
  {
    "text": "Cando",
    "value": "cando"
  },
  {
    "text": "Candor",
    "value": "candor"
  },
  {
    "text": "Caneadea",
    "value": "caneadea"
  },
  {
    "text": "Canehill",
    "value": "canehill"
  },
  {
    "text": "Caney",
    "value": "caney"
  },
  {
    "text": "Caneyville",
    "value": "caneyville"
  },
  {
    "text": "Canfield",
    "value": "canfield"
  },
  {
    "text": "Canisteo",
    "value": "canisteo"
  },
  {
    "text": "Canistota",
    "value": "canistota"
  },
  {
    "text": "Canmer",
    "value": "canmer"
  },
  {
    "text": "Cannel City",
    "value": "cannel city"
  },
  {
    "text": "Cannelton",
    "value": "cannelton"
  },
  {
    "text": "Cannon",
    "value": "cannon"
  },
  {
    "text": "Cannon Ball",
    "value": "cannon ball"
  },
  {
    "text": "Cannon Beach",
    "value": "cannon beach"
  },
  {
    "text": "Cannon Falls",
    "value": "cannon falls"
  },
  {
    "text": "Cannonsburg",
    "value": "cannonsburg"
  },
  {
    "text": "Cannonville",
    "value": "cannonville"
  },
  {
    "text": "Canoga Park",
    "value": "canoga park"
  },
  {
    "text": "Canon",
    "value": "canon"
  },
  {
    "text": "Canon City",
    "value": "canon city"
  },
  {
    "text": "Canones",
    "value": "canones"
  },
  {
    "text": "Canonsburg",
    "value": "canonsburg"
  },
  {
    "text": "Canova",
    "value": "canova"
  },
  {
    "text": "Canterbury",
    "value": "canterbury"
  },
  {
    "text": "Cantil",
    "value": "cantil"
  },
  {
    "text": "Canton",
    "value": "canton"
  },
  {
    "text": "Cantonment",
    "value": "cantonment"
  },
  {
    "text": "Cantrall",
    "value": "cantrall"
  },
  {
    "text": "Cantril",
    "value": "cantril"
  },
  {
    "text": "Cantua Creek",
    "value": "cantua creek"
  },
  {
    "text": "Canute",
    "value": "canute"
  },
  {
    "text": "Canutillo",
    "value": "canutillo"
  },
  {
    "text": "Canvas",
    "value": "canvas"
  },
  {
    "text": "Canyon",
    "value": "canyon"
  },
  {
    "text": "Canyon City",
    "value": "canyon city"
  },
  {
    "text": "Canyon Country",
    "value": "canyon country"
  },
  {
    "text": "Canyon Lake",
    "value": "canyon lake"
  },
  {
    "text": "Canyondam",
    "value": "canyondam"
  },
  {
    "text": "Canyonville",
    "value": "canyonville"
  },
  {
    "text": "Capac",
    "value": "capac"
  },
  {
    "text": "Capay",
    "value": "capay"
  },
  {
    "text": "Cape Canaveral",
    "value": "cape canaveral"
  },
  {
    "text": "Cape Carteret",
    "value": "cape carteret"
  },
  {
    "text": "Cape Charles",
    "value": "cape charles"
  },
  {
    "text": "Cape Coral",
    "value": "cape coral"
  },
  {
    "text": "Cape Elizabeth",
    "value": "cape elizabeth"
  },
  {
    "text": "Cape Fair",
    "value": "cape fair"
  },
  {
    "text": "Cape Girardeau",
    "value": "cape girardeau"
  },
  {
    "text": "Cape May",
    "value": "cape may"
  },
  {
    "text": "Cape May Court House",
    "value": "cape may court house"
  },
  {
    "text": "Cape May Point",
    "value": "cape may point"
  },
  {
    "text": "Cape Neddick",
    "value": "cape neddick"
  },
  {
    "text": "Cape Vincent",
    "value": "cape vincent"
  },
  {
    "text": "Capistrano Beach",
    "value": "capistrano beach"
  },
  {
    "text": "Capitan",
    "value": "capitan"
  },
  {
    "text": "Capitol Heights",
    "value": "capitol heights"
  },
  {
    "text": "Capitola",
    "value": "capitola"
  },
  {
    "text": "Caplinger Mills",
    "value": "caplinger mills"
  },
  {
    "text": "Capon Bridge",
    "value": "capon bridge"
  },
  {
    "text": "Capron",
    "value": "capron"
  },
  {
    "text": "Capshaw",
    "value": "capshaw"
  },
  {
    "text": "Captain Cook",
    "value": "captain cook"
  },
  {
    "text": "Captiva",
    "value": "captiva"
  },
  {
    "text": "Capulin",
    "value": "capulin"
  },
  {
    "text": "Caputa",
    "value": "caputa"
  },
  {
    "text": "Caratunk",
    "value": "caratunk"
  },
  {
    "text": "Caraway",
    "value": "caraway"
  },
  {
    "text": "Carbon",
    "value": "carbon"
  },
  {
    "text": "Carbon Cliff",
    "value": "carbon cliff"
  },
  {
    "text": "Carbon Hill",
    "value": "carbon hill"
  },
  {
    "text": "Carbonado",
    "value": "carbonado"
  },
  {
    "text": "Carbondale",
    "value": "carbondale"
  },
  {
    "text": "Cardale",
    "value": "cardale"
  },
  {
    "text": "Cardiff",
    "value": "cardiff"
  },
  {
    "text": "Cardiff-by-the-Sea",
    "value": "cardiff-by-the-sea"
  },
  {
    "text": "Cardinal",
    "value": "cardinal"
  },
  {
    "text": "Cardington",
    "value": "cardington"
  },
  {
    "text": "Cardwell",
    "value": "cardwell"
  },
  {
    "text": "Carefree",
    "value": "carefree"
  },
  {
    "text": "Carencro",
    "value": "carencro"
  },
  {
    "text": "Caret",
    "value": "caret"
  },
  {
    "text": "Carey",
    "value": "carey"
  },
  {
    "text": "Careywood",
    "value": "careywood"
  },
  {
    "text": "Caribou",
    "value": "caribou"
  },
  {
    "text": "Carl Junction",
    "value": "carl junction"
  },
  {
    "text": "Carle Place",
    "value": "carle place"
  },
  {
    "text": "Carleton",
    "value": "carleton"
  },
  {
    "text": "Carlin",
    "value": "carlin"
  },
  {
    "text": "Carlinville",
    "value": "carlinville"
  },
  {
    "text": "Carlisle",
    "value": "carlisle"
  },
  {
    "text": "Carlock",
    "value": "carlock"
  },
  {
    "text": "Carlos",
    "value": "carlos"
  },
  {
    "text": "Carlotta",
    "value": "carlotta"
  },
  {
    "text": "Carlsbad",
    "value": "carlsbad"
  },
  {
    "text": "Carlsborg",
    "value": "carlsborg"
  },
  {
    "text": "Carlstadt",
    "value": "carlstadt"
  },
  {
    "text": "Carlton",
    "value": "carlton"
  },
  {
    "text": "Carlyle",
    "value": "carlyle"
  },
  {
    "text": "Carlyss",
    "value": "carlyss"
  },
  {
    "text": "Carman",
    "value": "carman"
  },
  {
    "text": "Carmel",
    "value": "carmel"
  },
  {
    "text": "Carmel Hamlet",
    "value": "carmel hamlet"
  },
  {
    "text": "Carmel Valley",
    "value": "carmel valley"
  },
  {
    "text": "Carmel-by-the-Sea",
    "value": "carmel-by-the-sea"
  },
  {
    "text": "Carmen",
    "value": "carmen"
  },
  {
    "text": "Carmi",
    "value": "carmi"
  },
  {
    "text": "Carmichael",
    "value": "carmichael"
  },
  {
    "text": "Carmichaels",
    "value": "carmichaels"
  },
  {
    "text": "Carmine",
    "value": "carmine"
  },
  {
    "text": "Carnation",
    "value": "carnation"
  },
  {
    "text": "Carnegie",
    "value": "carnegie"
  },
  {
    "text": "Carnelian Bay",
    "value": "carnelian bay"
  },
  {
    "text": "Carnesville",
    "value": "carnesville"
  },
  {
    "text": "Carney",
    "value": "carney"
  },
  {
    "text": "Carneys Point",
    "value": "carneys point"
  },
  {
    "text": "Caro",
    "value": "caro"
  },
  {
    "text": "Caroga Lake",
    "value": "caroga lake"
  },
  {
    "text": "Carol Stream",
    "value": "carol stream"
  },
  {
    "text": "Carolina",
    "value": "carolina"
  },
  {
    "text": "Carolina Beach",
    "value": "carolina beach"
  },
  {
    "text": "Carolina Shores",
    "value": "carolina shores"
  },
  {
    "text": "Caroline",
    "value": "caroline"
  },
  {
    "text": "Carp Lake",
    "value": "carp lake"
  },
  {
    "text": "Carpenter",
    "value": "carpenter"
  },
  {
    "text": "Carpentersville",
    "value": "carpentersville"
  },
  {
    "text": "Carpinteria",
    "value": "carpinteria"
  },
  {
    "text": "Carpio",
    "value": "carpio"
  },
  {
    "text": "Carr",
    "value": "carr"
  },
  {
    "text": "Carrabelle",
    "value": "carrabelle"
  },
  {
    "text": "Carrboro",
    "value": "carrboro"
  },
  {
    "text": "Carriage Club",
    "value": "carriage club"
  },
  {
    "text": "Carrie",
    "value": "carrie"
  },
  {
    "text": "Carrier Mills",
    "value": "carrier mills"
  },
  {
    "text": "Carriere",
    "value": "carriere"
  },
  {
    "text": "Carrington",
    "value": "carrington"
  },
  {
    "text": "Carrizo Hill",
    "value": "carrizo hill"
  },
  {
    "text": "Carrizo Springs",
    "value": "carrizo springs"
  },
  {
    "text": "Carrizozo",
    "value": "carrizozo"
  },
  {
    "text": "Carroll",
    "value": "carroll"
  },
  {
    "text": "Carroll Valley",
    "value": "carroll valley"
  },
  {
    "text": "Carrollton",
    "value": "carrollton"
  },
  {
    "text": "Carrolltown",
    "value": "carrolltown"
  },
  {
    "text": "Carrollwood",
    "value": "carrollwood"
  },
  {
    "text": "Carrsville",
    "value": "carrsville"
  },
  {
    "text": "Carson",
    "value": "carson"
  },
  {
    "text": "Carson City",
    "value": "carson city"
  },
  {
    "text": "Carsonville",
    "value": "carsonville"
  },
  {
    "text": "Carter",
    "value": "carter"
  },
  {
    "text": "Carter Lake",
    "value": "carter lake"
  },
  {
    "text": "Carteret",
    "value": "carteret"
  },
  {
    "text": "Cartersville",
    "value": "cartersville"
  },
  {
    "text": "Carterville",
    "value": "carterville"
  },
  {
    "text": "Carthage",
    "value": "carthage"
  },
  {
    "text": "Cartwright",
    "value": "cartwright"
  },
  {
    "text": "Caruthers",
    "value": "caruthers"
  },
  {
    "text": "Caruthersville",
    "value": "caruthersville"
  },
  {
    "text": "Carver",
    "value": "carver"
  },
  {
    "text": "Carversville",
    "value": "carversville"
  },
  {
    "text": "Carville",
    "value": "carville"
  },
  {
    "text": "Cary",
    "value": "cary"
  },
  {
    "text": "Caryville",
    "value": "caryville"
  },
  {
    "text": "Casa",
    "value": "casa"
  },
  {
    "text": "Casa Blanca",
    "value": "casa blanca"
  },
  {
    "text": "Casa Conejo",
    "value": "casa conejo"
  },
  {
    "text": "Casa Grande",
    "value": "casa grande"
  },
  {
    "text": "Casanova",
    "value": "casanova"
  },
  {
    "text": "Casar",
    "value": "casar"
  },
  {
    "text": "Casas Adobes",
    "value": "casas adobes"
  },
  {
    "text": "Cascade",
    "value": "cascade"
  },
  {
    "text": "Cascade Locks",
    "value": "cascade locks"
  },
  {
    "text": "Cascade-Chipita Park",
    "value": "cascade-chipita park"
  },
  {
    "text": "Cascilla",
    "value": "cascilla"
  },
  {
    "text": "Casco",
    "value": "casco"
  },
  {
    "text": "Caseville",
    "value": "caseville"
  },
  {
    "text": "Casey",
    "value": "casey"
  },
  {
    "text": "Caseyville",
    "value": "caseyville"
  },
  {
    "text": "Cash",
    "value": "cash"
  },
  {
    "text": "Cashiers",
    "value": "cashiers"
  },
  {
    "text": "Cashion",
    "value": "cashion"
  },
  {
    "text": "Cashmere",
    "value": "cashmere"
  },
  {
    "text": "Cashton",
    "value": "cashton"
  },
  {
    "text": "Cashtown",
    "value": "cashtown"
  },
  {
    "text": "Casnovia",
    "value": "casnovia"
  },
  {
    "text": "Caspar",
    "value": "caspar"
  },
  {
    "text": "Casper",
    "value": "casper"
  },
  {
    "text": "Caspian",
    "value": "caspian"
  },
  {
    "text": "Cass",
    "value": "cass"
  },
  {
    "text": "Cass City",
    "value": "cass city"
  },
  {
    "text": "Cass Lake",
    "value": "cass lake"
  },
  {
    "text": "Cassadaga",
    "value": "cassadaga"
  },
  {
    "text": "Cassatt",
    "value": "cassatt"
  },
  {
    "text": "Casscoe",
    "value": "casscoe"
  },
  {
    "text": "Cassel",
    "value": "cassel"
  },
  {
    "text": "Casselberry",
    "value": "casselberry"
  },
  {
    "text": "Casselton",
    "value": "casselton"
  },
  {
    "text": "Cassoday",
    "value": "cassoday"
  },
  {
    "text": "Cassopolis",
    "value": "cassopolis"
  },
  {
    "text": "Casstown",
    "value": "casstown"
  },
  {
    "text": "Cassville",
    "value": "cassville"
  },
  {
    "text": "Castaic",
    "value": "castaic"
  },
  {
    "text": "Castalia",
    "value": "castalia"
  },
  {
    "text": "Castalian Springs",
    "value": "castalian springs"
  },
  {
    "text": "Castana",
    "value": "castana"
  },
  {
    "text": "Castell",
    "value": "castell"
  },
  {
    "text": "Castella",
    "value": "castella"
  },
  {
    "text": "Castile",
    "value": "castile"
  },
  {
    "text": "Castine",
    "value": "castine"
  },
  {
    "text": "Castle",
    "value": "castle"
  },
  {
    "text": "Castle Creek",
    "value": "castle creek"
  },
  {
    "text": "Castle Dale",
    "value": "castle dale"
  },
  {
    "text": "Castle Hayne",
    "value": "castle hayne"
  },
  {
    "text": "Castle Hills",
    "value": "castle hills"
  },
  {
    "text": "Castle Pines",
    "value": "castle pines"
  },
  {
    "text": "Castle Rock",
    "value": "castle rock"
  },
  {
    "text": "Castle Shannon",
    "value": "castle shannon"
  },
  {
    "text": "Castleberry",
    "value": "castleberry"
  },
  {
    "text": "Castleton",
    "value": "castleton"
  },
  {
    "text": "Castleton-on-Hudson",
    "value": "castleton-on-hudson"
  },
  {
    "text": "Castlewood",
    "value": "castlewood"
  },
  {
    "text": "Castor",
    "value": "castor"
  },
  {
    "text": "Castorland",
    "value": "castorland"
  },
  {
    "text": "Castro Valley",
    "value": "castro valley"
  },
  {
    "text": "Castroville",
    "value": "castroville"
  },
  {
    "text": "Cat Spring",
    "value": "cat spring"
  },
  {
    "text": "Cataldo",
    "value": "cataldo"
  },
  {
    "text": "Catarina",
    "value": "catarina"
  },
  {
    "text": "Catasauqua",
    "value": "catasauqua"
  },
  {
    "text": "Cataula",
    "value": "cataula"
  },
  {
    "text": "Cataumet",
    "value": "cataumet"
  },
  {
    "text": "Catawba",
    "value": "catawba"
  },
  {
    "text": "Catawissa",
    "value": "catawissa"
  },
  {
    "text": "Catharpin",
    "value": "catharpin"
  },
  {
    "text": "Cathay",
    "value": "cathay"
  },
  {
    "text": "Cathcart",
    "value": "cathcart"
  },
  {
    "text": "Cathedral City",
    "value": "cathedral city"
  },
  {
    "text": "Catherine",
    "value": "catherine"
  },
  {
    "text": "Catheys Valley",
    "value": "catheys valley"
  },
  {
    "text": "Cathlamet",
    "value": "cathlamet"
  },
  {
    "text": "Catlett",
    "value": "catlett"
  },
  {
    "text": "Catlettsburg",
    "value": "catlettsburg"
  },
  {
    "text": "Catlin",
    "value": "catlin"
  },
  {
    "text": "Cato",
    "value": "cato"
  },
  {
    "text": "Catonsville",
    "value": "catonsville"
  },
  {
    "text": "Catoosa",
    "value": "catoosa"
  },
  {
    "text": "Catron",
    "value": "catron"
  },
  {
    "text": "Catskill",
    "value": "catskill"
  },
  {
    "text": "Cattaraugus",
    "value": "cattaraugus"
  },
  {
    "text": "Caulfield",
    "value": "caulfield"
  },
  {
    "text": "Causey",
    "value": "causey"
  },
  {
    "text": "Cavalier",
    "value": "cavalier"
  },
  {
    "text": "Cave City",
    "value": "cave city"
  },
  {
    "text": "Cave Creek",
    "value": "cave creek"
  },
  {
    "text": "Cave Junction",
    "value": "cave junction"
  },
  {
    "text": "Cave Spring",
    "value": "cave spring"
  },
  {
    "text": "Cave Springs",
    "value": "cave springs"
  },
  {
    "text": "Cave-In-Rock",
    "value": "cave-in-rock"
  },
  {
    "text": "Cave-in-Rock",
    "value": "cave-in-rock"
  },
  {
    "text": "Cavendish",
    "value": "cavendish"
  },
  {
    "text": "Cavetown",
    "value": "cavetown"
  },
  {
    "text": "Cavour",
    "value": "cavour"
  },
  {
    "text": "Cawker City",
    "value": "cawker city"
  },
  {
    "text": "Cawood",
    "value": "cawood"
  },
  {
    "text": "Cayce",
    "value": "cayce"
  },
  {
    "text": "Cayucos",
    "value": "cayucos"
  },
  {
    "text": "Cayuga",
    "value": "cayuga"
  },
  {
    "text": "Cayuta",
    "value": "cayuta"
  },
  {
    "text": "Cazadero",
    "value": "cazadero"
  },
  {
    "text": "Cazenovia",
    "value": "cazenovia"
  },
  {
    "text": "Cañon City",
    "value": "cañon city"
  },
  {
    "text": "Cañones",
    "value": "cañones"
  },
  {
    "text": "Cecil",
    "value": "cecil"
  },
  {
    "text": "Cecilia",
    "value": "cecilia"
  },
  {
    "text": "Cecilton",
    "value": "cecilton"
  },
  {
    "text": "Cedar",
    "value": "cedar"
  },
  {
    "text": "Cedar Bluff",
    "value": "cedar bluff"
  },
  {
    "text": "Cedar Bluffs",
    "value": "cedar bluffs"
  },
  {
    "text": "Cedar Brook",
    "value": "cedar brook"
  },
  {
    "text": "Cedar City",
    "value": "cedar city"
  },
  {
    "text": "Cedar Creek",
    "value": "cedar creek"
  },
  {
    "text": "Cedar Creek Township",
    "value": "cedar creek township"
  },
  {
    "text": "Cedar Crest",
    "value": "cedar crest"
  },
  {
    "text": "Cedar Falls",
    "value": "cedar falls"
  },
  {
    "text": "Cedar Fork",
    "value": "cedar fork"
  },
  {
    "text": "Cedar Fort",
    "value": "cedar fort"
  },
  {
    "text": "Cedar Glen",
    "value": "cedar glen"
  },
  {
    "text": "Cedar Grove",
    "value": "cedar grove"
  },
  {
    "text": "Cedar Hill",
    "value": "cedar hill"
  },
  {
    "text": "Cedar Hills",
    "value": "cedar hills"
  },
  {
    "text": "Cedar Island",
    "value": "cedar island"
  },
  {
    "text": "Cedar Key",
    "value": "cedar key"
  },
  {
    "text": "Cedar Knolls",
    "value": "cedar knolls"
  },
  {
    "text": "Cedar Lake",
    "value": "cedar lake"
  },
  {
    "text": "Cedar Lane",
    "value": "cedar lane"
  },
  {
    "text": "Cedar Mountain",
    "value": "cedar mountain"
  },
  {
    "text": "Cedar Park",
    "value": "cedar park"
  },
  {
    "text": "Cedar Point",
    "value": "cedar point"
  },
  {
    "text": "Cedar Rapids",
    "value": "cedar rapids"
  },
  {
    "text": "Cedar Ridge",
    "value": "cedar ridge"
  },
  {
    "text": "Cedar Springs",
    "value": "cedar springs"
  },
  {
    "text": "Cedar Vale",
    "value": "cedar vale"
  },
  {
    "text": "Cedar Valley",
    "value": "cedar valley"
  },
  {
    "text": "Cedarburg",
    "value": "cedarburg"
  },
  {
    "text": "Cedarcreek",
    "value": "cedarcreek"
  },
  {
    "text": "Cedaredge",
    "value": "cedaredge"
  },
  {
    "text": "Cedarhurst",
    "value": "cedarhurst"
  },
  {
    "text": "Cedarpines Park",
    "value": "cedarpines park"
  },
  {
    "text": "Cedartown",
    "value": "cedartown"
  },
  {
    "text": "Cedarville",
    "value": "cedarville"
  },
  {
    "text": "Celebration",
    "value": "celebration"
  },
  {
    "text": "Celeste",
    "value": "celeste"
  },
  {
    "text": "Celestine",
    "value": "celestine"
  },
  {
    "text": "Celina",
    "value": "celina"
  },
  {
    "text": "Celoron",
    "value": "celoron"
  },
  {
    "text": "Cement",
    "value": "cement"
  },
  {
    "text": "Cement City",
    "value": "cement city"
  },
  {
    "text": "Centennial",
    "value": "centennial"
  },
  {
    "text": "Center",
    "value": "center"
  },
  {
    "text": "Center Barnstead",
    "value": "center barnstead"
  },
  {
    "text": "Center City",
    "value": "center city"
  },
  {
    "text": "Center Conway",
    "value": "center conway"
  },
  {
    "text": "Center Cross",
    "value": "center cross"
  },
  {
    "text": "Center Harbor",
    "value": "center harbor"
  },
  {
    "text": "Center Hill",
    "value": "center hill"
  },
  {
    "text": "Center Junction",
    "value": "center junction"
  },
  {
    "text": "Center Line",
    "value": "center line"
  },
  {
    "text": "Center Lovell",
    "value": "center lovell"
  },
  {
    "text": "Center Moriches",
    "value": "center moriches"
  },
  {
    "text": "Center Ossipee",
    "value": "center ossipee"
  },
  {
    "text": "Center Point",
    "value": "center point"
  },
  {
    "text": "Center Ridge",
    "value": "center ridge"
  },
  {
    "text": "Center Rutland",
    "value": "center rutland"
  },
  {
    "text": "Center Sandwich",
    "value": "center sandwich"
  },
  {
    "text": "Center Tuftonboro",
    "value": "center tuftonboro"
  },
  {
    "text": "Center Valley",
    "value": "center valley"
  },
  {
    "text": "Centerbrook",
    "value": "centerbrook"
  },
  {
    "text": "Centerburg",
    "value": "centerburg"
  },
  {
    "text": "Centereach",
    "value": "centereach"
  },
  {
    "text": "Centerfield",
    "value": "centerfield"
  },
  {
    "text": "Centerport",
    "value": "centerport"
  },
  {
    "text": "Centerton",
    "value": "centerton"
  },
  {
    "text": "Centertown",
    "value": "centertown"
  },
  {
    "text": "Centerview",
    "value": "centerview"
  },
  {
    "text": "Centerville",
    "value": "centerville"
  },
  {
    "text": "Centrahoma",
    "value": "centrahoma"
  },
  {
    "text": "Central",
    "value": "central"
  },
  {
    "text": "Central Bridge",
    "value": "central bridge"
  },
  {
    "text": "Central City",
    "value": "central city"
  },
  {
    "text": "Central Falls",
    "value": "central falls"
  },
  {
    "text": "Central Gardens",
    "value": "central gardens"
  },
  {
    "text": "Central Heights-Midland City",
    "value": "central heights-midland city"
  },
  {
    "text": "Central Islip",
    "value": "central islip"
  },
  {
    "text": "Central Lake",
    "value": "central lake"
  },
  {
    "text": "Central Park",
    "value": "central park"
  },
  {
    "text": "Central Point",
    "value": "central point"
  },
  {
    "text": "Central Square",
    "value": "central square"
  },
  {
    "text": "Central Valley",
    "value": "central valley"
  },
  {
    "text": "Central Village",
    "value": "central village"
  },
  {
    "text": "Centralia",
    "value": "centralia"
  },
  {
    "text": "Centre",
    "value": "centre"
  },
  {
    "text": "Centre Hall",
    "value": "centre hall"
  },
  {
    "text": "Centreville",
    "value": "centreville"
  },
  {
    "text": "Centuria",
    "value": "centuria"
  },
  {
    "text": "Century",
    "value": "century"
  },
  {
    "text": "Century City",
    "value": "century city"
  },
  {
    "text": "Ceredo",
    "value": "ceredo"
  },
  {
    "text": "Ceres",
    "value": "ceres"
  },
  {
    "text": "Ceresco",
    "value": "ceresco"
  },
  {
    "text": "Cerrillos",
    "value": "cerrillos"
  },
  {
    "text": "Cerritos",
    "value": "cerritos"
  },
  {
    "text": "Cerro",
    "value": "cerro"
  },
  {
    "text": "Cerro Gordo",
    "value": "cerro gordo"
  },
  {
    "text": "Ceylon",
    "value": "ceylon"
  },
  {
    "text": "Chadbourn",
    "value": "chadbourn"
  },
  {
    "text": "Chadds Ford",
    "value": "chadds ford"
  },
  {
    "text": "Chadron",
    "value": "chadron"
  },
  {
    "text": "Chadwick",
    "value": "chadwick"
  },
  {
    "text": "Chadwicks",
    "value": "chadwicks"
  },
  {
    "text": "Chaffee",
    "value": "chaffee"
  },
  {
    "text": "Chagrin Falls",
    "value": "chagrin falls"
  },
  {
    "text": "Chalfont",
    "value": "chalfont"
  },
  {
    "text": "Chalk Hill",
    "value": "chalk hill"
  },
  {
    "text": "Challenge",
    "value": "challenge"
  },
  {
    "text": "Challis",
    "value": "challis"
  },
  {
    "text": "Chalmers",
    "value": "chalmers"
  },
  {
    "text": "Chalmette",
    "value": "chalmette"
  },
  {
    "text": "Chama",
    "value": "chama"
  },
  {
    "text": "Chamberino",
    "value": "chamberino"
  },
  {
    "text": "Chamberlain",
    "value": "chamberlain"
  },
  {
    "text": "Chamberlayne",
    "value": "chamberlayne"
  },
  {
    "text": "Chambers",
    "value": "chambers"
  },
  {
    "text": "Chambersburg",
    "value": "chambersburg"
  },
  {
    "text": "Chamblee",
    "value": "chamblee"
  },
  {
    "text": "Chamisal",
    "value": "chamisal"
  },
  {
    "text": "Chamois",
    "value": "chamois"
  },
  {
    "text": "Champaign",
    "value": "champaign"
  },
  {
    "text": "Champion",
    "value": "champion"
  },
  {
    "text": "Champions Gate",
    "value": "champions gate"
  },
  {
    "text": "Champlain",
    "value": "champlain"
  },
  {
    "text": "Champlin",
    "value": "champlin"
  },
  {
    "text": "Chana",
    "value": "chana"
  },
  {
    "text": "Chancellor",
    "value": "chancellor"
  },
  {
    "text": "Chandler",
    "value": "chandler"
  },
  {
    "text": "Chandlerville",
    "value": "chandlerville"
  },
  {
    "text": "Chanhassen",
    "value": "chanhassen"
  },
  {
    "text": "Channahon",
    "value": "channahon"
  },
  {
    "text": "Channelview",
    "value": "channelview"
  },
  {
    "text": "Channing",
    "value": "channing"
  },
  {
    "text": "Chantilly",
    "value": "chantilly"
  },
  {
    "text": "Chanute",
    "value": "chanute"
  },
  {
    "text": "Chaparral",
    "value": "chaparral"
  },
  {
    "text": "Chapel Hill",
    "value": "chapel hill"
  },
  {
    "text": "Chapin",
    "value": "chapin"
  },
  {
    "text": "Chaplin",
    "value": "chaplin"
  },
  {
    "text": "Chapman",
    "value": "chapman"
  },
  {
    "text": "Chapmansboro",
    "value": "chapmansboro"
  },
  {
    "text": "Chapmanville",
    "value": "chapmanville"
  },
  {
    "text": "Chappaqua",
    "value": "chappaqua"
  },
  {
    "text": "Chappell",
    "value": "chappell"
  },
  {
    "text": "Chappell Hill",
    "value": "chappell hill"
  },
  {
    "text": "Chappells",
    "value": "chappells"
  },
  {
    "text": "Chaptico",
    "value": "chaptico"
  },
  {
    "text": "Chardon",
    "value": "chardon"
  },
  {
    "text": "Chariton",
    "value": "chariton"
  },
  {
    "text": "Charlack",
    "value": "charlack"
  },
  {
    "text": "Charlemont",
    "value": "charlemont"
  },
  {
    "text": "Charleroi",
    "value": "charleroi"
  },
  {
    "text": "Charles City",
    "value": "charles city"
  },
  {
    "text": "Charles Town",
    "value": "charles town"
  },
  {
    "text": "Charleston",
    "value": "charleston"
  },
  {
    "text": "Charlestown",
    "value": "charlestown"
  },
  {
    "text": "Charlevoix",
    "value": "charlevoix"
  },
  {
    "text": "Charlo",
    "value": "charlo"
  },
  {
    "text": "Charlotte",
    "value": "charlotte"
  },
  {
    "text": "Charlotte Court House",
    "value": "charlotte court house"
  },
  {
    "text": "Charlotte Hall",
    "value": "charlotte hall"
  },
  {
    "text": "Charlotte Harbor",
    "value": "charlotte harbor"
  },
  {
    "text": "Charlottesville",
    "value": "charlottesville"
  },
  {
    "text": "Charlton",
    "value": "charlton"
  },
  {
    "text": "Charlton City",
    "value": "charlton city"
  },
  {
    "text": "Charlton Heights",
    "value": "charlton heights"
  },
  {
    "text": "Charmco",
    "value": "charmco"
  },
  {
    "text": "Charter Oak",
    "value": "charter oak"
  },
  {
    "text": "Charter Township of Augusta",
    "value": "charter township of augusta"
  },
  {
    "text": "Charter Township of Oakland",
    "value": "charter township of oakland"
  },
  {
    "text": "Chase",
    "value": "chase"
  },
  {
    "text": "Chase City",
    "value": "chase city"
  },
  {
    "text": "Chase Mills",
    "value": "chase mills"
  },
  {
    "text": "Chaseburg",
    "value": "chaseburg"
  },
  {
    "text": "Chaska",
    "value": "chaska"
  },
  {
    "text": "Chassell",
    "value": "chassell"
  },
  {
    "text": "Chatawa",
    "value": "chatawa"
  },
  {
    "text": "Chateaugay",
    "value": "chateaugay"
  },
  {
    "text": "Chatfield",
    "value": "chatfield"
  },
  {
    "text": "Chatham",
    "value": "chatham"
  },
  {
    "text": "Chatom",
    "value": "chatom"
  },
  {
    "text": "Chatsworth",
    "value": "chatsworth"
  },
  {
    "text": "Chattahoochee",
    "value": "chattahoochee"
  },
  {
    "text": "Chattahoochee Hills",
    "value": "chattahoochee hills"
  },
  {
    "text": "Chattanooga",
    "value": "chattanooga"
  },
  {
    "text": "Chattaroy",
    "value": "chattaroy"
  },
  {
    "text": "Chaumont",
    "value": "chaumont"
  },
  {
    "text": "Chauncey",
    "value": "chauncey"
  },
  {
    "text": "Chautauqua",
    "value": "chautauqua"
  },
  {
    "text": "Chauvin",
    "value": "chauvin"
  },
  {
    "text": "Chavies",
    "value": "chavies"
  },
  {
    "text": "Chazy",
    "value": "chazy"
  },
  {
    "text": "Cheat Lake",
    "value": "cheat lake"
  },
  {
    "text": "Chebanse",
    "value": "chebanse"
  },
  {
    "text": "Chebeague Island",
    "value": "chebeague island"
  },
  {
    "text": "Cheboygan",
    "value": "cheboygan"
  },
  {
    "text": "Checotah",
    "value": "checotah"
  },
  {
    "text": "Cheektowaga",
    "value": "cheektowaga"
  },
  {
    "text": "Chefornak",
    "value": "chefornak"
  },
  {
    "text": "Chehalis",
    "value": "chehalis"
  },
  {
    "text": "Chelan",
    "value": "chelan"
  },
  {
    "text": "Chelan Falls",
    "value": "chelan falls"
  },
  {
    "text": "Chelmsford",
    "value": "chelmsford"
  },
  {
    "text": "Chelsea",
    "value": "chelsea"
  },
  {
    "text": "Cheltenham",
    "value": "cheltenham"
  },
  {
    "text": "Chemult",
    "value": "chemult"
  },
  {
    "text": "Chemung",
    "value": "chemung"
  },
  {
    "text": "Chenango Bridge",
    "value": "chenango bridge"
  },
  {
    "text": "Chenango Forks",
    "value": "chenango forks"
  },
  {
    "text": "Cheney",
    "value": "cheney"
  },
  {
    "text": "Cheneyville",
    "value": "cheneyville"
  },
  {
    "text": "Chenoa",
    "value": "chenoa"
  },
  {
    "text": "Chepachet",
    "value": "chepachet"
  },
  {
    "text": "Cheraw",
    "value": "cheraw"
  },
  {
    "text": "Cheriton",
    "value": "cheriton"
  },
  {
    "text": "Cherokee",
    "value": "cherokee"
  },
  {
    "text": "Cherokee Village",
    "value": "cherokee village"
  },
  {
    "text": "Cherry Creek",
    "value": "cherry creek"
  },
  {
    "text": "Cherry Fork",
    "value": "cherry fork"
  },
  {
    "text": "Cherry Grove",
    "value": "cherry grove"
  },
  {
    "text": "Cherry Hill",
    "value": "cherry hill"
  },
  {
    "text": "Cherry Hills Village",
    "value": "cherry hills village"
  },
  {
    "text": "Cherry Island",
    "value": "cherry island"
  },
  {
    "text": "Cherry Log",
    "value": "cherry log"
  },
  {
    "text": "Cherry Point",
    "value": "cherry point"
  },
  {
    "text": "Cherry Point Marine Base Mobile Home Park",
    "value": "cherry point marine base mobile home park"
  },
  {
    "text": "Cherry Tree",
    "value": "cherry tree"
  },
  {
    "text": "Cherry Valley",
    "value": "cherry valley"
  },
  {
    "text": "Cherryfield",
    "value": "cherryfield"
  },
  {
    "text": "Cherryplain",
    "value": "cherryplain"
  },
  {
    "text": "Cherryvale",
    "value": "cherryvale"
  },
  {
    "text": "Cherryville",
    "value": "cherryville"
  },
  {
    "text": "Chesaning",
    "value": "chesaning"
  },
  {
    "text": "Chesapeake",
    "value": "chesapeake"
  },
  {
    "text": "Chesapeake Beach",
    "value": "chesapeake beach"
  },
  {
    "text": "Chesapeake City",
    "value": "chesapeake city"
  },
  {
    "text": "Chesapeake Ranch Estates",
    "value": "chesapeake ranch estates"
  },
  {
    "text": "Cheshire",
    "value": "cheshire"
  },
  {
    "text": "Chesnee",
    "value": "chesnee"
  },
  {
    "text": "Chester",
    "value": "chester"
  },
  {
    "text": "Chester Gap",
    "value": "chester gap"
  },
  {
    "text": "Chester Heights",
    "value": "chester heights"
  },
  {
    "text": "Chester Springs",
    "value": "chester springs"
  },
  {
    "text": "Chesterbrook",
    "value": "chesterbrook"
  },
  {
    "text": "Chesterfield",
    "value": "chesterfield"
  },
  {
    "text": "Chesterfield Court House",
    "value": "chesterfield court house"
  },
  {
    "text": "Chesterhill",
    "value": "chesterhill"
  },
  {
    "text": "Chesterland",
    "value": "chesterland"
  },
  {
    "text": "Chesterton",
    "value": "chesterton"
  },
  {
    "text": "Chestertown",
    "value": "chestertown"
  },
  {
    "text": "Chesterville",
    "value": "chesterville"
  },
  {
    "text": "Chestnut",
    "value": "chestnut"
  },
  {
    "text": "Chestnut Hill",
    "value": "chestnut hill"
  },
  {
    "text": "Chestnut Mound",
    "value": "chestnut mound"
  },
  {
    "text": "Chestnut Ridge",
    "value": "chestnut ridge"
  },
  {
    "text": "Chestnutridge",
    "value": "chestnutridge"
  },
  {
    "text": "Cheswick",
    "value": "cheswick"
  },
  {
    "text": "Cheswold",
    "value": "cheswold"
  },
  {
    "text": "Chetek",
    "value": "chetek"
  },
  {
    "text": "Chetopa",
    "value": "chetopa"
  },
  {
    "text": "Chevak",
    "value": "chevak"
  },
  {
    "text": "Cheval",
    "value": "cheval"
  },
  {
    "text": "Cheverly",
    "value": "cheverly"
  },
  {
    "text": "Cheviot",
    "value": "cheviot"
  },
  {
    "text": "Chevy Chase",
    "value": "chevy chase"
  },
  {
    "text": "Chevy Chase Village",
    "value": "chevy chase village"
  },
  {
    "text": "Chewalla",
    "value": "chewalla"
  },
  {
    "text": "Chewelah",
    "value": "chewelah"
  },
  {
    "text": "Cheyenne",
    "value": "cheyenne"
  },
  {
    "text": "Cheyenne Wells",
    "value": "cheyenne wells"
  },
  {
    "text": "Cheyney",
    "value": "cheyney"
  },
  {
    "text": "Chicago",
    "value": "chicago"
  },
  {
    "text": "Chicago Heights",
    "value": "chicago heights"
  },
  {
    "text": "Chicago Ridge",
    "value": "chicago ridge"
  },
  {
    "text": "Chichester",
    "value": "chichester"
  },
  {
    "text": "Chickamauga",
    "value": "chickamauga"
  },
  {
    "text": "Chickasaw",
    "value": "chickasaw"
  },
  {
    "text": "Chickasha",
    "value": "chickasha"
  },
  {
    "text": "Chico",
    "value": "chico"
  },
  {
    "text": "Chicopee",
    "value": "chicopee"
  },
  {
    "text": "Chicora",
    "value": "chicora"
  },
  {
    "text": "Chidester",
    "value": "chidester"
  },
  {
    "text": "Chiefland",
    "value": "chiefland"
  },
  {
    "text": "Chilcoot",
    "value": "chilcoot"
  },
  {
    "text": "Childersburg",
    "value": "childersburg"
  },
  {
    "text": "Childress",
    "value": "childress"
  },
  {
    "text": "Childs",
    "value": "childs"
  },
  {
    "text": "Chilhowee",
    "value": "chilhowee"
  },
  {
    "text": "Chilhowie",
    "value": "chilhowie"
  },
  {
    "text": "Chili",
    "value": "chili"
  },
  {
    "text": "Chillicothe",
    "value": "chillicothe"
  },
  {
    "text": "Chilmark",
    "value": "chilmark"
  },
  {
    "text": "Chiloquin",
    "value": "chiloquin"
  },
  {
    "text": "Chilton",
    "value": "chilton"
  },
  {
    "text": "Chimacum",
    "value": "chimacum"
  },
  {
    "text": "Chimayo",
    "value": "chimayo"
  },
  {
    "text": "Chimney Rock",
    "value": "chimney rock"
  },
  {
    "text": "China",
    "value": "china"
  },
  {
    "text": "China Grove",
    "value": "china grove"
  },
  {
    "text": "China Spring",
    "value": "china spring"
  },
  {
    "text": "China Township",
    "value": "china township"
  },
  {
    "text": "Chinchilla",
    "value": "chinchilla"
  },
  {
    "text": "Chincoteague",
    "value": "chincoteague"
  },
  {
    "text": "Chincoteague Island",
    "value": "chincoteague island"
  },
  {
    "text": "Chinese Camp",
    "value": "chinese camp"
  },
  {
    "text": "Chinle",
    "value": "chinle"
  },
  {
    "text": "Chino",
    "value": "chino"
  },
  {
    "text": "Chino Hills",
    "value": "chino hills"
  },
  {
    "text": "Chino Valley",
    "value": "chino valley"
  },
  {
    "text": "Chinook",
    "value": "chinook"
  },
  {
    "text": "Chinquapin",
    "value": "chinquapin"
  },
  {
    "text": "Chipley",
    "value": "chipley"
  },
  {
    "text": "Chippewa Falls",
    "value": "chippewa falls"
  },
  {
    "text": "Chippewa Lake",
    "value": "chippewa lake"
  },
  {
    "text": "Chireno",
    "value": "chireno"
  },
  {
    "text": "Chisago City",
    "value": "chisago city"
  },
  {
    "text": "Chisholm",
    "value": "chisholm"
  },
  {
    "text": "Chittenango",
    "value": "chittenango"
  },
  {
    "text": "Chittenden",
    "value": "chittenden"
  },
  {
    "text": "Chloe",
    "value": "chloe"
  },
  {
    "text": "Chloride",
    "value": "chloride"
  },
  {
    "text": "Chocorua",
    "value": "chocorua"
  },
  {
    "text": "Chocowinity",
    "value": "chocowinity"
  },
  {
    "text": "Choctaw",
    "value": "choctaw"
  },
  {
    "text": "Chokio",
    "value": "chokio"
  },
  {
    "text": "Chokoloskee",
    "value": "chokoloskee"
  },
  {
    "text": "Choteau",
    "value": "choteau"
  },
  {
    "text": "Choudrant",
    "value": "choudrant"
  },
  {
    "text": "Chouteau",
    "value": "chouteau"
  },
  {
    "text": "Chowchilla",
    "value": "chowchilla"
  },
  {
    "text": "Chrisman",
    "value": "chrisman"
  },
  {
    "text": "Chrisney",
    "value": "chrisney"
  },
  {
    "text": "Christchurch",
    "value": "christchurch"
  },
  {
    "text": "Christiana",
    "value": "christiana"
  },
  {
    "text": "Christiansburg",
    "value": "christiansburg"
  },
  {
    "text": "Christine",
    "value": "christine"
  },
  {
    "text": "Christmas",
    "value": "christmas"
  },
  {
    "text": "Christmas Valley",
    "value": "christmas valley"
  },
  {
    "text": "Christopher",
    "value": "christopher"
  },
  {
    "text": "Christoval",
    "value": "christoval"
  },
  {
    "text": "Chualar",
    "value": "chualar"
  },
  {
    "text": "Chubbuck",
    "value": "chubbuck"
  },
  {
    "text": "Chuckey",
    "value": "chuckey"
  },
  {
    "text": "Chugiak",
    "value": "chugiak"
  },
  {
    "text": "Chugwater",
    "value": "chugwater"
  },
  {
    "text": "Chula",
    "value": "chula"
  },
  {
    "text": "Chula Vista",
    "value": "chula vista"
  },
  {
    "text": "Chuluota",
    "value": "chuluota"
  },
  {
    "text": "Chunchula",
    "value": "chunchula"
  },
  {
    "text": "Chunky",
    "value": "chunky"
  },
  {
    "text": "Church Creek",
    "value": "church creek"
  },
  {
    "text": "Church Hill",
    "value": "church hill"
  },
  {
    "text": "Church Point",
    "value": "church point"
  },
  {
    "text": "Church Road",
    "value": "church road"
  },
  {
    "text": "Church Rock",
    "value": "church rock"
  },
  {
    "text": "Churchill",
    "value": "churchill"
  },
  {
    "text": "Churchton",
    "value": "churchton"
  },
  {
    "text": "Churchville",
    "value": "churchville"
  },
  {
    "text": "Churdan",
    "value": "churdan"
  },
  {
    "text": "Churubusco",
    "value": "churubusco"
  },
  {
    "text": "Cibecue",
    "value": "cibecue"
  },
  {
    "text": "Cibola",
    "value": "cibola"
  },
  {
    "text": "Cibolo",
    "value": "cibolo"
  },
  {
    "text": "Cicero",
    "value": "cicero"
  },
  {
    "text": "Cima",
    "value": "cima"
  },
  {
    "text": "Cimarron",
    "value": "cimarron"
  },
  {
    "text": "Cimarron Hills",
    "value": "cimarron hills"
  },
  {
    "text": "Cincinnati",
    "value": "cincinnati"
  },
  {
    "text": "Cincinnatus",
    "value": "cincinnatus"
  },
  {
    "text": "Cinco Ranch",
    "value": "cinco ranch"
  },
  {
    "text": "Cinebar",
    "value": "cinebar"
  },
  {
    "text": "Cinnaminson",
    "value": "cinnaminson"
  },
  {
    "text": "Circle",
    "value": "circle"
  },
  {
    "text": "Circle Pines",
    "value": "circle pines"
  },
  {
    "text": "Circleville",
    "value": "circleville"
  },
  {
    "text": "Cisco",
    "value": "cisco"
  },
  {
    "text": "Cisne",
    "value": "cisne"
  },
  {
    "text": "Cissna Park",
    "value": "cissna park"
  },
  {
    "text": "Citra",
    "value": "citra"
  },
  {
    "text": "Citronelle",
    "value": "citronelle"
  },
  {
    "text": "Citrus City",
    "value": "citrus city"
  },
  {
    "text": "Citrus Heights",
    "value": "citrus heights"
  },
  {
    "text": "Citrus Hills",
    "value": "citrus hills"
  },
  {
    "text": "Citrus Park",
    "value": "citrus park"
  },
  {
    "text": "Citrus Ridge",
    "value": "citrus ridge"
  },
  {
    "text": "Citrus Springs",
    "value": "citrus springs"
  },
  {
    "text": "City Of Industry",
    "value": "city of industry"
  },
  {
    "text": "City of Angels",
    "value": "city of angels"
  },
  {
    "text": "City of Industry",
    "value": "city of industry"
  },
  {
    "text": "City of Los Angeles",
    "value": "city of los angeles"
  },
  {
    "text": "City of Saint Peters",
    "value": "city of saint peters"
  },
  {
    "text": "Clackamas",
    "value": "clackamas"
  },
  {
    "text": "Claflin",
    "value": "claflin"
  },
  {
    "text": "Claiborne",
    "value": "claiborne"
  },
  {
    "text": "Claire City",
    "value": "claire city"
  },
  {
    "text": "Clairfield",
    "value": "clairfield"
  },
  {
    "text": "Clairton",
    "value": "clairton"
  },
  {
    "text": "Clallam Bay",
    "value": "clallam bay"
  },
  {
    "text": "Clam Lake",
    "value": "clam lake"
  },
  {
    "text": "Clancy",
    "value": "clancy"
  },
  {
    "text": "Clanton",
    "value": "clanton"
  },
  {
    "text": "Clara",
    "value": "clara"
  },
  {
    "text": "Clara City",
    "value": "clara city"
  },
  {
    "text": "Clare",
    "value": "clare"
  },
  {
    "text": "Claremont",
    "value": "claremont"
  },
  {
    "text": "Claremore",
    "value": "claremore"
  },
  {
    "text": "Clarence",
    "value": "clarence"
  },
  {
    "text": "Clarence Center",
    "value": "clarence center"
  },
  {
    "text": "Clarendon",
    "value": "clarendon"
  },
  {
    "text": "Clarendon Hills",
    "value": "clarendon hills"
  },
  {
    "text": "Claridge",
    "value": "claridge"
  },
  {
    "text": "Clarinda",
    "value": "clarinda"
  },
  {
    "text": "Clarington",
    "value": "clarington"
  },
  {
    "text": "Clarion",
    "value": "clarion"
  },
  {
    "text": "Clarissa",
    "value": "clarissa"
  },
  {
    "text": "Clark",
    "value": "clark"
  },
  {
    "text": "Clark Fork",
    "value": "clark fork"
  },
  {
    "text": "Clark Mills",
    "value": "clark mills"
  },
  {
    "text": "Clarkdale",
    "value": "clarkdale"
  },
  {
    "text": "Clarkesville",
    "value": "clarkesville"
  },
  {
    "text": "Clarkfield",
    "value": "clarkfield"
  },
  {
    "text": "Clarklake",
    "value": "clarklake"
  },
  {
    "text": "Clarkrange",
    "value": "clarkrange"
  },
  {
    "text": "Clarkridge",
    "value": "clarkridge"
  },
  {
    "text": "Clarks",
    "value": "clarks"
  },
  {
    "text": "Clarks Green",
    "value": "clarks green"
  },
  {
    "text": "Clarks Grove",
    "value": "clarks grove"
  },
  {
    "text": "Clarks Hill",
    "value": "clarks hill"
  },
  {
    "text": "Clarks Mills",
    "value": "clarks mills"
  },
  {
    "text": "Clarks Summit",
    "value": "clarks summit"
  },
  {
    "text": "Clarksboro",
    "value": "clarksboro"
  },
  {
    "text": "Clarksburg",
    "value": "clarksburg"
  },
  {
    "text": "Clarksdale",
    "value": "clarksdale"
  },
  {
    "text": "Clarkson",
    "value": "clarkson"
  },
  {
    "text": "Clarkson Valley",
    "value": "clarkson valley"
  },
  {
    "text": "Clarkston",
    "value": "clarkston"
  },
  {
    "text": "Clarksville",
    "value": "clarksville"
  },
  {
    "text": "Clarkton",
    "value": "clarkton"
  },
  {
    "text": "Claryville",
    "value": "claryville"
  },
  {
    "text": "Clatonia",
    "value": "clatonia"
  },
  {
    "text": "Clatskanie",
    "value": "clatskanie"
  },
  {
    "text": "Claude",
    "value": "claude"
  },
  {
    "text": "Claudville",
    "value": "claudville"
  },
  {
    "text": "Claverack",
    "value": "claverack"
  },
  {
    "text": "Clawson",
    "value": "clawson"
  },
  {
    "text": "Claxton",
    "value": "claxton"
  },
  {
    "text": "Clay",
    "value": "clay"
  },
  {
    "text": "Clay Center",
    "value": "clay center"
  },
  {
    "text": "Clay City",
    "value": "clay city"
  },
  {
    "text": "Clay Springs",
    "value": "clay springs"
  },
  {
    "text": "Claycomo",
    "value": "claycomo"
  },
  {
    "text": "Clayhole",
    "value": "clayhole"
  },
  {
    "text": "Claymont",
    "value": "claymont"
  },
  {
    "text": "Claypool",
    "value": "claypool"
  },
  {
    "text": "Claysburg",
    "value": "claysburg"
  },
  {
    "text": "Claysville",
    "value": "claysville"
  },
  {
    "text": "Clayton",
    "value": "clayton"
  },
  {
    "text": "Clayville",
    "value": "clayville"
  },
  {
    "text": "Cle Elum",
    "value": "cle elum"
  },
  {
    "text": "Clear",
    "value": "clear"
  },
  {
    "text": "Clear Brook",
    "value": "clear brook"
  },
  {
    "text": "Clear Fork",
    "value": "clear fork"
  },
  {
    "text": "Clear Lake",
    "value": "clear lake"
  },
  {
    "text": "Clear Lake Shores",
    "value": "clear lake shores"
  },
  {
    "text": "Clear Spring",
    "value": "clear spring"
  },
  {
    "text": "Clearbrook",
    "value": "clearbrook"
  },
  {
    "text": "Clearfield",
    "value": "clearfield"
  },
  {
    "text": "Clearlake",
    "value": "clearlake"
  },
  {
    "text": "Clearlake Oaks",
    "value": "clearlake oaks"
  },
  {
    "text": "Clearmont",
    "value": "clearmont"
  },
  {
    "text": "Clearville",
    "value": "clearville"
  },
  {
    "text": "Clearwater",
    "value": "clearwater"
  },
  {
    "text": "Clearwater Beach",
    "value": "clearwater beach"
  },
  {
    "text": "Cleburne",
    "value": "cleburne"
  },
  {
    "text": "Cleghorn",
    "value": "cleghorn"
  },
  {
    "text": "Clementon",
    "value": "clementon"
  },
  {
    "text": "Clements",
    "value": "clements"
  },
  {
    "text": "Clemmons",
    "value": "clemmons"
  },
  {
    "text": "Clemons",
    "value": "clemons"
  },
  {
    "text": "Clemson",
    "value": "clemson"
  },
  {
    "text": "Clendenin",
    "value": "clendenin"
  },
  {
    "text": "Cleo Springs",
    "value": "cleo springs"
  },
  {
    "text": "Cleona",
    "value": "cleona"
  },
  {
    "text": "Clermont",
    "value": "clermont"
  },
  {
    "text": "Cleveland",
    "value": "cleveland"
  },
  {
    "text": "Cleveland Heights",
    "value": "cleveland heights"
  },
  {
    "text": "Clever",
    "value": "clever"
  },
  {
    "text": "Cleves",
    "value": "cleves"
  },
  {
    "text": "Clewiston",
    "value": "clewiston"
  },
  {
    "text": "Cliff",
    "value": "cliff"
  },
  {
    "text": "Cliff Island",
    "value": "cliff island"
  },
  {
    "text": "Clifford",
    "value": "clifford"
  },
  {
    "text": "Cliffside",
    "value": "cliffside"
  },
  {
    "text": "Cliffside Park",
    "value": "cliffside park"
  },
  {
    "text": "Cliffwood",
    "value": "cliffwood"
  },
  {
    "text": "Cliffwood Beach",
    "value": "cliffwood beach"
  },
  {
    "text": "Clifton",
    "value": "clifton"
  },
  {
    "text": "Clifton Forge",
    "value": "clifton forge"
  },
  {
    "text": "Clifton Heights",
    "value": "clifton heights"
  },
  {
    "text": "Clifton Hill",
    "value": "clifton hill"
  },
  {
    "text": "Clifton Park",
    "value": "clifton park"
  },
  {
    "text": "Clifton Springs",
    "value": "clifton springs"
  },
  {
    "text": "Climax",
    "value": "climax"
  },
  {
    "text": "Climax Springs",
    "value": "climax springs"
  },
  {
    "text": "Clinchco",
    "value": "clinchco"
  },
  {
    "text": "Clinchfield",
    "value": "clinchfield"
  },
  {
    "text": "Clines Corners",
    "value": "clines corners"
  },
  {
    "text": "Clint",
    "value": "clint"
  },
  {
    "text": "Clinton",
    "value": "clinton"
  },
  {
    "text": "Clinton Corners",
    "value": "clinton corners"
  },
  {
    "text": "Clinton Township",
    "value": "clinton township"
  },
  {
    "text": "Clintondale",
    "value": "clintondale"
  },
  {
    "text": "Clintonville",
    "value": "clintonville"
  },
  {
    "text": "Clintwood",
    "value": "clintwood"
  },
  {
    "text": "Clio",
    "value": "clio"
  },
  {
    "text": "Clipper Mills",
    "value": "clipper mills"
  },
  {
    "text": "Clitherall",
    "value": "clitherall"
  },
  {
    "text": "Clive",
    "value": "clive"
  },
  {
    "text": "Clontarf",
    "value": "clontarf"
  },
  {
    "text": "Clopton",
    "value": "clopton"
  },
  {
    "text": "Cloquet",
    "value": "cloquet"
  },
  {
    "text": "Closplint",
    "value": "closplint"
  },
  {
    "text": "Closter",
    "value": "closter"
  },
  {
    "text": "Cloudcroft",
    "value": "cloudcroft"
  },
  {
    "text": "Cloutierville",
    "value": "cloutierville"
  },
  {
    "text": "Clover",
    "value": "clover"
  },
  {
    "text": "Clover Hill",
    "value": "clover hill"
  },
  {
    "text": "Cloverdale",
    "value": "cloverdale"
  },
  {
    "text": "Cloverly",
    "value": "cloverly"
  },
  {
    "text": "Cloverport",
    "value": "cloverport"
  },
  {
    "text": "Clovis",
    "value": "clovis"
  },
  {
    "text": "Clune",
    "value": "clune"
  },
  {
    "text": "Clute",
    "value": "clute"
  },
  {
    "text": "Clutier",
    "value": "clutier"
  },
  {
    "text": "Clyde",
    "value": "clyde"
  },
  {
    "text": "Clyde Hill",
    "value": "clyde hill"
  },
  {
    "text": "Clyde Park",
    "value": "clyde park"
  },
  {
    "text": "Clyde Township",
    "value": "clyde township"
  },
  {
    "text": "Clyman",
    "value": "clyman"
  },
  {
    "text": "Clymer",
    "value": "clymer"
  },
  {
    "text": "Clyo",
    "value": "clyo"
  },
  {
    "text": "Coachella",
    "value": "coachella"
  },
  {
    "text": "Coahoma",
    "value": "coahoma"
  },
  {
    "text": "Coal",
    "value": "coal"
  },
  {
    "text": "Coal Center",
    "value": "coal center"
  },
  {
    "text": "Coal City",
    "value": "coal city"
  },
  {
    "text": "Coal Fork",
    "value": "coal fork"
  },
  {
    "text": "Coal Grove",
    "value": "coal grove"
  },
  {
    "text": "Coal Hill",
    "value": "coal hill"
  },
  {
    "text": "Coal Mountain",
    "value": "coal mountain"
  },
  {
    "text": "Coal Run Village",
    "value": "coal run village"
  },
  {
    "text": "Coal Township",
    "value": "coal township"
  },
  {
    "text": "Coal Valley",
    "value": "coal valley"
  },
  {
    "text": "Coaldale",
    "value": "coaldale"
  },
  {
    "text": "Coalfield",
    "value": "coalfield"
  },
  {
    "text": "Coalgate",
    "value": "coalgate"
  },
  {
    "text": "Coaling",
    "value": "coaling"
  },
  {
    "text": "Coalinga",
    "value": "coalinga"
  },
  {
    "text": "Coalmont",
    "value": "coalmont"
  },
  {
    "text": "Coalport",
    "value": "coalport"
  },
  {
    "text": "Coalton",
    "value": "coalton"
  },
  {
    "text": "Coalville",
    "value": "coalville"
  },
  {
    "text": "Coarsegold",
    "value": "coarsegold"
  },
  {
    "text": "Coatesville",
    "value": "coatesville"
  },
  {
    "text": "Coats",
    "value": "coats"
  },
  {
    "text": "Coatsburg",
    "value": "coatsburg"
  },
  {
    "text": "Coatsville",
    "value": "coatsville"
  },
  {
    "text": "Cobalt",
    "value": "cobalt"
  },
  {
    "text": "Cobb",
    "value": "cobb"
  },
  {
    "text": "Cobb Island",
    "value": "cobb island"
  },
  {
    "text": "Cobbs Creek",
    "value": "cobbs creek"
  },
  {
    "text": "Cobbtown",
    "value": "cobbtown"
  },
  {
    "text": "Cobden",
    "value": "cobden"
  },
  {
    "text": "Cobleskill",
    "value": "cobleskill"
  },
  {
    "text": "Coburg",
    "value": "coburg"
  },
  {
    "text": "Coburn",
    "value": "coburn"
  },
  {
    "text": "Cochecton",
    "value": "cochecton"
  },
  {
    "text": "Cochise",
    "value": "cochise"
  },
  {
    "text": "Cochiti Lake",
    "value": "cochiti lake"
  },
  {
    "text": "Cochiti Pueblo",
    "value": "cochiti pueblo"
  },
  {
    "text": "Cochran",
    "value": "cochran"
  },
  {
    "text": "Cochrane",
    "value": "cochrane"
  },
  {
    "text": "Cochranton",
    "value": "cochranton"
  },
  {
    "text": "Cochranville",
    "value": "cochranville"
  },
  {
    "text": "Cockeysville",
    "value": "cockeysville"
  },
  {
    "text": "Cockrell Hill",
    "value": "cockrell hill"
  },
  {
    "text": "Cocoa",
    "value": "cocoa"
  },
  {
    "text": "Cocoa Beach",
    "value": "cocoa beach"
  },
  {
    "text": "Cocolalla",
    "value": "cocolalla"
  },
  {
    "text": "Cocolamus",
    "value": "cocolamus"
  },
  {
    "text": "Coconut Creek",
    "value": "coconut creek"
  },
  {
    "text": "Coden",
    "value": "coden"
  },
  {
    "text": "Cody",
    "value": "cody"
  },
  {
    "text": "Coeburn",
    "value": "coeburn"
  },
  {
    "text": "Coello",
    "value": "coello"
  },
  {
    "text": "Coeur d'Alene",
    "value": "coeur d'alene"
  },
  {
    "text": "Coeymans",
    "value": "coeymans"
  },
  {
    "text": "Coeymans Hollow",
    "value": "coeymans hollow"
  },
  {
    "text": "Coffee Springs",
    "value": "coffee springs"
  },
  {
    "text": "Coffeen",
    "value": "coffeen"
  },
  {
    "text": "Coffeeville",
    "value": "coffeeville"
  },
  {
    "text": "Coffey",
    "value": "coffey"
  },
  {
    "text": "Coffeyville",
    "value": "coffeyville"
  },
  {
    "text": "Cofield",
    "value": "cofield"
  },
  {
    "text": "Cogan Station",
    "value": "cogan station"
  },
  {
    "text": "Coggon",
    "value": "coggon"
  },
  {
    "text": "Cogswell",
    "value": "cogswell"
  },
  {
    "text": "Cohasset",
    "value": "cohasset"
  },
  {
    "text": "Cohocton",
    "value": "cohocton"
  },
  {
    "text": "Cohoes",
    "value": "cohoes"
  },
  {
    "text": "Cohutta",
    "value": "cohutta"
  },
  {
    "text": "Coila",
    "value": "coila"
  },
  {
    "text": "Coin",
    "value": "coin"
  },
  {
    "text": "Coinjock",
    "value": "coinjock"
  },
  {
    "text": "Cokato",
    "value": "cokato"
  },
  {
    "text": "Cokeburg",
    "value": "cokeburg"
  },
  {
    "text": "Coker",
    "value": "coker"
  },
  {
    "text": "Coker Creek",
    "value": "coker creek"
  },
  {
    "text": "Cokeville",
    "value": "cokeville"
  },
  {
    "text": "Colbert",
    "value": "colbert"
  },
  {
    "text": "Colby",
    "value": "colby"
  },
  {
    "text": "Colchester",
    "value": "colchester"
  },
  {
    "text": "Colcord",
    "value": "colcord"
  },
  {
    "text": "Cold Brook",
    "value": "cold brook"
  },
  {
    "text": "Cold Spring",
    "value": "cold spring"
  },
  {
    "text": "Cold Spring Harbor",
    "value": "cold spring harbor"
  },
  {
    "text": "Cold Springs",
    "value": "cold springs"
  },
  {
    "text": "Colden",
    "value": "colden"
  },
  {
    "text": "Coldiron",
    "value": "coldiron"
  },
  {
    "text": "Coldspring",
    "value": "coldspring"
  },
  {
    "text": "Coldwater",
    "value": "coldwater"
  },
  {
    "text": "Cole Camp",
    "value": "cole camp"
  },
  {
    "text": "Colebrook",
    "value": "colebrook"
  },
  {
    "text": "Coleharbor",
    "value": "coleharbor"
  },
  {
    "text": "Coleman",
    "value": "coleman"
  },
  {
    "text": "Coleman Falls",
    "value": "coleman falls"
  },
  {
    "text": "Colerain",
    "value": "colerain"
  },
  {
    "text": "Coleraine",
    "value": "coleraine"
  },
  {
    "text": "Coleridge",
    "value": "coleridge"
  },
  {
    "text": "Coles Point",
    "value": "coles point"
  },
  {
    "text": "Colesburg",
    "value": "colesburg"
  },
  {
    "text": "Colesville",
    "value": "colesville"
  },
  {
    "text": "Coleville",
    "value": "coleville"
  },
  {
    "text": "Colfax",
    "value": "colfax"
  },
  {
    "text": "Colgate",
    "value": "colgate"
  },
  {
    "text": "Collbran",
    "value": "collbran"
  },
  {
    "text": "College Corner",
    "value": "college corner"
  },
  {
    "text": "College Grove",
    "value": "college grove"
  },
  {
    "text": "College Park",
    "value": "college park"
  },
  {
    "text": "College Place",
    "value": "college place"
  },
  {
    "text": "College Point",
    "value": "college point"
  },
  {
    "text": "College Springs",
    "value": "college springs"
  },
  {
    "text": "College Station",
    "value": "college station"
  },
  {
    "text": "Collegedale",
    "value": "collegedale"
  },
  {
    "text": "Collegeville",
    "value": "collegeville"
  },
  {
    "text": "Collettsville",
    "value": "collettsville"
  },
  {
    "text": "Colleyville",
    "value": "colleyville"
  },
  {
    "text": "Colliers",
    "value": "colliers"
  },
  {
    "text": "Collierville",
    "value": "collierville"
  },
  {
    "text": "Collingdale",
    "value": "collingdale"
  },
  {
    "text": "Collingswood",
    "value": "collingswood"
  },
  {
    "text": "Collins",
    "value": "collins"
  },
  {
    "text": "Collinston",
    "value": "collinston"
  },
  {
    "text": "Collinsville",
    "value": "collinsville"
  },
  {
    "text": "Collinwood",
    "value": "collinwood"
  },
  {
    "text": "Collison",
    "value": "collison"
  },
  {
    "text": "Colma",
    "value": "colma"
  },
  {
    "text": "Colman",
    "value": "colman"
  },
  {
    "text": "Colmar",
    "value": "colmar"
  },
  {
    "text": "Colmar Manor",
    "value": "colmar manor"
  },
  {
    "text": "Colmesneil",
    "value": "colmesneil"
  },
  {
    "text": "Colo",
    "value": "colo"
  },
  {
    "text": "Cologne",
    "value": "cologne"
  },
  {
    "text": "Coloma",
    "value": "coloma"
  },
  {
    "text": "Colome",
    "value": "colome"
  },
  {
    "text": "Colon",
    "value": "colon"
  },
  {
    "text": "Colona",
    "value": "colona"
  },
  {
    "text": "Colonia",
    "value": "colonia"
  },
  {
    "text": "Colonial Beach",
    "value": "colonial beach"
  },
  {
    "text": "Colonial Heights",
    "value": "colonial heights"
  },
  {
    "text": "Colonial Park",
    "value": "colonial park"
  },
  {
    "text": "Colonie",
    "value": "colonie"
  },
  {
    "text": "Colony",
    "value": "colony"
  },
  {
    "text": "Colony Springs",
    "value": "colony springs"
  },
  {
    "text": "Colora",
    "value": "colora"
  },
  {
    "text": "Colorado City",
    "value": "colorado city"
  },
  {
    "text": "Colorado Springs",
    "value": "colorado springs"
  },
  {
    "text": "Colp",
    "value": "colp"
  },
  {
    "text": "Colquitt",
    "value": "colquitt"
  },
  {
    "text": "Colrain",
    "value": "colrain"
  },
  {
    "text": "Colstrip",
    "value": "colstrip"
  },
  {
    "text": "Colt",
    "value": "colt"
  },
  {
    "text": "Colton",
    "value": "colton"
  },
  {
    "text": "Coltons Point",
    "value": "coltons point"
  },
  {
    "text": "Colts Neck",
    "value": "colts neck"
  },
  {
    "text": "Columbia",
    "value": "columbia"
  },
  {
    "text": "Columbia Center",
    "value": "columbia center"
  },
  {
    "text": "Columbia City",
    "value": "columbia city"
  },
  {
    "text": "Columbia Cross Roads",
    "value": "columbia cross roads"
  },
  {
    "text": "Columbia Falls",
    "value": "columbia falls"
  },
  {
    "text": "Columbia Heights",
    "value": "columbia heights"
  },
  {
    "text": "Columbia Station",
    "value": "columbia station"
  },
  {
    "text": "Columbiana",
    "value": "columbiana"
  },
  {
    "text": "Columbiaville",
    "value": "columbiaville"
  },
  {
    "text": "Columbine",
    "value": "columbine"
  },
  {
    "text": "Columbine Valley",
    "value": "columbine valley"
  },
  {
    "text": "Columbus",
    "value": "columbus"
  },
  {
    "text": "Columbus Air Force Base",
    "value": "columbus air force base"
  },
  {
    "text": "Columbus City",
    "value": "columbus city"
  },
  {
    "text": "Columbus Grove",
    "value": "columbus grove"
  },
  {
    "text": "Columbus Junction",
    "value": "columbus junction"
  },
  {
    "text": "Colusa",
    "value": "colusa"
  },
  {
    "text": "Colver",
    "value": "colver"
  },
  {
    "text": "Colville",
    "value": "colville"
  },
  {
    "text": "Colwich",
    "value": "colwich"
  },
  {
    "text": "Comanche",
    "value": "comanche"
  },
  {
    "text": "Combine",
    "value": "combine"
  },
  {
    "text": "Combined Locks",
    "value": "combined locks"
  },
  {
    "text": "Combs",
    "value": "combs"
  },
  {
    "text": "Comer",
    "value": "comer"
  },
  {
    "text": "Comfort",
    "value": "comfort"
  },
  {
    "text": "Comfrey",
    "value": "comfrey"
  },
  {
    "text": "Comins",
    "value": "comins"
  },
  {
    "text": "Commack",
    "value": "commack"
  },
  {
    "text": "Commerce",
    "value": "commerce"
  },
  {
    "text": "Commerce City",
    "value": "commerce city"
  },
  {
    "text": "Commercial Point",
    "value": "commercial point"
  },
  {
    "text": "Commiskey",
    "value": "commiskey"
  },
  {
    "text": "Commodore",
    "value": "commodore"
  },
  {
    "text": "Como",
    "value": "como"
  },
  {
    "text": "Comptche",
    "value": "comptche"
  },
  {
    "text": "Compton",
    "value": "compton"
  },
  {
    "text": "Comstock",
    "value": "comstock"
  },
  {
    "text": "Comstock Northwest",
    "value": "comstock northwest"
  },
  {
    "text": "Comstock Park",
    "value": "comstock park"
  },
  {
    "text": "Conashaugh Lakes",
    "value": "conashaugh lakes"
  },
  {
    "text": "Concan",
    "value": "concan"
  },
  {
    "text": "Conception",
    "value": "conception"
  },
  {
    "text": "Conception Junction",
    "value": "conception junction"
  },
  {
    "text": "Conchas",
    "value": "conchas"
  },
  {
    "text": "Concho",
    "value": "concho"
  },
  {
    "text": "Conconully",
    "value": "conconully"
  },
  {
    "text": "Concord",
    "value": "concord"
  },
  {
    "text": "Concordia",
    "value": "concordia"
  },
  {
    "text": "Concordville",
    "value": "concordville"
  },
  {
    "text": "Concrete",
    "value": "concrete"
  },
  {
    "text": "Conde",
    "value": "conde"
  },
  {
    "text": "Condon",
    "value": "condon"
  },
  {
    "text": "Conehatta",
    "value": "conehatta"
  },
  {
    "text": "Conejos",
    "value": "conejos"
  },
  {
    "text": "Conemaugh",
    "value": "conemaugh"
  },
  {
    "text": "Conestee",
    "value": "conestee"
  },
  {
    "text": "Conestoga",
    "value": "conestoga"
  },
  {
    "text": "Conesus",
    "value": "conesus"
  },
  {
    "text": "Conesville",
    "value": "conesville"
  },
  {
    "text": "Conetoe",
    "value": "conetoe"
  },
  {
    "text": "Conewango Valley",
    "value": "conewango valley"
  },
  {
    "text": "Confluence",
    "value": "confluence"
  },
  {
    "text": "Conger",
    "value": "conger"
  },
  {
    "text": "Congers",
    "value": "congers"
  },
  {
    "text": "Congerville",
    "value": "congerville"
  },
  {
    "text": "Congress",
    "value": "congress"
  },
  {
    "text": "Conifer",
    "value": "conifer"
  },
  {
    "text": "Conklin",
    "value": "conklin"
  },
  {
    "text": "Conley",
    "value": "conley"
  },
  {
    "text": "Conneaut",
    "value": "conneaut"
  },
  {
    "text": "Conneaut Lake",
    "value": "conneaut lake"
  },
  {
    "text": "Conneautville",
    "value": "conneautville"
  },
  {
    "text": "Connell",
    "value": "connell"
  },
  {
    "text": "Connellsville",
    "value": "connellsville"
  },
  {
    "text": "Connelly",
    "value": "connelly"
  },
  {
    "text": "Connelly Springs",
    "value": "connelly springs"
  },
  {
    "text": "Conner",
    "value": "conner"
  },
  {
    "text": "Connersville",
    "value": "connersville"
  },
  {
    "text": "Connerville",
    "value": "connerville"
  },
  {
    "text": "Conover",
    "value": "conover"
  },
  {
    "text": "Conowingo",
    "value": "conowingo"
  },
  {
    "text": "Conrad",
    "value": "conrad"
  },
  {
    "text": "Conrath",
    "value": "conrath"
  },
  {
    "text": "Conroe",
    "value": "conroe"
  },
  {
    "text": "Conroy",
    "value": "conroy"
  },
  {
    "text": "Conshohocken",
    "value": "conshohocken"
  },
  {
    "text": "Constable",
    "value": "constable"
  },
  {
    "text": "Constableville",
    "value": "constableville"
  },
  {
    "text": "Constantia",
    "value": "constantia"
  },
  {
    "text": "Constantine",
    "value": "constantine"
  },
  {
    "text": "Continental",
    "value": "continental"
  },
  {
    "text": "Continental Divide",
    "value": "continental divide"
  },
  {
    "text": "Contoocook",
    "value": "contoocook"
  },
  {
    "text": "Convent",
    "value": "convent"
  },
  {
    "text": "Converse",
    "value": "converse"
  },
  {
    "text": "Convoy",
    "value": "convoy"
  },
  {
    "text": "Conway",
    "value": "conway"
  },
  {
    "text": "Conway Springs",
    "value": "conway springs"
  },
  {
    "text": "Conyers",
    "value": "conyers"
  },
  {
    "text": "Conyngham",
    "value": "conyngham"
  },
  {
    "text": "Cook",
    "value": "cook"
  },
  {
    "text": "Cooke City",
    "value": "cooke city"
  },
  {
    "text": "Cookeville",
    "value": "cookeville"
  },
  {
    "text": "Cooks",
    "value": "cooks"
  },
  {
    "text": "Cooks Springs",
    "value": "cooks springs"
  },
  {
    "text": "Cooksburg",
    "value": "cooksburg"
  },
  {
    "text": "Cookson",
    "value": "cookson"
  },
  {
    "text": "Cookstown",
    "value": "cookstown"
  },
  {
    "text": "Cooksville",
    "value": "cooksville"
  },
  {
    "text": "Cookville",
    "value": "cookville"
  },
  {
    "text": "Cool",
    "value": "cool"
  },
  {
    "text": "Cool Ridge",
    "value": "cool ridge"
  },
  {
    "text": "Cool Valley",
    "value": "cool valley"
  },
  {
    "text": "Cooleemee",
    "value": "cooleemee"
  },
  {
    "text": "Coolidge",
    "value": "coolidge"
  },
  {
    "text": "Coolin",
    "value": "coolin"
  },
  {
    "text": "Coolspring",
    "value": "coolspring"
  },
  {
    "text": "Coolville",
    "value": "coolville"
  },
  {
    "text": "Coon Rapids",
    "value": "coon rapids"
  },
  {
    "text": "Coon Valley",
    "value": "coon valley"
  },
  {
    "text": "Cooper",
    "value": "cooper"
  },
  {
    "text": "Cooper City",
    "value": "cooper city"
  },
  {
    "text": "Cooper Landing",
    "value": "cooper landing"
  },
  {
    "text": "Coopersburg",
    "value": "coopersburg"
  },
  {
    "text": "Cooperstown",
    "value": "cooperstown"
  },
  {
    "text": "Coopersville",
    "value": "coopersville"
  },
  {
    "text": "Coopertown",
    "value": "coopertown"
  },
  {
    "text": "Coos Bay",
    "value": "coos bay"
  },
  {
    "text": "Coosada",
    "value": "coosada"
  },
  {
    "text": "Coosawhatchie",
    "value": "coosawhatchie"
  },
  {
    "text": "Cooter",
    "value": "cooter"
  },
  {
    "text": "Copake",
    "value": "copake"
  },
  {
    "text": "Copake Falls",
    "value": "copake falls"
  },
  {
    "text": "Copalis Beach",
    "value": "copalis beach"
  },
  {
    "text": "Copalis Crossing",
    "value": "copalis crossing"
  },
  {
    "text": "Copan",
    "value": "copan"
  },
  {
    "text": "Cope",
    "value": "cope"
  },
  {
    "text": "Copeland",
    "value": "copeland"
  },
  {
    "text": "Copemish",
    "value": "copemish"
  },
  {
    "text": "Copenhagen",
    "value": "copenhagen"
  },
  {
    "text": "Copiague",
    "value": "copiague"
  },
  {
    "text": "Coplay",
    "value": "coplay"
  },
  {
    "text": "Copley",
    "value": "copley"
  },
  {
    "text": "Coppell",
    "value": "coppell"
  },
  {
    "text": "Copper Canyon",
    "value": "copper canyon"
  },
  {
    "text": "Copper Center",
    "value": "copper center"
  },
  {
    "text": "Copper Harbor",
    "value": "copper harbor"
  },
  {
    "text": "Copper Hill",
    "value": "copper hill"
  },
  {
    "text": "Copperas Cove",
    "value": "copperas cove"
  },
  {
    "text": "Copperhill",
    "value": "copperhill"
  },
  {
    "text": "Copperopolis",
    "value": "copperopolis"
  },
  {
    "text": "Coquille",
    "value": "coquille"
  },
  {
    "text": "Cora",
    "value": "cora"
  },
  {
    "text": "Coral",
    "value": "coral"
  },
  {
    "text": "Coral Gables",
    "value": "coral gables"
  },
  {
    "text": "Coral Springs",
    "value": "coral springs"
  },
  {
    "text": "Coralville",
    "value": "coralville"
  },
  {
    "text": "Coram",
    "value": "coram"
  },
  {
    "text": "Coraopolis",
    "value": "coraopolis"
  },
  {
    "text": "Corapeake",
    "value": "corapeake"
  },
  {
    "text": "Corbett",
    "value": "corbett"
  },
  {
    "text": "Corbin",
    "value": "corbin"
  },
  {
    "text": "Corbin City",
    "value": "corbin city"
  },
  {
    "text": "Corcoran",
    "value": "corcoran"
  },
  {
    "text": "Cord",
    "value": "cord"
  },
  {
    "text": "Cordele",
    "value": "cordele"
  },
  {
    "text": "Cordell",
    "value": "cordell"
  },
  {
    "text": "Corder",
    "value": "corder"
  },
  {
    "text": "Cordova",
    "value": "cordova"
  },
  {
    "text": "Core",
    "value": "core"
  },
  {
    "text": "Corfu",
    "value": "corfu"
  },
  {
    "text": "Corinna",
    "value": "corinna"
  },
  {
    "text": "Corinne",
    "value": "corinne"
  },
  {
    "text": "Corinth",
    "value": "corinth"
  },
  {
    "text": "Corn",
    "value": "corn"
  },
  {
    "text": "Cornelia",
    "value": "cornelia"
  },
  {
    "text": "Cornelius",
    "value": "cornelius"
  },
  {
    "text": "Cornell",
    "value": "cornell"
  },
  {
    "text": "Cornersville",
    "value": "cornersville"
  },
  {
    "text": "Cornettsville",
    "value": "cornettsville"
  },
  {
    "text": "Corning",
    "value": "corning"
  },
  {
    "text": "Cornish",
    "value": "cornish"
  },
  {
    "text": "Cornish Flat",
    "value": "cornish flat"
  },
  {
    "text": "Cornucopia",
    "value": "cornucopia"
  },
  {
    "text": "Cornville",
    "value": "cornville"
  },
  {
    "text": "Cornwall",
    "value": "cornwall"
  },
  {
    "text": "Cornwall Bridge",
    "value": "cornwall bridge"
  },
  {
    "text": "Cornwall-on-Hudson",
    "value": "cornwall-on-hudson"
  },
  {
    "text": "Cornwallville",
    "value": "cornwallville"
  },
  {
    "text": "Cornwells Heights",
    "value": "cornwells heights"
  },
  {
    "text": "Corolla",
    "value": "corolla"
  },
  {
    "text": "Corona",
    "value": "corona"
  },
  {
    "text": "Corona Del Mar",
    "value": "corona del mar"
  },
  {
    "text": "Corona del Mar",
    "value": "corona del mar"
  },
  {
    "text": "Coronado",
    "value": "coronado"
  },
  {
    "text": "Corpus Christi",
    "value": "corpus christi"
  },
  {
    "text": "Corral",
    "value": "corral"
  },
  {
    "text": "Corral de Tierra",
    "value": "corral de tierra"
  },
  {
    "text": "Corrales",
    "value": "corrales"
  },
  {
    "text": "Corralitos",
    "value": "corralitos"
  },
  {
    "text": "Correctionville",
    "value": "correctionville"
  },
  {
    "text": "Correll",
    "value": "correll"
  },
  {
    "text": "Corrigan",
    "value": "corrigan"
  },
  {
    "text": "Corry",
    "value": "corry"
  },
  {
    "text": "Corryton",
    "value": "corryton"
  },
  {
    "text": "Corsica",
    "value": "corsica"
  },
  {
    "text": "Corsicana",
    "value": "corsicana"
  },
  {
    "text": "Cortaro",
    "value": "cortaro"
  },
  {
    "text": "Corte Madera",
    "value": "corte madera"
  },
  {
    "text": "Cortez",
    "value": "cortez"
  },
  {
    "text": "Cortland",
    "value": "cortland"
  },
  {
    "text": "Cortlandt Manor",
    "value": "cortlandt manor"
  },
  {
    "text": "Corunna",
    "value": "corunna"
  },
  {
    "text": "Corvallis",
    "value": "corvallis"
  },
  {
    "text": "Cory",
    "value": "cory"
  },
  {
    "text": "Corydon",
    "value": "corydon"
  },
  {
    "text": "Cos Cob",
    "value": "cos cob"
  },
  {
    "text": "Cosby",
    "value": "cosby"
  },
  {
    "text": "Coshocton",
    "value": "coshocton"
  },
  {
    "text": "Cosmopolis",
    "value": "cosmopolis"
  },
  {
    "text": "Cosmos",
    "value": "cosmos"
  },
  {
    "text": "Cossayuna",
    "value": "cossayuna"
  },
  {
    "text": "Cost",
    "value": "cost"
  },
  {
    "text": "Costa",
    "value": "costa"
  },
  {
    "text": "Costa Mesa",
    "value": "costa mesa"
  },
  {
    "text": "Cotati",
    "value": "cotati"
  },
  {
    "text": "Coto De Caza",
    "value": "coto de caza"
  },
  {
    "text": "Cotopaxi",
    "value": "cotopaxi"
  },
  {
    "text": "Cottage Grove",
    "value": "cottage grove"
  },
  {
    "text": "Cottage Hills",
    "value": "cottage hills"
  },
  {
    "text": "Cottageville",
    "value": "cottageville"
  },
  {
    "text": "Cottekill",
    "value": "cottekill"
  },
  {
    "text": "Cotter",
    "value": "cotter"
  },
  {
    "text": "Cottleville",
    "value": "cottleville"
  },
  {
    "text": "Cotton",
    "value": "cotton"
  },
  {
    "text": "Cotton Plant",
    "value": "cotton plant"
  },
  {
    "text": "Cotton Valley",
    "value": "cotton valley"
  },
  {
    "text": "Cottondale",
    "value": "cottondale"
  },
  {
    "text": "Cottonport",
    "value": "cottonport"
  },
  {
    "text": "Cottontown",
    "value": "cottontown"
  },
  {
    "text": "Cottonwood",
    "value": "cottonwood"
  },
  {
    "text": "Cottonwood Falls",
    "value": "cottonwood falls"
  },
  {
    "text": "Cottonwood Heights",
    "value": "cottonwood heights"
  },
  {
    "text": "Cottonwood Shores",
    "value": "cottonwood shores"
  },
  {
    "text": "Cotuit",
    "value": "cotuit"
  },
  {
    "text": "Cotulla",
    "value": "cotulla"
  },
  {
    "text": "Couch",
    "value": "couch"
  },
  {
    "text": "Couderay",
    "value": "couderay"
  },
  {
    "text": "Coudersport",
    "value": "coudersport"
  },
  {
    "text": "Cougar",
    "value": "cougar"
  },
  {
    "text": "Coulee City",
    "value": "coulee city"
  },
  {
    "text": "Coulee Dam",
    "value": "coulee dam"
  },
  {
    "text": "Coulter",
    "value": "coulter"
  },
  {
    "text": "Coulterville",
    "value": "coulterville"
  },
  {
    "text": "Counce",
    "value": "counce"
  },
  {
    "text": "Council",
    "value": "council"
  },
  {
    "text": "Council Bluffs",
    "value": "council bluffs"
  },
  {
    "text": "Council Grove",
    "value": "council grove"
  },
  {
    "text": "Council Hill",
    "value": "council hill"
  },
  {
    "text": "Counselor",
    "value": "counselor"
  },
  {
    "text": "Country Club",
    "value": "country club"
  },
  {
    "text": "Country Club Estates",
    "value": "country club estates"
  },
  {
    "text": "Country Club Hills",
    "value": "country club hills"
  },
  {
    "text": "Countryside",
    "value": "countryside"
  },
  {
    "text": "Countyline",
    "value": "countyline"
  },
  {
    "text": "Coupeville",
    "value": "coupeville"
  },
  {
    "text": "Coupland",
    "value": "coupland"
  },
  {
    "text": "Courtenay",
    "value": "courtenay"
  },
  {
    "text": "Courtland",
    "value": "courtland"
  },
  {
    "text": "Coushatta",
    "value": "coushatta"
  },
  {
    "text": "Cove",
    "value": "cove"
  },
  {
    "text": "Cove City",
    "value": "cove city"
  },
  {
    "text": "Cove Creek",
    "value": "cove creek"
  },
  {
    "text": "Covelo",
    "value": "covelo"
  },
  {
    "text": "Coventry",
    "value": "coventry"
  },
  {
    "text": "Covert",
    "value": "covert"
  },
  {
    "text": "Covesville",
    "value": "covesville"
  },
  {
    "text": "Covina",
    "value": "covina"
  },
  {
    "text": "Covington",
    "value": "covington"
  },
  {
    "text": "Cowan",
    "value": "cowan"
  },
  {
    "text": "Cowansville",
    "value": "cowansville"
  },
  {
    "text": "Coward",
    "value": "coward"
  },
  {
    "text": "Cowarts",
    "value": "cowarts"
  },
  {
    "text": "Cowden",
    "value": "cowden"
  },
  {
    "text": "Cowen",
    "value": "cowen"
  },
  {
    "text": "Coweta",
    "value": "coweta"
  },
  {
    "text": "Cowgill",
    "value": "cowgill"
  },
  {
    "text": "Cowiche",
    "value": "cowiche"
  },
  {
    "text": "Cowlesville",
    "value": "cowlesville"
  },
  {
    "text": "Cowley",
    "value": "cowley"
  },
  {
    "text": "Cowpens",
    "value": "cowpens"
  },
  {
    "text": "Coxs Creek",
    "value": "coxs creek"
  },
  {
    "text": "Coxs Mills",
    "value": "coxs mills"
  },
  {
    "text": "Coxsackie",
    "value": "coxsackie"
  },
  {
    "text": "Coy",
    "value": "coy"
  },
  {
    "text": "Coyanosa",
    "value": "coyanosa"
  },
  {
    "text": "Coyle",
    "value": "coyle"
  },
  {
    "text": "Coyote",
    "value": "coyote"
  },
  {
    "text": "Cozad",
    "value": "cozad"
  },
  {
    "text": "Crab Orchard",
    "value": "crab orchard"
  },
  {
    "text": "Crabtree",
    "value": "crabtree"
  },
  {
    "text": "Crafton",
    "value": "crafton"
  },
  {
    "text": "Craftsbury",
    "value": "craftsbury"
  },
  {
    "text": "Craftsbury Common",
    "value": "craftsbury common"
  },
  {
    "text": "Cragford",
    "value": "cragford"
  },
  {
    "text": "Cragsmoor",
    "value": "cragsmoor"
  },
  {
    "text": "Craig",
    "value": "craig"
  },
  {
    "text": "Craigmont",
    "value": "craigmont"
  },
  {
    "text": "Craigsville",
    "value": "craigsville"
  },
  {
    "text": "Craigville",
    "value": "craigville"
  },
  {
    "text": "Crainville",
    "value": "crainville"
  },
  {
    "text": "Cramerton",
    "value": "cramerton"
  },
  {
    "text": "Cranberry",
    "value": "cranberry"
  },
  {
    "text": "Cranberry Isles",
    "value": "cranberry isles"
  },
  {
    "text": "Cranberry Township",
    "value": "cranberry township"
  },
  {
    "text": "Cranbury",
    "value": "cranbury"
  },
  {
    "text": "Crandall",
    "value": "crandall"
  },
  {
    "text": "Crandon",
    "value": "crandon"
  },
  {
    "text": "Crane",
    "value": "crane"
  },
  {
    "text": "Crane Hill",
    "value": "crane hill"
  },
  {
    "text": "Crane Lake",
    "value": "crane lake"
  },
  {
    "text": "Cranesville",
    "value": "cranesville"
  },
  {
    "text": "Cranfills Gap",
    "value": "cranfills gap"
  },
  {
    "text": "Cranford",
    "value": "cranford"
  },
  {
    "text": "Cranks",
    "value": "cranks"
  },
  {
    "text": "Cranston",
    "value": "cranston"
  },
  {
    "text": "Crary",
    "value": "crary"
  },
  {
    "text": "Craryville",
    "value": "craryville"
  },
  {
    "text": "Crater Lake",
    "value": "crater lake"
  },
  {
    "text": "Crawford",
    "value": "crawford"
  },
  {
    "text": "Crawfordsville",
    "value": "crawfordsville"
  },
  {
    "text": "Crawfordville",
    "value": "crawfordville"
  },
  {
    "text": "Crawley",
    "value": "crawley"
  },
  {
    "text": "Crayne",
    "value": "crayne"
  },
  {
    "text": "Creal Springs",
    "value": "creal springs"
  },
  {
    "text": "Cream Ridge",
    "value": "cream ridge"
  },
  {
    "text": "Creede",
    "value": "creede"
  },
  {
    "text": "Creedmoor",
    "value": "creedmoor"
  },
  {
    "text": "Creekside",
    "value": "creekside"
  },
  {
    "text": "Creighton",
    "value": "creighton"
  },
  {
    "text": "Crenshaw",
    "value": "crenshaw"
  },
  {
    "text": "Creola",
    "value": "creola"
  },
  {
    "text": "Cresaptown",
    "value": "cresaptown"
  },
  {
    "text": "Cresbard",
    "value": "cresbard"
  },
  {
    "text": "Crescent",
    "value": "crescent"
  },
  {
    "text": "Crescent City",
    "value": "crescent city"
  },
  {
    "text": "Crescent Springs",
    "value": "crescent springs"
  },
  {
    "text": "Crescent Valley",
    "value": "crescent valley"
  },
  {
    "text": "Cresco",
    "value": "cresco"
  },
  {
    "text": "Cressey",
    "value": "cressey"
  },
  {
    "text": "Cresskill",
    "value": "cresskill"
  },
  {
    "text": "Cresson",
    "value": "cresson"
  },
  {
    "text": "Cressona",
    "value": "cressona"
  },
  {
    "text": "Crest Hill",
    "value": "crest hill"
  },
  {
    "text": "Crest Park",
    "value": "crest park"
  },
  {
    "text": "Crested Butte",
    "value": "crested butte"
  },
  {
    "text": "Crestline",
    "value": "crestline"
  },
  {
    "text": "Creston",
    "value": "creston"
  },
  {
    "text": "Crestone",
    "value": "crestone"
  },
  {
    "text": "Crestview",
    "value": "crestview"
  },
  {
    "text": "Crestview Hills",
    "value": "crestview hills"
  },
  {
    "text": "Crestwood",
    "value": "crestwood"
  },
  {
    "text": "Crestwood Village",
    "value": "crestwood village"
  },
  {
    "text": "Creswell",
    "value": "creswell"
  },
  {
    "text": "Crete",
    "value": "crete"
  },
  {
    "text": "Creve Coeur",
    "value": "creve coeur"
  },
  {
    "text": "Crewe",
    "value": "crewe"
  },
  {
    "text": "Cridersville",
    "value": "cridersville"
  },
  {
    "text": "Crimora",
    "value": "crimora"
  },
  {
    "text": "Cripple Creek",
    "value": "cripple creek"
  },
  {
    "text": "Crisfield",
    "value": "crisfield"
  },
  {
    "text": "Crittenden",
    "value": "crittenden"
  },
  {
    "text": "Critz",
    "value": "critz"
  },
  {
    "text": "Crivitz",
    "value": "crivitz"
  },
  {
    "text": "Crocker",
    "value": "crocker"
  },
  {
    "text": "Crockett",
    "value": "crockett"
  },
  {
    "text": "Crofton",
    "value": "crofton"
  },
  {
    "text": "Croghan",
    "value": "croghan"
  },
  {
    "text": "Cromona",
    "value": "cromona"
  },
  {
    "text": "Crompond",
    "value": "crompond"
  },
  {
    "text": "Cromwell",
    "value": "cromwell"
  },
  {
    "text": "Crook",
    "value": "crook"
  },
  {
    "text": "Crooks",
    "value": "crooks"
  },
  {
    "text": "Crookston",
    "value": "crookston"
  },
  {
    "text": "Crooksville",
    "value": "crooksville"
  },
  {
    "text": "Cropsey",
    "value": "cropsey"
  },
  {
    "text": "Cropseyville",
    "value": "cropseyville"
  },
  {
    "text": "Cropwell",
    "value": "cropwell"
  },
  {
    "text": "Crosby",
    "value": "crosby"
  },
  {
    "text": "Crosbyton",
    "value": "crosbyton"
  },
  {
    "text": "Cross",
    "value": "cross"
  },
  {
    "text": "Cross City",
    "value": "cross city"
  },
  {
    "text": "Cross Fork",
    "value": "cross fork"
  },
  {
    "text": "Cross Hill",
    "value": "cross hill"
  },
  {
    "text": "Cross Junction",
    "value": "cross junction"
  },
  {
    "text": "Cross Lake",
    "value": "cross lake"
  },
  {
    "text": "Cross Lanes",
    "value": "cross lanes"
  },
  {
    "text": "Cross Plains",
    "value": "cross plains"
  },
  {
    "text": "Cross River",
    "value": "cross river"
  },
  {
    "text": "Cross Roads",
    "value": "cross roads"
  },
  {
    "text": "Cross Timbers",
    "value": "cross timbers"
  },
  {
    "text": "Crossett",
    "value": "crossett"
  },
  {
    "text": "Crossnore",
    "value": "crossnore"
  },
  {
    "text": "Crossroads",
    "value": "crossroads"
  },
  {
    "text": "Crossville",
    "value": "crossville"
  },
  {
    "text": "Croswell",
    "value": "croswell"
  },
  {
    "text": "Crothersville",
    "value": "crothersville"
  },
  {
    "text": "Croton",
    "value": "croton"
  },
  {
    "text": "Croton Falls",
    "value": "croton falls"
  },
  {
    "text": "Croton-on-Hudson",
    "value": "croton-on-hudson"
  },
  {
    "text": "Crouse",
    "value": "crouse"
  },
  {
    "text": "Crow Agency",
    "value": "crow agency"
  },
  {
    "text": "Crowder",
    "value": "crowder"
  },
  {
    "text": "Crowell",
    "value": "crowell"
  },
  {
    "text": "Crowley",
    "value": "crowley"
  },
  {
    "text": "Crown",
    "value": "crown"
  },
  {
    "text": "Crown City",
    "value": "crown city"
  },
  {
    "text": "Crown Heights",
    "value": "crown heights"
  },
  {
    "text": "Crown King",
    "value": "crown king"
  },
  {
    "text": "Crown Point",
    "value": "crown point"
  },
  {
    "text": "Crownpoint",
    "value": "crownpoint"
  },
  {
    "text": "Crownsville",
    "value": "crownsville"
  },
  {
    "text": "Crows Landing",
    "value": "crows landing"
  },
  {
    "text": "Crowville",
    "value": "crowville"
  },
  {
    "text": "Croydon",
    "value": "croydon"
  },
  {
    "text": "Crozet",
    "value": "crozet"
  },
  {
    "text": "Crozier",
    "value": "crozier"
  },
  {
    "text": "Crucible",
    "value": "crucible"
  },
  {
    "text": "Cruger",
    "value": "cruger"
  },
  {
    "text": "Crugers",
    "value": "crugers"
  },
  {
    "text": "Crum",
    "value": "crum"
  },
  {
    "text": "Crum Lynne",
    "value": "crum lynne"
  },
  {
    "text": "Crump",
    "value": "crump"
  },
  {
    "text": "Crumpler",
    "value": "crumpler"
  },
  {
    "text": "Crumpton",
    "value": "crumpton"
  },
  {
    "text": "Crystal",
    "value": "crystal"
  },
  {
    "text": "Crystal Bay",
    "value": "crystal bay"
  },
  {
    "text": "Crystal Beach",
    "value": "crystal beach"
  },
  {
    "text": "Crystal City",
    "value": "crystal city"
  },
  {
    "text": "Crystal Falls",
    "value": "crystal falls"
  },
  {
    "text": "Crystal Hill",
    "value": "crystal hill"
  },
  {
    "text": "Crystal Lake",
    "value": "crystal lake"
  },
  {
    "text": "Crystal River",
    "value": "crystal river"
  },
  {
    "text": "Crystal Spring",
    "value": "crystal spring"
  },
  {
    "text": "Crystal Springs",
    "value": "crystal springs"
  },
  {
    "text": "Cub Run",
    "value": "cub run"
  },
  {
    "text": "Cuba",
    "value": "cuba"
  },
  {
    "text": "Cuba City",
    "value": "cuba city"
  },
  {
    "text": "Cubero",
    "value": "cubero"
  },
  {
    "text": "Cudahy",
    "value": "cudahy"
  },
  {
    "text": "Cuddebackville",
    "value": "cuddebackville"
  },
  {
    "text": "Cuddy",
    "value": "cuddy"
  },
  {
    "text": "Cudjoe Key",
    "value": "cudjoe key"
  },
  {
    "text": "Cuero",
    "value": "cuero"
  },
  {
    "text": "Culberson",
    "value": "culberson"
  },
  {
    "text": "Culbertson",
    "value": "culbertson"
  },
  {
    "text": "Culdesac",
    "value": "culdesac"
  },
  {
    "text": "Cullen",
    "value": "cullen"
  },
  {
    "text": "Culleoka",
    "value": "culleoka"
  },
  {
    "text": "Cullman",
    "value": "cullman"
  },
  {
    "text": "Culloden",
    "value": "culloden"
  },
  {
    "text": "Cullom",
    "value": "cullom"
  },
  {
    "text": "Cullowhee",
    "value": "cullowhee"
  },
  {
    "text": "Culpeper",
    "value": "culpeper"
  },
  {
    "text": "Culver",
    "value": "culver"
  },
  {
    "text": "Culver City",
    "value": "culver city"
  },
  {
    "text": "Cumberland",
    "value": "cumberland"
  },
  {
    "text": "Cumberland Center",
    "value": "cumberland center"
  },
  {
    "text": "Cumberland City",
    "value": "cumberland city"
  },
  {
    "text": "Cumberland Foreside",
    "value": "cumberland foreside"
  },
  {
    "text": "Cumberland Furnace",
    "value": "cumberland furnace"
  },
  {
    "text": "Cumberland Gap",
    "value": "cumberland gap"
  },
  {
    "text": "Cumbola",
    "value": "cumbola"
  },
  {
    "text": "Cumby",
    "value": "cumby"
  },
  {
    "text": "Cumming",
    "value": "cumming"
  },
  {
    "text": "Cummings",
    "value": "cummings"
  },
  {
    "text": "Cummington",
    "value": "cummington"
  },
  {
    "text": "Cuney",
    "value": "cuney"
  },
  {
    "text": "Cunningham",
    "value": "cunningham"
  },
  {
    "text": "Cupertino",
    "value": "cupertino"
  },
  {
    "text": "Curlew",
    "value": "curlew"
  },
  {
    "text": "Curran",
    "value": "curran"
  },
  {
    "text": "Currie",
    "value": "currie"
  },
  {
    "text": "Currituck",
    "value": "currituck"
  },
  {
    "text": "Curryville",
    "value": "curryville"
  },
  {
    "text": "Curtice",
    "value": "curtice"
  },
  {
    "text": "Curtis",
    "value": "curtis"
  },
  {
    "text": "Curtis Bay",
    "value": "curtis bay"
  },
  {
    "text": "Curtiss",
    "value": "curtiss"
  },
  {
    "text": "Curwensville",
    "value": "curwensville"
  },
  {
    "text": "Cushing",
    "value": "cushing"
  },
  {
    "text": "Cusick",
    "value": "cusick"
  },
  {
    "text": "Cusseta",
    "value": "cusseta"
  },
  {
    "text": "Custar",
    "value": "custar"
  },
  {
    "text": "Custer",
    "value": "custer"
  },
  {
    "text": "Custer City",
    "value": "custer city"
  },
  {
    "text": "Cut Bank",
    "value": "cut bank"
  },
  {
    "text": "Cut Off",
    "value": "cut off"
  },
  {
    "text": "Cutchogue",
    "value": "cutchogue"
  },
  {
    "text": "Cuthbert",
    "value": "cuthbert"
  },
  {
    "text": "Cutler",
    "value": "cutler"
  },
  {
    "text": "Cutler Bay",
    "value": "cutler bay"
  },
  {
    "text": "Cutler Ridge",
    "value": "cutler ridge"
  },
  {
    "text": "Cuttingsville",
    "value": "cuttingsville"
  },
  {
    "text": "Cuttyhunk",
    "value": "cuttyhunk"
  },
  {
    "text": "Cuyahoga Falls",
    "value": "cuyahoga falls"
  },
  {
    "text": "Cyclone",
    "value": "cyclone"
  },
  {
    "text": "Cygnet",
    "value": "cygnet"
  },
  {
    "text": "Cylinder",
    "value": "cylinder"
  },
  {
    "text": "Cynthiana",
    "value": "cynthiana"
  },
  {
    "text": "Cypress",
    "value": "cypress"
  },
  {
    "text": "Cypress Gardens",
    "value": "cypress gardens"
  },
  {
    "text": "Cypress Inn",
    "value": "cypress inn"
  },
  {
    "text": "Cypress Lake",
    "value": "cypress lake"
  },
  {
    "text": "Cypress Quarters",
    "value": "cypress quarters"
  },
  {
    "text": "Cyril",
    "value": "cyril"
  },
  {
    "text": "Cyrus",
    "value": "cyrus"
  },
  {
    "text": "D'Hanis",
    "value": "d'hanis"
  },
  {
    "text": "D'Iberville",
    "value": "d'iberville"
  },
  {
    "text": "D'Lo",
    "value": "d'lo"
  },
  {
    "text": "Dacoma",
    "value": "dacoma"
  },
  {
    "text": "Dacono",
    "value": "dacono"
  },
  {
    "text": "Dacula",
    "value": "dacula"
  },
  {
    "text": "Dade City",
    "value": "dade city"
  },
  {
    "text": "Dade City North",
    "value": "dade city north"
  },
  {
    "text": "Dadeville",
    "value": "dadeville"
  },
  {
    "text": "Dafter",
    "value": "dafter"
  },
  {
    "text": "Daggett",
    "value": "daggett"
  },
  {
    "text": "Dagmar",
    "value": "dagmar"
  },
  {
    "text": "Dagsboro",
    "value": "dagsboro"
  },
  {
    "text": "Dagus Mines",
    "value": "dagus mines"
  },
  {
    "text": "Dahinda",
    "value": "dahinda"
  },
  {
    "text": "Dahlen",
    "value": "dahlen"
  },
  {
    "text": "Dahlgren",
    "value": "dahlgren"
  },
  {
    "text": "Dahlonega",
    "value": "dahlonega"
  },
  {
    "text": "Daingerfield",
    "value": "daingerfield"
  },
  {
    "text": "Daisetta",
    "value": "daisetta"
  },
  {
    "text": "Daisy",
    "value": "daisy"
  },
  {
    "text": "Daisytown",
    "value": "daisytown"
  },
  {
    "text": "Dakota",
    "value": "dakota"
  },
  {
    "text": "Dakota City",
    "value": "dakota city"
  },
  {
    "text": "Dakota Dunes",
    "value": "dakota dunes"
  },
  {
    "text": "Dalbo",
    "value": "dalbo"
  },
  {
    "text": "Dale",
    "value": "dale"
  },
  {
    "text": "Dale City",
    "value": "dale city"
  },
  {
    "text": "Daleville",
    "value": "daleville"
  },
  {
    "text": "Dalhart",
    "value": "dalhart"
  },
  {
    "text": "Dallardsville",
    "value": "dallardsville"
  },
  {
    "text": "Dallas",
    "value": "dallas"
  },
  {
    "text": "Dallas Center",
    "value": "dallas center"
  },
  {
    "text": "Dallas City",
    "value": "dallas city"
  },
  {
    "text": "Dallastown",
    "value": "dallastown"
  },
  {
    "text": "Dallesport",
    "value": "dallesport"
  },
  {
    "text": "Dalmatia",
    "value": "dalmatia"
  },
  {
    "text": "Dalton",
    "value": "dalton"
  },
  {
    "text": "Dalton City",
    "value": "dalton city"
  },
  {
    "text": "Dalton Gardens",
    "value": "dalton gardens"
  },
  {
    "text": "Dalworthington Gardens",
    "value": "dalworthington gardens"
  },
  {
    "text": "Daly City",
    "value": "daly city"
  },
  {
    "text": "Dalzell",
    "value": "dalzell"
  },
  {
    "text": "Damar",
    "value": "damar"
  },
  {
    "text": "Damariscotta",
    "value": "damariscotta"
  },
  {
    "text": "Damascus",
    "value": "damascus"
  },
  {
    "text": "Dameron",
    "value": "dameron"
  },
  {
    "text": "Dammeron Valley",
    "value": "dammeron valley"
  },
  {
    "text": "Damon",
    "value": "damon"
  },
  {
    "text": "Dana",
    "value": "dana"
  },
  {
    "text": "Dana Point",
    "value": "dana point"
  },
  {
    "text": "Danboro",
    "value": "danboro"
  },
  {
    "text": "Danbury",
    "value": "danbury"
  },
  {
    "text": "Danby",
    "value": "danby"
  },
  {
    "text": "Dandridge",
    "value": "dandridge"
  },
  {
    "text": "Dane",
    "value": "dane"
  },
  {
    "text": "Danese",
    "value": "danese"
  },
  {
    "text": "Danevang",
    "value": "danevang"
  },
  {
    "text": "Danforth",
    "value": "danforth"
  },
  {
    "text": "Dania Beach",
    "value": "dania beach"
  },
  {
    "text": "Daniel",
    "value": "daniel"
  },
  {
    "text": "Daniels",
    "value": "daniels"
  },
  {
    "text": "Danielson",
    "value": "danielson"
  },
  {
    "text": "Danielsville",
    "value": "danielsville"
  },
  {
    "text": "Dannebrog",
    "value": "dannebrog"
  },
  {
    "text": "Dannemora",
    "value": "dannemora"
  },
  {
    "text": "Dansville",
    "value": "dansville"
  },
  {
    "text": "Dante",
    "value": "dante"
  },
  {
    "text": "Danube",
    "value": "danube"
  },
  {
    "text": "Danvers",
    "value": "danvers"
  },
  {
    "text": "Danville",
    "value": "danville"
  },
  {
    "text": "Daphne",
    "value": "daphne"
  },
  {
    "text": "Darby",
    "value": "darby"
  },
  {
    "text": "Dardanelle",
    "value": "dardanelle"
  },
  {
    "text": "Darden",
    "value": "darden"
  },
  {
    "text": "Dardenne",
    "value": "dardenne"
  },
  {
    "text": "Dardenne Prairie",
    "value": "dardenne prairie"
  },
  {
    "text": "Darfur",
    "value": "darfur"
  },
  {
    "text": "Darien",
    "value": "darien"
  },
  {
    "text": "Darien Center",
    "value": "darien center"
  },
  {
    "text": "Darling",
    "value": "darling"
  },
  {
    "text": "Darlington",
    "value": "darlington"
  },
  {
    "text": "Darmstadt",
    "value": "darmstadt"
  },
  {
    "text": "Darnestown",
    "value": "darnestown"
  },
  {
    "text": "Darrington",
    "value": "darrington"
  },
  {
    "text": "Darrouzett",
    "value": "darrouzett"
  },
  {
    "text": "Darrow",
    "value": "darrow"
  },
  {
    "text": "Dartmouth",
    "value": "dartmouth"
  },
  {
    "text": "Darwin",
    "value": "darwin"
  },
  {
    "text": "Dassel",
    "value": "dassel"
  },
  {
    "text": "Dateland",
    "value": "dateland"
  },
  {
    "text": "Datil",
    "value": "datil"
  },
  {
    "text": "Datto",
    "value": "datto"
  },
  {
    "text": "Daufuskie Landing",
    "value": "daufuskie landing"
  },
  {
    "text": "Dauphin",
    "value": "dauphin"
  },
  {
    "text": "Dauphin Island",
    "value": "dauphin island"
  },
  {
    "text": "Davenport",
    "value": "davenport"
  },
  {
    "text": "Davey",
    "value": "davey"
  },
  {
    "text": "David",
    "value": "david"
  },
  {
    "text": "David City",
    "value": "david city"
  },
  {
    "text": "Davidson",
    "value": "davidson"
  },
  {
    "text": "Davidsonville",
    "value": "davidsonville"
  },
  {
    "text": "Davidsville",
    "value": "davidsville"
  },
  {
    "text": "Davie",
    "value": "davie"
  },
  {
    "text": "Davilla",
    "value": "davilla"
  },
  {
    "text": "Davin",
    "value": "davin"
  },
  {
    "text": "Davis",
    "value": "davis"
  },
  {
    "text": "Davis City",
    "value": "davis city"
  },
  {
    "text": "Davis Creek",
    "value": "davis creek"
  },
  {
    "text": "Davis Junction",
    "value": "davis junction"
  },
  {
    "text": "Davisboro",
    "value": "davisboro"
  },
  {
    "text": "Davisburg",
    "value": "davisburg"
  },
  {
    "text": "Davison",
    "value": "davison"
  },
  {
    "text": "Daviston",
    "value": "daviston"
  },
  {
    "text": "Davisville",
    "value": "davisville"
  },
  {
    "text": "Dawn",
    "value": "dawn"
  },
  {
    "text": "Dawson",
    "value": "dawson"
  },
  {
    "text": "Dawson Springs",
    "value": "dawson springs"
  },
  {
    "text": "Dawsonville",
    "value": "dawsonville"
  },
  {
    "text": "Day",
    "value": "day"
  },
  {
    "text": "Day Heights",
    "value": "day heights"
  },
  {
    "text": "Dayhoit",
    "value": "dayhoit"
  },
  {
    "text": "Daykin",
    "value": "daykin"
  },
  {
    "text": "Days Creek",
    "value": "days creek"
  },
  {
    "text": "Dayton",
    "value": "dayton"
  },
  {
    "text": "Daytona Beach",
    "value": "daytona beach"
  },
  {
    "text": "Daytona Beach Shores",
    "value": "daytona beach shores"
  },
  {
    "text": "Dayville",
    "value": "dayville"
  },
  {
    "text": "Dazey",
    "value": "dazey"
  },
  {
    "text": "De Beque",
    "value": "de beque"
  },
  {
    "text": "De Berry",
    "value": "de berry"
  },
  {
    "text": "De Borgia",
    "value": "de borgia"
  },
  {
    "text": "De Forest",
    "value": "de forest"
  },
  {
    "text": "De Graff",
    "value": "de graff"
  },
  {
    "text": "De Kalb",
    "value": "de kalb"
  },
  {
    "text": "De Kalb Junction",
    "value": "de kalb junction"
  },
  {
    "text": "De Lancey",
    "value": "de lancey"
  },
  {
    "text": "De Land",
    "value": "de land"
  },
  {
    "text": "De Leon",
    "value": "de leon"
  },
  {
    "text": "De Leon Springs",
    "value": "de leon springs"
  },
  {
    "text": "De Pere",
    "value": "de pere"
  },
  {
    "text": "De Peyster",
    "value": "de peyster"
  },
  {
    "text": "De Queen",
    "value": "de queen"
  },
  {
    "text": "De Smet",
    "value": "de smet"
  },
  {
    "text": "De Soto",
    "value": "de soto"
  },
  {
    "text": "De Tour Village",
    "value": "de tour village"
  },
  {
    "text": "De Valls Bluff",
    "value": "de valls bluff"
  },
  {
    "text": "De Witt",
    "value": "de witt"
  },
  {
    "text": "DeBary",
    "value": "debary"
  },
  {
    "text": "DeCordova",
    "value": "decordova"
  },
  {
    "text": "DeFuniak Springs",
    "value": "defuniak springs"
  },
  {
    "text": "DeKalb",
    "value": "dekalb"
  },
  {
    "text": "DeLand",
    "value": "deland"
  },
  {
    "text": "DeMotte",
    "value": "demotte"
  },
  {
    "text": "DeQuincy",
    "value": "dequincy"
  },
  {
    "text": "DeRidder",
    "value": "deridder"
  },
  {
    "text": "DeRuyter",
    "value": "deruyter"
  },
  {
    "text": "DeSoto",
    "value": "desoto"
  },
  {
    "text": "DeWitt",
    "value": "dewitt"
  },
  {
    "text": "Deadwood",
    "value": "deadwood"
  },
  {
    "text": "Deal",
    "value": "deal"
  },
  {
    "text": "Deal Island",
    "value": "deal island"
  },
  {
    "text": "Deale",
    "value": "deale"
  },
  {
    "text": "Deane",
    "value": "deane"
  },
  {
    "text": "Deansboro",
    "value": "deansboro"
  },
  {
    "text": "Dearborn",
    "value": "dearborn"
  },
  {
    "text": "Dearborn Heights",
    "value": "dearborn heights"
  },
  {
    "text": "Dearing",
    "value": "dearing"
  },
  {
    "text": "Deary",
    "value": "deary"
  },
  {
    "text": "Death Valley",
    "value": "death valley"
  },
  {
    "text": "Deatsville",
    "value": "deatsville"
  },
  {
    "text": "Deaver",
    "value": "deaver"
  },
  {
    "text": "Debord",
    "value": "debord"
  },
  {
    "text": "Decatur",
    "value": "decatur"
  },
  {
    "text": "Decatur City",
    "value": "decatur city"
  },
  {
    "text": "Decaturville",
    "value": "decaturville"
  },
  {
    "text": "Decherd",
    "value": "decherd"
  },
  {
    "text": "Decker",
    "value": "decker"
  },
  {
    "text": "Deckerville",
    "value": "deckerville"
  },
  {
    "text": "Declo",
    "value": "declo"
  },
  {
    "text": "Decorah",
    "value": "decorah"
  },
  {
    "text": "Dedham",
    "value": "dedham"
  },
  {
    "text": "Deenwood",
    "value": "deenwood"
  },
  {
    "text": "Deep Gap",
    "value": "deep gap"
  },
  {
    "text": "Deep River",
    "value": "deep river"
  },
  {
    "text": "Deep Run",
    "value": "deep run"
  },
  {
    "text": "Deephaven",
    "value": "deephaven"
  },
  {
    "text": "Deepwater",
    "value": "deepwater"
  },
  {
    "text": "Deer",
    "value": "deer"
  },
  {
    "text": "Deer Creek",
    "value": "deer creek"
  },
  {
    "text": "Deer Grove",
    "value": "deer grove"
  },
  {
    "text": "Deer Harbor",
    "value": "deer harbor"
  },
  {
    "text": "Deer Island",
    "value": "deer island"
  },
  {
    "text": "Deer Isle",
    "value": "deer isle"
  },
  {
    "text": "Deer Lodge",
    "value": "deer lodge"
  },
  {
    "text": "Deer Park",
    "value": "deer park"
  },
  {
    "text": "Deer River",
    "value": "deer river"
  },
  {
    "text": "Deer Trail",
    "value": "deer trail"
  },
  {
    "text": "Deer Valley",
    "value": "deer valley"
  },
  {
    "text": "Deerbrook",
    "value": "deerbrook"
  },
  {
    "text": "Deerfield",
    "value": "deerfield"
  },
  {
    "text": "Deerfield Beach",
    "value": "deerfield beach"
  },
  {
    "text": "Deering",
    "value": "deering"
  },
  {
    "text": "Deersville",
    "value": "deersville"
  },
  {
    "text": "Deerwood",
    "value": "deerwood"
  },
  {
    "text": "Deeth",
    "value": "deeth"
  },
  {
    "text": "Deferiet",
    "value": "deferiet"
  },
  {
    "text": "Defiance",
    "value": "defiance"
  },
  {
    "text": "Deford",
    "value": "deford"
  },
  {
    "text": "Del Aire",
    "value": "del aire"
  },
  {
    "text": "Del City",
    "value": "del city"
  },
  {
    "text": "Del Mar",
    "value": "del mar"
  },
  {
    "text": "Del Norte",
    "value": "del norte"
  },
  {
    "text": "Del Rey",
    "value": "del rey"
  },
  {
    "text": "Del Rey Oaks",
    "value": "del rey oaks"
  },
  {
    "text": "Del Rio",
    "value": "del rio"
  },
  {
    "text": "Del Valle",
    "value": "del valle"
  },
  {
    "text": "Delafield",
    "value": "delafield"
  },
  {
    "text": "Delancey",
    "value": "delancey"
  },
  {
    "text": "Delanco",
    "value": "delanco"
  },
  {
    "text": "Delano",
    "value": "delano"
  },
  {
    "text": "Delanson",
    "value": "delanson"
  },
  {
    "text": "Delaplane",
    "value": "delaplane"
  },
  {
    "text": "Delavan",
    "value": "delavan"
  },
  {
    "text": "Delaware",
    "value": "delaware"
  },
  {
    "text": "Delaware City",
    "value": "delaware city"
  },
  {
    "text": "Delaware Water Gap",
    "value": "delaware water gap"
  },
  {
    "text": "Delbarton",
    "value": "delbarton"
  },
  {
    "text": "Delcambre",
    "value": "delcambre"
  },
  {
    "text": "Delco",
    "value": "delco"
  },
  {
    "text": "Delevan",
    "value": "delevan"
  },
  {
    "text": "Delhi",
    "value": "delhi"
  },
  {
    "text": "Delhi Hills",
    "value": "delhi hills"
  },
  {
    "text": "Delia",
    "value": "delia"
  },
  {
    "text": "Delight",
    "value": "delight"
  },
  {
    "text": "Dell",
    "value": "dell"
  },
  {
    "text": "Dell City",
    "value": "dell city"
  },
  {
    "text": "Dell Rapids",
    "value": "dell rapids"
  },
  {
    "text": "Dellrose",
    "value": "dellrose"
  },
  {
    "text": "Dellroy",
    "value": "dellroy"
  },
  {
    "text": "Dellslow",
    "value": "dellslow"
  },
  {
    "text": "Dellwood",
    "value": "dellwood"
  },
  {
    "text": "Delmar",
    "value": "delmar"
  },
  {
    "text": "Delmita",
    "value": "delmita"
  },
  {
    "text": "Delmont",
    "value": "delmont"
  },
  {
    "text": "Deloit",
    "value": "deloit"
  },
  {
    "text": "Delong",
    "value": "delong"
  },
  {
    "text": "Delorme",
    "value": "delorme"
  },
  {
    "text": "Delphi",
    "value": "delphi"
  },
  {
    "text": "Delphi Falls",
    "value": "delphi falls"
  },
  {
    "text": "Delphia",
    "value": "delphia"
  },
  {
    "text": "Delphos",
    "value": "delphos"
  },
  {
    "text": "Delray",
    "value": "delray"
  },
  {
    "text": "Delray Beach",
    "value": "delray beach"
  },
  {
    "text": "Delta",
    "value": "delta"
  },
  {
    "text": "Delta City",
    "value": "delta city"
  },
  {
    "text": "Delta Junction",
    "value": "delta junction"
  },
  {
    "text": "Deltaville",
    "value": "deltaville"
  },
  {
    "text": "Delton",
    "value": "delton"
  },
  {
    "text": "Deltona",
    "value": "deltona"
  },
  {
    "text": "Dema",
    "value": "dema"
  },
  {
    "text": "Demarest",
    "value": "demarest"
  },
  {
    "text": "Deming",
    "value": "deming"
  },
  {
    "text": "Demopolis",
    "value": "demopolis"
  },
  {
    "text": "Demorest",
    "value": "demorest"
  },
  {
    "text": "Denair",
    "value": "denair"
  },
  {
    "text": "Denali National Park",
    "value": "denali national park"
  },
  {
    "text": "Dendron",
    "value": "dendron"
  },
  {
    "text": "Denham Springs",
    "value": "denham springs"
  },
  {
    "text": "Denhoff",
    "value": "denhoff"
  },
  {
    "text": "Denison",
    "value": "denison"
  },
  {
    "text": "Denmark",
    "value": "denmark"
  },
  {
    "text": "Dennard",
    "value": "dennard"
  },
  {
    "text": "Dennehotso",
    "value": "dennehotso"
  },
  {
    "text": "Dennis",
    "value": "dennis"
  },
  {
    "text": "Dennis Port",
    "value": "dennis port"
  },
  {
    "text": "Dennison",
    "value": "dennison"
  },
  {
    "text": "Denniston",
    "value": "denniston"
  },
  {
    "text": "Dennisville",
    "value": "dennisville"
  },
  {
    "text": "Dennysville",
    "value": "dennysville"
  },
  {
    "text": "Dent",
    "value": "dent"
  },
  {
    "text": "Denton",
    "value": "denton"
  },
  {
    "text": "Dentsville",
    "value": "dentsville"
  },
  {
    "text": "Denver",
    "value": "denver"
  },
  {
    "text": "Denver City",
    "value": "denver city"
  },
  {
    "text": "Denville",
    "value": "denville"
  },
  {
    "text": "Depauville",
    "value": "depauville"
  },
  {
    "text": "Depauw",
    "value": "depauw"
  },
  {
    "text": "Depew",
    "value": "depew"
  },
  {
    "text": "Depoe Bay",
    "value": "depoe bay"
  },
  {
    "text": "Deport",
    "value": "deport"
  },
  {
    "text": "Deposit",
    "value": "deposit"
  },
  {
    "text": "Depue",
    "value": "depue"
  },
  {
    "text": "Deputy",
    "value": "deputy"
  },
  {
    "text": "Derby",
    "value": "derby"
  },
  {
    "text": "Derby Acres",
    "value": "derby acres"
  },
  {
    "text": "Derby Center",
    "value": "derby center"
  },
  {
    "text": "Derby Line",
    "value": "derby line"
  },
  {
    "text": "Derma",
    "value": "derma"
  },
  {
    "text": "Dermott",
    "value": "dermott"
  },
  {
    "text": "Derrick City",
    "value": "derrick city"
  },
  {
    "text": "Derry",
    "value": "derry"
  },
  {
    "text": "Derry Village",
    "value": "derry village"
  },
  {
    "text": "Derwood",
    "value": "derwood"
  },
  {
    "text": "Des Allemands",
    "value": "des allemands"
  },
  {
    "text": "Des Arc",
    "value": "des arc"
  },
  {
    "text": "Des Lacs",
    "value": "des lacs"
  },
  {
    "text": "Des Moines",
    "value": "des moines"
  },
  {
    "text": "Des Moines Township",
    "value": "des moines township"
  },
  {
    "text": "Des Peres",
    "value": "des peres"
  },
  {
    "text": "Des Plaines",
    "value": "des plaines"
  },
  {
    "text": "DesMoines",
    "value": "desmoines"
  },
  {
    "text": "Descanso",
    "value": "descanso"
  },
  {
    "text": "Desert Aire",
    "value": "desert aire"
  },
  {
    "text": "Desert Center",
    "value": "desert center"
  },
  {
    "text": "Desert Hills",
    "value": "desert hills"
  },
  {
    "text": "Desert Hot Springs",
    "value": "desert hot springs"
  },
  {
    "text": "Deshler",
    "value": "deshler"
  },
  {
    "text": "Desloge",
    "value": "desloge"
  },
  {
    "text": "Destin",
    "value": "destin"
  },
  {
    "text": "Destrehan",
    "value": "destrehan"
  },
  {
    "text": "Detroit",
    "value": "detroit"
  },
  {
    "text": "Detroit Beach",
    "value": "detroit beach"
  },
  {
    "text": "Detroit Harbor",
    "value": "detroit harbor"
  },
  {
    "text": "Detroit Lakes",
    "value": "detroit lakes"
  },
  {
    "text": "Devens",
    "value": "devens"
  },
  {
    "text": "Devers",
    "value": "devers"
  },
  {
    "text": "Deville",
    "value": "deville"
  },
  {
    "text": "Devils Elbow",
    "value": "devils elbow"
  },
  {
    "text": "Devils Lake",
    "value": "devils lake"
  },
  {
    "text": "Devils Tower",
    "value": "devils tower"
  },
  {
    "text": "Devine",
    "value": "devine"
  },
  {
    "text": "Devol",
    "value": "devol"
  },
  {
    "text": "Devola",
    "value": "devola"
  },
  {
    "text": "Devon",
    "value": "devon"
  },
  {
    "text": "Dewart",
    "value": "dewart"
  },
  {
    "text": "Dewey",
    "value": "dewey"
  },
  {
    "text": "Dewey-Humboldt",
    "value": "dewey-humboldt"
  },
  {
    "text": "Deweyville",
    "value": "deweyville"
  },
  {
    "text": "Dewitt",
    "value": "dewitt"
  },
  {
    "text": "Dewittville",
    "value": "dewittville"
  },
  {
    "text": "Dewy Rose",
    "value": "dewy rose"
  },
  {
    "text": "Dexter",
    "value": "dexter"
  },
  {
    "text": "Diablo",
    "value": "diablo"
  },
  {
    "text": "Diagonal",
    "value": "diagonal"
  },
  {
    "text": "Diamond",
    "value": "diamond"
  },
  {
    "text": "Diamond Bar",
    "value": "diamond bar"
  },
  {
    "text": "Diamond City",
    "value": "diamond city"
  },
  {
    "text": "Diamond Point",
    "value": "diamond point"
  },
  {
    "text": "Diamond Ridge",
    "value": "diamond ridge"
  },
  {
    "text": "Diamond Springs",
    "value": "diamond springs"
  },
  {
    "text": "Diamondhead",
    "value": "diamondhead"
  },
  {
    "text": "Diamondville",
    "value": "diamondville"
  },
  {
    "text": "Diana",
    "value": "diana"
  },
  {
    "text": "Diaz",
    "value": "diaz"
  },
  {
    "text": "Dibble",
    "value": "dibble"
  },
  {
    "text": "Diboll",
    "value": "diboll"
  },
  {
    "text": "Dice",
    "value": "dice"
  },
  {
    "text": "Dickens",
    "value": "dickens"
  },
  {
    "text": "Dickerson",
    "value": "dickerson"
  },
  {
    "text": "Dickey",
    "value": "dickey"
  },
  {
    "text": "Dickeyville",
    "value": "dickeyville"
  },
  {
    "text": "Dickinson",
    "value": "dickinson"
  },
  {
    "text": "Dickinson Center",
    "value": "dickinson center"
  },
  {
    "text": "Dickson",
    "value": "dickson"
  },
  {
    "text": "Dickson City",
    "value": "dickson city"
  },
  {
    "text": "Dierks",
    "value": "dierks"
  },
  {
    "text": "Dieterich",
    "value": "dieterich"
  },
  {
    "text": "Dietrich",
    "value": "dietrich"
  },
  {
    "text": "Diggs",
    "value": "diggs"
  },
  {
    "text": "Dighton",
    "value": "dighton"
  },
  {
    "text": "Dike",
    "value": "dike"
  },
  {
    "text": "Dilkon",
    "value": "dilkon"
  },
  {
    "text": "Dill City",
    "value": "dill city"
  },
  {
    "text": "Dillard",
    "value": "dillard"
  },
  {
    "text": "Dille",
    "value": "dille"
  },
  {
    "text": "Diller",
    "value": "diller"
  },
  {
    "text": "Dilley",
    "value": "dilley"
  },
  {
    "text": "Dilliner",
    "value": "dilliner"
  },
  {
    "text": "Dillingham",
    "value": "dillingham"
  },
  {
    "text": "Dillon",
    "value": "dillon"
  },
  {
    "text": "Dillon Beach",
    "value": "dillon beach"
  },
  {
    "text": "Dillonvale",
    "value": "dillonvale"
  },
  {
    "text": "Dillsboro",
    "value": "dillsboro"
  },
  {
    "text": "Dillsburg",
    "value": "dillsburg"
  },
  {
    "text": "Dilltown",
    "value": "dilltown"
  },
  {
    "text": "Dillwyn",
    "value": "dillwyn"
  },
  {
    "text": "Dilworth",
    "value": "dilworth"
  },
  {
    "text": "Dime Box",
    "value": "dime box"
  },
  {
    "text": "Dimmitt",
    "value": "dimmitt"
  },
  {
    "text": "Dimock",
    "value": "dimock"
  },
  {
    "text": "Dimondale",
    "value": "dimondale"
  },
  {
    "text": "Dingess",
    "value": "dingess"
  },
  {
    "text": "Dingmans Ferry",
    "value": "dingmans ferry"
  },
  {
    "text": "Dinosaur",
    "value": "dinosaur"
  },
  {
    "text": "Dinuba",
    "value": "dinuba"
  },
  {
    "text": "Dinwiddie",
    "value": "dinwiddie"
  },
  {
    "text": "Discovery Bay",
    "value": "discovery bay"
  },
  {
    "text": "Disney",
    "value": "disney"
  },
  {
    "text": "Disputanta",
    "value": "disputanta"
  },
  {
    "text": "Distant",
    "value": "distant"
  },
  {
    "text": "District Heights",
    "value": "district heights"
  },
  {
    "text": "Dittmer",
    "value": "dittmer"
  },
  {
    "text": "Divernon",
    "value": "divernon"
  },
  {
    "text": "Divide",
    "value": "divide"
  },
  {
    "text": "Dix",
    "value": "dix"
  },
  {
    "text": "Dix Hills",
    "value": "dix hills"
  },
  {
    "text": "Dixfield",
    "value": "dixfield"
  },
  {
    "text": "Dixie",
    "value": "dixie"
  },
  {
    "text": "Dixmont",
    "value": "dixmont"
  },
  {
    "text": "Dixmoor",
    "value": "dixmoor"
  },
  {
    "text": "Dixon",
    "value": "dixon"
  },
  {
    "text": "Dixon Lane-Meadow Creek",
    "value": "dixon lane-meadow creek"
  },
  {
    "text": "Dixon Springs",
    "value": "dixon springs"
  },
  {
    "text": "Dixons Mills",
    "value": "dixons mills"
  },
  {
    "text": "Dixonville",
    "value": "dixonville"
  },
  {
    "text": "Dobbins",
    "value": "dobbins"
  },
  {
    "text": "Dobbs Ferry",
    "value": "dobbs ferry"
  },
  {
    "text": "Dobson",
    "value": "dobson"
  },
  {
    "text": "Docena",
    "value": "docena"
  },
  {
    "text": "Dock Junction",
    "value": "dock junction"
  },
  {
    "text": "Doctor Phillips",
    "value": "doctor phillips"
  },
  {
    "text": "Dodd City",
    "value": "dodd city"
  },
  {
    "text": "Doddridge",
    "value": "doddridge"
  },
  {
    "text": "Doddsville",
    "value": "doddsville"
  },
  {
    "text": "Dodge",
    "value": "dodge"
  },
  {
    "text": "Dodge Center",
    "value": "dodge center"
  },
  {
    "text": "Dodge City",
    "value": "dodge city"
  },
  {
    "text": "Dodgeville",
    "value": "dodgeville"
  },
  {
    "text": "Dodson",
    "value": "dodson"
  },
  {
    "text": "Doe Run",
    "value": "doe run"
  },
  {
    "text": "Doerun",
    "value": "doerun"
  },
  {
    "text": "Doffing",
    "value": "doffing"
  },
  {
    "text": "Dola",
    "value": "dola"
  },
  {
    "text": "Dolan Springs",
    "value": "dolan springs"
  },
  {
    "text": "Doland",
    "value": "doland"
  },
  {
    "text": "Dolgeville",
    "value": "dolgeville"
  },
  {
    "text": "Dollar Bay",
    "value": "dollar bay"
  },
  {
    "text": "Dolliver",
    "value": "dolliver"
  },
  {
    "text": "Dolomite",
    "value": "dolomite"
  },
  {
    "text": "Dolores",
    "value": "dolores"
  },
  {
    "text": "Dolphin",
    "value": "dolphin"
  },
  {
    "text": "Dolton",
    "value": "dolton"
  },
  {
    "text": "Dona Ana",
    "value": "dona ana"
  },
  {
    "text": "Donahue",
    "value": "donahue"
  },
  {
    "text": "Donald",
    "value": "donald"
  },
  {
    "text": "Donalds",
    "value": "donalds"
  },
  {
    "text": "Donaldson",
    "value": "donaldson"
  },
  {
    "text": "Donaldsonville",
    "value": "donaldsonville"
  },
  {
    "text": "Donalsonville",
    "value": "donalsonville"
  },
  {
    "text": "Donegal",
    "value": "donegal"
  },
  {
    "text": "Dongola",
    "value": "dongola"
  },
  {
    "text": "Donie",
    "value": "donie"
  },
  {
    "text": "Doniphan",
    "value": "doniphan"
  },
  {
    "text": "Donna",
    "value": "donna"
  },
  {
    "text": "Donnellson",
    "value": "donnellson"
  },
  {
    "text": "Donnelly",
    "value": "donnelly"
  },
  {
    "text": "Donnelsville",
    "value": "donnelsville"
  },
  {
    "text": "Donner",
    "value": "donner"
  },
  {
    "text": "Donnybrook",
    "value": "donnybrook"
  },
  {
    "text": "Donora",
    "value": "donora"
  },
  {
    "text": "Donovan",
    "value": "donovan"
  },
  {
    "text": "Doolittle",
    "value": "doolittle"
  },
  {
    "text": "Doon",
    "value": "doon"
  },
  {
    "text": "Dora",
    "value": "dora"
  },
  {
    "text": "Doral",
    "value": "doral"
  },
  {
    "text": "Doraville",
    "value": "doraville"
  },
  {
    "text": "Dorchester",
    "value": "dorchester"
  },
  {
    "text": "Dorena",
    "value": "dorena"
  },
  {
    "text": "Dormont",
    "value": "dormont"
  },
  {
    "text": "Dornsife",
    "value": "dornsife"
  },
  {
    "text": "Dorothy",
    "value": "dorothy"
  },
  {
    "text": "Dorr",
    "value": "dorr"
  },
  {
    "text": "Dorrance",
    "value": "dorrance"
  },
  {
    "text": "Dorris",
    "value": "dorris"
  },
  {
    "text": "Dorset",
    "value": "dorset"
  },
  {
    "text": "Dorsey",
    "value": "dorsey"
  },
  {
    "text": "Dorton",
    "value": "dorton"
  },
  {
    "text": "Dos Palos",
    "value": "dos palos"
  },
  {
    "text": "Dos Rios",
    "value": "dos rios"
  },
  {
    "text": "Doss",
    "value": "doss"
  },
  {
    "text": "Doswell",
    "value": "doswell"
  },
  {
    "text": "Dothan",
    "value": "dothan"
  },
  {
    "text": "Doty",
    "value": "doty"
  },
  {
    "text": "Double Oak",
    "value": "double oak"
  },
  {
    "text": "Double Springs",
    "value": "double springs"
  },
  {
    "text": "Douds",
    "value": "douds"
  },
  {
    "text": "Dougherty",
    "value": "dougherty"
  },
  {
    "text": "Douglas",
    "value": "douglas"
  },
  {
    "text": "Douglas City",
    "value": "douglas city"
  },
  {
    "text": "Douglass",
    "value": "douglass"
  },
  {
    "text": "Douglass Hills",
    "value": "douglass hills"
  },
  {
    "text": "Douglassville",
    "value": "douglassville"
  },
  {
    "text": "Douglasville",
    "value": "douglasville"
  },
  {
    "text": "Dousman",
    "value": "dousman"
  },
  {
    "text": "Dove Creek",
    "value": "dove creek"
  },
  {
    "text": "Dove Valley",
    "value": "dove valley"
  },
  {
    "text": "Dover",
    "value": "dover"
  },
  {
    "text": "Dover Air Force Base",
    "value": "dover air force base"
  },
  {
    "text": "Dover Plains",
    "value": "dover plains"
  },
  {
    "text": "Dover-Foxcroft",
    "value": "dover-foxcroft"
  },
  {
    "text": "Dovray",
    "value": "dovray"
  },
  {
    "text": "Dow",
    "value": "dow"
  },
  {
    "text": "Dow City",
    "value": "dow city"
  },
  {
    "text": "Dowagiac",
    "value": "dowagiac"
  },
  {
    "text": "Dowell",
    "value": "dowell"
  },
  {
    "text": "Dowelltown",
    "value": "dowelltown"
  },
  {
    "text": "Dowling",
    "value": "dowling"
  },
  {
    "text": "Downers Grove",
    "value": "downers grove"
  },
  {
    "text": "Downey",
    "value": "downey"
  },
  {
    "text": "Downieville",
    "value": "downieville"
  },
  {
    "text": "Downing",
    "value": "downing"
  },
  {
    "text": "Downingtown",
    "value": "downingtown"
  },
  {
    "text": "Downs",
    "value": "downs"
  },
  {
    "text": "Downsville",
    "value": "downsville"
  },
  {
    "text": "Dows",
    "value": "dows"
  },
  {
    "text": "Doyle",
    "value": "doyle"
  },
  {
    "text": "Doylesburg",
    "value": "doylesburg"
  },
  {
    "text": "Doylestown",
    "value": "doylestown"
  },
  {
    "text": "Doyline",
    "value": "doyline"
  },
  {
    "text": "Dozier",
    "value": "dozier"
  },
  {
    "text": "Doña Ana",
    "value": "doña ana"
  },
  {
    "text": "Dracut",
    "value": "dracut"
  },
  {
    "text": "Dragoon",
    "value": "dragoon"
  },
  {
    "text": "Drain",
    "value": "drain"
  },
  {
    "text": "Drake",
    "value": "drake"
  },
  {
    "text": "Drakes Branch",
    "value": "drakes branch"
  },
  {
    "text": "Drakesboro",
    "value": "drakesboro"
  },
  {
    "text": "Drakesville",
    "value": "drakesville"
  },
  {
    "text": "Draper",
    "value": "draper"
  },
  {
    "text": "Drasco",
    "value": "drasco"
  },
  {
    "text": "Dravosburg",
    "value": "dravosburg"
  },
  {
    "text": "Drayton",
    "value": "drayton"
  },
  {
    "text": "Drayton Plains",
    "value": "drayton plains"
  },
  {
    "text": "Dresden",
    "value": "dresden"
  },
  {
    "text": "Dresden Mills",
    "value": "dresden mills"
  },
  {
    "text": "Dresher",
    "value": "dresher"
  },
  {
    "text": "Dresser",
    "value": "dresser"
  },
  {
    "text": "Drew",
    "value": "drew"
  },
  {
    "text": "Drewryville",
    "value": "drewryville"
  },
  {
    "text": "Drexel",
    "value": "drexel"
  },
  {
    "text": "Drexel Hill",
    "value": "drexel hill"
  },
  {
    "text": "Drift",
    "value": "drift"
  },
  {
    "text": "Drifting",
    "value": "drifting"
  },
  {
    "text": "Driftwood",
    "value": "driftwood"
  },
  {
    "text": "Driggs",
    "value": "driggs"
  },
  {
    "text": "Dripping Springs",
    "value": "dripping springs"
  },
  {
    "text": "Driscoll",
    "value": "driscoll"
  },
  {
    "text": "Driver",
    "value": "driver"
  },
  {
    "text": "Druid Hills",
    "value": "druid hills"
  },
  {
    "text": "Drummond",
    "value": "drummond"
  },
  {
    "text": "Drummond Island",
    "value": "drummond island"
  },
  {
    "text": "Drummonds",
    "value": "drummonds"
  },
  {
    "text": "Drumore",
    "value": "drumore"
  },
  {
    "text": "Drumright",
    "value": "drumright"
  },
  {
    "text": "Drums",
    "value": "drums"
  },
  {
    "text": "Drury",
    "value": "drury"
  },
  {
    "text": "Dry Branch",
    "value": "dry branch"
  },
  {
    "text": "Dry Creek",
    "value": "dry creek"
  },
  {
    "text": "Dry Fork",
    "value": "dry fork"
  },
  {
    "text": "Dry Prong",
    "value": "dry prong"
  },
  {
    "text": "Dry Ridge",
    "value": "dry ridge"
  },
  {
    "text": "Dry Run",
    "value": "dry run"
  },
  {
    "text": "Dryden",
    "value": "dryden"
  },
  {
    "text": "Dryfork",
    "value": "dryfork"
  },
  {
    "text": "Du Bois",
    "value": "du bois"
  },
  {
    "text": "Du Pont",
    "value": "du pont"
  },
  {
    "text": "Du Quoin",
    "value": "du quoin"
  },
  {
    "text": "DuBois",
    "value": "dubois"
  },
  {
    "text": "DuPont",
    "value": "dupont"
  },
  {
    "text": "Duanesburg",
    "value": "duanesburg"
  },
  {
    "text": "Duarte",
    "value": "duarte"
  },
  {
    "text": "Dubach",
    "value": "dubach"
  },
  {
    "text": "Dubberly",
    "value": "dubberly"
  },
  {
    "text": "Dublin",
    "value": "dublin"
  },
  {
    "text": "Dubois",
    "value": "dubois"
  },
  {
    "text": "Dubuque",
    "value": "dubuque"
  },
  {
    "text": "Duchesne",
    "value": "duchesne"
  },
  {
    "text": "Duck",
    "value": "duck"
  },
  {
    "text": "Duck Creek Village",
    "value": "duck creek village"
  },
  {
    "text": "Duck Hill",
    "value": "duck hill"
  },
  {
    "text": "Duck River",
    "value": "duck river"
  },
  {
    "text": "Ducket Crossing",
    "value": "ducket crossing"
  },
  {
    "text": "Ducktown",
    "value": "ducktown"
  },
  {
    "text": "Duckwater",
    "value": "duckwater"
  },
  {
    "text": "Ducor",
    "value": "ducor"
  },
  {
    "text": "Dudley",
    "value": "dudley"
  },
  {
    "text": "Due West",
    "value": "due west"
  },
  {
    "text": "Duenweg",
    "value": "duenweg"
  },
  {
    "text": "Duff",
    "value": "duff"
  },
  {
    "text": "Duffield",
    "value": "duffield"
  },
  {
    "text": "Dufur",
    "value": "dufur"
  },
  {
    "text": "Dugger",
    "value": "dugger"
  },
  {
    "text": "Dugspur",
    "value": "dugspur"
  },
  {
    "text": "Dugway",
    "value": "dugway"
  },
  {
    "text": "Duke",
    "value": "duke"
  },
  {
    "text": "Duke Center",
    "value": "duke center"
  },
  {
    "text": "Dukedom",
    "value": "dukedom"
  },
  {
    "text": "Dulac",
    "value": "dulac"
  },
  {
    "text": "Dulce",
    "value": "dulce"
  },
  {
    "text": "Dulles",
    "value": "dulles"
  },
  {
    "text": "Duluth",
    "value": "duluth"
  },
  {
    "text": "Dulzura",
    "value": "dulzura"
  },
  {
    "text": "Dumas",
    "value": "dumas"
  },
  {
    "text": "Dumfries",
    "value": "dumfries"
  },
  {
    "text": "Dumont",
    "value": "dumont"
  },
  {
    "text": "Dunbar",
    "value": "dunbar"
  },
  {
    "text": "Dunbarton Center",
    "value": "dunbarton center"
  },
  {
    "text": "Dunbridge",
    "value": "dunbridge"
  },
  {
    "text": "Duncan",
    "value": "duncan"
  },
  {
    "text": "Duncan Falls",
    "value": "duncan falls"
  },
  {
    "text": "Duncannon",
    "value": "duncannon"
  },
  {
    "text": "Duncansville",
    "value": "duncansville"
  },
  {
    "text": "Duncanville",
    "value": "duncanville"
  },
  {
    "text": "Duncombe",
    "value": "duncombe"
  },
  {
    "text": "Dundalk",
    "value": "dundalk"
  },
  {
    "text": "Dundas",
    "value": "dundas"
  },
  {
    "text": "Dundee",
    "value": "dundee"
  },
  {
    "text": "Dunean",
    "value": "dunean"
  },
  {
    "text": "Dunedin",
    "value": "dunedin"
  },
  {
    "text": "Dunellen",
    "value": "dunellen"
  },
  {
    "text": "Dunfermline",
    "value": "dunfermline"
  },
  {
    "text": "Dunkerton",
    "value": "dunkerton"
  },
  {
    "text": "Dunkirk",
    "value": "dunkirk"
  },
  {
    "text": "Dunlap",
    "value": "dunlap"
  },
  {
    "text": "Dunlo",
    "value": "dunlo"
  },
  {
    "text": "Dunlow",
    "value": "dunlow"
  },
  {
    "text": "Dunmor",
    "value": "dunmor"
  },
  {
    "text": "Dunmore",
    "value": "dunmore"
  },
  {
    "text": "Dunn",
    "value": "dunn"
  },
  {
    "text": "Dunn Center",
    "value": "dunn center"
  },
  {
    "text": "Dunn Loring",
    "value": "dunn loring"
  },
  {
    "text": "Dunnegan",
    "value": "dunnegan"
  },
  {
    "text": "Dunnell",
    "value": "dunnell"
  },
  {
    "text": "Dunnellon",
    "value": "dunnellon"
  },
  {
    "text": "Dunnigan",
    "value": "dunnigan"
  },
  {
    "text": "Dunning",
    "value": "dunning"
  },
  {
    "text": "Dunnsville",
    "value": "dunnsville"
  },
  {
    "text": "Dunnville",
    "value": "dunnville"
  },
  {
    "text": "Dunseith",
    "value": "dunseith"
  },
  {
    "text": "Dunsmuir",
    "value": "dunsmuir"
  },
  {
    "text": "Dunstable",
    "value": "dunstable"
  },
  {
    "text": "Dunwoody",
    "value": "dunwoody"
  },
  {
    "text": "Dupo",
    "value": "dupo"
  },
  {
    "text": "Dupont",
    "value": "dupont"
  },
  {
    "text": "Dupree",
    "value": "dupree"
  },
  {
    "text": "Dupuyer",
    "value": "dupuyer"
  },
  {
    "text": "Duquesne",
    "value": "duquesne"
  },
  {
    "text": "Durand",
    "value": "durand"
  },
  {
    "text": "Durango",
    "value": "durango"
  },
  {
    "text": "Durant",
    "value": "durant"
  },
  {
    "text": "Durbin",
    "value": "durbin"
  },
  {
    "text": "Durham",
    "value": "durham"
  },
  {
    "text": "Durhamville",
    "value": "durhamville"
  },
  {
    "text": "Durkee",
    "value": "durkee"
  },
  {
    "text": "Duryea",
    "value": "duryea"
  },
  {
    "text": "Dushore",
    "value": "dushore"
  },
  {
    "text": "Duson",
    "value": "duson"
  },
  {
    "text": "Dustin",
    "value": "dustin"
  },
  {
    "text": "Dutch Flat",
    "value": "dutch flat"
  },
  {
    "text": "Dutch Harbor",
    "value": "dutch harbor"
  },
  {
    "text": "Dutch John",
    "value": "dutch john"
  },
  {
    "text": "Dutton",
    "value": "dutton"
  },
  {
    "text": "Duvall",
    "value": "duvall"
  },
  {
    "text": "Duxbury",
    "value": "duxbury"
  },
  {
    "text": "Dwale",
    "value": "dwale"
  },
  {
    "text": "Dwarf",
    "value": "dwarf"
  },
  {
    "text": "Dwight",
    "value": "dwight"
  },
  {
    "text": "Dyer",
    "value": "dyer"
  },
  {
    "text": "Dyersburg",
    "value": "dyersburg"
  },
  {
    "text": "Dyersville",
    "value": "dyersville"
  },
  {
    "text": "Dyess",
    "value": "dyess"
  },
  {
    "text": "Dyke",
    "value": "dyke"
  },
  {
    "text": "Dysart",
    "value": "dysart"
  },
  {
    "text": "Eads",
    "value": "eads"
  },
  {
    "text": "Eagan",
    "value": "eagan"
  },
  {
    "text": "Eagar",
    "value": "eagar"
  },
  {
    "text": "Eagle",
    "value": "eagle"
  },
  {
    "text": "Eagle Bay",
    "value": "eagle bay"
  },
  {
    "text": "Eagle Bend",
    "value": "eagle bend"
  },
  {
    "text": "Eagle Bridge",
    "value": "eagle bridge"
  },
  {
    "text": "Eagle Butte",
    "value": "eagle butte"
  },
  {
    "text": "Eagle Creek",
    "value": "eagle creek"
  },
  {
    "text": "Eagle Grove",
    "value": "eagle grove"
  },
  {
    "text": "Eagle Lake",
    "value": "eagle lake"
  },
  {
    "text": "Eagle Mountain",
    "value": "eagle mountain"
  },
  {
    "text": "Eagle Nest",
    "value": "eagle nest"
  },
  {
    "text": "Eagle Pass",
    "value": "eagle pass"
  },
  {
    "text": "Eagle Point",
    "value": "eagle point"
  },
  {
    "text": "Eagle River",
    "value": "eagle river"
  },
  {
    "text": "Eagle Rock",
    "value": "eagle rock"
  },
  {
    "text": "Eagle Springs",
    "value": "eagle springs"
  },
  {
    "text": "Eagles Mere",
    "value": "eagles mere"
  },
  {
    "text": "Eagletown",
    "value": "eagletown"
  },
  {
    "text": "Eagleville",
    "value": "eagleville"
  },
  {
    "text": "Eakly",
    "value": "eakly"
  },
  {
    "text": "Earl Park",
    "value": "earl park"
  },
  {
    "text": "Earle",
    "value": "earle"
  },
  {
    "text": "Earleton",
    "value": "earleton"
  },
  {
    "text": "Earleville",
    "value": "earleville"
  },
  {
    "text": "Earlham",
    "value": "earlham"
  },
  {
    "text": "Earlimart",
    "value": "earlimart"
  },
  {
    "text": "Earlington",
    "value": "earlington"
  },
  {
    "text": "Earlsboro",
    "value": "earlsboro"
  },
  {
    "text": "Earlton",
    "value": "earlton"
  },
  {
    "text": "Earlville",
    "value": "earlville"
  },
  {
    "text": "Early",
    "value": "early"
  },
  {
    "text": "Early Branch",
    "value": "early branch"
  },
  {
    "text": "Earlysville",
    "value": "earlysville"
  },
  {
    "text": "Earp",
    "value": "earp"
  },
  {
    "text": "Earth",
    "value": "earth"
  },
  {
    "text": "Earth City",
    "value": "earth city"
  },
  {
    "text": "Easley",
    "value": "easley"
  },
  {
    "text": "East Alton",
    "value": "east alton"
  },
  {
    "text": "East Amherst",
    "value": "east amherst"
  },
  {
    "text": "East Andover",
    "value": "east andover"
  },
  {
    "text": "East Arlington",
    "value": "east arlington"
  },
  {
    "text": "East Aurora",
    "value": "east aurora"
  },
  {
    "text": "East Baldwin",
    "value": "east baldwin"
  },
  {
    "text": "East Bank",
    "value": "east bank"
  },
  {
    "text": "East Barre",
    "value": "east barre"
  },
  {
    "text": "East Bend",
    "value": "east bend"
  },
  {
    "text": "East Berlin",
    "value": "east berlin"
  },
  {
    "text": "East Bernard",
    "value": "east bernard"
  },
  {
    "text": "East Berne",
    "value": "east berne"
  },
  {
    "text": "East Bernstadt",
    "value": "east bernstadt"
  },
  {
    "text": "East Bethany",
    "value": "east bethany"
  },
  {
    "text": "East Bethel",
    "value": "east bethel"
  },
  {
    "text": "East Blue Hill",
    "value": "east blue hill"
  },
  {
    "text": "East Boothbay",
    "value": "east boothbay"
  },
  {
    "text": "East Boston",
    "value": "east boston"
  },
  {
    "text": "East Brady",
    "value": "east brady"
  },
  {
    "text": "East Branch",
    "value": "east branch"
  },
  {
    "text": "East Brewton",
    "value": "east brewton"
  },
  {
    "text": "East Bridgewater",
    "value": "east bridgewater"
  },
  {
    "text": "East Brookfield",
    "value": "east brookfield"
  },
  {
    "text": "East Brunswick",
    "value": "east brunswick"
  },
  {
    "text": "East Burke",
    "value": "east burke"
  },
  {
    "text": "East Butler",
    "value": "east butler"
  },
  {
    "text": "East Calais",
    "value": "east calais"
  },
  {
    "text": "East Canaan",
    "value": "east canaan"
  },
  {
    "text": "East Canton",
    "value": "east canton"
  },
  {
    "text": "East Carbon City",
    "value": "east carbon city"
  },
  {
    "text": "East Carondelet",
    "value": "east carondelet"
  },
  {
    "text": "East Chatham",
    "value": "east chatham"
  },
  {
    "text": "East Chattanooga",
    "value": "east chattanooga"
  },
  {
    "text": "East Chicago",
    "value": "east chicago"
  },
  {
    "text": "East China",
    "value": "east china"
  },
  {
    "text": "East Claridon",
    "value": "east claridon"
  },
  {
    "text": "East Cleveland",
    "value": "east cleveland"
  },
  {
    "text": "East Concord",
    "value": "east concord"
  },
  {
    "text": "East Conemaugh",
    "value": "east conemaugh"
  },
  {
    "text": "East Corinth",
    "value": "east corinth"
  },
  {
    "text": "East Dennis",
    "value": "east dennis"
  },
  {
    "text": "East Derry",
    "value": "east derry"
  },
  {
    "text": "East Dixfield",
    "value": "east dixfield"
  },
  {
    "text": "East Dorset",
    "value": "east dorset"
  },
  {
    "text": "East Douglas",
    "value": "east douglas"
  },
  {
    "text": "East Dover",
    "value": "east dover"
  },
  {
    "text": "East Dublin",
    "value": "east dublin"
  },
  {
    "text": "East Dubuque",
    "value": "east dubuque"
  },
  {
    "text": "East Dundee",
    "value": "east dundee"
  },
  {
    "text": "East Durham",
    "value": "east durham"
  },
  {
    "text": "East Earl",
    "value": "east earl"
  },
  {
    "text": "East Ellijay",
    "value": "east ellijay"
  },
  {
    "text": "East Ellsworth",
    "value": "east ellsworth"
  },
  {
    "text": "East Elmhurst",
    "value": "east elmhurst"
  },
  {
    "text": "East Fairfield",
    "value": "east fairfield"
  },
  {
    "text": "East Falmouth",
    "value": "east falmouth"
  },
  {
    "text": "East Farmingdale",
    "value": "east farmingdale"
  },
  {
    "text": "East Flat Rock",
    "value": "east flat rock"
  },
  {
    "text": "East Foothills",
    "value": "east foothills"
  },
  {
    "text": "East Freedom",
    "value": "east freedom"
  },
  {
    "text": "East Freetown",
    "value": "east freetown"
  },
  {
    "text": "East Fultonham",
    "value": "east fultonham"
  },
  {
    "text": "East Galesburg",
    "value": "east galesburg"
  },
  {
    "text": "East Garden City",
    "value": "east garden city"
  },
  {
    "text": "East Germantown",
    "value": "east germantown"
  },
  {
    "text": "East Glacier Park",
    "value": "east glacier park"
  },
  {
    "text": "East Glastonbury",
    "value": "east glastonbury"
  },
  {
    "text": "East Granby",
    "value": "east granby"
  },
  {
    "text": "East Grand Forks",
    "value": "east grand forks"
  },
  {
    "text": "East Grand Rapids",
    "value": "east grand rapids"
  },
  {
    "text": "East Greenbush",
    "value": "east greenbush"
  },
  {
    "text": "East Greenville",
    "value": "east greenville"
  },
  {
    "text": "East Greenwich",
    "value": "east greenwich"
  },
  {
    "text": "East Haddam",
    "value": "east haddam"
  },
  {
    "text": "East Hampstead",
    "value": "east hampstead"
  },
  {
    "text": "East Hampton",
    "value": "east hampton"
  },
  {
    "text": "East Hampton North",
    "value": "east hampton north"
  },
  {
    "text": "East Hanover",
    "value": "east hanover"
  },
  {
    "text": "East Hardwick",
    "value": "east hardwick"
  },
  {
    "text": "East Harlem",
    "value": "east harlem"
  },
  {
    "text": "East Hartford",
    "value": "east hartford"
  },
  {
    "text": "East Hartland",
    "value": "east hartland"
  },
  {
    "text": "East Harwich",
    "value": "east harwich"
  },
  {
    "text": "East Haven",
    "value": "east haven"
  },
  {
    "text": "East Hazel Crest",
    "value": "east hazel crest"
  },
  {
    "text": "East Hebron",
    "value": "east hebron"
  },
  {
    "text": "East Helena",
    "value": "east helena"
  },
  {
    "text": "East Hill-Meridian",
    "value": "east hill-meridian"
  },
  {
    "text": "East Hills",
    "value": "east hills"
  },
  {
    "text": "East Islip",
    "value": "east islip"
  },
  {
    "text": "East Ithaca",
    "value": "east ithaca"
  },
  {
    "text": "East Jordan",
    "value": "east jordan"
  },
  {
    "text": "East Killingly",
    "value": "east killingly"
  },
  {
    "text": "East Kingston",
    "value": "east kingston"
  },
  {
    "text": "East Lake",
    "value": "east lake"
  },
  {
    "text": "East Lake-Orient Park",
    "value": "east lake-orient park"
  },
  {
    "text": "East Lansing",
    "value": "east lansing"
  },
  {
    "text": "East Leroy",
    "value": "east leroy"
  },
  {
    "text": "East Liberty",
    "value": "east liberty"
  },
  {
    "text": "East Liverpool",
    "value": "east liverpool"
  },
  {
    "text": "East Longmeadow",
    "value": "east longmeadow"
  },
  {
    "text": "East Los Angeles",
    "value": "east los angeles"
  },
  {
    "text": "East Lyme",
    "value": "east lyme"
  },
  {
    "text": "East Lynn",
    "value": "east lynn"
  },
  {
    "text": "East Lynne",
    "value": "east lynne"
  },
  {
    "text": "East Machias",
    "value": "east machias"
  },
  {
    "text": "East Mansfield",
    "value": "east mansfield"
  },
  {
    "text": "East Marion",
    "value": "east marion"
  },
  {
    "text": "East Massapequa",
    "value": "east massapequa"
  },
  {
    "text": "East McKeesport",
    "value": "east mckeesport"
  },
  {
    "text": "East Meadow",
    "value": "east meadow"
  },
  {
    "text": "East Meredith",
    "value": "east meredith"
  },
  {
    "text": "East Middlebury",
    "value": "east middlebury"
  },
  {
    "text": "East Millinocket",
    "value": "east millinocket"
  },
  {
    "text": "East Millsboro",
    "value": "east millsboro"
  },
  {
    "text": "East Moline",
    "value": "east moline"
  },
  {
    "text": "East Montpelier",
    "value": "east montpelier"
  },
  {
    "text": "East Moriches",
    "value": "east moriches"
  },
  {
    "text": "East Nassau",
    "value": "east nassau"
  },
  {
    "text": "East New Market",
    "value": "east new market"
  },
  {
    "text": "East New York",
    "value": "east new york"
  },
  {
    "text": "East Newark",
    "value": "east newark"
  },
  {
    "text": "East Newnan",
    "value": "east newnan"
  },
  {
    "text": "East Norriton",
    "value": "east norriton"
  },
  {
    "text": "East Northport",
    "value": "east northport"
  },
  {
    "text": "East Norwich",
    "value": "east norwich"
  },
  {
    "text": "East Olympia",
    "value": "east olympia"
  },
  {
    "text": "East Orange",
    "value": "east orange"
  },
  {
    "text": "East Orland",
    "value": "east orland"
  },
  {
    "text": "East Otis",
    "value": "east otis"
  },
  {
    "text": "East Otto",
    "value": "east otto"
  },
  {
    "text": "East Palatka",
    "value": "east palatka"
  },
  {
    "text": "East Palestine",
    "value": "east palestine"
  },
  {
    "text": "East Palo Alto",
    "value": "east palo alto"
  },
  {
    "text": "East Pasadena",
    "value": "east pasadena"
  },
  {
    "text": "East Patchogue",
    "value": "east patchogue"
  },
  {
    "text": "East Pembroke",
    "value": "east pembroke"
  },
  {
    "text": "East Pennsboro",
    "value": "east pennsboro"
  },
  {
    "text": "East Peoria",
    "value": "east peoria"
  },
  {
    "text": "East Petersburg",
    "value": "east petersburg"
  },
  {
    "text": "East Pharsalia",
    "value": "east pharsalia"
  },
  {
    "text": "East Pittsburgh",
    "value": "east pittsburgh"
  },
  {
    "text": "East Point",
    "value": "east point"
  },
  {
    "text": "East Port Orchard",
    "value": "east port orchard"
  },
  {
    "text": "East Poultney",
    "value": "east poultney"
  },
  {
    "text": "East Prairie",
    "value": "east prairie"
  },
  {
    "text": "East Prospect",
    "value": "east prospect"
  },
  {
    "text": "East Providence",
    "value": "east providence"
  },
  {
    "text": "East Quogue",
    "value": "east quogue"
  },
  {
    "text": "East Rancho Dominguez",
    "value": "east rancho dominguez"
  },
  {
    "text": "East Randolph",
    "value": "east randolph"
  },
  {
    "text": "East Renton Highlands",
    "value": "east renton highlands"
  },
  {
    "text": "East Richmond Heights",
    "value": "east richmond heights"
  },
  {
    "text": "East Ridge",
    "value": "east ridge"
  },
  {
    "text": "East Rochester",
    "value": "east rochester"
  },
  {
    "text": "East Rockaway",
    "value": "east rockaway"
  },
  {
    "text": "East Rutherford",
    "value": "east rutherford"
  },
  {
    "text": "East Ryegate",
    "value": "east ryegate"
  },
  {
    "text": "East Saint Johnsbury",
    "value": "east saint johnsbury"
  },
  {
    "text": "East Saint Louis",
    "value": "east saint louis"
  },
  {
    "text": "East Sandwich",
    "value": "east sandwich"
  },
  {
    "text": "East Schodack",
    "value": "east schodack"
  },
  {
    "text": "East Setauket",
    "value": "east setauket"
  },
  {
    "text": "East Shoreham",
    "value": "east shoreham"
  },
  {
    "text": "East Smethport",
    "value": "east smethport"
  },
  {
    "text": "East Smithfield",
    "value": "east smithfield"
  },
  {
    "text": "East Sonora",
    "value": "east sonora"
  },
  {
    "text": "East Sparta",
    "value": "east sparta"
  },
  {
    "text": "East Spencer",
    "value": "east spencer"
  },
  {
    "text": "East Springfield",
    "value": "east springfield"
  },
  {
    "text": "East St. Louis",
    "value": "east st. louis"
  },
  {
    "text": "East Stone Gap",
    "value": "east stone gap"
  },
  {
    "text": "East Stroudsburg",
    "value": "east stroudsburg"
  },
  {
    "text": "East Syracuse",
    "value": "east syracuse"
  },
  {
    "text": "East Taunton",
    "value": "east taunton"
  },
  {
    "text": "East Tawas",
    "value": "east tawas"
  },
  {
    "text": "East Templeton",
    "value": "east templeton"
  },
  {
    "text": "East Thetford",
    "value": "east thetford"
  },
  {
    "text": "East Topsham",
    "value": "east topsham"
  },
  {
    "text": "East Troy",
    "value": "east troy"
  },
  {
    "text": "East Vandergrift",
    "value": "east vandergrift"
  },
  {
    "text": "East Wakefield",
    "value": "east wakefield"
  },
  {
    "text": "East Wallingford",
    "value": "east wallingford"
  },
  {
    "text": "East Walpole",
    "value": "east walpole"
  },
  {
    "text": "East Wareham",
    "value": "east wareham"
  },
  {
    "text": "East Waterboro",
    "value": "east waterboro"
  },
  {
    "text": "East Waterford",
    "value": "east waterford"
  },
  {
    "text": "East Wenatchee",
    "value": "east wenatchee"
  },
  {
    "text": "East Weymouth",
    "value": "east weymouth"
  },
  {
    "text": "East White Plains",
    "value": "east white plains"
  },
  {
    "text": "East Whiteland",
    "value": "east whiteland"
  },
  {
    "text": "East Williamson",
    "value": "east williamson"
  },
  {
    "text": "East Wilton",
    "value": "east wilton"
  },
  {
    "text": "East Windsor",
    "value": "east windsor"
  },
  {
    "text": "East Worcester",
    "value": "east worcester"
  },
  {
    "text": "East York",
    "value": "east york"
  },
  {
    "text": "Eastaboga",
    "value": "eastaboga"
  },
  {
    "text": "Eastanollee",
    "value": "eastanollee"
  },
  {
    "text": "Eastchester",
    "value": "eastchester"
  },
  {
    "text": "Eastern",
    "value": "eastern"
  },
  {
    "text": "Eastford",
    "value": "eastford"
  },
  {
    "text": "Eastham",
    "value": "eastham"
  },
  {
    "text": "Easthampton",
    "value": "easthampton"
  },
  {
    "text": "Eastlake",
    "value": "eastlake"
  },
  {
    "text": "Eastland",
    "value": "eastland"
  },
  {
    "text": "Eastman",
    "value": "eastman"
  },
  {
    "text": "Easton",
    "value": "easton"
  },
  {
    "text": "Eastover",
    "value": "eastover"
  },
  {
    "text": "Eastpoint",
    "value": "eastpoint"
  },
  {
    "text": "Eastpointe",
    "value": "eastpointe"
  },
  {
    "text": "Eastport",
    "value": "eastport"
  },
  {
    "text": "Eastsound",
    "value": "eastsound"
  },
  {
    "text": "Eastvale",
    "value": "eastvale"
  },
  {
    "text": "Eastview",
    "value": "eastview"
  },
  {
    "text": "Eastville",
    "value": "eastville"
  },
  {
    "text": "Eastwood",
    "value": "eastwood"
  },
  {
    "text": "Eaton",
    "value": "eaton"
  },
  {
    "text": "Eaton Center",
    "value": "eaton center"
  },
  {
    "text": "Eaton Park",
    "value": "eaton park"
  },
  {
    "text": "Eaton Rapids",
    "value": "eaton rapids"
  },
  {
    "text": "Eatonton",
    "value": "eatonton"
  },
  {
    "text": "Eatontown",
    "value": "eatontown"
  },
  {
    "text": "Eatonville",
    "value": "eatonville"
  },
  {
    "text": "Eau Claire",
    "value": "eau claire"
  },
  {
    "text": "Eau Galle",
    "value": "eau galle"
  },
  {
    "text": "Eben Junction",
    "value": "eben junction"
  },
  {
    "text": "Ebensburg",
    "value": "ebensburg"
  },
  {
    "text": "Ebony",
    "value": "ebony"
  },
  {
    "text": "Ebro",
    "value": "ebro"
  },
  {
    "text": "Eccles",
    "value": "eccles"
  },
  {
    "text": "Echelon",
    "value": "echelon"
  },
  {
    "text": "Echo",
    "value": "echo"
  },
  {
    "text": "Echola",
    "value": "echola"
  },
  {
    "text": "Eckert",
    "value": "eckert"
  },
  {
    "text": "Eckerty",
    "value": "eckerty"
  },
  {
    "text": "Eckley",
    "value": "eckley"
  },
  {
    "text": "Eclectic",
    "value": "eclectic"
  },
  {
    "text": "Economy",
    "value": "economy"
  },
  {
    "text": "Ecorse",
    "value": "ecorse"
  },
  {
    "text": "Ecru",
    "value": "ecru"
  },
  {
    "text": "Ector",
    "value": "ector"
  },
  {
    "text": "Edcouch",
    "value": "edcouch"
  },
  {
    "text": "Eddington",
    "value": "eddington"
  },
  {
    "text": "Eddy",
    "value": "eddy"
  },
  {
    "text": "Eddystone",
    "value": "eddystone"
  },
  {
    "text": "Eddyville",
    "value": "eddyville"
  },
  {
    "text": "Edelstein",
    "value": "edelstein"
  },
  {
    "text": "Eden",
    "value": "eden"
  },
  {
    "text": "Eden Isle",
    "value": "eden isle"
  },
  {
    "text": "Eden Mills",
    "value": "eden mills"
  },
  {
    "text": "Eden Prairie",
    "value": "eden prairie"
  },
  {
    "text": "Eden Valley",
    "value": "eden valley"
  },
  {
    "text": "Edenton",
    "value": "edenton"
  },
  {
    "text": "Edenville",
    "value": "edenville"
  },
  {
    "text": "Edgar",
    "value": "edgar"
  },
  {
    "text": "Edgar Springs",
    "value": "edgar springs"
  },
  {
    "text": "Edgard",
    "value": "edgard"
  },
  {
    "text": "Edgartown",
    "value": "edgartown"
  },
  {
    "text": "Edgecliff Village",
    "value": "edgecliff village"
  },
  {
    "text": "Edgecomb",
    "value": "edgecomb"
  },
  {
    "text": "Edgefield",
    "value": "edgefield"
  },
  {
    "text": "Edgeley",
    "value": "edgeley"
  },
  {
    "text": "Edgemont",
    "value": "edgemont"
  },
  {
    "text": "Edgemoor",
    "value": "edgemoor"
  },
  {
    "text": "Edgerton",
    "value": "edgerton"
  },
  {
    "text": "Edgewater",
    "value": "edgewater"
  },
  {
    "text": "Edgewater Park",
    "value": "edgewater park"
  },
  {
    "text": "Edgewood",
    "value": "edgewood"
  },
  {
    "text": "Edgeworth",
    "value": "edgeworth"
  },
  {
    "text": "Edgmont",
    "value": "edgmont"
  },
  {
    "text": "Edie",
    "value": "edie"
  },
  {
    "text": "Edina",
    "value": "edina"
  },
  {
    "text": "Edinboro",
    "value": "edinboro"
  },
  {
    "text": "Edinburg",
    "value": "edinburg"
  },
  {
    "text": "Edinburgh",
    "value": "edinburgh"
  },
  {
    "text": "Edison",
    "value": "edison"
  },
  {
    "text": "Edisto",
    "value": "edisto"
  },
  {
    "text": "Edisto Island",
    "value": "edisto island"
  },
  {
    "text": "Edmeston",
    "value": "edmeston"
  },
  {
    "text": "Edmond",
    "value": "edmond"
  },
  {
    "text": "Edmonds",
    "value": "edmonds"
  },
  {
    "text": "Edmondson",
    "value": "edmondson"
  },
  {
    "text": "Edmonston",
    "value": "edmonston"
  },
  {
    "text": "Edmonton",
    "value": "edmonton"
  },
  {
    "text": "Edmore",
    "value": "edmore"
  },
  {
    "text": "Edna",
    "value": "edna"
  },
  {
    "text": "Edneyville",
    "value": "edneyville"
  },
  {
    "text": "Edon",
    "value": "edon"
  },
  {
    "text": "Edroy",
    "value": "edroy"
  },
  {
    "text": "Edwall",
    "value": "edwall"
  },
  {
    "text": "Edward",
    "value": "edward"
  },
  {
    "text": "Edwards",
    "value": "edwards"
  },
  {
    "text": "Edwards Air Force Base",
    "value": "edwards air force base"
  },
  {
    "text": "Edwardsburg",
    "value": "edwardsburg"
  },
  {
    "text": "Edwardsport",
    "value": "edwardsport"
  },
  {
    "text": "Edwardsville",
    "value": "edwardsville"
  },
  {
    "text": "Eek",
    "value": "eek"
  },
  {
    "text": "Effie",
    "value": "effie"
  },
  {
    "text": "Effingham",
    "value": "effingham"
  },
  {
    "text": "Effort",
    "value": "effort"
  },
  {
    "text": "Efland",
    "value": "efland"
  },
  {
    "text": "Egan",
    "value": "egan"
  },
  {
    "text": "Egg Harbor",
    "value": "egg harbor"
  },
  {
    "text": "Egg Harbor City",
    "value": "egg harbor city"
  },
  {
    "text": "Eggleston",
    "value": "eggleston"
  },
  {
    "text": "Eglin Air Force Base",
    "value": "eglin air force base"
  },
  {
    "text": "Eglin Village",
    "value": "eglin village"
  },
  {
    "text": "Eglon",
    "value": "eglon"
  },
  {
    "text": "Egypt",
    "value": "egypt"
  },
  {
    "text": "Egypt Lake-Leto",
    "value": "egypt lake-leto"
  },
  {
    "text": "Ehrenberg",
    "value": "ehrenberg"
  },
  {
    "text": "Ehrhardt",
    "value": "ehrhardt"
  },
  {
    "text": "Eidson",
    "value": "eidson"
  },
  {
    "text": "Eielson Air Force Base",
    "value": "eielson air force base"
  },
  {
    "text": "Eight Mile",
    "value": "eight mile"
  },
  {
    "text": "Eighty Eight",
    "value": "eighty eight"
  },
  {
    "text": "Eighty Four",
    "value": "eighty four"
  },
  {
    "text": "Eitzen",
    "value": "eitzen"
  },
  {
    "text": "Ekalaka",
    "value": "ekalaka"
  },
  {
    "text": "Ekron",
    "value": "ekron"
  },
  {
    "text": "Ekwok",
    "value": "ekwok"
  },
  {
    "text": "El Cajon",
    "value": "el cajon"
  },
  {
    "text": "El Campo",
    "value": "el campo"
  },
  {
    "text": "El Centro",
    "value": "el centro"
  },
  {
    "text": "El Cerrito",
    "value": "el cerrito"
  },
  {
    "text": "El Dorado",
    "value": "el dorado"
  },
  {
    "text": "El Dorado Hills",
    "value": "el dorado hills"
  },
  {
    "text": "El Dorado Springs",
    "value": "el dorado springs"
  },
  {
    "text": "El Granada",
    "value": "el granada"
  },
  {
    "text": "El Indio",
    "value": "el indio"
  },
  {
    "text": "El Jebel",
    "value": "el jebel"
  },
  {
    "text": "El Macero",
    "value": "el macero"
  },
  {
    "text": "El Mirage",
    "value": "el mirage"
  },
  {
    "text": "El Monte",
    "value": "el monte"
  },
  {
    "text": "El Nido",
    "value": "el nido"
  },
  {
    "text": "El Paso",
    "value": "el paso"
  },
  {
    "text": "El Portal",
    "value": "el portal"
  },
  {
    "text": "El Prado",
    "value": "el prado"
  },
  {
    "text": "El Reno",
    "value": "el reno"
  },
  {
    "text": "El Rio",
    "value": "el rio"
  },
  {
    "text": "El Rito",
    "value": "el rito"
  },
  {
    "text": "El Segundo",
    "value": "el segundo"
  },
  {
    "text": "El Sobrante",
    "value": "el sobrante"
  },
  {
    "text": "El Toro",
    "value": "el toro"
  },
  {
    "text": "El Verano",
    "value": "el verano"
  },
  {
    "text": "Elaine",
    "value": "elaine"
  },
  {
    "text": "Eland",
    "value": "eland"
  },
  {
    "text": "Elba",
    "value": "elba"
  },
  {
    "text": "Elberfeld",
    "value": "elberfeld"
  },
  {
    "text": "Elberon",
    "value": "elberon"
  },
  {
    "text": "Elbert",
    "value": "elbert"
  },
  {
    "text": "Elberta",
    "value": "elberta"
  },
  {
    "text": "Elberton",
    "value": "elberton"
  },
  {
    "text": "Elbing",
    "value": "elbing"
  },
  {
    "text": "Elbow Lake",
    "value": "elbow lake"
  },
  {
    "text": "Elbridge",
    "value": "elbridge"
  },
  {
    "text": "Elburn",
    "value": "elburn"
  },
  {
    "text": "Elcho",
    "value": "elcho"
  },
  {
    "text": "Eldena",
    "value": "eldena"
  },
  {
    "text": "Eldersburg",
    "value": "eldersburg"
  },
  {
    "text": "Elderton",
    "value": "elderton"
  },
  {
    "text": "Eldon",
    "value": "eldon"
  },
  {
    "text": "Eldora",
    "value": "eldora"
  },
  {
    "text": "Eldorado",
    "value": "eldorado"
  },
  {
    "text": "Eldorado Springs",
    "value": "eldorado springs"
  },
  {
    "text": "Eldred",
    "value": "eldred"
  },
  {
    "text": "Eldridge",
    "value": "eldridge"
  },
  {
    "text": "Eleanor",
    "value": "eleanor"
  },
  {
    "text": "Electra",
    "value": "electra"
  },
  {
    "text": "Electric City",
    "value": "electric city"
  },
  {
    "text": "Elephant Butte",
    "value": "elephant butte"
  },
  {
    "text": "Eleva",
    "value": "eleva"
  },
  {
    "text": "Elfers",
    "value": "elfers"
  },
  {
    "text": "Elfrida",
    "value": "elfrida"
  },
  {
    "text": "Elgin",
    "value": "elgin"
  },
  {
    "text": "Elida",
    "value": "elida"
  },
  {
    "text": "Elim",
    "value": "elim"
  },
  {
    "text": "Eliot",
    "value": "eliot"
  },
  {
    "text": "Elizabeth",
    "value": "elizabeth"
  },
  {
    "text": "Elizabeth City",
    "value": "elizabeth city"
  },
  {
    "text": "Elizabethport",
    "value": "elizabethport"
  },
  {
    "text": "Elizabethton",
    "value": "elizabethton"
  },
  {
    "text": "Elizabethtown",
    "value": "elizabethtown"
  },
  {
    "text": "Elizabethville",
    "value": "elizabethville"
  },
  {
    "text": "Elizaville",
    "value": "elizaville"
  },
  {
    "text": "Elk",
    "value": "elk"
  },
  {
    "text": "Elk City",
    "value": "elk city"
  },
  {
    "text": "Elk Creek",
    "value": "elk creek"
  },
  {
    "text": "Elk Falls",
    "value": "elk falls"
  },
  {
    "text": "Elk Garden",
    "value": "elk garden"
  },
  {
    "text": "Elk Grove",
    "value": "elk grove"
  },
  {
    "text": "Elk Grove Village",
    "value": "elk grove village"
  },
  {
    "text": "Elk Horn",
    "value": "elk horn"
  },
  {
    "text": "Elk Mills",
    "value": "elk mills"
  },
  {
    "text": "Elk Mound",
    "value": "elk mound"
  },
  {
    "text": "Elk Mountain",
    "value": "elk mountain"
  },
  {
    "text": "Elk Park",
    "value": "elk park"
  },
  {
    "text": "Elk Plain",
    "value": "elk plain"
  },
  {
    "text": "Elk Point",
    "value": "elk point"
  },
  {
    "text": "Elk Rapids",
    "value": "elk rapids"
  },
  {
    "text": "Elk Ridge",
    "value": "elk ridge"
  },
  {
    "text": "Elk River",
    "value": "elk river"
  },
  {
    "text": "Elk Run Heights",
    "value": "elk run heights"
  },
  {
    "text": "Elka Park",
    "value": "elka park"
  },
  {
    "text": "Elkader",
    "value": "elkader"
  },
  {
    "text": "Elkhart",
    "value": "elkhart"
  },
  {
    "text": "Elkhart Lake",
    "value": "elkhart lake"
  },
  {
    "text": "Elkhorn",
    "value": "elkhorn"
  },
  {
    "text": "Elkhorn City",
    "value": "elkhorn city"
  },
  {
    "text": "Elkin",
    "value": "elkin"
  },
  {
    "text": "Elkins",
    "value": "elkins"
  },
  {
    "text": "Elkins Park",
    "value": "elkins park"
  },
  {
    "text": "Elkland",
    "value": "elkland"
  },
  {
    "text": "Elkmont",
    "value": "elkmont"
  },
  {
    "text": "Elko",
    "value": "elko"
  },
  {
    "text": "Elko New Market",
    "value": "elko new market"
  },
  {
    "text": "Elkridge",
    "value": "elkridge"
  },
  {
    "text": "Elkton",
    "value": "elkton"
  },
  {
    "text": "Elkview",
    "value": "elkview"
  },
  {
    "text": "Elkville",
    "value": "elkville"
  },
  {
    "text": "Elkwood",
    "value": "elkwood"
  },
  {
    "text": "Ellabell",
    "value": "ellabell"
  },
  {
    "text": "Ellamore",
    "value": "ellamore"
  },
  {
    "text": "Ellaville",
    "value": "ellaville"
  },
  {
    "text": "Ellenboro",
    "value": "ellenboro"
  },
  {
    "text": "Ellenburg",
    "value": "ellenburg"
  },
  {
    "text": "Ellenburg Center",
    "value": "ellenburg center"
  },
  {
    "text": "Ellenburg Depot",
    "value": "ellenburg depot"
  },
  {
    "text": "Ellendale",
    "value": "ellendale"
  },
  {
    "text": "Ellensburg",
    "value": "ellensburg"
  },
  {
    "text": "Ellenton",
    "value": "ellenton"
  },
  {
    "text": "Ellenville",
    "value": "ellenville"
  },
  {
    "text": "Ellenwood",
    "value": "ellenwood"
  },
  {
    "text": "Ellerbe",
    "value": "ellerbe"
  },
  {
    "text": "Ellerslie",
    "value": "ellerslie"
  },
  {
    "text": "Ellery",
    "value": "ellery"
  },
  {
    "text": "Ellettsville",
    "value": "ellettsville"
  },
  {
    "text": "Ellicott",
    "value": "ellicott"
  },
  {
    "text": "Ellicott City",
    "value": "ellicott city"
  },
  {
    "text": "Ellicottville",
    "value": "ellicottville"
  },
  {
    "text": "Ellijay",
    "value": "ellijay"
  },
  {
    "text": "Ellinger",
    "value": "ellinger"
  },
  {
    "text": "Ellington",
    "value": "ellington"
  },
  {
    "text": "Ellinwood",
    "value": "ellinwood"
  },
  {
    "text": "Elliott",
    "value": "elliott"
  },
  {
    "text": "Elliottsburg",
    "value": "elliottsburg"
  },
  {
    "text": "Elliottville",
    "value": "elliottville"
  },
  {
    "text": "Ellis",
    "value": "ellis"
  },
  {
    "text": "Ellis Grove",
    "value": "ellis grove"
  },
  {
    "text": "Ellison Bay",
    "value": "ellison bay"
  },
  {
    "text": "Elliston",
    "value": "elliston"
  },
  {
    "text": "Ellisville",
    "value": "ellisville"
  },
  {
    "text": "Elloree",
    "value": "elloree"
  },
  {
    "text": "Ellsinore",
    "value": "ellsinore"
  },
  {
    "text": "Ellston",
    "value": "ellston"
  },
  {
    "text": "Ellsworth",
    "value": "ellsworth"
  },
  {
    "text": "Ellsworth Air Force Base",
    "value": "ellsworth air force base"
  },
  {
    "text": "Ellwood City",
    "value": "ellwood city"
  },
  {
    "text": "Elm",
    "value": "elm"
  },
  {
    "text": "Elm City",
    "value": "elm city"
  },
  {
    "text": "Elm Creek",
    "value": "elm creek"
  },
  {
    "text": "Elm Grove",
    "value": "elm grove"
  },
  {
    "text": "Elm Mott",
    "value": "elm mott"
  },
  {
    "text": "Elma",
    "value": "elma"
  },
  {
    "text": "Elmendorf",
    "value": "elmendorf"
  },
  {
    "text": "Elmer",
    "value": "elmer"
  },
  {
    "text": "Elmer City",
    "value": "elmer city"
  },
  {
    "text": "Elmhurst",
    "value": "elmhurst"
  },
  {
    "text": "Elmira",
    "value": "elmira"
  },
  {
    "text": "Elmira Heights",
    "value": "elmira heights"
  },
  {
    "text": "Elmo",
    "value": "elmo"
  },
  {
    "text": "Elmont",
    "value": "elmont"
  },
  {
    "text": "Elmora",
    "value": "elmora"
  },
  {
    "text": "Elmore",
    "value": "elmore"
  },
  {
    "text": "Elmore City",
    "value": "elmore city"
  },
  {
    "text": "Elmsford",
    "value": "elmsford"
  },
  {
    "text": "Elmwood",
    "value": "elmwood"
  },
  {
    "text": "Elmwood Park",
    "value": "elmwood park"
  },
  {
    "text": "Elnora",
    "value": "elnora"
  },
  {
    "text": "Elon",
    "value": "elon"
  },
  {
    "text": "Elora",
    "value": "elora"
  },
  {
    "text": "Eloy",
    "value": "eloy"
  },
  {
    "text": "Elroy",
    "value": "elroy"
  },
  {
    "text": "Elsa",
    "value": "elsa"
  },
  {
    "text": "Elsah",
    "value": "elsah"
  },
  {
    "text": "Elsberry",
    "value": "elsberry"
  },
  {
    "text": "Elsie",
    "value": "elsie"
  },
  {
    "text": "Elsinore",
    "value": "elsinore"
  },
  {
    "text": "Elsmere",
    "value": "elsmere"
  },
  {
    "text": "Elsmore",
    "value": "elsmore"
  },
  {
    "text": "Elton",
    "value": "elton"
  },
  {
    "text": "Eltopia",
    "value": "eltopia"
  },
  {
    "text": "Elvaston",
    "value": "elvaston"
  },
  {
    "text": "Elverson",
    "value": "elverson"
  },
  {
    "text": "Elverta",
    "value": "elverta"
  },
  {
    "text": "Elwell",
    "value": "elwell"
  },
  {
    "text": "Elwood",
    "value": "elwood"
  },
  {
    "text": "Ely",
    "value": "ely"
  },
  {
    "text": "Elyria",
    "value": "elyria"
  },
  {
    "text": "Elysburg",
    "value": "elysburg"
  },
  {
    "text": "Elysian",
    "value": "elysian"
  },
  {
    "text": "Elysian Fields",
    "value": "elysian fields"
  },
  {
    "text": "Embarrass",
    "value": "embarrass"
  },
  {
    "text": "Emblem",
    "value": "emblem"
  },
  {
    "text": "Embudo",
    "value": "embudo"
  },
  {
    "text": "Emden",
    "value": "emden"
  },
  {
    "text": "Emerado",
    "value": "emerado"
  },
  {
    "text": "Emerald Isle",
    "value": "emerald isle"
  },
  {
    "text": "Emerald Lake Hills",
    "value": "emerald lake hills"
  },
  {
    "text": "Emerson",
    "value": "emerson"
  },
  {
    "text": "Emery",
    "value": "emery"
  },
  {
    "text": "Emeryville",
    "value": "emeryville"
  },
  {
    "text": "Emigrant",
    "value": "emigrant"
  },
  {
    "text": "Emigrant Gap",
    "value": "emigrant gap"
  },
  {
    "text": "Emigsville",
    "value": "emigsville"
  },
  {
    "text": "Emily",
    "value": "emily"
  },
  {
    "text": "Eminence",
    "value": "eminence"
  },
  {
    "text": "Emington",
    "value": "emington"
  },
  {
    "text": "Emlenton",
    "value": "emlenton"
  },
  {
    "text": "Emlyn",
    "value": "emlyn"
  },
  {
    "text": "Emma",
    "value": "emma"
  },
  {
    "text": "Emmalena",
    "value": "emmalena"
  },
  {
    "text": "Emmaus",
    "value": "emmaus"
  },
  {
    "text": "Emmet",
    "value": "emmet"
  },
  {
    "text": "Emmetsburg",
    "value": "emmetsburg"
  },
  {
    "text": "Emmett",
    "value": "emmett"
  },
  {
    "text": "Emmitsburg",
    "value": "emmitsburg"
  },
  {
    "text": "Emmonak",
    "value": "emmonak"
  },
  {
    "text": "Emmons",
    "value": "emmons"
  },
  {
    "text": "Emory",
    "value": "emory"
  },
  {
    "text": "Empire",
    "value": "empire"
  },
  {
    "text": "Emporia",
    "value": "emporia"
  },
  {
    "text": "Emporium",
    "value": "emporium"
  },
  {
    "text": "Emsworth",
    "value": "emsworth"
  },
  {
    "text": "Encampment",
    "value": "encampment"
  },
  {
    "text": "Enchanted Hills",
    "value": "enchanted hills"
  },
  {
    "text": "Encinal",
    "value": "encinal"
  },
  {
    "text": "Encinitas",
    "value": "encinitas"
  },
  {
    "text": "Encino",
    "value": "encino"
  },
  {
    "text": "Endeavor",
    "value": "endeavor"
  },
  {
    "text": "Enderlin",
    "value": "enderlin"
  },
  {
    "text": "Endicott",
    "value": "endicott"
  },
  {
    "text": "Endwell",
    "value": "endwell"
  },
  {
    "text": "Energy",
    "value": "energy"
  },
  {
    "text": "Enfield",
    "value": "enfield"
  },
  {
    "text": "Engadine",
    "value": "engadine"
  },
  {
    "text": "Engelhard",
    "value": "engelhard"
  },
  {
    "text": "England",
    "value": "england"
  },
  {
    "text": "Englewood",
    "value": "englewood"
  },
  {
    "text": "Englewood Cliffs",
    "value": "englewood cliffs"
  },
  {
    "text": "English",
    "value": "english"
  },
  {
    "text": "Englishtown",
    "value": "englishtown"
  },
  {
    "text": "Enid",
    "value": "enid"
  },
  {
    "text": "Enigma",
    "value": "enigma"
  },
  {
    "text": "Enka",
    "value": "enka"
  },
  {
    "text": "Enka Village",
    "value": "enka village"
  },
  {
    "text": "Ennice",
    "value": "ennice"
  },
  {
    "text": "Enning",
    "value": "enning"
  },
  {
    "text": "Ennis",
    "value": "ennis"
  },
  {
    "text": "Enoch",
    "value": "enoch"
  },
  {
    "text": "Enochs",
    "value": "enochs"
  },
  {
    "text": "Enola",
    "value": "enola"
  },
  {
    "text": "Enon",
    "value": "enon"
  },
  {
    "text": "Enon Valley",
    "value": "enon valley"
  },
  {
    "text": "Enoree",
    "value": "enoree"
  },
  {
    "text": "Enosburg Falls",
    "value": "enosburg falls"
  },
  {
    "text": "Ensign",
    "value": "ensign"
  },
  {
    "text": "Ensley",
    "value": "ensley"
  },
  {
    "text": "Enterprise",
    "value": "enterprise"
  },
  {
    "text": "Entiat",
    "value": "entiat"
  },
  {
    "text": "Entriken",
    "value": "entriken"
  },
  {
    "text": "Enumclaw",
    "value": "enumclaw"
  },
  {
    "text": "Enville",
    "value": "enville"
  },
  {
    "text": "Eola",
    "value": "eola"
  },
  {
    "text": "Eolia",
    "value": "eolia"
  },
  {
    "text": "Epes",
    "value": "epes"
  },
  {
    "text": "Ephraim",
    "value": "ephraim"
  },
  {
    "text": "Ephrata",
    "value": "ephrata"
  },
  {
    "text": "Epping",
    "value": "epping"
  },
  {
    "text": "Epps",
    "value": "epps"
  },
  {
    "text": "Epsom",
    "value": "epsom"
  },
  {
    "text": "Epworth",
    "value": "epworth"
  },
  {
    "text": "Equality",
    "value": "equality"
  },
  {
    "text": "Equinunk",
    "value": "equinunk"
  },
  {
    "text": "Era",
    "value": "era"
  },
  {
    "text": "Erath",
    "value": "erath"
  },
  {
    "text": "Erda",
    "value": "erda"
  },
  {
    "text": "Erhard",
    "value": "erhard"
  },
  {
    "text": "Erick",
    "value": "erick"
  },
  {
    "text": "Ericson",
    "value": "ericson"
  },
  {
    "text": "Erie",
    "value": "erie"
  },
  {
    "text": "Erieville",
    "value": "erieville"
  },
  {
    "text": "Erin",
    "value": "erin"
  },
  {
    "text": "Erlanger",
    "value": "erlanger"
  },
  {
    "text": "Ermine",
    "value": "ermine"
  },
  {
    "text": "Ernul",
    "value": "ernul"
  },
  {
    "text": "Eros",
    "value": "eros"
  },
  {
    "text": "Errol",
    "value": "errol"
  },
  {
    "text": "Erskine",
    "value": "erskine"
  },
  {
    "text": "Erving",
    "value": "erving"
  },
  {
    "text": "Erwin",
    "value": "erwin"
  },
  {
    "text": "Erwinna",
    "value": "erwinna"
  },
  {
    "text": "Erwinville",
    "value": "erwinville"
  },
  {
    "text": "Esbon",
    "value": "esbon"
  },
  {
    "text": "Escalante",
    "value": "escalante"
  },
  {
    "text": "Escalon",
    "value": "escalon"
  },
  {
    "text": "Escanaba",
    "value": "escanaba"
  },
  {
    "text": "Escobares",
    "value": "escobares"
  },
  {
    "text": "Escondido",
    "value": "escondido"
  },
  {
    "text": "Eskdale",
    "value": "eskdale"
  },
  {
    "text": "Esko",
    "value": "esko"
  },
  {
    "text": "Eskridge",
    "value": "eskridge"
  },
  {
    "text": "Esmond",
    "value": "esmond"
  },
  {
    "text": "Esmont",
    "value": "esmont"
  },
  {
    "text": "Espanola",
    "value": "espanola"
  },
  {
    "text": "Esparto",
    "value": "esparto"
  },
  {
    "text": "Española",
    "value": "española"
  },
  {
    "text": "Esperance",
    "value": "esperance"
  },
  {
    "text": "Essex",
    "value": "essex"
  },
  {
    "text": "Essex Fells",
    "value": "essex fells"
  },
  {
    "text": "Essex Junction",
    "value": "essex junction"
  },
  {
    "text": "Essexville",
    "value": "essexville"
  },
  {
    "text": "Essie",
    "value": "essie"
  },
  {
    "text": "Essington",
    "value": "essington"
  },
  {
    "text": "Estacada",
    "value": "estacada"
  },
  {
    "text": "Estancia",
    "value": "estancia"
  },
  {
    "text": "Estell Manor",
    "value": "estell manor"
  },
  {
    "text": "Estelline",
    "value": "estelline"
  },
  {
    "text": "Ester",
    "value": "ester"
  },
  {
    "text": "Estero",
    "value": "estero"
  },
  {
    "text": "Estes Park",
    "value": "estes park"
  },
  {
    "text": "Estherville",
    "value": "estherville"
  },
  {
    "text": "Estherwood",
    "value": "estherwood"
  },
  {
    "text": "Estill",
    "value": "estill"
  },
  {
    "text": "Estill Springs",
    "value": "estill springs"
  },
  {
    "text": "Ethan",
    "value": "ethan"
  },
  {
    "text": "Ethel",
    "value": "ethel"
  },
  {
    "text": "Ethelsville",
    "value": "ethelsville"
  },
  {
    "text": "Ether",
    "value": "ether"
  },
  {
    "text": "Ethete",
    "value": "ethete"
  },
  {
    "text": "Ethridge",
    "value": "ethridge"
  },
  {
    "text": "Etlan",
    "value": "etlan"
  },
  {
    "text": "Etna",
    "value": "etna"
  },
  {
    "text": "Etna Green",
    "value": "etna green"
  },
  {
    "text": "Etoile",
    "value": "etoile"
  },
  {
    "text": "Eton",
    "value": "eton"
  },
  {
    "text": "Etowah",
    "value": "etowah"
  },
  {
    "text": "Etta",
    "value": "etta"
  },
  {
    "text": "Etters",
    "value": "etters"
  },
  {
    "text": "Ettrick",
    "value": "ettrick"
  },
  {
    "text": "Eubank",
    "value": "eubank"
  },
  {
    "text": "Eucha",
    "value": "eucha"
  },
  {
    "text": "Euclid",
    "value": "euclid"
  },
  {
    "text": "Eudora",
    "value": "eudora"
  },
  {
    "text": "Eufaula",
    "value": "eufaula"
  },
  {
    "text": "Eugene",
    "value": "eugene"
  },
  {
    "text": "Euharlee",
    "value": "euharlee"
  },
  {
    "text": "Euless",
    "value": "euless"
  },
  {
    "text": "Eunice",
    "value": "eunice"
  },
  {
    "text": "Eupora",
    "value": "eupora"
  },
  {
    "text": "Eure",
    "value": "eure"
  },
  {
    "text": "Eureka",
    "value": "eureka"
  },
  {
    "text": "Eureka Springs",
    "value": "eureka springs"
  },
  {
    "text": "Eustace",
    "value": "eustace"
  },
  {
    "text": "Eustis",
    "value": "eustis"
  },
  {
    "text": "Eutaw",
    "value": "eutaw"
  },
  {
    "text": "Eutawville",
    "value": "eutawville"
  },
  {
    "text": "Eva",
    "value": "eva"
  },
  {
    "text": "Evadale",
    "value": "evadale"
  },
  {
    "text": "Evangeline",
    "value": "evangeline"
  },
  {
    "text": "Evans",
    "value": "evans"
  },
  {
    "text": "Evans City",
    "value": "evans city"
  },
  {
    "text": "Evans Mills",
    "value": "evans mills"
  },
  {
    "text": "Evansburg",
    "value": "evansburg"
  },
  {
    "text": "Evansdale",
    "value": "evansdale"
  },
  {
    "text": "Evansport",
    "value": "evansport"
  },
  {
    "text": "Evanston",
    "value": "evanston"
  },
  {
    "text": "Evansville",
    "value": "evansville"
  },
  {
    "text": "Evant",
    "value": "evant"
  },
  {
    "text": "Evart",
    "value": "evart"
  },
  {
    "text": "Evarts",
    "value": "evarts"
  },
  {
    "text": "Eveleth",
    "value": "eveleth"
  },
  {
    "text": "Evendale",
    "value": "evendale"
  },
  {
    "text": "Evening Shade",
    "value": "evening shade"
  },
  {
    "text": "Evensville",
    "value": "evensville"
  },
  {
    "text": "Everest",
    "value": "everest"
  },
  {
    "text": "Everett",
    "value": "everett"
  },
  {
    "text": "Everetts",
    "value": "everetts"
  },
  {
    "text": "Everglades City",
    "value": "everglades city"
  },
  {
    "text": "Evergreen",
    "value": "evergreen"
  },
  {
    "text": "Evergreen Park",
    "value": "evergreen park"
  },
  {
    "text": "Everly",
    "value": "everly"
  },
  {
    "text": "Everman",
    "value": "everman"
  },
  {
    "text": "Everson",
    "value": "everson"
  },
  {
    "text": "Everton",
    "value": "everton"
  },
  {
    "text": "Evington",
    "value": "evington"
  },
  {
    "text": "Evinston",
    "value": "evinston"
  },
  {
    "text": "Ewan",
    "value": "ewan"
  },
  {
    "text": "Ewell",
    "value": "ewell"
  },
  {
    "text": "Ewen",
    "value": "ewen"
  },
  {
    "text": "Ewing",
    "value": "ewing"
  },
  {
    "text": "Excel",
    "value": "excel"
  },
  {
    "text": "Excello",
    "value": "excello"
  },
  {
    "text": "Excelsior",
    "value": "excelsior"
  },
  {
    "text": "Excelsior Springs",
    "value": "excelsior springs"
  },
  {
    "text": "Exeland",
    "value": "exeland"
  },
  {
    "text": "Exeter",
    "value": "exeter"
  },
  {
    "text": "Exeter Corners",
    "value": "exeter corners"
  },
  {
    "text": "Exira",
    "value": "exira"
  },
  {
    "text": "Exline",
    "value": "exline"
  },
  {
    "text": "Exmore",
    "value": "exmore"
  },
  {
    "text": "Export",
    "value": "export"
  },
  {
    "text": "Exton",
    "value": "exton"
  },
  {
    "text": "Eyota",
    "value": "eyota"
  },
  {
    "text": "Ezel",
    "value": "ezel"
  },
  {
    "text": "F.E. Warren Air Force Base",
    "value": "f.e. warren air force base"
  },
  {
    "text": "Fabens",
    "value": "fabens"
  },
  {
    "text": "Faber",
    "value": "faber"
  },
  {
    "text": "Fabius",
    "value": "fabius"
  },
  {
    "text": "Fackler",
    "value": "fackler"
  },
  {
    "text": "Factoryville",
    "value": "factoryville"
  },
  {
    "text": "Fair Bluff",
    "value": "fair bluff"
  },
  {
    "text": "Fair Grove",
    "value": "fair grove"
  },
  {
    "text": "Fair Haven",
    "value": "fair haven"
  },
  {
    "text": "Fair Lawn",
    "value": "fair lawn"
  },
  {
    "text": "Fair Oaks",
    "value": "fair oaks"
  },
  {
    "text": "Fair Oaks Ranch",
    "value": "fair oaks ranch"
  },
  {
    "text": "Fair Play",
    "value": "fair play"
  },
  {
    "text": "Fairacres",
    "value": "fairacres"
  },
  {
    "text": "Fairbank",
    "value": "fairbank"
  },
  {
    "text": "Fairbanks",
    "value": "fairbanks"
  },
  {
    "text": "Fairbanks Ranch",
    "value": "fairbanks ranch"
  },
  {
    "text": "Fairborn",
    "value": "fairborn"
  },
  {
    "text": "Fairburn",
    "value": "fairburn"
  },
  {
    "text": "Fairbury",
    "value": "fairbury"
  },
  {
    "text": "Fairchance",
    "value": "fairchance"
  },
  {
    "text": "Fairchild",
    "value": "fairchild"
  },
  {
    "text": "Fairchild Air Force Base",
    "value": "fairchild air force base"
  },
  {
    "text": "Fairdale",
    "value": "fairdale"
  },
  {
    "text": "Fairdealing",
    "value": "fairdealing"
  },
  {
    "text": "Fairfax",
    "value": "fairfax"
  },
  {
    "text": "Fairfax Station",
    "value": "fairfax station"
  },
  {
    "text": "Fairfield",
    "value": "fairfield"
  },
  {
    "text": "Fairfield Bay",
    "value": "fairfield bay"
  },
  {
    "text": "Fairfield Glade",
    "value": "fairfield glade"
  },
  {
    "text": "Fairforest",
    "value": "fairforest"
  },
  {
    "text": "Fairgrove",
    "value": "fairgrove"
  },
  {
    "text": "Fairhaven",
    "value": "fairhaven"
  },
  {
    "text": "Fairhope",
    "value": "fairhope"
  },
  {
    "text": "Fairland",
    "value": "fairland"
  },
  {
    "text": "Fairlawn",
    "value": "fairlawn"
  },
  {
    "text": "Fairlee",
    "value": "fairlee"
  },
  {
    "text": "Fairless Hills",
    "value": "fairless hills"
  },
  {
    "text": "Fairmont",
    "value": "fairmont"
  },
  {
    "text": "Fairmont City",
    "value": "fairmont city"
  },
  {
    "text": "Fairmount",
    "value": "fairmount"
  },
  {
    "text": "Fairmount City",
    "value": "fairmount city"
  },
  {
    "text": "Fairplay",
    "value": "fairplay"
  },
  {
    "text": "Fairport",
    "value": "fairport"
  },
  {
    "text": "Fairport Harbor",
    "value": "fairport harbor"
  },
  {
    "text": "Fairton",
    "value": "fairton"
  },
  {
    "text": "Fairview",
    "value": "fairview"
  },
  {
    "text": "Fairview Heights",
    "value": "fairview heights"
  },
  {
    "text": "Fairview Park",
    "value": "fairview park"
  },
  {
    "text": "Fairview Shores",
    "value": "fairview shores"
  },
  {
    "text": "Fairview-Ferndale",
    "value": "fairview-ferndale"
  },
  {
    "text": "Fairwater",
    "value": "fairwater"
  },
  {
    "text": "Fairway",
    "value": "fairway"
  },
  {
    "text": "Fairwood",
    "value": "fairwood"
  },
  {
    "text": "Faison",
    "value": "faison"
  },
  {
    "text": "Faith",
    "value": "faith"
  },
  {
    "text": "Falcon",
    "value": "falcon"
  },
  {
    "text": "Falcon Heights",
    "value": "falcon heights"
  },
  {
    "text": "Falconer",
    "value": "falconer"
  },
  {
    "text": "Falfurrias",
    "value": "falfurrias"
  },
  {
    "text": "Falkland",
    "value": "falkland"
  },
  {
    "text": "Falkner",
    "value": "falkner"
  },
  {
    "text": "Falkville",
    "value": "falkville"
  },
  {
    "text": "Fall Branch",
    "value": "fall branch"
  },
  {
    "text": "Fall City",
    "value": "fall city"
  },
  {
    "text": "Fall Creek",
    "value": "fall creek"
  },
  {
    "text": "Fall River",
    "value": "fall river"
  },
  {
    "text": "Fall River Mills",
    "value": "fall river mills"
  },
  {
    "text": "Fall Rock",
    "value": "fall rock"
  },
  {
    "text": "Fallbrook",
    "value": "fallbrook"
  },
  {
    "text": "Fallentimber",
    "value": "fallentimber"
  },
  {
    "text": "Falling Spring",
    "value": "falling spring"
  },
  {
    "text": "Falling Waters",
    "value": "falling waters"
  },
  {
    "text": "Fallon",
    "value": "fallon"
  },
  {
    "text": "Falls",
    "value": "falls"
  },
  {
    "text": "Falls Church",
    "value": "falls church"
  },
  {
    "text": "Falls City",
    "value": "falls city"
  },
  {
    "text": "Falls Creek",
    "value": "falls creek"
  },
  {
    "text": "Falls Mills",
    "value": "falls mills"
  },
  {
    "text": "Falls Village",
    "value": "falls village"
  },
  {
    "text": "Falls of Rough",
    "value": "falls of rough"
  },
  {
    "text": "Fallsburg",
    "value": "fallsburg"
  },
  {
    "text": "Fallston",
    "value": "fallston"
  },
  {
    "text": "Falmouth",
    "value": "falmouth"
  },
  {
    "text": "Fancy Farm",
    "value": "fancy farm"
  },
  {
    "text": "Fancy Gap",
    "value": "fancy gap"
  },
  {
    "text": "Fannettsburg",
    "value": "fannettsburg"
  },
  {
    "text": "Fanwood",
    "value": "fanwood"
  },
  {
    "text": "Far Hills",
    "value": "far hills"
  },
  {
    "text": "Far Rockaway",
    "value": "far rockaway"
  },
  {
    "text": "Farber",
    "value": "farber"
  },
  {
    "text": "Fargo",
    "value": "fargo"
  },
  {
    "text": "Faribault",
    "value": "faribault"
  },
  {
    "text": "Farina",
    "value": "farina"
  },
  {
    "text": "Farley",
    "value": "farley"
  },
  {
    "text": "Farlington",
    "value": "farlington"
  },
  {
    "text": "Farmdale",
    "value": "farmdale"
  },
  {
    "text": "Farmer City",
    "value": "farmer city"
  },
  {
    "text": "Farmers Branch",
    "value": "farmers branch"
  },
  {
    "text": "Farmersburg",
    "value": "farmersburg"
  },
  {
    "text": "Farmersville",
    "value": "farmersville"
  },
  {
    "text": "Farmerville",
    "value": "farmerville"
  },
  {
    "text": "Farmingdale",
    "value": "farmingdale"
  },
  {
    "text": "Farmington",
    "value": "farmington"
  },
  {
    "text": "Farmington Hills",
    "value": "farmington hills"
  },
  {
    "text": "Farmingville",
    "value": "farmingville"
  },
  {
    "text": "Farmland",
    "value": "farmland"
  },
  {
    "text": "Farmville",
    "value": "farmville"
  },
  {
    "text": "Farnam",
    "value": "farnam"
  },
  {
    "text": "Farner",
    "value": "farner"
  },
  {
    "text": "Farnham",
    "value": "farnham"
  },
  {
    "text": "Farnhamville",
    "value": "farnhamville"
  },
  {
    "text": "Farnsworth",
    "value": "farnsworth"
  },
  {
    "text": "Farr West",
    "value": "farr west"
  },
  {
    "text": "Farragut",
    "value": "farragut"
  },
  {
    "text": "Farrell",
    "value": "farrell"
  },
  {
    "text": "Farson",
    "value": "farson"
  },
  {
    "text": "Farwell",
    "value": "farwell"
  },
  {
    "text": "Fate",
    "value": "fate"
  },
  {
    "text": "Faucett",
    "value": "faucett"
  },
  {
    "text": "Faulkner",
    "value": "faulkner"
  },
  {
    "text": "Faulkton",
    "value": "faulkton"
  },
  {
    "text": "Faunsdale",
    "value": "faunsdale"
  },
  {
    "text": "Fawn Grove",
    "value": "fawn grove"
  },
  {
    "text": "Fawnskin",
    "value": "fawnskin"
  },
  {
    "text": "Faxon",
    "value": "faxon"
  },
  {
    "text": "Fay",
    "value": "fay"
  },
  {
    "text": "Fayette",
    "value": "fayette"
  },
  {
    "text": "Fayette City",
    "value": "fayette city"
  },
  {
    "text": "Fayetteville",
    "value": "fayetteville"
  },
  {
    "text": "Fayville",
    "value": "fayville"
  },
  {
    "text": "Feasterville",
    "value": "feasterville"
  },
  {
    "text": "Feasterville-Trevose",
    "value": "feasterville-trevose"
  },
  {
    "text": "Feather Sound",
    "value": "feather sound"
  },
  {
    "text": "Federal Dam",
    "value": "federal dam"
  },
  {
    "text": "Federal Heights",
    "value": "federal heights"
  },
  {
    "text": "Federal Way",
    "value": "federal way"
  },
  {
    "text": "Federalsburg",
    "value": "federalsburg"
  },
  {
    "text": "Fedora",
    "value": "fedora"
  },
  {
    "text": "Fedscreek",
    "value": "fedscreek"
  },
  {
    "text": "Feeding Hills",
    "value": "feeding hills"
  },
  {
    "text": "Felch",
    "value": "felch"
  },
  {
    "text": "Felchville",
    "value": "felchville"
  },
  {
    "text": "Felda",
    "value": "felda"
  },
  {
    "text": "Felicity",
    "value": "felicity"
  },
  {
    "text": "Fellows",
    "value": "fellows"
  },
  {
    "text": "Fellsmere",
    "value": "fellsmere"
  },
  {
    "text": "Felt",
    "value": "felt"
  },
  {
    "text": "Felton",
    "value": "felton"
  },
  {
    "text": "Felts Mills",
    "value": "felts mills"
  },
  {
    "text": "Fence",
    "value": "fence"
  },
  {
    "text": "Fence Lake",
    "value": "fence lake"
  },
  {
    "text": "Fenelton",
    "value": "fenelton"
  },
  {
    "text": "Fennimore",
    "value": "fennimore"
  },
  {
    "text": "Fennville",
    "value": "fennville"
  },
  {
    "text": "Fenton",
    "value": "fenton"
  },
  {
    "text": "Fentress",
    "value": "fentress"
  },
  {
    "text": "Fenwick",
    "value": "fenwick"
  },
  {
    "text": "Fenwick Island",
    "value": "fenwick island"
  },
  {
    "text": "Ferdinand",
    "value": "ferdinand"
  },
  {
    "text": "Fergus Falls",
    "value": "fergus falls"
  },
  {
    "text": "Ferguson",
    "value": "ferguson"
  },
  {
    "text": "Fern Acres",
    "value": "fern acres"
  },
  {
    "text": "Fern Creek",
    "value": "fern creek"
  },
  {
    "text": "Fern Park",
    "value": "fern park"
  },
  {
    "text": "Fernandina Beach",
    "value": "fernandina beach"
  },
  {
    "text": "Ferndale",
    "value": "ferndale"
  },
  {
    "text": "Fernley",
    "value": "fernley"
  },
  {
    "text": "Fernway",
    "value": "fernway"
  },
  {
    "text": "Fernwood",
    "value": "fernwood"
  },
  {
    "text": "Ferriday",
    "value": "ferriday"
  },
  {
    "text": "Ferris",
    "value": "ferris"
  },
  {
    "text": "Ferrisburgh",
    "value": "ferrisburgh"
  },
  {
    "text": "Ferron",
    "value": "ferron"
  },
  {
    "text": "Ferrum",
    "value": "ferrum"
  },
  {
    "text": "Ferrysburg",
    "value": "ferrysburg"
  },
  {
    "text": "Ferryville",
    "value": "ferryville"
  },
  {
    "text": "Fertile",
    "value": "fertile"
  },
  {
    "text": "Fessenden",
    "value": "fessenden"
  },
  {
    "text": "Festus",
    "value": "festus"
  },
  {
    "text": "Feura Bush",
    "value": "feura bush"
  },
  {
    "text": "Fiddletown",
    "value": "fiddletown"
  },
  {
    "text": "Fieldale",
    "value": "fieldale"
  },
  {
    "text": "Fielding",
    "value": "fielding"
  },
  {
    "text": "Fieldon",
    "value": "fieldon"
  },
  {
    "text": "Fieldsboro",
    "value": "fieldsboro"
  },
  {
    "text": "Fife",
    "value": "fife"
  },
  {
    "text": "Fife Lake",
    "value": "fife lake"
  },
  {
    "text": "Fifield",
    "value": "fifield"
  },
  {
    "text": "Fifth Street",
    "value": "fifth street"
  },
  {
    "text": "Fifty Lakes",
    "value": "fifty lakes"
  },
  {
    "text": "Fifty-Six",
    "value": "fifty-six"
  },
  {
    "text": "Filer",
    "value": "filer"
  },
  {
    "text": "Filer City",
    "value": "filer city"
  },
  {
    "text": "Filion",
    "value": "filion"
  },
  {
    "text": "Filley",
    "value": "filley"
  },
  {
    "text": "Fillmore",
    "value": "fillmore"
  },
  {
    "text": "Fincastle",
    "value": "fincastle"
  },
  {
    "text": "Finchville",
    "value": "finchville"
  },
  {
    "text": "Findlay",
    "value": "findlay"
  },
  {
    "text": "Findley Lake",
    "value": "findley lake"
  },
  {
    "text": "Fine",
    "value": "fine"
  },
  {
    "text": "Fingal",
    "value": "fingal"
  },
  {
    "text": "Finger",
    "value": "finger"
  },
  {
    "text": "Finksburg",
    "value": "finksburg"
  },
  {
    "text": "Finland",
    "value": "finland"
  },
  {
    "text": "Finlayson",
    "value": "finlayson"
  },
  {
    "text": "Finley",
    "value": "finley"
  },
  {
    "text": "Finleyville",
    "value": "finleyville"
  },
  {
    "text": "Fircrest",
    "value": "fircrest"
  },
  {
    "text": "Fire Island",
    "value": "fire island"
  },
  {
    "text": "Firebaugh",
    "value": "firebaugh"
  },
  {
    "text": "Firestone",
    "value": "firestone"
  },
  {
    "text": "Firth",
    "value": "firth"
  },
  {
    "text": "Fischer",
    "value": "fischer"
  },
  {
    "text": "Fish Camp",
    "value": "fish camp"
  },
  {
    "text": "Fish Creek",
    "value": "fish creek"
  },
  {
    "text": "Fish Haven",
    "value": "fish haven"
  },
  {
    "text": "Fish Lake",
    "value": "fish lake"
  },
  {
    "text": "Fisher",
    "value": "fisher"
  },
  {
    "text": "Fishers",
    "value": "fishers"
  },
  {
    "text": "Fishers Island",
    "value": "fishers island"
  },
  {
    "text": "Fishersville",
    "value": "fishersville"
  },
  {
    "text": "Fishertown",
    "value": "fishertown"
  },
  {
    "text": "Fisherville",
    "value": "fisherville"
  },
  {
    "text": "Fishhook",
    "value": "fishhook"
  },
  {
    "text": "Fishing Creek",
    "value": "fishing creek"
  },
  {
    "text": "Fishkill",
    "value": "fishkill"
  },
  {
    "text": "Fishs Eddy",
    "value": "fishs eddy"
  },
  {
    "text": "Fishtail",
    "value": "fishtail"
  },
  {
    "text": "Fisk",
    "value": "fisk"
  },
  {
    "text": "Fiskdale",
    "value": "fiskdale"
  },
  {
    "text": "Fisty",
    "value": "fisty"
  },
  {
    "text": "Fitchburg",
    "value": "fitchburg"
  },
  {
    "text": "Fithian",
    "value": "fithian"
  },
  {
    "text": "Fitzgerald",
    "value": "fitzgerald"
  },
  {
    "text": "Fitzhugh",
    "value": "fitzhugh"
  },
  {
    "text": "Fitzpatrick",
    "value": "fitzpatrick"
  },
  {
    "text": "Fitzwilliam",
    "value": "fitzwilliam"
  },
  {
    "text": "Five Points",
    "value": "five points"
  },
  {
    "text": "Flag Pond",
    "value": "flag pond"
  },
  {
    "text": "Flagler",
    "value": "flagler"
  },
  {
    "text": "Flagler Beach",
    "value": "flagler beach"
  },
  {
    "text": "Flagstaff",
    "value": "flagstaff"
  },
  {
    "text": "Flagtown",
    "value": "flagtown"
  },
  {
    "text": "Flanagan",
    "value": "flanagan"
  },
  {
    "text": "Flanders",
    "value": "flanders"
  },
  {
    "text": "Flandreau",
    "value": "flandreau"
  },
  {
    "text": "Flasher",
    "value": "flasher"
  },
  {
    "text": "Flat",
    "value": "flat"
  },
  {
    "text": "Flat Lick",
    "value": "flat lick"
  },
  {
    "text": "Flat River",
    "value": "flat river"
  },
  {
    "text": "Flat Rock",
    "value": "flat rock"
  },
  {
    "text": "Flat Top",
    "value": "flat top"
  },
  {
    "text": "Flatbush",
    "value": "flatbush"
  },
  {
    "text": "Flatgap",
    "value": "flatgap"
  },
  {
    "text": "Flatonia",
    "value": "flatonia"
  },
  {
    "text": "Flatwoods",
    "value": "flatwoods"
  },
  {
    "text": "Flaxton",
    "value": "flaxton"
  },
  {
    "text": "Flaxville",
    "value": "flaxville"
  },
  {
    "text": "Fleetwood",
    "value": "fleetwood"
  },
  {
    "text": "Fleischmanns",
    "value": "fleischmanns"
  },
  {
    "text": "Fleming",
    "value": "fleming"
  },
  {
    "text": "Fleming Island",
    "value": "fleming island"
  },
  {
    "text": "Fleming-Neon",
    "value": "fleming-neon"
  },
  {
    "text": "Flemingsburg",
    "value": "flemingsburg"
  },
  {
    "text": "Flemington",
    "value": "flemington"
  },
  {
    "text": "Fletcher",
    "value": "fletcher"
  },
  {
    "text": "Flicksville",
    "value": "flicksville"
  },
  {
    "text": "Flint",
    "value": "flint"
  },
  {
    "text": "Flint Hill",
    "value": "flint hill"
  },
  {
    "text": "Flinton",
    "value": "flinton"
  },
  {
    "text": "Flintstone",
    "value": "flintstone"
  },
  {
    "text": "Flintville",
    "value": "flintville"
  },
  {
    "text": "Flippin",
    "value": "flippin"
  },
  {
    "text": "Flom",
    "value": "flom"
  },
  {
    "text": "Flomaton",
    "value": "flomaton"
  },
  {
    "text": "Flomot",
    "value": "flomot"
  },
  {
    "text": "Floodwood",
    "value": "floodwood"
  },
  {
    "text": "Flora",
    "value": "flora"
  },
  {
    "text": "Flora Vista",
    "value": "flora vista"
  },
  {
    "text": "Florahome",
    "value": "florahome"
  },
  {
    "text": "Floral",
    "value": "floral"
  },
  {
    "text": "Floral City",
    "value": "floral city"
  },
  {
    "text": "Floral Park",
    "value": "floral park"
  },
  {
    "text": "Florala",
    "value": "florala"
  },
  {
    "text": "Florence",
    "value": "florence"
  },
  {
    "text": "Florence-Graham",
    "value": "florence-graham"
  },
  {
    "text": "Floresville",
    "value": "floresville"
  },
  {
    "text": "Florham Park",
    "value": "florham park"
  },
  {
    "text": "Florida",
    "value": "florida"
  },
  {
    "text": "Florida City",
    "value": "florida city"
  },
  {
    "text": "Florien",
    "value": "florien"
  },
  {
    "text": "Florin",
    "value": "florin"
  },
  {
    "text": "Floris",
    "value": "floris"
  },
  {
    "text": "Florissant",
    "value": "florissant"
  },
  {
    "text": "Floriston",
    "value": "floriston"
  },
  {
    "text": "Flossmoor",
    "value": "flossmoor"
  },
  {
    "text": "Flourtown",
    "value": "flourtown"
  },
  {
    "text": "Flovilla",
    "value": "flovilla"
  },
  {
    "text": "Flower Mound",
    "value": "flower mound"
  },
  {
    "text": "Floweree",
    "value": "floweree"
  },
  {
    "text": "Flowery Branch",
    "value": "flowery branch"
  },
  {
    "text": "Flowood",
    "value": "flowood"
  },
  {
    "text": "Floyd",
    "value": "floyd"
  },
  {
    "text": "Floydada",
    "value": "floydada"
  },
  {
    "text": "Floyds Knobs",
    "value": "floyds knobs"
  },
  {
    "text": "Fluker",
    "value": "fluker"
  },
  {
    "text": "Flushing",
    "value": "flushing"
  },
  {
    "text": "Fluvanna",
    "value": "fluvanna"
  },
  {
    "text": "Fly Creek",
    "value": "fly creek"
  },
  {
    "text": "Flynn",
    "value": "flynn"
  },
  {
    "text": "Fogelsville",
    "value": "fogelsville"
  },
  {
    "text": "Folcroft",
    "value": "folcroft"
  },
  {
    "text": "Foley",
    "value": "foley"
  },
  {
    "text": "Folkston",
    "value": "folkston"
  },
  {
    "text": "Follansbee",
    "value": "follansbee"
  },
  {
    "text": "Follett",
    "value": "follett"
  },
  {
    "text": "Folly Beach",
    "value": "folly beach"
  },
  {
    "text": "Folsom",
    "value": "folsom"
  },
  {
    "text": "Fombell",
    "value": "fombell"
  },
  {
    "text": "Fond du Lac",
    "value": "fond du lac"
  },
  {
    "text": "Fonda",
    "value": "fonda"
  },
  {
    "text": "Fontana",
    "value": "fontana"
  },
  {
    "text": "Fontana Dam",
    "value": "fontana dam"
  },
  {
    "text": "Fontanelle",
    "value": "fontanelle"
  },
  {
    "text": "Foosland",
    "value": "foosland"
  },
  {
    "text": "Foothill Ranch",
    "value": "foothill ranch"
  },
  {
    "text": "Footville",
    "value": "footville"
  },
  {
    "text": "Forbes",
    "value": "forbes"
  },
  {
    "text": "Forbestown",
    "value": "forbestown"
  },
  {
    "text": "Force",
    "value": "force"
  },
  {
    "text": "Ford",
    "value": "ford"
  },
  {
    "text": "Ford City",
    "value": "ford city"
  },
  {
    "text": "Ford Cliff",
    "value": "ford cliff"
  },
  {
    "text": "Ford Heights",
    "value": "ford heights"
  },
  {
    "text": "Fordland",
    "value": "fordland"
  },
  {
    "text": "Fordoche",
    "value": "fordoche"
  },
  {
    "text": "Fords",
    "value": "fords"
  },
  {
    "text": "Fords Branch",
    "value": "fords branch"
  },
  {
    "text": "Fordsville",
    "value": "fordsville"
  },
  {
    "text": "Fordville",
    "value": "fordville"
  },
  {
    "text": "Fordyce",
    "value": "fordyce"
  },
  {
    "text": "Foreman",
    "value": "foreman"
  },
  {
    "text": "Forest",
    "value": "forest"
  },
  {
    "text": "Forest Acres",
    "value": "forest acres"
  },
  {
    "text": "Forest City",
    "value": "forest city"
  },
  {
    "text": "Forest Falls",
    "value": "forest falls"
  },
  {
    "text": "Forest Green",
    "value": "forest green"
  },
  {
    "text": "Forest Grove",
    "value": "forest grove"
  },
  {
    "text": "Forest Hill",
    "value": "forest hill"
  },
  {
    "text": "Forest Hills",
    "value": "forest hills"
  },
  {
    "text": "Forest Home",
    "value": "forest home"
  },
  {
    "text": "Forest Knolls",
    "value": "forest knolls"
  },
  {
    "text": "Forest Lake",
    "value": "forest lake"
  },
  {
    "text": "Forest Meadows",
    "value": "forest meadows"
  },
  {
    "text": "Forest Park",
    "value": "forest park"
  },
  {
    "text": "Forest Ranch",
    "value": "forest ranch"
  },
  {
    "text": "Forest River",
    "value": "forest river"
  },
  {
    "text": "Forestburg",
    "value": "forestburg"
  },
  {
    "text": "Forestburgh",
    "value": "forestburgh"
  },
  {
    "text": "Forestdale",
    "value": "forestdale"
  },
  {
    "text": "Foresthill",
    "value": "foresthill"
  },
  {
    "text": "Foreston",
    "value": "foreston"
  },
  {
    "text": "Forestport",
    "value": "forestport"
  },
  {
    "text": "Forestville",
    "value": "forestville"
  },
  {
    "text": "Forgan",
    "value": "forgan"
  },
  {
    "text": "Foristell",
    "value": "foristell"
  },
  {
    "text": "Fork",
    "value": "fork"
  },
  {
    "text": "Fork Union",
    "value": "fork union"
  },
  {
    "text": "Forked River",
    "value": "forked river"
  },
  {
    "text": "Forkland",
    "value": "forkland"
  },
  {
    "text": "Forks",
    "value": "forks"
  },
  {
    "text": "Forks Of Salmon",
    "value": "forks of salmon"
  },
  {
    "text": "Forksville",
    "value": "forksville"
  },
  {
    "text": "Forman",
    "value": "forman"
  },
  {
    "text": "Formoso",
    "value": "formoso"
  },
  {
    "text": "Forney",
    "value": "forney"
  },
  {
    "text": "Forrest",
    "value": "forrest"
  },
  {
    "text": "Forrest City",
    "value": "forrest city"
  },
  {
    "text": "Forreston",
    "value": "forreston"
  },
  {
    "text": "Forsan",
    "value": "forsan"
  },
  {
    "text": "Forsyth",
    "value": "forsyth"
  },
  {
    "text": "Fort Ann",
    "value": "fort ann"
  },
  {
    "text": "Fort Apache",
    "value": "fort apache"
  },
  {
    "text": "Fort Ashby",
    "value": "fort ashby"
  },
  {
    "text": "Fort Atkinson",
    "value": "fort atkinson"
  },
  {
    "text": "Fort Belknap Agency",
    "value": "fort belknap agency"
  },
  {
    "text": "Fort Belvoir",
    "value": "fort belvoir"
  },
  {
    "text": "Fort Benning",
    "value": "fort benning"
  },
  {
    "text": "Fort Benton",
    "value": "fort benton"
  },
  {
    "text": "Fort Bidwell",
    "value": "fort bidwell"
  },
  {
    "text": "Fort Blackmore",
    "value": "fort blackmore"
  },
  {
    "text": "Fort Bliss",
    "value": "fort bliss"
  },
  {
    "text": "Fort Bragg",
    "value": "fort bragg"
  },
  {
    "text": "Fort Branch",
    "value": "fort branch"
  },
  {
    "text": "Fort Calhoun",
    "value": "fort calhoun"
  },
  {
    "text": "Fort Campbell",
    "value": "fort campbell"
  },
  {
    "text": "Fort Campbell North",
    "value": "fort campbell north"
  },
  {
    "text": "Fort Carson",
    "value": "fort carson"
  },
  {
    "text": "Fort Cavazos",
    "value": "fort cavazos"
  },
  {
    "text": "Fort Cobb",
    "value": "fort cobb"
  },
  {
    "text": "Fort Collins",
    "value": "fort collins"
  },
  {
    "text": "Fort Covington",
    "value": "fort covington"
  },
  {
    "text": "Fort Davis",
    "value": "fort davis"
  },
  {
    "text": "Fort Defiance",
    "value": "fort defiance"
  },
  {
    "text": "Fort Deposit",
    "value": "fort deposit"
  },
  {
    "text": "Fort Dick",
    "value": "fort dick"
  },
  {
    "text": "Fort Dix",
    "value": "fort dix"
  },
  {
    "text": "Fort Dodge",
    "value": "fort dodge"
  },
  {
    "text": "Fort Drum",
    "value": "fort drum"
  },
  {
    "text": "Fort Duchesne",
    "value": "fort duchesne"
  },
  {
    "text": "Fort Edward",
    "value": "fort edward"
  },
  {
    "text": "Fort Eustis",
    "value": "fort eustis"
  },
  {
    "text": "Fort Fairfield",
    "value": "fort fairfield"
  },
  {
    "text": "Fort Gaines",
    "value": "fort gaines"
  },
  {
    "text": "Fort Garland",
    "value": "fort garland"
  },
  {
    "text": "Fort Gay",
    "value": "fort gay"
  },
  {
    "text": "Fort George G. Meade",
    "value": "fort george g. meade"
  },
  {
    "text": "Fort Gibson",
    "value": "fort gibson"
  },
  {
    "text": "Fort Gratiot",
    "value": "fort gratiot"
  },
  {
    "text": "Fort Greely",
    "value": "fort greely"
  },
  {
    "text": "Fort Hall",
    "value": "fort hall"
  },
  {
    "text": "Fort Hancock",
    "value": "fort hancock"
  },
  {
    "text": "Fort Harrison",
    "value": "fort harrison"
  },
  {
    "text": "Fort Hill",
    "value": "fort hill"
  },
  {
    "text": "Fort Hood",
    "value": "fort hood"
  },
  {
    "text": "Fort Howard",
    "value": "fort howard"
  },
  {
    "text": "Fort Huachuca",
    "value": "fort huachuca"
  },
  {
    "text": "Fort Hunter",
    "value": "fort hunter"
  },
  {
    "text": "Fort Irwin",
    "value": "fort irwin"
  },
  {
    "text": "Fort Jennings",
    "value": "fort jennings"
  },
  {
    "text": "Fort Johnson",
    "value": "fort johnson"
  },
  {
    "text": "Fort Jones",
    "value": "fort jones"
  },
  {
    "text": "Fort Kent",
    "value": "fort kent"
  },
  {
    "text": "Fort Klamath",
    "value": "fort klamath"
  },
  {
    "text": "Fort Knox",
    "value": "fort knox"
  },
  {
    "text": "Fort Laramie",
    "value": "fort laramie"
  },
  {
    "text": "Fort Lauderdale",
    "value": "fort lauderdale"
  },
  {
    "text": "Fort Lawn",
    "value": "fort lawn"
  },
  {
    "text": "Fort Leavenworth",
    "value": "fort leavenworth"
  },
  {
    "text": "Fort Lee",
    "value": "fort lee"
  },
  {
    "text": "Fort Leonard Wood",
    "value": "fort leonard wood"
  },
  {
    "text": "Fort Lewis",
    "value": "fort lewis"
  },
  {
    "text": "Fort Littleton",
    "value": "fort littleton"
  },
  {
    "text": "Fort Loramie",
    "value": "fort loramie"
  },
  {
    "text": "Fort Loudon",
    "value": "fort loudon"
  },
  {
    "text": "Fort Lupton",
    "value": "fort lupton"
  },
  {
    "text": "Fort Madison",
    "value": "fort madison"
  },
  {
    "text": "Fort McCoy",
    "value": "fort mccoy"
  },
  {
    "text": "Fort McDowell",
    "value": "fort mcdowell"
  },
  {
    "text": "Fort Meade",
    "value": "fort meade"
  },
  {
    "text": "Fort Mill",
    "value": "fort mill"
  },
  {
    "text": "Fort Mitchell",
    "value": "fort mitchell"
  },
  {
    "text": "Fort Mohave",
    "value": "fort mohave"
  },
  {
    "text": "Fort Monmouth",
    "value": "fort monmouth"
  },
  {
    "text": "Fort Monroe",
    "value": "fort monroe"
  },
  {
    "text": "Fort Montgomery",
    "value": "fort montgomery"
  },
  {
    "text": "Fort Morgan",
    "value": "fort morgan"
  },
  {
    "text": "Fort Myer",
    "value": "fort myer"
  },
  {
    "text": "Fort Myers",
    "value": "fort myers"
  },
  {
    "text": "Fort Myers Beach",
    "value": "fort myers beach"
  },
  {
    "text": "Fort Necessity",
    "value": "fort necessity"
  },
  {
    "text": "Fort Novosel",
    "value": "fort novosel"
  },
  {
    "text": "Fort Ogden",
    "value": "fort ogden"
  },
  {
    "text": "Fort Oglethorpe",
    "value": "fort oglethorpe"
  },
  {
    "text": "Fort Payne",
    "value": "fort payne"
  },
  {
    "text": "Fort Peck",
    "value": "fort peck"
  },
  {
    "text": "Fort Pierce",
    "value": "fort pierce"
  },
  {
    "text": "Fort Pierre",
    "value": "fort pierre"
  },
  {
    "text": "Fort Plain",
    "value": "fort plain"
  },
  {
    "text": "Fort Polk",
    "value": "fort polk"
  },
  {
    "text": "Fort Polk South",
    "value": "fort polk south"
  },
  {
    "text": "Fort Ransom",
    "value": "fort ransom"
  },
  {
    "text": "Fort Recovery",
    "value": "fort recovery"
  },
  {
    "text": "Fort Richardson",
    "value": "fort richardson"
  },
  {
    "text": "Fort Riley",
    "value": "fort riley"
  },
  {
    "text": "Fort Ripley",
    "value": "fort ripley"
  },
  {
    "text": "Fort Rock",
    "value": "fort rock"
  },
  {
    "text": "Fort Rucker",
    "value": "fort rucker"
  },
  {
    "text": "Fort Sam Houston Joint Base San Antonio",
    "value": "fort sam houston joint base san antonio"
  },
  {
    "text": "Fort Scott",
    "value": "fort scott"
  },
  {
    "text": "Fort Shafter",
    "value": "fort shafter"
  },
  {
    "text": "Fort Shaw",
    "value": "fort shaw"
  },
  {
    "text": "Fort Sheridan",
    "value": "fort sheridan"
  },
  {
    "text": "Fort Sill",
    "value": "fort sill"
  },
  {
    "text": "Fort Smith",
    "value": "fort smith"
  },
  {
    "text": "Fort Stanton",
    "value": "fort stanton"
  },
  {
    "text": "Fort Stewart",
    "value": "fort stewart"
  },
  {
    "text": "Fort Stockton",
    "value": "fort stockton"
  },
  {
    "text": "Fort Sumner",
    "value": "fort sumner"
  },
  {
    "text": "Fort Supply",
    "value": "fort supply"
  },
  {
    "text": "Fort Thomas",
    "value": "fort thomas"
  },
  {
    "text": "Fort Thompson",
    "value": "fort thompson"
  },
  {
    "text": "Fort Totten",
    "value": "fort totten"
  },
  {
    "text": "Fort Towson",
    "value": "fort towson"
  },
  {
    "text": "Fort Valley",
    "value": "fort valley"
  },
  {
    "text": "Fort Wainwright",
    "value": "fort wainwright"
  },
  {
    "text": "Fort Walton Beach",
    "value": "fort walton beach"
  },
  {
    "text": "Fort Washakie",
    "value": "fort washakie"
  },
  {
    "text": "Fort Washington",
    "value": "fort washington"
  },
  {
    "text": "Fort Wayne",
    "value": "fort wayne"
  },
  {
    "text": "Fort White",
    "value": "fort white"
  },
  {
    "text": "Fort Wingate",
    "value": "fort wingate"
  },
  {
    "text": "Fort Worth",
    "value": "fort worth"
  },
  {
    "text": "Fort Wright",
    "value": "fort wright"
  },
  {
    "text": "Fort Yates",
    "value": "fort yates"
  },
  {
    "text": "Fort Yukon",
    "value": "fort yukon"
  },
  {
    "text": "Fortine",
    "value": "fortine"
  },
  {
    "text": "Fortson",
    "value": "fortson"
  },
  {
    "text": "Fortuna",
    "value": "fortuna"
  },
  {
    "text": "Fortuna Foothills",
    "value": "fortuna foothills"
  },
  {
    "text": "Fortville",
    "value": "fortville"
  },
  {
    "text": "Forty Fort",
    "value": "forty fort"
  },
  {
    "text": "Foss",
    "value": "foss"
  },
  {
    "text": "Fossil",
    "value": "fossil"
  },
  {
    "text": "Fosston",
    "value": "fosston"
  },
  {
    "text": "Foster",
    "value": "foster"
  },
  {
    "text": "Foster City",
    "value": "foster city"
  },
  {
    "text": "Fosters",
    "value": "fosters"
  },
  {
    "text": "Fostoria",
    "value": "fostoria"
  },
  {
    "text": "Fouke",
    "value": "fouke"
  },
  {
    "text": "Fountain",
    "value": "fountain"
  },
  {
    "text": "Fountain City",
    "value": "fountain city"
  },
  {
    "text": "Fountain Green",
    "value": "fountain green"
  },
  {
    "text": "Fountain Hill",
    "value": "fountain hill"
  },
  {
    "text": "Fountain Hills",
    "value": "fountain hills"
  },
  {
    "text": "Fountain Inn",
    "value": "fountain inn"
  },
  {
    "text": "Fountain Run",
    "value": "fountain run"
  },
  {
    "text": "Fountain Valley",
    "value": "fountain valley"
  },
  {
    "text": "Fountainebleau",
    "value": "fountainebleau"
  },
  {
    "text": "Fountaintown",
    "value": "fountaintown"
  },
  {
    "text": "Fountainville",
    "value": "fountainville"
  },
  {
    "text": "Four Corners",
    "value": "four corners"
  },
  {
    "text": "Four Oaks",
    "value": "four oaks"
  },
  {
    "text": "Four Seasons",
    "value": "four seasons"
  },
  {
    "text": "Four States",
    "value": "four states"
  },
  {
    "text": "Fourmile",
    "value": "fourmile"
  },
  {
    "text": "Fowler",
    "value": "fowler"
  },
  {
    "text": "Fowlerton",
    "value": "fowlerton"
  },
  {
    "text": "Fowlerville",
    "value": "fowlerville"
  },
  {
    "text": "Fowlstown",
    "value": "fowlstown"
  },
  {
    "text": "Fox",
    "value": "fox"
  },
  {
    "text": "Fox Chapel",
    "value": "fox chapel"
  },
  {
    "text": "Fox Farm-College",
    "value": "fox farm-college"
  },
  {
    "text": "Fox Island",
    "value": "fox island"
  },
  {
    "text": "Fox Lake",
    "value": "fox lake"
  },
  {
    "text": "Fox Lake Hills",
    "value": "fox lake hills"
  },
  {
    "text": "Fox Point",
    "value": "fox point"
  },
  {
    "text": "Fox River Grove",
    "value": "fox river grove"
  },
  {
    "text": "Fox Valley",
    "value": "fox valley"
  },
  {
    "text": "Foxboro",
    "value": "foxboro"
  },
  {
    "text": "Foxborough",
    "value": "foxborough"
  },
  {
    "text": "Foxburg",
    "value": "foxburg"
  },
  {
    "text": "Foxfield",
    "value": "foxfield"
  },
  {
    "text": "Foxhome",
    "value": "foxhome"
  },
  {
    "text": "Foxton",
    "value": "foxton"
  },
  {
    "text": "Foxworth",
    "value": "foxworth"
  },
  {
    "text": "Foyil",
    "value": "foyil"
  },
  {
    "text": "Frackville",
    "value": "frackville"
  },
  {
    "text": "Frakes",
    "value": "frakes"
  },
  {
    "text": "Frametown",
    "value": "frametown"
  },
  {
    "text": "Framingham",
    "value": "framingham"
  },
  {
    "text": "Framingham Center",
    "value": "framingham center"
  },
  {
    "text": "Francestown",
    "value": "francestown"
  },
  {
    "text": "Francesville",
    "value": "francesville"
  },
  {
    "text": "Francis",
    "value": "francis"
  },
  {
    "text": "Francisco",
    "value": "francisco"
  },
  {
    "text": "Franconia",
    "value": "franconia"
  },
  {
    "text": "Frankenmuth",
    "value": "frankenmuth"
  },
  {
    "text": "Frankewing",
    "value": "frankewing"
  },
  {
    "text": "Frankford",
    "value": "frankford"
  },
  {
    "text": "Frankfort",
    "value": "frankfort"
  },
  {
    "text": "Frankfort Heights",
    "value": "frankfort heights"
  },
  {
    "text": "Franklin",
    "value": "franklin"
  },
  {
    "text": "Franklin Furnace",
    "value": "franklin furnace"
  },
  {
    "text": "Franklin Grove",
    "value": "franklin grove"
  },
  {
    "text": "Franklin Lakes",
    "value": "franklin lakes"
  },
  {
    "text": "Franklin Park",
    "value": "franklin park"
  },
  {
    "text": "Franklin Springs",
    "value": "franklin springs"
  },
  {
    "text": "Franklin Square",
    "value": "franklin square"
  },
  {
    "text": "Franklinton",
    "value": "franklinton"
  },
  {
    "text": "Franklintown",
    "value": "franklintown"
  },
  {
    "text": "Franklinville",
    "value": "franklinville"
  },
  {
    "text": "Frankston",
    "value": "frankston"
  },
  {
    "text": "Franksville",
    "value": "franksville"
  },
  {
    "text": "Frankton",
    "value": "frankton"
  },
  {
    "text": "Franktown",
    "value": "franktown"
  },
  {
    "text": "Frankville",
    "value": "frankville"
  },
  {
    "text": "Fraser",
    "value": "fraser"
  },
  {
    "text": "Frazee",
    "value": "frazee"
  },
  {
    "text": "Frazer",
    "value": "frazer"
  },
  {
    "text": "Frazeysburg",
    "value": "frazeysburg"
  },
  {
    "text": "Frazier Park",
    "value": "frazier park"
  },
  {
    "text": "Fraziers Bottom",
    "value": "fraziers bottom"
  },
  {
    "text": "Fred",
    "value": "fred"
  },
  {
    "text": "Frederic",
    "value": "frederic"
  },
  {
    "text": "Frederica",
    "value": "frederica"
  },
  {
    "text": "Frederick",
    "value": "frederick"
  },
  {
    "text": "Fredericksburg",
    "value": "fredericksburg"
  },
  {
    "text": "Fredericktown",
    "value": "fredericktown"
  },
  {
    "text": "Fredonia",
    "value": "fredonia"
  },
  {
    "text": "Free Soil",
    "value": "free soil"
  },
  {
    "text": "Free Union",
    "value": "free union"
  },
  {
    "text": "Freeborn",
    "value": "freeborn"
  },
  {
    "text": "Freeburg",
    "value": "freeburg"
  },
  {
    "text": "Freeburn",
    "value": "freeburn"
  },
  {
    "text": "Freedom",
    "value": "freedom"
  },
  {
    "text": "Freehold",
    "value": "freehold"
  },
  {
    "text": "Freeland",
    "value": "freeland"
  },
  {
    "text": "Freelandville",
    "value": "freelandville"
  },
  {
    "text": "Freeman",
    "value": "freeman"
  },
  {
    "text": "Freeport",
    "value": "freeport"
  },
  {
    "text": "Freer",
    "value": "freer"
  },
  {
    "text": "Freetown",
    "value": "freetown"
  },
  {
    "text": "Freeville",
    "value": "freeville"
  },
  {
    "text": "Freistatt",
    "value": "freistatt"
  },
  {
    "text": "Fremont",
    "value": "fremont"
  },
  {
    "text": "French Camp",
    "value": "french camp"
  },
  {
    "text": "French Creek",
    "value": "french creek"
  },
  {
    "text": "French Lick",
    "value": "french lick"
  },
  {
    "text": "French Settlement",
    "value": "french settlement"
  },
  {
    "text": "French Village",
    "value": "french village"
  },
  {
    "text": "Frenchburg",
    "value": "frenchburg"
  },
  {
    "text": "Frenchs Corner",
    "value": "frenchs corner"
  },
  {
    "text": "Frenchtown",
    "value": "frenchtown"
  },
  {
    "text": "Frenchville",
    "value": "frenchville"
  },
  {
    "text": "Fresh Meadows",
    "value": "fresh meadows"
  },
  {
    "text": "Fresno",
    "value": "fresno"
  },
  {
    "text": "Frewsburg",
    "value": "frewsburg"
  },
  {
    "text": "Friant",
    "value": "friant"
  },
  {
    "text": "Friars Point",
    "value": "friars point"
  },
  {
    "text": "Friday Harbor",
    "value": "friday harbor"
  },
  {
    "text": "Fridley",
    "value": "fridley"
  },
  {
    "text": "Friedens",
    "value": "friedens"
  },
  {
    "text": "Friedensburg",
    "value": "friedensburg"
  },
  {
    "text": "Friedheim",
    "value": "friedheim"
  },
  {
    "text": "Friend",
    "value": "friend"
  },
  {
    "text": "Friendly",
    "value": "friendly"
  },
  {
    "text": "Friendship",
    "value": "friendship"
  },
  {
    "text": "Friendsville",
    "value": "friendsville"
  },
  {
    "text": "Friendswood",
    "value": "friendswood"
  },
  {
    "text": "Frierson",
    "value": "frierson"
  },
  {
    "text": "Fries",
    "value": "fries"
  },
  {
    "text": "Friesland",
    "value": "friesland"
  },
  {
    "text": "Friona",
    "value": "friona"
  },
  {
    "text": "Frisco",
    "value": "frisco"
  },
  {
    "text": "Frisco City",
    "value": "frisco city"
  },
  {
    "text": "Fritch",
    "value": "fritch"
  },
  {
    "text": "Frohna",
    "value": "frohna"
  },
  {
    "text": "Froid",
    "value": "froid"
  },
  {
    "text": "Fromberg",
    "value": "fromberg"
  },
  {
    "text": "Front Royal",
    "value": "front royal"
  },
  {
    "text": "Frontenac",
    "value": "frontenac"
  },
  {
    "text": "Frontier",
    "value": "frontier"
  },
  {
    "text": "Frost",
    "value": "frost"
  },
  {
    "text": "Frostburg",
    "value": "frostburg"
  },
  {
    "text": "Frostproof",
    "value": "frostproof"
  },
  {
    "text": "Fruit Cove",
    "value": "fruit cove"
  },
  {
    "text": "Fruit Heights",
    "value": "fruit heights"
  },
  {
    "text": "Fruita",
    "value": "fruita"
  },
  {
    "text": "Fruitdale",
    "value": "fruitdale"
  },
  {
    "text": "Fruithurst",
    "value": "fruithurst"
  },
  {
    "text": "Fruitland",
    "value": "fruitland"
  },
  {
    "text": "Fruitland Park",
    "value": "fruitland park"
  },
  {
    "text": "Fruitport",
    "value": "fruitport"
  },
  {
    "text": "Fruitvale",
    "value": "fruitvale"
  },
  {
    "text": "Fruitville",
    "value": "fruitville"
  },
  {
    "text": "Fryburg",
    "value": "fryburg"
  },
  {
    "text": "Frye Island",
    "value": "frye island"
  },
  {
    "text": "Fryeburg",
    "value": "fryeburg"
  },
  {
    "text": "Ft. Pierce",
    "value": "ft. pierce"
  },
  {
    "text": "Ft. Washington",
    "value": "ft. washington"
  },
  {
    "text": "Fulda",
    "value": "fulda"
  },
  {
    "text": "Fulks Run",
    "value": "fulks run"
  },
  {
    "text": "Fullerton",
    "value": "fullerton"
  },
  {
    "text": "Fulshear",
    "value": "fulshear"
  },
  {
    "text": "Fulton",
    "value": "fulton"
  },
  {
    "text": "Fultondale",
    "value": "fultondale"
  },
  {
    "text": "Fultonham",
    "value": "fultonham"
  },
  {
    "text": "Fultonville",
    "value": "fultonville"
  },
  {
    "text": "Fults",
    "value": "fults"
  },
  {
    "text": "Funk",
    "value": "funk"
  },
  {
    "text": "Funkstown",
    "value": "funkstown"
  },
  {
    "text": "Funston",
    "value": "funston"
  },
  {
    "text": "Fuquay-Varina",
    "value": "fuquay-varina"
  },
  {
    "text": "Furlong",
    "value": "furlong"
  },
  {
    "text": "Furman",
    "value": "furman"
  },
  {
    "text": "Furnace Creek",
    "value": "furnace creek"
  },
  {
    "text": "Fyffe",
    "value": "fyffe"
  },
  {
    "text": "Gaastra",
    "value": "gaastra"
  },
  {
    "text": "Gabbs",
    "value": "gabbs"
  },
  {
    "text": "Gable",
    "value": "gable"
  },
  {
    "text": "Gabriels",
    "value": "gabriels"
  },
  {
    "text": "Gackle",
    "value": "gackle"
  },
  {
    "text": "Gadsden",
    "value": "gadsden"
  },
  {
    "text": "Gaffney",
    "value": "gaffney"
  },
  {
    "text": "Gage",
    "value": "gage"
  },
  {
    "text": "Gagetown",
    "value": "gagetown"
  },
  {
    "text": "Gahanna",
    "value": "gahanna"
  },
  {
    "text": "Gail",
    "value": "gail"
  },
  {
    "text": "Gaines",
    "value": "gaines"
  },
  {
    "text": "Gainesboro",
    "value": "gainesboro"
  },
  {
    "text": "Gainestown",
    "value": "gainestown"
  },
  {
    "text": "Gainesville",
    "value": "gainesville"
  },
  {
    "text": "Gaithersburg",
    "value": "gaithersburg"
  },
  {
    "text": "Gakona",
    "value": "gakona"
  },
  {
    "text": "Galata",
    "value": "galata"
  },
  {
    "text": "Galatia",
    "value": "galatia"
  },
  {
    "text": "Galax",
    "value": "galax"
  },
  {
    "text": "Galena",
    "value": "galena"
  },
  {
    "text": "Galena Park",
    "value": "galena park"
  },
  {
    "text": "Gales Creek",
    "value": "gales creek"
  },
  {
    "text": "Gales Ferry",
    "value": "gales ferry"
  },
  {
    "text": "Galesburg",
    "value": "galesburg"
  },
  {
    "text": "Galesville",
    "value": "galesville"
  },
  {
    "text": "Galeton",
    "value": "galeton"
  },
  {
    "text": "Galeville",
    "value": "galeville"
  },
  {
    "text": "Galien",
    "value": "galien"
  },
  {
    "text": "Galion",
    "value": "galion"
  },
  {
    "text": "Galivants Ferry",
    "value": "galivants ferry"
  },
  {
    "text": "Gallagher",
    "value": "gallagher"
  },
  {
    "text": "Gallant",
    "value": "gallant"
  },
  {
    "text": "Gallatin",
    "value": "gallatin"
  },
  {
    "text": "Gallatin Gateway",
    "value": "gallatin gateway"
  },
  {
    "text": "Gallaway",
    "value": "gallaway"
  },
  {
    "text": "Galliano",
    "value": "galliano"
  },
  {
    "text": "Gallina",
    "value": "gallina"
  },
  {
    "text": "Gallion",
    "value": "gallion"
  },
  {
    "text": "Gallipolis",
    "value": "gallipolis"
  },
  {
    "text": "Gallipolis Ferry",
    "value": "gallipolis ferry"
  },
  {
    "text": "Gallitzin",
    "value": "gallitzin"
  },
  {
    "text": "Galloway",
    "value": "galloway"
  },
  {
    "text": "Gallup",
    "value": "gallup"
  },
  {
    "text": "Galt",
    "value": "galt"
  },
  {
    "text": "Galva",
    "value": "galva"
  },
  {
    "text": "Galveston",
    "value": "galveston"
  },
  {
    "text": "Galway",
    "value": "galway"
  },
  {
    "text": "Gamaliel",
    "value": "gamaliel"
  },
  {
    "text": "Gambell",
    "value": "gambell"
  },
  {
    "text": "Gambier",
    "value": "gambier"
  },
  {
    "text": "Gambrills",
    "value": "gambrills"
  },
  {
    "text": "Gamerco",
    "value": "gamerco"
  },
  {
    "text": "Ganado",
    "value": "ganado"
  },
  {
    "text": "Gandeeville",
    "value": "gandeeville"
  },
  {
    "text": "Gandy",
    "value": "gandy"
  },
  {
    "text": "Gann Valley",
    "value": "gann valley"
  },
  {
    "text": "Gannvalley",
    "value": "gannvalley"
  },
  {
    "text": "Gans",
    "value": "gans"
  },
  {
    "text": "Gansevoort",
    "value": "gansevoort"
  },
  {
    "text": "Gantt",
    "value": "gantt"
  },
  {
    "text": "Gap",
    "value": "gap"
  },
  {
    "text": "Gap Mills",
    "value": "gap mills"
  },
  {
    "text": "Garards Fort",
    "value": "garards fort"
  },
  {
    "text": "Garber",
    "value": "garber"
  },
  {
    "text": "Garberville",
    "value": "garberville"
  },
  {
    "text": "Garden",
    "value": "garden"
  },
  {
    "text": "Garden City",
    "value": "garden city"
  },
  {
    "text": "Garden City Park",
    "value": "garden city park"
  },
  {
    "text": "Garden City South",
    "value": "garden city south"
  },
  {
    "text": "Garden Grove",
    "value": "garden grove"
  },
  {
    "text": "Garden Home-Whitford",
    "value": "garden home-whitford"
  },
  {
    "text": "Garden Plain",
    "value": "garden plain"
  },
  {
    "text": "Garden Prairie",
    "value": "garden prairie"
  },
  {
    "text": "Garden Ridge",
    "value": "garden ridge"
  },
  {
    "text": "Garden Valley",
    "value": "garden valley"
  },
  {
    "text": "Gardena",
    "value": "gardena"
  },
  {
    "text": "Gardendale",
    "value": "gardendale"
  },
  {
    "text": "Gardiner",
    "value": "gardiner"
  },
  {
    "text": "Gardner",
    "value": "gardner"
  },
  {
    "text": "Gardners",
    "value": "gardners"
  },
  {
    "text": "Gardnertown",
    "value": "gardnertown"
  },
  {
    "text": "Gardnerville",
    "value": "gardnerville"
  },
  {
    "text": "Gardnerville Ranchos",
    "value": "gardnerville ranchos"
  },
  {
    "text": "Garfield",
    "value": "garfield"
  },
  {
    "text": "Garfield Heights",
    "value": "garfield heights"
  },
  {
    "text": "Garibaldi",
    "value": "garibaldi"
  },
  {
    "text": "Garland",
    "value": "garland"
  },
  {
    "text": "Garland City",
    "value": "garland city"
  },
  {
    "text": "Garnavillo",
    "value": "garnavillo"
  },
  {
    "text": "Garner",
    "value": "garner"
  },
  {
    "text": "Garnerville",
    "value": "garnerville"
  },
  {
    "text": "Garnet Valley",
    "value": "garnet valley"
  },
  {
    "text": "Garnett",
    "value": "garnett"
  },
  {
    "text": "Garretson",
    "value": "garretson"
  },
  {
    "text": "Garrett",
    "value": "garrett"
  },
  {
    "text": "Garrett Park",
    "value": "garrett park"
  },
  {
    "text": "Garrettsville",
    "value": "garrettsville"
  },
  {
    "text": "Garrison",
    "value": "garrison"
  },
  {
    "text": "Garrisonville",
    "value": "garrisonville"
  },
  {
    "text": "Garryowen",
    "value": "garryowen"
  },
  {
    "text": "Garvin",
    "value": "garvin"
  },
  {
    "text": "Garwin",
    "value": "garwin"
  },
  {
    "text": "Garwood",
    "value": "garwood"
  },
  {
    "text": "Gary",
    "value": "gary"
  },
  {
    "text": "Gary City",
    "value": "gary city"
  },
  {
    "text": "Garysburg",
    "value": "garysburg"
  },
  {
    "text": "Garyville",
    "value": "garyville"
  },
  {
    "text": "Gas",
    "value": "gas"
  },
  {
    "text": "Gas City",
    "value": "gas city"
  },
  {
    "text": "Gasburg",
    "value": "gasburg"
  },
  {
    "text": "Gasport",
    "value": "gasport"
  },
  {
    "text": "Gasquet",
    "value": "gasquet"
  },
  {
    "text": "Gassaway",
    "value": "gassaway"
  },
  {
    "text": "Gassville",
    "value": "gassville"
  },
  {
    "text": "Gaston",
    "value": "gaston"
  },
  {
    "text": "Gastonia",
    "value": "gastonia"
  },
  {
    "text": "Gastonville",
    "value": "gastonville"
  },
  {
    "text": "Gate",
    "value": "gate"
  },
  {
    "text": "Gate City",
    "value": "gate city"
  },
  {
    "text": "Gates",
    "value": "gates"
  },
  {
    "text": "Gates Mills",
    "value": "gates mills"
  },
  {
    "text": "Gatesville",
    "value": "gatesville"
  },
  {
    "text": "Gateway",
    "value": "gateway"
  },
  {
    "text": "Gatewood",
    "value": "gatewood"
  },
  {
    "text": "Gatlinburg",
    "value": "gatlinburg"
  },
  {
    "text": "Gatzke",
    "value": "gatzke"
  },
  {
    "text": "Gauley Bridge",
    "value": "gauley bridge"
  },
  {
    "text": "Gause",
    "value": "gause"
  },
  {
    "text": "Gautier",
    "value": "gautier"
  },
  {
    "text": "Gay",
    "value": "gay"
  },
  {
    "text": "Gay Head",
    "value": "gay head"
  },
  {
    "text": "Gaylesville",
    "value": "gaylesville"
  },
  {
    "text": "Gaylord",
    "value": "gaylord"
  },
  {
    "text": "Gaylordsville",
    "value": "gaylordsville"
  },
  {
    "text": "Gays",
    "value": "gays"
  },
  {
    "text": "Gays Creek",
    "value": "gays creek"
  },
  {
    "text": "Gays Mills",
    "value": "gays mills"
  },
  {
    "text": "Gaysville",
    "value": "gaysville"
  },
  {
    "text": "Gayville",
    "value": "gayville"
  },
  {
    "text": "Gazelle",
    "value": "gazelle"
  },
  {
    "text": "Gearhart",
    "value": "gearhart"
  },
  {
    "text": "Geary",
    "value": "geary"
  },
  {
    "text": "Geddes",
    "value": "geddes"
  },
  {
    "text": "Geff",
    "value": "geff"
  },
  {
    "text": "Geigertown",
    "value": "geigertown"
  },
  {
    "text": "Geismar",
    "value": "geismar"
  },
  {
    "text": "Genesee",
    "value": "genesee"
  },
  {
    "text": "Genesee Depot",
    "value": "genesee depot"
  },
  {
    "text": "Geneseo",
    "value": "geneseo"
  },
  {
    "text": "Geneva",
    "value": "geneva"
  },
  {
    "text": "Geneva-on-the-Lake",
    "value": "geneva-on-the-lake"
  },
  {
    "text": "Genoa",
    "value": "genoa"
  },
  {
    "text": "Genoa City",
    "value": "genoa city"
  },
  {
    "text": "Gentry",
    "value": "gentry"
  },
  {
    "text": "Gentryville",
    "value": "gentryville"
  },
  {
    "text": "George",
    "value": "george"
  },
  {
    "text": "George West",
    "value": "george west"
  },
  {
    "text": "Georges Mills",
    "value": "georges mills"
  },
  {
    "text": "Georgetown",
    "value": "georgetown"
  },
  {
    "text": "Georgiana",
    "value": "georgiana"
  },
  {
    "text": "Gerald",
    "value": "gerald"
  },
  {
    "text": "Geraldine",
    "value": "geraldine"
  },
  {
    "text": "Gerber",
    "value": "gerber"
  },
  {
    "text": "Gering",
    "value": "gering"
  },
  {
    "text": "Gerlach",
    "value": "gerlach"
  },
  {
    "text": "Gerlaw",
    "value": "gerlaw"
  },
  {
    "text": "German Valley",
    "value": "german valley"
  },
  {
    "text": "Germansville",
    "value": "germansville"
  },
  {
    "text": "Germanton",
    "value": "germanton"
  },
  {
    "text": "Germantown",
    "value": "germantown"
  },
  {
    "text": "Germantown Hills",
    "value": "germantown hills"
  },
  {
    "text": "Germfask",
    "value": "germfask"
  },
  {
    "text": "Geronimo",
    "value": "geronimo"
  },
  {
    "text": "Gerrardstown",
    "value": "gerrardstown"
  },
  {
    "text": "Gerry",
    "value": "gerry"
  },
  {
    "text": "Gerton",
    "value": "gerton"
  },
  {
    "text": "Gervais",
    "value": "gervais"
  },
  {
    "text": "Gettysburg",
    "value": "gettysburg"
  },
  {
    "text": "Getzville",
    "value": "getzville"
  },
  {
    "text": "Geuda Springs",
    "value": "geuda springs"
  },
  {
    "text": "Geyser",
    "value": "geyser"
  },
  {
    "text": "Geyserville",
    "value": "geyserville"
  },
  {
    "text": "Ghent",
    "value": "ghent"
  },
  {
    "text": "Gibbon",
    "value": "gibbon"
  },
  {
    "text": "Gibbonsville",
    "value": "gibbonsville"
  },
  {
    "text": "Gibbsboro",
    "value": "gibbsboro"
  },
  {
    "text": "Gibbstown",
    "value": "gibbstown"
  },
  {
    "text": "Gibraltar",
    "value": "gibraltar"
  },
  {
    "text": "Gibsland",
    "value": "gibsland"
  },
  {
    "text": "Gibson",
    "value": "gibson"
  },
  {
    "text": "Gibson City",
    "value": "gibson city"
  },
  {
    "text": "Gibson Island",
    "value": "gibson island"
  },
  {
    "text": "Gibsonburg",
    "value": "gibsonburg"
  },
  {
    "text": "Gibsonia",
    "value": "gibsonia"
  },
  {
    "text": "Gibsonton",
    "value": "gibsonton"
  },
  {
    "text": "Gibsonville",
    "value": "gibsonville"
  },
  {
    "text": "Giddings",
    "value": "giddings"
  },
  {
    "text": "Gideon",
    "value": "gideon"
  },
  {
    "text": "Gifford",
    "value": "gifford"
  },
  {
    "text": "Gig Harbor",
    "value": "gig harbor"
  },
  {
    "text": "Gila",
    "value": "gila"
  },
  {
    "text": "Gila Bend",
    "value": "gila bend"
  },
  {
    "text": "Gilbert",
    "value": "gilbert"
  },
  {
    "text": "Gilbertown",
    "value": "gilbertown"
  },
  {
    "text": "Gilberts",
    "value": "gilberts"
  },
  {
    "text": "Gilbertsville",
    "value": "gilbertsville"
  },
  {
    "text": "Gilbertville",
    "value": "gilbertville"
  },
  {
    "text": "Gilboa",
    "value": "gilboa"
  },
  {
    "text": "Gilby",
    "value": "gilby"
  },
  {
    "text": "Gilchrist",
    "value": "gilchrist"
  },
  {
    "text": "Gilcrest",
    "value": "gilcrest"
  },
  {
    "text": "Gildford",
    "value": "gildford"
  },
  {
    "text": "Gile",
    "value": "gile"
  },
  {
    "text": "Gilead",
    "value": "gilead"
  },
  {
    "text": "Gilford",
    "value": "gilford"
  },
  {
    "text": "Gill",
    "value": "gill"
  },
  {
    "text": "Gillespie",
    "value": "gillespie"
  },
  {
    "text": "Gillett",
    "value": "gillett"
  },
  {
    "text": "Gillette",
    "value": "gillette"
  },
  {
    "text": "Gillham",
    "value": "gillham"
  },
  {
    "text": "Gilliam",
    "value": "gilliam"
  },
  {
    "text": "Gillsville",
    "value": "gillsville"
  },
  {
    "text": "Gilman",
    "value": "gilman"
  },
  {
    "text": "Gilman City",
    "value": "gilman city"
  },
  {
    "text": "Gilmanton",
    "value": "gilmanton"
  },
  {
    "text": "Gilmanton Ironworks",
    "value": "gilmanton ironworks"
  },
  {
    "text": "Gilmer",
    "value": "gilmer"
  },
  {
    "text": "Gilmore City",
    "value": "gilmore city"
  },
  {
    "text": "Gilroy",
    "value": "gilroy"
  },
  {
    "text": "Gilson",
    "value": "gilson"
  },
  {
    "text": "Gilsum",
    "value": "gilsum"
  },
  {
    "text": "Giltner",
    "value": "giltner"
  },
  {
    "text": "Gipsy",
    "value": "gipsy"
  },
  {
    "text": "Girard",
    "value": "girard"
  },
  {
    "text": "Girardville",
    "value": "girardville"
  },
  {
    "text": "Girdler",
    "value": "girdler"
  },
  {
    "text": "Girdletree",
    "value": "girdletree"
  },
  {
    "text": "Girdwood",
    "value": "girdwood"
  },
  {
    "text": "Girvin",
    "value": "girvin"
  },
  {
    "text": "Given",
    "value": "given"
  },
  {
    "text": "Gladbrook",
    "value": "gladbrook"
  },
  {
    "text": "Glade Spring",
    "value": "glade spring"
  },
  {
    "text": "Glade Valley",
    "value": "glade valley"
  },
  {
    "text": "Gladehill",
    "value": "gladehill"
  },
  {
    "text": "Gladeville",
    "value": "gladeville"
  },
  {
    "text": "Gladewater",
    "value": "gladewater"
  },
  {
    "text": "Gladstone",
    "value": "gladstone"
  },
  {
    "text": "Gladwin",
    "value": "gladwin"
  },
  {
    "text": "Gladwyne",
    "value": "gladwyne"
  },
  {
    "text": "Gladys",
    "value": "gladys"
  },
  {
    "text": "Glandorf",
    "value": "glandorf"
  },
  {
    "text": "Glasco",
    "value": "glasco"
  },
  {
    "text": "Glasford",
    "value": "glasford"
  },
  {
    "text": "Glasgow",
    "value": "glasgow"
  },
  {
    "text": "Glassboro",
    "value": "glassboro"
  },
  {
    "text": "Glassport",
    "value": "glassport"
  },
  {
    "text": "Glastonbury",
    "value": "glastonbury"
  },
  {
    "text": "Gleason",
    "value": "gleason"
  },
  {
    "text": "Glen",
    "value": "glen"
  },
  {
    "text": "Glen Allan",
    "value": "glen allan"
  },
  {
    "text": "Glen Allen",
    "value": "glen allen"
  },
  {
    "text": "Glen Alpine",
    "value": "glen alpine"
  },
  {
    "text": "Glen Arbor",
    "value": "glen arbor"
  },
  {
    "text": "Glen Arm",
    "value": "glen arm"
  },
  {
    "text": "Glen Burnie",
    "value": "glen burnie"
  },
  {
    "text": "Glen Campbell",
    "value": "glen campbell"
  },
  {
    "text": "Glen Carbon",
    "value": "glen carbon"
  },
  {
    "text": "Glen Cove",
    "value": "glen cove"
  },
  {
    "text": "Glen Daniel",
    "value": "glen daniel"
  },
  {
    "text": "Glen Easton",
    "value": "glen easton"
  },
  {
    "text": "Glen Echo",
    "value": "glen echo"
  },
  {
    "text": "Glen Elder",
    "value": "glen elder"
  },
  {
    "text": "Glen Ellen",
    "value": "glen ellen"
  },
  {
    "text": "Glen Ellyn",
    "value": "glen ellyn"
  },
  {
    "text": "Glen Flora",
    "value": "glen flora"
  },
  {
    "text": "Glen Fork",
    "value": "glen fork"
  },
  {
    "text": "Glen Gardner",
    "value": "glen gardner"
  },
  {
    "text": "Glen Haven",
    "value": "glen haven"
  },
  {
    "text": "Glen Head",
    "value": "glen head"
  },
  {
    "text": "Glen Hope",
    "value": "glen hope"
  },
  {
    "text": "Glen Jean",
    "value": "glen jean"
  },
  {
    "text": "Glen Lyn",
    "value": "glen lyn"
  },
  {
    "text": "Glen Lyon",
    "value": "glen lyon"
  },
  {
    "text": "Glen Mills",
    "value": "glen mills"
  },
  {
    "text": "Glen Oaks",
    "value": "glen oaks"
  },
  {
    "text": "Glen Raven",
    "value": "glen raven"
  },
  {
    "text": "Glen Richey",
    "value": "glen richey"
  },
  {
    "text": "Glen Riddle Lima",
    "value": "glen riddle lima"
  },
  {
    "text": "Glen Ridge",
    "value": "glen ridge"
  },
  {
    "text": "Glen Rock",
    "value": "glen rock"
  },
  {
    "text": "Glen Rose",
    "value": "glen rose"
  },
  {
    "text": "Glen Saint Mary",
    "value": "glen saint mary"
  },
  {
    "text": "Glen Spey",
    "value": "glen spey"
  },
  {
    "text": "Glen Ullin",
    "value": "glen ullin"
  },
  {
    "text": "Glen White",
    "value": "glen white"
  },
  {
    "text": "Glen Wild",
    "value": "glen wild"
  },
  {
    "text": "Glenallen",
    "value": "glenallen"
  },
  {
    "text": "Glenarden",
    "value": "glenarden"
  },
  {
    "text": "Glenarm",
    "value": "glenarm"
  },
  {
    "text": "Glenbeulah",
    "value": "glenbeulah"
  },
  {
    "text": "Glenbrook",
    "value": "glenbrook"
  },
  {
    "text": "Glenburn",
    "value": "glenburn"
  },
  {
    "text": "Glencoe",
    "value": "glencoe"
  },
  {
    "text": "Glendale",
    "value": "glendale"
  },
  {
    "text": "Glendale Heights",
    "value": "glendale heights"
  },
  {
    "text": "Glendale Luke Air Force Base",
    "value": "glendale luke air force base"
  },
  {
    "text": "Glendale Springs",
    "value": "glendale springs"
  },
  {
    "text": "Glendive",
    "value": "glendive"
  },
  {
    "text": "Glendo",
    "value": "glendo"
  },
  {
    "text": "Glendora",
    "value": "glendora"
  },
  {
    "text": "Gleneagle",
    "value": "gleneagle"
  },
  {
    "text": "Gleneden Beach",
    "value": "gleneden beach"
  },
  {
    "text": "Glenelg",
    "value": "glenelg"
  },
  {
    "text": "Glenfield",
    "value": "glenfield"
  },
  {
    "text": "Glenford",
    "value": "glenford"
  },
  {
    "text": "Glenham",
    "value": "glenham"
  },
  {
    "text": "Glenhaven",
    "value": "glenhaven"
  },
  {
    "text": "Glenmont",
    "value": "glenmont"
  },
  {
    "text": "Glenmoor",
    "value": "glenmoor"
  },
  {
    "text": "Glenmoore",
    "value": "glenmoore"
  },
  {
    "text": "Glenmora",
    "value": "glenmora"
  },
  {
    "text": "Glenn",
    "value": "glenn"
  },
  {
    "text": "Glenn Dale",
    "value": "glenn dale"
  },
  {
    "text": "Glenn Heights",
    "value": "glenn heights"
  },
  {
    "text": "Glennallen",
    "value": "glennallen"
  },
  {
    "text": "Glennie",
    "value": "glennie"
  },
  {
    "text": "Glenns Ferry",
    "value": "glenns ferry"
  },
  {
    "text": "Glennville",
    "value": "glennville"
  },
  {
    "text": "Glenolden",
    "value": "glenolden"
  },
  {
    "text": "Glenoma",
    "value": "glenoma"
  },
  {
    "text": "Glenpool",
    "value": "glenpool"
  },
  {
    "text": "Glenrock",
    "value": "glenrock"
  },
  {
    "text": "Glens",
    "value": "glens"
  },
  {
    "text": "Glens Falls",
    "value": "glens falls"
  },
  {
    "text": "Glens Fork",
    "value": "glens fork"
  },
  {
    "text": "Glenshaw",
    "value": "glenshaw"
  },
  {
    "text": "Glenside",
    "value": "glenside"
  },
  {
    "text": "Glentana",
    "value": "glentana"
  },
  {
    "text": "Glenview",
    "value": "glenview"
  },
  {
    "text": "Glenvil",
    "value": "glenvil"
  },
  {
    "text": "Glenville",
    "value": "glenville"
  },
  {
    "text": "Glenwood",
    "value": "glenwood"
  },
  {
    "text": "Glenwood City",
    "value": "glenwood city"
  },
  {
    "text": "Glenwood Landing",
    "value": "glenwood landing"
  },
  {
    "text": "Glenwood Springs",
    "value": "glenwood springs"
  },
  {
    "text": "Glidden",
    "value": "glidden"
  },
  {
    "text": "Glide",
    "value": "glide"
  },
  {
    "text": "Globe",
    "value": "globe"
  },
  {
    "text": "Glorieta",
    "value": "glorieta"
  },
  {
    "text": "Gloster",
    "value": "gloster"
  },
  {
    "text": "Gloucester",
    "value": "gloucester"
  },
  {
    "text": "Gloucester City",
    "value": "gloucester city"
  },
  {
    "text": "Gloucester Point",
    "value": "gloucester point"
  },
  {
    "text": "Glouster",
    "value": "glouster"
  },
  {
    "text": "Glover",
    "value": "glover"
  },
  {
    "text": "Gloversville",
    "value": "gloversville"
  },
  {
    "text": "Glyndon",
    "value": "glyndon"
  },
  {
    "text": "Gnadenhutten",
    "value": "gnadenhutten"
  },
  {
    "text": "Gobler",
    "value": "gobler"
  },
  {
    "text": "Gobles",
    "value": "gobles"
  },
  {
    "text": "Goddard",
    "value": "goddard"
  },
  {
    "text": "Godfrey",
    "value": "godfrey"
  },
  {
    "text": "Godley",
    "value": "godley"
  },
  {
    "text": "Godwin",
    "value": "godwin"
  },
  {
    "text": "Goehner",
    "value": "goehner"
  },
  {
    "text": "Goessel",
    "value": "goessel"
  },
  {
    "text": "Goetzville",
    "value": "goetzville"
  },
  {
    "text": "Goff",
    "value": "goff"
  },
  {
    "text": "Goffstown",
    "value": "goffstown"
  },
  {
    "text": "Golconda",
    "value": "golconda"
  },
  {
    "text": "Gold Bar",
    "value": "gold bar"
  },
  {
    "text": "Gold Beach",
    "value": "gold beach"
  },
  {
    "text": "Gold Canyon",
    "value": "gold canyon"
  },
  {
    "text": "Gold Hill",
    "value": "gold hill"
  },
  {
    "text": "Gold Key Lake",
    "value": "gold key lake"
  },
  {
    "text": "Gold River",
    "value": "gold river"
  },
  {
    "text": "Golden",
    "value": "golden"
  },
  {
    "text": "Golden Beach",
    "value": "golden beach"
  },
  {
    "text": "Golden City",
    "value": "golden city"
  },
  {
    "text": "Golden Eagle",
    "value": "golden eagle"
  },
  {
    "text": "Golden Gate",
    "value": "golden gate"
  },
  {
    "text": "Golden Grove",
    "value": "golden grove"
  },
  {
    "text": "Golden Hills",
    "value": "golden hills"
  },
  {
    "text": "Golden Meadow",
    "value": "golden meadow"
  },
  {
    "text": "Golden Triangle",
    "value": "golden triangle"
  },
  {
    "text": "Golden Valley",
    "value": "golden valley"
  },
  {
    "text": "Goldendale",
    "value": "goldendale"
  },
  {
    "text": "Goldenrod",
    "value": "goldenrod"
  },
  {
    "text": "Goldens Bridge",
    "value": "goldens bridge"
  },
  {
    "text": "Goldfield",
    "value": "goldfield"
  },
  {
    "text": "Goldonna",
    "value": "goldonna"
  },
  {
    "text": "Goldsboro",
    "value": "goldsboro"
  },
  {
    "text": "Goldsby",
    "value": "goldsby"
  },
  {
    "text": "Goldsmith",
    "value": "goldsmith"
  },
  {
    "text": "Goldston",
    "value": "goldston"
  },
  {
    "text": "Goldthwaite",
    "value": "goldthwaite"
  },
  {
    "text": "Goldvein",
    "value": "goldvein"
  },
  {
    "text": "Goleta",
    "value": "goleta"
  },
  {
    "text": "Golf",
    "value": "golf"
  },
  {
    "text": "Golf Manor",
    "value": "golf manor"
  },
  {
    "text": "Goliad",
    "value": "goliad"
  },
  {
    "text": "Goltry",
    "value": "goltry"
  },
  {
    "text": "Gomer",
    "value": "gomer"
  },
  {
    "text": "Gonvick",
    "value": "gonvick"
  },
  {
    "text": "Gonzales",
    "value": "gonzales"
  },
  {
    "text": "Gonzalez",
    "value": "gonzalez"
  },
  {
    "text": "Goochland",
    "value": "goochland"
  },
  {
    "text": "Good Hart",
    "value": "good hart"
  },
  {
    "text": "Good Hope",
    "value": "good hope"
  },
  {
    "text": "Good Thunder",
    "value": "good thunder"
  },
  {
    "text": "Goode",
    "value": "goode"
  },
  {
    "text": "Goodells",
    "value": "goodells"
  },
  {
    "text": "Goodfellow Air Force Base",
    "value": "goodfellow air force base"
  },
  {
    "text": "Goodfield",
    "value": "goodfield"
  },
  {
    "text": "Goodhue",
    "value": "goodhue"
  },
  {
    "text": "Gooding",
    "value": "gooding"
  },
  {
    "text": "Goodland",
    "value": "goodland"
  },
  {
    "text": "Goodlettsville",
    "value": "goodlettsville"
  },
  {
    "text": "Goodman",
    "value": "goodman"
  },
  {
    "text": "Goodrich",
    "value": "goodrich"
  },
  {
    "text": "Goodridge",
    "value": "goodridge"
  },
  {
    "text": "Goodspring",
    "value": "goodspring"
  },
  {
    "text": "Goodsprings",
    "value": "goodsprings"
  },
  {
    "text": "Goodview",
    "value": "goodview"
  },
  {
    "text": "Goodwater",
    "value": "goodwater"
  },
  {
    "text": "Goodwell",
    "value": "goodwell"
  },
  {
    "text": "Goodwin",
    "value": "goodwin"
  },
  {
    "text": "Goodwine",
    "value": "goodwine"
  },
  {
    "text": "Goodyear",
    "value": "goodyear"
  },
  {
    "text": "Goose Creek",
    "value": "goose creek"
  },
  {
    "text": "Goose Lake",
    "value": "goose lake"
  },
  {
    "text": "Goose Prairie",
    "value": "goose prairie"
  },
  {
    "text": "Gordo",
    "value": "gordo"
  },
  {
    "text": "Gordon",
    "value": "gordon"
  },
  {
    "text": "Gordonsville",
    "value": "gordonsville"
  },
  {
    "text": "Gordonville",
    "value": "gordonville"
  },
  {
    "text": "Gore",
    "value": "gore"
  },
  {
    "text": "Gore Springs",
    "value": "gore springs"
  },
  {
    "text": "Goree",
    "value": "goree"
  },
  {
    "text": "Goreville",
    "value": "goreville"
  },
  {
    "text": "Gorham",
    "value": "gorham"
  },
  {
    "text": "Gorin",
    "value": "gorin"
  },
  {
    "text": "Gorman",
    "value": "gorman"
  },
  {
    "text": "Gormania",
    "value": "gormania"
  },
  {
    "text": "Goshen",
    "value": "goshen"
  },
  {
    "text": "Gosnell",
    "value": "gosnell"
  },
  {
    "text": "Gosport",
    "value": "gosport"
  },
  {
    "text": "Gotebo",
    "value": "gotebo"
  },
  {
    "text": "Gotha",
    "value": "gotha"
  },
  {
    "text": "Gothenburg",
    "value": "gothenburg"
  },
  {
    "text": "Gould",
    "value": "gould"
  },
  {
    "text": "Gouldbusk",
    "value": "gouldbusk"
  },
  {
    "text": "Goulds",
    "value": "goulds"
  },
  {
    "text": "Gouldsboro",
    "value": "gouldsboro"
  },
  {
    "text": "Gouverneur",
    "value": "gouverneur"
  },
  {
    "text": "Gove",
    "value": "gove"
  },
  {
    "text": "Government Camp",
    "value": "government camp"
  },
  {
    "text": "Gowanda",
    "value": "gowanda"
  },
  {
    "text": "Gowen",
    "value": "gowen"
  },
  {
    "text": "Gower",
    "value": "gower"
  },
  {
    "text": "Gowrie",
    "value": "gowrie"
  },
  {
    "text": "Grabill",
    "value": "grabill"
  },
  {
    "text": "Grace",
    "value": "grace"
  },
  {
    "text": "Grace City",
    "value": "grace city"
  },
  {
    "text": "Gracemont",
    "value": "gracemont"
  },
  {
    "text": "Graceville",
    "value": "graceville"
  },
  {
    "text": "Gracewood",
    "value": "gracewood"
  },
  {
    "text": "Gracey",
    "value": "gracey"
  },
  {
    "text": "Grady",
    "value": "grady"
  },
  {
    "text": "Gradyville",
    "value": "gradyville"
  },
  {
    "text": "Graettinger",
    "value": "graettinger"
  },
  {
    "text": "Graff",
    "value": "graff"
  },
  {
    "text": "Graford",
    "value": "graford"
  },
  {
    "text": "Grafton",
    "value": "grafton"
  },
  {
    "text": "Graham",
    "value": "graham"
  },
  {
    "text": "Grahamsville",
    "value": "grahamsville"
  },
  {
    "text": "Grain Valley",
    "value": "grain valley"
  },
  {
    "text": "Grambling",
    "value": "grambling"
  },
  {
    "text": "Gramercy",
    "value": "gramercy"
  },
  {
    "text": "Grammer",
    "value": "grammer"
  },
  {
    "text": "Grampian",
    "value": "grampian"
  },
  {
    "text": "Granada",
    "value": "granada"
  },
  {
    "text": "Granada Hills",
    "value": "granada hills"
  },
  {
    "text": "Granbury",
    "value": "granbury"
  },
  {
    "text": "Granby",
    "value": "granby"
  },
  {
    "text": "Grand Bay",
    "value": "grand bay"
  },
  {
    "text": "Grand Blanc",
    "value": "grand blanc"
  },
  {
    "text": "Grand Cane",
    "value": "grand cane"
  },
  {
    "text": "Grand Canyon",
    "value": "grand canyon"
  },
  {
    "text": "Grand Canyon Village",
    "value": "grand canyon village"
  },
  {
    "text": "Grand Chain",
    "value": "grand chain"
  },
  {
    "text": "Grand Chenier",
    "value": "grand chenier"
  },
  {
    "text": "Grand Coteau",
    "value": "grand coteau"
  },
  {
    "text": "Grand Coulee",
    "value": "grand coulee"
  },
  {
    "text": "Grand Forks",
    "value": "grand forks"
  },
  {
    "text": "Grand Forks Air Force Base",
    "value": "grand forks air force base"
  },
  {
    "text": "Grand Gorge",
    "value": "grand gorge"
  },
  {
    "text": "Grand Haven",
    "value": "grand haven"
  },
  {
    "text": "Grand Island",
    "value": "grand island"
  },
  {
    "text": "Grand Isle",
    "value": "grand isle"
  },
  {
    "text": "Grand Junction",
    "value": "grand junction"
  },
  {
    "text": "Grand Lake",
    "value": "grand lake"
  },
  {
    "text": "Grand Ledge",
    "value": "grand ledge"
  },
  {
    "text": "Grand Marais",
    "value": "grand marais"
  },
  {
    "text": "Grand Marsh",
    "value": "grand marsh"
  },
  {
    "text": "Grand Meadow",
    "value": "grand meadow"
  },
  {
    "text": "Grand Mound",
    "value": "grand mound"
  },
  {
    "text": "Grand Prairie",
    "value": "grand prairie"
  },
  {
    "text": "Grand Rapids",
    "value": "grand rapids"
  },
  {
    "text": "Grand Ridge",
    "value": "grand ridge"
  },
  {
    "text": "Grand River",
    "value": "grand river"
  },
  {
    "text": "Grand Rivers",
    "value": "grand rivers"
  },
  {
    "text": "Grand Ronde",
    "value": "grand ronde"
  },
  {
    "text": "Grand Saline",
    "value": "grand saline"
  },
  {
    "text": "Grand Terrace",
    "value": "grand terrace"
  },
  {
    "text": "Grand Tower",
    "value": "grand tower"
  },
  {
    "text": "Grand View",
    "value": "grand view"
  },
  {
    "text": "Grandfalls",
    "value": "grandfalls"
  },
  {
    "text": "Grandfield",
    "value": "grandfield"
  },
  {
    "text": "Grandin",
    "value": "grandin"
  },
  {
    "text": "Grandview",
    "value": "grandview"
  },
  {
    "text": "Grandview Heights",
    "value": "grandview heights"
  },
  {
    "text": "Grandville",
    "value": "grandville"
  },
  {
    "text": "Grandy",
    "value": "grandy"
  },
  {
    "text": "Granger",
    "value": "granger"
  },
  {
    "text": "Grangeville",
    "value": "grangeville"
  },
  {
    "text": "Granite",
    "value": "granite"
  },
  {
    "text": "Granite Bay",
    "value": "granite bay"
  },
  {
    "text": "Granite City",
    "value": "granite city"
  },
  {
    "text": "Granite Falls",
    "value": "granite falls"
  },
  {
    "text": "Granite Quarry",
    "value": "granite quarry"
  },
  {
    "text": "Granite Shoals",
    "value": "granite shoals"
  },
  {
    "text": "Granite Springs",
    "value": "granite springs"
  },
  {
    "text": "Graniteville",
    "value": "graniteville"
  },
  {
    "text": "Grannis",
    "value": "grannis"
  },
  {
    "text": "Grant",
    "value": "grant"
  },
  {
    "text": "Grant City",
    "value": "grant city"
  },
  {
    "text": "Grant Park",
    "value": "grant park"
  },
  {
    "text": "Grant Town",
    "value": "grant town"
  },
  {
    "text": "Grant-Valkaria",
    "value": "grant-valkaria"
  },
  {
    "text": "Grantham",
    "value": "grantham"
  },
  {
    "text": "Granton",
    "value": "granton"
  },
  {
    "text": "Grants",
    "value": "grants"
  },
  {
    "text": "Grants Pass",
    "value": "grants pass"
  },
  {
    "text": "Grantsboro",
    "value": "grantsboro"
  },
  {
    "text": "Grantsburg",
    "value": "grantsburg"
  },
  {
    "text": "Grantsville",
    "value": "grantsville"
  },
  {
    "text": "Grantville",
    "value": "grantville"
  },
  {
    "text": "Granville",
    "value": "granville"
  },
  {
    "text": "Granville South",
    "value": "granville south"
  },
  {
    "text": "Granville Summit",
    "value": "granville summit"
  },
  {
    "text": "Grapeland",
    "value": "grapeland"
  },
  {
    "text": "Grapeview",
    "value": "grapeview"
  },
  {
    "text": "Grapeville",
    "value": "grapeville"
  },
  {
    "text": "Grapevine",
    "value": "grapevine"
  },
  {
    "text": "Grasonville",
    "value": "grasonville"
  },
  {
    "text": "Grass Lake",
    "value": "grass lake"
  },
  {
    "text": "Grass Range",
    "value": "grass range"
  },
  {
    "text": "Grass Valley",
    "value": "grass valley"
  },
  {
    "text": "Grassflat",
    "value": "grassflat"
  },
  {
    "text": "Grasston",
    "value": "grasston"
  },
  {
    "text": "Grassy Butte",
    "value": "grassy butte"
  },
  {
    "text": "Grassy Creek",
    "value": "grassy creek"
  },
  {
    "text": "Gratiot",
    "value": "gratiot"
  },
  {
    "text": "Gratis",
    "value": "gratis"
  },
  {
    "text": "Graton",
    "value": "graton"
  },
  {
    "text": "Gratz",
    "value": "gratz"
  },
  {
    "text": "Gravel Switch",
    "value": "gravel switch"
  },
  {
    "text": "Gravesend",
    "value": "gravesend"
  },
  {
    "text": "Gravette",
    "value": "gravette"
  },
  {
    "text": "Gravity",
    "value": "gravity"
  },
  {
    "text": "Gravois Mills",
    "value": "gravois mills"
  },
  {
    "text": "Grawn",
    "value": "grawn"
  },
  {
    "text": "Gray",
    "value": "gray"
  },
  {
    "text": "Gray Court",
    "value": "gray court"
  },
  {
    "text": "Gray Summit",
    "value": "gray summit"
  },
  {
    "text": "Grayland",
    "value": "grayland"
  },
  {
    "text": "Grayling",
    "value": "grayling"
  },
  {
    "text": "Grays Knob",
    "value": "grays knob"
  },
  {
    "text": "Grays River",
    "value": "grays river"
  },
  {
    "text": "Grayslake",
    "value": "grayslake"
  },
  {
    "text": "Grayson",
    "value": "grayson"
  },
  {
    "text": "Graysville",
    "value": "graysville"
  },
  {
    "text": "Graytown",
    "value": "graytown"
  },
  {
    "text": "Grayville",
    "value": "grayville"
  },
  {
    "text": "Great Barrington",
    "value": "great barrington"
  },
  {
    "text": "Great Bend",
    "value": "great bend"
  },
  {
    "text": "Great Cacapon",
    "value": "great cacapon"
  },
  {
    "text": "Great Falls",
    "value": "great falls"
  },
  {
    "text": "Great Lakes",
    "value": "great lakes"
  },
  {
    "text": "Great Meadows",
    "value": "great meadows"
  },
  {
    "text": "Great Mills",
    "value": "great mills"
  },
  {
    "text": "Great Neck",
    "value": "great neck"
  },
  {
    "text": "Great Neck Plaza",
    "value": "great neck plaza"
  },
  {
    "text": "Great River",
    "value": "great river"
  },
  {
    "text": "Great Valley",
    "value": "great valley"
  },
  {
    "text": "Greater Northdale",
    "value": "greater northdale"
  },
  {
    "text": "Greatwood",
    "value": "greatwood"
  },
  {
    "text": "Greece",
    "value": "greece"
  },
  {
    "text": "Greeley",
    "value": "greeley"
  },
  {
    "text": "Greeleyville",
    "value": "greeleyville"
  },
  {
    "text": "Green",
    "value": "green"
  },
  {
    "text": "Green Acres",
    "value": "green acres"
  },
  {
    "text": "Green Bank",
    "value": "green bank"
  },
  {
    "text": "Green Bay",
    "value": "green bay"
  },
  {
    "text": "Green Camp",
    "value": "green camp"
  },
  {
    "text": "Green Castle",
    "value": "green castle"
  },
  {
    "text": "Green City",
    "value": "green city"
  },
  {
    "text": "Green Cove Springs",
    "value": "green cove springs"
  },
  {
    "text": "Green Forest",
    "value": "green forest"
  },
  {
    "text": "Green Haven",
    "value": "green haven"
  },
  {
    "text": "Green Island",
    "value": "green island"
  },
  {
    "text": "Green Isle",
    "value": "green isle"
  },
  {
    "text": "Green Lake",
    "value": "green lake"
  },
  {
    "text": "Green Lane",
    "value": "green lane"
  },
  {
    "text": "Green Level",
    "value": "green level"
  },
  {
    "text": "Green Mountain",
    "value": "green mountain"
  },
  {
    "text": "Green Mountain Falls",
    "value": "green mountain falls"
  },
  {
    "text": "Green Oaks",
    "value": "green oaks"
  },
  {
    "text": "Green Park",
    "value": "green park"
  },
  {
    "text": "Green Pond",
    "value": "green pond"
  },
  {
    "text": "Green Ridge",
    "value": "green ridge"
  },
  {
    "text": "Green River",
    "value": "green river"
  },
  {
    "text": "Green Rock",
    "value": "green rock"
  },
  {
    "text": "Green Sea",
    "value": "green sea"
  },
  {
    "text": "Green Spring",
    "value": "green spring"
  },
  {
    "text": "Green Springs",
    "value": "green springs"
  },
  {
    "text": "Green Tree",
    "value": "green tree"
  },
  {
    "text": "Green Valley",
    "value": "green valley"
  },
  {
    "text": "Green Valley Lake",
    "value": "green valley lake"
  },
  {
    "text": "Green Village",
    "value": "green village"
  },
  {
    "text": "Greenacres",
    "value": "greenacres"
  },
  {
    "text": "Greenacres City",
    "value": "greenacres city"
  },
  {
    "text": "Greenback",
    "value": "greenback"
  },
  {
    "text": "Greenbackville",
    "value": "greenbackville"
  },
  {
    "text": "Greenbank",
    "value": "greenbank"
  },
  {
    "text": "Greenbelt",
    "value": "greenbelt"
  },
  {
    "text": "Greenbrae",
    "value": "greenbrae"
  },
  {
    "text": "Greenbriar",
    "value": "greenbriar"
  },
  {
    "text": "Greenbrier",
    "value": "greenbrier"
  },
  {
    "text": "Greenburgh",
    "value": "greenburgh"
  },
  {
    "text": "Greenbush",
    "value": "greenbush"
  },
  {
    "text": "Greencastle",
    "value": "greencastle"
  },
  {
    "text": "Greencreek",
    "value": "greencreek"
  },
  {
    "text": "Greendale",
    "value": "greendale"
  },
  {
    "text": "Greendell",
    "value": "greendell"
  },
  {
    "text": "Greene",
    "value": "greene"
  },
  {
    "text": "Greene Village",
    "value": "greene village"
  },
  {
    "text": "Greeneville",
    "value": "greeneville"
  },
  {
    "text": "Greenfield",
    "value": "greenfield"
  },
  {
    "text": "Greenfield Center",
    "value": "greenfield center"
  },
  {
    "text": "Greenfield Park",
    "value": "greenfield park"
  },
  {
    "text": "Greenford",
    "value": "greenford"
  },
  {
    "text": "Greenhills",
    "value": "greenhills"
  },
  {
    "text": "Greenland",
    "value": "greenland"
  },
  {
    "text": "Greenlawn",
    "value": "greenlawn"
  },
  {
    "text": "Greenleaf",
    "value": "greenleaf"
  },
  {
    "text": "Greenock",
    "value": "greenock"
  },
  {
    "text": "Greenport",
    "value": "greenport"
  },
  {
    "text": "Greens Farms",
    "value": "greens farms"
  },
  {
    "text": "Greens Fork",
    "value": "greens fork"
  },
  {
    "text": "Greensboro",
    "value": "greensboro"
  },
  {
    "text": "Greensboro Bend",
    "value": "greensboro bend"
  },
  {
    "text": "Greensburg",
    "value": "greensburg"
  },
  {
    "text": "Greentop",
    "value": "greentop"
  },
  {
    "text": "Greentown",
    "value": "greentown"
  },
  {
    "text": "Greenup",
    "value": "greenup"
  },
  {
    "text": "Greenvale",
    "value": "greenvale"
  },
  {
    "text": "Greenview",
    "value": "greenview"
  },
  {
    "text": "Greenville",
    "value": "greenville"
  },
  {
    "text": "Greenville Junction",
    "value": "greenville junction"
  },
  {
    "text": "Greenwald",
    "value": "greenwald"
  },
  {
    "text": "Greenwell Springs",
    "value": "greenwell springs"
  },
  {
    "text": "Greenwich",
    "value": "greenwich"
  },
  {
    "text": "Greenwood",
    "value": "greenwood"
  },
  {
    "text": "Greenwood Lake",
    "value": "greenwood lake"
  },
  {
    "text": "Greenwood Springs",
    "value": "greenwood springs"
  },
  {
    "text": "Greenwood Village",
    "value": "greenwood village"
  },
  {
    "text": "Greer",
    "value": "greer"
  },
  {
    "text": "Gregory",
    "value": "gregory"
  },
  {
    "text": "Greig",
    "value": "greig"
  },
  {
    "text": "Grenada",
    "value": "grenada"
  },
  {
    "text": "Grenloch",
    "value": "grenloch"
  },
  {
    "text": "Grenola",
    "value": "grenola"
  },
  {
    "text": "Grenora",
    "value": "grenora"
  },
  {
    "text": "Grenville",
    "value": "grenville"
  },
  {
    "text": "Gresham",
    "value": "gresham"
  },
  {
    "text": "Gresham Park",
    "value": "gresham park"
  },
  {
    "text": "Grethel",
    "value": "grethel"
  },
  {
    "text": "Gretna",
    "value": "gretna"
  },
  {
    "text": "Grey Eagle",
    "value": "grey eagle"
  },
  {
    "text": "Greybull",
    "value": "greybull"
  },
  {
    "text": "Gridley",
    "value": "gridley"
  },
  {
    "text": "Griffin",
    "value": "griffin"
  },
  {
    "text": "Griffith",
    "value": "griffith"
  },
  {
    "text": "Griffithsville",
    "value": "griffithsville"
  },
  {
    "text": "Griffithville",
    "value": "griffithville"
  },
  {
    "text": "Grifton",
    "value": "grifton"
  },
  {
    "text": "Griggsville",
    "value": "griggsville"
  },
  {
    "text": "Grimes",
    "value": "grimes"
  },
  {
    "text": "Grimesland",
    "value": "grimesland"
  },
  {
    "text": "Grimsley",
    "value": "grimsley"
  },
  {
    "text": "Grimstead",
    "value": "grimstead"
  },
  {
    "text": "Grindstone",
    "value": "grindstone"
  },
  {
    "text": "Grinnell",
    "value": "grinnell"
  },
  {
    "text": "Grissom Arb",
    "value": "grissom arb"
  },
  {
    "text": "Griswold",
    "value": "griswold"
  },
  {
    "text": "Grizzly Flat",
    "value": "grizzly flat"
  },
  {
    "text": "Groesbeck",
    "value": "groesbeck"
  },
  {
    "text": "Groom",
    "value": "groom"
  },
  {
    "text": "Grosse Ile",
    "value": "grosse ile"
  },
  {
    "text": "Grosse Ile Township",
    "value": "grosse ile township"
  },
  {
    "text": "Grosse Pointe",
    "value": "grosse pointe"
  },
  {
    "text": "Grosse Pointe Farms",
    "value": "grosse pointe farms"
  },
  {
    "text": "Grosse Pointe Park",
    "value": "grosse pointe park"
  },
  {
    "text": "Grosse Pointe Shores",
    "value": "grosse pointe shores"
  },
  {
    "text": "Grosse Pointe Woods",
    "value": "grosse pointe woods"
  },
  {
    "text": "Grosse Tete",
    "value": "grosse tete"
  },
  {
    "text": "Grosvenor Dale",
    "value": "grosvenor dale"
  },
  {
    "text": "Groton",
    "value": "groton"
  },
  {
    "text": "Grottoes",
    "value": "grottoes"
  },
  {
    "text": "Grouse Creek",
    "value": "grouse creek"
  },
  {
    "text": "Grove",
    "value": "grove"
  },
  {
    "text": "Grove City",
    "value": "grove city"
  },
  {
    "text": "Grove Hill",
    "value": "grove hill"
  },
  {
    "text": "Grove Oak",
    "value": "grove oak"
  },
  {
    "text": "Groveland",
    "value": "groveland"
  },
  {
    "text": "Groveport",
    "value": "groveport"
  },
  {
    "text": "Grover",
    "value": "grover"
  },
  {
    "text": "Grover Beach",
    "value": "grover beach"
  },
  {
    "text": "Grover Hill",
    "value": "grover hill"
  },
  {
    "text": "Grovertown",
    "value": "grovertown"
  },
  {
    "text": "Groves",
    "value": "groves"
  },
  {
    "text": "Grovespring",
    "value": "grovespring"
  },
  {
    "text": "Groveton",
    "value": "groveton"
  },
  {
    "text": "Grovetown",
    "value": "grovetown"
  },
  {
    "text": "Grubbs",
    "value": "grubbs"
  },
  {
    "text": "Grubville",
    "value": "grubville"
  },
  {
    "text": "Gruetli-Laager",
    "value": "gruetli-laager"
  },
  {
    "text": "Grundy",
    "value": "grundy"
  },
  {
    "text": "Grundy Center",
    "value": "grundy center"
  },
  {
    "text": "Gruver",
    "value": "gruver"
  },
  {
    "text": "Grygla",
    "value": "grygla"
  },
  {
    "text": "Guadalupe",
    "value": "guadalupe"
  },
  {
    "text": "Guadalupita",
    "value": "guadalupita"
  },
  {
    "text": "Gualala",
    "value": "gualala"
  },
  {
    "text": "Guasti",
    "value": "guasti"
  },
  {
    "text": "Guatay",
    "value": "guatay"
  },
  {
    "text": "Guerneville",
    "value": "guerneville"
  },
  {
    "text": "Guernsey",
    "value": "guernsey"
  },
  {
    "text": "Gueydan",
    "value": "gueydan"
  },
  {
    "text": "Guffey",
    "value": "guffey"
  },
  {
    "text": "Guide Rock",
    "value": "guide rock"
  },
  {
    "text": "Guild",
    "value": "guild"
  },
  {
    "text": "Guilderland",
    "value": "guilderland"
  },
  {
    "text": "Guilderland Center",
    "value": "guilderland center"
  },
  {
    "text": "Guildhall",
    "value": "guildhall"
  },
  {
    "text": "Guilford",
    "value": "guilford"
  },
  {
    "text": "Guin",
    "value": "guin"
  },
  {
    "text": "Guinda",
    "value": "guinda"
  },
  {
    "text": "Guion",
    "value": "guion"
  },
  {
    "text": "Gulf",
    "value": "gulf"
  },
  {
    "text": "Gulf Breeze",
    "value": "gulf breeze"
  },
  {
    "text": "Gulf Shores",
    "value": "gulf shores"
  },
  {
    "text": "Gulfport",
    "value": "gulfport"
  },
  {
    "text": "Gulliver",
    "value": "gulliver"
  },
  {
    "text": "Gully",
    "value": "gully"
  },
  {
    "text": "Gum Spring",
    "value": "gum spring"
  },
  {
    "text": "Gumlog",
    "value": "gumlog"
  },
  {
    "text": "Gun Barrel City",
    "value": "gun barrel city"
  },
  {
    "text": "Gunbarrel",
    "value": "gunbarrel"
  },
  {
    "text": "Gunnison",
    "value": "gunnison"
  },
  {
    "text": "Gunpowder",
    "value": "gunpowder"
  },
  {
    "text": "Gunter",
    "value": "gunter"
  },
  {
    "text": "Guntersville",
    "value": "guntersville"
  },
  {
    "text": "Guntown",
    "value": "guntown"
  },
  {
    "text": "Gunville",
    "value": "gunville"
  },
  {
    "text": "Gurdon",
    "value": "gurdon"
  },
  {
    "text": "Gurley",
    "value": "gurley"
  },
  {
    "text": "Gurnee",
    "value": "gurnee"
  },
  {
    "text": "Gustavus",
    "value": "gustavus"
  },
  {
    "text": "Gustine",
    "value": "gustine"
  },
  {
    "text": "Guston",
    "value": "guston"
  },
  {
    "text": "Guthrie",
    "value": "guthrie"
  },
  {
    "text": "Guthrie Center",
    "value": "guthrie center"
  },
  {
    "text": "Guttenberg",
    "value": "guttenberg"
  },
  {
    "text": "Guy",
    "value": "guy"
  },
  {
    "text": "Guymon",
    "value": "guymon"
  },
  {
    "text": "Guys",
    "value": "guys"
  },
  {
    "text": "Guys Mills",
    "value": "guys mills"
  },
  {
    "text": "Guysville",
    "value": "guysville"
  },
  {
    "text": "Guyton",
    "value": "guyton"
  },
  {
    "text": "Gwinn",
    "value": "gwinn"
  },
  {
    "text": "Gwinner",
    "value": "gwinner"
  },
  {
    "text": "Gwynedd",
    "value": "gwynedd"
  },
  {
    "text": "Gwynedd Valley",
    "value": "gwynedd valley"
  },
  {
    "text": "Gwynn",
    "value": "gwynn"
  },
  {
    "text": "Gwynn Oak",
    "value": "gwynn oak"
  },
  {
    "text": "Gwynneville",
    "value": "gwynneville"
  },
  {
    "text": "Gypsum",
    "value": "gypsum"
  },
  {
    "text": "Hachita",
    "value": "hachita"
  },
  {
    "text": "Hacienda Heights",
    "value": "hacienda heights"
  },
  {
    "text": "Hackberry",
    "value": "hackberry"
  },
  {
    "text": "Hackensack",
    "value": "hackensack"
  },
  {
    "text": "Hacker Valley",
    "value": "hacker valley"
  },
  {
    "text": "Hackett",
    "value": "hackett"
  },
  {
    "text": "Hackettstown",
    "value": "hackettstown"
  },
  {
    "text": "Hackleburg",
    "value": "hackleburg"
  },
  {
    "text": "Haddam",
    "value": "haddam"
  },
  {
    "text": "Haddock",
    "value": "haddock"
  },
  {
    "text": "Haddon Heights",
    "value": "haddon heights"
  },
  {
    "text": "Haddonfield",
    "value": "haddonfield"
  },
  {
    "text": "Hadley",
    "value": "hadley"
  },
  {
    "text": "Hagaman",
    "value": "hagaman"
  },
  {
    "text": "Hagan",
    "value": "hagan"
  },
  {
    "text": "Hagarstown",
    "value": "hagarstown"
  },
  {
    "text": "Hagarville",
    "value": "hagarville"
  },
  {
    "text": "Hager City",
    "value": "hager city"
  },
  {
    "text": "Hagerhill",
    "value": "hagerhill"
  },
  {
    "text": "Hagerman",
    "value": "hagerman"
  },
  {
    "text": "Hagerstown",
    "value": "hagerstown"
  },
  {
    "text": "Hague",
    "value": "hague"
  },
  {
    "text": "Hahira",
    "value": "hahira"
  },
  {
    "text": "Hahnville",
    "value": "hahnville"
  },
  {
    "text": "Haigler",
    "value": "haigler"
  },
  {
    "text": "Haiku",
    "value": "haiku"
  },
  {
    "text": "Haiku-Pauwela",
    "value": "haiku-pauwela"
  },
  {
    "text": "Hailey",
    "value": "hailey"
  },
  {
    "text": "Haileyville",
    "value": "haileyville"
  },
  {
    "text": "Haines",
    "value": "haines"
  },
  {
    "text": "Haines City",
    "value": "haines city"
  },
  {
    "text": "Haines Falls",
    "value": "haines falls"
  },
  {
    "text": "Hainesport",
    "value": "hainesport"
  },
  {
    "text": "Hainesville",
    "value": "hainesville"
  },
  {
    "text": "Hakalau",
    "value": "hakalau"
  },
  {
    "text": "Halbur",
    "value": "halbur"
  },
  {
    "text": "Halcottsville",
    "value": "halcottsville"
  },
  {
    "text": "Hale",
    "value": "hale"
  },
  {
    "text": "Hale Center",
    "value": "hale center"
  },
  {
    "text": "Hale Creek",
    "value": "hale creek"
  },
  {
    "text": "Hale'iwa",
    "value": "hale'iwa"
  },
  {
    "text": "Haledon",
    "value": "haledon"
  },
  {
    "text": "Hales Corners",
    "value": "hales corners"
  },
  {
    "text": "Halethorpe",
    "value": "halethorpe"
  },
  {
    "text": "Haletown",
    "value": "haletown"
  },
  {
    "text": "Haleyville",
    "value": "haleyville"
  },
  {
    "text": "Half Moon",
    "value": "half moon"
  },
  {
    "text": "Half Moon Bay",
    "value": "half moon bay"
  },
  {
    "text": "Half Way",
    "value": "half way"
  },
  {
    "text": "Halfmoon",
    "value": "halfmoon"
  },
  {
    "text": "Halfway",
    "value": "halfway"
  },
  {
    "text": "Halifax",
    "value": "halifax"
  },
  {
    "text": "Hall",
    "value": "hall"
  },
  {
    "text": "Hall Summit",
    "value": "hall summit"
  },
  {
    "text": "Hallam",
    "value": "hallam"
  },
  {
    "text": "Hallandale",
    "value": "hallandale"
  },
  {
    "text": "Hallandale Beach",
    "value": "hallandale beach"
  },
  {
    "text": "Hallettsville",
    "value": "hallettsville"
  },
  {
    "text": "Halliday",
    "value": "halliday"
  },
  {
    "text": "Hallie",
    "value": "hallie"
  },
  {
    "text": "Hallieford",
    "value": "hallieford"
  },
  {
    "text": "Hallock",
    "value": "hallock"
  },
  {
    "text": "Hallowell",
    "value": "hallowell"
  },
  {
    "text": "Halls",
    "value": "halls"
  },
  {
    "text": "Halls Crossroads",
    "value": "halls crossroads"
  },
  {
    "text": "Hallsboro",
    "value": "hallsboro"
  },
  {
    "text": "Hallstead",
    "value": "hallstead"
  },
  {
    "text": "Hallsville",
    "value": "hallsville"
  },
  {
    "text": "Hallwood",
    "value": "hallwood"
  },
  {
    "text": "Halsey",
    "value": "halsey"
  },
  {
    "text": "Halstad",
    "value": "halstad"
  },
  {
    "text": "Halstead",
    "value": "halstead"
  },
  {
    "text": "Haltom City",
    "value": "haltom city"
  },
  {
    "text": "Ham Lake",
    "value": "ham lake"
  },
  {
    "text": "Hambleton",
    "value": "hambleton"
  },
  {
    "text": "Hamburg",
    "value": "hamburg"
  },
  {
    "text": "Hamden",
    "value": "hamden"
  },
  {
    "text": "Hamel",
    "value": "hamel"
  },
  {
    "text": "Hamer",
    "value": "hamer"
  },
  {
    "text": "Hamersville",
    "value": "hamersville"
  },
  {
    "text": "Hamill",
    "value": "hamill"
  },
  {
    "text": "Hamilton",
    "value": "hamilton"
  },
  {
    "text": "Hamilton City",
    "value": "hamilton city"
  },
  {
    "text": "Hamilton Square",
    "value": "hamilton square"
  },
  {
    "text": "Hamler",
    "value": "hamler"
  },
  {
    "text": "Hamlet",
    "value": "hamlet"
  },
  {
    "text": "Hamlin",
    "value": "hamlin"
  },
  {
    "text": "Hammett",
    "value": "hammett"
  },
  {
    "text": "Hammon",
    "value": "hammon"
  },
  {
    "text": "Hammond",
    "value": "hammond"
  },
  {
    "text": "Hammondsport",
    "value": "hammondsport"
  },
  {
    "text": "Hammondsville",
    "value": "hammondsville"
  },
  {
    "text": "Hammonton",
    "value": "hammonton"
  },
  {
    "text": "Hampden",
    "value": "hampden"
  },
  {
    "text": "Hampden Sydney",
    "value": "hampden sydney"
  },
  {
    "text": "Hampshire",
    "value": "hampshire"
  },
  {
    "text": "Hampstead",
    "value": "hampstead"
  },
  {
    "text": "Hampton",
    "value": "hampton"
  },
  {
    "text": "Hampton Bays",
    "value": "hampton bays"
  },
  {
    "text": "Hampton Falls",
    "value": "hampton falls"
  },
  {
    "text": "Hamptonville",
    "value": "hamptonville"
  },
  {
    "text": "Hamshire",
    "value": "hamshire"
  },
  {
    "text": "Hamtramck",
    "value": "hamtramck"
  },
  {
    "text": "Hana",
    "value": "hana"
  },
  {
    "text": "Hanahan",
    "value": "hanahan"
  },
  {
    "text": "Hanalei",
    "value": "hanalei"
  },
  {
    "text": "Hanama'ulu",
    "value": "hanama'ulu"
  },
  {
    "text": "Hanapepe",
    "value": "hanapepe"
  },
  {
    "text": "Hanapēpē",
    "value": "hanapēpē"
  },
  {
    "text": "Hanceville",
    "value": "hanceville"
  },
  {
    "text": "Hancock",
    "value": "hancock"
  },
  {
    "text": "Hancocks Bridge",
    "value": "hancocks bridge"
  },
  {
    "text": "Handley",
    "value": "handley"
  },
  {
    "text": "Hanford",
    "value": "hanford"
  },
  {
    "text": "Hankamer",
    "value": "hankamer"
  },
  {
    "text": "Hankins",
    "value": "hankins"
  },
  {
    "text": "Hankinson",
    "value": "hankinson"
  },
  {
    "text": "Hanksville",
    "value": "hanksville"
  },
  {
    "text": "Hanley Falls",
    "value": "hanley falls"
  },
  {
    "text": "Hanlontown",
    "value": "hanlontown"
  },
  {
    "text": "Hanna",
    "value": "hanna"
  },
  {
    "text": "Hanna City",
    "value": "hanna city"
  },
  {
    "text": "Hannacroix",
    "value": "hannacroix"
  },
  {
    "text": "Hannaford",
    "value": "hannaford"
  },
  {
    "text": "Hannah",
    "value": "hannah"
  },
  {
    "text": "Hannastown",
    "value": "hannastown"
  },
  {
    "text": "Hannawa Falls",
    "value": "hannawa falls"
  },
  {
    "text": "Hannibal",
    "value": "hannibal"
  },
  {
    "text": "Hanover",
    "value": "hanover"
  },
  {
    "text": "Hanover Park",
    "value": "hanover park"
  },
  {
    "text": "Hanoverton",
    "value": "hanoverton"
  },
  {
    "text": "Hanscom Air Force Base",
    "value": "hanscom air force base"
  },
  {
    "text": "Hansen",
    "value": "hansen"
  },
  {
    "text": "Hansford",
    "value": "hansford"
  },
  {
    "text": "Hanska",
    "value": "hanska"
  },
  {
    "text": "Hanson",
    "value": "hanson"
  },
  {
    "text": "Hanston",
    "value": "hanston"
  },
  {
    "text": "Hansville",
    "value": "hansville"
  },
  {
    "text": "Hapeville",
    "value": "hapeville"
  },
  {
    "text": "Happy",
    "value": "happy"
  },
  {
    "text": "Happy Camp",
    "value": "happy camp"
  },
  {
    "text": "Happy Jack",
    "value": "happy jack"
  },
  {
    "text": "Happy Valley",
    "value": "happy valley"
  },
  {
    "text": "Harahan",
    "value": "harahan"
  },
  {
    "text": "Harbert",
    "value": "harbert"
  },
  {
    "text": "Harbeson",
    "value": "harbeson"
  },
  {
    "text": "Harbinger",
    "value": "harbinger"
  },
  {
    "text": "Harbor",
    "value": "harbor"
  },
  {
    "text": "Harbor Beach",
    "value": "harbor beach"
  },
  {
    "text": "Harbor City",
    "value": "harbor city"
  },
  {
    "text": "Harbor Springs",
    "value": "harbor springs"
  },
  {
    "text": "Harborcreek",
    "value": "harborcreek"
  },
  {
    "text": "Harborside",
    "value": "harborside"
  },
  {
    "text": "Harcourt",
    "value": "harcourt"
  },
  {
    "text": "Hardaway",
    "value": "hardaway"
  },
  {
    "text": "Hardburly",
    "value": "hardburly"
  },
  {
    "text": "Hardeeville",
    "value": "hardeeville"
  },
  {
    "text": "Hardesty",
    "value": "hardesty"
  },
  {
    "text": "Hardin",
    "value": "hardin"
  },
  {
    "text": "Harding",
    "value": "harding"
  },
  {
    "text": "Hardinsburg",
    "value": "hardinsburg"
  },
  {
    "text": "Hardwick",
    "value": "hardwick"
  },
  {
    "text": "Hardy",
    "value": "hardy"
  },
  {
    "text": "Hardyville",
    "value": "hardyville"
  },
  {
    "text": "Harford",
    "value": "harford"
  },
  {
    "text": "Hargill",
    "value": "hargill"
  },
  {
    "text": "Harker Heights",
    "value": "harker heights"
  },
  {
    "text": "Harkers Island",
    "value": "harkers island"
  },
  {
    "text": "Harlan",
    "value": "harlan"
  },
  {
    "text": "Harlem",
    "value": "harlem"
  },
  {
    "text": "Harleton",
    "value": "harleton"
  },
  {
    "text": "Harleysville",
    "value": "harleysville"
  },
  {
    "text": "Harleyville",
    "value": "harleyville"
  },
  {
    "text": "Harlingen",
    "value": "harlingen"
  },
  {
    "text": "Harlowton",
    "value": "harlowton"
  },
  {
    "text": "Harman",
    "value": "harman"
  },
  {
    "text": "Harmans",
    "value": "harmans"
  },
  {
    "text": "Harmon",
    "value": "harmon"
  },
  {
    "text": "Harmonsburg",
    "value": "harmonsburg"
  },
  {
    "text": "Harmony",
    "value": "harmony"
  },
  {
    "text": "Harned",
    "value": "harned"
  },
  {
    "text": "Harold",
    "value": "harold"
  },
  {
    "text": "Harper",
    "value": "harper"
  },
  {
    "text": "Harper Woods",
    "value": "harper woods"
  },
  {
    "text": "Harpers Ferry",
    "value": "harpers ferry"
  },
  {
    "text": "Harpersfield",
    "value": "harpersfield"
  },
  {
    "text": "Harpersville",
    "value": "harpersville"
  },
  {
    "text": "Harperville",
    "value": "harperville"
  },
  {
    "text": "Harpster",
    "value": "harpster"
  },
  {
    "text": "Harpswell",
    "value": "harpswell"
  },
  {
    "text": "Harpursville",
    "value": "harpursville"
  },
  {
    "text": "Harrah",
    "value": "harrah"
  },
  {
    "text": "Harrells",
    "value": "harrells"
  },
  {
    "text": "Harrellsville",
    "value": "harrellsville"
  },
  {
    "text": "Harriet",
    "value": "harriet"
  },
  {
    "text": "Harrietta",
    "value": "harrietta"
  },
  {
    "text": "Harriman",
    "value": "harriman"
  },
  {
    "text": "Harrington",
    "value": "harrington"
  },
  {
    "text": "Harrington Park",
    "value": "harrington park"
  },
  {
    "text": "Harris",
    "value": "harris"
  },
  {
    "text": "Harris Hill",
    "value": "harris hill"
  },
  {
    "text": "Harrisburg",
    "value": "harrisburg"
  },
  {
    "text": "Harrison",
    "value": "harrison"
  },
  {
    "text": "Harrison City",
    "value": "harrison city"
  },
  {
    "text": "Harrison Valley",
    "value": "harrison valley"
  },
  {
    "text": "Harrisonburg",
    "value": "harrisonburg"
  },
  {
    "text": "Harrisonville",
    "value": "harrisonville"
  },
  {
    "text": "Harristown",
    "value": "harristown"
  },
  {
    "text": "Harrisville",
    "value": "harrisville"
  },
  {
    "text": "Harrod",
    "value": "harrod"
  },
  {
    "text": "Harrods Creek",
    "value": "harrods creek"
  },
  {
    "text": "Harrodsburg",
    "value": "harrodsburg"
  },
  {
    "text": "Harrogate",
    "value": "harrogate"
  },
  {
    "text": "Harrold",
    "value": "harrold"
  },
  {
    "text": "Harsens Island",
    "value": "harsens island"
  },
  {
    "text": "Harshaw",
    "value": "harshaw"
  },
  {
    "text": "Hart",
    "value": "hart"
  },
  {
    "text": "Hartfield",
    "value": "hartfield"
  },
  {
    "text": "Hartford",
    "value": "hartford"
  },
  {
    "text": "Hartford City",
    "value": "hartford city"
  },
  {
    "text": "Hartington",
    "value": "hartington"
  },
  {
    "text": "Hartland",
    "value": "hartland"
  },
  {
    "text": "Hartleton",
    "value": "hartleton"
  },
  {
    "text": "Hartley",
    "value": "hartley"
  },
  {
    "text": "Hartline",
    "value": "hartline"
  },
  {
    "text": "Hartly",
    "value": "hartly"
  },
  {
    "text": "Hartman",
    "value": "hartman"
  },
  {
    "text": "Harts",
    "value": "harts"
  },
  {
    "text": "Hartsburg",
    "value": "hartsburg"
  },
  {
    "text": "Hartsdale",
    "value": "hartsdale"
  },
  {
    "text": "Hartsel",
    "value": "hartsel"
  },
  {
    "text": "Hartselle",
    "value": "hartselle"
  },
  {
    "text": "Hartsfield",
    "value": "hartsfield"
  },
  {
    "text": "Hartshorn",
    "value": "hartshorn"
  },
  {
    "text": "Hartshorne",
    "value": "hartshorne"
  },
  {
    "text": "Hartstown",
    "value": "hartstown"
  },
  {
    "text": "Hartsville",
    "value": "hartsville"
  },
  {
    "text": "Hartville",
    "value": "hartville"
  },
  {
    "text": "Hartwell",
    "value": "hartwell"
  },
  {
    "text": "Hartwick",
    "value": "hartwick"
  },
  {
    "text": "Harvard",
    "value": "harvard"
  },
  {
    "text": "Harvel",
    "value": "harvel"
  },
  {
    "text": "Harvest",
    "value": "harvest"
  },
  {
    "text": "Harvey",
    "value": "harvey"
  },
  {
    "text": "Harveys Lake",
    "value": "harveys lake"
  },
  {
    "text": "Harveysburg",
    "value": "harveysburg"
  },
  {
    "text": "Harveyville",
    "value": "harveyville"
  },
  {
    "text": "Harviell",
    "value": "harviell"
  },
  {
    "text": "Harwich",
    "value": "harwich"
  },
  {
    "text": "Harwich Port",
    "value": "harwich port"
  },
  {
    "text": "Harwick",
    "value": "harwick"
  },
  {
    "text": "Harwinton",
    "value": "harwinton"
  },
  {
    "text": "Harwood",
    "value": "harwood"
  },
  {
    "text": "Harwood Heights",
    "value": "harwood heights"
  },
  {
    "text": "Hasbrouck Heights",
    "value": "hasbrouck heights"
  },
  {
    "text": "Haskell",
    "value": "haskell"
  },
  {
    "text": "Haskins",
    "value": "haskins"
  },
  {
    "text": "Haslet",
    "value": "haslet"
  },
  {
    "text": "Haslett",
    "value": "haslett"
  },
  {
    "text": "Hasson Heights",
    "value": "hasson heights"
  },
  {
    "text": "Hastings",
    "value": "hastings"
  },
  {
    "text": "Hastings-on-Hudson",
    "value": "hastings-on-hudson"
  },
  {
    "text": "Hasty",
    "value": "hasty"
  },
  {
    "text": "Hat Creek",
    "value": "hat creek"
  },
  {
    "text": "Hatboro",
    "value": "hatboro"
  },
  {
    "text": "Hatch",
    "value": "hatch"
  },
  {
    "text": "Hatchechubbee",
    "value": "hatchechubbee"
  },
  {
    "text": "Hatfield",
    "value": "hatfield"
  },
  {
    "text": "Hathaway Pines",
    "value": "hathaway pines"
  },
  {
    "text": "Hathorne",
    "value": "hathorne"
  },
  {
    "text": "Hatley",
    "value": "hatley"
  },
  {
    "text": "Hatteras",
    "value": "hatteras"
  },
  {
    "text": "Hattiesburg",
    "value": "hattiesburg"
  },
  {
    "text": "Hattieville",
    "value": "hattieville"
  },
  {
    "text": "Hatton",
    "value": "hatton"
  },
  {
    "text": "Hau'ula",
    "value": "hau'ula"
  },
  {
    "text": "Haubstadt",
    "value": "haubstadt"
  },
  {
    "text": "Haugan",
    "value": "haugan"
  },
  {
    "text": "Haugen",
    "value": "haugen"
  },
  {
    "text": "Haughton",
    "value": "haughton"
  },
  {
    "text": "Hauppauge",
    "value": "hauppauge"
  },
  {
    "text": "Havana",
    "value": "havana"
  },
  {
    "text": "Havelock",
    "value": "havelock"
  },
  {
    "text": "Haven",
    "value": "haven"
  },
  {
    "text": "Havensville",
    "value": "havensville"
  },
  {
    "text": "Haverford",
    "value": "haverford"
  },
  {
    "text": "Haverhill",
    "value": "haverhill"
  },
  {
    "text": "Haverstraw",
    "value": "haverstraw"
  },
  {
    "text": "Havertown",
    "value": "havertown"
  },
  {
    "text": "Haviland",
    "value": "haviland"
  },
  {
    "text": "Havre",
    "value": "havre"
  },
  {
    "text": "Havre de Grace",
    "value": "havre de grace"
  },
  {
    "text": "Haw River",
    "value": "haw river"
  },
  {
    "text": "Hawaii National Park",
    "value": "hawaii national park"
  },
  {
    "text": "Hawaiian Acres",
    "value": "hawaiian acres"
  },
  {
    "text": "Hawaiian Gardens",
    "value": "hawaiian gardens"
  },
  {
    "text": "Hawarden",
    "value": "hawarden"
  },
  {
    "text": "Hawesville",
    "value": "hawesville"
  },
  {
    "text": "Hawi",
    "value": "hawi"
  },
  {
    "text": "Hawk Point",
    "value": "hawk point"
  },
  {
    "text": "Hawk Run",
    "value": "hawk run"
  },
  {
    "text": "Hawk Springs",
    "value": "hawk springs"
  },
  {
    "text": "Hawkeye",
    "value": "hawkeye"
  },
  {
    "text": "Hawkins",
    "value": "hawkins"
  },
  {
    "text": "Hawkinsville",
    "value": "hawkinsville"
  },
  {
    "text": "Hawks",
    "value": "hawks"
  },
  {
    "text": "Hawley",
    "value": "hawley"
  },
  {
    "text": "Hawleyville",
    "value": "hawleyville"
  },
  {
    "text": "Haworth",
    "value": "haworth"
  },
  {
    "text": "Hawthorn",
    "value": "hawthorn"
  },
  {
    "text": "Hawthorn Woods",
    "value": "hawthorn woods"
  },
  {
    "text": "Hawthorne",
    "value": "hawthorne"
  },
  {
    "text": "Haxtun",
    "value": "haxtun"
  },
  {
    "text": "Hay",
    "value": "hay"
  },
  {
    "text": "Hay Springs",
    "value": "hay springs"
  },
  {
    "text": "Hayden",
    "value": "hayden"
  },
  {
    "text": "Hayden Lake",
    "value": "hayden lake"
  },
  {
    "text": "Haydenville",
    "value": "haydenville"
  },
  {
    "text": "Hayes",
    "value": "hayes"
  },
  {
    "text": "Hayes Center",
    "value": "hayes center"
  },
  {
    "text": "Hayesville",
    "value": "hayesville"
  },
  {
    "text": "Hayfield",
    "value": "hayfield"
  },
  {
    "text": "Hayfork",
    "value": "hayfork"
  },
  {
    "text": "Haymarket",
    "value": "haymarket"
  },
  {
    "text": "Haynesville",
    "value": "haynesville"
  },
  {
    "text": "Hayneville",
    "value": "hayneville"
  },
  {
    "text": "Hays",
    "value": "hays"
  },
  {
    "text": "Haysi",
    "value": "haysi"
  },
  {
    "text": "Haysville",
    "value": "haysville"
  },
  {
    "text": "Hayti",
    "value": "hayti"
  },
  {
    "text": "Hayward",
    "value": "hayward"
  },
  {
    "text": "Haywood",
    "value": "haywood"
  },
  {
    "text": "Hazard",
    "value": "hazard"
  },
  {
    "text": "Hazel",
    "value": "hazel"
  },
  {
    "text": "Hazel Crest",
    "value": "hazel crest"
  },
  {
    "text": "Hazel Green",
    "value": "hazel green"
  },
  {
    "text": "Hazel Park",
    "value": "hazel park"
  },
  {
    "text": "Hazelhurst",
    "value": "hazelhurst"
  },
  {
    "text": "Hazelton",
    "value": "hazelton"
  },
  {
    "text": "Hazelwood",
    "value": "hazelwood"
  },
  {
    "text": "Hazen",
    "value": "hazen"
  },
  {
    "text": "Hazlehurst",
    "value": "hazlehurst"
  },
  {
    "text": "Hazlet",
    "value": "hazlet"
  },
  {
    "text": "Hazleton",
    "value": "hazleton"
  },
  {
    "text": "Haʻikū",
    "value": "haʻikū"
  },
  {
    "text": "Head of Westport",
    "value": "head of westport"
  },
  {
    "text": "Headland",
    "value": "headland"
  },
  {
    "text": "Headrick",
    "value": "headrick"
  },
  {
    "text": "Healdsburg",
    "value": "healdsburg"
  },
  {
    "text": "Healdton",
    "value": "healdton"
  },
  {
    "text": "Healy",
    "value": "healy"
  },
  {
    "text": "Hearne",
    "value": "hearne"
  },
  {
    "text": "Heart Butte",
    "value": "heart butte"
  },
  {
    "text": "Heartwell",
    "value": "heartwell"
  },
  {
    "text": "Heath",
    "value": "heath"
  },
  {
    "text": "Heath Springs",
    "value": "heath springs"
  },
  {
    "text": "Heathrow",
    "value": "heathrow"
  },
  {
    "text": "Heathsville",
    "value": "heathsville"
  },
  {
    "text": "Heavener",
    "value": "heavener"
  },
  {
    "text": "Hebbronville",
    "value": "hebbronville"
  },
  {
    "text": "Heber",
    "value": "heber"
  },
  {
    "text": "Heber City",
    "value": "heber city"
  },
  {
    "text": "Heber Springs",
    "value": "heber springs"
  },
  {
    "text": "Heber-Overgaard",
    "value": "heber-overgaard"
  },
  {
    "text": "Hebo",
    "value": "hebo"
  },
  {
    "text": "Hebron",
    "value": "hebron"
  },
  {
    "text": "Hecker",
    "value": "hecker"
  },
  {
    "text": "Hecla",
    "value": "hecla"
  },
  {
    "text": "Hector",
    "value": "hector"
  },
  {
    "text": "Hedgesville",
    "value": "hedgesville"
  },
  {
    "text": "Hedley",
    "value": "hedley"
  },
  {
    "text": "Hedrick",
    "value": "hedrick"
  },
  {
    "text": "Hedwig Village",
    "value": "hedwig village"
  },
  {
    "text": "Heflin",
    "value": "heflin"
  },
  {
    "text": "Hegins",
    "value": "hegins"
  },
  {
    "text": "Heidelberg",
    "value": "heidelberg"
  },
  {
    "text": "Heidenheimer",
    "value": "heidenheimer"
  },
  {
    "text": "Heidrick",
    "value": "heidrick"
  },
  {
    "text": "Heiskell",
    "value": "heiskell"
  },
  {
    "text": "Heislerville",
    "value": "heislerville"
  },
  {
    "text": "Helen",
    "value": "helen"
  },
  {
    "text": "Helena",
    "value": "helena"
  },
  {
    "text": "Helena West Side",
    "value": "helena west side"
  },
  {
    "text": "Helendale",
    "value": "helendale"
  },
  {
    "text": "Helenville",
    "value": "helenville"
  },
  {
    "text": "Helenwood",
    "value": "helenwood"
  },
  {
    "text": "Helix",
    "value": "helix"
  },
  {
    "text": "Hellertown",
    "value": "hellertown"
  },
  {
    "text": "Hellier",
    "value": "hellier"
  },
  {
    "text": "Helm",
    "value": "helm"
  },
  {
    "text": "Helmetta",
    "value": "helmetta"
  },
  {
    "text": "Helmsburg",
    "value": "helmsburg"
  },
  {
    "text": "Helmville",
    "value": "helmville"
  },
  {
    "text": "Helotes",
    "value": "helotes"
  },
  {
    "text": "Helper",
    "value": "helper"
  },
  {
    "text": "Helton",
    "value": "helton"
  },
  {
    "text": "Heltonville",
    "value": "heltonville"
  },
  {
    "text": "Helvetia",
    "value": "helvetia"
  },
  {
    "text": "Hemet",
    "value": "hemet"
  },
  {
    "text": "Hemingford",
    "value": "hemingford"
  },
  {
    "text": "Hemingway",
    "value": "hemingway"
  },
  {
    "text": "Hemlock",
    "value": "hemlock"
  },
  {
    "text": "Hemlock Farms",
    "value": "hemlock farms"
  },
  {
    "text": "Hemphill",
    "value": "hemphill"
  },
  {
    "text": "Hempstead",
    "value": "hempstead"
  },
  {
    "text": "Henagar",
    "value": "henagar"
  },
  {
    "text": "Henderson",
    "value": "henderson"
  },
  {
    "text": "Hendersonville",
    "value": "hendersonville"
  },
  {
    "text": "Hendricks",
    "value": "hendricks"
  },
  {
    "text": "Hendrix",
    "value": "hendrix"
  },
  {
    "text": "Hendrum",
    "value": "hendrum"
  },
  {
    "text": "Henefer",
    "value": "henefer"
  },
  {
    "text": "Henley",
    "value": "henley"
  },
  {
    "text": "Hennepin",
    "value": "hennepin"
  },
  {
    "text": "Hennessey",
    "value": "hennessey"
  },
  {
    "text": "Henniker",
    "value": "henniker"
  },
  {
    "text": "Henning",
    "value": "henning"
  },
  {
    "text": "Henrico",
    "value": "henrico"
  },
  {
    "text": "Henrietta",
    "value": "henrietta"
  },
  {
    "text": "Henrieville",
    "value": "henrieville"
  },
  {
    "text": "Henry",
    "value": "henry"
  },
  {
    "text": "Henryetta",
    "value": "henryetta"
  },
  {
    "text": "Henryville",
    "value": "henryville"
  },
  {
    "text": "Hensel",
    "value": "hensel"
  },
  {
    "text": "Hensley",
    "value": "hensley"
  },
  {
    "text": "Hensonville",
    "value": "hensonville"
  },
  {
    "text": "Hephzibah",
    "value": "hephzibah"
  },
  {
    "text": "Hepler",
    "value": "hepler"
  },
  {
    "text": "Heppner",
    "value": "heppner"
  },
  {
    "text": "Hepzibah",
    "value": "hepzibah"
  },
  {
    "text": "Herald",
    "value": "herald"
  },
  {
    "text": "Herbster",
    "value": "herbster"
  },
  {
    "text": "Herculaneum",
    "value": "herculaneum"
  },
  {
    "text": "Hercules",
    "value": "hercules"
  },
  {
    "text": "Hereford",
    "value": "hereford"
  },
  {
    "text": "Herington",
    "value": "herington"
  },
  {
    "text": "Heritage Creek",
    "value": "heritage creek"
  },
  {
    "text": "Herkimer",
    "value": "herkimer"
  },
  {
    "text": "Herlong",
    "value": "herlong"
  },
  {
    "text": "Herman",
    "value": "herman"
  },
  {
    "text": "Hermann",
    "value": "hermann"
  },
  {
    "text": "Hermansville",
    "value": "hermansville"
  },
  {
    "text": "Hermantown",
    "value": "hermantown"
  },
  {
    "text": "Hermanville",
    "value": "hermanville"
  },
  {
    "text": "Herminie",
    "value": "herminie"
  },
  {
    "text": "Hermiston",
    "value": "hermiston"
  },
  {
    "text": "Hermitage",
    "value": "hermitage"
  },
  {
    "text": "Hermleigh",
    "value": "hermleigh"
  },
  {
    "text": "Hermon",
    "value": "hermon"
  },
  {
    "text": "Hermosa",
    "value": "hermosa"
  },
  {
    "text": "Hermosa Beach",
    "value": "hermosa beach"
  },
  {
    "text": "Hernandez",
    "value": "hernandez"
  },
  {
    "text": "Hernando",
    "value": "hernando"
  },
  {
    "text": "Herndon",
    "value": "herndon"
  },
  {
    "text": "Hernshaw",
    "value": "hernshaw"
  },
  {
    "text": "Herod",
    "value": "herod"
  },
  {
    "text": "Heron",
    "value": "heron"
  },
  {
    "text": "Heron Lake",
    "value": "heron lake"
  },
  {
    "text": "Herreid",
    "value": "herreid"
  },
  {
    "text": "Herrick",
    "value": "herrick"
  },
  {
    "text": "Herriman",
    "value": "herriman"
  },
  {
    "text": "Herrin",
    "value": "herrin"
  },
  {
    "text": "Herron",
    "value": "herron"
  },
  {
    "text": "Herscher",
    "value": "herscher"
  },
  {
    "text": "Hersey",
    "value": "hersey"
  },
  {
    "text": "Hershey",
    "value": "hershey"
  },
  {
    "text": "Hertel",
    "value": "hertel"
  },
  {
    "text": "Hertford",
    "value": "hertford"
  },
  {
    "text": "Hesperia",
    "value": "hesperia"
  },
  {
    "text": "Hesperus",
    "value": "hesperus"
  },
  {
    "text": "Hessel",
    "value": "hessel"
  },
  {
    "text": "Hessmer",
    "value": "hessmer"
  },
  {
    "text": "Hesston",
    "value": "hesston"
  },
  {
    "text": "Hestand",
    "value": "hestand"
  },
  {
    "text": "Hester",
    "value": "hester"
  },
  {
    "text": "Heth",
    "value": "heth"
  },
  {
    "text": "Hettick",
    "value": "hettick"
  },
  {
    "text": "Hettinger",
    "value": "hettinger"
  },
  {
    "text": "Heuvelton",
    "value": "heuvelton"
  },
  {
    "text": "Hewett",
    "value": "hewett"
  },
  {
    "text": "Hewitt",
    "value": "hewitt"
  },
  {
    "text": "Hewlett",
    "value": "hewlett"
  },
  {
    "text": "Hext",
    "value": "hext"
  },
  {
    "text": "Heyburn",
    "value": "heyburn"
  },
  {
    "text": "Heyworth",
    "value": "heyworth"
  },
  {
    "text": "Hi Hat",
    "value": "hi hat"
  },
  {
    "text": "Hialeah",
    "value": "hialeah"
  },
  {
    "text": "Hialeah Gardens",
    "value": "hialeah gardens"
  },
  {
    "text": "Hiawassee",
    "value": "hiawassee"
  },
  {
    "text": "Hiawatha",
    "value": "hiawatha"
  },
  {
    "text": "Hibbing",
    "value": "hibbing"
  },
  {
    "text": "Hibbs",
    "value": "hibbs"
  },
  {
    "text": "Hibernia",
    "value": "hibernia"
  },
  {
    "text": "Hickman",
    "value": "hickman"
  },
  {
    "text": "Hickory",
    "value": "hickory"
  },
  {
    "text": "Hickory Corners",
    "value": "hickory corners"
  },
  {
    "text": "Hickory Creek",
    "value": "hickory creek"
  },
  {
    "text": "Hickory Flat",
    "value": "hickory flat"
  },
  {
    "text": "Hickory Grove",
    "value": "hickory grove"
  },
  {
    "text": "Hickory Hills",
    "value": "hickory hills"
  },
  {
    "text": "Hickory Ridge",
    "value": "hickory ridge"
  },
  {
    "text": "Hickory Valley",
    "value": "hickory valley"
  },
  {
    "text": "Hicksville",
    "value": "hicksville"
  },
  {
    "text": "Hico",
    "value": "hico"
  },
  {
    "text": "Hidalgo",
    "value": "hidalgo"
  },
  {
    "text": "Hidden Hills",
    "value": "hidden hills"
  },
  {
    "text": "Hidden Valley",
    "value": "hidden valley"
  },
  {
    "text": "Hidden Valley Lake",
    "value": "hidden valley lake"
  },
  {
    "text": "Hiddenite",
    "value": "hiddenite"
  },
  {
    "text": "Higbee",
    "value": "higbee"
  },
  {
    "text": "Higden",
    "value": "higden"
  },
  {
    "text": "Higdon",
    "value": "higdon"
  },
  {
    "text": "Higganum",
    "value": "higganum"
  },
  {
    "text": "Higgins",
    "value": "higgins"
  },
  {
    "text": "Higgins Lake",
    "value": "higgins lake"
  },
  {
    "text": "Higginson",
    "value": "higginson"
  },
  {
    "text": "Higginsport",
    "value": "higginsport"
  },
  {
    "text": "Higginsville",
    "value": "higginsville"
  },
  {
    "text": "High Bridge",
    "value": "high bridge"
  },
  {
    "text": "High Falls",
    "value": "high falls"
  },
  {
    "text": "High Hill",
    "value": "high hill"
  },
  {
    "text": "High Island",
    "value": "high island"
  },
  {
    "text": "High Point",
    "value": "high point"
  },
  {
    "text": "High Ridge",
    "value": "high ridge"
  },
  {
    "text": "High Rolls",
    "value": "high rolls"
  },
  {
    "text": "High Shoals",
    "value": "high shoals"
  },
  {
    "text": "High Springs",
    "value": "high springs"
  },
  {
    "text": "High View",
    "value": "high view"
  },
  {
    "text": "Highfalls",
    "value": "highfalls"
  },
  {
    "text": "Highgate Center",
    "value": "highgate center"
  },
  {
    "text": "Highgate Springs",
    "value": "highgate springs"
  },
  {
    "text": "Highgrove",
    "value": "highgrove"
  },
  {
    "text": "Highland",
    "value": "highland"
  },
  {
    "text": "Highland Beach",
    "value": "highland beach"
  },
  {
    "text": "Highland City",
    "value": "highland city"
  },
  {
    "text": "Highland Falls",
    "value": "highland falls"
  },
  {
    "text": "Highland Heights",
    "value": "highland heights"
  },
  {
    "text": "Highland Hills",
    "value": "highland hills"
  },
  {
    "text": "Highland Home",
    "value": "highland home"
  },
  {
    "text": "Highland Lakes",
    "value": "highland lakes"
  },
  {
    "text": "Highland Mills",
    "value": "highland mills"
  },
  {
    "text": "Highland Park",
    "value": "highland park"
  },
  {
    "text": "Highland Springs",
    "value": "highland springs"
  },
  {
    "text": "Highland Village",
    "value": "highland village"
  },
  {
    "text": "Highlands",
    "value": "highlands"
  },
  {
    "text": "Highlands Ranch",
    "value": "highlands ranch"
  },
  {
    "text": "Highlands-Baywood Park",
    "value": "highlands-baywood park"
  },
  {
    "text": "Highlandville",
    "value": "highlandville"
  },
  {
    "text": "Highmore",
    "value": "highmore"
  },
  {
    "text": "Highmount",
    "value": "highmount"
  },
  {
    "text": "Highspire",
    "value": "highspire"
  },
  {
    "text": "Hightstown",
    "value": "hightstown"
  },
  {
    "text": "Highwood",
    "value": "highwood"
  },
  {
    "text": "Higley",
    "value": "higley"
  },
  {
    "text": "Hiko",
    "value": "hiko"
  },
  {
    "text": "Hilbert",
    "value": "hilbert"
  },
  {
    "text": "Hilda",
    "value": "hilda"
  },
  {
    "text": "Hildale",
    "value": "hildale"
  },
  {
    "text": "Hildebran",
    "value": "hildebran"
  },
  {
    "text": "Hildreth",
    "value": "hildreth"
  },
  {
    "text": "Hilger",
    "value": "hilger"
  },
  {
    "text": "Hilham",
    "value": "hilham"
  },
  {
    "text": "Hill",
    "value": "hill"
  },
  {
    "text": "Hill 'n Dale",
    "value": "hill 'n dale"
  },
  {
    "text": "Hill Air Force Base",
    "value": "hill air force base"
  },
  {
    "text": "Hill City",
    "value": "hill city"
  },
  {
    "text": "Hill Point",
    "value": "hill point"
  },
  {
    "text": "Hillburn",
    "value": "hillburn"
  },
  {
    "text": "Hillcrest Heights",
    "value": "hillcrest heights"
  },
  {
    "text": "Hiller",
    "value": "hiller"
  },
  {
    "text": "Hilliard",
    "value": "hilliard"
  },
  {
    "text": "Hilliards",
    "value": "hilliards"
  },
  {
    "text": "Hillister",
    "value": "hillister"
  },
  {
    "text": "Hillman",
    "value": "hillman"
  },
  {
    "text": "Hillrose",
    "value": "hillrose"
  },
  {
    "text": "Hills",
    "value": "hills"
  },
  {
    "text": "Hillsboro",
    "value": "hillsboro"
  },
  {
    "text": "Hillsboro Beach",
    "value": "hillsboro beach"
  },
  {
    "text": "Hillsborough",
    "value": "hillsborough"
  },
  {
    "text": "Hillsdale",
    "value": "hillsdale"
  },
  {
    "text": "Hillsgrove",
    "value": "hillsgrove"
  },
  {
    "text": "Hillside",
    "value": "hillside"
  },
  {
    "text": "Hillsville",
    "value": "hillsville"
  },
  {
    "text": "Hilltop",
    "value": "hilltop"
  },
  {
    "text": "Hilltown",
    "value": "hilltown"
  },
  {
    "text": "Hillview",
    "value": "hillview"
  },
  {
    "text": "Hilmar",
    "value": "hilmar"
  },
  {
    "text": "Hilo",
    "value": "hilo"
  },
  {
    "text": "Hilton",
    "value": "hilton"
  },
  {
    "text": "Hilton Head",
    "value": "hilton head"
  },
  {
    "text": "Hilton Head Island",
    "value": "hilton head island"
  },
  {
    "text": "Hiltons",
    "value": "hiltons"
  },
  {
    "text": "Himrod",
    "value": "himrod"
  },
  {
    "text": "Hinckley",
    "value": "hinckley"
  },
  {
    "text": "Hindman",
    "value": "hindman"
  },
  {
    "text": "Hindsboro",
    "value": "hindsboro"
  },
  {
    "text": "Hindsville",
    "value": "hindsville"
  },
  {
    "text": "Hines",
    "value": "hines"
  },
  {
    "text": "Hinesburg",
    "value": "hinesburg"
  },
  {
    "text": "Hineston",
    "value": "hineston"
  },
  {
    "text": "Hinesville",
    "value": "hinesville"
  },
  {
    "text": "Hingham",
    "value": "hingham"
  },
  {
    "text": "Hinkle",
    "value": "hinkle"
  },
  {
    "text": "Hinkley",
    "value": "hinkley"
  },
  {
    "text": "Hinsdale",
    "value": "hinsdale"
  },
  {
    "text": "Hinton",
    "value": "hinton"
  },
  {
    "text": "Hiram",
    "value": "hiram"
  },
  {
    "text": "Hiseville",
    "value": "hiseville"
  },
  {
    "text": "Hitchcock",
    "value": "hitchcock"
  },
  {
    "text": "Hitchins",
    "value": "hitchins"
  },
  {
    "text": "Hitchita",
    "value": "hitchita"
  },
  {
    "text": "Hitterdal",
    "value": "hitterdal"
  },
  {
    "text": "Hiwasse",
    "value": "hiwasse"
  },
  {
    "text": "Hiwassee",
    "value": "hiwassee"
  },
  {
    "text": "Hixson",
    "value": "hixson"
  },
  {
    "text": "Hixton",
    "value": "hixton"
  },
  {
    "text": "Ho-Ho-Kus",
    "value": "ho-ho-kus"
  },
  {
    "text": "Hoagland",
    "value": "hoagland"
  },
  {
    "text": "Hoback",
    "value": "hoback"
  },
  {
    "text": "Hobart",
    "value": "hobart"
  },
  {
    "text": "Hobbs",
    "value": "hobbs"
  },
  {
    "text": "Hobbsville",
    "value": "hobbsville"
  },
  {
    "text": "Hobe Sound",
    "value": "hobe sound"
  },
  {
    "text": "Hobgood",
    "value": "hobgood"
  },
  {
    "text": "Hoboken",
    "value": "hoboken"
  },
  {
    "text": "Hobson",
    "value": "hobson"
  },
  {
    "text": "Hobucken",
    "value": "hobucken"
  },
  {
    "text": "Hockessin",
    "value": "hockessin"
  },
  {
    "text": "Hockley",
    "value": "hockley"
  },
  {
    "text": "Hodgdon",
    "value": "hodgdon"
  },
  {
    "text": "Hodge",
    "value": "hodge"
  },
  {
    "text": "Hodgen",
    "value": "hodgen"
  },
  {
    "text": "Hodgenville",
    "value": "hodgenville"
  },
  {
    "text": "Hodges",
    "value": "hodges"
  },
  {
    "text": "Hodgkins",
    "value": "hodgkins"
  },
  {
    "text": "Hoehne",
    "value": "hoehne"
  },
  {
    "text": "Hoffman",
    "value": "hoffman"
  },
  {
    "text": "Hoffman Estates",
    "value": "hoffman estates"
  },
  {
    "text": "Hogansburg",
    "value": "hogansburg"
  },
  {
    "text": "Hogansville",
    "value": "hogansville"
  },
  {
    "text": "Hogeland",
    "value": "hogeland"
  },
  {
    "text": "Hohenwald",
    "value": "hohenwald"
  },
  {
    "text": "Hoisington",
    "value": "hoisington"
  },
  {
    "text": "Hokah",
    "value": "hokah"
  },
  {
    "text": "Hokes Bluff",
    "value": "hokes bluff"
  },
  {
    "text": "Holabird",
    "value": "holabird"
  },
  {
    "text": "Holbrook",
    "value": "holbrook"
  },
  {
    "text": "Holcomb",
    "value": "holcomb"
  },
  {
    "text": "Holcombe",
    "value": "holcombe"
  },
  {
    "text": "Holden",
    "value": "holden"
  },
  {
    "text": "Holden Heights",
    "value": "holden heights"
  },
  {
    "text": "Holdenville",
    "value": "holdenville"
  },
  {
    "text": "Holderness",
    "value": "holderness"
  },
  {
    "text": "Holdingford",
    "value": "holdingford"
  },
  {
    "text": "Holdrege",
    "value": "holdrege"
  },
  {
    "text": "Holgate",
    "value": "holgate"
  },
  {
    "text": "Holiday",
    "value": "holiday"
  },
  {
    "text": "Holiday Island",
    "value": "holiday island"
  },
  {
    "text": "Holladay",
    "value": "holladay"
  },
  {
    "text": "Holland",
    "value": "holland"
  },
  {
    "text": "Holland Patent",
    "value": "holland patent"
  },
  {
    "text": "Hollandale",
    "value": "hollandale"
  },
  {
    "text": "Hollansburg",
    "value": "hollansburg"
  },
  {
    "text": "Holley",
    "value": "holley"
  },
  {
    "text": "Holliday",
    "value": "holliday"
  },
  {
    "text": "Hollidaysburg",
    "value": "hollidaysburg"
  },
  {
    "text": "Hollins",
    "value": "hollins"
  },
  {
    "text": "Hollis",
    "value": "hollis"
  },
  {
    "text": "Hollis Center",
    "value": "hollis center"
  },
  {
    "text": "Hollis Hills",
    "value": "hollis hills"
  },
  {
    "text": "Hollister",
    "value": "hollister"
  },
  {
    "text": "Holliston",
    "value": "holliston"
  },
  {
    "text": "Holloman Air Force Base",
    "value": "holloman air force base"
  },
  {
    "text": "Hollow Rock",
    "value": "hollow rock"
  },
  {
    "text": "Holloway",
    "value": "holloway"
  },
  {
    "text": "Hollsopple",
    "value": "hollsopple"
  },
  {
    "text": "Holly",
    "value": "holly"
  },
  {
    "text": "Holly Bluff",
    "value": "holly bluff"
  },
  {
    "text": "Holly Grove",
    "value": "holly grove"
  },
  {
    "text": "Holly Hill",
    "value": "holly hill"
  },
  {
    "text": "Holly Pond",
    "value": "holly pond"
  },
  {
    "text": "Holly Ridge",
    "value": "holly ridge"
  },
  {
    "text": "Holly Springs",
    "value": "holly springs"
  },
  {
    "text": "Hollywood",
    "value": "hollywood"
  },
  {
    "text": "Hollywood Park",
    "value": "hollywood park"
  },
  {
    "text": "Holmdel",
    "value": "holmdel"
  },
  {
    "text": "Holmen",
    "value": "holmen"
  },
  {
    "text": "Holmes",
    "value": "holmes"
  },
  {
    "text": "Holmes Beach",
    "value": "holmes beach"
  },
  {
    "text": "Holmes City",
    "value": "holmes city"
  },
  {
    "text": "Holmes Mill",
    "value": "holmes mill"
  },
  {
    "text": "Holmesville",
    "value": "holmesville"
  },
  {
    "text": "Holstein",
    "value": "holstein"
  },
  {
    "text": "Holt",
    "value": "holt"
  },
  {
    "text": "Holton",
    "value": "holton"
  },
  {
    "text": "Holts Summit",
    "value": "holts summit"
  },
  {
    "text": "Holtsville",
    "value": "holtsville"
  },
  {
    "text": "Holtville",
    "value": "holtville"
  },
  {
    "text": "Holtwood",
    "value": "holtwood"
  },
  {
    "text": "Holualoa",
    "value": "holualoa"
  },
  {
    "text": "Holy Cross",
    "value": "holy cross"
  },
  {
    "text": "Holyoke",
    "value": "holyoke"
  },
  {
    "text": "Holyrood",
    "value": "holyrood"
  },
  {
    "text": "Home",
    "value": "home"
  },
  {
    "text": "Homedale",
    "value": "homedale"
  },
  {
    "text": "Homeland",
    "value": "homeland"
  },
  {
    "text": "Homeland Park",
    "value": "homeland park"
  },
  {
    "text": "Homer",
    "value": "homer"
  },
  {
    "text": "Homer City",
    "value": "homer city"
  },
  {
    "text": "Homer Glen",
    "value": "homer glen"
  },
  {
    "text": "Homerville",
    "value": "homerville"
  },
  {
    "text": "Homestead",
    "value": "homestead"
  },
  {
    "text": "Hometown",
    "value": "hometown"
  },
  {
    "text": "Homewood",
    "value": "homewood"
  },
  {
    "text": "Homeworth",
    "value": "homeworth"
  },
  {
    "text": "Hominy",
    "value": "hominy"
  },
  {
    "text": "Homosassa",
    "value": "homosassa"
  },
  {
    "text": "Homosassa Springs",
    "value": "homosassa springs"
  },
  {
    "text": "Honaker",
    "value": "honaker"
  },
  {
    "text": "Honaunau",
    "value": "honaunau"
  },
  {
    "text": "Honaunau-Napoopoo",
    "value": "honaunau-napoopoo"
  },
  {
    "text": "Hondo",
    "value": "hondo"
  },
  {
    "text": "Honea Path",
    "value": "honea path"
  },
  {
    "text": "Honeoye",
    "value": "honeoye"
  },
  {
    "text": "Honeoye Falls",
    "value": "honeoye falls"
  },
  {
    "text": "Honesdale",
    "value": "honesdale"
  },
  {
    "text": "Honey Brook",
    "value": "honey brook"
  },
  {
    "text": "Honey Creek",
    "value": "honey creek"
  },
  {
    "text": "Honey Grove",
    "value": "honey grove"
  },
  {
    "text": "Honeydew",
    "value": "honeydew"
  },
  {
    "text": "Honeyford",
    "value": "honeyford"
  },
  {
    "text": "Honeyville",
    "value": "honeyville"
  },
  {
    "text": "Honoka'a",
    "value": "honoka'a"
  },
  {
    "text": "Honokaa",
    "value": "honokaa"
  },
  {
    "text": "Honolulu",
    "value": "honolulu"
  },
  {
    "text": "Honomu",
    "value": "honomu"
  },
  {
    "text": "Honor",
    "value": "honor"
  },
  {
    "text": "Honoraville",
    "value": "honoraville"
  },
  {
    "text": "Hood",
    "value": "hood"
  },
  {
    "text": "Hood River",
    "value": "hood river"
  },
  {
    "text": "Hoodsport",
    "value": "hoodsport"
  },
  {
    "text": "Hooker",
    "value": "hooker"
  },
  {
    "text": "Hookerton",
    "value": "hookerton"
  },
  {
    "text": "Hooks",
    "value": "hooks"
  },
  {
    "text": "Hooksett",
    "value": "hooksett"
  },
  {
    "text": "Hookstown",
    "value": "hookstown"
  },
  {
    "text": "Hoonah",
    "value": "hoonah"
  },
  {
    "text": "Hoopa",
    "value": "hoopa"
  },
  {
    "text": "Hooper",
    "value": "hooper"
  },
  {
    "text": "Hooper Bay",
    "value": "hooper bay"
  },
  {
    "text": "Hoopeston",
    "value": "hoopeston"
  },
  {
    "text": "Hoople",
    "value": "hoople"
  },
  {
    "text": "Hoosick",
    "value": "hoosick"
  },
  {
    "text": "Hoosick Falls",
    "value": "hoosick falls"
  },
  {
    "text": "Hooven",
    "value": "hooven"
  },
  {
    "text": "Hoover",
    "value": "hoover"
  },
  {
    "text": "Hooversville",
    "value": "hooversville"
  },
  {
    "text": "Hop Bottom",
    "value": "hop bottom"
  },
  {
    "text": "Hopatcong",
    "value": "hopatcong"
  },
  {
    "text": "Hope",
    "value": "hope"
  },
  {
    "text": "Hope Hull",
    "value": "hope hull"
  },
  {
    "text": "Hope Mills",
    "value": "hope mills"
  },
  {
    "text": "Hope Valley",
    "value": "hope valley"
  },
  {
    "text": "Hopedale",
    "value": "hopedale"
  },
  {
    "text": "Hopewell",
    "value": "hopewell"
  },
  {
    "text": "Hopewell Junction",
    "value": "hopewell junction"
  },
  {
    "text": "Hopkins",
    "value": "hopkins"
  },
  {
    "text": "Hopkinsville",
    "value": "hopkinsville"
  },
  {
    "text": "Hopkinton",
    "value": "hopkinton"
  },
  {
    "text": "Hopland",
    "value": "hopland"
  },
  {
    "text": "Hopwood",
    "value": "hopwood"
  },
  {
    "text": "Hoquiam",
    "value": "hoquiam"
  },
  {
    "text": "Horace",
    "value": "horace"
  },
  {
    "text": "Horatio",
    "value": "horatio"
  },
  {
    "text": "Hordville",
    "value": "hordville"
  },
  {
    "text": "Horicon",
    "value": "horicon"
  },
  {
    "text": "Horizon City",
    "value": "horizon city"
  },
  {
    "text": "Horn Lake",
    "value": "horn lake"
  },
  {
    "text": "Hornbeck",
    "value": "hornbeck"
  },
  {
    "text": "Hornbrook",
    "value": "hornbrook"
  },
  {
    "text": "Hornell",
    "value": "hornell"
  },
  {
    "text": "Horner",
    "value": "horner"
  },
  {
    "text": "Hornersville",
    "value": "hornersville"
  },
  {
    "text": "Hornick",
    "value": "hornick"
  },
  {
    "text": "Hornitos",
    "value": "hornitos"
  },
  {
    "text": "Hornsby",
    "value": "hornsby"
  },
  {
    "text": "Horse Branch",
    "value": "horse branch"
  },
  {
    "text": "Horse Cave",
    "value": "horse cave"
  },
  {
    "text": "Horse Creek",
    "value": "horse creek"
  },
  {
    "text": "Horse Shoe",
    "value": "horse shoe"
  },
  {
    "text": "Horseheads",
    "value": "horseheads"
  },
  {
    "text": "Horseshoe Bay",
    "value": "horseshoe bay"
  },
  {
    "text": "Horseshoe Beach",
    "value": "horseshoe beach"
  },
  {
    "text": "Horseshoe Bend",
    "value": "horseshoe bend"
  },
  {
    "text": "Horsham",
    "value": "horsham"
  },
  {
    "text": "Hortense",
    "value": "hortense"
  },
  {
    "text": "Horton",
    "value": "horton"
  },
  {
    "text": "Hortonville",
    "value": "hortonville"
  },
  {
    "text": "Hoschton",
    "value": "hoschton"
  },
  {
    "text": "Hosford",
    "value": "hosford"
  },
  {
    "text": "Hoskins",
    "value": "hoskins"
  },
  {
    "text": "Hoskinston",
    "value": "hoskinston"
  },
  {
    "text": "Hosmer",
    "value": "hosmer"
  },
  {
    "text": "Hospers",
    "value": "hospers"
  },
  {
    "text": "Hostetter",
    "value": "hostetter"
  },
  {
    "text": "Hot Springs",
    "value": "hot springs"
  },
  {
    "text": "Hot Springs National Park",
    "value": "hot springs national park"
  },
  {
    "text": "Hot Springs Village",
    "value": "hot springs village"
  },
  {
    "text": "Hot Sulphur Springs",
    "value": "hot sulphur springs"
  },
  {
    "text": "Hotchkiss",
    "value": "hotchkiss"
  },
  {
    "text": "Hotevilla",
    "value": "hotevilla"
  },
  {
    "text": "Houck",
    "value": "houck"
  },
  {
    "text": "Houghton",
    "value": "houghton"
  },
  {
    "text": "Houghton Lake",
    "value": "houghton lake"
  },
  {
    "text": "Houghton Lake Heights",
    "value": "houghton lake heights"
  },
  {
    "text": "Houlka",
    "value": "houlka"
  },
  {
    "text": "Houlton",
    "value": "houlton"
  },
  {
    "text": "Houma",
    "value": "houma"
  },
  {
    "text": "Housatonic",
    "value": "housatonic"
  },
  {
    "text": "House",
    "value": "house"
  },
  {
    "text": "House Springs",
    "value": "house springs"
  },
  {
    "text": "Houston",
    "value": "houston"
  },
  {
    "text": "Houstonia",
    "value": "houstonia"
  },
  {
    "text": "Houtzdale",
    "value": "houtzdale"
  },
  {
    "text": "Hoven",
    "value": "hoven"
  },
  {
    "text": "Hovland",
    "value": "hovland"
  },
  {
    "text": "Howard",
    "value": "howard"
  },
  {
    "text": "Howard Beach",
    "value": "howard beach"
  },
  {
    "text": "Howard City",
    "value": "howard city"
  },
  {
    "text": "Howard Lake",
    "value": "howard lake"
  },
  {
    "text": "Howards Grove",
    "value": "howards grove"
  },
  {
    "text": "Howardsville",
    "value": "howardsville"
  },
  {
    "text": "Howe",
    "value": "howe"
  },
  {
    "text": "Howell",
    "value": "howell"
  },
  {
    "text": "Howell Township",
    "value": "howell township"
  },
  {
    "text": "Howells",
    "value": "howells"
  },
  {
    "text": "Howes",
    "value": "howes"
  },
  {
    "text": "Howes Cave",
    "value": "howes cave"
  },
  {
    "text": "Howey-in-the-Hills",
    "value": "howey-in-the-hills"
  },
  {
    "text": "Howland",
    "value": "howland"
  },
  {
    "text": "Howland Center",
    "value": "howland center"
  },
  {
    "text": "Hoxie",
    "value": "hoxie"
  },
  {
    "text": "Hoyleton",
    "value": "hoyleton"
  },
  {
    "text": "Hoyt",
    "value": "hoyt"
  },
  {
    "text": "Hoyt Lakes",
    "value": "hoyt lakes"
  },
  {
    "text": "Hoytville",
    "value": "hoytville"
  },
  {
    "text": "Hoʻolehua",
    "value": "hoʻolehua"
  },
  {
    "text": "Huachuca City",
    "value": "huachuca city"
  },
  {
    "text": "Hubbard",
    "value": "hubbard"
  },
  {
    "text": "Hubbard Lake",
    "value": "hubbard lake"
  },
  {
    "text": "Hubbardston",
    "value": "hubbardston"
  },
  {
    "text": "Hubbardsville",
    "value": "hubbardsville"
  },
  {
    "text": "Hubbell",
    "value": "hubbell"
  },
  {
    "text": "Huber Heights",
    "value": "huber heights"
  },
  {
    "text": "Huber Ridge",
    "value": "huber ridge"
  },
  {
    "text": "Hubert",
    "value": "hubert"
  },
  {
    "text": "Hubertus",
    "value": "hubertus"
  },
  {
    "text": "Huddleston",
    "value": "huddleston"
  },
  {
    "text": "Huddy",
    "value": "huddy"
  },
  {
    "text": "Hudgins",
    "value": "hudgins"
  },
  {
    "text": "Hudson",
    "value": "hudson"
  },
  {
    "text": "Hudson Falls",
    "value": "hudson falls"
  },
  {
    "text": "Hudson Oaks",
    "value": "hudson oaks"
  },
  {
    "text": "Hudsonville",
    "value": "hudsonville"
  },
  {
    "text": "Huey",
    "value": "huey"
  },
  {
    "text": "Hueysville",
    "value": "hueysville"
  },
  {
    "text": "Hueytown",
    "value": "hueytown"
  },
  {
    "text": "Huffman",
    "value": "huffman"
  },
  {
    "text": "Huger",
    "value": "huger"
  },
  {
    "text": "Huggins",
    "value": "huggins"
  },
  {
    "text": "Hughes",
    "value": "hughes"
  },
  {
    "text": "Hughes Springs",
    "value": "hughes springs"
  },
  {
    "text": "Hugheston",
    "value": "hugheston"
  },
  {
    "text": "Hughesville",
    "value": "hughesville"
  },
  {
    "text": "Hughson",
    "value": "hughson"
  },
  {
    "text": "Hugo",
    "value": "hugo"
  },
  {
    "text": "Hugoton",
    "value": "hugoton"
  },
  {
    "text": "Huguenot",
    "value": "huguenot"
  },
  {
    "text": "Hulbert",
    "value": "hulbert"
  },
  {
    "text": "Hulen",
    "value": "hulen"
  },
  {
    "text": "Hulett",
    "value": "hulett"
  },
  {
    "text": "Hull",
    "value": "hull"
  },
  {
    "text": "Hulls Cove",
    "value": "hulls cove"
  },
  {
    "text": "Humansville",
    "value": "humansville"
  },
  {
    "text": "Humarock",
    "value": "humarock"
  },
  {
    "text": "Humbird",
    "value": "humbird"
  },
  {
    "text": "Humble",
    "value": "humble"
  },
  {
    "text": "Humboldt",
    "value": "humboldt"
  },
  {
    "text": "Humboldt Hill",
    "value": "humboldt hill"
  },
  {
    "text": "Hume",
    "value": "hume"
  },
  {
    "text": "Humeston",
    "value": "humeston"
  },
  {
    "text": "Hummelstown",
    "value": "hummelstown"
  },
  {
    "text": "Humphrey",
    "value": "humphrey"
  },
  {
    "text": "Humphreys",
    "value": "humphreys"
  },
  {
    "text": "Hundred",
    "value": "hundred"
  },
  {
    "text": "Hungerford",
    "value": "hungerford"
  },
  {
    "text": "Hungry Horse",
    "value": "hungry horse"
  },
  {
    "text": "Hunker",
    "value": "hunker"
  },
  {
    "text": "Hunlock Creek",
    "value": "hunlock creek"
  },
  {
    "text": "Hunnewell",
    "value": "hunnewell"
  },
  {
    "text": "Hunt",
    "value": "hunt"
  },
  {
    "text": "Hunt Valley",
    "value": "hunt valley"
  },
  {
    "text": "Hunter",
    "value": "hunter"
  },
  {
    "text": "Hunters",
    "value": "hunters"
  },
  {
    "text": "Hunters Creek",
    "value": "hunters creek"
  },
  {
    "text": "Hunters Creek Village",
    "value": "hunters creek village"
  },
  {
    "text": "Huntersville",
    "value": "huntersville"
  },
  {
    "text": "Huntertown",
    "value": "huntertown"
  },
  {
    "text": "Huntingburg",
    "value": "huntingburg"
  },
  {
    "text": "Huntingdon",
    "value": "huntingdon"
  },
  {
    "text": "Huntingdon Valley",
    "value": "huntingdon valley"
  },
  {
    "text": "Huntington",
    "value": "huntington"
  },
  {
    "text": "Huntington Beach",
    "value": "huntington beach"
  },
  {
    "text": "Huntington Mills",
    "value": "huntington mills"
  },
  {
    "text": "Huntington Park",
    "value": "huntington park"
  },
  {
    "text": "Huntington Station",
    "value": "huntington station"
  },
  {
    "text": "Huntington Woods",
    "value": "huntington woods"
  },
  {
    "text": "Huntingtown",
    "value": "huntingtown"
  },
  {
    "text": "Huntland",
    "value": "huntland"
  },
  {
    "text": "Huntley",
    "value": "huntley"
  },
  {
    "text": "Huntly",
    "value": "huntly"
  },
  {
    "text": "Huntsburg",
    "value": "huntsburg"
  },
  {
    "text": "Huntsville",
    "value": "huntsville"
  },
  {
    "text": "Hurdland",
    "value": "hurdland"
  },
  {
    "text": "Hurdle Mills",
    "value": "hurdle mills"
  },
  {
    "text": "Hurdsfield",
    "value": "hurdsfield"
  },
  {
    "text": "Hurlburt Field",
    "value": "hurlburt field"
  },
  {
    "text": "Hurley",
    "value": "hurley"
  },
  {
    "text": "Hurleyville",
    "value": "hurleyville"
  },
  {
    "text": "Hurlock",
    "value": "hurlock"
  },
  {
    "text": "Huron",
    "value": "huron"
  },
  {
    "text": "Hurricane",
    "value": "hurricane"
  },
  {
    "text": "Hurst",
    "value": "hurst"
  },
  {
    "text": "Hurstbourne",
    "value": "hurstbourne"
  },
  {
    "text": "Hurt",
    "value": "hurt"
  },
  {
    "text": "Hurtsboro",
    "value": "hurtsboro"
  },
  {
    "text": "Huslia",
    "value": "huslia"
  },
  {
    "text": "Huson",
    "value": "huson"
  },
  {
    "text": "Husser",
    "value": "husser"
  },
  {
    "text": "Hustisford",
    "value": "hustisford"
  },
  {
    "text": "Hustle",
    "value": "hustle"
  },
  {
    "text": "Huston",
    "value": "huston"
  },
  {
    "text": "Hustontown",
    "value": "hustontown"
  },
  {
    "text": "Hustonville",
    "value": "hustonville"
  },
  {
    "text": "Hutchins",
    "value": "hutchins"
  },
  {
    "text": "Hutchinson",
    "value": "hutchinson"
  },
  {
    "text": "Hutsonville",
    "value": "hutsonville"
  },
  {
    "text": "Huttig",
    "value": "huttig"
  },
  {
    "text": "Hutto",
    "value": "hutto"
  },
  {
    "text": "Huttonsville",
    "value": "huttonsville"
  },
  {
    "text": "Huxford",
    "value": "huxford"
  },
  {
    "text": "Huxley",
    "value": "huxley"
  },
  {
    "text": "Hyampom",
    "value": "hyampom"
  },
  {
    "text": "Hyannis",
    "value": "hyannis"
  },
  {
    "text": "Hyattsville",
    "value": "hyattsville"
  },
  {
    "text": "Hyattville",
    "value": "hyattville"
  },
  {
    "text": "Hydaburg",
    "value": "hydaburg"
  },
  {
    "text": "Hyde",
    "value": "hyde"
  },
  {
    "text": "Hyde Park",
    "value": "hyde park"
  },
  {
    "text": "Hyden",
    "value": "hyden"
  },
  {
    "text": "Hyder",
    "value": "hyder"
  },
  {
    "text": "Hydetown",
    "value": "hydetown"
  },
  {
    "text": "Hydeville",
    "value": "hydeville"
  },
  {
    "text": "Hydro",
    "value": "hydro"
  },
  {
    "text": "Hye",
    "value": "hye"
  },
  {
    "text": "Hygiene",
    "value": "hygiene"
  },
  {
    "text": "Hymera",
    "value": "hymera"
  },
  {
    "text": "Hyndman",
    "value": "hyndman"
  },
  {
    "text": "Hypoluxo",
    "value": "hypoluxo"
  },
  {
    "text": "Hyrum",
    "value": "hyrum"
  },
  {
    "text": "Hysham",
    "value": "hysham"
  },
  {
    "text": "Hāwī",
    "value": "hāwī"
  },
  {
    "text": "Iaeger",
    "value": "iaeger"
  },
  {
    "text": "Ibapah",
    "value": "ibapah"
  },
  {
    "text": "Iberia",
    "value": "iberia"
  },
  {
    "text": "Icard",
    "value": "icard"
  },
  {
    "text": "Ickesburg",
    "value": "ickesburg"
  },
  {
    "text": "Ida",
    "value": "ida"
  },
  {
    "text": "Ida Grove",
    "value": "ida grove"
  },
  {
    "text": "Idabel",
    "value": "idabel"
  },
  {
    "text": "Idaho City",
    "value": "idaho city"
  },
  {
    "text": "Idaho Falls",
    "value": "idaho falls"
  },
  {
    "text": "Idaho Springs",
    "value": "idaho springs"
  },
  {
    "text": "Idalou",
    "value": "idalou"
  },
  {
    "text": "Idaville",
    "value": "idaville"
  },
  {
    "text": "Ideal",
    "value": "ideal"
  },
  {
    "text": "Ider",
    "value": "ider"
  },
  {
    "text": "Idledale",
    "value": "idledale"
  },
  {
    "text": "Idlewild",
    "value": "idlewild"
  },
  {
    "text": "Idleyld Park",
    "value": "idleyld park"
  },
  {
    "text": "Idyllwild",
    "value": "idyllwild"
  },
  {
    "text": "Idylwood",
    "value": "idylwood"
  },
  {
    "text": "Ignacio",
    "value": "ignacio"
  },
  {
    "text": "Igo",
    "value": "igo"
  },
  {
    "text": "Ijamsville",
    "value": "ijamsville"
  },
  {
    "text": "Ikes Fork",
    "value": "ikes fork"
  },
  {
    "text": "Ilfeld",
    "value": "ilfeld"
  },
  {
    "text": "Iliff",
    "value": "iliff"
  },
  {
    "text": "Ilion",
    "value": "ilion"
  },
  {
    "text": "Illinois City",
    "value": "illinois city"
  },
  {
    "text": "Illiopolis",
    "value": "illiopolis"
  },
  {
    "text": "Ilwaco",
    "value": "ilwaco"
  },
  {
    "text": "Imbler",
    "value": "imbler"
  },
  {
    "text": "Imboden",
    "value": "imboden"
  },
  {
    "text": "Imlay",
    "value": "imlay"
  },
  {
    "text": "Imlay City",
    "value": "imlay city"
  },
  {
    "text": "Imler",
    "value": "imler"
  },
  {
    "text": "Immokalee",
    "value": "immokalee"
  },
  {
    "text": "Imogene",
    "value": "imogene"
  },
  {
    "text": "Imperial",
    "value": "imperial"
  },
  {
    "text": "Imperial Beach",
    "value": "imperial beach"
  },
  {
    "text": "Ina",
    "value": "ina"
  },
  {
    "text": "Inavale",
    "value": "inavale"
  },
  {
    "text": "Inchelium",
    "value": "inchelium"
  },
  {
    "text": "Incline Village",
    "value": "incline village"
  },
  {
    "text": "Independence",
    "value": "independence"
  },
  {
    "text": "Index",
    "value": "index"
  },
  {
    "text": "Indiahoma",
    "value": "indiahoma"
  },
  {
    "text": "Indialantic",
    "value": "indialantic"
  },
  {
    "text": "Indian",
    "value": "indian"
  },
  {
    "text": "Indian Harbour Beach",
    "value": "indian harbour beach"
  },
  {
    "text": "Indian Head",
    "value": "indian head"
  },
  {
    "text": "Indian Head Park",
    "value": "indian head park"
  },
  {
    "text": "Indian Hills",
    "value": "indian hills"
  },
  {
    "text": "Indian Lake",
    "value": "indian lake"
  },
  {
    "text": "Indian Lake Estates",
    "value": "indian lake estates"
  },
  {
    "text": "Indian Mound",
    "value": "indian mound"
  },
  {
    "text": "Indian Mountain Lake",
    "value": "indian mountain lake"
  },
  {
    "text": "Indian Orchard",
    "value": "indian orchard"
  },
  {
    "text": "Indian River",
    "value": "indian river"
  },
  {
    "text": "Indian River Shores",
    "value": "indian river shores"
  },
  {
    "text": "Indian Rocks Beach",
    "value": "indian rocks beach"
  },
  {
    "text": "Indian Shores",
    "value": "indian shores"
  },
  {
    "text": "Indian Springs",
    "value": "indian springs"
  },
  {
    "text": "Indian Trail",
    "value": "indian trail"
  },
  {
    "text": "Indian Valley",
    "value": "indian valley"
  },
  {
    "text": "Indian Wells",
    "value": "indian wells"
  },
  {
    "text": "Indiana",
    "value": "indiana"
  },
  {
    "text": "Indianapolis",
    "value": "indianapolis"
  },
  {
    "text": "Indianola",
    "value": "indianola"
  },
  {
    "text": "Indiantown",
    "value": "indiantown"
  },
  {
    "text": "Indio",
    "value": "indio"
  },
  {
    "text": "Indore",
    "value": "indore"
  },
  {
    "text": "Industry",
    "value": "industry"
  },
  {
    "text": "Inez",
    "value": "inez"
  },
  {
    "text": "Ingalls",
    "value": "ingalls"
  },
  {
    "text": "Ingleside",
    "value": "ingleside"
  },
  {
    "text": "Inglewood",
    "value": "inglewood"
  },
  {
    "text": "Inglewood-Finn Hill",
    "value": "inglewood-finn hill"
  },
  {
    "text": "Inglis",
    "value": "inglis"
  },
  {
    "text": "Ingraham",
    "value": "ingraham"
  },
  {
    "text": "Ingram",
    "value": "ingram"
  },
  {
    "text": "Inkom",
    "value": "inkom"
  },
  {
    "text": "Inkster",
    "value": "inkster"
  },
  {
    "text": "Inland",
    "value": "inland"
  },
  {
    "text": "Inlet",
    "value": "inlet"
  },
  {
    "text": "Inlet Beach",
    "value": "inlet beach"
  },
  {
    "text": "Inman",
    "value": "inman"
  },
  {
    "text": "Inola",
    "value": "inola"
  },
  {
    "text": "Institute",
    "value": "institute"
  },
  {
    "text": "Intercession City",
    "value": "intercession city"
  },
  {
    "text": "Intercourse",
    "value": "intercourse"
  },
  {
    "text": "Interior",
    "value": "interior"
  },
  {
    "text": "Interlachen",
    "value": "interlachen"
  },
  {
    "text": "Interlaken",
    "value": "interlaken"
  },
  {
    "text": "Interlochen",
    "value": "interlochen"
  },
  {
    "text": "International Falls",
    "value": "international falls"
  },
  {
    "text": "Intervale",
    "value": "intervale"
  },
  {
    "text": "Inver Grove Heights",
    "value": "inver grove heights"
  },
  {
    "text": "Inverness",
    "value": "inverness"
  },
  {
    "text": "Inwood",
    "value": "inwood"
  },
  {
    "text": "Inyokern",
    "value": "inyokern"
  },
  {
    "text": "Iola",
    "value": "iola"
  },
  {
    "text": "Iona",
    "value": "iona"
  },
  {
    "text": "Ione",
    "value": "ione"
  },
  {
    "text": "Ionia",
    "value": "ionia"
  },
  {
    "text": "Iota",
    "value": "iota"
  },
  {
    "text": "Iowa",
    "value": "iowa"
  },
  {
    "text": "Iowa City",
    "value": "iowa city"
  },
  {
    "text": "Iowa Colony",
    "value": "iowa colony"
  },
  {
    "text": "Iowa Falls",
    "value": "iowa falls"
  },
  {
    "text": "Iowa Park",
    "value": "iowa park"
  },
  {
    "text": "Ipava",
    "value": "ipava"
  },
  {
    "text": "Ipswich",
    "value": "ipswich"
  },
  {
    "text": "Ira",
    "value": "ira"
  },
  {
    "text": "Iraan",
    "value": "iraan"
  },
  {
    "text": "Irasburg",
    "value": "irasburg"
  },
  {
    "text": "Iredell",
    "value": "iredell"
  },
  {
    "text": "Ireland",
    "value": "ireland"
  },
  {
    "text": "Irene",
    "value": "irene"
  },
  {
    "text": "Ireton",
    "value": "ireton"
  },
  {
    "text": "Irma",
    "value": "irma"
  },
  {
    "text": "Irmo",
    "value": "irmo"
  },
  {
    "text": "Iron",
    "value": "iron"
  },
  {
    "text": "Iron City",
    "value": "iron city"
  },
  {
    "text": "Iron Gate",
    "value": "iron gate"
  },
  {
    "text": "Iron Junction",
    "value": "iron junction"
  },
  {
    "text": "Iron Mountain",
    "value": "iron mountain"
  },
  {
    "text": "Iron Ridge",
    "value": "iron ridge"
  },
  {
    "text": "Iron River",
    "value": "iron river"
  },
  {
    "text": "Iron Station",
    "value": "iron station"
  },
  {
    "text": "Irondale",
    "value": "irondale"
  },
  {
    "text": "Irondequoit",
    "value": "irondequoit"
  },
  {
    "text": "Irons",
    "value": "irons"
  },
  {
    "text": "Ironside",
    "value": "ironside"
  },
  {
    "text": "Ironsides",
    "value": "ironsides"
  },
  {
    "text": "Ironton",
    "value": "ironton"
  },
  {
    "text": "Ironville",
    "value": "ironville"
  },
  {
    "text": "Ironwood",
    "value": "ironwood"
  },
  {
    "text": "Iroquois",
    "value": "iroquois"
  },
  {
    "text": "Irrigon",
    "value": "irrigon"
  },
  {
    "text": "Irvine",
    "value": "irvine"
  },
  {
    "text": "Irving",
    "value": "irving"
  },
  {
    "text": "Irvington",
    "value": "irvington"
  },
  {
    "text": "Irvona",
    "value": "irvona"
  },
  {
    "text": "Irwin",
    "value": "irwin"
  },
  {
    "text": "Irwindale",
    "value": "irwindale"
  },
  {
    "text": "Irwinton",
    "value": "irwinton"
  },
  {
    "text": "Isaban",
    "value": "isaban"
  },
  {
    "text": "Isabel",
    "value": "isabel"
  },
  {
    "text": "Isabella",
    "value": "isabella"
  },
  {
    "text": "Isanti",
    "value": "isanti"
  },
  {
    "text": "Iselin",
    "value": "iselin"
  },
  {
    "text": "Ishpeming",
    "value": "ishpeming"
  },
  {
    "text": "Islamorada",
    "value": "islamorada"
  },
  {
    "text": "Island",
    "value": "island"
  },
  {
    "text": "Island Falls",
    "value": "island falls"
  },
  {
    "text": "Island Heights",
    "value": "island heights"
  },
  {
    "text": "Island Lake",
    "value": "island lake"
  },
  {
    "text": "Island Park",
    "value": "island park"
  },
  {
    "text": "Island Pond",
    "value": "island pond"
  },
  {
    "text": "Islandia",
    "value": "islandia"
  },
  {
    "text": "Isle",
    "value": "isle"
  },
  {
    "text": "Isle La Motte",
    "value": "isle la motte"
  },
  {
    "text": "Isle of Palms",
    "value": "isle of palms"
  },
  {
    "text": "Isle of Wight",
    "value": "isle of wight"
  },
  {
    "text": "Islesboro",
    "value": "islesboro"
  },
  {
    "text": "Islesford",
    "value": "islesford"
  },
  {
    "text": "Isleta",
    "value": "isleta"
  },
  {
    "text": "Isleton",
    "value": "isleton"
  },
  {
    "text": "Islip",
    "value": "islip"
  },
  {
    "text": "Islip Terrace",
    "value": "islip terrace"
  },
  {
    "text": "Ismay",
    "value": "ismay"
  },
  {
    "text": "Isola",
    "value": "isola"
  },
  {
    "text": "Isom",
    "value": "isom"
  },
  {
    "text": "Isonville",
    "value": "isonville"
  },
  {
    "text": "Issaquah",
    "value": "issaquah"
  },
  {
    "text": "Italy",
    "value": "italy"
  },
  {
    "text": "Itasca",
    "value": "itasca"
  },
  {
    "text": "Ithaca",
    "value": "ithaca"
  },
  {
    "text": "Itmann",
    "value": "itmann"
  },
  {
    "text": "Itta Bena",
    "value": "itta bena"
  },
  {
    "text": "Iuka",
    "value": "iuka"
  },
  {
    "text": "Iva",
    "value": "iva"
  },
  {
    "text": "Ivan",
    "value": "ivan"
  },
  {
    "text": "Ivanhoe",
    "value": "ivanhoe"
  },
  {
    "text": "Ivel",
    "value": "ivel"
  },
  {
    "text": "Ivesdale",
    "value": "ivesdale"
  },
  {
    "text": "Ivey",
    "value": "ivey"
  },
  {
    "text": "Ivins",
    "value": "ivins"
  },
  {
    "text": "Ivor",
    "value": "ivor"
  },
  {
    "text": "Ivoryton",
    "value": "ivoryton"
  },
  {
    "text": "Ivy",
    "value": "ivy"
  },
  {
    "text": "Ivydale",
    "value": "ivydale"
  },
  {
    "text": "Ivyland",
    "value": "ivyland"
  },
  {
    "text": "Ixonia",
    "value": "ixonia"
  },
  {
    "text": "J B P H H",
    "value": "j b p h h"
  },
  {
    "text": "Jacinto City",
    "value": "jacinto city"
  },
  {
    "text": "Jack",
    "value": "jack"
  },
  {
    "text": "Jackman",
    "value": "jackman"
  },
  {
    "text": "Jackpot",
    "value": "jackpot"
  },
  {
    "text": "Jacks Creek",
    "value": "jacks creek"
  },
  {
    "text": "Jacksboro",
    "value": "jacksboro"
  },
  {
    "text": "Jackson",
    "value": "jackson"
  },
  {
    "text": "Jackson Center",
    "value": "jackson center"
  },
  {
    "text": "Jackson Heights",
    "value": "jackson heights"
  },
  {
    "text": "Jackson Springs",
    "value": "jackson springs"
  },
  {
    "text": "Jacksonburg",
    "value": "jacksonburg"
  },
  {
    "text": "Jacksonport",
    "value": "jacksonport"
  },
  {
    "text": "Jacksons Gap",
    "value": "jacksons gap"
  },
  {
    "text": "Jacksontown",
    "value": "jacksontown"
  },
  {
    "text": "Jacksonville",
    "value": "jacksonville"
  },
  {
    "text": "Jacksonville Beach",
    "value": "jacksonville beach"
  },
  {
    "text": "Jacksville",
    "value": "jacksville"
  },
  {
    "text": "Jacob",
    "value": "jacob"
  },
  {
    "text": "Jacobs Creek",
    "value": "jacobs creek"
  },
  {
    "text": "Jacobsburg",
    "value": "jacobsburg"
  },
  {
    "text": "Jacobson",
    "value": "jacobson"
  },
  {
    "text": "Jacobus",
    "value": "jacobus"
  },
  {
    "text": "Jacumba",
    "value": "jacumba"
  },
  {
    "text": "Jacumba Hot Springs",
    "value": "jacumba hot springs"
  },
  {
    "text": "Jadwin",
    "value": "jadwin"
  },
  {
    "text": "Jaffrey",
    "value": "jaffrey"
  },
  {
    "text": "Jakin",
    "value": "jakin"
  },
  {
    "text": "Jal",
    "value": "jal"
  },
  {
    "text": "Jamaica",
    "value": "jamaica"
  },
  {
    "text": "Jamaica Plain",
    "value": "jamaica plain"
  },
  {
    "text": "James City",
    "value": "james city"
  },
  {
    "text": "Jamesburg",
    "value": "jamesburg"
  },
  {
    "text": "Jameson",
    "value": "jameson"
  },
  {
    "text": "Jamesport",
    "value": "jamesport"
  },
  {
    "text": "Jamestown",
    "value": "jamestown"
  },
  {
    "text": "Jamestown West",
    "value": "jamestown west"
  },
  {
    "text": "Jamesville",
    "value": "jamesville"
  },
  {
    "text": "Jamison",
    "value": "jamison"
  },
  {
    "text": "Jamul",
    "value": "jamul"
  },
  {
    "text": "Jane Lew",
    "value": "jane lew"
  },
  {
    "text": "Janesville",
    "value": "janesville"
  },
  {
    "text": "Jansen",
    "value": "jansen"
  },
  {
    "text": "Jarales",
    "value": "jarales"
  },
  {
    "text": "Jarbidge",
    "value": "jarbidge"
  },
  {
    "text": "Jarratt",
    "value": "jarratt"
  },
  {
    "text": "Jarreau",
    "value": "jarreau"
  },
  {
    "text": "Jarrell",
    "value": "jarrell"
  },
  {
    "text": "Jarrettsville",
    "value": "jarrettsville"
  },
  {
    "text": "Jarvisburg",
    "value": "jarvisburg"
  },
  {
    "text": "Jasmine Estates",
    "value": "jasmine estates"
  },
  {
    "text": "Jasonville",
    "value": "jasonville"
  },
  {
    "text": "Jasper",
    "value": "jasper"
  },
  {
    "text": "Java",
    "value": "java"
  },
  {
    "text": "Java Center",
    "value": "java center"
  },
  {
    "text": "Jay",
    "value": "jay"
  },
  {
    "text": "Jay Em",
    "value": "jay em"
  },
  {
    "text": "Jayess",
    "value": "jayess"
  },
  {
    "text": "Jayton",
    "value": "jayton"
  },
  {
    "text": "Jber",
    "value": "jber"
  },
  {
    "text": "Jean",
    "value": "jean"
  },
  {
    "text": "Jeanerette",
    "value": "jeanerette"
  },
  {
    "text": "Jeannette",
    "value": "jeannette"
  },
  {
    "text": "Jeddo",
    "value": "jeddo"
  },
  {
    "text": "Jeff",
    "value": "jeff"
  },
  {
    "text": "Jeffers",
    "value": "jeffers"
  },
  {
    "text": "Jefferson",
    "value": "jefferson"
  },
  {
    "text": "Jefferson City",
    "value": "jefferson city"
  },
  {
    "text": "Jefferson Hills",
    "value": "jefferson hills"
  },
  {
    "text": "Jefferson Valley",
    "value": "jefferson valley"
  },
  {
    "text": "Jeffersonton",
    "value": "jeffersonton"
  },
  {
    "text": "Jeffersontown",
    "value": "jeffersontown"
  },
  {
    "text": "Jeffersonville",
    "value": "jeffersonville"
  },
  {
    "text": "Jeffrey",
    "value": "jeffrey"
  },
  {
    "text": "Jekyll Island",
    "value": "jekyll island"
  },
  {
    "text": "Jellico",
    "value": "jellico"
  },
  {
    "text": "Jelm",
    "value": "jelm"
  },
  {
    "text": "Jemez Pueblo",
    "value": "jemez pueblo"
  },
  {
    "text": "Jemez Springs",
    "value": "jemez springs"
  },
  {
    "text": "Jemison",
    "value": "jemison"
  },
  {
    "text": "Jena",
    "value": "jena"
  },
  {
    "text": "Jenera",
    "value": "jenera"
  },
  {
    "text": "Jenison",
    "value": "jenison"
  },
  {
    "text": "Jenkinjones",
    "value": "jenkinjones"
  },
  {
    "text": "Jenkins",
    "value": "jenkins"
  },
  {
    "text": "Jenkinsburg",
    "value": "jenkinsburg"
  },
  {
    "text": "Jenkinsville",
    "value": "jenkinsville"
  },
  {
    "text": "Jenkintown",
    "value": "jenkintown"
  },
  {
    "text": "Jenks",
    "value": "jenks"
  },
  {
    "text": "Jenner",
    "value": "jenner"
  },
  {
    "text": "Jennerstown",
    "value": "jennerstown"
  },
  {
    "text": "Jennings",
    "value": "jennings"
  },
  {
    "text": "Jensen",
    "value": "jensen"
  },
  {
    "text": "Jensen Beach",
    "value": "jensen beach"
  },
  {
    "text": "Jeremiah",
    "value": "jeremiah"
  },
  {
    "text": "Jericho",
    "value": "jericho"
  },
  {
    "text": "Jerico Springs",
    "value": "jerico springs"
  },
  {
    "text": "Jermyn",
    "value": "jermyn"
  },
  {
    "text": "Jerome",
    "value": "jerome"
  },
  {
    "text": "Jeromesville",
    "value": "jeromesville"
  },
  {
    "text": "Jerry City",
    "value": "jerry city"
  },
  {
    "text": "Jersey",
    "value": "jersey"
  },
  {
    "text": "Jersey City",
    "value": "jersey city"
  },
  {
    "text": "Jersey Mills",
    "value": "jersey mills"
  },
  {
    "text": "Jersey Shore",
    "value": "jersey shore"
  },
  {
    "text": "Jersey Village",
    "value": "jersey village"
  },
  {
    "text": "Jerseyville",
    "value": "jerseyville"
  },
  {
    "text": "Jerusalem",
    "value": "jerusalem"
  },
  {
    "text": "Jesse",
    "value": "jesse"
  },
  {
    "text": "Jessieville",
    "value": "jessieville"
  },
  {
    "text": "Jessup",
    "value": "jessup"
  },
  {
    "text": "Jesup",
    "value": "jesup"
  },
  {
    "text": "Jet",
    "value": "jet"
  },
  {
    "text": "Jetersville",
    "value": "jetersville"
  },
  {
    "text": "Jetmore",
    "value": "jetmore"
  },
  {
    "text": "Jetson",
    "value": "jetson"
  },
  {
    "text": "Jewell",
    "value": "jewell"
  },
  {
    "text": "Jewell Ridge",
    "value": "jewell ridge"
  },
  {
    "text": "Jewett",
    "value": "jewett"
  },
  {
    "text": "Jewett City",
    "value": "jewett city"
  },
  {
    "text": "Jim Falls",
    "value": "jim falls"
  },
  {
    "text": "Jim Thorpe",
    "value": "jim thorpe"
  },
  {
    "text": "Joanna",
    "value": "joanna"
  },
  {
    "text": "Joaquin",
    "value": "joaquin"
  },
  {
    "text": "Jobstown",
    "value": "jobstown"
  },
  {
    "text": "Joelton",
    "value": "joelton"
  },
  {
    "text": "Joes",
    "value": "joes"
  },
  {
    "text": "Johannesburg",
    "value": "johannesburg"
  },
  {
    "text": "John Day",
    "value": "john day"
  },
  {
    "text": "Johns Creek",
    "value": "johns creek"
  },
  {
    "text": "Johns Island",
    "value": "johns island"
  },
  {
    "text": "Johnsburg",
    "value": "johnsburg"
  },
  {
    "text": "Johnson",
    "value": "johnson"
  },
  {
    "text": "Johnson City",
    "value": "johnson city"
  },
  {
    "text": "Johnson Creek",
    "value": "johnson creek"
  },
  {
    "text": "Johnsonburg",
    "value": "johnsonburg"
  },
  {
    "text": "Johnsonville",
    "value": "johnsonville"
  },
  {
    "text": "Johnston",
    "value": "johnston"
  },
  {
    "text": "Johnston City",
    "value": "johnston city"
  },
  {
    "text": "Johnstown",
    "value": "johnstown"
  },
  {
    "text": "Joice",
    "value": "joice"
  },
  {
    "text": "Joiner",
    "value": "joiner"
  },
  {
    "text": "Joint Base Lewis McChord",
    "value": "joint base lewis mcchord"
  },
  {
    "text": "Joliet",
    "value": "joliet"
  },
  {
    "text": "Jolley",
    "value": "jolley"
  },
  {
    "text": "Jollyville",
    "value": "jollyville"
  },
  {
    "text": "Jolo",
    "value": "jolo"
  },
  {
    "text": "Jolon",
    "value": "jolon"
  },
  {
    "text": "Jonancy",
    "value": "jonancy"
  },
  {
    "text": "Jonas Ridge",
    "value": "jonas ridge"
  },
  {
    "text": "Jones",
    "value": "jones"
  },
  {
    "text": "Jones County",
    "value": "jones county"
  },
  {
    "text": "Jones Mill",
    "value": "jones mill"
  },
  {
    "text": "Jones Mills",
    "value": "jones mills"
  },
  {
    "text": "Jonesboro",
    "value": "jonesboro"
  },
  {
    "text": "Jonesborough",
    "value": "jonesborough"
  },
  {
    "text": "Jonesburg",
    "value": "jonesburg"
  },
  {
    "text": "Jonesport",
    "value": "jonesport"
  },
  {
    "text": "Jonestown",
    "value": "jonestown"
  },
  {
    "text": "Jonesville",
    "value": "jonesville"
  },
  {
    "text": "Joplin",
    "value": "joplin"
  },
  {
    "text": "Joppa",
    "value": "joppa"
  },
  {
    "text": "Jordan",
    "value": "jordan"
  },
  {
    "text": "Jordan Valley",
    "value": "jordan valley"
  },
  {
    "text": "Jordanville",
    "value": "jordanville"
  },
  {
    "text": "Joseph",
    "value": "joseph"
  },
  {
    "text": "Joseph City",
    "value": "joseph city"
  },
  {
    "text": "Josephine",
    "value": "josephine"
  },
  {
    "text": "Joshua",
    "value": "joshua"
  },
  {
    "text": "Joshua Tree",
    "value": "joshua tree"
  },
  {
    "text": "Jourdanton",
    "value": "jourdanton"
  },
  {
    "text": "Joy",
    "value": "joy"
  },
  {
    "text": "Joyce",
    "value": "joyce"
  },
  {
    "text": "Jud",
    "value": "jud"
  },
  {
    "text": "Juda",
    "value": "juda"
  },
  {
    "text": "Judith Gap",
    "value": "judith gap"
  },
  {
    "text": "Judson",
    "value": "judson"
  },
  {
    "text": "Judsonia",
    "value": "judsonia"
  },
  {
    "text": "Julesburg",
    "value": "julesburg"
  },
  {
    "text": "Juliaetta",
    "value": "juliaetta"
  },
  {
    "text": "Julian",
    "value": "julian"
  },
  {
    "text": "Juliette",
    "value": "juliette"
  },
  {
    "text": "Juliustown",
    "value": "juliustown"
  },
  {
    "text": "Jumping Branch",
    "value": "jumping branch"
  },
  {
    "text": "Junction",
    "value": "junction"
  },
  {
    "text": "Junction City",
    "value": "junction city"
  },
  {
    "text": "June Lake",
    "value": "june lake"
  },
  {
    "text": "Juneau",
    "value": "juneau"
  },
  {
    "text": "Juniata",
    "value": "juniata"
  },
  {
    "text": "Junior",
    "value": "junior"
  },
  {
    "text": "Juno Beach",
    "value": "juno beach"
  },
  {
    "text": "Juntura",
    "value": "juntura"
  },
  {
    "text": "Jupiter",
    "value": "jupiter"
  },
  {
    "text": "Jurupa Valley",
    "value": "jurupa valley"
  },
  {
    "text": "Justice",
    "value": "justice"
  },
  {
    "text": "Justiceburg",
    "value": "justiceburg"
  },
  {
    "text": "Justin",
    "value": "justin"
  },
  {
    "text": "Ka'a'awa",
    "value": "ka'a'awa"
  },
  {
    "text": "Ka'anapali",
    "value": "ka'anapali"
  },
  {
    "text": "Kaaawa",
    "value": "kaaawa"
  },
  {
    "text": "Kaanapali Landing",
    "value": "kaanapali landing"
  },
  {
    "text": "Kadoka",
    "value": "kadoka"
  },
  {
    "text": "Kahaluu-Keauhou",
    "value": "kahaluu-keauhou"
  },
  {
    "text": "Kahlotus",
    "value": "kahlotus"
  },
  {
    "text": "Kahoka",
    "value": "kahoka"
  },
  {
    "text": "Kahuku",
    "value": "kahuku"
  },
  {
    "text": "Kahului",
    "value": "kahului"
  },
  {
    "text": "Kaibito",
    "value": "kaibito"
  },
  {
    "text": "Kailua",
    "value": "kailua"
  },
  {
    "text": "Kailua-Kona",
    "value": "kailua-kona"
  },
  {
    "text": "Kaiser",
    "value": "kaiser"
  },
  {
    "text": "Kake",
    "value": "kake"
  },
  {
    "text": "Kaktovik",
    "value": "kaktovik"
  },
  {
    "text": "Kalaheo",
    "value": "kalaheo"
  },
  {
    "text": "Kalama",
    "value": "kalama"
  },
  {
    "text": "Kalamazoo",
    "value": "kalamazoo"
  },
  {
    "text": "Kalaoa",
    "value": "kalaoa"
  },
  {
    "text": "Kaleva",
    "value": "kaleva"
  },
  {
    "text": "Kalida",
    "value": "kalida"
  },
  {
    "text": "Kalispell",
    "value": "kalispell"
  },
  {
    "text": "Kalkaska",
    "value": "kalkaska"
  },
  {
    "text": "Kalona",
    "value": "kalona"
  },
  {
    "text": "Kalskag",
    "value": "kalskag"
  },
  {
    "text": "Kalāheo",
    "value": "kalāheo"
  },
  {
    "text": "Kamas",
    "value": "kamas"
  },
  {
    "text": "Kamiah",
    "value": "kamiah"
  },
  {
    "text": "Kampsville",
    "value": "kampsville"
  },
  {
    "text": "Kamrar",
    "value": "kamrar"
  },
  {
    "text": "Kanab",
    "value": "kanab"
  },
  {
    "text": "Kanaranzi",
    "value": "kanaranzi"
  },
  {
    "text": "Kanarraville",
    "value": "kanarraville"
  },
  {
    "text": "Kanawha",
    "value": "kanawha"
  },
  {
    "text": "Kanawha Head",
    "value": "kanawha head"
  },
  {
    "text": "Kandiyohi",
    "value": "kandiyohi"
  },
  {
    "text": "Kane",
    "value": "kane"
  },
  {
    "text": "Kaneohe",
    "value": "kaneohe"
  },
  {
    "text": "Kaneville",
    "value": "kaneville"
  },
  {
    "text": "Kankakee",
    "value": "kankakee"
  },
  {
    "text": "Kannapolis",
    "value": "kannapolis"
  },
  {
    "text": "Kanopolis",
    "value": "kanopolis"
  },
  {
    "text": "Kanosh",
    "value": "kanosh"
  },
  {
    "text": "Kansas",
    "value": "kansas"
  },
  {
    "text": "Kansas City",
    "value": "kansas city"
  },
  {
    "text": "Kansasville",
    "value": "kansasville"
  },
  {
    "text": "Kapa'a",
    "value": "kapa'a"
  },
  {
    "text": "Kapaa",
    "value": "kapaa"
  },
  {
    "text": "Kapaau",
    "value": "kapaau"
  },
  {
    "text": "Kaplan",
    "value": "kaplan"
  },
  {
    "text": "Kapolei",
    "value": "kapolei"
  },
  {
    "text": "Karlsruhe",
    "value": "karlsruhe"
  },
  {
    "text": "Karlstad",
    "value": "karlstad"
  },
  {
    "text": "Karnack",
    "value": "karnack"
  },
  {
    "text": "Karnak",
    "value": "karnak"
  },
  {
    "text": "Karnes City",
    "value": "karnes city"
  },
  {
    "text": "Karns City",
    "value": "karns city"
  },
  {
    "text": "Karthaus",
    "value": "karthaus"
  },
  {
    "text": "Kasigluk",
    "value": "kasigluk"
  },
  {
    "text": "Kasilof",
    "value": "kasilof"
  },
  {
    "text": "Kasota",
    "value": "kasota"
  },
  {
    "text": "Kasson",
    "value": "kasson"
  },
  {
    "text": "Kathleen",
    "value": "kathleen"
  },
  {
    "text": "Kathryn",
    "value": "kathryn"
  },
  {
    "text": "Katonah",
    "value": "katonah"
  },
  {
    "text": "Katy",
    "value": "katy"
  },
  {
    "text": "Kaufman",
    "value": "kaufman"
  },
  {
    "text": "Kaukauna",
    "value": "kaukauna"
  },
  {
    "text": "Kaumakani",
    "value": "kaumakani"
  },
  {
    "text": "Kaunakakai",
    "value": "kaunakakai"
  },
  {
    "text": "Kaw City",
    "value": "kaw city"
  },
  {
    "text": "Kawkawlin",
    "value": "kawkawlin"
  },
  {
    "text": "Kaycee",
    "value": "kaycee"
  },
  {
    "text": "Kayenta",
    "value": "kayenta"
  },
  {
    "text": "Kaylor",
    "value": "kaylor"
  },
  {
    "text": "Kaysville",
    "value": "kaysville"
  },
  {
    "text": "Keaau",
    "value": "keaau"
  },
  {
    "text": "Keachi",
    "value": "keachi"
  },
  {
    "text": "Kealakekua",
    "value": "kealakekua"
  },
  {
    "text": "Kealia",
    "value": "kealia"
  },
  {
    "text": "Keams Canyon",
    "value": "keams canyon"
  },
  {
    "text": "Keansburg",
    "value": "keansburg"
  },
  {
    "text": "Kearney",
    "value": "kearney"
  },
  {
    "text": "Kearneysville",
    "value": "kearneysville"
  },
  {
    "text": "Kearns",
    "value": "kearns"
  },
  {
    "text": "Kearny",
    "value": "kearny"
  },
  {
    "text": "Kearsarge",
    "value": "kearsarge"
  },
  {
    "text": "Keasbey",
    "value": "keasbey"
  },
  {
    "text": "Keatchie",
    "value": "keatchie"
  },
  {
    "text": "Keauhou",
    "value": "keauhou"
  },
  {
    "text": "Keavy",
    "value": "keavy"
  },
  {
    "text": "Kea‘au",
    "value": "kea‘au"
  },
  {
    "text": "Kechi",
    "value": "kechi"
  },
  {
    "text": "Keedysville",
    "value": "keedysville"
  },
  {
    "text": "Keego Harbor",
    "value": "keego harbor"
  },
  {
    "text": "Keeling",
    "value": "keeling"
  },
  {
    "text": "Keen Mountain",
    "value": "keen mountain"
  },
  {
    "text": "Keene",
    "value": "keene"
  },
  {
    "text": "Keene Valley",
    "value": "keene valley"
  },
  {
    "text": "Keenes",
    "value": "keenes"
  },
  {
    "text": "Keenesburg",
    "value": "keenesburg"
  },
  {
    "text": "Keeseville",
    "value": "keeseville"
  },
  {
    "text": "Keewatin",
    "value": "keewatin"
  },
  {
    "text": "Keezletown",
    "value": "keezletown"
  },
  {
    "text": "Keiser",
    "value": "keiser"
  },
  {
    "text": "Keithsburg",
    "value": "keithsburg"
  },
  {
    "text": "Keithville",
    "value": "keithville"
  },
  {
    "text": "Keizer",
    "value": "keizer"
  },
  {
    "text": "Kekaha",
    "value": "kekaha"
  },
  {
    "text": "Kelayres",
    "value": "kelayres"
  },
  {
    "text": "Kelford",
    "value": "kelford"
  },
  {
    "text": "Kell",
    "value": "kell"
  },
  {
    "text": "Keller",
    "value": "keller"
  },
  {
    "text": "Kellerton",
    "value": "kellerton"
  },
  {
    "text": "Kelley",
    "value": "kelley"
  },
  {
    "text": "Kelleys Island",
    "value": "kelleys island"
  },
  {
    "text": "Kelliher",
    "value": "kelliher"
  },
  {
    "text": "Kellnersville",
    "value": "kellnersville"
  },
  {
    "text": "Kellogg",
    "value": "kellogg"
  },
  {
    "text": "Kelly",
    "value": "kelly"
  },
  {
    "text": "Kellysville",
    "value": "kellysville"
  },
  {
    "text": "Kellyton",
    "value": "kellyton"
  },
  {
    "text": "Kellyville",
    "value": "kellyville"
  },
  {
    "text": "Kelseyville",
    "value": "kelseyville"
  },
  {
    "text": "Kelso",
    "value": "kelso"
  },
  {
    "text": "Kelton",
    "value": "kelton"
  },
  {
    "text": "Kemah",
    "value": "kemah"
  },
  {
    "text": "Kemmerer",
    "value": "kemmerer"
  },
  {
    "text": "Kemp",
    "value": "kemp"
  },
  {
    "text": "Kempner",
    "value": "kempner"
  },
  {
    "text": "Kempton",
    "value": "kempton"
  },
  {
    "text": "Ken Caryl",
    "value": "ken caryl"
  },
  {
    "text": "Kenai",
    "value": "kenai"
  },
  {
    "text": "Kenansville",
    "value": "kenansville"
  },
  {
    "text": "Kenbridge",
    "value": "kenbridge"
  },
  {
    "text": "Kendalia",
    "value": "kendalia"
  },
  {
    "text": "Kendall",
    "value": "kendall"
  },
  {
    "text": "Kendall Park",
    "value": "kendall park"
  },
  {
    "text": "Kendallville",
    "value": "kendallville"
  },
  {
    "text": "Kendleton",
    "value": "kendleton"
  },
  {
    "text": "Kendrick",
    "value": "kendrick"
  },
  {
    "text": "Kenduskeag",
    "value": "kenduskeag"
  },
  {
    "text": "Kenedy",
    "value": "kenedy"
  },
  {
    "text": "Kenefic",
    "value": "kenefic"
  },
  {
    "text": "Kenesaw",
    "value": "kenesaw"
  },
  {
    "text": "Kenilworth",
    "value": "kenilworth"
  },
  {
    "text": "Kenly",
    "value": "kenly"
  },
  {
    "text": "Kenmare",
    "value": "kenmare"
  },
  {
    "text": "Kenmore",
    "value": "kenmore"
  },
  {
    "text": "Kenna",
    "value": "kenna"
  },
  {
    "text": "Kennan",
    "value": "kennan"
  },
  {
    "text": "Kennard",
    "value": "kennard"
  },
  {
    "text": "Kennebec",
    "value": "kennebec"
  },
  {
    "text": "Kennebunk",
    "value": "kennebunk"
  },
  {
    "text": "Kennebunkport",
    "value": "kennebunkport"
  },
  {
    "text": "Kennedale",
    "value": "kennedale"
  },
  {
    "text": "Kennedy",
    "value": "kennedy"
  },
  {
    "text": "Kennedyville",
    "value": "kennedyville"
  },
  {
    "text": "Kenner",
    "value": "kenner"
  },
  {
    "text": "Kennerdell",
    "value": "kennerdell"
  },
  {
    "text": "Kennesaw",
    "value": "kennesaw"
  },
  {
    "text": "Kenneth City",
    "value": "kenneth city"
  },
  {
    "text": "Kennett",
    "value": "kennett"
  },
  {
    "text": "Kennett Square",
    "value": "kennett square"
  },
  {
    "text": "Kennewick",
    "value": "kennewick"
  },
  {
    "text": "Kenney",
    "value": "kenney"
  },
  {
    "text": "Kenosha",
    "value": "kenosha"
  },
  {
    "text": "Kenova",
    "value": "kenova"
  },
  {
    "text": "Kensal",
    "value": "kensal"
  },
  {
    "text": "Kensett",
    "value": "kensett"
  },
  {
    "text": "Kensington",
    "value": "kensington"
  },
  {
    "text": "Kent",
    "value": "kent"
  },
  {
    "text": "Kent City",
    "value": "kent city"
  },
  {
    "text": "Kentfield",
    "value": "kentfield"
  },
  {
    "text": "Kentland",
    "value": "kentland"
  },
  {
    "text": "Kenton",
    "value": "kenton"
  },
  {
    "text": "Kents Hill",
    "value": "kents hill"
  },
  {
    "text": "Kents Store",
    "value": "kents store"
  },
  {
    "text": "Kentuck",
    "value": "kentuck"
  },
  {
    "text": "Kentwood",
    "value": "kentwood"
  },
  {
    "text": "Kenvil",
    "value": "kenvil"
  },
  {
    "text": "Kenwood",
    "value": "kenwood"
  },
  {
    "text": "Kenyon",
    "value": "kenyon"
  },
  {
    "text": "Keo",
    "value": "keo"
  },
  {
    "text": "Keokea",
    "value": "keokea"
  },
  {
    "text": "Keokee",
    "value": "keokee"
  },
  {
    "text": "Keokuk",
    "value": "keokuk"
  },
  {
    "text": "Keosauqua",
    "value": "keosauqua"
  },
  {
    "text": "Keota",
    "value": "keota"
  },
  {
    "text": "Kerby",
    "value": "kerby"
  },
  {
    "text": "Kerens",
    "value": "kerens"
  },
  {
    "text": "Kerhonkson",
    "value": "kerhonkson"
  },
  {
    "text": "Kerkhoven",
    "value": "kerkhoven"
  },
  {
    "text": "Kerman",
    "value": "kerman"
  },
  {
    "text": "Kermit",
    "value": "kermit"
  },
  {
    "text": "Kernersville",
    "value": "kernersville"
  },
  {
    "text": "Kernville",
    "value": "kernville"
  },
  {
    "text": "Kerrick",
    "value": "kerrick"
  },
  {
    "text": "Kerrville",
    "value": "kerrville"
  },
  {
    "text": "Kersey",
    "value": "kersey"
  },
  {
    "text": "Kershaw",
    "value": "kershaw"
  },
  {
    "text": "Keshena",
    "value": "keshena"
  },
  {
    "text": "Kesley",
    "value": "kesley"
  },
  {
    "text": "Keswick",
    "value": "keswick"
  },
  {
    "text": "Ketchikan",
    "value": "ketchikan"
  },
  {
    "text": "Ketchum",
    "value": "ketchum"
  },
  {
    "text": "Kettering",
    "value": "kettering"
  },
  {
    "text": "Kettle Falls",
    "value": "kettle falls"
  },
  {
    "text": "Kettle River",
    "value": "kettle river"
  },
  {
    "text": "Kettleman",
    "value": "kettleman"
  },
  {
    "text": "Kettleman City",
    "value": "kettleman city"
  },
  {
    "text": "Keuka Park",
    "value": "keuka park"
  },
  {
    "text": "Kevil",
    "value": "kevil"
  },
  {
    "text": "Kevin",
    "value": "kevin"
  },
  {
    "text": "Kew Gardens",
    "value": "kew gardens"
  },
  {
    "text": "Kewadin",
    "value": "kewadin"
  },
  {
    "text": "Kewanee",
    "value": "kewanee"
  },
  {
    "text": "Kewanna",
    "value": "kewanna"
  },
  {
    "text": "Kewaskum",
    "value": "kewaskum"
  },
  {
    "text": "Kewaunee",
    "value": "kewaunee"
  },
  {
    "text": "Key Biscayne",
    "value": "key biscayne"
  },
  {
    "text": "Key Colony Beach",
    "value": "key colony beach"
  },
  {
    "text": "Key Largo",
    "value": "key largo"
  },
  {
    "text": "Key West",
    "value": "key west"
  },
  {
    "text": "Keyes",
    "value": "keyes"
  },
  {
    "text": "Keyesport",
    "value": "keyesport"
  },
  {
    "text": "Keymar",
    "value": "keymar"
  },
  {
    "text": "Keyport",
    "value": "keyport"
  },
  {
    "text": "Keyser",
    "value": "keyser"
  },
  {
    "text": "Keystone",
    "value": "keystone"
  },
  {
    "text": "Keystone Heights",
    "value": "keystone heights"
  },
  {
    "text": "Keysville",
    "value": "keysville"
  },
  {
    "text": "Keytesville",
    "value": "keytesville"
  },
  {
    "text": "Kiahsville",
    "value": "kiahsville"
  },
  {
    "text": "Kiamesha Lake",
    "value": "kiamesha lake"
  },
  {
    "text": "Kiana",
    "value": "kiana"
  },
  {
    "text": "Kiawah Island",
    "value": "kiawah island"
  },
  {
    "text": "Kidder",
    "value": "kidder"
  },
  {
    "text": "Kidron",
    "value": "kidron"
  },
  {
    "text": "Kiefer",
    "value": "kiefer"
  },
  {
    "text": "Kiel",
    "value": "kiel"
  },
  {
    "text": "Kieler",
    "value": "kieler"
  },
  {
    "text": "Kiester",
    "value": "kiester"
  },
  {
    "text": "Kihei",
    "value": "kihei"
  },
  {
    "text": "Kila",
    "value": "kila"
  },
  {
    "text": "Kilauea",
    "value": "kilauea"
  },
  {
    "text": "Kilbourne",
    "value": "kilbourne"
  },
  {
    "text": "Kildeer",
    "value": "kildeer"
  },
  {
    "text": "Kilgore",
    "value": "kilgore"
  },
  {
    "text": "Kilkenny",
    "value": "kilkenny"
  },
  {
    "text": "Kill Buck",
    "value": "kill buck"
  },
  {
    "text": "Kill Devil Hills",
    "value": "kill devil hills"
  },
  {
    "text": "Killbuck",
    "value": "killbuck"
  },
  {
    "text": "Killdeer",
    "value": "killdeer"
  },
  {
    "text": "Killeen",
    "value": "killeen"
  },
  {
    "text": "Killen",
    "value": "killen"
  },
  {
    "text": "Killington",
    "value": "killington"
  },
  {
    "text": "Killingworth",
    "value": "killingworth"
  },
  {
    "text": "Kilmarnock",
    "value": "kilmarnock"
  },
  {
    "text": "Kilmichael",
    "value": "kilmichael"
  },
  {
    "text": "Kiln",
    "value": "kiln"
  },
  {
    "text": "Kim",
    "value": "kim"
  },
  {
    "text": "Kimball",
    "value": "kimball"
  },
  {
    "text": "Kimballton",
    "value": "kimballton"
  },
  {
    "text": "Kimberling City",
    "value": "kimberling city"
  },
  {
    "text": "Kimberly",
    "value": "kimberly"
  },
  {
    "text": "Kimberton",
    "value": "kimberton"
  },
  {
    "text": "Kimbolton",
    "value": "kimbolton"
  },
  {
    "text": "Kimmell",
    "value": "kimmell"
  },
  {
    "text": "Kimmswick",
    "value": "kimmswick"
  },
  {
    "text": "Kimper",
    "value": "kimper"
  },
  {
    "text": "Kinard",
    "value": "kinard"
  },
  {
    "text": "Kinards",
    "value": "kinards"
  },
  {
    "text": "Kincaid",
    "value": "kincaid"
  },
  {
    "text": "Kincheloe",
    "value": "kincheloe"
  },
  {
    "text": "Kinde",
    "value": "kinde"
  },
  {
    "text": "Kinder",
    "value": "kinder"
  },
  {
    "text": "Kinderhook",
    "value": "kinderhook"
  },
  {
    "text": "Kindred",
    "value": "kindred"
  },
  {
    "text": "King",
    "value": "king"
  },
  {
    "text": "King City",
    "value": "king city"
  },
  {
    "text": "King Cove",
    "value": "king cove"
  },
  {
    "text": "King Ferry",
    "value": "king ferry"
  },
  {
    "text": "King George",
    "value": "king george"
  },
  {
    "text": "King Salmon",
    "value": "king salmon"
  },
  {
    "text": "King William",
    "value": "king william"
  },
  {
    "text": "King and Queen Court House",
    "value": "king and queen court house"
  },
  {
    "text": "King of Prussia",
    "value": "king of prussia"
  },
  {
    "text": "Kingdom City",
    "value": "kingdom city"
  },
  {
    "text": "Kingfield",
    "value": "kingfield"
  },
  {
    "text": "Kingfisher",
    "value": "kingfisher"
  },
  {
    "text": "Kingman",
    "value": "kingman"
  },
  {
    "text": "Kingmont",
    "value": "kingmont"
  },
  {
    "text": "Kings Bay",
    "value": "kings bay"
  },
  {
    "text": "Kings Beach",
    "value": "kings beach"
  },
  {
    "text": "Kings Canyon National Pk",
    "value": "kings canyon national pk"
  },
  {
    "text": "Kings Grant",
    "value": "kings grant"
  },
  {
    "text": "Kings Mills",
    "value": "kings mills"
  },
  {
    "text": "Kings Mountain",
    "value": "kings mountain"
  },
  {
    "text": "Kings Park",
    "value": "kings park"
  },
  {
    "text": "Kingsburg",
    "value": "kingsburg"
  },
  {
    "text": "Kingsbury",
    "value": "kingsbury"
  },
  {
    "text": "Kingsford",
    "value": "kingsford"
  },
  {
    "text": "Kingsford Heights",
    "value": "kingsford heights"
  },
  {
    "text": "Kingsland",
    "value": "kingsland"
  },
  {
    "text": "Kingsley",
    "value": "kingsley"
  },
  {
    "text": "Kingsport",
    "value": "kingsport"
  },
  {
    "text": "Kingston",
    "value": "kingston"
  },
  {
    "text": "Kingston Springs",
    "value": "kingston springs"
  },
  {
    "text": "Kingstown",
    "value": "kingstown"
  },
  {
    "text": "Kingstree",
    "value": "kingstree"
  },
  {
    "text": "Kingsville",
    "value": "kingsville"
  },
  {
    "text": "Kingwood",
    "value": "kingwood"
  },
  {
    "text": "Kinmundy",
    "value": "kinmundy"
  },
  {
    "text": "Kinnear",
    "value": "kinnear"
  },
  {
    "text": "Kinnelon",
    "value": "kinnelon"
  },
  {
    "text": "Kinross",
    "value": "kinross"
  },
  {
    "text": "Kinsale",
    "value": "kinsale"
  },
  {
    "text": "Kinsey",
    "value": "kinsey"
  },
  {
    "text": "Kinsley",
    "value": "kinsley"
  },
  {
    "text": "Kinsman",
    "value": "kinsman"
  },
  {
    "text": "Kinston",
    "value": "kinston"
  },
  {
    "text": "Kinta",
    "value": "kinta"
  },
  {
    "text": "Kintnersville",
    "value": "kintnersville"
  },
  {
    "text": "Kintyre",
    "value": "kintyre"
  },
  {
    "text": "Kinwood",
    "value": "kinwood"
  },
  {
    "text": "Kinzers",
    "value": "kinzers"
  },
  {
    "text": "Kiowa",
    "value": "kiowa"
  },
  {
    "text": "Kipnuk",
    "value": "kipnuk"
  },
  {
    "text": "Kirby",
    "value": "kirby"
  },
  {
    "text": "Kirbyville",
    "value": "kirbyville"
  },
  {
    "text": "Kirkersville",
    "value": "kirkersville"
  },
  {
    "text": "Kirkland",
    "value": "kirkland"
  },
  {
    "text": "Kirklin",
    "value": "kirklin"
  },
  {
    "text": "Kirksey",
    "value": "kirksey"
  },
  {
    "text": "Kirksville",
    "value": "kirksville"
  },
  {
    "text": "Kirkville",
    "value": "kirkville"
  },
  {
    "text": "Kirkwood",
    "value": "kirkwood"
  },
  {
    "text": "Kiron",
    "value": "kiron"
  },
  {
    "text": "Kirtland",
    "value": "kirtland"
  },
  {
    "text": "Kirtland Air Force Base",
    "value": "kirtland air force base"
  },
  {
    "text": "Kirvin",
    "value": "kirvin"
  },
  {
    "text": "Kirwin",
    "value": "kirwin"
  },
  {
    "text": "Kiryas Joel",
    "value": "kiryas joel"
  },
  {
    "text": "Kismet",
    "value": "kismet"
  },
  {
    "text": "Kissee Mills",
    "value": "kissee mills"
  },
  {
    "text": "Kissimmee",
    "value": "kissimmee"
  },
  {
    "text": "Kistler",
    "value": "kistler"
  },
  {
    "text": "Kit Carson",
    "value": "kit carson"
  },
  {
    "text": "Kite",
    "value": "kite"
  },
  {
    "text": "Kittanning",
    "value": "kittanning"
  },
  {
    "text": "Kittery",
    "value": "kittery"
  },
  {
    "text": "Kittery Point",
    "value": "kittery point"
  },
  {
    "text": "Kittitas",
    "value": "kittitas"
  },
  {
    "text": "Kittredge",
    "value": "kittredge"
  },
  {
    "text": "Kittrell",
    "value": "kittrell"
  },
  {
    "text": "Kitts Hill",
    "value": "kitts hill"
  },
  {
    "text": "Kitty Hawk",
    "value": "kitty hawk"
  },
  {
    "text": "Klamath",
    "value": "klamath"
  },
  {
    "text": "Klamath Falls",
    "value": "klamath falls"
  },
  {
    "text": "Klamath River",
    "value": "klamath river"
  },
  {
    "text": "Klawak",
    "value": "klawak"
  },
  {
    "text": "Klickitat",
    "value": "klickitat"
  },
  {
    "text": "Klingerstown",
    "value": "klingerstown"
  },
  {
    "text": "Klondike",
    "value": "klondike"
  },
  {
    "text": "Knapp",
    "value": "knapp"
  },
  {
    "text": "Kneeland",
    "value": "kneeland"
  },
  {
    "text": "Knife River",
    "value": "knife river"
  },
  {
    "text": "Knifley",
    "value": "knifley"
  },
  {
    "text": "Knightdale",
    "value": "knightdale"
  },
  {
    "text": "Knights Landing",
    "value": "knights landing"
  },
  {
    "text": "Knightsen",
    "value": "knightsen"
  },
  {
    "text": "Knightstown",
    "value": "knightstown"
  },
  {
    "text": "Knightsville",
    "value": "knightsville"
  },
  {
    "text": "Knippa",
    "value": "knippa"
  },
  {
    "text": "Knob Lick",
    "value": "knob lick"
  },
  {
    "text": "Knob Noster",
    "value": "knob noster"
  },
  {
    "text": "Knotts Island",
    "value": "knotts island"
  },
  {
    "text": "Knowlesville",
    "value": "knowlesville"
  },
  {
    "text": "Knox",
    "value": "knox"
  },
  {
    "text": "Knox City",
    "value": "knox city"
  },
  {
    "text": "Knox Dale",
    "value": "knox dale"
  },
  {
    "text": "Knoxville",
    "value": "knoxville"
  },
  {
    "text": "Kodak",
    "value": "kodak"
  },
  {
    "text": "Kodiak",
    "value": "kodiak"
  },
  {
    "text": "Kodiak Station",
    "value": "kodiak station"
  },
  {
    "text": "Koeltztown",
    "value": "koeltztown"
  },
  {
    "text": "Kohler",
    "value": "kohler"
  },
  {
    "text": "Kokomo",
    "value": "kokomo"
  },
  {
    "text": "Koloa",
    "value": "koloa"
  },
  {
    "text": "Konawa",
    "value": "konawa"
  },
  {
    "text": "Kongiganak",
    "value": "kongiganak"
  },
  {
    "text": "Koosharem",
    "value": "koosharem"
  },
  {
    "text": "Kooskia",
    "value": "kooskia"
  },
  {
    "text": "Kootenai",
    "value": "kootenai"
  },
  {
    "text": "Koppel",
    "value": "koppel"
  },
  {
    "text": "Kopperl",
    "value": "kopperl"
  },
  {
    "text": "Korbel",
    "value": "korbel"
  },
  {
    "text": "Koreatown",
    "value": "koreatown"
  },
  {
    "text": "Kosciusko",
    "value": "kosciusko"
  },
  {
    "text": "Koshkonong",
    "value": "koshkonong"
  },
  {
    "text": "Kosse",
    "value": "kosse"
  },
  {
    "text": "Kossuth",
    "value": "kossuth"
  },
  {
    "text": "Kotlik",
    "value": "kotlik"
  },
  {
    "text": "Kotzebue",
    "value": "kotzebue"
  },
  {
    "text": "Kountze",
    "value": "kountze"
  },
  {
    "text": "Kouts",
    "value": "kouts"
  },
  {
    "text": "Kragnes",
    "value": "kragnes"
  },
  {
    "text": "Krakow",
    "value": "krakow"
  },
  {
    "text": "Kranzburg",
    "value": "kranzburg"
  },
  {
    "text": "Kreamer",
    "value": "kreamer"
  },
  {
    "text": "Krebs",
    "value": "krebs"
  },
  {
    "text": "Kremlin",
    "value": "kremlin"
  },
  {
    "text": "Kremmling",
    "value": "kremmling"
  },
  {
    "text": "Kresgeville",
    "value": "kresgeville"
  },
  {
    "text": "Kress",
    "value": "kress"
  },
  {
    "text": "Kronenwetter",
    "value": "kronenwetter"
  },
  {
    "text": "Krotz Springs",
    "value": "krotz springs"
  },
  {
    "text": "Krugerville",
    "value": "krugerville"
  },
  {
    "text": "Krum",
    "value": "krum"
  },
  {
    "text": "Krypton",
    "value": "krypton"
  },
  {
    "text": "Kualapu'u",
    "value": "kualapu'u"
  },
  {
    "text": "Kula",
    "value": "kula"
  },
  {
    "text": "Kulm",
    "value": "kulm"
  },
  {
    "text": "Kulpmont",
    "value": "kulpmont"
  },
  {
    "text": "Kulpsville",
    "value": "kulpsville"
  },
  {
    "text": "Kuna",
    "value": "kuna"
  },
  {
    "text": "Kunia Camp",
    "value": "kunia camp"
  },
  {
    "text": "Kunkletown",
    "value": "kunkletown"
  },
  {
    "text": "Kure Beach",
    "value": "kure beach"
  },
  {
    "text": "Kurten",
    "value": "kurten"
  },
  {
    "text": "Kurtistown",
    "value": "kurtistown"
  },
  {
    "text": "Kuttawa",
    "value": "kuttawa"
  },
  {
    "text": "Kutztown",
    "value": "kutztown"
  },
  {
    "text": "Kwethluk",
    "value": "kwethluk"
  },
  {
    "text": "Kwigillingok",
    "value": "kwigillingok"
  },
  {
    "text": "Kykotsmovi Village",
    "value": "kykotsmovi village"
  },
  {
    "text": "Kyle",
    "value": "kyle"
  },
  {
    "text": "Kylertown",
    "value": "kylertown"
  },
  {
    "text": "Kyles Ford",
    "value": "kyles ford"
  },
  {
    "text": "Kīhei",
    "value": "kīhei"
  },
  {
    "text": "L'Anse",
    "value": "l'anse"
  },
  {
    "text": "La Barge",
    "value": "la barge"
  },
  {
    "text": "La Belle",
    "value": "la belle"
  },
  {
    "text": "La Canada Flintridge",
    "value": "la canada flintridge"
  },
  {
    "text": "La Cañada Flintridge",
    "value": "la cañada flintridge"
  },
  {
    "text": "La Center",
    "value": "la center"
  },
  {
    "text": "La Conner",
    "value": "la conner"
  },
  {
    "text": "La Coste",
    "value": "la coste"
  },
  {
    "text": "La Crescent",
    "value": "la crescent"
  },
  {
    "text": "La Crescenta",
    "value": "la crescenta"
  },
  {
    "text": "La Crosse",
    "value": "la crosse"
  },
  {
    "text": "La Cygne",
    "value": "la cygne"
  },
  {
    "text": "La Farge",
    "value": "la farge"
  },
  {
    "text": "La Fargeville",
    "value": "la fargeville"
  },
  {
    "text": "La Fayette",
    "value": "la fayette"
  },
  {
    "text": "La Feria",
    "value": "la feria"
  },
  {
    "text": "La Fontaine",
    "value": "la fontaine"
  },
  {
    "text": "La Fox",
    "value": "la fox"
  },
  {
    "text": "La France",
    "value": "la france"
  },
  {
    "text": "La Grande",
    "value": "la grande"
  },
  {
    "text": "La Grange",
    "value": "la grange"
  },
  {
    "text": "La Grange Park",
    "value": "la grange park"
  },
  {
    "text": "La Habra",
    "value": "la habra"
  },
  {
    "text": "La Habra Heights",
    "value": "la habra heights"
  },
  {
    "text": "La Harpe",
    "value": "la harpe"
  },
  {
    "text": "La Honda",
    "value": "la honda"
  },
  {
    "text": "La Jara",
    "value": "la jara"
  },
  {
    "text": "La Jolla",
    "value": "la jolla"
  },
  {
    "text": "La Joya",
    "value": "la joya"
  },
  {
    "text": "La Junta",
    "value": "la junta"
  },
  {
    "text": "La Luz",
    "value": "la luz"
  },
  {
    "text": "La Marque",
    "value": "la marque"
  },
  {
    "text": "La Mesa",
    "value": "la mesa"
  },
  {
    "text": "La Mirada",
    "value": "la mirada"
  },
  {
    "text": "La Moille",
    "value": "la moille"
  },
  {
    "text": "La Monte",
    "value": "la monte"
  },
  {
    "text": "La Motte",
    "value": "la motte"
  },
  {
    "text": "La Palma",
    "value": "la palma"
  },
  {
    "text": "La Paz",
    "value": "la paz"
  },
  {
    "text": "La Pine",
    "value": "la pine"
  },
  {
    "text": "La Plata",
    "value": "la plata"
  },
  {
    "text": "La Plume",
    "value": "la plume"
  },
  {
    "text": "La Pointe",
    "value": "la pointe"
  },
  {
    "text": "La Porte",
    "value": "la porte"
  },
  {
    "text": "La Porte City",
    "value": "la porte city"
  },
  {
    "text": "La Pryor",
    "value": "la pryor"
  },
  {
    "text": "La Puente",
    "value": "la puente"
  },
  {
    "text": "La Push",
    "value": "la push"
  },
  {
    "text": "La Quinta",
    "value": "la quinta"
  },
  {
    "text": "La Riviera",
    "value": "la riviera"
  },
  {
    "text": "La Rue",
    "value": "la rue"
  },
  {
    "text": "La Russell",
    "value": "la russell"
  },
  {
    "text": "La Sal",
    "value": "la sal"
  },
  {
    "text": "La Salle",
    "value": "la salle"
  },
  {
    "text": "La Selva Beach",
    "value": "la selva beach"
  },
  {
    "text": "La Vale",
    "value": "la vale"
  },
  {
    "text": "La Valle",
    "value": "la valle"
  },
  {
    "text": "La Vergne",
    "value": "la vergne"
  },
  {
    "text": "La Verne",
    "value": "la verne"
  },
  {
    "text": "La Vernia",
    "value": "la vernia"
  },
  {
    "text": "La Veta",
    "value": "la veta"
  },
  {
    "text": "La Villa",
    "value": "la villa"
  },
  {
    "text": "La Vista",
    "value": "la vista"
  },
  {
    "text": "La Ward",
    "value": "la ward"
  },
  {
    "text": "La'ie",
    "value": "la'ie"
  },
  {
    "text": "LaBelle",
    "value": "labelle"
  },
  {
    "text": "LaBolt",
    "value": "labolt"
  },
  {
    "text": "LaCrosse",
    "value": "lacrosse"
  },
  {
    "text": "LaFayette",
    "value": "lafayette"
  },
  {
    "text": "LaFollette",
    "value": "lafollette"
  },
  {
    "text": "LaGrange",
    "value": "lagrange"
  },
  {
    "text": "LaMadera",
    "value": "lamadera"
  },
  {
    "text": "LaMoure",
    "value": "lamoure"
  },
  {
    "text": "LaPlace",
    "value": "laplace"
  },
  {
    "text": "LaPorte",
    "value": "laporte"
  },
  {
    "text": "LaRue",
    "value": "larue"
  },
  {
    "text": "LaVerkin",
    "value": "laverkin"
  },
  {
    "text": "Labadie",
    "value": "labadie"
  },
  {
    "text": "Labadieville",
    "value": "labadieville"
  },
  {
    "text": "Lac du Flambeau",
    "value": "lac du flambeau"
  },
  {
    "text": "Lacassine",
    "value": "lacassine"
  },
  {
    "text": "Lacey",
    "value": "lacey"
  },
  {
    "text": "Laceys Spring",
    "value": "laceys spring"
  },
  {
    "text": "Laceyville",
    "value": "laceyville"
  },
  {
    "text": "Lachine",
    "value": "lachine"
  },
  {
    "text": "Lackawanna",
    "value": "lackawanna"
  },
  {
    "text": "Lackawaxen",
    "value": "lackawaxen"
  },
  {
    "text": "Lackey",
    "value": "lackey"
  },
  {
    "text": "Lackland Air Force Base",
    "value": "lackland air force base"
  },
  {
    "text": "Laclede",
    "value": "laclede"
  },
  {
    "text": "Lacombe",
    "value": "lacombe"
  },
  {
    "text": "Lacon",
    "value": "lacon"
  },
  {
    "text": "Lacona",
    "value": "lacona"
  },
  {
    "text": "Laconia",
    "value": "laconia"
  },
  {
    "text": "Lacoochee",
    "value": "lacoochee"
  },
  {
    "text": "Lacota",
    "value": "lacota"
  },
  {
    "text": "Lacrosse",
    "value": "lacrosse"
  },
  {
    "text": "Ladd",
    "value": "ladd"
  },
  {
    "text": "Laddonia",
    "value": "laddonia"
  },
  {
    "text": "Ladera Heights",
    "value": "ladera heights"
  },
  {
    "text": "Ladera Ranch",
    "value": "ladera ranch"
  },
  {
    "text": "Ladoga",
    "value": "ladoga"
  },
  {
    "text": "Ladonia",
    "value": "ladonia"
  },
  {
    "text": "Ladora",
    "value": "ladora"
  },
  {
    "text": "Ladson",
    "value": "ladson"
  },
  {
    "text": "Ladue",
    "value": "ladue"
  },
  {
    "text": "Lady Lake",
    "value": "lady lake"
  },
  {
    "text": "Ladys Island",
    "value": "ladys island"
  },
  {
    "text": "Ladysmith",
    "value": "ladysmith"
  },
  {
    "text": "Lafayette",
    "value": "lafayette"
  },
  {
    "text": "Lafayette Hill",
    "value": "lafayette hill"
  },
  {
    "text": "Lafferty",
    "value": "lafferty"
  },
  {
    "text": "Lafitte",
    "value": "lafitte"
  },
  {
    "text": "Lafox",
    "value": "lafox"
  },
  {
    "text": "Lago Vista",
    "value": "lago vista"
  },
  {
    "text": "Lagrange",
    "value": "lagrange"
  },
  {
    "text": "Lagrangeville",
    "value": "lagrangeville"
  },
  {
    "text": "Lagro",
    "value": "lagro"
  },
  {
    "text": "Laguna",
    "value": "laguna"
  },
  {
    "text": "Laguna Beach",
    "value": "laguna beach"
  },
  {
    "text": "Laguna Heights",
    "value": "laguna heights"
  },
  {
    "text": "Laguna Hills",
    "value": "laguna hills"
  },
  {
    "text": "Laguna Niguel",
    "value": "laguna niguel"
  },
  {
    "text": "Laguna Vista",
    "value": "laguna vista"
  },
  {
    "text": "Laguna Woods",
    "value": "laguna woods"
  },
  {
    "text": "Lagunitas",
    "value": "lagunitas"
  },
  {
    "text": "Lahaina",
    "value": "lahaina"
  },
  {
    "text": "Lahaska",
    "value": "lahaska"
  },
  {
    "text": "Lahmansville",
    "value": "lahmansville"
  },
  {
    "text": "Lahoma",
    "value": "lahoma"
  },
  {
    "text": "Laingsburg",
    "value": "laingsburg"
  },
  {
    "text": "Lairdsville",
    "value": "lairdsville"
  },
  {
    "text": "Lake",
    "value": "lake"
  },
  {
    "text": "Lake Alfred",
    "value": "lake alfred"
  },
  {
    "text": "Lake Andes",
    "value": "lake andes"
  },
  {
    "text": "Lake Ann",
    "value": "lake ann"
  },
  {
    "text": "Lake Arbor",
    "value": "lake arbor"
  },
  {
    "text": "Lake Ariel",
    "value": "lake ariel"
  },
  {
    "text": "Lake Arrowhead",
    "value": "lake arrowhead"
  },
  {
    "text": "Lake Arthur",
    "value": "lake arthur"
  },
  {
    "text": "Lake Barcroft",
    "value": "lake barcroft"
  },
  {
    "text": "Lake Barrington",
    "value": "lake barrington"
  },
  {
    "text": "Lake Benton",
    "value": "lake benton"
  },
  {
    "text": "Lake Bluff",
    "value": "lake bluff"
  },
  {
    "text": "Lake Bronson",
    "value": "lake bronson"
  },
  {
    "text": "Lake Buena Vista",
    "value": "lake buena vista"
  },
  {
    "text": "Lake Butler",
    "value": "lake butler"
  },
  {
    "text": "Lake Charles",
    "value": "lake charles"
  },
  {
    "text": "Lake City",
    "value": "lake city"
  },
  {
    "text": "Lake Clarke Shores",
    "value": "lake clarke shores"
  },
  {
    "text": "Lake Clear",
    "value": "lake clear"
  },
  {
    "text": "Lake Como",
    "value": "lake como"
  },
  {
    "text": "Lake Cormorant",
    "value": "lake cormorant"
  },
  {
    "text": "Lake Creek",
    "value": "lake creek"
  },
  {
    "text": "Lake Crystal",
    "value": "lake crystal"
  },
  {
    "text": "Lake Dallas",
    "value": "lake dallas"
  },
  {
    "text": "Lake Delton",
    "value": "lake delton"
  },
  {
    "text": "Lake Elmo",
    "value": "lake elmo"
  },
  {
    "text": "Lake Elmore",
    "value": "lake elmore"
  },
  {
    "text": "Lake Elsinore",
    "value": "lake elsinore"
  },
  {
    "text": "Lake Forest",
    "value": "lake forest"
  },
  {
    "text": "Lake Forest Park",
    "value": "lake forest park"
  },
  {
    "text": "Lake Fork",
    "value": "lake fork"
  },
  {
    "text": "Lake Frederick",
    "value": "lake frederick"
  },
  {
    "text": "Lake Geneva",
    "value": "lake geneva"
  },
  {
    "text": "Lake George",
    "value": "lake george"
  },
  {
    "text": "Lake Goodwin",
    "value": "lake goodwin"
  },
  {
    "text": "Lake Grove",
    "value": "lake grove"
  },
  {
    "text": "Lake Hamilton",
    "value": "lake hamilton"
  },
  {
    "text": "Lake Harmony",
    "value": "lake harmony"
  },
  {
    "text": "Lake Havasu City",
    "value": "lake havasu city"
  },
  {
    "text": "Lake Helen",
    "value": "lake helen"
  },
  {
    "text": "Lake Hiawatha",
    "value": "lake hiawatha"
  },
  {
    "text": "Lake Hopatcong",
    "value": "lake hopatcong"
  },
  {
    "text": "Lake Hughes",
    "value": "lake hughes"
  },
  {
    "text": "Lake Huntington",
    "value": "lake huntington"
  },
  {
    "text": "Lake Isabella",
    "value": "lake isabella"
  },
  {
    "text": "Lake Itasca",
    "value": "lake itasca"
  },
  {
    "text": "Lake Jackson",
    "value": "lake jackson"
  },
  {
    "text": "Lake Junaluska",
    "value": "lake junaluska"
  },
  {
    "text": "Lake Katrine",
    "value": "lake katrine"
  },
  {
    "text": "Lake Leelanau",
    "value": "lake leelanau"
  },
  {
    "text": "Lake Lillian",
    "value": "lake lillian"
  },
  {
    "text": "Lake Linden",
    "value": "lake linden"
  },
  {
    "text": "Lake Los Angeles",
    "value": "lake los angeles"
  },
  {
    "text": "Lake Lotawana",
    "value": "lake lotawana"
  },
  {
    "text": "Lake Lure",
    "value": "lake lure"
  },
  {
    "text": "Lake Luzerne",
    "value": "lake luzerne"
  },
  {
    "text": "Lake Lynn",
    "value": "lake lynn"
  },
  {
    "text": "Lake Magdalene",
    "value": "lake magdalene"
  },
  {
    "text": "Lake Marcel-Stillwater",
    "value": "lake marcel-stillwater"
  },
  {
    "text": "Lake Mary",
    "value": "lake mary"
  },
  {
    "text": "Lake Mills",
    "value": "lake mills"
  },
  {
    "text": "Lake Milton",
    "value": "lake milton"
  },
  {
    "text": "Lake Monroe",
    "value": "lake monroe"
  },
  {
    "text": "Lake Nebagamon",
    "value": "lake nebagamon"
  },
  {
    "text": "Lake Norden",
    "value": "lake norden"
  },
  {
    "text": "Lake Odessa",
    "value": "lake odessa"
  },
  {
    "text": "Lake Orion",
    "value": "lake orion"
  },
  {
    "text": "Lake Oswego",
    "value": "lake oswego"
  },
  {
    "text": "Lake Ozark",
    "value": "lake ozark"
  },
  {
    "text": "Lake Panasoffkee",
    "value": "lake panasoffkee"
  },
  {
    "text": "Lake Park",
    "value": "lake park"
  },
  {
    "text": "Lake Peekskill",
    "value": "lake peekskill"
  },
  {
    "text": "Lake Placid",
    "value": "lake placid"
  },
  {
    "text": "Lake Pleasant",
    "value": "lake pleasant"
  },
  {
    "text": "Lake Point",
    "value": "lake point"
  },
  {
    "text": "Lake Powell",
    "value": "lake powell"
  },
  {
    "text": "Lake Preston",
    "value": "lake preston"
  },
  {
    "text": "Lake Providence",
    "value": "lake providence"
  },
  {
    "text": "Lake Purdy",
    "value": "lake purdy"
  },
  {
    "text": "Lake Ridge",
    "value": "lake ridge"
  },
  {
    "text": "Lake Ronkonkoma",
    "value": "lake ronkonkoma"
  },
  {
    "text": "Lake Saint Louis",
    "value": "lake saint louis"
  },
  {
    "text": "Lake San Marcos",
    "value": "lake san marcos"
  },
  {
    "text": "Lake Sarasota",
    "value": "lake sarasota"
  },
  {
    "text": "Lake Shasta",
    "value": "lake shasta"
  },
  {
    "text": "Lake Shore",
    "value": "lake shore"
  },
  {
    "text": "Lake Station",
    "value": "lake station"
  },
  {
    "text": "Lake Stevens",
    "value": "lake stevens"
  },
  {
    "text": "Lake Success",
    "value": "lake success"
  },
  {
    "text": "Lake Summerset",
    "value": "lake summerset"
  },
  {
    "text": "Lake Tahoe",
    "value": "lake tahoe"
  },
  {
    "text": "Lake Tansi",
    "value": "lake tansi"
  },
  {
    "text": "Lake Tomahawk",
    "value": "lake tomahawk"
  },
  {
    "text": "Lake Toxaway",
    "value": "lake toxaway"
  },
  {
    "text": "Lake View",
    "value": "lake view"
  },
  {
    "text": "Lake Villa",
    "value": "lake villa"
  },
  {
    "text": "Lake Village",
    "value": "lake village"
  },
  {
    "text": "Lake Waccamaw",
    "value": "lake waccamaw"
  },
  {
    "text": "Lake Wales",
    "value": "lake wales"
  },
  {
    "text": "Lake Wilson",
    "value": "lake wilson"
  },
  {
    "text": "Lake Winola",
    "value": "lake winola"
  },
  {
    "text": "Lake Worth",
    "value": "lake worth"
  },
  {
    "text": "Lake Wylie",
    "value": "lake wylie"
  },
  {
    "text": "Lake Zurich",
    "value": "lake zurich"
  },
  {
    "text": "Lake in the Hills",
    "value": "lake in the hills"
  },
  {
    "text": "Lake of the Woods",
    "value": "lake of the woods"
  },
  {
    "text": "Lakebay",
    "value": "lakebay"
  },
  {
    "text": "Lakefield",
    "value": "lakefield"
  },
  {
    "text": "Lakehead",
    "value": "lakehead"
  },
  {
    "text": "Lakehills",
    "value": "lakehills"
  },
  {
    "text": "Lakehurst",
    "value": "lakehurst"
  },
  {
    "text": "Lakeland",
    "value": "lakeland"
  },
  {
    "text": "Lakeland Highlands",
    "value": "lakeland highlands"
  },
  {
    "text": "Lakemont",
    "value": "lakemont"
  },
  {
    "text": "Lakemoor",
    "value": "lakemoor"
  },
  {
    "text": "Lakemore",
    "value": "lakemore"
  },
  {
    "text": "Lakeport",
    "value": "lakeport"
  },
  {
    "text": "Lakes",
    "value": "lakes"
  },
  {
    "text": "Lakes of the Four Seasons",
    "value": "lakes of the four seasons"
  },
  {
    "text": "Lakeshore",
    "value": "lakeshore"
  },
  {
    "text": "Lakeside",
    "value": "lakeside"
  },
  {
    "text": "Lakeside Marblehead",
    "value": "lakeside marblehead"
  },
  {
    "text": "Lakeside Park",
    "value": "lakeside park"
  },
  {
    "text": "Lakesite",
    "value": "lakesite"
  },
  {
    "text": "Laketon",
    "value": "laketon"
  },
  {
    "text": "Laketown",
    "value": "laketown"
  },
  {
    "text": "Lakeview",
    "value": "lakeview"
  },
  {
    "text": "Lakeville",
    "value": "lakeville"
  },
  {
    "text": "Lakeway",
    "value": "lakeway"
  },
  {
    "text": "Lakewood",
    "value": "lakewood"
  },
  {
    "text": "Lakewood Ranch",
    "value": "lakewood ranch"
  },
  {
    "text": "Lakewood Shores",
    "value": "lakewood shores"
  },
  {
    "text": "Lakin",
    "value": "lakin"
  },
  {
    "text": "Lakota",
    "value": "lakota"
  },
  {
    "text": "Lamar",
    "value": "lamar"
  },
  {
    "text": "Lambert",
    "value": "lambert"
  },
  {
    "text": "Lamberton",
    "value": "lamberton"
  },
  {
    "text": "Lambertville",
    "value": "lambertville"
  },
  {
    "text": "Lambrook",
    "value": "lambrook"
  },
  {
    "text": "Lambsburg",
    "value": "lambsburg"
  },
  {
    "text": "Lame Deer",
    "value": "lame deer"
  },
  {
    "text": "Lamesa",
    "value": "lamesa"
  },
  {
    "text": "Lamoille",
    "value": "lamoille"
  },
  {
    "text": "Lamoni",
    "value": "lamoni"
  },
  {
    "text": "Lamont",
    "value": "lamont"
  },
  {
    "text": "Lampasas",
    "value": "lampasas"
  },
  {
    "text": "Lampe",
    "value": "lampe"
  },
  {
    "text": "Lampeter",
    "value": "lampeter"
  },
  {
    "text": "Lamy",
    "value": "lamy"
  },
  {
    "text": "Lana'i City",
    "value": "lana'i city"
  },
  {
    "text": "Lanagan",
    "value": "lanagan"
  },
  {
    "text": "Lanai",
    "value": "lanai"
  },
  {
    "text": "Lanark",
    "value": "lanark"
  },
  {
    "text": "Lanark Village",
    "value": "lanark village"
  },
  {
    "text": "Lancaster",
    "value": "lancaster"
  },
  {
    "text": "Lancing",
    "value": "lancing"
  },
  {
    "text": "Land O' Lakes",
    "value": "land o' lakes"
  },
  {
    "text": "Landen",
    "value": "landen"
  },
  {
    "text": "Landenberg",
    "value": "landenberg"
  },
  {
    "text": "Lander",
    "value": "lander"
  },
  {
    "text": "Landers",
    "value": "landers"
  },
  {
    "text": "Landing",
    "value": "landing"
  },
  {
    "text": "Landis",
    "value": "landis"
  },
  {
    "text": "Landisburg",
    "value": "landisburg"
  },
  {
    "text": "Landisville",
    "value": "landisville"
  },
  {
    "text": "Landmark Naples Mobile Home Park",
    "value": "landmark naples mobile home park"
  },
  {
    "text": "Landover",
    "value": "landover"
  },
  {
    "text": "Landover Hills",
    "value": "landover hills"
  },
  {
    "text": "Landrum",
    "value": "landrum"
  },
  {
    "text": "Lane",
    "value": "lane"
  },
  {
    "text": "Lane City",
    "value": "lane city"
  },
  {
    "text": "Lanesboro",
    "value": "lanesboro"
  },
  {
    "text": "Lanesborough",
    "value": "lanesborough"
  },
  {
    "text": "Lanesville",
    "value": "lanesville"
  },
  {
    "text": "Lanett",
    "value": "lanett"
  },
  {
    "text": "Laneview",
    "value": "laneview"
  },
  {
    "text": "Laneville",
    "value": "laneville"
  },
  {
    "text": "Lanexa",
    "value": "lanexa"
  },
  {
    "text": "Langdon",
    "value": "langdon"
  },
  {
    "text": "Langeloth",
    "value": "langeloth"
  },
  {
    "text": "Langford",
    "value": "langford"
  },
  {
    "text": "Langhorne",
    "value": "langhorne"
  },
  {
    "text": "Langley",
    "value": "langley"
  },
  {
    "text": "Langley Park",
    "value": "langley park"
  },
  {
    "text": "Langlois",
    "value": "langlois"
  },
  {
    "text": "Langston",
    "value": "langston"
  },
  {
    "text": "Langsville",
    "value": "langsville"
  },
  {
    "text": "Lanham",
    "value": "lanham"
  },
  {
    "text": "Lankin",
    "value": "lankin"
  },
  {
    "text": "Lannon",
    "value": "lannon"
  },
  {
    "text": "Lanoka Harbor",
    "value": "lanoka harbor"
  },
  {
    "text": "Lansdale",
    "value": "lansdale"
  },
  {
    "text": "Lansdowne",
    "value": "lansdowne"
  },
  {
    "text": "Lanse",
    "value": "lanse"
  },
  {
    "text": "Lansford",
    "value": "lansford"
  },
  {
    "text": "Lansing",
    "value": "lansing"
  },
  {
    "text": "Lantana",
    "value": "lantana"
  },
  {
    "text": "Laona",
    "value": "laona"
  },
  {
    "text": "Laotto",
    "value": "laotto"
  },
  {
    "text": "Lapaz",
    "value": "lapaz"
  },
  {
    "text": "Lapeer",
    "value": "lapeer"
  },
  {
    "text": "Lapel",
    "value": "lapel"
  },
  {
    "text": "Lapine",
    "value": "lapine"
  },
  {
    "text": "Laplace",
    "value": "laplace"
  },
  {
    "text": "Lapoint",
    "value": "lapoint"
  },
  {
    "text": "Laporte",
    "value": "laporte"
  },
  {
    "text": "Lapwai",
    "value": "lapwai"
  },
  {
    "text": "Laquey",
    "value": "laquey"
  },
  {
    "text": "Laramie",
    "value": "laramie"
  },
  {
    "text": "Larchmont",
    "value": "larchmont"
  },
  {
    "text": "Larchwood",
    "value": "larchwood"
  },
  {
    "text": "Laredo",
    "value": "laredo"
  },
  {
    "text": "Largo",
    "value": "largo"
  },
  {
    "text": "Larimore",
    "value": "larimore"
  },
  {
    "text": "Larkspur",
    "value": "larkspur"
  },
  {
    "text": "Larksville",
    "value": "larksville"
  },
  {
    "text": "Larned",
    "value": "larned"
  },
  {
    "text": "Larose",
    "value": "larose"
  },
  {
    "text": "Larrabee",
    "value": "larrabee"
  },
  {
    "text": "Larsen",
    "value": "larsen"
  },
  {
    "text": "Larslan",
    "value": "larslan"
  },
  {
    "text": "Larue",
    "value": "larue"
  },
  {
    "text": "Larwill",
    "value": "larwill"
  },
  {
    "text": "Las Animas",
    "value": "las animas"
  },
  {
    "text": "Las Cruces",
    "value": "las cruces"
  },
  {
    "text": "Las Flores",
    "value": "las flores"
  },
  {
    "text": "Las Vegas",
    "value": "las vegas"
  },
  {
    "text": "Lasara",
    "value": "lasara"
  },
  {
    "text": "Lascassas",
    "value": "lascassas"
  },
  {
    "text": "Lashmeet",
    "value": "lashmeet"
  },
  {
    "text": "Latexo",
    "value": "latexo"
  },
  {
    "text": "Latham",
    "value": "latham"
  },
  {
    "text": "Lathrop",
    "value": "lathrop"
  },
  {
    "text": "Lathrup Village",
    "value": "lathrup village"
  },
  {
    "text": "Latimer",
    "value": "latimer"
  },
  {
    "text": "Laton",
    "value": "laton"
  },
  {
    "text": "Latonia",
    "value": "latonia"
  },
  {
    "text": "Latrobe",
    "value": "latrobe"
  },
  {
    "text": "Latta",
    "value": "latta"
  },
  {
    "text": "Lattimore",
    "value": "lattimore"
  },
  {
    "text": "Latty",
    "value": "latty"
  },
  {
    "text": "Lauderdale",
    "value": "lauderdale"
  },
  {
    "text": "Lauderdale Lakes",
    "value": "lauderdale lakes"
  },
  {
    "text": "Lauderdale by the sea",
    "value": "lauderdale by the sea"
  },
  {
    "text": "Lauderhill",
    "value": "lauderhill"
  },
  {
    "text": "Laughlin",
    "value": "laughlin"
  },
  {
    "text": "Laughlintown",
    "value": "laughlintown"
  },
  {
    "text": "Laura",
    "value": "laura"
  },
  {
    "text": "Laurel",
    "value": "laurel"
  },
  {
    "text": "Laurel Bloomery",
    "value": "laurel bloomery"
  },
  {
    "text": "Laurel Fork",
    "value": "laurel fork"
  },
  {
    "text": "Laurel Hill",
    "value": "laurel hill"
  },
  {
    "text": "Laurel Springs",
    "value": "laurel springs"
  },
  {
    "text": "Laurelton",
    "value": "laurelton"
  },
  {
    "text": "Laurelville",
    "value": "laurelville"
  },
  {
    "text": "Laurence Harbor",
    "value": "laurence harbor"
  },
  {
    "text": "Laurens",
    "value": "laurens"
  },
  {
    "text": "Laurie",
    "value": "laurie"
  },
  {
    "text": "Laurinburg",
    "value": "laurinburg"
  },
  {
    "text": "Laurium",
    "value": "laurium"
  },
  {
    "text": "Laurys Station",
    "value": "laurys station"
  },
  {
    "text": "Lava Hot Springs",
    "value": "lava hot springs"
  },
  {
    "text": "Lavaca",
    "value": "lavaca"
  },
  {
    "text": "Lavalette",
    "value": "lavalette"
  },
  {
    "text": "Lavallette",
    "value": "lavallette"
  },
  {
    "text": "Laveen",
    "value": "laveen"
  },
  {
    "text": "Laverne",
    "value": "laverne"
  },
  {
    "text": "Lavina",
    "value": "lavina"
  },
  {
    "text": "Lavinia",
    "value": "lavinia"
  },
  {
    "text": "Lavon",
    "value": "lavon"
  },
  {
    "text": "Lavonia",
    "value": "lavonia"
  },
  {
    "text": "Lawai",
    "value": "lawai"
  },
  {
    "text": "Lawler",
    "value": "lawler"
  },
  {
    "text": "Lawley",
    "value": "lawley"
  },
  {
    "text": "Lawn",
    "value": "lawn"
  },
  {
    "text": "Lawndale",
    "value": "lawndale"
  },
  {
    "text": "Lawnside",
    "value": "lawnside"
  },
  {
    "text": "Lawnton",
    "value": "lawnton"
  },
  {
    "text": "Lawrence",
    "value": "lawrence"
  },
  {
    "text": "Lawrenceburg",
    "value": "lawrenceburg"
  },
  {
    "text": "Lawrenceville",
    "value": "lawrenceville"
  },
  {
    "text": "Lawson",
    "value": "lawson"
  },
  {
    "text": "Lawsonville",
    "value": "lawsonville"
  },
  {
    "text": "Lawtell",
    "value": "lawtell"
  },
  {
    "text": "Lawtey",
    "value": "lawtey"
  },
  {
    "text": "Lawton",
    "value": "lawton"
  },
  {
    "text": "Lawtons",
    "value": "lawtons"
  },
  {
    "text": "Layton",
    "value": "layton"
  },
  {
    "text": "Laytonsville",
    "value": "laytonsville"
  },
  {
    "text": "Laytonville",
    "value": "laytonville"
  },
  {
    "text": "Lazy Mountain",
    "value": "lazy mountain"
  },
  {
    "text": "Le Blanc",
    "value": "le blanc"
  },
  {
    "text": "Le Center",
    "value": "le center"
  },
  {
    "text": "Le Claire",
    "value": "le claire"
  },
  {
    "text": "Le Grand",
    "value": "le grand"
  },
  {
    "text": "Le Mars",
    "value": "le mars"
  },
  {
    "text": "Le Raysville",
    "value": "le raysville"
  },
  {
    "text": "Le Roy",
    "value": "le roy"
  },
  {
    "text": "Le Sueur",
    "value": "le sueur"
  },
  {
    "text": "LeChee",
    "value": "lechee"
  },
  {
    "text": "LeRoy",
    "value": "leroy"
  },
  {
    "text": "Leachville",
    "value": "leachville"
  },
  {
    "text": "Lead",
    "value": "lead"
  },
  {
    "text": "Lead Hill",
    "value": "lead hill"
  },
  {
    "text": "Leadore",
    "value": "leadore"
  },
  {
    "text": "Leadville",
    "value": "leadville"
  },
  {
    "text": "Leadwood",
    "value": "leadwood"
  },
  {
    "text": "Leaf River",
    "value": "leaf river"
  },
  {
    "text": "League City",
    "value": "league city"
  },
  {
    "text": "Leakesville",
    "value": "leakesville"
  },
  {
    "text": "Leakey",
    "value": "leakey"
  },
  {
    "text": "Lealman",
    "value": "lealman"
  },
  {
    "text": "Leander",
    "value": "leander"
  },
  {
    "text": "Leary",
    "value": "leary"
  },
  {
    "text": "Leasburg",
    "value": "leasburg"
  },
  {
    "text": "Leavenworth",
    "value": "leavenworth"
  },
  {
    "text": "Leavittsburg",
    "value": "leavittsburg"
  },
  {
    "text": "Leawood",
    "value": "leawood"
  },
  {
    "text": "Lebanon",
    "value": "lebanon"
  },
  {
    "text": "Lebanon Junction",
    "value": "lebanon junction"
  },
  {
    "text": "Lebec",
    "value": "lebec"
  },
  {
    "text": "Lebo",
    "value": "lebo"
  },
  {
    "text": "Leburn",
    "value": "leburn"
  },
  {
    "text": "Lecanto",
    "value": "lecanto"
  },
  {
    "text": "Lecompte",
    "value": "lecompte"
  },
  {
    "text": "Lecompton",
    "value": "lecompton"
  },
  {
    "text": "Lecontes Mills",
    "value": "lecontes mills"
  },
  {
    "text": "Ledbetter",
    "value": "ledbetter"
  },
  {
    "text": "Lederach",
    "value": "lederach"
  },
  {
    "text": "Ledger",
    "value": "ledger"
  },
  {
    "text": "Ledgewood",
    "value": "ledgewood"
  },
  {
    "text": "Ledyard",
    "value": "ledyard"
  },
  {
    "text": "Ledyard Center",
    "value": "ledyard center"
  },
  {
    "text": "Lee",
    "value": "lee"
  },
  {
    "text": "Lee Center",
    "value": "lee center"
  },
  {
    "text": "Lee Vining",
    "value": "lee vining"
  },
  {
    "text": "Lee's Summit",
    "value": "lee's summit"
  },
  {
    "text": "Leechburg",
    "value": "leechburg"
  },
  {
    "text": "Leedey",
    "value": "leedey"
  },
  {
    "text": "Leeds",
    "value": "leeds"
  },
  {
    "text": "Leeds Point",
    "value": "leeds point"
  },
  {
    "text": "Leeper",
    "value": "leeper"
  },
  {
    "text": "Lees Creek",
    "value": "lees creek"
  },
  {
    "text": "Leesburg",
    "value": "leesburg"
  },
  {
    "text": "Leesport",
    "value": "leesport"
  },
  {
    "text": "Leesville",
    "value": "leesville"
  },
  {
    "text": "Leeton",
    "value": "leeton"
  },
  {
    "text": "Leetonia",
    "value": "leetonia"
  },
  {
    "text": "Leetsdale",
    "value": "leetsdale"
  },
  {
    "text": "Leflore",
    "value": "leflore"
  },
  {
    "text": "Lefor",
    "value": "lefor"
  },
  {
    "text": "Lefors",
    "value": "lefors"
  },
  {
    "text": "Left Hand",
    "value": "left hand"
  },
  {
    "text": "Leggett",
    "value": "leggett"
  },
  {
    "text": "Lehi",
    "value": "lehi"
  },
  {
    "text": "Lehigh",
    "value": "lehigh"
  },
  {
    "text": "Lehigh Acres",
    "value": "lehigh acres"
  },
  {
    "text": "Lehigh Valley",
    "value": "lehigh valley"
  },
  {
    "text": "Lehighton",
    "value": "lehighton"
  },
  {
    "text": "Lehman",
    "value": "lehman"
  },
  {
    "text": "Leicester",
    "value": "leicester"
  },
  {
    "text": "Leigh",
    "value": "leigh"
  },
  {
    "text": "Leighton",
    "value": "leighton"
  },
  {
    "text": "Leipsic",
    "value": "leipsic"
  },
  {
    "text": "Leisure City",
    "value": "leisure city"
  },
  {
    "text": "Leitchfield",
    "value": "leitchfield"
  },
  {
    "text": "Leith-Hatfield",
    "value": "leith-hatfield"
  },
  {
    "text": "Leivasy",
    "value": "leivasy"
  },
  {
    "text": "Leland",
    "value": "leland"
  },
  {
    "text": "Lelia Lake",
    "value": "lelia lake"
  },
  {
    "text": "Lely",
    "value": "lely"
  },
  {
    "text": "Lemasters",
    "value": "lemasters"
  },
  {
    "text": "Lemay",
    "value": "lemay"
  },
  {
    "text": "Leming",
    "value": "leming"
  },
  {
    "text": "Lemitar",
    "value": "lemitar"
  },
  {
    "text": "Lemmon",
    "value": "lemmon"
  },
  {
    "text": "Lemon Cove",
    "value": "lemon cove"
  },
  {
    "text": "Lemon Grove",
    "value": "lemon grove"
  },
  {
    "text": "Lemon Springs",
    "value": "lemon springs"
  },
  {
    "text": "Lemoncove",
    "value": "lemoncove"
  },
  {
    "text": "Lemont",
    "value": "lemont"
  },
  {
    "text": "Lemont Furnace",
    "value": "lemont furnace"
  },
  {
    "text": "Lemoore",
    "value": "lemoore"
  },
  {
    "text": "Lemoyne",
    "value": "lemoyne"
  },
  {
    "text": "Lempster",
    "value": "lempster"
  },
  {
    "text": "Lena",
    "value": "lena"
  },
  {
    "text": "Lenapah",
    "value": "lenapah"
  },
  {
    "text": "Lenexa",
    "value": "lenexa"
  },
  {
    "text": "Lengby",
    "value": "lengby"
  },
  {
    "text": "Lenhartsville",
    "value": "lenhartsville"
  },
  {
    "text": "Lenni",
    "value": "lenni"
  },
  {
    "text": "Lennon",
    "value": "lennon"
  },
  {
    "text": "Lennox",
    "value": "lennox"
  },
  {
    "text": "Lenoir",
    "value": "lenoir"
  },
  {
    "text": "Lenoir City",
    "value": "lenoir city"
  },
  {
    "text": "Lenora",
    "value": "lenora"
  },
  {
    "text": "Lenorah",
    "value": "lenorah"
  },
  {
    "text": "Lenore",
    "value": "lenore"
  },
  {
    "text": "Lenox",
    "value": "lenox"
  },
  {
    "text": "Lenox Dale",
    "value": "lenox dale"
  },
  {
    "text": "Lenoxville",
    "value": "lenoxville"
  },
  {
    "text": "Lents",
    "value": "lents"
  },
  {
    "text": "Lenzburg",
    "value": "lenzburg"
  },
  {
    "text": "Leo",
    "value": "leo"
  },
  {
    "text": "Leo-Cedarville",
    "value": "leo-cedarville"
  },
  {
    "text": "Leola",
    "value": "leola"
  },
  {
    "text": "Leoma",
    "value": "leoma"
  },
  {
    "text": "Leominster",
    "value": "leominster"
  },
  {
    "text": "Leon",
    "value": "leon"
  },
  {
    "text": "Leon Valley",
    "value": "leon valley"
  },
  {
    "text": "Leona",
    "value": "leona"
  },
  {
    "text": "Leonard",
    "value": "leonard"
  },
  {
    "text": "Leonardo",
    "value": "leonardo"
  },
  {
    "text": "Leonardsville",
    "value": "leonardsville"
  },
  {
    "text": "Leonardtown",
    "value": "leonardtown"
  },
  {
    "text": "Leonardville",
    "value": "leonardville"
  },
  {
    "text": "Leonia",
    "value": "leonia"
  },
  {
    "text": "Leonidas",
    "value": "leonidas"
  },
  {
    "text": "Leonore",
    "value": "leonore"
  },
  {
    "text": "Leonville",
    "value": "leonville"
  },
  {
    "text": "Leopold",
    "value": "leopold"
  },
  {
    "text": "Leopolis",
    "value": "leopolis"
  },
  {
    "text": "Leota",
    "value": "leota"
  },
  {
    "text": "Leoti",
    "value": "leoti"
  },
  {
    "text": "Lepanto",
    "value": "lepanto"
  },
  {
    "text": "Lerdo",
    "value": "lerdo"
  },
  {
    "text": "Lerna",
    "value": "lerna"
  },
  {
    "text": "Lerona",
    "value": "lerona"
  },
  {
    "text": "Leroy",
    "value": "leroy"
  },
  {
    "text": "Lesage",
    "value": "lesage"
  },
  {
    "text": "Leslie",
    "value": "leslie"
  },
  {
    "text": "Lester",
    "value": "lester"
  },
  {
    "text": "Lester Prairie",
    "value": "lester prairie"
  },
  {
    "text": "Lesterville",
    "value": "lesterville"
  },
  {
    "text": "Letart",
    "value": "letart"
  },
  {
    "text": "Letcher",
    "value": "letcher"
  },
  {
    "text": "Letohatchee",
    "value": "letohatchee"
  },
  {
    "text": "Letts",
    "value": "letts"
  },
  {
    "text": "Lettsworth",
    "value": "lettsworth"
  },
  {
    "text": "Leupp",
    "value": "leupp"
  },
  {
    "text": "Levan",
    "value": "levan"
  },
  {
    "text": "Levant",
    "value": "levant"
  },
  {
    "text": "Levelland",
    "value": "levelland"
  },
  {
    "text": "Levels",
    "value": "levels"
  },
  {
    "text": "Leverett",
    "value": "leverett"
  },
  {
    "text": "Levering",
    "value": "levering"
  },
  {
    "text": "Levittown",
    "value": "levittown"
  },
  {
    "text": "Lewellen",
    "value": "lewellen"
  },
  {
    "text": "Lewes",
    "value": "lewes"
  },
  {
    "text": "Lewis",
    "value": "lewis"
  },
  {
    "text": "Lewis Center",
    "value": "lewis center"
  },
  {
    "text": "Lewis Run",
    "value": "lewis run"
  },
  {
    "text": "Lewisberry",
    "value": "lewisberry"
  },
  {
    "text": "Lewisboro",
    "value": "lewisboro"
  },
  {
    "text": "Lewisburg",
    "value": "lewisburg"
  },
  {
    "text": "Lewisport",
    "value": "lewisport"
  },
  {
    "text": "Lewiston",
    "value": "lewiston"
  },
  {
    "text": "Lewiston Orchards",
    "value": "lewiston orchards"
  },
  {
    "text": "Lewiston Woodville",
    "value": "lewiston woodville"
  },
  {
    "text": "Lewistown",
    "value": "lewistown"
  },
  {
    "text": "Lewisville",
    "value": "lewisville"
  },
  {
    "text": "Lexa",
    "value": "lexa"
  },
  {
    "text": "Lexington",
    "value": "lexington"
  },
  {
    "text": "Lexington Park",
    "value": "lexington park"
  },
  {
    "text": "Lexington-Fayette",
    "value": "lexington-fayette"
  },
  {
    "text": "Libby",
    "value": "libby"
  },
  {
    "text": "Liberal",
    "value": "liberal"
  },
  {
    "text": "Liberty",
    "value": "liberty"
  },
  {
    "text": "Liberty Center",
    "value": "liberty center"
  },
  {
    "text": "Liberty City",
    "value": "liberty city"
  },
  {
    "text": "Liberty Corner",
    "value": "liberty corner"
  },
  {
    "text": "Liberty Hill",
    "value": "liberty hill"
  },
  {
    "text": "Liberty Lake",
    "value": "liberty lake"
  },
  {
    "text": "Liberty Mills",
    "value": "liberty mills"
  },
  {
    "text": "Liberty Township",
    "value": "liberty township"
  },
  {
    "text": "Libertyville",
    "value": "libertyville"
  },
  {
    "text": "Libuse",
    "value": "libuse"
  },
  {
    "text": "Lick Creek",
    "value": "lick creek"
  },
  {
    "text": "Licking",
    "value": "licking"
  },
  {
    "text": "Lidgerwood",
    "value": "lidgerwood"
  },
  {
    "text": "Lido Beach",
    "value": "lido beach"
  },
  {
    "text": "Light Street",
    "value": "light street"
  },
  {
    "text": "Lightfoot",
    "value": "lightfoot"
  },
  {
    "text": "Lighthouse Point",
    "value": "lighthouse point"
  },
  {
    "text": "Lignite",
    "value": "lignite"
  },
  {
    "text": "Lignum",
    "value": "lignum"
  },
  {
    "text": "Ligonier",
    "value": "ligonier"
  },
  {
    "text": "Liguori",
    "value": "liguori"
  },
  {
    "text": "Lihue",
    "value": "lihue"
  },
  {
    "text": "Lilbourn",
    "value": "lilbourn"
  },
  {
    "text": "Lilburn",
    "value": "lilburn"
  },
  {
    "text": "Lilesville",
    "value": "lilesville"
  },
  {
    "text": "Lillian",
    "value": "lillian"
  },
  {
    "text": "Lillie",
    "value": "lillie"
  },
  {
    "text": "Lillington",
    "value": "lillington"
  },
  {
    "text": "Lilliwaup",
    "value": "lilliwaup"
  },
  {
    "text": "Lilly",
    "value": "lilly"
  },
  {
    "text": "Lily",
    "value": "lily"
  },
  {
    "text": "Lima",
    "value": "lima"
  },
  {
    "text": "Lime Springs",
    "value": "lime springs"
  },
  {
    "text": "Limeport",
    "value": "limeport"
  },
  {
    "text": "Limerick",
    "value": "limerick"
  },
  {
    "text": "Limestone",
    "value": "limestone"
  },
  {
    "text": "Limington",
    "value": "limington"
  },
  {
    "text": "Limon",
    "value": "limon"
  },
  {
    "text": "Lincoln",
    "value": "lincoln"
  },
  {
    "text": "Lincoln City",
    "value": "lincoln city"
  },
  {
    "text": "Lincoln Heights",
    "value": "lincoln heights"
  },
  {
    "text": "Lincoln Park",
    "value": "lincoln park"
  },
  {
    "text": "Lincoln University",
    "value": "lincoln university"
  },
  {
    "text": "Lincoln Village",
    "value": "lincoln village"
  },
  {
    "text": "Lincolndale",
    "value": "lincolndale"
  },
  {
    "text": "Lincolnia",
    "value": "lincolnia"
  },
  {
    "text": "Lincolnshire",
    "value": "lincolnshire"
  },
  {
    "text": "Lincolnton",
    "value": "lincolnton"
  },
  {
    "text": "Lincolnville",
    "value": "lincolnville"
  },
  {
    "text": "Lincolnville Center",
    "value": "lincolnville center"
  },
  {
    "text": "Lincolnwood",
    "value": "lincolnwood"
  },
  {
    "text": "Lincroft",
    "value": "lincroft"
  },
  {
    "text": "Lind",
    "value": "lind"
  },
  {
    "text": "Lindale",
    "value": "lindale"
  },
  {
    "text": "Linden",
    "value": "linden"
  },
  {
    "text": "Lindenhurst",
    "value": "lindenhurst"
  },
  {
    "text": "Lindenwold",
    "value": "lindenwold"
  },
  {
    "text": "Lindenwood",
    "value": "lindenwood"
  },
  {
    "text": "Lindley",
    "value": "lindley"
  },
  {
    "text": "Lindon",
    "value": "lindon"
  },
  {
    "text": "Lindrith",
    "value": "lindrith"
  },
  {
    "text": "Lindsay",
    "value": "lindsay"
  },
  {
    "text": "Lindsborg",
    "value": "lindsborg"
  },
  {
    "text": "Lindsey",
    "value": "lindsey"
  },
  {
    "text": "Lindside",
    "value": "lindside"
  },
  {
    "text": "Lindstrom",
    "value": "lindstrom"
  },
  {
    "text": "Line Lexington",
    "value": "line lexington"
  },
  {
    "text": "Linefork",
    "value": "linefork"
  },
  {
    "text": "Linesville",
    "value": "linesville"
  },
  {
    "text": "Lineville",
    "value": "lineville"
  },
  {
    "text": "Lingle",
    "value": "lingle"
  },
  {
    "text": "Linkwood",
    "value": "linkwood"
  },
  {
    "text": "Linn",
    "value": "linn"
  },
  {
    "text": "Linn Creek",
    "value": "linn creek"
  },
  {
    "text": "Linn Grove",
    "value": "linn grove"
  },
  {
    "text": "Linneus",
    "value": "linneus"
  },
  {
    "text": "Lino Lakes",
    "value": "lino lakes"
  },
  {
    "text": "Linthicum",
    "value": "linthicum"
  },
  {
    "text": "Linthicum Heights",
    "value": "linthicum heights"
  },
  {
    "text": "Linton",
    "value": "linton"
  },
  {
    "text": "Linton Hall",
    "value": "linton hall"
  },
  {
    "text": "Linville",
    "value": "linville"
  },
  {
    "text": "Linwood",
    "value": "linwood"
  },
  {
    "text": "Lionville",
    "value": "lionville"
  },
  {
    "text": "Lipan",
    "value": "lipan"
  },
  {
    "text": "Lipscomb",
    "value": "lipscomb"
  },
  {
    "text": "Lisbon",
    "value": "lisbon"
  },
  {
    "text": "Lisbon Falls",
    "value": "lisbon falls"
  },
  {
    "text": "Lisco",
    "value": "lisco"
  },
  {
    "text": "Liscomb",
    "value": "liscomb"
  },
  {
    "text": "Lisle",
    "value": "lisle"
  },
  {
    "text": "Lisman",
    "value": "lisman"
  },
  {
    "text": "Lismore",
    "value": "lismore"
  },
  {
    "text": "Litchfield",
    "value": "litchfield"
  },
  {
    "text": "Litchfield Park",
    "value": "litchfield park"
  },
  {
    "text": "Litchville",
    "value": "litchville"
  },
  {
    "text": "Literberry",
    "value": "literberry"
  },
  {
    "text": "Lithia",
    "value": "lithia"
  },
  {
    "text": "Lithia Springs",
    "value": "lithia springs"
  },
  {
    "text": "Lithonia",
    "value": "lithonia"
  },
  {
    "text": "Lithopolis",
    "value": "lithopolis"
  },
  {
    "text": "Lititz",
    "value": "lititz"
  },
  {
    "text": "Littcarr",
    "value": "littcarr"
  },
  {
    "text": "Little America",
    "value": "little america"
  },
  {
    "text": "Little Birch",
    "value": "little birch"
  },
  {
    "text": "Little Boston",
    "value": "little boston"
  },
  {
    "text": "Little Canada",
    "value": "little canada"
  },
  {
    "text": "Little Cedar",
    "value": "little cedar"
  },
  {
    "text": "Little Chute",
    "value": "little chute"
  },
  {
    "text": "Little Compton",
    "value": "little compton"
  },
  {
    "text": "Little Cottonwood Creek Valley",
    "value": "little cottonwood creek valley"
  },
  {
    "text": "Little Deer Isle",
    "value": "little deer isle"
  },
  {
    "text": "Little Eagle",
    "value": "little eagle"
  },
  {
    "text": "Little Elm",
    "value": "little elm"
  },
  {
    "text": "Little Falls",
    "value": "little falls"
  },
  {
    "text": "Little Ferry",
    "value": "little ferry"
  },
  {
    "text": "Little Flock",
    "value": "little flock"
  },
  {
    "text": "Little Genesee",
    "value": "little genesee"
  },
  {
    "text": "Little Hocking",
    "value": "little hocking"
  },
  {
    "text": "Little Lake",
    "value": "little lake"
  },
  {
    "text": "Little Meadows",
    "value": "little meadows"
  },
  {
    "text": "Little Mountain",
    "value": "little mountain"
  },
  {
    "text": "Little Neck",
    "value": "little neck"
  },
  {
    "text": "Little Orleans",
    "value": "little orleans"
  },
  {
    "text": "Little Plymouth",
    "value": "little plymouth"
  },
  {
    "text": "Little River",
    "value": "little river"
  },
  {
    "text": "Little River-Academy",
    "value": "little river-academy"
  },
  {
    "text": "Little Rock",
    "value": "little rock"
  },
  {
    "text": "Little Rock Air Force Base",
    "value": "little rock air force base"
  },
  {
    "text": "Little Silver",
    "value": "little silver"
  },
  {
    "text": "Little Sioux",
    "value": "little sioux"
  },
  {
    "text": "Little Suamico",
    "value": "little suamico"
  },
  {
    "text": "Little Switzerland",
    "value": "little switzerland"
  },
  {
    "text": "Little Valley",
    "value": "little valley"
  },
  {
    "text": "Little York",
    "value": "little york"
  },
  {
    "text": "Littlefield",
    "value": "littlefield"
  },
  {
    "text": "Littlefork",
    "value": "littlefork"
  },
  {
    "text": "Littlerock",
    "value": "littlerock"
  },
  {
    "text": "Littlestown",
    "value": "littlestown"
  },
  {
    "text": "Littleton",
    "value": "littleton"
  },
  {
    "text": "Littleville",
    "value": "littleville"
  },
  {
    "text": "Live Oak",
    "value": "live oak"
  },
  {
    "text": "Lively",
    "value": "lively"
  },
  {
    "text": "Livermore",
    "value": "livermore"
  },
  {
    "text": "Livermore Falls",
    "value": "livermore falls"
  },
  {
    "text": "Liverpool",
    "value": "liverpool"
  },
  {
    "text": "Livingston",
    "value": "livingston"
  },
  {
    "text": "Livingston Manor",
    "value": "livingston manor"
  },
  {
    "text": "Livonia",
    "value": "livonia"
  },
  {
    "text": "Lizella",
    "value": "lizella"
  },
  {
    "text": "Lizemores",
    "value": "lizemores"
  },
  {
    "text": "Lizton",
    "value": "lizton"
  },
  {
    "text": "Llano",
    "value": "llano"
  },
  {
    "text": "Llewellyn",
    "value": "llewellyn"
  },
  {
    "text": "Loa",
    "value": "loa"
  },
  {
    "text": "Loachapoka",
    "value": "loachapoka"
  },
  {
    "text": "Loami",
    "value": "loami"
  },
  {
    "text": "Lobeco",
    "value": "lobeco"
  },
  {
    "text": "Lobelville",
    "value": "lobelville"
  },
  {
    "text": "Loch Sheldrake",
    "value": "loch sheldrake"
  },
  {
    "text": "Lock Haven",
    "value": "lock haven"
  },
  {
    "text": "Lockbourne",
    "value": "lockbourne"
  },
  {
    "text": "Locke",
    "value": "locke"
  },
  {
    "text": "Lockeford",
    "value": "lockeford"
  },
  {
    "text": "Lockesburg",
    "value": "lockesburg"
  },
  {
    "text": "Lockhart",
    "value": "lockhart"
  },
  {
    "text": "Lockland",
    "value": "lockland"
  },
  {
    "text": "Lockney",
    "value": "lockney"
  },
  {
    "text": "Lockport",
    "value": "lockport"
  },
  {
    "text": "Lockridge",
    "value": "lockridge"
  },
  {
    "text": "Lockwood",
    "value": "lockwood"
  },
  {
    "text": "Loco Hills",
    "value": "loco hills"
  },
  {
    "text": "Locust",
    "value": "locust"
  },
  {
    "text": "Locust Dale",
    "value": "locust dale"
  },
  {
    "text": "Locust Fork",
    "value": "locust fork"
  },
  {
    "text": "Locust Grove",
    "value": "locust grove"
  },
  {
    "text": "Locust Hill",
    "value": "locust hill"
  },
  {
    "text": "Locust Valley",
    "value": "locust valley"
  },
  {
    "text": "Locustville",
    "value": "locustville"
  },
  {
    "text": "Loda",
    "value": "loda"
  },
  {
    "text": "Lodge",
    "value": "lodge"
  },
  {
    "text": "Lodge Grass",
    "value": "lodge grass"
  },
  {
    "text": "Lodgepole",
    "value": "lodgepole"
  },
  {
    "text": "Lodi",
    "value": "lodi"
  },
  {
    "text": "Log Lane Village",
    "value": "log lane village"
  },
  {
    "text": "Logan",
    "value": "logan"
  },
  {
    "text": "Logan Elm Village",
    "value": "logan elm village"
  },
  {
    "text": "Logandale",
    "value": "logandale"
  },
  {
    "text": "Logansport",
    "value": "logansport"
  },
  {
    "text": "Loganton",
    "value": "loganton"
  },
  {
    "text": "Loganville",
    "value": "loganville"
  },
  {
    "text": "Lohman",
    "value": "lohman"
  },
  {
    "text": "Lohn",
    "value": "lohn"
  },
  {
    "text": "Lohrville",
    "value": "lohrville"
  },
  {
    "text": "Loleta",
    "value": "loleta"
  },
  {
    "text": "Lolita",
    "value": "lolita"
  },
  {
    "text": "Lolo",
    "value": "lolo"
  },
  {
    "text": "Loma",
    "value": "loma"
  },
  {
    "text": "Loma Linda",
    "value": "loma linda"
  },
  {
    "text": "Loma Mar",
    "value": "loma mar"
  },
  {
    "text": "Loman",
    "value": "loman"
  },
  {
    "text": "Lomax",
    "value": "lomax"
  },
  {
    "text": "Lombard",
    "value": "lombard"
  },
  {
    "text": "Lometa",
    "value": "lometa"
  },
  {
    "text": "Lomira",
    "value": "lomira"
  },
  {
    "text": "Lomita",
    "value": "lomita"
  },
  {
    "text": "Lompoc",
    "value": "lompoc"
  },
  {
    "text": "Lonaconing",
    "value": "lonaconing"
  },
  {
    "text": "London",
    "value": "london"
  },
  {
    "text": "London Mills",
    "value": "london mills"
  },
  {
    "text": "Londonderry",
    "value": "londonderry"
  },
  {
    "text": "Lone",
    "value": "lone"
  },
  {
    "text": "Lone Grove",
    "value": "lone grove"
  },
  {
    "text": "Lone Jack",
    "value": "lone jack"
  },
  {
    "text": "Lone Oak",
    "value": "lone oak"
  },
  {
    "text": "Lone Pine",
    "value": "lone pine"
  },
  {
    "text": "Lone Rock",
    "value": "lone rock"
  },
  {
    "text": "Lone Star",
    "value": "lone star"
  },
  {
    "text": "Lone Tree",
    "value": "lone tree"
  },
  {
    "text": "Lone Wolf",
    "value": "lone wolf"
  },
  {
    "text": "Lonedell",
    "value": "lonedell"
  },
  {
    "text": "Lonetree",
    "value": "lonetree"
  },
  {
    "text": "Long Barn",
    "value": "long barn"
  },
  {
    "text": "Long Beach",
    "value": "long beach"
  },
  {
    "text": "Long Bottom",
    "value": "long bottom"
  },
  {
    "text": "Long Branch",
    "value": "long branch"
  },
  {
    "text": "Long Creek",
    "value": "long creek"
  },
  {
    "text": "Long Eddy",
    "value": "long eddy"
  },
  {
    "text": "Long Grove",
    "value": "long grove"
  },
  {
    "text": "Long Hill",
    "value": "long hill"
  },
  {
    "text": "Long Island",
    "value": "long island"
  },
  {
    "text": "Long Island City",
    "value": "long island city"
  },
  {
    "text": "Long Lake",
    "value": "long lake"
  },
  {
    "text": "Long Lane",
    "value": "long lane"
  },
  {
    "text": "Long Neck",
    "value": "long neck"
  },
  {
    "text": "Long Pine",
    "value": "long pine"
  },
  {
    "text": "Long Pond",
    "value": "long pond"
  },
  {
    "text": "Long Prairie",
    "value": "long prairie"
  },
  {
    "text": "Long Valley",
    "value": "long valley"
  },
  {
    "text": "Longboat Key",
    "value": "longboat key"
  },
  {
    "text": "Longbranch",
    "value": "longbranch"
  },
  {
    "text": "Longdale",
    "value": "longdale"
  },
  {
    "text": "Longford",
    "value": "longford"
  },
  {
    "text": "Longmeadow",
    "value": "longmeadow"
  },
  {
    "text": "Longmont",
    "value": "longmont"
  },
  {
    "text": "Longport",
    "value": "longport"
  },
  {
    "text": "Longs",
    "value": "longs"
  },
  {
    "text": "Longstreet",
    "value": "longstreet"
  },
  {
    "text": "Longton",
    "value": "longton"
  },
  {
    "text": "Longview",
    "value": "longview"
  },
  {
    "text": "Longville",
    "value": "longville"
  },
  {
    "text": "Longwood",
    "value": "longwood"
  },
  {
    "text": "Lonoke",
    "value": "lonoke"
  },
  {
    "text": "Lonsdale",
    "value": "lonsdale"
  },
  {
    "text": "Loogootee",
    "value": "loogootee"
  },
  {
    "text": "Lookeba",
    "value": "lookeba"
  },
  {
    "text": "Lookout",
    "value": "lookout"
  },
  {
    "text": "Lookout Mountain",
    "value": "lookout mountain"
  },
  {
    "text": "Loomis",
    "value": "loomis"
  },
  {
    "text": "Loon Lake",
    "value": "loon lake"
  },
  {
    "text": "Looneyville",
    "value": "looneyville"
  },
  {
    "text": "Loop",
    "value": "loop"
  },
  {
    "text": "Loose Creek",
    "value": "loose creek"
  },
  {
    "text": "Lopeno",
    "value": "lopeno"
  },
  {
    "text": "Lopez",
    "value": "lopez"
  },
  {
    "text": "Lopez Island",
    "value": "lopez island"
  },
  {
    "text": "Lorado",
    "value": "lorado"
  },
  {
    "text": "Lorain",
    "value": "lorain"
  },
  {
    "text": "Loraine",
    "value": "loraine"
  },
  {
    "text": "Lorane",
    "value": "lorane"
  },
  {
    "text": "Loranger",
    "value": "loranger"
  },
  {
    "text": "Lordsburg",
    "value": "lordsburg"
  },
  {
    "text": "Lordstown",
    "value": "lordstown"
  },
  {
    "text": "Lore City",
    "value": "lore city"
  },
  {
    "text": "Loreauville",
    "value": "loreauville"
  },
  {
    "text": "Lorena",
    "value": "lorena"
  },
  {
    "text": "Lorenzo",
    "value": "lorenzo"
  },
  {
    "text": "Loretto",
    "value": "loretto"
  },
  {
    "text": "Lorida",
    "value": "lorida"
  },
  {
    "text": "Lorimor",
    "value": "lorimor"
  },
  {
    "text": "Loris",
    "value": "loris"
  },
  {
    "text": "Lorman",
    "value": "lorman"
  },
  {
    "text": "Lorraine",
    "value": "lorraine"
  },
  {
    "text": "Lorton",
    "value": "lorton"
  },
  {
    "text": "Los Alamitos",
    "value": "los alamitos"
  },
  {
    "text": "Los Alamos",
    "value": "los alamos"
  },
  {
    "text": "Los Altos",
    "value": "los altos"
  },
  {
    "text": "Los Altos Hills",
    "value": "los altos hills"
  },
  {
    "text": "Los Angeles",
    "value": "los angeles"
  },
  {
    "text": "Los Banos",
    "value": "los banos"
  },
  {
    "text": "Los Ebanos",
    "value": "los ebanos"
  },
  {
    "text": "Los Fresnos",
    "value": "los fresnos"
  },
  {
    "text": "Los Gatos",
    "value": "los gatos"
  },
  {
    "text": "Los Indios",
    "value": "los indios"
  },
  {
    "text": "Los Lunas",
    "value": "los lunas"
  },
  {
    "text": "Los Molinos",
    "value": "los molinos"
  },
  {
    "text": "Los Ojos",
    "value": "los ojos"
  },
  {
    "text": "Los Olivos",
    "value": "los olivos"
  },
  {
    "text": "Los Osos",
    "value": "los osos"
  },
  {
    "text": "Los Ranchos de Albuquerque",
    "value": "los ranchos de albuquerque"
  },
  {
    "text": "Los Serranos",
    "value": "los serranos"
  },
  {
    "text": "Losantville",
    "value": "losantville"
  },
  {
    "text": "Lost City",
    "value": "lost city"
  },
  {
    "text": "Lost Creek",
    "value": "lost creek"
  },
  {
    "text": "Lost Hills",
    "value": "lost hills"
  },
  {
    "text": "Lost Nation",
    "value": "lost nation"
  },
  {
    "text": "Lost Springs",
    "value": "lost springs"
  },
  {
    "text": "Lostant",
    "value": "lostant"
  },
  {
    "text": "Lostine",
    "value": "lostine"
  },
  {
    "text": "Lothair",
    "value": "lothair"
  },
  {
    "text": "Lothian",
    "value": "lothian"
  },
  {
    "text": "Lott",
    "value": "lott"
  },
  {
    "text": "Lottie",
    "value": "lottie"
  },
  {
    "text": "Lottsburg",
    "value": "lottsburg"
  },
  {
    "text": "Lotus",
    "value": "lotus"
  },
  {
    "text": "Louann",
    "value": "louann"
  },
  {
    "text": "Loudon",
    "value": "loudon"
  },
  {
    "text": "Loudonville",
    "value": "loudonville"
  },
  {
    "text": "Louin",
    "value": "louin"
  },
  {
    "text": "Louisa",
    "value": "louisa"
  },
  {
    "text": "Louisburg",
    "value": "louisburg"
  },
  {
    "text": "Louise",
    "value": "louise"
  },
  {
    "text": "Louisiana",
    "value": "louisiana"
  },
  {
    "text": "Louisville",
    "value": "louisville"
  },
  {
    "text": "Loup City",
    "value": "loup city"
  },
  {
    "text": "Louviers",
    "value": "louviers"
  },
  {
    "text": "Lovejoy",
    "value": "lovejoy"
  },
  {
    "text": "Lovelady",
    "value": "lovelady"
  },
  {
    "text": "Loveland",
    "value": "loveland"
  },
  {
    "text": "Loveland Park",
    "value": "loveland park"
  },
  {
    "text": "Lovell",
    "value": "lovell"
  },
  {
    "text": "Lovelock",
    "value": "lovelock"
  },
  {
    "text": "Lovely",
    "value": "lovely"
  },
  {
    "text": "Loves Park",
    "value": "loves park"
  },
  {
    "text": "Lovettsville",
    "value": "lovettsville"
  },
  {
    "text": "Loveville",
    "value": "loveville"
  },
  {
    "text": "Lovilia",
    "value": "lovilia"
  },
  {
    "text": "Loving",
    "value": "loving"
  },
  {
    "text": "Lovingston",
    "value": "lovingston"
  },
  {
    "text": "Lovington",
    "value": "lovington"
  },
  {
    "text": "Low Moor",
    "value": "low moor"
  },
  {
    "text": "Low Point",
    "value": "low point"
  },
  {
    "text": "Lowden",
    "value": "lowden"
  },
  {
    "text": "Lowell",
    "value": "lowell"
  },
  {
    "text": "Lowellville",
    "value": "lowellville"
  },
  {
    "text": "Lower Allen",
    "value": "lower allen"
  },
  {
    "text": "Lower Brule",
    "value": "lower brule"
  },
  {
    "text": "Lower Burrell",
    "value": "lower burrell"
  },
  {
    "text": "Lower Kalskag",
    "value": "lower kalskag"
  },
  {
    "text": "Lower Lake",
    "value": "lower lake"
  },
  {
    "text": "Lower Peach Tree",
    "value": "lower peach tree"
  },
  {
    "text": "Lower Salem",
    "value": "lower salem"
  },
  {
    "text": "Lower Waterford",
    "value": "lower waterford"
  },
  {
    "text": "Lowesville",
    "value": "lowesville"
  },
  {
    "text": "Lowgap",
    "value": "lowgap"
  },
  {
    "text": "Lowland",
    "value": "lowland"
  },
  {
    "text": "Lowman",
    "value": "lowman"
  },
  {
    "text": "Lowmansville",
    "value": "lowmansville"
  },
  {
    "text": "Lowndes",
    "value": "lowndes"
  },
  {
    "text": "Lowndesboro",
    "value": "lowndesboro"
  },
  {
    "text": "Lowry",
    "value": "lowry"
  },
  {
    "text": "Lowry City",
    "value": "lowry city"
  },
  {
    "text": "Lowry Crossing",
    "value": "lowry crossing"
  },
  {
    "text": "Lowville",
    "value": "lowville"
  },
  {
    "text": "Loxahatchee",
    "value": "loxahatchee"
  },
  {
    "text": "Loxahatchee Groves",
    "value": "loxahatchee groves"
  },
  {
    "text": "Loxley",
    "value": "loxley"
  },
  {
    "text": "Loyal",
    "value": "loyal"
  },
  {
    "text": "Loyalhanna",
    "value": "loyalhanna"
  },
  {
    "text": "Loyall",
    "value": "loyall"
  },
  {
    "text": "Loyalsock",
    "value": "loyalsock"
  },
  {
    "text": "Loyalton",
    "value": "loyalton"
  },
  {
    "text": "Loysburg",
    "value": "loysburg"
  },
  {
    "text": "Loysville",
    "value": "loysville"
  },
  {
    "text": "Lu Verne",
    "value": "lu verne"
  },
  {
    "text": "Luana",
    "value": "luana"
  },
  {
    "text": "Lubbock",
    "value": "lubbock"
  },
  {
    "text": "Lubec",
    "value": "lubec"
  },
  {
    "text": "Lublin",
    "value": "lublin"
  },
  {
    "text": "Lucama",
    "value": "lucama"
  },
  {
    "text": "Lucan",
    "value": "lucan"
  },
  {
    "text": "Lucas",
    "value": "lucas"
  },
  {
    "text": "Lucas Valley-Marinwood",
    "value": "lucas valley-marinwood"
  },
  {
    "text": "Lucasville",
    "value": "lucasville"
  },
  {
    "text": "Lucedale",
    "value": "lucedale"
  },
  {
    "text": "Lucerne",
    "value": "lucerne"
  },
  {
    "text": "Lucerne Mines",
    "value": "lucerne mines"
  },
  {
    "text": "Lucerne Valley",
    "value": "lucerne valley"
  },
  {
    "text": "Lucien",
    "value": "lucien"
  },
  {
    "text": "Lucile",
    "value": "lucile"
  },
  {
    "text": "Lucinda",
    "value": "lucinda"
  },
  {
    "text": "Luck",
    "value": "luck"
  },
  {
    "text": "Luckey",
    "value": "luckey"
  },
  {
    "text": "Ludell",
    "value": "ludell"
  },
  {
    "text": "Ludington",
    "value": "ludington"
  },
  {
    "text": "Ludlow",
    "value": "ludlow"
  },
  {
    "text": "Ludlow Falls",
    "value": "ludlow falls"
  },
  {
    "text": "Ludowici",
    "value": "ludowici"
  },
  {
    "text": "Luebbering",
    "value": "luebbering"
  },
  {
    "text": "Lueders",
    "value": "lueders"
  },
  {
    "text": "Lufkin",
    "value": "lufkin"
  },
  {
    "text": "Lugoff",
    "value": "lugoff"
  },
  {
    "text": "Lukachukai",
    "value": "lukachukai"
  },
  {
    "text": "Luke Air Force Base",
    "value": "luke air force base"
  },
  {
    "text": "Lula",
    "value": "lula"
  },
  {
    "text": "Luling",
    "value": "luling"
  },
  {
    "text": "Lulu",
    "value": "lulu"
  },
  {
    "text": "Lumber Bridge",
    "value": "lumber bridge"
  },
  {
    "text": "Lumber City",
    "value": "lumber city"
  },
  {
    "text": "Lumberport",
    "value": "lumberport"
  },
  {
    "text": "Lumberton",
    "value": "lumberton"
  },
  {
    "text": "Lummi Island",
    "value": "lummi island"
  },
  {
    "text": "Lumpkin",
    "value": "lumpkin"
  },
  {
    "text": "Luna Pier",
    "value": "luna pier"
  },
  {
    "text": "Lund",
    "value": "lund"
  },
  {
    "text": "Lunenburg",
    "value": "lunenburg"
  },
  {
    "text": "Luning",
    "value": "luning"
  },
  {
    "text": "Lupton",
    "value": "lupton"
  },
  {
    "text": "Luray",
    "value": "luray"
  },
  {
    "text": "Lusby",
    "value": "lusby"
  },
  {
    "text": "Lusk",
    "value": "lusk"
  },
  {
    "text": "Lutcher",
    "value": "lutcher"
  },
  {
    "text": "Luther",
    "value": "luther"
  },
  {
    "text": "Luthersburg",
    "value": "luthersburg"
  },
  {
    "text": "Luthersville",
    "value": "luthersville"
  },
  {
    "text": "Lutherville",
    "value": "lutherville"
  },
  {
    "text": "Lutherville-Timonium",
    "value": "lutherville-timonium"
  },
  {
    "text": "Lutsen",
    "value": "lutsen"
  },
  {
    "text": "Luttrell",
    "value": "luttrell"
  },
  {
    "text": "Lutts",
    "value": "lutts"
  },
  {
    "text": "Lutz",
    "value": "lutz"
  },
  {
    "text": "Luverne",
    "value": "luverne"
  },
  {
    "text": "Luxemburg",
    "value": "luxemburg"
  },
  {
    "text": "Luxor",
    "value": "luxor"
  },
  {
    "text": "Luxora",
    "value": "luxora"
  },
  {
    "text": "Luzerne",
    "value": "luzerne"
  },
  {
    "text": "Lyburn",
    "value": "lyburn"
  },
  {
    "text": "Lydia",
    "value": "lydia"
  },
  {
    "text": "Lyerly",
    "value": "lyerly"
  },
  {
    "text": "Lyford",
    "value": "lyford"
  },
  {
    "text": "Lykens",
    "value": "lykens"
  },
  {
    "text": "Lyle",
    "value": "lyle"
  },
  {
    "text": "Lyles",
    "value": "lyles"
  },
  {
    "text": "Lyman",
    "value": "lyman"
  },
  {
    "text": "Lyme",
    "value": "lyme"
  },
  {
    "text": "Lyme Center",
    "value": "lyme center"
  },
  {
    "text": "Lynbrook",
    "value": "lynbrook"
  },
  {
    "text": "Lynch",
    "value": "lynch"
  },
  {
    "text": "Lynch Station",
    "value": "lynch station"
  },
  {
    "text": "Lynchburg",
    "value": "lynchburg"
  },
  {
    "text": "Lynd",
    "value": "lynd"
  },
  {
    "text": "Lyndeborough",
    "value": "lyndeborough"
  },
  {
    "text": "Lyndell",
    "value": "lyndell"
  },
  {
    "text": "Lynden",
    "value": "lynden"
  },
  {
    "text": "Lyndhurst",
    "value": "lyndhurst"
  },
  {
    "text": "Lyndon",
    "value": "lyndon"
  },
  {
    "text": "Lyndon Center",
    "value": "lyndon center"
  },
  {
    "text": "Lyndon Station",
    "value": "lyndon station"
  },
  {
    "text": "Lyndonville",
    "value": "lyndonville"
  },
  {
    "text": "Lyndora",
    "value": "lyndora"
  },
  {
    "text": "Lynn",
    "value": "lynn"
  },
  {
    "text": "Lynn Center",
    "value": "lynn center"
  },
  {
    "text": "Lynn Haven",
    "value": "lynn haven"
  },
  {
    "text": "Lynndale",
    "value": "lynndale"
  },
  {
    "text": "Lynnfield",
    "value": "lynnfield"
  },
  {
    "text": "Lynnville",
    "value": "lynnville"
  },
  {
    "text": "Lynnwood",
    "value": "lynnwood"
  },
  {
    "text": "Lynwood",
    "value": "lynwood"
  },
  {
    "text": "Lynx",
    "value": "lynx"
  },
  {
    "text": "Lynxville",
    "value": "lynxville"
  },
  {
    "text": "Lyon",
    "value": "lyon"
  },
  {
    "text": "Lyon Mountain",
    "value": "lyon mountain"
  },
  {
    "text": "Lyon Station",
    "value": "lyon station"
  },
  {
    "text": "Lyons",
    "value": "lyons"
  },
  {
    "text": "Lyons Falls",
    "value": "lyons falls"
  },
  {
    "text": "Lysite",
    "value": "lysite"
  },
  {
    "text": "Lytle",
    "value": "lytle"
  },
  {
    "text": "Lytle Creek",
    "value": "lytle creek"
  },
  {
    "text": "Lytton",
    "value": "lytton"
  },
  {
    "text": "M C B H Kaneohe Bay",
    "value": "m c b h kaneohe bay"
  },
  {
    "text": "Mabank",
    "value": "mabank"
  },
  {
    "text": "Mabel",
    "value": "mabel"
  },
  {
    "text": "Mabelvale",
    "value": "mabelvale"
  },
  {
    "text": "Maben",
    "value": "maben"
  },
  {
    "text": "Mableton",
    "value": "mableton"
  },
  {
    "text": "Mabscott",
    "value": "mabscott"
  },
  {
    "text": "Mabton",
    "value": "mabton"
  },
  {
    "text": "MacArthur",
    "value": "macarthur"
  },
  {
    "text": "Macatawa",
    "value": "macatawa"
  },
  {
    "text": "Macclenny",
    "value": "macclenny"
  },
  {
    "text": "Macclesfield",
    "value": "macclesfield"
  },
  {
    "text": "Macdoel",
    "value": "macdoel"
  },
  {
    "text": "Macedon",
    "value": "macedon"
  },
  {
    "text": "Macedonia",
    "value": "macedonia"
  },
  {
    "text": "Maceo",
    "value": "maceo"
  },
  {
    "text": "Machesney Park",
    "value": "machesney park"
  },
  {
    "text": "Machias",
    "value": "machias"
  },
  {
    "text": "Machipongo",
    "value": "machipongo"
  },
  {
    "text": "Mack",
    "value": "mack"
  },
  {
    "text": "Mackay",
    "value": "mackay"
  },
  {
    "text": "Mackeyville",
    "value": "mackeyville"
  },
  {
    "text": "Mackinac Island",
    "value": "mackinac island"
  },
  {
    "text": "Mackinaw",
    "value": "mackinaw"
  },
  {
    "text": "Mackinaw City",
    "value": "mackinaw city"
  },
  {
    "text": "Macks Creek",
    "value": "macks creek"
  },
  {
    "text": "Macksburg",
    "value": "macksburg"
  },
  {
    "text": "Macksville",
    "value": "macksville"
  },
  {
    "text": "Mackville",
    "value": "mackville"
  },
  {
    "text": "Macomb",
    "value": "macomb"
  },
  {
    "text": "Macon",
    "value": "macon"
  },
  {
    "text": "Macungie",
    "value": "macungie"
  },
  {
    "text": "Macy",
    "value": "macy"
  },
  {
    "text": "Mad River",
    "value": "mad river"
  },
  {
    "text": "Madawaska",
    "value": "madawaska"
  },
  {
    "text": "Madbury",
    "value": "madbury"
  },
  {
    "text": "Madden",
    "value": "madden"
  },
  {
    "text": "Maddock",
    "value": "maddock"
  },
  {
    "text": "Madeira",
    "value": "madeira"
  },
  {
    "text": "Madeira Beach",
    "value": "madeira beach"
  },
  {
    "text": "Madelia",
    "value": "madelia"
  },
  {
    "text": "Madera",
    "value": "madera"
  },
  {
    "text": "Madera Ranchos",
    "value": "madera ranchos"
  },
  {
    "text": "Madill",
    "value": "madill"
  },
  {
    "text": "Madison",
    "value": "madison"
  },
  {
    "text": "Madison Heights",
    "value": "madison heights"
  },
  {
    "text": "Madison Lake",
    "value": "madison lake"
  },
  {
    "text": "Madison Park",
    "value": "madison park"
  },
  {
    "text": "Madisonburg",
    "value": "madisonburg"
  },
  {
    "text": "Madisonville",
    "value": "madisonville"
  },
  {
    "text": "Madras",
    "value": "madras"
  },
  {
    "text": "Madrid",
    "value": "madrid"
  },
  {
    "text": "Maeser",
    "value": "maeser"
  },
  {
    "text": "Magalia",
    "value": "magalia"
  },
  {
    "text": "Magazine",
    "value": "magazine"
  },
  {
    "text": "Magdalena",
    "value": "magdalena"
  },
  {
    "text": "Magee",
    "value": "magee"
  },
  {
    "text": "Maggie Valley",
    "value": "maggie valley"
  },
  {
    "text": "Magna",
    "value": "magna"
  },
  {
    "text": "Magness",
    "value": "magness"
  },
  {
    "text": "Magnolia",
    "value": "magnolia"
  },
  {
    "text": "Magnolia Springs",
    "value": "magnolia springs"
  },
  {
    "text": "Mahaffey",
    "value": "mahaffey"
  },
  {
    "text": "Mahanoy City",
    "value": "mahanoy city"
  },
  {
    "text": "Mahaska",
    "value": "mahaska"
  },
  {
    "text": "Mahnomen",
    "value": "mahnomen"
  },
  {
    "text": "Mahomet",
    "value": "mahomet"
  },
  {
    "text": "Mahopac",
    "value": "mahopac"
  },
  {
    "text": "Mahtomedi",
    "value": "mahtomedi"
  },
  {
    "text": "Mahwah",
    "value": "mahwah"
  },
  {
    "text": "Maiden",
    "value": "maiden"
  },
  {
    "text": "Maiden Rock",
    "value": "maiden rock"
  },
  {
    "text": "Maidens",
    "value": "maidens"
  },
  {
    "text": "Maidsville",
    "value": "maidsville"
  },
  {
    "text": "Maine",
    "value": "maine"
  },
  {
    "text": "Mainesburg",
    "value": "mainesburg"
  },
  {
    "text": "Maineville",
    "value": "maineville"
  },
  {
    "text": "Maitland",
    "value": "maitland"
  },
  {
    "text": "Maize",
    "value": "maize"
  },
  {
    "text": "Majestic",
    "value": "majestic"
  },
  {
    "text": "Makanda",
    "value": "makanda"
  },
  {
    "text": "Makawao",
    "value": "makawao"
  },
  {
    "text": "Makinen",
    "value": "makinen"
  },
  {
    "text": "Makoti",
    "value": "makoti"
  },
  {
    "text": "Malabar",
    "value": "malabar"
  },
  {
    "text": "Malad City",
    "value": "malad city"
  },
  {
    "text": "Malaga",
    "value": "malaga"
  },
  {
    "text": "Malakoff",
    "value": "malakoff"
  },
  {
    "text": "Malcolm",
    "value": "malcolm"
  },
  {
    "text": "Malcom",
    "value": "malcom"
  },
  {
    "text": "Malden",
    "value": "malden"
  },
  {
    "text": "Malden Bridge",
    "value": "malden bridge"
  },
  {
    "text": "Malibu",
    "value": "malibu"
  },
  {
    "text": "Malibu Beach",
    "value": "malibu beach"
  },
  {
    "text": "Malin",
    "value": "malin"
  },
  {
    "text": "Malinta",
    "value": "malinta"
  },
  {
    "text": "Mallard",
    "value": "mallard"
  },
  {
    "text": "Mallory",
    "value": "mallory"
  },
  {
    "text": "Malmo",
    "value": "malmo"
  },
  {
    "text": "Malmstrom Air Force Base",
    "value": "malmstrom air force base"
  },
  {
    "text": "Malo",
    "value": "malo"
  },
  {
    "text": "Malone",
    "value": "malone"
  },
  {
    "text": "Malott",
    "value": "malott"
  },
  {
    "text": "Malta",
    "value": "malta"
  },
  {
    "text": "Malta Bend",
    "value": "malta bend"
  },
  {
    "text": "Malvern",
    "value": "malvern"
  },
  {
    "text": "Malverne",
    "value": "malverne"
  },
  {
    "text": "Mamaroneck",
    "value": "mamaroneck"
  },
  {
    "text": "Mammoth",
    "value": "mammoth"
  },
  {
    "text": "Mammoth Cave",
    "value": "mammoth cave"
  },
  {
    "text": "Mammoth Lakes",
    "value": "mammoth lakes"
  },
  {
    "text": "Mammoth Spring",
    "value": "mammoth spring"
  },
  {
    "text": "Mamou",
    "value": "mamou"
  },
  {
    "text": "Man",
    "value": "man"
  },
  {
    "text": "Manahawkin",
    "value": "manahawkin"
  },
  {
    "text": "Manakin",
    "value": "manakin"
  },
  {
    "text": "Manalapan",
    "value": "manalapan"
  },
  {
    "text": "Manasquan",
    "value": "manasquan"
  },
  {
    "text": "Manassa",
    "value": "manassa"
  },
  {
    "text": "Manassas",
    "value": "manassas"
  },
  {
    "text": "Manassas Park",
    "value": "manassas park"
  },
  {
    "text": "Manatee Road",
    "value": "manatee road"
  },
  {
    "text": "Manawa",
    "value": "manawa"
  },
  {
    "text": "Mancelona",
    "value": "mancelona"
  },
  {
    "text": "Manchaca",
    "value": "manchaca"
  },
  {
    "text": "Manchaug",
    "value": "manchaug"
  },
  {
    "text": "Manchester",
    "value": "manchester"
  },
  {
    "text": "Manchester Center",
    "value": "manchester center"
  },
  {
    "text": "Manchester-by-the-Sea",
    "value": "manchester-by-the-sea"
  },
  {
    "text": "Mancos",
    "value": "mancos"
  },
  {
    "text": "Mandan",
    "value": "mandan"
  },
  {
    "text": "Mandaree",
    "value": "mandaree"
  },
  {
    "text": "Mandarin",
    "value": "mandarin"
  },
  {
    "text": "Mandata",
    "value": "mandata"
  },
  {
    "text": "Manderson",
    "value": "manderson"
  },
  {
    "text": "Mandeville",
    "value": "mandeville"
  },
  {
    "text": "Mangham",
    "value": "mangham"
  },
  {
    "text": "Mango",
    "value": "mango"
  },
  {
    "text": "Mangonia Park",
    "value": "mangonia park"
  },
  {
    "text": "Mangum",
    "value": "mangum"
  },
  {
    "text": "Manhasset",
    "value": "manhasset"
  },
  {
    "text": "Manhattan",
    "value": "manhattan"
  },
  {
    "text": "Manhattan Beach",
    "value": "manhattan beach"
  },
  {
    "text": "Manheim",
    "value": "manheim"
  },
  {
    "text": "Manila",
    "value": "manila"
  },
  {
    "text": "Manilla",
    "value": "manilla"
  },
  {
    "text": "Manistee",
    "value": "manistee"
  },
  {
    "text": "Manistique",
    "value": "manistique"
  },
  {
    "text": "Manito",
    "value": "manito"
  },
  {
    "text": "Manitou",
    "value": "manitou"
  },
  {
    "text": "Manitou Beach",
    "value": "manitou beach"
  },
  {
    "text": "Manitou Springs",
    "value": "manitou springs"
  },
  {
    "text": "Manitowish Waters",
    "value": "manitowish waters"
  },
  {
    "text": "Manitowoc",
    "value": "manitowoc"
  },
  {
    "text": "Mankato",
    "value": "mankato"
  },
  {
    "text": "Manley",
    "value": "manley"
  },
  {
    "text": "Manley Hot Springs",
    "value": "manley hot springs"
  },
  {
    "text": "Manlius",
    "value": "manlius"
  },
  {
    "text": "Manly",
    "value": "manly"
  },
  {
    "text": "Mannford",
    "value": "mannford"
  },
  {
    "text": "Manning",
    "value": "manning"
  },
  {
    "text": "Mannington",
    "value": "mannington"
  },
  {
    "text": "Manns Choice",
    "value": "manns choice"
  },
  {
    "text": "Manns Harbor",
    "value": "manns harbor"
  },
  {
    "text": "Mannsville",
    "value": "mannsville"
  },
  {
    "text": "Manokotak",
    "value": "manokotak"
  },
  {
    "text": "Manomet",
    "value": "manomet"
  },
  {
    "text": "Manor",
    "value": "manor"
  },
  {
    "text": "Manorhaven",
    "value": "manorhaven"
  },
  {
    "text": "Manorville",
    "value": "manorville"
  },
  {
    "text": "Manquin",
    "value": "manquin"
  },
  {
    "text": "Mansfield",
    "value": "mansfield"
  },
  {
    "text": "Mansfield Center",
    "value": "mansfield center"
  },
  {
    "text": "Mansfield Depot",
    "value": "mansfield depot"
  },
  {
    "text": "Manson",
    "value": "manson"
  },
  {
    "text": "Mansura",
    "value": "mansura"
  },
  {
    "text": "Mantachie",
    "value": "mantachie"
  },
  {
    "text": "Manteca",
    "value": "manteca"
  },
  {
    "text": "Mantee",
    "value": "mantee"
  },
  {
    "text": "Manteno",
    "value": "manteno"
  },
  {
    "text": "Manteo",
    "value": "manteo"
  },
  {
    "text": "Manter",
    "value": "manter"
  },
  {
    "text": "Manti",
    "value": "manti"
  },
  {
    "text": "Mantoloking",
    "value": "mantoloking"
  },
  {
    "text": "Manton",
    "value": "manton"
  },
  {
    "text": "Mantorville",
    "value": "mantorville"
  },
  {
    "text": "Mantua",
    "value": "mantua"
  },
  {
    "text": "Manvel",
    "value": "manvel"
  },
  {
    "text": "Manville",
    "value": "manville"
  },
  {
    "text": "Many",
    "value": "many"
  },
  {
    "text": "Many Farms",
    "value": "many farms"
  },
  {
    "text": "Manzanita",
    "value": "manzanita"
  },
  {
    "text": "Manzanola",
    "value": "manzanola"
  },
  {
    "text": "Mapaville",
    "value": "mapaville"
  },
  {
    "text": "Maple",
    "value": "maple"
  },
  {
    "text": "Maple City",
    "value": "maple city"
  },
  {
    "text": "Maple Falls",
    "value": "maple falls"
  },
  {
    "text": "Maple Glen",
    "value": "maple glen"
  },
  {
    "text": "Maple Grove",
    "value": "maple grove"
  },
  {
    "text": "Maple Heights",
    "value": "maple heights"
  },
  {
    "text": "Maple Hill",
    "value": "maple hill"
  },
  {
    "text": "Maple Lake",
    "value": "maple lake"
  },
  {
    "text": "Maple Mount",
    "value": "maple mount"
  },
  {
    "text": "Maple Park",
    "value": "maple park"
  },
  {
    "text": "Maple Plain",
    "value": "maple plain"
  },
  {
    "text": "Maple Rapids",
    "value": "maple rapids"
  },
  {
    "text": "Maple Shade",
    "value": "maple shade"
  },
  {
    "text": "Maple Shade Township",
    "value": "maple shade township"
  },
  {
    "text": "Maple Valley",
    "value": "maple valley"
  },
  {
    "text": "Maplecrest",
    "value": "maplecrest"
  },
  {
    "text": "Maplesville",
    "value": "maplesville"
  },
  {
    "text": "Mapleton",
    "value": "mapleton"
  },
  {
    "text": "Mapleville",
    "value": "mapleville"
  },
  {
    "text": "Maplewood",
    "value": "maplewood"
  },
  {
    "text": "Mappsville",
    "value": "mappsville"
  },
  {
    "text": "Maquoketa",
    "value": "maquoketa"
  },
  {
    "text": "Maquon",
    "value": "maquon"
  },
  {
    "text": "Mar Lin",
    "value": "mar lin"
  },
  {
    "text": "Maramec",
    "value": "maramec"
  },
  {
    "text": "Marana",
    "value": "marana"
  },
  {
    "text": "Marathon",
    "value": "marathon"
  },
  {
    "text": "Marathon Shores",
    "value": "marathon shores"
  },
  {
    "text": "Marble",
    "value": "marble"
  },
  {
    "text": "Marble Falls",
    "value": "marble falls"
  },
  {
    "text": "Marble Hill",
    "value": "marble hill"
  },
  {
    "text": "Marble Rock",
    "value": "marble rock"
  },
  {
    "text": "Marblehead",
    "value": "marblehead"
  },
  {
    "text": "Marblehill",
    "value": "marblehill"
  },
  {
    "text": "Marbleton",
    "value": "marbleton"
  },
  {
    "text": "Marbury",
    "value": "marbury"
  },
  {
    "text": "Marceline",
    "value": "marceline"
  },
  {
    "text": "Marcell",
    "value": "marcell"
  },
  {
    "text": "Marcellus",
    "value": "marcellus"
  },
  {
    "text": "March Air Force Base",
    "value": "march air force base"
  },
  {
    "text": "March Air Reserve Base",
    "value": "march air reserve base"
  },
  {
    "text": "Marco Island",
    "value": "marco island"
  },
  {
    "text": "Marcola",
    "value": "marcola"
  },
  {
    "text": "Marcus",
    "value": "marcus"
  },
  {
    "text": "Marcus Hook",
    "value": "marcus hook"
  },
  {
    "text": "Marcy",
    "value": "marcy"
  },
  {
    "text": "Mardela Springs",
    "value": "mardela springs"
  },
  {
    "text": "Marengo",
    "value": "marengo"
  },
  {
    "text": "Marenisco",
    "value": "marenisco"
  },
  {
    "text": "Marfa",
    "value": "marfa"
  },
  {
    "text": "Margaret",
    "value": "margaret"
  },
  {
    "text": "Margarettsville",
    "value": "margarettsville"
  },
  {
    "text": "Margaretville",
    "value": "margaretville"
  },
  {
    "text": "Margate",
    "value": "margate"
  },
  {
    "text": "Margate City",
    "value": "margate city"
  },
  {
    "text": "Maria Stein",
    "value": "maria stein"
  },
  {
    "text": "Marianna",
    "value": "marianna"
  },
  {
    "text": "Maribel",
    "value": "maribel"
  },
  {
    "text": "Maricopa",
    "value": "maricopa"
  },
  {
    "text": "Mariemont",
    "value": "mariemont"
  },
  {
    "text": "Marienthal",
    "value": "marienthal"
  },
  {
    "text": "Marienville",
    "value": "marienville"
  },
  {
    "text": "Marietta",
    "value": "marietta"
  },
  {
    "text": "Marilla",
    "value": "marilla"
  },
  {
    "text": "Marina",
    "value": "marina"
  },
  {
    "text": "Marina del Rey",
    "value": "marina del rey"
  },
  {
    "text": "Marine",
    "value": "marine"
  },
  {
    "text": "Marine City",
    "value": "marine city"
  },
  {
    "text": "Marine Corps Base Camp Lejeune",
    "value": "marine corps base camp lejeune"
  },
  {
    "text": "Marine Corps Reserve Support Command Kansas City",
    "value": "marine corps reserve support command kansas city"
  },
  {
    "text": "Marine on Saint Croix",
    "value": "marine on saint croix"
  },
  {
    "text": "Marinette",
    "value": "marinette"
  },
  {
    "text": "Maringouin",
    "value": "maringouin"
  },
  {
    "text": "Marion",
    "value": "marion"
  },
  {
    "text": "Marion Center",
    "value": "marion center"
  },
  {
    "text": "Marion Heights",
    "value": "marion heights"
  },
  {
    "text": "Marion Junction",
    "value": "marion junction"
  },
  {
    "text": "Marionville",
    "value": "marionville"
  },
  {
    "text": "Mariposa",
    "value": "mariposa"
  },
  {
    "text": "Marissa",
    "value": "marissa"
  },
  {
    "text": "Mark Center",
    "value": "mark center"
  },
  {
    "text": "Marked Tree",
    "value": "marked tree"
  },
  {
    "text": "Markesan",
    "value": "markesan"
  },
  {
    "text": "Markham",
    "value": "markham"
  },
  {
    "text": "Markle",
    "value": "markle"
  },
  {
    "text": "Markleeville",
    "value": "markleeville"
  },
  {
    "text": "Marklesburg",
    "value": "marklesburg"
  },
  {
    "text": "Markleton",
    "value": "markleton"
  },
  {
    "text": "Markleville",
    "value": "markleville"
  },
  {
    "text": "Markleysburg",
    "value": "markleysburg"
  },
  {
    "text": "Marks",
    "value": "marks"
  },
  {
    "text": "Marksville",
    "value": "marksville"
  },
  {
    "text": "Marland",
    "value": "marland"
  },
  {
    "text": "Marlboro",
    "value": "marlboro"
  },
  {
    "text": "Marlborough",
    "value": "marlborough"
  },
  {
    "text": "Marlette",
    "value": "marlette"
  },
  {
    "text": "Marlin",
    "value": "marlin"
  },
  {
    "text": "Marlinton",
    "value": "marlinton"
  },
  {
    "text": "Marlow",
    "value": "marlow"
  },
  {
    "text": "Marlow Heights",
    "value": "marlow heights"
  },
  {
    "text": "Marlton",
    "value": "marlton"
  },
  {
    "text": "Marmaduke",
    "value": "marmaduke"
  },
  {
    "text": "Marmet",
    "value": "marmet"
  },
  {
    "text": "Marmora",
    "value": "marmora"
  },
  {
    "text": "Marne",
    "value": "marne"
  },
  {
    "text": "Maroa",
    "value": "maroa"
  },
  {
    "text": "Marquand",
    "value": "marquand"
  },
  {
    "text": "Marquette",
    "value": "marquette"
  },
  {
    "text": "Marquette Heights",
    "value": "marquette heights"
  },
  {
    "text": "Marquez",
    "value": "marquez"
  },
  {
    "text": "Marrero",
    "value": "marrero"
  },
  {
    "text": "Marriott-Slaterville",
    "value": "marriott-slaterville"
  },
  {
    "text": "Marriottsville",
    "value": "marriottsville"
  },
  {
    "text": "Marrowbone",
    "value": "marrowbone"
  },
  {
    "text": "Marrowstone",
    "value": "marrowstone"
  },
  {
    "text": "Mars",
    "value": "mars"
  },
  {
    "text": "Mars Hill",
    "value": "mars hill"
  },
  {
    "text": "Marseilles",
    "value": "marseilles"
  },
  {
    "text": "Marshall",
    "value": "marshall"
  },
  {
    "text": "Marshallberg",
    "value": "marshallberg"
  },
  {
    "text": "Marshalls Creek",
    "value": "marshalls creek"
  },
  {
    "text": "Marshalltown",
    "value": "marshalltown"
  },
  {
    "text": "Marshallville",
    "value": "marshallville"
  },
  {
    "text": "Marshfield",
    "value": "marshfield"
  },
  {
    "text": "Marshfield Hills",
    "value": "marshfield hills"
  },
  {
    "text": "Marshville",
    "value": "marshville"
  },
  {
    "text": "Marsing",
    "value": "marsing"
  },
  {
    "text": "Marston",
    "value": "marston"
  },
  {
    "text": "Marstons Mills",
    "value": "marstons mills"
  },
  {
    "text": "Mart",
    "value": "mart"
  },
  {
    "text": "Martel",
    "value": "martel"
  },
  {
    "text": "Martell",
    "value": "martell"
  },
  {
    "text": "Martelle",
    "value": "martelle"
  },
  {
    "text": "Martensdale",
    "value": "martensdale"
  },
  {
    "text": "Martha",
    "value": "martha"
  },
  {
    "text": "Martha Lake",
    "value": "martha lake"
  },
  {
    "text": "Marthasville",
    "value": "marthasville"
  },
  {
    "text": "Marthaville",
    "value": "marthaville"
  },
  {
    "text": "Martin",
    "value": "martin"
  },
  {
    "text": "Martin City",
    "value": "martin city"
  },
  {
    "text": "Martindale",
    "value": "martindale"
  },
  {
    "text": "Martinez",
    "value": "martinez"
  },
  {
    "text": "Martins Creek",
    "value": "martins creek"
  },
  {
    "text": "Martins Ferry",
    "value": "martins ferry"
  },
  {
    "text": "Martinsburg",
    "value": "martinsburg"
  },
  {
    "text": "Martinsdale",
    "value": "martinsdale"
  },
  {
    "text": "Martinsville",
    "value": "martinsville"
  },
  {
    "text": "Martinton",
    "value": "martinton"
  },
  {
    "text": "Martville",
    "value": "martville"
  },
  {
    "text": "Marty",
    "value": "marty"
  },
  {
    "text": "Marvell",
    "value": "marvell"
  },
  {
    "text": "Marvin",
    "value": "marvin"
  },
  {
    "text": "Mary Esther",
    "value": "mary esther"
  },
  {
    "text": "Maryd",
    "value": "maryd"
  },
  {
    "text": "Marydel",
    "value": "marydel"
  },
  {
    "text": "Maryknoll",
    "value": "maryknoll"
  },
  {
    "text": "Maryland",
    "value": "maryland"
  },
  {
    "text": "Maryland Heights",
    "value": "maryland heights"
  },
  {
    "text": "Marylhurst",
    "value": "marylhurst"
  },
  {
    "text": "Maryneal",
    "value": "maryneal"
  },
  {
    "text": "Marysvale",
    "value": "marysvale"
  },
  {
    "text": "Marysville",
    "value": "marysville"
  },
  {
    "text": "Maryvale",
    "value": "maryvale"
  },
  {
    "text": "Maryville",
    "value": "maryville"
  },
  {
    "text": "Mascot",
    "value": "mascot"
  },
  {
    "text": "Mascotte",
    "value": "mascotte"
  },
  {
    "text": "Mascoutah",
    "value": "mascoutah"
  },
  {
    "text": "Mashantucket",
    "value": "mashantucket"
  },
  {
    "text": "Mashpee",
    "value": "mashpee"
  },
  {
    "text": "Mason",
    "value": "mason"
  },
  {
    "text": "Mason City",
    "value": "mason city"
  },
  {
    "text": "Masonboro",
    "value": "masonboro"
  },
  {
    "text": "Masonic Home",
    "value": "masonic home"
  },
  {
    "text": "Masontown",
    "value": "masontown"
  },
  {
    "text": "Masonville",
    "value": "masonville"
  },
  {
    "text": "Maspeth",
    "value": "maspeth"
  },
  {
    "text": "Mass City",
    "value": "mass city"
  },
  {
    "text": "Massapequa",
    "value": "massapequa"
  },
  {
    "text": "Massapequa Park",
    "value": "massapequa park"
  },
  {
    "text": "Massena",
    "value": "massena"
  },
  {
    "text": "Massey",
    "value": "massey"
  },
  {
    "text": "Massillon",
    "value": "massillon"
  },
  {
    "text": "Mastic",
    "value": "mastic"
  },
  {
    "text": "Mastic Beach",
    "value": "mastic beach"
  },
  {
    "text": "Masury",
    "value": "masury"
  },
  {
    "text": "Matador",
    "value": "matador"
  },
  {
    "text": "Matagorda",
    "value": "matagorda"
  },
  {
    "text": "Matamoras",
    "value": "matamoras"
  },
  {
    "text": "Matawan",
    "value": "matawan"
  },
  {
    "text": "Matewan",
    "value": "matewan"
  },
  {
    "text": "Matfield Green",
    "value": "matfield green"
  },
  {
    "text": "Mather",
    "value": "mather"
  },
  {
    "text": "Mather Field",
    "value": "mather field"
  },
  {
    "text": "Matheson",
    "value": "matheson"
  },
  {
    "text": "Mathews",
    "value": "mathews"
  },
  {
    "text": "Mathias",
    "value": "mathias"
  },
  {
    "text": "Mathis",
    "value": "mathis"
  },
  {
    "text": "Mathiston",
    "value": "mathiston"
  },
  {
    "text": "Matlock",
    "value": "matlock"
  },
  {
    "text": "Matoaka",
    "value": "matoaka"
  },
  {
    "text": "Mattapan",
    "value": "mattapan"
  },
  {
    "text": "Mattapoisett",
    "value": "mattapoisett"
  },
  {
    "text": "Mattaponi",
    "value": "mattaponi"
  },
  {
    "text": "Mattawa",
    "value": "mattawa"
  },
  {
    "text": "Mattawamkeag",
    "value": "mattawamkeag"
  },
  {
    "text": "Mattawan",
    "value": "mattawan"
  },
  {
    "text": "Mattawana",
    "value": "mattawana"
  },
  {
    "text": "Matteson",
    "value": "matteson"
  },
  {
    "text": "Matthews",
    "value": "matthews"
  },
  {
    "text": "Mattituck",
    "value": "mattituck"
  },
  {
    "text": "Mattoon",
    "value": "mattoon"
  },
  {
    "text": "Mattydale",
    "value": "mattydale"
  },
  {
    "text": "Mauckport",
    "value": "mauckport"
  },
  {
    "text": "Maud",
    "value": "maud"
  },
  {
    "text": "Mauk",
    "value": "mauk"
  },
  {
    "text": "Mauldin",
    "value": "mauldin"
  },
  {
    "text": "Maumee",
    "value": "maumee"
  },
  {
    "text": "Maumelle",
    "value": "maumelle"
  },
  {
    "text": "Maunaloa",
    "value": "maunaloa"
  },
  {
    "text": "Maupin",
    "value": "maupin"
  },
  {
    "text": "Maurepas",
    "value": "maurepas"
  },
  {
    "text": "Maurertown",
    "value": "maurertown"
  },
  {
    "text": "Maurice",
    "value": "maurice"
  },
  {
    "text": "Mauricetown",
    "value": "mauricetown"
  },
  {
    "text": "Mauriceville",
    "value": "mauriceville"
  },
  {
    "text": "Maury",
    "value": "maury"
  },
  {
    "text": "Maury City",
    "value": "maury city"
  },
  {
    "text": "Mauston",
    "value": "mauston"
  },
  {
    "text": "Max",
    "value": "max"
  },
  {
    "text": "Max Meadows",
    "value": "max meadows"
  },
  {
    "text": "Maxatawny",
    "value": "maxatawny"
  },
  {
    "text": "Maxbass",
    "value": "maxbass"
  },
  {
    "text": "Maximo",
    "value": "maximo"
  },
  {
    "text": "Maxton",
    "value": "maxton"
  },
  {
    "text": "Maxwell",
    "value": "maxwell"
  },
  {
    "text": "Maxwelton",
    "value": "maxwelton"
  },
  {
    "text": "May",
    "value": "may"
  },
  {
    "text": "Maybee",
    "value": "maybee"
  },
  {
    "text": "Maybrook",
    "value": "maybrook"
  },
  {
    "text": "Mayer",
    "value": "mayer"
  },
  {
    "text": "Mayersville",
    "value": "mayersville"
  },
  {
    "text": "Mayesville",
    "value": "mayesville"
  },
  {
    "text": "Mayetta",
    "value": "mayetta"
  },
  {
    "text": "Mayfield",
    "value": "mayfield"
  },
  {
    "text": "Mayfield Heights",
    "value": "mayfield heights"
  },
  {
    "text": "Mayflower",
    "value": "mayflower"
  },
  {
    "text": "Mayflower Village",
    "value": "mayflower village"
  },
  {
    "text": "Mayhill",
    "value": "mayhill"
  },
  {
    "text": "Mayking",
    "value": "mayking"
  },
  {
    "text": "Maylene",
    "value": "maylene"
  },
  {
    "text": "Maynard",
    "value": "maynard"
  },
  {
    "text": "Maynardville",
    "value": "maynardville"
  },
  {
    "text": "Mayo",
    "value": "mayo"
  },
  {
    "text": "Mayodan",
    "value": "mayodan"
  },
  {
    "text": "Maypearl",
    "value": "maypearl"
  },
  {
    "text": "Mayport",
    "value": "mayport"
  },
  {
    "text": "Mays",
    "value": "mays"
  },
  {
    "text": "Mays Landing",
    "value": "mays landing"
  },
  {
    "text": "Mays Lick",
    "value": "mays lick"
  },
  {
    "text": "Maysel",
    "value": "maysel"
  },
  {
    "text": "Mayslick",
    "value": "mayslick"
  },
  {
    "text": "Maysville",
    "value": "maysville"
  },
  {
    "text": "Maytown",
    "value": "maytown"
  },
  {
    "text": "Mayview",
    "value": "mayview"
  },
  {
    "text": "Mayville",
    "value": "mayville"
  },
  {
    "text": "Maywood",
    "value": "maywood"
  },
  {
    "text": "Mazeppa",
    "value": "mazeppa"
  },
  {
    "text": "Mazomanie",
    "value": "mazomanie"
  },
  {
    "text": "Mazon",
    "value": "mazon"
  },
  {
    "text": "Mc Alpin",
    "value": "mc alpin"
  },
  {
    "text": "Mc Kittrick",
    "value": "mc kittrick"
  },
  {
    "text": "McAdenville",
    "value": "mcadenville"
  },
  {
    "text": "McAdoo",
    "value": "mcadoo"
  },
  {
    "text": "McAfee",
    "value": "mcafee"
  },
  {
    "text": "McAlester",
    "value": "mcalester"
  },
  {
    "text": "McAlister",
    "value": "mcalister"
  },
  {
    "text": "McAlisterville",
    "value": "mcalisterville"
  },
  {
    "text": "McAllen",
    "value": "mcallen"
  },
  {
    "text": "McAllister",
    "value": "mcallister"
  },
  {
    "text": "McAlpin",
    "value": "mcalpin"
  },
  {
    "text": "McAndrews",
    "value": "mcandrews"
  },
  {
    "text": "McArthur",
    "value": "mcarthur"
  },
  {
    "text": "McBain",
    "value": "mcbain"
  },
  {
    "text": "McBee",
    "value": "mcbee"
  },
  {
    "text": "McBride",
    "value": "mcbride"
  },
  {
    "text": "McCall",
    "value": "mccall"
  },
  {
    "text": "McCall Creek",
    "value": "mccall creek"
  },
  {
    "text": "McCalla",
    "value": "mccalla"
  },
  {
    "text": "McCallsburg",
    "value": "mccallsburg"
  },
  {
    "text": "McCamey",
    "value": "mccamey"
  },
  {
    "text": "McCammon",
    "value": "mccammon"
  },
  {
    "text": "McCanna",
    "value": "mccanna"
  },
  {
    "text": "McCarley",
    "value": "mccarley"
  },
  {
    "text": "McCarr",
    "value": "mccarr"
  },
  {
    "text": "McCarran",
    "value": "mccarran"
  },
  {
    "text": "McCaskill",
    "value": "mccaskill"
  },
  {
    "text": "McCaysville",
    "value": "mccaysville"
  },
  {
    "text": "McChord Air Force Base",
    "value": "mcchord air force base"
  },
  {
    "text": "McClave",
    "value": "mcclave"
  },
  {
    "text": "McCleary",
    "value": "mccleary"
  },
  {
    "text": "McClellan",
    "value": "mcclellan"
  },
  {
    "text": "McClellan Park",
    "value": "mcclellan park"
  },
  {
    "text": "McClelland",
    "value": "mcclelland"
  },
  {
    "text": "McClellandtown",
    "value": "mcclellandtown"
  },
  {
    "text": "McClellanville",
    "value": "mcclellanville"
  },
  {
    "text": "McCloud",
    "value": "mccloud"
  },
  {
    "text": "McClure",
    "value": "mcclure"
  },
  {
    "text": "McClusky",
    "value": "mcclusky"
  },
  {
    "text": "McColl",
    "value": "mccoll"
  },
  {
    "text": "McComb",
    "value": "mccomb"
  },
  {
    "text": "McConnell",
    "value": "mcconnell"
  },
  {
    "text": "McConnells",
    "value": "mcconnells"
  },
  {
    "text": "McConnellsburg",
    "value": "mcconnellsburg"
  },
  {
    "text": "McConnelsville",
    "value": "mcconnelsville"
  },
  {
    "text": "McCook",
    "value": "mccook"
  },
  {
    "text": "McCool",
    "value": "mccool"
  },
  {
    "text": "McCool Junction",
    "value": "mccool junction"
  },
  {
    "text": "McCordsville",
    "value": "mccordsville"
  },
  {
    "text": "McCormick",
    "value": "mccormick"
  },
  {
    "text": "McCoy",
    "value": "mccoy"
  },
  {
    "text": "McCracken",
    "value": "mccracken"
  },
  {
    "text": "McCrory",
    "value": "mccrory"
  },
  {
    "text": "McCune",
    "value": "mccune"
  },
  {
    "text": "McCurtain",
    "value": "mccurtain"
  },
  {
    "text": "McCutchenville",
    "value": "mccutchenville"
  },
  {
    "text": "McDade",
    "value": "mcdade"
  },
  {
    "text": "McDaniel",
    "value": "mcdaniel"
  },
  {
    "text": "McDaniels",
    "value": "mcdaniels"
  },
  {
    "text": "McDavid",
    "value": "mcdavid"
  },
  {
    "text": "McDermitt",
    "value": "mcdermitt"
  },
  {
    "text": "McDermott",
    "value": "mcdermott"
  },
  {
    "text": "McDonald",
    "value": "mcdonald"
  },
  {
    "text": "McDonough",
    "value": "mcdonough"
  },
  {
    "text": "McDowell",
    "value": "mcdowell"
  },
  {
    "text": "McElhattan",
    "value": "mcelhattan"
  },
  {
    "text": "McEwen",
    "value": "mcewen"
  },
  {
    "text": "McFall",
    "value": "mcfall"
  },
  {
    "text": "McFarland",
    "value": "mcfarland"
  },
  {
    "text": "McGaheysville",
    "value": "mcgaheysville"
  },
  {
    "text": "McGee",
    "value": "mcgee"
  },
  {
    "text": "McGehee",
    "value": "mcgehee"
  },
  {
    "text": "McGill",
    "value": "mcgill"
  },
  {
    "text": "McGrady",
    "value": "mcgrady"
  },
  {
    "text": "McGrann",
    "value": "mcgrann"
  },
  {
    "text": "McGrath",
    "value": "mcgrath"
  },
  {
    "text": "McGraw",
    "value": "mcgraw"
  },
  {
    "text": "McGraws",
    "value": "mcgraws"
  },
  {
    "text": "McGregor",
    "value": "mcgregor"
  },
  {
    "text": "McGuffey",
    "value": "mcguffey"
  },
  {
    "text": "McHenry",
    "value": "mchenry"
  },
  {
    "text": "McIndoe Falls",
    "value": "mcindoe falls"
  },
  {
    "text": "McIntire",
    "value": "mcintire"
  },
  {
    "text": "McIntosh",
    "value": "mcintosh"
  },
  {
    "text": "McIntyre",
    "value": "mcintyre"
  },
  {
    "text": "McKean",
    "value": "mckean"
  },
  {
    "text": "McKee",
    "value": "mckee"
  },
  {
    "text": "McKees Rocks",
    "value": "mckees rocks"
  },
  {
    "text": "McKeesport",
    "value": "mckeesport"
  },
  {
    "text": "McKenna",
    "value": "mckenna"
  },
  {
    "text": "McKenney",
    "value": "mckenney"
  },
  {
    "text": "McKenzie",
    "value": "mckenzie"
  },
  {
    "text": "McKinleyville",
    "value": "mckinleyville"
  },
  {
    "text": "McKinney",
    "value": "mckinney"
  },
  {
    "text": "McKittrick",
    "value": "mckittrick"
  },
  {
    "text": "McLain",
    "value": "mclain"
  },
  {
    "text": "McLaughlin",
    "value": "mclaughlin"
  },
  {
    "text": "McLean",
    "value": "mclean"
  },
  {
    "text": "McLeansboro",
    "value": "mcleansboro"
  },
  {
    "text": "McLeansville",
    "value": "mcleansville"
  },
  {
    "text": "McLemoresville",
    "value": "mclemoresville"
  },
  {
    "text": "McLendon-Chisholm",
    "value": "mclendon-chisholm"
  },
  {
    "text": "McLeod",
    "value": "mcleod"
  },
  {
    "text": "McLoud",
    "value": "mcloud"
  },
  {
    "text": "McLouth",
    "value": "mclouth"
  },
  {
    "text": "McMechen",
    "value": "mcmechen"
  },
  {
    "text": "McMillan",
    "value": "mcmillan"
  },
  {
    "text": "McMinnville",
    "value": "mcminnville"
  },
  {
    "text": "McMurray",
    "value": "mcmurray"
  },
  {
    "text": "McNabb",
    "value": "mcnabb"
  },
  {
    "text": "McNary",
    "value": "mcnary"
  },
  {
    "text": "McNeal",
    "value": "mcneal"
  },
  {
    "text": "McNeil",
    "value": "mcneil"
  },
  {
    "text": "McNeill",
    "value": "mcneill"
  },
  {
    "text": "McPherson",
    "value": "mcpherson"
  },
  {
    "text": "McQueeney",
    "value": "mcqueeney"
  },
  {
    "text": "McRae",
    "value": "mcrae"
  },
  {
    "text": "McRae-Helena",
    "value": "mcrae-helena"
  },
  {
    "text": "McRoberts",
    "value": "mcroberts"
  },
  {
    "text": "McSherrystown",
    "value": "mcsherrystown"
  },
  {
    "text": "McVeytown",
    "value": "mcveytown"
  },
  {
    "text": "McVille",
    "value": "mcville"
  },
  {
    "text": "Mead",
    "value": "mead"
  },
  {
    "text": "Meade",
    "value": "meade"
  },
  {
    "text": "Meadow",
    "value": "meadow"
  },
  {
    "text": "Meadow Bridge",
    "value": "meadow bridge"
  },
  {
    "text": "Meadow Creek",
    "value": "meadow creek"
  },
  {
    "text": "Meadow Grove",
    "value": "meadow grove"
  },
  {
    "text": "Meadow Lakes",
    "value": "meadow lakes"
  },
  {
    "text": "Meadow Lands",
    "value": "meadow lands"
  },
  {
    "text": "Meadow Valley",
    "value": "meadow valley"
  },
  {
    "text": "Meadow Vista",
    "value": "meadow vista"
  },
  {
    "text": "Meadowbrook",
    "value": "meadowbrook"
  },
  {
    "text": "Meadowlands",
    "value": "meadowlands"
  },
  {
    "text": "Meadows Place",
    "value": "meadows place"
  },
  {
    "text": "Meadows of Dan",
    "value": "meadows of dan"
  },
  {
    "text": "Meadowview",
    "value": "meadowview"
  },
  {
    "text": "Meads",
    "value": "meads"
  },
  {
    "text": "Meadview",
    "value": "meadview"
  },
  {
    "text": "Meadville",
    "value": "meadville"
  },
  {
    "text": "Meally",
    "value": "meally"
  },
  {
    "text": "Means",
    "value": "means"
  },
  {
    "text": "Meansville",
    "value": "meansville"
  },
  {
    "text": "Mears",
    "value": "mears"
  },
  {
    "text": "Mebane",
    "value": "mebane"
  },
  {
    "text": "Mecca",
    "value": "mecca"
  },
  {
    "text": "Mechanic Falls",
    "value": "mechanic falls"
  },
  {
    "text": "Mechanicsburg",
    "value": "mechanicsburg"
  },
  {
    "text": "Mechanicstown",
    "value": "mechanicstown"
  },
  {
    "text": "Mechanicsville",
    "value": "mechanicsville"
  },
  {
    "text": "Mechanicville",
    "value": "mechanicville"
  },
  {
    "text": "Mecosta",
    "value": "mecosta"
  },
  {
    "text": "Medanales",
    "value": "medanales"
  },
  {
    "text": "Medaryville",
    "value": "medaryville"
  },
  {
    "text": "Meddybemps",
    "value": "meddybemps"
  },
  {
    "text": "Medfield",
    "value": "medfield"
  },
  {
    "text": "Medford",
    "value": "medford"
  },
  {
    "text": "Medford Lakes",
    "value": "medford lakes"
  },
  {
    "text": "Media",
    "value": "media"
  },
  {
    "text": "Mediapolis",
    "value": "mediapolis"
  },
  {
    "text": "Medical Lake",
    "value": "medical lake"
  },
  {
    "text": "Medicine Bow",
    "value": "medicine bow"
  },
  {
    "text": "Medicine Lake",
    "value": "medicine lake"
  },
  {
    "text": "Medicine Lodge",
    "value": "medicine lodge"
  },
  {
    "text": "Medicine Park",
    "value": "medicine park"
  },
  {
    "text": "Medimont",
    "value": "medimont"
  },
  {
    "text": "Medina",
    "value": "medina"
  },
  {
    "text": "Medinah",
    "value": "medinah"
  },
  {
    "text": "Medley",
    "value": "medley"
  },
  {
    "text": "Medon",
    "value": "medon"
  },
  {
    "text": "Medora",
    "value": "medora"
  },
  {
    "text": "Medulla",
    "value": "medulla"
  },
  {
    "text": "Medusa",
    "value": "medusa"
  },
  {
    "text": "Medway",
    "value": "medway"
  },
  {
    "text": "Meeker",
    "value": "meeker"
  },
  {
    "text": "Meeteetse",
    "value": "meeteetse"
  },
  {
    "text": "Megargel",
    "value": "megargel"
  },
  {
    "text": "Meggett",
    "value": "meggett"
  },
  {
    "text": "Meherrin",
    "value": "meherrin"
  },
  {
    "text": "Mehlville",
    "value": "mehlville"
  },
  {
    "text": "Mehoopany",
    "value": "mehoopany"
  },
  {
    "text": "Meigs",
    "value": "meigs"
  },
  {
    "text": "Mekinock",
    "value": "mekinock"
  },
  {
    "text": "Mekoryuk",
    "value": "mekoryuk"
  },
  {
    "text": "Melba",
    "value": "melba"
  },
  {
    "text": "Melber",
    "value": "melber"
  },
  {
    "text": "Melbourne",
    "value": "melbourne"
  },
  {
    "text": "Melbourne Beach",
    "value": "melbourne beach"
  },
  {
    "text": "Melbourne Village",
    "value": "melbourne village"
  },
  {
    "text": "Melcher-Dallas",
    "value": "melcher-dallas"
  },
  {
    "text": "Melcroft",
    "value": "melcroft"
  },
  {
    "text": "Melfa",
    "value": "melfa"
  },
  {
    "text": "Melissa",
    "value": "melissa"
  },
  {
    "text": "Mellen",
    "value": "mellen"
  },
  {
    "text": "Mellette",
    "value": "mellette"
  },
  {
    "text": "Mellott",
    "value": "mellott"
  },
  {
    "text": "Melrose",
    "value": "melrose"
  },
  {
    "text": "Melrose Park",
    "value": "melrose park"
  },
  {
    "text": "Melstone",
    "value": "melstone"
  },
  {
    "text": "Melvern",
    "value": "melvern"
  },
  {
    "text": "Melville",
    "value": "melville"
  },
  {
    "text": "Melvin",
    "value": "melvin"
  },
  {
    "text": "Melvin Village",
    "value": "melvin village"
  },
  {
    "text": "Melvindale",
    "value": "melvindale"
  },
  {
    "text": "Memphis",
    "value": "memphis"
  },
  {
    "text": "Mena",
    "value": "mena"
  },
  {
    "text": "Menahga",
    "value": "menahga"
  },
  {
    "text": "Menan",
    "value": "menan"
  },
  {
    "text": "Menands",
    "value": "menands"
  },
  {
    "text": "Menard",
    "value": "menard"
  },
  {
    "text": "Menasha",
    "value": "menasha"
  },
  {
    "text": "Mendenhall",
    "value": "mendenhall"
  },
  {
    "text": "Mendham",
    "value": "mendham"
  },
  {
    "text": "Mendocino",
    "value": "mendocino"
  },
  {
    "text": "Mendocino City",
    "value": "mendocino city"
  },
  {
    "text": "Mendon",
    "value": "mendon"
  },
  {
    "text": "Mendota",
    "value": "mendota"
  },
  {
    "text": "Mendota Heights",
    "value": "mendota heights"
  },
  {
    "text": "Menifee",
    "value": "menifee"
  },
  {
    "text": "Menlo",
    "value": "menlo"
  },
  {
    "text": "Menlo Park",
    "value": "menlo park"
  },
  {
    "text": "Menno",
    "value": "menno"
  },
  {
    "text": "Meno",
    "value": "meno"
  },
  {
    "text": "Menoken",
    "value": "menoken"
  },
  {
    "text": "Menominee",
    "value": "menominee"
  },
  {
    "text": "Menomonee Falls",
    "value": "menomonee falls"
  },
  {
    "text": "Menomonie",
    "value": "menomonie"
  },
  {
    "text": "Mentmore",
    "value": "mentmore"
  },
  {
    "text": "Mentone",
    "value": "mentone"
  },
  {
    "text": "Mentor",
    "value": "mentor"
  },
  {
    "text": "Mequon",
    "value": "mequon"
  },
  {
    "text": "Mer Rouge",
    "value": "mer rouge"
  },
  {
    "text": "Meraux",
    "value": "meraux"
  },
  {
    "text": "Merced",
    "value": "merced"
  },
  {
    "text": "Mercedes",
    "value": "mercedes"
  },
  {
    "text": "Mercer",
    "value": "mercer"
  },
  {
    "text": "Mercer Island",
    "value": "mercer island"
  },
  {
    "text": "Mercersburg",
    "value": "mercersburg"
  },
  {
    "text": "Mercerville",
    "value": "mercerville"
  },
  {
    "text": "Merchantville",
    "value": "merchantville"
  },
  {
    "text": "Meredith",
    "value": "meredith"
  },
  {
    "text": "Meredithville",
    "value": "meredithville"
  },
  {
    "text": "Meredosia",
    "value": "meredosia"
  },
  {
    "text": "Mereta",
    "value": "mereta"
  },
  {
    "text": "Meriden",
    "value": "meriden"
  },
  {
    "text": "Meridian",
    "value": "meridian"
  },
  {
    "text": "Meridian Hills",
    "value": "meridian hills"
  },
  {
    "text": "Meridianville",
    "value": "meridianville"
  },
  {
    "text": "Merigold",
    "value": "merigold"
  },
  {
    "text": "Merino",
    "value": "merino"
  },
  {
    "text": "Merion",
    "value": "merion"
  },
  {
    "text": "Merion Station",
    "value": "merion station"
  },
  {
    "text": "Merkel",
    "value": "merkel"
  },
  {
    "text": "Merlin",
    "value": "merlin"
  },
  {
    "text": "Merna",
    "value": "merna"
  },
  {
    "text": "Merom",
    "value": "merom"
  },
  {
    "text": "Merriam",
    "value": "merriam"
  },
  {
    "text": "Merrick",
    "value": "merrick"
  },
  {
    "text": "Merrifield",
    "value": "merrifield"
  },
  {
    "text": "Merrill",
    "value": "merrill"
  },
  {
    "text": "Merrillan",
    "value": "merrillan"
  },
  {
    "text": "Merrillville",
    "value": "merrillville"
  },
  {
    "text": "Merrimac",
    "value": "merrimac"
  },
  {
    "text": "Merrimack",
    "value": "merrimack"
  },
  {
    "text": "Merriman",
    "value": "merriman"
  },
  {
    "text": "Merrionette Park",
    "value": "merrionette park"
  },
  {
    "text": "Merritt",
    "value": "merritt"
  },
  {
    "text": "Merritt Island",
    "value": "merritt island"
  },
  {
    "text": "Merry Hill",
    "value": "merry hill"
  },
  {
    "text": "Merry Point",
    "value": "merry point"
  },
  {
    "text": "Merryville",
    "value": "merryville"
  },
  {
    "text": "Mershon",
    "value": "mershon"
  },
  {
    "text": "Mertens",
    "value": "mertens"
  },
  {
    "text": "Merton",
    "value": "merton"
  },
  {
    "text": "Mertzon",
    "value": "mertzon"
  },
  {
    "text": "Mertztown",
    "value": "mertztown"
  },
  {
    "text": "Mesa",
    "value": "mesa"
  },
  {
    "text": "Mesa Verde",
    "value": "mesa verde"
  },
  {
    "text": "Mesa Verde National Park",
    "value": "mesa verde national park"
  },
  {
    "text": "Mescal",
    "value": "mescal"
  },
  {
    "text": "Mescalero",
    "value": "mescalero"
  },
  {
    "text": "Meshoppen",
    "value": "meshoppen"
  },
  {
    "text": "Mesick",
    "value": "mesick"
  },
  {
    "text": "Mesilla",
    "value": "mesilla"
  },
  {
    "text": "Mesilla Park",
    "value": "mesilla park"
  },
  {
    "text": "Mesopotamia",
    "value": "mesopotamia"
  },
  {
    "text": "Mesquite",
    "value": "mesquite"
  },
  {
    "text": "Meta",
    "value": "meta"
  },
  {
    "text": "Metairie",
    "value": "metairie"
  },
  {
    "text": "Metaline",
    "value": "metaline"
  },
  {
    "text": "Metaline Falls",
    "value": "metaline falls"
  },
  {
    "text": "Metamora",
    "value": "metamora"
  },
  {
    "text": "Metcalf",
    "value": "metcalf"
  },
  {
    "text": "Metcalfe",
    "value": "metcalfe"
  },
  {
    "text": "Methuen",
    "value": "methuen"
  },
  {
    "text": "Metlakatla",
    "value": "metlakatla"
  },
  {
    "text": "Metropolis",
    "value": "metropolis"
  },
  {
    "text": "Mettawa",
    "value": "mettawa"
  },
  {
    "text": "Metter",
    "value": "metter"
  },
  {
    "text": "Mettler",
    "value": "mettler"
  },
  {
    "text": "Metuchen",
    "value": "metuchen"
  },
  {
    "text": "Metz",
    "value": "metz"
  },
  {
    "text": "Mexia",
    "value": "mexia"
  },
  {
    "text": "Mexico",
    "value": "mexico"
  },
  {
    "text": "Mexico Beach",
    "value": "mexico beach"
  },
  {
    "text": "Meyersdale",
    "value": "meyersdale"
  },
  {
    "text": "Meyersville",
    "value": "meyersville"
  },
  {
    "text": "Mi-Wuk Village",
    "value": "mi-wuk village"
  },
  {
    "text": "Miami",
    "value": "miami"
  },
  {
    "text": "Miami Beach",
    "value": "miami beach"
  },
  {
    "text": "Miami Gardens",
    "value": "miami gardens"
  },
  {
    "text": "Miami Lakes",
    "value": "miami lakes"
  },
  {
    "text": "Miami Shores",
    "value": "miami shores"
  },
  {
    "text": "Miami Springs",
    "value": "miami springs"
  },
  {
    "text": "Miamisburg",
    "value": "miamisburg"
  },
  {
    "text": "Miamitown",
    "value": "miamitown"
  },
  {
    "text": "Miamiville",
    "value": "miamiville"
  },
  {
    "text": "Mica",
    "value": "mica"
  },
  {
    "text": "Micanopy",
    "value": "micanopy"
  },
  {
    "text": "Micco",
    "value": "micco"
  },
  {
    "text": "Michael",
    "value": "michael"
  },
  {
    "text": "Michie",
    "value": "michie"
  },
  {
    "text": "Michigamme",
    "value": "michigamme"
  },
  {
    "text": "Michigan",
    "value": "michigan"
  },
  {
    "text": "Michigan Center",
    "value": "michigan center"
  },
  {
    "text": "Michigan City",
    "value": "michigan city"
  },
  {
    "text": "Michigantown",
    "value": "michigantown"
  },
  {
    "text": "Mickleton",
    "value": "mickleton"
  },
  {
    "text": "Mico",
    "value": "mico"
  },
  {
    "text": "Micro",
    "value": "micro"
  },
  {
    "text": "Middle Bass",
    "value": "middle bass"
  },
  {
    "text": "Middle Granville",
    "value": "middle granville"
  },
  {
    "text": "Middle Grove",
    "value": "middle grove"
  },
  {
    "text": "Middle Haddam",
    "value": "middle haddam"
  },
  {
    "text": "Middle Island",
    "value": "middle island"
  },
  {
    "text": "Middle Point",
    "value": "middle point"
  },
  {
    "text": "Middle River",
    "value": "middle river"
  },
  {
    "text": "Middle Valley",
    "value": "middle valley"
  },
  {
    "text": "Middle Village",
    "value": "middle village"
  },
  {
    "text": "Middleboro",
    "value": "middleboro"
  },
  {
    "text": "Middleborough",
    "value": "middleborough"
  },
  {
    "text": "Middlebourne",
    "value": "middlebourne"
  },
  {
    "text": "Middlebrook",
    "value": "middlebrook"
  },
  {
    "text": "Middleburg",
    "value": "middleburg"
  },
  {
    "text": "Middleburg Heights",
    "value": "middleburg heights"
  },
  {
    "text": "Middleburgh",
    "value": "middleburgh"
  },
  {
    "text": "Middlebury",
    "value": "middlebury"
  },
  {
    "text": "Middlebury (village)",
    "value": "middlebury (village)"
  },
  {
    "text": "Middlebury Center",
    "value": "middlebury center"
  },
  {
    "text": "Middlebush",
    "value": "middlebush"
  },
  {
    "text": "Middlefield",
    "value": "middlefield"
  },
  {
    "text": "Middleport",
    "value": "middleport"
  },
  {
    "text": "Middlesboro",
    "value": "middlesboro"
  },
  {
    "text": "Middlesex",
    "value": "middlesex"
  },
  {
    "text": "Middleton",
    "value": "middleton"
  },
  {
    "text": "Middleton Corners",
    "value": "middleton corners"
  },
  {
    "text": "Middletown",
    "value": "middletown"
  },
  {
    "text": "Middletown Springs",
    "value": "middletown springs"
  },
  {
    "text": "Middleville",
    "value": "middleville"
  },
  {
    "text": "Midfield",
    "value": "midfield"
  },
  {
    "text": "Midkiff",
    "value": "midkiff"
  },
  {
    "text": "Midland",
    "value": "midland"
  },
  {
    "text": "Midland City",
    "value": "midland city"
  },
  {
    "text": "Midland Park",
    "value": "midland park"
  },
  {
    "text": "Midlothian",
    "value": "midlothian"
  },
  {
    "text": "Midpines",
    "value": "midpines"
  },
  {
    "text": "Midvale",
    "value": "midvale"
  },
  {
    "text": "Midville",
    "value": "midville"
  },
  {
    "text": "Midway",
    "value": "midway"
  },
  {
    "text": "Midway City",
    "value": "midway city"
  },
  {
    "text": "Midway Park",
    "value": "midway park"
  },
  {
    "text": "Midwest",
    "value": "midwest"
  },
  {
    "text": "Midwest City",
    "value": "midwest city"
  },
  {
    "text": "Mifflin",
    "value": "mifflin"
  },
  {
    "text": "Mifflinburg",
    "value": "mifflinburg"
  },
  {
    "text": "Mifflintown",
    "value": "mifflintown"
  },
  {
    "text": "Mifflinville",
    "value": "mifflinville"
  },
  {
    "text": "Mikado",
    "value": "mikado"
  },
  {
    "text": "Mikana",
    "value": "mikana"
  },
  {
    "text": "Milaca",
    "value": "milaca"
  },
  {
    "text": "Milam",
    "value": "milam"
  },
  {
    "text": "Milan",
    "value": "milan"
  },
  {
    "text": "Milano",
    "value": "milano"
  },
  {
    "text": "Milanville",
    "value": "milanville"
  },
  {
    "text": "Milbank",
    "value": "milbank"
  },
  {
    "text": "Milbridge",
    "value": "milbridge"
  },
  {
    "text": "Milburn",
    "value": "milburn"
  },
  {
    "text": "Mildred",
    "value": "mildred"
  },
  {
    "text": "Miles",
    "value": "miles"
  },
  {
    "text": "Miles City",
    "value": "miles city"
  },
  {
    "text": "Milesburg",
    "value": "milesburg"
  },
  {
    "text": "Milesville",
    "value": "milesville"
  },
  {
    "text": "Miley",
    "value": "miley"
  },
  {
    "text": "Milfay",
    "value": "milfay"
  },
  {
    "text": "Milford",
    "value": "milford"
  },
  {
    "text": "Milford Center",
    "value": "milford center"
  },
  {
    "text": "Milford Mill",
    "value": "milford mill"
  },
  {
    "text": "Mililani",
    "value": "mililani"
  },
  {
    "text": "Mililani Town",
    "value": "mililani town"
  },
  {
    "text": "Mill City",
    "value": "mill city"
  },
  {
    "text": "Mill Creek",
    "value": "mill creek"
  },
  {
    "text": "Mill Hall",
    "value": "mill hall"
  },
  {
    "text": "Mill Neck",
    "value": "mill neck"
  },
  {
    "text": "Mill Run",
    "value": "mill run"
  },
  {
    "text": "Mill Shoals",
    "value": "mill shoals"
  },
  {
    "text": "Mill Spring",
    "value": "mill spring"
  },
  {
    "text": "Mill Valley",
    "value": "mill valley"
  },
  {
    "text": "Milladore",
    "value": "milladore"
  },
  {
    "text": "Millboro",
    "value": "millboro"
  },
  {
    "text": "Millbrae",
    "value": "millbrae"
  },
  {
    "text": "Millbrook",
    "value": "millbrook"
  },
  {
    "text": "Millburn",
    "value": "millburn"
  },
  {
    "text": "Millbury",
    "value": "millbury"
  },
  {
    "text": "Millcreek",
    "value": "millcreek"
  },
  {
    "text": "Milldale",
    "value": "milldale"
  },
  {
    "text": "Milledgeville",
    "value": "milledgeville"
  },
  {
    "text": "Millen",
    "value": "millen"
  },
  {
    "text": "Miller",
    "value": "miller"
  },
  {
    "text": "Miller City",
    "value": "miller city"
  },
  {
    "text": "Miller Place",
    "value": "miller place"
  },
  {
    "text": "Millers",
    "value": "millers"
  },
  {
    "text": "Millers Creek",
    "value": "millers creek"
  },
  {
    "text": "Millers Falls",
    "value": "millers falls"
  },
  {
    "text": "Millers Tavern",
    "value": "millers tavern"
  },
  {
    "text": "Millersburg",
    "value": "millersburg"
  },
  {
    "text": "Millersport",
    "value": "millersport"
  },
  {
    "text": "Millerstown",
    "value": "millerstown"
  },
  {
    "text": "Millersview",
    "value": "millersview"
  },
  {
    "text": "Millersville",
    "value": "millersville"
  },
  {
    "text": "Millerton",
    "value": "millerton"
  },
  {
    "text": "Millerville",
    "value": "millerville"
  },
  {
    "text": "Millfield",
    "value": "millfield"
  },
  {
    "text": "Millheim",
    "value": "millheim"
  },
  {
    "text": "Millican",
    "value": "millican"
  },
  {
    "text": "Milligan",
    "value": "milligan"
  },
  {
    "text": "Milligan College",
    "value": "milligan college"
  },
  {
    "text": "Milliken",
    "value": "milliken"
  },
  {
    "text": "Millington",
    "value": "millington"
  },
  {
    "text": "Millinocket",
    "value": "millinocket"
  },
  {
    "text": "Millis",
    "value": "millis"
  },
  {
    "text": "Millmont",
    "value": "millmont"
  },
  {
    "text": "Millport",
    "value": "millport"
  },
  {
    "text": "Millry",
    "value": "millry"
  },
  {
    "text": "Mills",
    "value": "mills"
  },
  {
    "text": "Mills River",
    "value": "mills river"
  },
  {
    "text": "Millsap",
    "value": "millsap"
  },
  {
    "text": "Millsboro",
    "value": "millsboro"
  },
  {
    "text": "Millstadt",
    "value": "millstadt"
  },
  {
    "text": "Millston",
    "value": "millston"
  },
  {
    "text": "Millstone",
    "value": "millstone"
  },
  {
    "text": "Milltown",
    "value": "milltown"
  },
  {
    "text": "Millvale",
    "value": "millvale"
  },
  {
    "text": "Millville",
    "value": "millville"
  },
  {
    "text": "Millwood",
    "value": "millwood"
  },
  {
    "text": "Milmay",
    "value": "milmay"
  },
  {
    "text": "Milmine",
    "value": "milmine"
  },
  {
    "text": "Milner",
    "value": "milner"
  },
  {
    "text": "Milnesville",
    "value": "milnesville"
  },
  {
    "text": "Milnor",
    "value": "milnor"
  },
  {
    "text": "Milo",
    "value": "milo"
  },
  {
    "text": "Milpitas",
    "value": "milpitas"
  },
  {
    "text": "Milroy",
    "value": "milroy"
  },
  {
    "text": "Milton",
    "value": "milton"
  },
  {
    "text": "Milton Mills",
    "value": "milton mills"
  },
  {
    "text": "Milton-Freewater",
    "value": "milton-freewater"
  },
  {
    "text": "Miltona",
    "value": "miltona"
  },
  {
    "text": "Miltonvale",
    "value": "miltonvale"
  },
  {
    "text": "Milwaukee",
    "value": "milwaukee"
  },
  {
    "text": "Milwaukie",
    "value": "milwaukie"
  },
  {
    "text": "Mims",
    "value": "mims"
  },
  {
    "text": "Mina",
    "value": "mina"
  },
  {
    "text": "Minatare",
    "value": "minatare"
  },
  {
    "text": "Minburn",
    "value": "minburn"
  },
  {
    "text": "Minco",
    "value": "minco"
  },
  {
    "text": "Minden",
    "value": "minden"
  },
  {
    "text": "Minden City",
    "value": "minden city"
  },
  {
    "text": "Mindenmines",
    "value": "mindenmines"
  },
  {
    "text": "Mindoro",
    "value": "mindoro"
  },
  {
    "text": "Mine Hill",
    "value": "mine hill"
  },
  {
    "text": "Mineola",
    "value": "mineola"
  },
  {
    "text": "Mineral",
    "value": "mineral"
  },
  {
    "text": "Mineral Bluff",
    "value": "mineral bluff"
  },
  {
    "text": "Mineral City",
    "value": "mineral city"
  },
  {
    "text": "Mineral Point",
    "value": "mineral point"
  },
  {
    "text": "Mineral Ridge",
    "value": "mineral ridge"
  },
  {
    "text": "Mineral Springs",
    "value": "mineral springs"
  },
  {
    "text": "Mineral Wells",
    "value": "mineral wells"
  },
  {
    "text": "Minersville",
    "value": "minersville"
  },
  {
    "text": "Minerva",
    "value": "minerva"
  },
  {
    "text": "Minetto",
    "value": "minetto"
  },
  {
    "text": "Mineville",
    "value": "mineville"
  },
  {
    "text": "Minford",
    "value": "minford"
  },
  {
    "text": "Mingo",
    "value": "mingo"
  },
  {
    "text": "Mingo Junction",
    "value": "mingo junction"
  },
  {
    "text": "Mingoville",
    "value": "mingoville"
  },
  {
    "text": "Mingus",
    "value": "mingus"
  },
  {
    "text": "Minidoka",
    "value": "minidoka"
  },
  {
    "text": "Minier",
    "value": "minier"
  },
  {
    "text": "Minisink Hills",
    "value": "minisink hills"
  },
  {
    "text": "Minneapolis",
    "value": "minneapolis"
  },
  {
    "text": "Minneola",
    "value": "minneola"
  },
  {
    "text": "Minneota",
    "value": "minneota"
  },
  {
    "text": "Minnesota City",
    "value": "minnesota city"
  },
  {
    "text": "Minnesota Lake",
    "value": "minnesota lake"
  },
  {
    "text": "Minnetonka",
    "value": "minnetonka"
  },
  {
    "text": "Minnetonka Beach",
    "value": "minnetonka beach"
  },
  {
    "text": "Minnetonka Mills",
    "value": "minnetonka mills"
  },
  {
    "text": "Minnetrista",
    "value": "minnetrista"
  },
  {
    "text": "Minnewaukan",
    "value": "minnewaukan"
  },
  {
    "text": "Minnie",
    "value": "minnie"
  },
  {
    "text": "Minoa",
    "value": "minoa"
  },
  {
    "text": "Minocqua",
    "value": "minocqua"
  },
  {
    "text": "Minong",
    "value": "minong"
  },
  {
    "text": "Minonk",
    "value": "minonk"
  },
  {
    "text": "Minooka",
    "value": "minooka"
  },
  {
    "text": "Minor Hill",
    "value": "minor hill"
  },
  {
    "text": "Minot",
    "value": "minot"
  },
  {
    "text": "Minot Air Force Base",
    "value": "minot air force base"
  },
  {
    "text": "Minotola",
    "value": "minotola"
  },
  {
    "text": "Minster",
    "value": "minster"
  },
  {
    "text": "Mint Hill",
    "value": "mint hill"
  },
  {
    "text": "Minter",
    "value": "minter"
  },
  {
    "text": "Minter City",
    "value": "minter city"
  },
  {
    "text": "Minto",
    "value": "minto"
  },
  {
    "text": "Minturn",
    "value": "minturn"
  },
  {
    "text": "Mio",
    "value": "mio"
  },
  {
    "text": "Mira Loma",
    "value": "mira loma"
  },
  {
    "text": "Miracle",
    "value": "miracle"
  },
  {
    "text": "Miramar",
    "value": "miramar"
  },
  {
    "text": "Miramar Beach",
    "value": "miramar beach"
  },
  {
    "text": "Miramonte",
    "value": "miramonte"
  },
  {
    "text": "Miranda",
    "value": "miranda"
  },
  {
    "text": "Mirando City",
    "value": "mirando city"
  },
  {
    "text": "Mirror Lake",
    "value": "mirror lake"
  },
  {
    "text": "Misenheimer",
    "value": "misenheimer"
  },
  {
    "text": "Mishawaka",
    "value": "mishawaka"
  },
  {
    "text": "Mishicot",
    "value": "mishicot"
  },
  {
    "text": "Mission",
    "value": "mission"
  },
  {
    "text": "Mission Hill",
    "value": "mission hill"
  },
  {
    "text": "Mission Hills",
    "value": "mission hills"
  },
  {
    "text": "Mission Viejo",
    "value": "mission viejo"
  },
  {
    "text": "Mississippi State",
    "value": "mississippi state"
  },
  {
    "text": "Missoula",
    "value": "missoula"
  },
  {
    "text": "Missouri City",
    "value": "missouri city"
  },
  {
    "text": "Missouri Valley",
    "value": "missouri valley"
  },
  {
    "text": "Mistletoe",
    "value": "mistletoe"
  },
  {
    "text": "Mitchell",
    "value": "mitchell"
  },
  {
    "text": "Mitchells",
    "value": "mitchells"
  },
  {
    "text": "Mitchellville",
    "value": "mitchellville"
  },
  {
    "text": "Mittie",
    "value": "mittie"
  },
  {
    "text": "Mize",
    "value": "mize"
  },
  {
    "text": "Mizpah",
    "value": "mizpah"
  },
  {
    "text": "Moab",
    "value": "moab"
  },
  {
    "text": "Moapa",
    "value": "moapa"
  },
  {
    "text": "Moatsville",
    "value": "moatsville"
  },
  {
    "text": "Mobeetie",
    "value": "mobeetie"
  },
  {
    "text": "Moberly",
    "value": "moberly"
  },
  {
    "text": "Mobile",
    "value": "mobile"
  },
  {
    "text": "Mobridge",
    "value": "mobridge"
  },
  {
    "text": "Moccasin",
    "value": "moccasin"
  },
  {
    "text": "Mocksville",
    "value": "mocksville"
  },
  {
    "text": "Modale",
    "value": "modale"
  },
  {
    "text": "Mode",
    "value": "mode"
  },
  {
    "text": "Model",
    "value": "model"
  },
  {
    "text": "Model City",
    "value": "model city"
  },
  {
    "text": "Modena",
    "value": "modena"
  },
  {
    "text": "Modesto",
    "value": "modesto"
  },
  {
    "text": "Modoc",
    "value": "modoc"
  },
  {
    "text": "Moffat",
    "value": "moffat"
  },
  {
    "text": "Moffett",
    "value": "moffett"
  },
  {
    "text": "Mogadore",
    "value": "mogadore"
  },
  {
    "text": "Mohall",
    "value": "mohall"
  },
  {
    "text": "Mohave Valley",
    "value": "mohave valley"
  },
  {
    "text": "Mohawk",
    "value": "mohawk"
  },
  {
    "text": "Mohegan Lake",
    "value": "mohegan lake"
  },
  {
    "text": "Mohler",
    "value": "mohler"
  },
  {
    "text": "Mohnton",
    "value": "mohnton"
  },
  {
    "text": "Mohrsville",
    "value": "mohrsville"
  },
  {
    "text": "Mojave",
    "value": "mojave"
  },
  {
    "text": "Mokane",
    "value": "mokane"
  },
  {
    "text": "Mokelumne Hill",
    "value": "mokelumne hill"
  },
  {
    "text": "Mokena",
    "value": "mokena"
  },
  {
    "text": "Molalla",
    "value": "molalla"
  },
  {
    "text": "Molena",
    "value": "molena"
  },
  {
    "text": "Molina",
    "value": "molina"
  },
  {
    "text": "Moline",
    "value": "moline"
  },
  {
    "text": "Molino",
    "value": "molino"
  },
  {
    "text": "Molt",
    "value": "molt"
  },
  {
    "text": "Momence",
    "value": "momence"
  },
  {
    "text": "Mona",
    "value": "mona"
  },
  {
    "text": "Monaca",
    "value": "monaca"
  },
  {
    "text": "Monahans",
    "value": "monahans"
  },
  {
    "text": "Monarch",
    "value": "monarch"
  },
  {
    "text": "Monaville",
    "value": "monaville"
  },
  {
    "text": "Moncks Corner",
    "value": "moncks corner"
  },
  {
    "text": "Monclova",
    "value": "monclova"
  },
  {
    "text": "Moncure",
    "value": "moncure"
  },
  {
    "text": "Mondamin",
    "value": "mondamin"
  },
  {
    "text": "Mondovi",
    "value": "mondovi"
  },
  {
    "text": "Monee",
    "value": "monee"
  },
  {
    "text": "Monessen",
    "value": "monessen"
  },
  {
    "text": "Moneta",
    "value": "moneta"
  },
  {
    "text": "Monett",
    "value": "monett"
  },
  {
    "text": "Monetta",
    "value": "monetta"
  },
  {
    "text": "Monette",
    "value": "monette"
  },
  {
    "text": "Money",
    "value": "money"
  },
  {
    "text": "Mongaup Valley",
    "value": "mongaup valley"
  },
  {
    "text": "Monhegan",
    "value": "monhegan"
  },
  {
    "text": "Monitor",
    "value": "monitor"
  },
  {
    "text": "Monkton",
    "value": "monkton"
  },
  {
    "text": "Monmouth",
    "value": "monmouth"
  },
  {
    "text": "Monmouth Beach",
    "value": "monmouth beach"
  },
  {
    "text": "Monmouth Junction",
    "value": "monmouth junction"
  },
  {
    "text": "Mono Vista",
    "value": "mono vista"
  },
  {
    "text": "Monon",
    "value": "monon"
  },
  {
    "text": "Monona",
    "value": "monona"
  },
  {
    "text": "Monongah",
    "value": "monongah"
  },
  {
    "text": "Monongahela",
    "value": "monongahela"
  },
  {
    "text": "Monroe",
    "value": "monroe"
  },
  {
    "text": "Monroe Bridge",
    "value": "monroe bridge"
  },
  {
    "text": "Monroe Center",
    "value": "monroe center"
  },
  {
    "text": "Monroe City",
    "value": "monroe city"
  },
  {
    "text": "Monroeton",
    "value": "monroeton"
  },
  {
    "text": "Monroeville",
    "value": "monroeville"
  },
  {
    "text": "Monrovia",
    "value": "monrovia"
  },
  {
    "text": "Monsey",
    "value": "monsey"
  },
  {
    "text": "Monson",
    "value": "monson"
  },
  {
    "text": "Mont Alto",
    "value": "mont alto"
  },
  {
    "text": "Mont Belvieu",
    "value": "mont belvieu"
  },
  {
    "text": "Mont Clare",
    "value": "mont clare"
  },
  {
    "text": "Mont Vernon",
    "value": "mont vernon"
  },
  {
    "text": "Montague",
    "value": "montague"
  },
  {
    "text": "Montalba",
    "value": "montalba"
  },
  {
    "text": "Montana City",
    "value": "montana city"
  },
  {
    "text": "Montandon",
    "value": "montandon"
  },
  {
    "text": "Montara",
    "value": "montara"
  },
  {
    "text": "Montauk",
    "value": "montauk"
  },
  {
    "text": "Montcalm",
    "value": "montcalm"
  },
  {
    "text": "Montchanin",
    "value": "montchanin"
  },
  {
    "text": "Montclair",
    "value": "montclair"
  },
  {
    "text": "Monte Rio",
    "value": "monte rio"
  },
  {
    "text": "Monte Sereno",
    "value": "monte sereno"
  },
  {
    "text": "Monte Vista",
    "value": "monte vista"
  },
  {
    "text": "Monteagle",
    "value": "monteagle"
  },
  {
    "text": "Montebello",
    "value": "montebello"
  },
  {
    "text": "Montecito",
    "value": "montecito"
  },
  {
    "text": "Montegut",
    "value": "montegut"
  },
  {
    "text": "Montello",
    "value": "montello"
  },
  {
    "text": "Monterey",
    "value": "monterey"
  },
  {
    "text": "Monterey Park",
    "value": "monterey park"
  },
  {
    "text": "Monterville",
    "value": "monterville"
  },
  {
    "text": "Montesano",
    "value": "montesano"
  },
  {
    "text": "Montevallo",
    "value": "montevallo"
  },
  {
    "text": "Montevideo",
    "value": "montevideo"
  },
  {
    "text": "Monteview",
    "value": "monteview"
  },
  {
    "text": "Montezuma",
    "value": "montezuma"
  },
  {
    "text": "Montezuma Creek",
    "value": "montezuma creek"
  },
  {
    "text": "Montfort",
    "value": "montfort"
  },
  {
    "text": "Montgomery",
    "value": "montgomery"
  },
  {
    "text": "Montgomery Center",
    "value": "montgomery center"
  },
  {
    "text": "Montgomery City",
    "value": "montgomery city"
  },
  {
    "text": "Montgomery Creek",
    "value": "montgomery creek"
  },
  {
    "text": "Montgomery Village",
    "value": "montgomery village"
  },
  {
    "text": "Montgomeryville",
    "value": "montgomeryville"
  },
  {
    "text": "Monticello",
    "value": "monticello"
  },
  {
    "text": "Montour",
    "value": "montour"
  },
  {
    "text": "Montour Falls",
    "value": "montour falls"
  },
  {
    "text": "Montoursville",
    "value": "montoursville"
  },
  {
    "text": "Montpelier",
    "value": "montpelier"
  },
  {
    "text": "Montpelier Station",
    "value": "montpelier station"
  },
  {
    "text": "Montreal",
    "value": "montreal"
  },
  {
    "text": "Montreat",
    "value": "montreat"
  },
  {
    "text": "Montrose",
    "value": "montrose"
  },
  {
    "text": "Montrose-Ghent",
    "value": "montrose-ghent"
  },
  {
    "text": "Montross",
    "value": "montross"
  },
  {
    "text": "Montvale",
    "value": "montvale"
  },
  {
    "text": "Montverde",
    "value": "montverde"
  },
  {
    "text": "Montville",
    "value": "montville"
  },
  {
    "text": "Montville Center",
    "value": "montville center"
  },
  {
    "text": "Montz",
    "value": "montz"
  },
  {
    "text": "Monument",
    "value": "monument"
  },
  {
    "text": "Monument Beach",
    "value": "monument beach"
  },
  {
    "text": "Monument Valley",
    "value": "monument valley"
  },
  {
    "text": "Moodus",
    "value": "moodus"
  },
  {
    "text": "Moody",
    "value": "moody"
  },
  {
    "text": "Moody A F B",
    "value": "moody a f b"
  },
  {
    "text": "Moody Air Force Base",
    "value": "moody air force base"
  },
  {
    "text": "Mooers",
    "value": "mooers"
  },
  {
    "text": "Mooers Forks",
    "value": "mooers forks"
  },
  {
    "text": "Moon",
    "value": "moon"
  },
  {
    "text": "Moon Township",
    "value": "moon township"
  },
  {
    "text": "Moonachie",
    "value": "moonachie"
  },
  {
    "text": "Moorcroft",
    "value": "moorcroft"
  },
  {
    "text": "Moore",
    "value": "moore"
  },
  {
    "text": "Moore Haven",
    "value": "moore haven"
  },
  {
    "text": "Moorefield",
    "value": "moorefield"
  },
  {
    "text": "Moorefield Station",
    "value": "moorefield station"
  },
  {
    "text": "Mooreland",
    "value": "mooreland"
  },
  {
    "text": "Moores Hill",
    "value": "moores hill"
  },
  {
    "text": "Mooresboro",
    "value": "mooresboro"
  },
  {
    "text": "Mooresburg",
    "value": "mooresburg"
  },
  {
    "text": "Moorestown",
    "value": "moorestown"
  },
  {
    "text": "Mooresville",
    "value": "mooresville"
  },
  {
    "text": "Mooreton",
    "value": "mooreton"
  },
  {
    "text": "Mooreville",
    "value": "mooreville"
  },
  {
    "text": "Moorhead",
    "value": "moorhead"
  },
  {
    "text": "Mooringsport",
    "value": "mooringsport"
  },
  {
    "text": "Moorland",
    "value": "moorland"
  },
  {
    "text": "Moorpark",
    "value": "moorpark"
  },
  {
    "text": "Moose",
    "value": "moose"
  },
  {
    "text": "Moose Lake",
    "value": "moose lake"
  },
  {
    "text": "Moose Pass",
    "value": "moose pass"
  },
  {
    "text": "Moose Wilson Road",
    "value": "moose wilson road"
  },
  {
    "text": "Mooseheart",
    "value": "mooseheart"
  },
  {
    "text": "Moosic",
    "value": "moosic"
  },
  {
    "text": "Moosup",
    "value": "moosup"
  },
  {
    "text": "Mora",
    "value": "mora"
  },
  {
    "text": "Moraga",
    "value": "moraga"
  },
  {
    "text": "Moraine",
    "value": "moraine"
  },
  {
    "text": "Moran",
    "value": "moran"
  },
  {
    "text": "Moravia",
    "value": "moravia"
  },
  {
    "text": "Moravian Falls",
    "value": "moravian falls"
  },
  {
    "text": "Moreauville",
    "value": "moreauville"
  },
  {
    "text": "Morehead",
    "value": "morehead"
  },
  {
    "text": "Morehead City",
    "value": "morehead city"
  },
  {
    "text": "Moreland",
    "value": "moreland"
  },
  {
    "text": "Moreland Hills",
    "value": "moreland hills"
  },
  {
    "text": "Morenci",
    "value": "morenci"
  },
  {
    "text": "Moreno Valley",
    "value": "moreno valley"
  },
  {
    "text": "Moretown",
    "value": "moretown"
  },
  {
    "text": "Morgan",
    "value": "morgan"
  },
  {
    "text": "Morgan City",
    "value": "morgan city"
  },
  {
    "text": "Morgan Hill",
    "value": "morgan hill"
  },
  {
    "text": "Morgan Mill",
    "value": "morgan mill"
  },
  {
    "text": "Morganfield",
    "value": "morganfield"
  },
  {
    "text": "Morganton",
    "value": "morganton"
  },
  {
    "text": "Morgantown",
    "value": "morgantown"
  },
  {
    "text": "Morganville",
    "value": "morganville"
  },
  {
    "text": "Morganza",
    "value": "morganza"
  },
  {
    "text": "Moriah",
    "value": "moriah"
  },
  {
    "text": "Moriah Center",
    "value": "moriah center"
  },
  {
    "text": "Moriarty",
    "value": "moriarty"
  },
  {
    "text": "Moriches",
    "value": "moriches"
  },
  {
    "text": "Morland",
    "value": "morland"
  },
  {
    "text": "Morley",
    "value": "morley"
  },
  {
    "text": "Mormon Lake",
    "value": "mormon lake"
  },
  {
    "text": "Morning Sun",
    "value": "morning sun"
  },
  {
    "text": "Morning View",
    "value": "morning view"
  },
  {
    "text": "Moro",
    "value": "moro"
  },
  {
    "text": "Morocco",
    "value": "morocco"
  },
  {
    "text": "Morongo Valley",
    "value": "morongo valley"
  },
  {
    "text": "Moroni",
    "value": "moroni"
  },
  {
    "text": "Morral",
    "value": "morral"
  },
  {
    "text": "Morrice",
    "value": "morrice"
  },
  {
    "text": "Morrill",
    "value": "morrill"
  },
  {
    "text": "Morrilton",
    "value": "morrilton"
  },
  {
    "text": "Morris",
    "value": "morris"
  },
  {
    "text": "Morris Chapel",
    "value": "morris chapel"
  },
  {
    "text": "Morris Plains",
    "value": "morris plains"
  },
  {
    "text": "Morrisdale",
    "value": "morrisdale"
  },
  {
    "text": "Morrison",
    "value": "morrison"
  },
  {
    "text": "Morrisonville",
    "value": "morrisonville"
  },
  {
    "text": "Morriston",
    "value": "morriston"
  },
  {
    "text": "Morristown",
    "value": "morristown"
  },
  {
    "text": "Morrisville",
    "value": "morrisville"
  },
  {
    "text": "Morro Bay",
    "value": "morro bay"
  },
  {
    "text": "Morrow",
    "value": "morrow"
  },
  {
    "text": "Morrowville",
    "value": "morrowville"
  },
  {
    "text": "Morse",
    "value": "morse"
  },
  {
    "text": "Morse Bluff",
    "value": "morse bluff"
  },
  {
    "text": "Morton",
    "value": "morton"
  },
  {
    "text": "Morton Grove",
    "value": "morton grove"
  },
  {
    "text": "Mortons Gap",
    "value": "mortons gap"
  },
  {
    "text": "Morven",
    "value": "morven"
  },
  {
    "text": "Mosca",
    "value": "mosca"
  },
  {
    "text": "Moscow",
    "value": "moscow"
  },
  {
    "text": "Moscow Mills",
    "value": "moscow mills"
  },
  {
    "text": "Moseley",
    "value": "moseley"
  },
  {
    "text": "Moselle",
    "value": "moselle"
  },
  {
    "text": "Moses Lake",
    "value": "moses lake"
  },
  {
    "text": "Moshannon",
    "value": "moshannon"
  },
  {
    "text": "Mosheim",
    "value": "mosheim"
  },
  {
    "text": "Mosier",
    "value": "mosier"
  },
  {
    "text": "Mosinee",
    "value": "mosinee"
  },
  {
    "text": "Mosquero",
    "value": "mosquero"
  },
  {
    "text": "Moss",
    "value": "moss"
  },
  {
    "text": "Moss Beach",
    "value": "moss beach"
  },
  {
    "text": "Moss Bluff",
    "value": "moss bluff"
  },
  {
    "text": "Moss Landing",
    "value": "moss landing"
  },
  {
    "text": "Moss Point",
    "value": "moss point"
  },
  {
    "text": "Mossville",
    "value": "mossville"
  },
  {
    "text": "Mossyrock",
    "value": "mossyrock"
  },
  {
    "text": "Motley",
    "value": "motley"
  },
  {
    "text": "Mott",
    "value": "mott"
  },
  {
    "text": "Moulton",
    "value": "moulton"
  },
  {
    "text": "Moultonborough",
    "value": "moultonborough"
  },
  {
    "text": "Moultrie",
    "value": "moultrie"
  },
  {
    "text": "Mound",
    "value": "mound"
  },
  {
    "text": "Mound Bayou",
    "value": "mound bayou"
  },
  {
    "text": "Mound City",
    "value": "mound city"
  },
  {
    "text": "Mound Valley",
    "value": "mound valley"
  },
  {
    "text": "Moundridge",
    "value": "moundridge"
  },
  {
    "text": "Mounds",
    "value": "mounds"
  },
  {
    "text": "Mounds View",
    "value": "mounds view"
  },
  {
    "text": "Moundsville",
    "value": "moundsville"
  },
  {
    "text": "Moundville",
    "value": "moundville"
  },
  {
    "text": "Mount Aetna",
    "value": "mount aetna"
  },
  {
    "text": "Mount Airy",
    "value": "mount airy"
  },
  {
    "text": "Mount Alto",
    "value": "mount alto"
  },
  {
    "text": "Mount Angel",
    "value": "mount angel"
  },
  {
    "text": "Mount Arlington",
    "value": "mount arlington"
  },
  {
    "text": "Mount Auburn",
    "value": "mount auburn"
  },
  {
    "text": "Mount Aukum",
    "value": "mount aukum"
  },
  {
    "text": "Mount Ayr",
    "value": "mount ayr"
  },
  {
    "text": "Mount Baldy",
    "value": "mount baldy"
  },
  {
    "text": "Mount Berry",
    "value": "mount berry"
  },
  {
    "text": "Mount Bethel",
    "value": "mount bethel"
  },
  {
    "text": "Mount Blanchard",
    "value": "mount blanchard"
  },
  {
    "text": "Mount Braddock",
    "value": "mount braddock"
  },
  {
    "text": "Mount Calm",
    "value": "mount calm"
  },
  {
    "text": "Mount Calvary",
    "value": "mount calvary"
  },
  {
    "text": "Mount Carbon",
    "value": "mount carbon"
  },
  {
    "text": "Mount Carmel",
    "value": "mount carmel"
  },
  {
    "text": "Mount Carroll",
    "value": "mount carroll"
  },
  {
    "text": "Mount Clare",
    "value": "mount clare"
  },
  {
    "text": "Mount Clemens",
    "value": "mount clemens"
  },
  {
    "text": "Mount Cory",
    "value": "mount cory"
  },
  {
    "text": "Mount Crawford",
    "value": "mount crawford"
  },
  {
    "text": "Mount Croghan",
    "value": "mount croghan"
  },
  {
    "text": "Mount Desert",
    "value": "mount desert"
  },
  {
    "text": "Mount Dora",
    "value": "mount dora"
  },
  {
    "text": "Mount Eaton",
    "value": "mount eaton"
  },
  {
    "text": "Mount Eden",
    "value": "mount eden"
  },
  {
    "text": "Mount Enterprise",
    "value": "mount enterprise"
  },
  {
    "text": "Mount Ephraim",
    "value": "mount ephraim"
  },
  {
    "text": "Mount Erie",
    "value": "mount erie"
  },
  {
    "text": "Mount Gay-Shamrock",
    "value": "mount gay-shamrock"
  },
  {
    "text": "Mount Gilead",
    "value": "mount gilead"
  },
  {
    "text": "Mount Gretna",
    "value": "mount gretna"
  },
  {
    "text": "Mount Hamilton",
    "value": "mount hamilton"
  },
  {
    "text": "Mount Hermon",
    "value": "mount hermon"
  },
  {
    "text": "Mount Holly",
    "value": "mount holly"
  },
  {
    "text": "Mount Holly Springs",
    "value": "mount holly springs"
  },
  {
    "text": "Mount Hood Parkdale",
    "value": "mount hood parkdale"
  },
  {
    "text": "Mount Hope",
    "value": "mount hope"
  },
  {
    "text": "Mount Horeb",
    "value": "mount horeb"
  },
  {
    "text": "Mount Ida",
    "value": "mount ida"
  },
  {
    "text": "Mount Jackson",
    "value": "mount jackson"
  },
  {
    "text": "Mount Jewett",
    "value": "mount jewett"
  },
  {
    "text": "Mount Joy",
    "value": "mount joy"
  },
  {
    "text": "Mount Judea",
    "value": "mount judea"
  },
  {
    "text": "Mount Juliet",
    "value": "mount juliet"
  },
  {
    "text": "Mount Kisco",
    "value": "mount kisco"
  },
  {
    "text": "Mount Laguna",
    "value": "mount laguna"
  },
  {
    "text": "Mount Laurel",
    "value": "mount laurel"
  },
  {
    "text": "Mount Lebanon",
    "value": "mount lebanon"
  },
  {
    "text": "Mount Lemmon",
    "value": "mount lemmon"
  },
  {
    "text": "Mount Lookout",
    "value": "mount lookout"
  },
  {
    "text": "Mount Marion",
    "value": "mount marion"
  },
  {
    "text": "Mount Meigs",
    "value": "mount meigs"
  },
  {
    "text": "Mount Morris",
    "value": "mount morris"
  },
  {
    "text": "Mount Nebo",
    "value": "mount nebo"
  },
  {
    "text": "Mount Olive",
    "value": "mount olive"
  },
  {
    "text": "Mount Olivet",
    "value": "mount olivet"
  },
  {
    "text": "Mount Orab",
    "value": "mount orab"
  },
  {
    "text": "Mount Perry",
    "value": "mount perry"
  },
  {
    "text": "Mount Pleasant",
    "value": "mount pleasant"
  },
  {
    "text": "Mount Pleasant Mills",
    "value": "mount pleasant mills"
  },
  {
    "text": "Mount Plymouth",
    "value": "mount plymouth"
  },
  {
    "text": "Mount Pocono",
    "value": "mount pocono"
  },
  {
    "text": "Mount Prospect",
    "value": "mount prospect"
  },
  {
    "text": "Mount Pulaski",
    "value": "mount pulaski"
  },
  {
    "text": "Mount Rainier",
    "value": "mount rainier"
  },
  {
    "text": "Mount Royal",
    "value": "mount royal"
  },
  {
    "text": "Mount Saint Francis",
    "value": "mount saint francis"
  },
  {
    "text": "Mount Saint Joseph",
    "value": "mount saint joseph"
  },
  {
    "text": "Mount Shasta",
    "value": "mount shasta"
  },
  {
    "text": "Mount Sherman",
    "value": "mount sherman"
  },
  {
    "text": "Mount Sidney",
    "value": "mount sidney"
  },
  {
    "text": "Mount Sinai",
    "value": "mount sinai"
  },
  {
    "text": "Mount Solon",
    "value": "mount solon"
  },
  {
    "text": "Mount Sterling",
    "value": "mount sterling"
  },
  {
    "text": "Mount Storm",
    "value": "mount storm"
  },
  {
    "text": "Mount Summit",
    "value": "mount summit"
  },
  {
    "text": "Mount Tabor",
    "value": "mount tabor"
  },
  {
    "text": "Mount Tremper",
    "value": "mount tremper"
  },
  {
    "text": "Mount Ulla",
    "value": "mount ulla"
  },
  {
    "text": "Mount Union",
    "value": "mount union"
  },
  {
    "text": "Mount Upton",
    "value": "mount upton"
  },
  {
    "text": "Mount Vernon",
    "value": "mount vernon"
  },
  {
    "text": "Mount Victory",
    "value": "mount victory"
  },
  {
    "text": "Mount Vision",
    "value": "mount vision"
  },
  {
    "text": "Mount Washington",
    "value": "mount washington"
  },
  {
    "text": "Mount Wilson",
    "value": "mount wilson"
  },
  {
    "text": "Mount Wolf",
    "value": "mount wolf"
  },
  {
    "text": "Mount Zion",
    "value": "mount zion"
  },
  {
    "text": "Mountain",
    "value": "mountain"
  },
  {
    "text": "Mountain Brook",
    "value": "mountain brook"
  },
  {
    "text": "Mountain Center",
    "value": "mountain center"
  },
  {
    "text": "Mountain City",
    "value": "mountain city"
  },
  {
    "text": "Mountain Dale",
    "value": "mountain dale"
  },
  {
    "text": "Mountain Green",
    "value": "mountain green"
  },
  {
    "text": "Mountain Grove",
    "value": "mountain grove"
  },
  {
    "text": "Mountain Home",
    "value": "mountain home"
  },
  {
    "text": "Mountain Home Air Force Base",
    "value": "mountain home air force base"
  },
  {
    "text": "Mountain House",
    "value": "mountain house"
  },
  {
    "text": "Mountain Iron",
    "value": "mountain iron"
  },
  {
    "text": "Mountain Lake",
    "value": "mountain lake"
  },
  {
    "text": "Mountain Lake Park",
    "value": "mountain lake park"
  },
  {
    "text": "Mountain Lakes",
    "value": "mountain lakes"
  },
  {
    "text": "Mountain Lodge Park",
    "value": "mountain lodge park"
  },
  {
    "text": "Mountain Park",
    "value": "mountain park"
  },
  {
    "text": "Mountain Pass",
    "value": "mountain pass"
  },
  {
    "text": "Mountain Pine",
    "value": "mountain pine"
  },
  {
    "text": "Mountain Ranch",
    "value": "mountain ranch"
  },
  {
    "text": "Mountain Rest",
    "value": "mountain rest"
  },
  {
    "text": "Mountain Top",
    "value": "mountain top"
  },
  {
    "text": "Mountain View",
    "value": "mountain view"
  },
  {
    "text": "Mountain Village",
    "value": "mountain village"
  },
  {
    "text": "Mountainair",
    "value": "mountainair"
  },
  {
    "text": "Mountainburg",
    "value": "mountainburg"
  },
  {
    "text": "Mountainhome",
    "value": "mountainhome"
  },
  {
    "text": "Mountainside",
    "value": "mountainside"
  },
  {
    "text": "Mountainville",
    "value": "mountainville"
  },
  {
    "text": "Mountlake Terrace",
    "value": "mountlake terrace"
  },
  {
    "text": "Mountville",
    "value": "mountville"
  },
  {
    "text": "Mousie",
    "value": "mousie"
  },
  {
    "text": "Mouth of Wilson",
    "value": "mouth of wilson"
  },
  {
    "text": "Mouthcard",
    "value": "mouthcard"
  },
  {
    "text": "Moville",
    "value": "moville"
  },
  {
    "text": "Moweaqua",
    "value": "moweaqua"
  },
  {
    "text": "Mowrystown",
    "value": "mowrystown"
  },
  {
    "text": "Moxee",
    "value": "moxee"
  },
  {
    "text": "Moxee City",
    "value": "moxee city"
  },
  {
    "text": "Moyers",
    "value": "moyers"
  },
  {
    "text": "Moyie Springs",
    "value": "moyie springs"
  },
  {
    "text": "Moyock",
    "value": "moyock"
  },
  {
    "text": "Mt Pleasant",
    "value": "mt pleasant"
  },
  {
    "text": "Mt. Dora",
    "value": "mt. dora"
  },
  {
    "text": "Mt. Morris",
    "value": "mt. morris"
  },
  {
    "text": "Mt. Pleasant",
    "value": "mt. pleasant"
  },
  {
    "text": "Mt. Vernon",
    "value": "mt. vernon"
  },
  {
    "text": "Mud Butte",
    "value": "mud butte"
  },
  {
    "text": "Muenster",
    "value": "muenster"
  },
  {
    "text": "Muir",
    "value": "muir"
  },
  {
    "text": "Mukilteo",
    "value": "mukilteo"
  },
  {
    "text": "Mukwonago",
    "value": "mukwonago"
  },
  {
    "text": "Mulberry",
    "value": "mulberry"
  },
  {
    "text": "Mulberry Grove",
    "value": "mulberry grove"
  },
  {
    "text": "Muldoon",
    "value": "muldoon"
  },
  {
    "text": "Muldraugh",
    "value": "muldraugh"
  },
  {
    "text": "Muldrow",
    "value": "muldrow"
  },
  {
    "text": "Muleshoe",
    "value": "muleshoe"
  },
  {
    "text": "Mulga",
    "value": "mulga"
  },
  {
    "text": "Mulhall",
    "value": "mulhall"
  },
  {
    "text": "Mulino",
    "value": "mulino"
  },
  {
    "text": "Mulkeytown",
    "value": "mulkeytown"
  },
  {
    "text": "Mullan",
    "value": "mullan"
  },
  {
    "text": "Mullen",
    "value": "mullen"
  },
  {
    "text": "Mullens",
    "value": "mullens"
  },
  {
    "text": "Mullett Lake",
    "value": "mullett lake"
  },
  {
    "text": "Mullica Hill",
    "value": "mullica hill"
  },
  {
    "text": "Mulliken",
    "value": "mulliken"
  },
  {
    "text": "Mullin",
    "value": "mullin"
  },
  {
    "text": "Mullins",
    "value": "mullins"
  },
  {
    "text": "Mullinville",
    "value": "mullinville"
  },
  {
    "text": "Mulvane",
    "value": "mulvane"
  },
  {
    "text": "Mumford",
    "value": "mumford"
  },
  {
    "text": "Muncie",
    "value": "muncie"
  },
  {
    "text": "Muncy",
    "value": "muncy"
  },
  {
    "text": "Muncy Valley",
    "value": "muncy valley"
  },
  {
    "text": "Munday",
    "value": "munday"
  },
  {
    "text": "Mundelein",
    "value": "mundelein"
  },
  {
    "text": "Munden",
    "value": "munden"
  },
  {
    "text": "Munds Park",
    "value": "munds park"
  },
  {
    "text": "Munford",
    "value": "munford"
  },
  {
    "text": "Munfordville",
    "value": "munfordville"
  },
  {
    "text": "Munger",
    "value": "munger"
  },
  {
    "text": "Munhall",
    "value": "munhall"
  },
  {
    "text": "Munich",
    "value": "munich"
  },
  {
    "text": "Munising",
    "value": "munising"
  },
  {
    "text": "Munith",
    "value": "munith"
  },
  {
    "text": "Munnsville",
    "value": "munnsville"
  },
  {
    "text": "Munroe Falls",
    "value": "munroe falls"
  },
  {
    "text": "Munson",
    "value": "munson"
  },
  {
    "text": "Munster",
    "value": "munster"
  },
  {
    "text": "Murchison",
    "value": "murchison"
  },
  {
    "text": "Murdo",
    "value": "murdo"
  },
  {
    "text": "Murdock",
    "value": "murdock"
  },
  {
    "text": "Murfreesboro",
    "value": "murfreesboro"
  },
  {
    "text": "Murphy",
    "value": "murphy"
  },
  {
    "text": "Murphys",
    "value": "murphys"
  },
  {
    "text": "Murphysboro",
    "value": "murphysboro"
  },
  {
    "text": "Murray",
    "value": "murray"
  },
  {
    "text": "Murray City",
    "value": "murray city"
  },
  {
    "text": "Murrayville",
    "value": "murrayville"
  },
  {
    "text": "Murrells Inlet",
    "value": "murrells inlet"
  },
  {
    "text": "Murrieta",
    "value": "murrieta"
  },
  {
    "text": "Murrieta Hot Springs",
    "value": "murrieta hot springs"
  },
  {
    "text": "Murrysville",
    "value": "murrysville"
  },
  {
    "text": "Murtaugh",
    "value": "murtaugh"
  },
  {
    "text": "Muscadine",
    "value": "muscadine"
  },
  {
    "text": "Muscatine",
    "value": "muscatine"
  },
  {
    "text": "Muscle Shoals",
    "value": "muscle shoals"
  },
  {
    "text": "Muscoda",
    "value": "muscoda"
  },
  {
    "text": "Muscotah",
    "value": "muscotah"
  },
  {
    "text": "Muscoy",
    "value": "muscoy"
  },
  {
    "text": "Muse",
    "value": "muse"
  },
  {
    "text": "Musella",
    "value": "musella"
  },
  {
    "text": "Muskego",
    "value": "muskego"
  },
  {
    "text": "Muskegon",
    "value": "muskegon"
  },
  {
    "text": "Muskegon Heights",
    "value": "muskegon heights"
  },
  {
    "text": "Muskogee",
    "value": "muskogee"
  },
  {
    "text": "Musselshell",
    "value": "musselshell"
  },
  {
    "text": "Mustang",
    "value": "mustang"
  },
  {
    "text": "Mustoe",
    "value": "mustoe"
  },
  {
    "text": "Mutual",
    "value": "mutual"
  },
  {
    "text": "Myakka City",
    "value": "myakka city"
  },
  {
    "text": "Myers Flat",
    "value": "myers flat"
  },
  {
    "text": "Myerstown",
    "value": "myerstown"
  },
  {
    "text": "Myersville",
    "value": "myersville"
  },
  {
    "text": "Mylo",
    "value": "mylo"
  },
  {
    "text": "Myrtle",
    "value": "myrtle"
  },
  {
    "text": "Myrtle Beach",
    "value": "myrtle beach"
  },
  {
    "text": "Myrtle Creek",
    "value": "myrtle creek"
  },
  {
    "text": "Myrtle Point",
    "value": "myrtle point"
  },
  {
    "text": "Mystic",
    "value": "mystic"
  },
  {
    "text": "Mystic Island",
    "value": "mystic island"
  },
  {
    "text": "Myton",
    "value": "myton"
  },
  {
    "text": "Naalehu",
    "value": "naalehu"
  },
  {
    "text": "Nabb",
    "value": "nabb"
  },
  {
    "text": "Naches",
    "value": "naches"
  },
  {
    "text": "Nachusa",
    "value": "nachusa"
  },
  {
    "text": "Nacogdoches",
    "value": "nacogdoches"
  },
  {
    "text": "Nageezi",
    "value": "nageezi"
  },
  {
    "text": "Nags Head",
    "value": "nags head"
  },
  {
    "text": "Nahant",
    "value": "nahant"
  },
  {
    "text": "Nahunta",
    "value": "nahunta"
  },
  {
    "text": "Nakina",
    "value": "nakina"
  },
  {
    "text": "Naknek",
    "value": "naknek"
  },
  {
    "text": "Nalcrest",
    "value": "nalcrest"
  },
  {
    "text": "Nallen",
    "value": "nallen"
  },
  {
    "text": "Nampa",
    "value": "nampa"
  },
  {
    "text": "Nanafalia",
    "value": "nanafalia"
  },
  {
    "text": "Nancy",
    "value": "nancy"
  },
  {
    "text": "Nanjemoy",
    "value": "nanjemoy"
  },
  {
    "text": "Nanticoke",
    "value": "nanticoke"
  },
  {
    "text": "Nantucket",
    "value": "nantucket"
  },
  {
    "text": "Nanty Glo",
    "value": "nanty glo"
  },
  {
    "text": "Nanuet",
    "value": "nanuet"
  },
  {
    "text": "Napa",
    "value": "napa"
  },
  {
    "text": "Napakiak",
    "value": "napakiak"
  },
  {
    "text": "Napanoch",
    "value": "napanoch"
  },
  {
    "text": "Napavine",
    "value": "napavine"
  },
  {
    "text": "Naper",
    "value": "naper"
  },
  {
    "text": "Naperville",
    "value": "naperville"
  },
  {
    "text": "Napier",
    "value": "napier"
  },
  {
    "text": "Napili-Honokowai",
    "value": "napili-honokowai"
  },
  {
    "text": "Naples",
    "value": "naples"
  },
  {
    "text": "Naples Park",
    "value": "naples park"
  },
  {
    "text": "Napoleon",
    "value": "napoleon"
  },
  {
    "text": "Napoleonville",
    "value": "napoleonville"
  },
  {
    "text": "Naponee",
    "value": "naponee"
  },
  {
    "text": "Nappanee",
    "value": "nappanee"
  },
  {
    "text": "Nara Visa",
    "value": "nara visa"
  },
  {
    "text": "Naranja",
    "value": "naranja"
  },
  {
    "text": "Narberth",
    "value": "narberth"
  },
  {
    "text": "Nardin",
    "value": "nardin"
  },
  {
    "text": "Narka",
    "value": "narka"
  },
  {
    "text": "Narragansett",
    "value": "narragansett"
  },
  {
    "text": "Narrows",
    "value": "narrows"
  },
  {
    "text": "Narrowsburg",
    "value": "narrowsburg"
  },
  {
    "text": "Narvon",
    "value": "narvon"
  },
  {
    "text": "Naselle",
    "value": "naselle"
  },
  {
    "text": "Nash",
    "value": "nash"
  },
  {
    "text": "Nashoba",
    "value": "nashoba"
  },
  {
    "text": "Nashotah",
    "value": "nashotah"
  },
  {
    "text": "Nashport",
    "value": "nashport"
  },
  {
    "text": "Nashua",
    "value": "nashua"
  },
  {
    "text": "Nashville",
    "value": "nashville"
  },
  {
    "text": "Nashwauk",
    "value": "nashwauk"
  },
  {
    "text": "Nassau",
    "value": "nassau"
  },
  {
    "text": "Nassau Bay",
    "value": "nassau bay"
  },
  {
    "text": "Nassau Village-Ratliff",
    "value": "nassau village-ratliff"
  },
  {
    "text": "Nassawadox",
    "value": "nassawadox"
  },
  {
    "text": "Natalbany",
    "value": "natalbany"
  },
  {
    "text": "Natalia",
    "value": "natalia"
  },
  {
    "text": "Natchez",
    "value": "natchez"
  },
  {
    "text": "Natchitoches",
    "value": "natchitoches"
  },
  {
    "text": "Nathalie",
    "value": "nathalie"
  },
  {
    "text": "Nathrop",
    "value": "nathrop"
  },
  {
    "text": "Natick",
    "value": "natick"
  },
  {
    "text": "National City",
    "value": "national city"
  },
  {
    "text": "National Harbor",
    "value": "national harbor"
  },
  {
    "text": "National Park",
    "value": "national park"
  },
  {
    "text": "Natoma",
    "value": "natoma"
  },
  {
    "text": "Natrona",
    "value": "natrona"
  },
  {
    "text": "Natrona Heights",
    "value": "natrona heights"
  },
  {
    "text": "Natural Bridge",
    "value": "natural bridge"
  },
  {
    "text": "Natural Bridge Station",
    "value": "natural bridge station"
  },
  {
    "text": "Naturita",
    "value": "naturita"
  },
  {
    "text": "Naubinway",
    "value": "naubinway"
  },
  {
    "text": "Naugatuck",
    "value": "naugatuck"
  },
  {
    "text": "Nauvoo",
    "value": "nauvoo"
  },
  {
    "text": "Navajo",
    "value": "navajo"
  },
  {
    "text": "Navajo Dam",
    "value": "navajo dam"
  },
  {
    "text": "Naval Air Station/ Jrb",
    "value": "naval air station/ jrb"
  },
  {
    "text": "Navarre",
    "value": "navarre"
  },
  {
    "text": "Navarro",
    "value": "navarro"
  },
  {
    "text": "Navasota",
    "value": "navasota"
  },
  {
    "text": "Navassa",
    "value": "navassa"
  },
  {
    "text": "Navesink",
    "value": "navesink"
  },
  {
    "text": "Naylor",
    "value": "naylor"
  },
  {
    "text": "Naytahwaush",
    "value": "naytahwaush"
  },
  {
    "text": "Nazareth",
    "value": "nazareth"
  },
  {
    "text": "Nazlini",
    "value": "nazlini"
  },
  {
    "text": "Neah Bay",
    "value": "neah bay"
  },
  {
    "text": "Neapolis",
    "value": "neapolis"
  },
  {
    "text": "Neavitt",
    "value": "neavitt"
  },
  {
    "text": "Nebo",
    "value": "nebo"
  },
  {
    "text": "Nebraska City",
    "value": "nebraska city"
  },
  {
    "text": "Necedah",
    "value": "necedah"
  },
  {
    "text": "Neche",
    "value": "neche"
  },
  {
    "text": "Neches",
    "value": "neches"
  },
  {
    "text": "Neck City",
    "value": "neck city"
  },
  {
    "text": "Nederland",
    "value": "nederland"
  },
  {
    "text": "Nedrow",
    "value": "nedrow"
  },
  {
    "text": "Needham",
    "value": "needham"
  },
  {
    "text": "Needham Heights",
    "value": "needham heights"
  },
  {
    "text": "Needles",
    "value": "needles"
  },
  {
    "text": "Needmore",
    "value": "needmore"
  },
  {
    "text": "Needville",
    "value": "needville"
  },
  {
    "text": "Neely",
    "value": "neely"
  },
  {
    "text": "Neelyton",
    "value": "neelyton"
  },
  {
    "text": "Neelyville",
    "value": "neelyville"
  },
  {
    "text": "Neenah",
    "value": "neenah"
  },
  {
    "text": "Neeses",
    "value": "neeses"
  },
  {
    "text": "Neffs",
    "value": "neffs"
  },
  {
    "text": "Negaunee",
    "value": "negaunee"
  },
  {
    "text": "Negley",
    "value": "negley"
  },
  {
    "text": "Negreet",
    "value": "negreet"
  },
  {
    "text": "Nehalem",
    "value": "nehalem"
  },
  {
    "text": "Nehawka",
    "value": "nehawka"
  },
  {
    "text": "Neihart",
    "value": "neihart"
  },
  {
    "text": "Neillsville",
    "value": "neillsville"
  },
  {
    "text": "Neilton",
    "value": "neilton"
  },
  {
    "text": "Nekoma",
    "value": "nekoma"
  },
  {
    "text": "Nekoosa",
    "value": "nekoosa"
  },
  {
    "text": "Neligh",
    "value": "neligh"
  },
  {
    "text": "Nellis Air Force Base",
    "value": "nellis air force base"
  },
  {
    "text": "Nelliston",
    "value": "nelliston"
  },
  {
    "text": "Nellysford",
    "value": "nellysford"
  },
  {
    "text": "Nelson",
    "value": "nelson"
  },
  {
    "text": "Nelsonia",
    "value": "nelsonia"
  },
  {
    "text": "Nelsonville",
    "value": "nelsonville"
  },
  {
    "text": "Nemacolin",
    "value": "nemacolin"
  },
  {
    "text": "Nemaha",
    "value": "nemaha"
  },
  {
    "text": "Nemo",
    "value": "nemo"
  },
  {
    "text": "Nemours",
    "value": "nemours"
  },
  {
    "text": "Nenana",
    "value": "nenana"
  },
  {
    "text": "Neodesha",
    "value": "neodesha"
  },
  {
    "text": "Neoga",
    "value": "neoga"
  },
  {
    "text": "Neola",
    "value": "neola"
  },
  {
    "text": "Neon",
    "value": "neon"
  },
  {
    "text": "Neosho",
    "value": "neosho"
  },
  {
    "text": "Neosho Falls",
    "value": "neosho falls"
  },
  {
    "text": "Neosho Rapids",
    "value": "neosho rapids"
  },
  {
    "text": "Neotsu",
    "value": "neotsu"
  },
  {
    "text": "Nephi",
    "value": "nephi"
  },
  {
    "text": "Neponset",
    "value": "neponset"
  },
  {
    "text": "Neptune Beach",
    "value": "neptune beach"
  },
  {
    "text": "Neptune City",
    "value": "neptune city"
  },
  {
    "text": "Nerinx",
    "value": "nerinx"
  },
  {
    "text": "Nerstrand",
    "value": "nerstrand"
  },
  {
    "text": "Nesbit",
    "value": "nesbit"
  },
  {
    "text": "Nesconset",
    "value": "nesconset"
  },
  {
    "text": "Nescopeck",
    "value": "nescopeck"
  },
  {
    "text": "Neshanic Station",
    "value": "neshanic station"
  },
  {
    "text": "Neshkoro",
    "value": "neshkoro"
  },
  {
    "text": "Neskowin",
    "value": "neskowin"
  },
  {
    "text": "Nesmith",
    "value": "nesmith"
  },
  {
    "text": "Nespelem",
    "value": "nespelem"
  },
  {
    "text": "Nesquehoning",
    "value": "nesquehoning"
  },
  {
    "text": "Ness City",
    "value": "ness city"
  },
  {
    "text": "Netarts",
    "value": "netarts"
  },
  {
    "text": "Netawaka",
    "value": "netawaka"
  },
  {
    "text": "Netcong",
    "value": "netcong"
  },
  {
    "text": "Nett Lake",
    "value": "nett lake"
  },
  {
    "text": "Nettie",
    "value": "nettie"
  },
  {
    "text": "Nettleton",
    "value": "nettleton"
  },
  {
    "text": "Nevada",
    "value": "nevada"
  },
  {
    "text": "Nevada City",
    "value": "nevada city"
  },
  {
    "text": "Neversink",
    "value": "neversink"
  },
  {
    "text": "Neville",
    "value": "neville"
  },
  {
    "text": "Nevis",
    "value": "nevis"
  },
  {
    "text": "New Albany",
    "value": "new albany"
  },
  {
    "text": "New Albin",
    "value": "new albin"
  },
  {
    "text": "New Alexandria",
    "value": "new alexandria"
  },
  {
    "text": "New Almaden",
    "value": "new almaden"
  },
  {
    "text": "New Athens",
    "value": "new athens"
  },
  {
    "text": "New Auburn",
    "value": "new auburn"
  },
  {
    "text": "New Augusta",
    "value": "new augusta"
  },
  {
    "text": "New Baden",
    "value": "new baden"
  },
  {
    "text": "New Baltimore",
    "value": "new baltimore"
  },
  {
    "text": "New Bavaria",
    "value": "new bavaria"
  },
  {
    "text": "New Beaver",
    "value": "new beaver"
  },
  {
    "text": "New Bedford",
    "value": "new bedford"
  },
  {
    "text": "New Berlin",
    "value": "new berlin"
  },
  {
    "text": "New Berlinville",
    "value": "new berlinville"
  },
  {
    "text": "New Bern",
    "value": "new bern"
  },
  {
    "text": "New Bethlehem",
    "value": "new bethlehem"
  },
  {
    "text": "New Blaine",
    "value": "new blaine"
  },
  {
    "text": "New Bloomfield",
    "value": "new bloomfield"
  },
  {
    "text": "New Bloomington",
    "value": "new bloomington"
  },
  {
    "text": "New Boston",
    "value": "new boston"
  },
  {
    "text": "New Braintree",
    "value": "new braintree"
  },
  {
    "text": "New Braunfels",
    "value": "new braunfels"
  },
  {
    "text": "New Bremen",
    "value": "new bremen"
  },
  {
    "text": "New Brighton",
    "value": "new brighton"
  },
  {
    "text": "New Britain",
    "value": "new britain"
  },
  {
    "text": "New Brockton",
    "value": "new brockton"
  },
  {
    "text": "New Brunswick",
    "value": "new brunswick"
  },
  {
    "text": "New Buffalo",
    "value": "new buffalo"
  },
  {
    "text": "New Burlington",
    "value": "new burlington"
  },
  {
    "text": "New California",
    "value": "new california"
  },
  {
    "text": "New Cambria",
    "value": "new cambria"
  },
  {
    "text": "New Canaan",
    "value": "new canaan"
  },
  {
    "text": "New Caney",
    "value": "new caney"
  },
  {
    "text": "New Canton",
    "value": "new canton"
  },
  {
    "text": "New Carlisle",
    "value": "new carlisle"
  },
  {
    "text": "New Carrollton",
    "value": "new carrollton"
  },
  {
    "text": "New Castle",
    "value": "new castle"
  },
  {
    "text": "New Century",
    "value": "new century"
  },
  {
    "text": "New Century, KS",
    "value": "new century, ks"
  },
  {
    "text": "New Church",
    "value": "new church"
  },
  {
    "text": "New City",
    "value": "new city"
  },
  {
    "text": "New Columbia",
    "value": "new columbia"
  },
  {
    "text": "New Concord",
    "value": "new concord"
  },
  {
    "text": "New Creek",
    "value": "new creek"
  },
  {
    "text": "New Cumberland",
    "value": "new cumberland"
  },
  {
    "text": "New Cuyama",
    "value": "new cuyama"
  },
  {
    "text": "New Deal",
    "value": "new deal"
  },
  {
    "text": "New Derry",
    "value": "new derry"
  },
  {
    "text": "New Dorp",
    "value": "new dorp"
  },
  {
    "text": "New Douglas",
    "value": "new douglas"
  },
  {
    "text": "New Durham",
    "value": "new durham"
  },
  {
    "text": "New Eagle",
    "value": "new eagle"
  },
  {
    "text": "New Edinburg",
    "value": "new edinburg"
  },
  {
    "text": "New Effington",
    "value": "new effington"
  },
  {
    "text": "New Egypt",
    "value": "new egypt"
  },
  {
    "text": "New Ellenton",
    "value": "new ellenton"
  },
  {
    "text": "New England",
    "value": "new england"
  },
  {
    "text": "New Enterprise",
    "value": "new enterprise"
  },
  {
    "text": "New Era",
    "value": "new era"
  },
  {
    "text": "New Fairfield",
    "value": "new fairfield"
  },
  {
    "text": "New Florence",
    "value": "new florence"
  },
  {
    "text": "New Franken",
    "value": "new franken"
  },
  {
    "text": "New Franklin",
    "value": "new franklin"
  },
  {
    "text": "New Freedom",
    "value": "new freedom"
  },
  {
    "text": "New Freeport",
    "value": "new freeport"
  },
  {
    "text": "New Galilee",
    "value": "new galilee"
  },
  {
    "text": "New Germany",
    "value": "new germany"
  },
  {
    "text": "New Glarus",
    "value": "new glarus"
  },
  {
    "text": "New Gloucester",
    "value": "new gloucester"
  },
  {
    "text": "New Goshen",
    "value": "new goshen"
  },
  {
    "text": "New Gretna",
    "value": "new gretna"
  },
  {
    "text": "New Hampton",
    "value": "new hampton"
  },
  {
    "text": "New Hanover",
    "value": "new hanover"
  },
  {
    "text": "New Harbor",
    "value": "new harbor"
  },
  {
    "text": "New Harmony",
    "value": "new harmony"
  },
  {
    "text": "New Hartford",
    "value": "new hartford"
  },
  {
    "text": "New Haven",
    "value": "new haven"
  },
  {
    "text": "New Hebron",
    "value": "new hebron"
  },
  {
    "text": "New Hill",
    "value": "new hill"
  },
  {
    "text": "New Holland",
    "value": "new holland"
  },
  {
    "text": "New Holstein",
    "value": "new holstein"
  },
  {
    "text": "New Home",
    "value": "new home"
  },
  {
    "text": "New Hope",
    "value": "new hope"
  },
  {
    "text": "New Hudson",
    "value": "new hudson"
  },
  {
    "text": "New Hyde Park",
    "value": "new hyde park"
  },
  {
    "text": "New Iberia",
    "value": "new iberia"
  },
  {
    "text": "New Ipswich",
    "value": "new ipswich"
  },
  {
    "text": "New Johnsonville",
    "value": "new johnsonville"
  },
  {
    "text": "New Kensington",
    "value": "new kensington"
  },
  {
    "text": "New Kent",
    "value": "new kent"
  },
  {
    "text": "New Kingston",
    "value": "new kingston"
  },
  {
    "text": "New Kingstown",
    "value": "new kingstown"
  },
  {
    "text": "New Knoxville",
    "value": "new knoxville"
  },
  {
    "text": "New Lebanon",
    "value": "new lebanon"
  },
  {
    "text": "New Leipzig",
    "value": "new leipzig"
  },
  {
    "text": "New Lenox",
    "value": "new lenox"
  },
  {
    "text": "New Lexington",
    "value": "new lexington"
  },
  {
    "text": "New Limerick",
    "value": "new limerick"
  },
  {
    "text": "New Lisbon",
    "value": "new lisbon"
  },
  {
    "text": "New Llano",
    "value": "new llano"
  },
  {
    "text": "New London",
    "value": "new london"
  },
  {
    "text": "New Lothrop",
    "value": "new lothrop"
  },
  {
    "text": "New Madison",
    "value": "new madison"
  },
  {
    "text": "New Madrid",
    "value": "new madrid"
  },
  {
    "text": "New Market",
    "value": "new market"
  },
  {
    "text": "New Marlborough",
    "value": "new marlborough"
  },
  {
    "text": "New Marshfield",
    "value": "new marshfield"
  },
  {
    "text": "New Martinsville",
    "value": "new martinsville"
  },
  {
    "text": "New Matamoras",
    "value": "new matamoras"
  },
  {
    "text": "New Meadows",
    "value": "new meadows"
  },
  {
    "text": "New Melle",
    "value": "new melle"
  },
  {
    "text": "New Middletown",
    "value": "new middletown"
  },
  {
    "text": "New Milford",
    "value": "new milford"
  },
  {
    "text": "New Milton",
    "value": "new milton"
  },
  {
    "text": "New Orleans",
    "value": "new orleans"
  },
  {
    "text": "New Oxford",
    "value": "new oxford"
  },
  {
    "text": "New Palestine",
    "value": "new palestine"
  },
  {
    "text": "New Paltz",
    "value": "new paltz"
  },
  {
    "text": "New Paris",
    "value": "new paris"
  },
  {
    "text": "New Park",
    "value": "new park"
  },
  {
    "text": "New Pekin",
    "value": "new pekin"
  },
  {
    "text": "New Philadelphia",
    "value": "new philadelphia"
  },
  {
    "text": "New Pine Creek",
    "value": "new pine creek"
  },
  {
    "text": "New Plymouth",
    "value": "new plymouth"
  },
  {
    "text": "New Point",
    "value": "new point"
  },
  {
    "text": "New Port Richey",
    "value": "new port richey"
  },
  {
    "text": "New Port Richey East",
    "value": "new port richey east"
  },
  {
    "text": "New Portland",
    "value": "new portland"
  },
  {
    "text": "New Prague",
    "value": "new prague"
  },
  {
    "text": "New Preston",
    "value": "new preston"
  },
  {
    "text": "New Preston Marble Dale",
    "value": "new preston marble dale"
  },
  {
    "text": "New Providence",
    "value": "new providence"
  },
  {
    "text": "New Raymer",
    "value": "new raymer"
  },
  {
    "text": "New Richland",
    "value": "new richland"
  },
  {
    "text": "New Richmond",
    "value": "new richmond"
  },
  {
    "text": "New Riegel",
    "value": "new riegel"
  },
  {
    "text": "New Ringgold",
    "value": "new ringgold"
  },
  {
    "text": "New River",
    "value": "new river"
  },
  {
    "text": "New Roads",
    "value": "new roads"
  },
  {
    "text": "New Rochelle",
    "value": "new rochelle"
  },
  {
    "text": "New Rockford",
    "value": "new rockford"
  },
  {
    "text": "New Ross",
    "value": "new ross"
  },
  {
    "text": "New Salem",
    "value": "new salem"
  },
  {
    "text": "New Salisbury",
    "value": "new salisbury"
  },
  {
    "text": "New Sarpy",
    "value": "new sarpy"
  },
  {
    "text": "New Sharon",
    "value": "new sharon"
  },
  {
    "text": "New Shoreham",
    "value": "new shoreham"
  },
  {
    "text": "New Site",
    "value": "new site"
  },
  {
    "text": "New Smyrna Beach",
    "value": "new smyrna beach"
  },
  {
    "text": "New Springfield",
    "value": "new springfield"
  },
  {
    "text": "New Square",
    "value": "new square"
  },
  {
    "text": "New Stanton",
    "value": "new stanton"
  },
  {
    "text": "New Straitsville",
    "value": "new straitsville"
  },
  {
    "text": "New Stuyahok",
    "value": "new stuyahok"
  },
  {
    "text": "New Suffolk",
    "value": "new suffolk"
  },
  {
    "text": "New Summerfield",
    "value": "new summerfield"
  },
  {
    "text": "New Sweden",
    "value": "new sweden"
  },
  {
    "text": "New Tazewell",
    "value": "new tazewell"
  },
  {
    "text": "New Town",
    "value": "new town"
  },
  {
    "text": "New Trenton",
    "value": "new trenton"
  },
  {
    "text": "New Tripoli",
    "value": "new tripoli"
  },
  {
    "text": "New Troy",
    "value": "new troy"
  },
  {
    "text": "New Ulm",
    "value": "new ulm"
  },
  {
    "text": "New Underwood",
    "value": "new underwood"
  },
  {
    "text": "New Vernon",
    "value": "new vernon"
  },
  {
    "text": "New Vienna",
    "value": "new vienna"
  },
  {
    "text": "New Vineyard",
    "value": "new vineyard"
  },
  {
    "text": "New Virginia",
    "value": "new virginia"
  },
  {
    "text": "New Washington",
    "value": "new washington"
  },
  {
    "text": "New Waterford",
    "value": "new waterford"
  },
  {
    "text": "New Waverly",
    "value": "new waverly"
  },
  {
    "text": "New Weston",
    "value": "new weston"
  },
  {
    "text": "New Whiteland",
    "value": "new whiteland"
  },
  {
    "text": "New Wilmington",
    "value": "new wilmington"
  },
  {
    "text": "New Windsor",
    "value": "new windsor"
  },
  {
    "text": "New Woodstock",
    "value": "new woodstock"
  },
  {
    "text": "New York",
    "value": "new york"
  },
  {
    "text": "New York City",
    "value": "new york city"
  },
  {
    "text": "New York County",
    "value": "new york county"
  },
  {
    "text": "New York Mills",
    "value": "new york mills"
  },
  {
    "text": "New Zion",
    "value": "new zion"
  },
  {
    "text": "Newalla",
    "value": "newalla"
  },
  {
    "text": "Newark",
    "value": "newark"
  },
  {
    "text": "Newark Valley",
    "value": "newark valley"
  },
  {
    "text": "Newaygo",
    "value": "newaygo"
  },
  {
    "text": "Newberg",
    "value": "newberg"
  },
  {
    "text": "Newbern",
    "value": "newbern"
  },
  {
    "text": "Newberry",
    "value": "newberry"
  },
  {
    "text": "Newberry Springs",
    "value": "newberry springs"
  },
  {
    "text": "Newborn",
    "value": "newborn"
  },
  {
    "text": "Newburg",
    "value": "newburg"
  },
  {
    "text": "Newburgh",
    "value": "newburgh"
  },
  {
    "text": "Newburgh Heights",
    "value": "newburgh heights"
  },
  {
    "text": "Newbury",
    "value": "newbury"
  },
  {
    "text": "Newbury Old Town",
    "value": "newbury old town"
  },
  {
    "text": "Newbury Park",
    "value": "newbury park"
  },
  {
    "text": "Newbury Township",
    "value": "newbury township"
  },
  {
    "text": "Newburyport",
    "value": "newburyport"
  },
  {
    "text": "Newcastle",
    "value": "newcastle"
  },
  {
    "text": "Newcomb",
    "value": "newcomb"
  },
  {
    "text": "Newcomerstown",
    "value": "newcomerstown"
  },
  {
    "text": "Newdale",
    "value": "newdale"
  },
  {
    "text": "Newell",
    "value": "newell"
  },
  {
    "text": "Newellton",
    "value": "newellton"
  },
  {
    "text": "Newfane",
    "value": "newfane"
  },
  {
    "text": "Newfield",
    "value": "newfield"
  },
  {
    "text": "Newfields",
    "value": "newfields"
  },
  {
    "text": "Newfolden",
    "value": "newfolden"
  },
  {
    "text": "Newfoundland",
    "value": "newfoundland"
  },
  {
    "text": "Newhall",
    "value": "newhall"
  },
  {
    "text": "Newhebron",
    "value": "newhebron"
  },
  {
    "text": "Newhope",
    "value": "newhope"
  },
  {
    "text": "Newington",
    "value": "newington"
  },
  {
    "text": "Newkirk",
    "value": "newkirk"
  },
  {
    "text": "Newland",
    "value": "newland"
  },
  {
    "text": "Newman",
    "value": "newman"
  },
  {
    "text": "Newman Grove",
    "value": "newman grove"
  },
  {
    "text": "Newman Lake",
    "value": "newman lake"
  },
  {
    "text": "Newmanstown",
    "value": "newmanstown"
  },
  {
    "text": "Newmarket",
    "value": "newmarket"
  },
  {
    "text": "Newnan",
    "value": "newnan"
  },
  {
    "text": "Newport",
    "value": "newport"
  },
  {
    "text": "Newport Beach",
    "value": "newport beach"
  },
  {
    "text": "Newport Center",
    "value": "newport center"
  },
  {
    "text": "Newport Coast",
    "value": "newport coast"
  },
  {
    "text": "Newport News",
    "value": "newport news"
  },
  {
    "text": "Newry",
    "value": "newry"
  },
  {
    "text": "Newsoms",
    "value": "newsoms"
  },
  {
    "text": "Newton",
    "value": "newton"
  },
  {
    "text": "Newton Center",
    "value": "newton center"
  },
  {
    "text": "Newton Centre",
    "value": "newton centre"
  },
  {
    "text": "Newton Corner",
    "value": "newton corner"
  },
  {
    "text": "Newton Falls",
    "value": "newton falls"
  },
  {
    "text": "Newton Grove",
    "value": "newton grove"
  },
  {
    "text": "Newton Highlands",
    "value": "newton highlands"
  },
  {
    "text": "Newton Lower Falls",
    "value": "newton lower falls"
  },
  {
    "text": "Newton Upper Falls",
    "value": "newton upper falls"
  },
  {
    "text": "Newtonville",
    "value": "newtonville"
  },
  {
    "text": "Newtown",
    "value": "newtown"
  },
  {
    "text": "Newtown Square",
    "value": "newtown square"
  },
  {
    "text": "Newville",
    "value": "newville"
  },
  {
    "text": "Ney",
    "value": "ney"
  },
  {
    "text": "Nezperce",
    "value": "nezperce"
  },
  {
    "text": "Niagara",
    "value": "niagara"
  },
  {
    "text": "Niagara Falls",
    "value": "niagara falls"
  },
  {
    "text": "Niangua",
    "value": "niangua"
  },
  {
    "text": "Niantic",
    "value": "niantic"
  },
  {
    "text": "Nibley",
    "value": "nibley"
  },
  {
    "text": "Nicasio",
    "value": "nicasio"
  },
  {
    "text": "Nice",
    "value": "nice"
  },
  {
    "text": "Niceville",
    "value": "niceville"
  },
  {
    "text": "Nicholasville",
    "value": "nicholasville"
  },
  {
    "text": "Nicholls",
    "value": "nicholls"
  },
  {
    "text": "Nichols",
    "value": "nichols"
  },
  {
    "text": "Nichols Hills",
    "value": "nichols hills"
  },
  {
    "text": "Nicholson",
    "value": "nicholson"
  },
  {
    "text": "Nicholville",
    "value": "nicholville"
  },
  {
    "text": "Nickelsville",
    "value": "nickelsville"
  },
  {
    "text": "Nickerson",
    "value": "nickerson"
  },
  {
    "text": "Nicktown",
    "value": "nicktown"
  },
  {
    "text": "Nicolaus",
    "value": "nicolaus"
  },
  {
    "text": "Nicollet",
    "value": "nicollet"
  },
  {
    "text": "Nikiski",
    "value": "nikiski"
  },
  {
    "text": "Niland",
    "value": "niland"
  },
  {
    "text": "Niles",
    "value": "niles"
  },
  {
    "text": "Nilwood",
    "value": "nilwood"
  },
  {
    "text": "Nimitz",
    "value": "nimitz"
  },
  {
    "text": "Nimrod",
    "value": "nimrod"
  },
  {
    "text": "Nine Mile Falls",
    "value": "nine mile falls"
  },
  {
    "text": "Ninety Six",
    "value": "ninety six"
  },
  {
    "text": "Nineveh",
    "value": "nineveh"
  },
  {
    "text": "Ninilchik",
    "value": "ninilchik"
  },
  {
    "text": "Ninnekah",
    "value": "ninnekah"
  },
  {
    "text": "Niobrara",
    "value": "niobrara"
  },
  {
    "text": "Niota",
    "value": "niota"
  },
  {
    "text": "Nipomo",
    "value": "nipomo"
  },
  {
    "text": "Nipton",
    "value": "nipton"
  },
  {
    "text": "Niskayuna",
    "value": "niskayuna"
  },
  {
    "text": "Nisswa",
    "value": "nisswa"
  },
  {
    "text": "Nitro",
    "value": "nitro"
  },
  {
    "text": "Niverville",
    "value": "niverville"
  },
  {
    "text": "Niwot",
    "value": "niwot"
  },
  {
    "text": "Nixa",
    "value": "nixa"
  },
  {
    "text": "Nixon",
    "value": "nixon"
  },
  {
    "text": "Noatak",
    "value": "noatak"
  },
  {
    "text": "Noble",
    "value": "noble"
  },
  {
    "text": "Nobleboro",
    "value": "nobleboro"
  },
  {
    "text": "Noblesville",
    "value": "noblesville"
  },
  {
    "text": "Nobleton",
    "value": "nobleton"
  },
  {
    "text": "Nocona",
    "value": "nocona"
  },
  {
    "text": "Nodaway",
    "value": "nodaway"
  },
  {
    "text": "Noel",
    "value": "noel"
  },
  {
    "text": "Nogal",
    "value": "nogal"
  },
  {
    "text": "Nogales",
    "value": "nogales"
  },
  {
    "text": "Nokesville",
    "value": "nokesville"
  },
  {
    "text": "Nokomis",
    "value": "nokomis"
  },
  {
    "text": "Nolanville",
    "value": "nolanville"
  },
  {
    "text": "Nolensville",
    "value": "nolensville"
  },
  {
    "text": "Noma",
    "value": "noma"
  },
  {
    "text": "Nome",
    "value": "nome"
  },
  {
    "text": "Nooksack",
    "value": "nooksack"
  },
  {
    "text": "Noonan",
    "value": "noonan"
  },
  {
    "text": "Noorvik",
    "value": "noorvik"
  },
  {
    "text": "Nora",
    "value": "nora"
  },
  {
    "text": "Nora Springs",
    "value": "nora springs"
  },
  {
    "text": "Norborne",
    "value": "norborne"
  },
  {
    "text": "Norcatur",
    "value": "norcatur"
  },
  {
    "text": "Norco",
    "value": "norco"
  },
  {
    "text": "Norcross",
    "value": "norcross"
  },
  {
    "text": "Norden",
    "value": "norden"
  },
  {
    "text": "Nordheim",
    "value": "nordheim"
  },
  {
    "text": "Nordman",
    "value": "nordman"
  },
  {
    "text": "Norfolk",
    "value": "norfolk"
  },
  {
    "text": "Norfork",
    "value": "norfork"
  },
  {
    "text": "Norge",
    "value": "norge"
  },
  {
    "text": "Norlina",
    "value": "norlina"
  },
  {
    "text": "Norma",
    "value": "norma"
  },
  {
    "text": "Normal",
    "value": "normal"
  },
  {
    "text": "Normalville",
    "value": "normalville"
  },
  {
    "text": "Norman",
    "value": "norman"
  },
  {
    "text": "Norman Park",
    "value": "norman park"
  },
  {
    "text": "Normandy",
    "value": "normandy"
  },
  {
    "text": "Normandy Beach",
    "value": "normandy beach"
  },
  {
    "text": "Normandy Park",
    "value": "normandy park"
  },
  {
    "text": "Normangee",
    "value": "normangee"
  },
  {
    "text": "Normantown",
    "value": "normantown"
  },
  {
    "text": "Norphlet",
    "value": "norphlet"
  },
  {
    "text": "Norridge",
    "value": "norridge"
  },
  {
    "text": "Norridgewock",
    "value": "norridgewock"
  },
  {
    "text": "Norris",
    "value": "norris"
  },
  {
    "text": "Norris City",
    "value": "norris city"
  },
  {
    "text": "Norristown",
    "value": "norristown"
  },
  {
    "text": "North",
    "value": "north"
  },
  {
    "text": "North Adams",
    "value": "north adams"
  },
  {
    "text": "North Amherst",
    "value": "north amherst"
  },
  {
    "text": "North Amityville",
    "value": "north amityville"
  },
  {
    "text": "North Andover",
    "value": "north andover"
  },
  {
    "text": "North Anson",
    "value": "north anson"
  },
  {
    "text": "North Apollo",
    "value": "north apollo"
  },
  {
    "text": "North Arlington",
    "value": "north arlington"
  },
  {
    "text": "North Atlanta",
    "value": "north atlanta"
  },
  {
    "text": "North Attleboro",
    "value": "north attleboro"
  },
  {
    "text": "North Attleborough",
    "value": "north attleborough"
  },
  {
    "text": "North Augusta",
    "value": "north augusta"
  },
  {
    "text": "North Aurora",
    "value": "north aurora"
  },
  {
    "text": "North Babylon",
    "value": "north babylon"
  },
  {
    "text": "North Baltimore",
    "value": "north baltimore"
  },
  {
    "text": "North Bangor",
    "value": "north bangor"
  },
  {
    "text": "North Barrington",
    "value": "north barrington"
  },
  {
    "text": "North Bay",
    "value": "north bay"
  },
  {
    "text": "North Bay Village",
    "value": "north bay village"
  },
  {
    "text": "North Beach",
    "value": "north beach"
  },
  {
    "text": "North Bellmore",
    "value": "north bellmore"
  },
  {
    "text": "North Bend",
    "value": "north bend"
  },
  {
    "text": "North Bennington",
    "value": "north bennington"
  },
  {
    "text": "North Benton",
    "value": "north benton"
  },
  {
    "text": "North Bergen",
    "value": "north bergen"
  },
  {
    "text": "North Berwick",
    "value": "north berwick"
  },
  {
    "text": "North Bethesda",
    "value": "north bethesda"
  },
  {
    "text": "North Billerica",
    "value": "north billerica"
  },
  {
    "text": "North Bloomfield",
    "value": "north bloomfield"
  },
  {
    "text": "North Bonneville",
    "value": "north bonneville"
  },
  {
    "text": "North Braddock",
    "value": "north braddock"
  },
  {
    "text": "North Branch",
    "value": "north branch"
  },
  {
    "text": "North Branford",
    "value": "north branford"
  },
  {
    "text": "North Bridgton",
    "value": "north bridgton"
  },
  {
    "text": "North Brookfield",
    "value": "north brookfield"
  },
  {
    "text": "North Brooksville",
    "value": "north brooksville"
  },
  {
    "text": "North Browning",
    "value": "north browning"
  },
  {
    "text": "North Brunswick",
    "value": "north brunswick"
  },
  {
    "text": "North Brunswick Township",
    "value": "north brunswick township"
  },
  {
    "text": "North Calais",
    "value": "north calais"
  },
  {
    "text": "North Caldwell",
    "value": "north caldwell"
  },
  {
    "text": "North Canton",
    "value": "north canton"
  },
  {
    "text": "North Cape May",
    "value": "north cape may"
  },
  {
    "text": "North Catasauqua",
    "value": "north catasauqua"
  },
  {
    "text": "North Charleston",
    "value": "north charleston"
  },
  {
    "text": "North Chatham",
    "value": "north chatham"
  },
  {
    "text": "North Chelmsford",
    "value": "north chelmsford"
  },
  {
    "text": "North Chicago",
    "value": "north chicago"
  },
  {
    "text": "North Chili",
    "value": "north chili"
  },
  {
    "text": "North Clarendon",
    "value": "north clarendon"
  },
  {
    "text": "North College Hill",
    "value": "north college hill"
  },
  {
    "text": "North Collins",
    "value": "north collins"
  },
  {
    "text": "North Concord",
    "value": "north concord"
  },
  {
    "text": "North Conway",
    "value": "north conway"
  },
  {
    "text": "North Corbin",
    "value": "north corbin"
  },
  {
    "text": "North Creek",
    "value": "north creek"
  },
  {
    "text": "North Crossett",
    "value": "north crossett"
  },
  {
    "text": "North Dartmouth",
    "value": "north dartmouth"
  },
  {
    "text": "North DeLand",
    "value": "north deland"
  },
  {
    "text": "North Dighton",
    "value": "north dighton"
  },
  {
    "text": "North Eagle Butte",
    "value": "north eagle butte"
  },
  {
    "text": "North East",
    "value": "north east"
  },
  {
    "text": "North Eastham",
    "value": "north eastham"
  },
  {
    "text": "North Easton",
    "value": "north easton"
  },
  {
    "text": "North Edwards",
    "value": "north edwards"
  },
  {
    "text": "North English",
    "value": "north english"
  },
  {
    "text": "North Fair Oaks",
    "value": "north fair oaks"
  },
  {
    "text": "North Fairfield",
    "value": "north fairfield"
  },
  {
    "text": "North Falmouth",
    "value": "north falmouth"
  },
  {
    "text": "North Ferrisburgh",
    "value": "north ferrisburgh"
  },
  {
    "text": "North Fond du Lac",
    "value": "north fond du lac"
  },
  {
    "text": "North Fork",
    "value": "north fork"
  },
  {
    "text": "North Fort Myers",
    "value": "north fort myers"
  },
  {
    "text": "North Franklin",
    "value": "north franklin"
  },
  {
    "text": "North Freedom",
    "value": "north freedom"
  },
  {
    "text": "North Garden",
    "value": "north garden"
  },
  {
    "text": "North Gates",
    "value": "north gates"
  },
  {
    "text": "North Georgetown",
    "value": "north georgetown"
  },
  {
    "text": "North Grafton",
    "value": "north grafton"
  },
  {
    "text": "North Granby",
    "value": "north granby"
  },
  {
    "text": "North Greece",
    "value": "north greece"
  },
  {
    "text": "North Grosvenor Dale",
    "value": "north grosvenor dale"
  },
  {
    "text": "North Haledon",
    "value": "north haledon"
  },
  {
    "text": "North Hampton",
    "value": "north hampton"
  },
  {
    "text": "North Hartland",
    "value": "north hartland"
  },
  {
    "text": "North Hatfield",
    "value": "north hatfield"
  },
  {
    "text": "North Haven",
    "value": "north haven"
  },
  {
    "text": "North Haverhill",
    "value": "north haverhill"
  },
  {
    "text": "North Henderson",
    "value": "north henderson"
  },
  {
    "text": "North Hero",
    "value": "north hero"
  },
  {
    "text": "North Highlands",
    "value": "north highlands"
  },
  {
    "text": "North Hills",
    "value": "north hills"
  },
  {
    "text": "North Hollywood",
    "value": "north hollywood"
  },
  {
    "text": "North Hoosick",
    "value": "north hoosick"
  },
  {
    "text": "North Houston",
    "value": "north houston"
  },
  {
    "text": "North Hudson",
    "value": "north hudson"
  },
  {
    "text": "North Hyde Park",
    "value": "north hyde park"
  },
  {
    "text": "North Jackson",
    "value": "north jackson"
  },
  {
    "text": "North Java",
    "value": "north java"
  },
  {
    "text": "North Judson",
    "value": "north judson"
  },
  {
    "text": "North Kansas City",
    "value": "north kansas city"
  },
  {
    "text": "North Kingstown",
    "value": "north kingstown"
  },
  {
    "text": "North Kingsville",
    "value": "north kingsville"
  },
  {
    "text": "North Lake",
    "value": "north lake"
  },
  {
    "text": "North Lakeport",
    "value": "north lakeport"
  },
  {
    "text": "North Las Vegas",
    "value": "north las vegas"
  },
  {
    "text": "North Lauderdale",
    "value": "north lauderdale"
  },
  {
    "text": "North Lawrence",
    "value": "north lawrence"
  },
  {
    "text": "North Lewisburg",
    "value": "north lewisburg"
  },
  {
    "text": "North Liberty",
    "value": "north liberty"
  },
  {
    "text": "North Lima",
    "value": "north lima"
  },
  {
    "text": "North Lindenhurst",
    "value": "north lindenhurst"
  },
  {
    "text": "North Little Rock",
    "value": "north little rock"
  },
  {
    "text": "North Logan",
    "value": "north logan"
  },
  {
    "text": "North Loup",
    "value": "north loup"
  },
  {
    "text": "North Madison",
    "value": "north madison"
  },
  {
    "text": "North Manchester",
    "value": "north manchester"
  },
  {
    "text": "North Mankato",
    "value": "north mankato"
  },
  {
    "text": "North Marshfield",
    "value": "north marshfield"
  },
  {
    "text": "North Massapequa",
    "value": "north massapequa"
  },
  {
    "text": "North Matewan",
    "value": "north matewan"
  },
  {
    "text": "North Merrick",
    "value": "north merrick"
  },
  {
    "text": "North Metro",
    "value": "north metro"
  },
  {
    "text": "North Miami",
    "value": "north miami"
  },
  {
    "text": "North Miami Beach",
    "value": "north miami beach"
  },
  {
    "text": "North Middleton Township",
    "value": "north middleton township"
  },
  {
    "text": "North Middletown",
    "value": "north middletown"
  },
  {
    "text": "North Monmouth",
    "value": "north monmouth"
  },
  {
    "text": "North Montpelier",
    "value": "north montpelier"
  },
  {
    "text": "North Muskegon",
    "value": "north muskegon"
  },
  {
    "text": "North Myrtle Beach",
    "value": "north myrtle beach"
  },
  {
    "text": "North Naples",
    "value": "north naples"
  },
  {
    "text": "North New Hyde Park",
    "value": "north new hyde park"
  },
  {
    "text": "North Newton",
    "value": "north newton"
  },
  {
    "text": "North Newton Township",
    "value": "north newton township"
  },
  {
    "text": "North Norwich",
    "value": "north norwich"
  },
  {
    "text": "North Oaks",
    "value": "north oaks"
  },
  {
    "text": "North Ogden",
    "value": "north ogden"
  },
  {
    "text": "North Olmsted",
    "value": "north olmsted"
  },
  {
    "text": "North Oxford",
    "value": "north oxford"
  },
  {
    "text": "North Palm Beach",
    "value": "north palm beach"
  },
  {
    "text": "North Palm Springs",
    "value": "north palm springs"
  },
  {
    "text": "North Pekin",
    "value": "north pekin"
  },
  {
    "text": "North Peoria",
    "value": "north peoria"
  },
  {
    "text": "North Plainfield",
    "value": "north plainfield"
  },
  {
    "text": "North Plains",
    "value": "north plains"
  },
  {
    "text": "North Platte",
    "value": "north platte"
  },
  {
    "text": "North Pole",
    "value": "north pole"
  },
  {
    "text": "North Pomfret",
    "value": "north pomfret"
  },
  {
    "text": "North Port",
    "value": "north port"
  },
  {
    "text": "North Potomac",
    "value": "north potomac"
  },
  {
    "text": "North Powder",
    "value": "north powder"
  },
  {
    "text": "North Prairie",
    "value": "north prairie"
  },
  {
    "text": "North Providence",
    "value": "north providence"
  },
  {
    "text": "North Quincy",
    "value": "north quincy"
  },
  {
    "text": "North Randall",
    "value": "north randall"
  },
  {
    "text": "North Reading",
    "value": "north reading"
  },
  {
    "text": "North Redington Beach",
    "value": "north redington beach"
  },
  {
    "text": "North Richland Hills",
    "value": "north richland hills"
  },
  {
    "text": "North Ridgeville",
    "value": "north ridgeville"
  },
  {
    "text": "North Rim",
    "value": "north rim"
  },
  {
    "text": "North River",
    "value": "north river"
  },
  {
    "text": "North Riverside",
    "value": "north riverside"
  },
  {
    "text": "North Rose",
    "value": "north rose"
  },
  {
    "text": "North Royalton",
    "value": "north royalton"
  },
  {
    "text": "North Saint Paul",
    "value": "north saint paul"
  },
  {
    "text": "North Salem",
    "value": "north salem"
  },
  {
    "text": "North Salt Lake",
    "value": "north salt lake"
  },
  {
    "text": "North San Juan",
    "value": "north san juan"
  },
  {
    "text": "North Scituate",
    "value": "north scituate"
  },
  {
    "text": "North Sea",
    "value": "north sea"
  },
  {
    "text": "North Sioux City",
    "value": "north sioux city"
  },
  {
    "text": "North Smithfield",
    "value": "north smithfield"
  },
  {
    "text": "North Spearfish",
    "value": "north spearfish"
  },
  {
    "text": "North Springfield",
    "value": "north springfield"
  },
  {
    "text": "North Stamford",
    "value": "north stamford"
  },
  {
    "text": "North Star",
    "value": "north star"
  },
  {
    "text": "North Stonington",
    "value": "north stonington"
  },
  {
    "text": "North Stratford",
    "value": "north stratford"
  },
  {
    "text": "North Street",
    "value": "north street"
  },
  {
    "text": "North Sutton",
    "value": "north sutton"
  },
  {
    "text": "North Syracuse",
    "value": "north syracuse"
  },
  {
    "text": "North Tazewell",
    "value": "north tazewell"
  },
  {
    "text": "North Thetford",
    "value": "north thetford"
  },
  {
    "text": "North Tonawanda",
    "value": "north tonawanda"
  },
  {
    "text": "North Troy",
    "value": "north troy"
  },
  {
    "text": "North Truro",
    "value": "north truro"
  },
  {
    "text": "North Turner",
    "value": "north turner"
  },
  {
    "text": "North Valley Stream",
    "value": "north valley stream"
  },
  {
    "text": "North Vernon",
    "value": "north vernon"
  },
  {
    "text": "North Versailles",
    "value": "north versailles"
  },
  {
    "text": "North Wales",
    "value": "north wales"
  },
  {
    "text": "North Walpole",
    "value": "north walpole"
  },
  {
    "text": "North Waltham",
    "value": "north waltham"
  },
  {
    "text": "North Warren",
    "value": "north warren"
  },
  {
    "text": "North Washington",
    "value": "north washington"
  },
  {
    "text": "North Waterboro",
    "value": "north waterboro"
  },
  {
    "text": "North Webster",
    "value": "north webster"
  },
  {
    "text": "North Weeki Wachee",
    "value": "north weeki wachee"
  },
  {
    "text": "North Weems",
    "value": "north weems"
  },
  {
    "text": "North Weymouth",
    "value": "north weymouth"
  },
  {
    "text": "North Wildwood",
    "value": "north wildwood"
  },
  {
    "text": "North Wilkesboro",
    "value": "north wilkesboro"
  },
  {
    "text": "North Windham",
    "value": "north windham"
  },
  {
    "text": "North Woodstock",
    "value": "north woodstock"
  },
  {
    "text": "North Yarmouth",
    "value": "north yarmouth"
  },
  {
    "text": "North Zulch",
    "value": "north zulch"
  },
  {
    "text": "Northampton",
    "value": "northampton"
  },
  {
    "text": "Northboro",
    "value": "northboro"
  },
  {
    "text": "Northborough",
    "value": "northborough"
  },
  {
    "text": "Northbridge",
    "value": "northbridge"
  },
  {
    "text": "Northbrook",
    "value": "northbrook"
  },
  {
    "text": "Northeast Harbor",
    "value": "northeast harbor"
  },
  {
    "text": "Northern Cambria",
    "value": "northern cambria"
  },
  {
    "text": "Northfield",
    "value": "northfield"
  },
  {
    "text": "Northfield Falls",
    "value": "northfield falls"
  },
  {
    "text": "Northford",
    "value": "northford"
  },
  {
    "text": "Northfork",
    "value": "northfork"
  },
  {
    "text": "Northgate",
    "value": "northgate"
  },
  {
    "text": "Northglenn",
    "value": "northglenn"
  },
  {
    "text": "Northlake",
    "value": "northlake"
  },
  {
    "text": "Northome",
    "value": "northome"
  },
  {
    "text": "Northport",
    "value": "northport"
  },
  {
    "text": "Northridge",
    "value": "northridge"
  },
  {
    "text": "Northumberland",
    "value": "northumberland"
  },
  {
    "text": "Northvale",
    "value": "northvale"
  },
  {
    "text": "Northview",
    "value": "northview"
  },
  {
    "text": "Northville",
    "value": "northville"
  },
  {
    "text": "Northway",
    "value": "northway"
  },
  {
    "text": "Northwest Harbor",
    "value": "northwest harbor"
  },
  {
    "text": "Northwest Harwich",
    "value": "northwest harwich"
  },
  {
    "text": "Northwest Ithaca",
    "value": "northwest ithaca"
  },
  {
    "text": "Northwood",
    "value": "northwood"
  },
  {
    "text": "Northwoods",
    "value": "northwoods"
  },
  {
    "text": "Norton",
    "value": "norton"
  },
  {
    "text": "Norton Shores",
    "value": "norton shores"
  },
  {
    "text": "Nortonville",
    "value": "nortonville"
  },
  {
    "text": "Norvell",
    "value": "norvell"
  },
  {
    "text": "Norwalk",
    "value": "norwalk"
  },
  {
    "text": "Norway",
    "value": "norway"
  },
  {
    "text": "Norwell",
    "value": "norwell"
  },
  {
    "text": "Norwich",
    "value": "norwich"
  },
  {
    "text": "Norwood",
    "value": "norwood"
  },
  {
    "text": "Norwood Young America",
    "value": "norwood young america"
  },
  {
    "text": "Notasulga",
    "value": "notasulga"
  },
  {
    "text": "Noti",
    "value": "noti"
  },
  {
    "text": "Notre Dame",
    "value": "notre dame"
  },
  {
    "text": "Nottawa",
    "value": "nottawa"
  },
  {
    "text": "Nottingham",
    "value": "nottingham"
  },
  {
    "text": "Nova",
    "value": "nova"
  },
  {
    "text": "Novato",
    "value": "novato"
  },
  {
    "text": "Novelty",
    "value": "novelty"
  },
  {
    "text": "Novi",
    "value": "novi"
  },
  {
    "text": "Novice",
    "value": "novice"
  },
  {
    "text": "Novinger",
    "value": "novinger"
  },
  {
    "text": "Nowata",
    "value": "nowata"
  },
  {
    "text": "Nowthen",
    "value": "nowthen"
  },
  {
    "text": "Noxapater",
    "value": "noxapater"
  },
  {
    "text": "Noxen",
    "value": "noxen"
  },
  {
    "text": "Noxon",
    "value": "noxon"
  },
  {
    "text": "Noyes",
    "value": "noyes"
  },
  {
    "text": "Nucla",
    "value": "nucla"
  },
  {
    "text": "Nuevo",
    "value": "nuevo"
  },
  {
    "text": "Nuiqsut",
    "value": "nuiqsut"
  },
  {
    "text": "Nunam Iqua",
    "value": "nunam iqua"
  },
  {
    "text": "Nunapitchuk",
    "value": "nunapitchuk"
  },
  {
    "text": "Nunda",
    "value": "nunda"
  },
  {
    "text": "Nunez",
    "value": "nunez"
  },
  {
    "text": "Nunica",
    "value": "nunica"
  },
  {
    "text": "Nunn",
    "value": "nunn"
  },
  {
    "text": "Nunnelly",
    "value": "nunnelly"
  },
  {
    "text": "Nuremberg",
    "value": "nuremberg"
  },
  {
    "text": "Nursery",
    "value": "nursery"
  },
  {
    "text": "Nutley",
    "value": "nutley"
  },
  {
    "text": "Nutrioso",
    "value": "nutrioso"
  },
  {
    "text": "Nutting Lake",
    "value": "nutting lake"
  },
  {
    "text": "Nyack",
    "value": "nyack"
  },
  {
    "text": "Nye",
    "value": "nye"
  },
  {
    "text": "Nyssa",
    "value": "nyssa"
  },
  {
    "text": "Nīnole",
    "value": "nīnole"
  },
  {
    "text": "O'Brien",
    "value": "o'brien"
  },
  {
    "text": "O'Donnell",
    "value": "o'donnell"
  },
  {
    "text": "O'Fallon",
    "value": "o'fallon"
  },
  {
    "text": "O'Neals",
    "value": "o'neals"
  },
  {
    "text": "O'Neill",
    "value": "o'neill"
  },
  {
    "text": "Oacoma",
    "value": "oacoma"
  },
  {
    "text": "Oak",
    "value": "oak"
  },
  {
    "text": "Oak Bluffs",
    "value": "oak bluffs"
  },
  {
    "text": "Oak Brook",
    "value": "oak brook"
  },
  {
    "text": "Oak City",
    "value": "oak city"
  },
  {
    "text": "Oak Cliff Place",
    "value": "oak cliff place"
  },
  {
    "text": "Oak Creek",
    "value": "oak creek"
  },
  {
    "text": "Oak Forest",
    "value": "oak forest"
  },
  {
    "text": "Oak Grove",
    "value": "oak grove"
  },
  {
    "text": "Oak Hall",
    "value": "oak hall"
  },
  {
    "text": "Oak Harbor",
    "value": "oak harbor"
  },
  {
    "text": "Oak Hill",
    "value": "oak hill"
  },
  {
    "text": "Oak Hills",
    "value": "oak hills"
  },
  {
    "text": "Oak Island",
    "value": "oak island"
  },
  {
    "text": "Oak Lawn",
    "value": "oak lawn"
  },
  {
    "text": "Oak Leaf",
    "value": "oak leaf"
  },
  {
    "text": "Oak Park",
    "value": "oak park"
  },
  {
    "text": "Oak Park Heights",
    "value": "oak park heights"
  },
  {
    "text": "Oak Point",
    "value": "oak point"
  },
  {
    "text": "Oak Ridge",
    "value": "oak ridge"
  },
  {
    "text": "Oak Ridge North",
    "value": "oak ridge north"
  },
  {
    "text": "Oak Run",
    "value": "oak run"
  },
  {
    "text": "Oak Vale",
    "value": "oak vale"
  },
  {
    "text": "Oak View",
    "value": "oak view"
  },
  {
    "text": "Oakboro",
    "value": "oakboro"
  },
  {
    "text": "Oakbrook",
    "value": "oakbrook"
  },
  {
    "text": "Oakbrook Terrace",
    "value": "oakbrook terrace"
  },
  {
    "text": "Oakdale",
    "value": "oakdale"
  },
  {
    "text": "Oakes",
    "value": "oakes"
  },
  {
    "text": "Oakesdale",
    "value": "oakesdale"
  },
  {
    "text": "Oakfield",
    "value": "oakfield"
  },
  {
    "text": "Oakford",
    "value": "oakford"
  },
  {
    "text": "Oakgrove",
    "value": "oakgrove"
  },
  {
    "text": "Oakham",
    "value": "oakham"
  },
  {
    "text": "Oakhurst",
    "value": "oakhurst"
  },
  {
    "text": "Oakland",
    "value": "oakland"
  },
  {
    "text": "Oakland City",
    "value": "oakland city"
  },
  {
    "text": "Oakland Estates Mobile Home Park",
    "value": "oakland estates mobile home park"
  },
  {
    "text": "Oakland Gardens",
    "value": "oakland gardens"
  },
  {
    "text": "Oakland Mills",
    "value": "oakland mills"
  },
  {
    "text": "Oakland Park",
    "value": "oakland park"
  },
  {
    "text": "Oakley",
    "value": "oakley"
  },
  {
    "text": "Oaklyn",
    "value": "oaklyn"
  },
  {
    "text": "Oakman",
    "value": "oakman"
  },
  {
    "text": "Oakmont",
    "value": "oakmont"
  },
  {
    "text": "Oakpark",
    "value": "oakpark"
  },
  {
    "text": "Oakridge",
    "value": "oakridge"
  },
  {
    "text": "Oaks",
    "value": "oaks"
  },
  {
    "text": "Oaks Corners",
    "value": "oaks corners"
  },
  {
    "text": "Oakton",
    "value": "oakton"
  },
  {
    "text": "Oaktown",
    "value": "oaktown"
  },
  {
    "text": "Oakvale",
    "value": "oakvale"
  },
  {
    "text": "Oakville",
    "value": "oakville"
  },
  {
    "text": "Oakwood",
    "value": "oakwood"
  },
  {
    "text": "Oakwood Village",
    "value": "oakwood village"
  },
  {
    "text": "Oberlin",
    "value": "oberlin"
  },
  {
    "text": "Obernburg",
    "value": "obernburg"
  },
  {
    "text": "Obetz",
    "value": "obetz"
  },
  {
    "text": "Obion",
    "value": "obion"
  },
  {
    "text": "Oblong",
    "value": "oblong"
  },
  {
    "text": "Ocala",
    "value": "ocala"
  },
  {
    "text": "Occidental",
    "value": "occidental"
  },
  {
    "text": "Occoquan",
    "value": "occoquan"
  },
  {
    "text": "Ocean City",
    "value": "ocean city"
  },
  {
    "text": "Ocean Gate",
    "value": "ocean gate"
  },
  {
    "text": "Ocean Grove",
    "value": "ocean grove"
  },
  {
    "text": "Ocean Isle Beach",
    "value": "ocean isle beach"
  },
  {
    "text": "Ocean Park",
    "value": "ocean park"
  },
  {
    "text": "Ocean Pines",
    "value": "ocean pines"
  },
  {
    "text": "Ocean Shores",
    "value": "ocean shores"
  },
  {
    "text": "Ocean Springs",
    "value": "ocean springs"
  },
  {
    "text": "Ocean View",
    "value": "ocean view"
  },
  {
    "text": "Oceana",
    "value": "oceana"
  },
  {
    "text": "Oceano",
    "value": "oceano"
  },
  {
    "text": "Oceanport",
    "value": "oceanport"
  },
  {
    "text": "Oceanside",
    "value": "oceanside"
  },
  {
    "text": "Oceanville",
    "value": "oceanville"
  },
  {
    "text": "Oceola",
    "value": "oceola"
  },
  {
    "text": "Ochelata",
    "value": "ochelata"
  },
  {
    "text": "Ocheyedan",
    "value": "ocheyedan"
  },
  {
    "text": "Ochlocknee",
    "value": "ochlocknee"
  },
  {
    "text": "Ochopee",
    "value": "ochopee"
  },
  {
    "text": "Ocilla",
    "value": "ocilla"
  },
  {
    "text": "Ocklawaha",
    "value": "ocklawaha"
  },
  {
    "text": "Ocoee",
    "value": "ocoee"
  },
  {
    "text": "Oconee",
    "value": "oconee"
  },
  {
    "text": "Oconomowoc",
    "value": "oconomowoc"
  },
  {
    "text": "Oconto",
    "value": "oconto"
  },
  {
    "text": "Oconto Falls",
    "value": "oconto falls"
  },
  {
    "text": "Ocotillo",
    "value": "ocotillo"
  },
  {
    "text": "Ocracoke",
    "value": "ocracoke"
  },
  {
    "text": "Odanah",
    "value": "odanah"
  },
  {
    "text": "Odebolt",
    "value": "odebolt"
  },
  {
    "text": "Odell",
    "value": "odell"
  },
  {
    "text": "Odem",
    "value": "odem"
  },
  {
    "text": "Oden",
    "value": "oden"
  },
  {
    "text": "Odenton",
    "value": "odenton"
  },
  {
    "text": "Odenville",
    "value": "odenville"
  },
  {
    "text": "Odessa",
    "value": "odessa"
  },
  {
    "text": "Odiak",
    "value": "odiak"
  },
  {
    "text": "Odin",
    "value": "odin"
  },
  {
    "text": "Odon",
    "value": "odon"
  },
  {
    "text": "Odum",
    "value": "odum"
  },
  {
    "text": "Oelrichs",
    "value": "oelrichs"
  },
  {
    "text": "Oelwein",
    "value": "oelwein"
  },
  {
    "text": "Offerle",
    "value": "offerle"
  },
  {
    "text": "Offutt Air Force Base",
    "value": "offutt air force base"
  },
  {
    "text": "Ogallah",
    "value": "ogallah"
  },
  {
    "text": "Ogallala",
    "value": "ogallala"
  },
  {
    "text": "Ogden",
    "value": "ogden"
  },
  {
    "text": "Ogdensburg",
    "value": "ogdensburg"
  },
  {
    "text": "Ogema",
    "value": "ogema"
  },
  {
    "text": "Ogilvie",
    "value": "ogilvie"
  },
  {
    "text": "Oglala",
    "value": "oglala"
  },
  {
    "text": "Oglesby",
    "value": "oglesby"
  },
  {
    "text": "Oglethorpe",
    "value": "oglethorpe"
  },
  {
    "text": "Ogunquit",
    "value": "ogunquit"
  },
  {
    "text": "Ohatchee",
    "value": "ohatchee"
  },
  {
    "text": "Ohio",
    "value": "ohio"
  },
  {
    "text": "Ohio City",
    "value": "ohio city"
  },
  {
    "text": "Ohiopyle",
    "value": "ohiopyle"
  },
  {
    "text": "Ohiowa",
    "value": "ohiowa"
  },
  {
    "text": "Ohkay Owingeh",
    "value": "ohkay owingeh"
  },
  {
    "text": "Ohlman",
    "value": "ohlman"
  },
  {
    "text": "Oil City",
    "value": "oil city"
  },
  {
    "text": "Oil Springs",
    "value": "oil springs"
  },
  {
    "text": "Oil Trough",
    "value": "oil trough"
  },
  {
    "text": "Oildale",
    "value": "oildale"
  },
  {
    "text": "Oilmont",
    "value": "oilmont"
  },
  {
    "text": "Oilton",
    "value": "oilton"
  },
  {
    "text": "Oilville",
    "value": "oilville"
  },
  {
    "text": "Ojai",
    "value": "ojai"
  },
  {
    "text": "Ojibwa",
    "value": "ojibwa"
  },
  {
    "text": "Ojo Caliente",
    "value": "ojo caliente"
  },
  {
    "text": "Ojus",
    "value": "ojus"
  },
  {
    "text": "Okabena",
    "value": "okabena"
  },
  {
    "text": "Okahumpka",
    "value": "okahumpka"
  },
  {
    "text": "Okanogan",
    "value": "okanogan"
  },
  {
    "text": "Okarche",
    "value": "okarche"
  },
  {
    "text": "Okatie",
    "value": "okatie"
  },
  {
    "text": "Okaton",
    "value": "okaton"
  },
  {
    "text": "Okauchee",
    "value": "okauchee"
  },
  {
    "text": "Okauchee Lake",
    "value": "okauchee lake"
  },
  {
    "text": "Okawville",
    "value": "okawville"
  },
  {
    "text": "Okeana",
    "value": "okeana"
  },
  {
    "text": "Okeechobee",
    "value": "okeechobee"
  },
  {
    "text": "Okeene",
    "value": "okeene"
  },
  {
    "text": "Okemah",
    "value": "okemah"
  },
  {
    "text": "Okemos",
    "value": "okemos"
  },
  {
    "text": "Oketo",
    "value": "oketo"
  },
  {
    "text": "Oklahoma City",
    "value": "oklahoma city"
  },
  {
    "text": "Oklaunion",
    "value": "oklaunion"
  },
  {
    "text": "Oklee",
    "value": "oklee"
  },
  {
    "text": "Okmulgee",
    "value": "okmulgee"
  },
  {
    "text": "Okoboji",
    "value": "okoboji"
  },
  {
    "text": "Okolona",
    "value": "okolona"
  },
  {
    "text": "Okreek",
    "value": "okreek"
  },
  {
    "text": "Oktaha",
    "value": "oktaha"
  },
  {
    "text": "Ola",
    "value": "ola"
  },
  {
    "text": "Olalla",
    "value": "olalla"
  },
  {
    "text": "Olancha",
    "value": "olancha"
  },
  {
    "text": "Olanta",
    "value": "olanta"
  },
  {
    "text": "Olar",
    "value": "olar"
  },
  {
    "text": "Olathe",
    "value": "olathe"
  },
  {
    "text": "Olaton",
    "value": "olaton"
  },
  {
    "text": "Olcott",
    "value": "olcott"
  },
  {
    "text": "Old Appleton",
    "value": "old appleton"
  },
  {
    "text": "Old Bethpage",
    "value": "old bethpage"
  },
  {
    "text": "Old Bridge",
    "value": "old bridge"
  },
  {
    "text": "Old Brookville",
    "value": "old brookville"
  },
  {
    "text": "Old Chatham",
    "value": "old chatham"
  },
  {
    "text": "Old Fields",
    "value": "old fields"
  },
  {
    "text": "Old Forge",
    "value": "old forge"
  },
  {
    "text": "Old Fort",
    "value": "old fort"
  },
  {
    "text": "Old Glory",
    "value": "old glory"
  },
  {
    "text": "Old Greenwich",
    "value": "old greenwich"
  },
  {
    "text": "Old Hickory",
    "value": "old hickory"
  },
  {
    "text": "Old Houston Place",
    "value": "old houston place"
  },
  {
    "text": "Old Lyme",
    "value": "old lyme"
  },
  {
    "text": "Old Monroe",
    "value": "old monroe"
  },
  {
    "text": "Old Ocean",
    "value": "old ocean"
  },
  {
    "text": "Old Orchard Beach",
    "value": "old orchard beach"
  },
  {
    "text": "Old Pekin",
    "value": "old pekin"
  },
  {
    "text": "Old Peru",
    "value": "old peru"
  },
  {
    "text": "Old Point Station",
    "value": "old point station"
  },
  {
    "text": "Old Saybrook",
    "value": "old saybrook"
  },
  {
    "text": "Old Tappan",
    "value": "old tappan"
  },
  {
    "text": "Old Town",
    "value": "old town"
  },
  {
    "text": "Old Washington",
    "value": "old washington"
  },
  {
    "text": "Old Westbury",
    "value": "old westbury"
  },
  {
    "text": "Oldenburg",
    "value": "oldenburg"
  },
  {
    "text": "Oldfield",
    "value": "oldfield"
  },
  {
    "text": "Oldham",
    "value": "oldham"
  },
  {
    "text": "Olds",
    "value": "olds"
  },
  {
    "text": "Oldsmar",
    "value": "oldsmar"
  },
  {
    "text": "Oldtown",
    "value": "oldtown"
  },
  {
    "text": "Oldwick",
    "value": "oldwick"
  },
  {
    "text": "Olean",
    "value": "olean"
  },
  {
    "text": "Olema",
    "value": "olema"
  },
  {
    "text": "Oley",
    "value": "oley"
  },
  {
    "text": "Olga",
    "value": "olga"
  },
  {
    "text": "Olin",
    "value": "olin"
  },
  {
    "text": "Olinda",
    "value": "olinda"
  },
  {
    "text": "Olive",
    "value": "olive"
  },
  {
    "text": "Olive Branch",
    "value": "olive branch"
  },
  {
    "text": "Olive Hill",
    "value": "olive hill"
  },
  {
    "text": "Olivebridge",
    "value": "olivebridge"
  },
  {
    "text": "Olivehill",
    "value": "olivehill"
  },
  {
    "text": "Olivehurst",
    "value": "olivehurst"
  },
  {
    "text": "Oliver Springs",
    "value": "oliver springs"
  },
  {
    "text": "Olivet",
    "value": "olivet"
  },
  {
    "text": "Olivette",
    "value": "olivette"
  },
  {
    "text": "Olivia",
    "value": "olivia"
  },
  {
    "text": "Oljato-Monument Valley",
    "value": "oljato-monument valley"
  },
  {
    "text": "Olla",
    "value": "olla"
  },
  {
    "text": "Ollie",
    "value": "ollie"
  },
  {
    "text": "Olmito",
    "value": "olmito"
  },
  {
    "text": "Olmitz",
    "value": "olmitz"
  },
  {
    "text": "Olmos Park",
    "value": "olmos park"
  },
  {
    "text": "Olmstead",
    "value": "olmstead"
  },
  {
    "text": "Olmsted",
    "value": "olmsted"
  },
  {
    "text": "Olmsted Falls",
    "value": "olmsted falls"
  },
  {
    "text": "Olmstedville",
    "value": "olmstedville"
  },
  {
    "text": "Olney",
    "value": "olney"
  },
  {
    "text": "Olney Springs",
    "value": "olney springs"
  },
  {
    "text": "Olpe",
    "value": "olpe"
  },
  {
    "text": "Olsburg",
    "value": "olsburg"
  },
  {
    "text": "Olton",
    "value": "olton"
  },
  {
    "text": "Olustee",
    "value": "olustee"
  },
  {
    "text": "Olympia",
    "value": "olympia"
  },
  {
    "text": "Olympia Fields",
    "value": "olympia fields"
  },
  {
    "text": "Olympic Valley",
    "value": "olympic valley"
  },
  {
    "text": "Olyphant",
    "value": "olyphant"
  },
  {
    "text": "Omaha",
    "value": "omaha"
  },
  {
    "text": "Omak",
    "value": "omak"
  },
  {
    "text": "Omar",
    "value": "omar"
  },
  {
    "text": "Omega",
    "value": "omega"
  },
  {
    "text": "Omena",
    "value": "omena"
  },
  {
    "text": "Omer",
    "value": "omer"
  },
  {
    "text": "Omro",
    "value": "omro"
  },
  {
    "text": "Ona",
    "value": "ona"
  },
  {
    "text": "Onaga",
    "value": "onaga"
  },
  {
    "text": "Onaka",
    "value": "onaka"
  },
  {
    "text": "Onalaska",
    "value": "onalaska"
  },
  {
    "text": "Onamia",
    "value": "onamia"
  },
  {
    "text": "Onancock",
    "value": "onancock"
  },
  {
    "text": "Onarga",
    "value": "onarga"
  },
  {
    "text": "Onawa",
    "value": "onawa"
  },
  {
    "text": "Onaway",
    "value": "onaway"
  },
  {
    "text": "Oneco",
    "value": "oneco"
  },
  {
    "text": "Oneida",
    "value": "oneida"
  },
  {
    "text": "Onekama",
    "value": "onekama"
  },
  {
    "text": "Onemo",
    "value": "onemo"
  },
  {
    "text": "Oneonta",
    "value": "oneonta"
  },
  {
    "text": "Ong",
    "value": "ong"
  },
  {
    "text": "Onida",
    "value": "onida"
  },
  {
    "text": "Onion Creek",
    "value": "onion creek"
  },
  {
    "text": "Onion Spring",
    "value": "onion spring"
  },
  {
    "text": "Onley",
    "value": "onley"
  },
  {
    "text": "Only",
    "value": "only"
  },
  {
    "text": "Ono",
    "value": "ono"
  },
  {
    "text": "Onondaga",
    "value": "onondaga"
  },
  {
    "text": "Onset",
    "value": "onset"
  },
  {
    "text": "Onslow",
    "value": "onslow"
  },
  {
    "text": "Onsted",
    "value": "onsted"
  },
  {
    "text": "Ontario",
    "value": "ontario"
  },
  {
    "text": "Ontonagon",
    "value": "ontonagon"
  },
  {
    "text": "Oolitic",
    "value": "oolitic"
  },
  {
    "text": "Oologah",
    "value": "oologah"
  },
  {
    "text": "Ooltewah",
    "value": "ooltewah"
  },
  {
    "text": "Oostburg",
    "value": "oostburg"
  },
  {
    "text": "Opa-locka",
    "value": "opa-locka"
  },
  {
    "text": "Opal Cliffs",
    "value": "opal cliffs"
  },
  {
    "text": "Opdyke",
    "value": "opdyke"
  },
  {
    "text": "Opelika",
    "value": "opelika"
  },
  {
    "text": "Opelousas",
    "value": "opelousas"
  },
  {
    "text": "Opheim",
    "value": "opheim"
  },
  {
    "text": "Ophelia",
    "value": "ophelia"
  },
  {
    "text": "Opp",
    "value": "opp"
  },
  {
    "text": "Oquawka",
    "value": "oquawka"
  },
  {
    "text": "Oquossoc",
    "value": "oquossoc"
  },
  {
    "text": "Ora",
    "value": "ora"
  },
  {
    "text": "Oracle",
    "value": "oracle"
  },
  {
    "text": "Oradell",
    "value": "oradell"
  },
  {
    "text": "Oral",
    "value": "oral"
  },
  {
    "text": "Oran",
    "value": "oran"
  },
  {
    "text": "Orange",
    "value": "orange"
  },
  {
    "text": "Orange Beach",
    "value": "orange beach"
  },
  {
    "text": "Orange City",
    "value": "orange city"
  },
  {
    "text": "Orange Cove",
    "value": "orange cove"
  },
  {
    "text": "Orange Grove",
    "value": "orange grove"
  },
  {
    "text": "Orange Lake",
    "value": "orange lake"
  },
  {
    "text": "Orange Park",
    "value": "orange park"
  },
  {
    "text": "Orange Springs",
    "value": "orange springs"
  },
  {
    "text": "Orangeburg",
    "value": "orangeburg"
  },
  {
    "text": "Orangefield",
    "value": "orangefield"
  },
  {
    "text": "Orangevale",
    "value": "orangevale"
  },
  {
    "text": "Orangeville",
    "value": "orangeville"
  },
  {
    "text": "Orbisonia",
    "value": "orbisonia"
  },
  {
    "text": "Orcas",
    "value": "orcas"
  },
  {
    "text": "Orchard",
    "value": "orchard"
  },
  {
    "text": "Orchard Hill",
    "value": "orchard hill"
  },
  {
    "text": "Orchard Lake",
    "value": "orchard lake"
  },
  {
    "text": "Orchard Park",
    "value": "orchard park"
  },
  {
    "text": "Orchards",
    "value": "orchards"
  },
  {
    "text": "Orchid",
    "value": "orchid"
  },
  {
    "text": "Orchidlands Estates",
    "value": "orchidlands estates"
  },
  {
    "text": "Orcutt",
    "value": "orcutt"
  },
  {
    "text": "Ord",
    "value": "ord"
  },
  {
    "text": "Orderville",
    "value": "orderville"
  },
  {
    "text": "Ordway",
    "value": "ordway"
  },
  {
    "text": "Ore City",
    "value": "ore city"
  },
  {
    "text": "Oreana",
    "value": "oreana"
  },
  {
    "text": "Orefield",
    "value": "orefield"
  },
  {
    "text": "Oregon",
    "value": "oregon"
  },
  {
    "text": "Oregon City",
    "value": "oregon city"
  },
  {
    "text": "Oregon House",
    "value": "oregon house"
  },
  {
    "text": "Oregonia",
    "value": "oregonia"
  },
  {
    "text": "Oreland",
    "value": "oreland"
  },
  {
    "text": "Orem",
    "value": "orem"
  },
  {
    "text": "Orestes",
    "value": "orestes"
  },
  {
    "text": "Orford",
    "value": "orford"
  },
  {
    "text": "Orfordville",
    "value": "orfordville"
  },
  {
    "text": "Organ",
    "value": "organ"
  },
  {
    "text": "Orick",
    "value": "orick"
  },
  {
    "text": "Orient",
    "value": "orient"
  },
  {
    "text": "Oriental",
    "value": "oriental"
  },
  {
    "text": "Orinda",
    "value": "orinda"
  },
  {
    "text": "Orion",
    "value": "orion"
  },
  {
    "text": "Oriska",
    "value": "oriska"
  },
  {
    "text": "Oriskany",
    "value": "oriskany"
  },
  {
    "text": "Oriskany Falls",
    "value": "oriskany falls"
  },
  {
    "text": "Orkney Springs",
    "value": "orkney springs"
  },
  {
    "text": "Orla",
    "value": "orla"
  },
  {
    "text": "Orland",
    "value": "orland"
  },
  {
    "text": "Orland Hills",
    "value": "orland hills"
  },
  {
    "text": "Orland Park",
    "value": "orland park"
  },
  {
    "text": "Orlando",
    "value": "orlando"
  },
  {
    "text": "Orleans",
    "value": "orleans"
  },
  {
    "text": "Orlinda",
    "value": "orlinda"
  },
  {
    "text": "Orma",
    "value": "orma"
  },
  {
    "text": "Ormond Beach",
    "value": "ormond beach"
  },
  {
    "text": "Ormsby",
    "value": "ormsby"
  },
  {
    "text": "Oro Grande",
    "value": "oro grande"
  },
  {
    "text": "Oro Valley",
    "value": "oro valley"
  },
  {
    "text": "Orofino",
    "value": "orofino"
  },
  {
    "text": "Orogrande",
    "value": "orogrande"
  },
  {
    "text": "Orondo",
    "value": "orondo"
  },
  {
    "text": "Orono",
    "value": "orono"
  },
  {
    "text": "Oronoco",
    "value": "oronoco"
  },
  {
    "text": "Oronogo",
    "value": "oronogo"
  },
  {
    "text": "Orosi",
    "value": "orosi"
  },
  {
    "text": "Orovada",
    "value": "orovada"
  },
  {
    "text": "Oroville",
    "value": "oroville"
  },
  {
    "text": "Orr",
    "value": "orr"
  },
  {
    "text": "Orrick",
    "value": "orrick"
  },
  {
    "text": "Orrington",
    "value": "orrington"
  },
  {
    "text": "Orrs Island",
    "value": "orrs island"
  },
  {
    "text": "Orrstown",
    "value": "orrstown"
  },
  {
    "text": "Orrtanna",
    "value": "orrtanna"
  },
  {
    "text": "Orrum",
    "value": "orrum"
  },
  {
    "text": "Orrville",
    "value": "orrville"
  },
  {
    "text": "Orson",
    "value": "orson"
  },
  {
    "text": "Orting",
    "value": "orting"
  },
  {
    "text": "Ortley",
    "value": "ortley"
  },
  {
    "text": "Ortonville",
    "value": "ortonville"
  },
  {
    "text": "Orviston",
    "value": "orviston"
  },
  {
    "text": "Orwell",
    "value": "orwell"
  },
  {
    "text": "Orwigsburg",
    "value": "orwigsburg"
  },
  {
    "text": "Osage",
    "value": "osage"
  },
  {
    "text": "Osage Beach",
    "value": "osage beach"
  },
  {
    "text": "Osage City",
    "value": "osage city"
  },
  {
    "text": "Osakis",
    "value": "osakis"
  },
  {
    "text": "Osawatomie",
    "value": "osawatomie"
  },
  {
    "text": "Osborn",
    "value": "osborn"
  },
  {
    "text": "Osborne",
    "value": "osborne"
  },
  {
    "text": "Osburn",
    "value": "osburn"
  },
  {
    "text": "Oscar",
    "value": "oscar"
  },
  {
    "text": "Osceola",
    "value": "osceola"
  },
  {
    "text": "Osceola Mills",
    "value": "osceola mills"
  },
  {
    "text": "Osco",
    "value": "osco"
  },
  {
    "text": "Oscoda",
    "value": "oscoda"
  },
  {
    "text": "Osgood",
    "value": "osgood"
  },
  {
    "text": "Oshkosh",
    "value": "oshkosh"
  },
  {
    "text": "Oshtemo",
    "value": "oshtemo"
  },
  {
    "text": "Oskaloosa",
    "value": "oskaloosa"
  },
  {
    "text": "Oslo",
    "value": "oslo"
  },
  {
    "text": "Osmond",
    "value": "osmond"
  },
  {
    "text": "Osnabrock",
    "value": "osnabrock"
  },
  {
    "text": "Osprey",
    "value": "osprey"
  },
  {
    "text": "Osseo",
    "value": "osseo"
  },
  {
    "text": "Ossian",
    "value": "ossian"
  },
  {
    "text": "Ossineke",
    "value": "ossineke"
  },
  {
    "text": "Ossining",
    "value": "ossining"
  },
  {
    "text": "Ossipee",
    "value": "ossipee"
  },
  {
    "text": "Osteen",
    "value": "osteen"
  },
  {
    "text": "Osterburg",
    "value": "osterburg"
  },
  {
    "text": "Osterville",
    "value": "osterville"
  },
  {
    "text": "Ostrander",
    "value": "ostrander"
  },
  {
    "text": "Oswegatchie",
    "value": "oswegatchie"
  },
  {
    "text": "Oswego",
    "value": "oswego"
  },
  {
    "text": "Osyka",
    "value": "osyka"
  },
  {
    "text": "Otego",
    "value": "otego"
  },
  {
    "text": "Othello",
    "value": "othello"
  },
  {
    "text": "Otho",
    "value": "otho"
  },
  {
    "text": "Otis",
    "value": "otis"
  },
  {
    "text": "Otis Orchards",
    "value": "otis orchards"
  },
  {
    "text": "Otisco",
    "value": "otisco"
  },
  {
    "text": "Otisville",
    "value": "otisville"
  },
  {
    "text": "Otley",
    "value": "otley"
  },
  {
    "text": "Oto",
    "value": "oto"
  },
  {
    "text": "Otoe",
    "value": "otoe"
  },
  {
    "text": "Otsego",
    "value": "otsego"
  },
  {
    "text": "Ottawa",
    "value": "ottawa"
  },
  {
    "text": "Otter Creek",
    "value": "otter creek"
  },
  {
    "text": "Otter Lake",
    "value": "otter lake"
  },
  {
    "text": "Otter Rock",
    "value": "otter rock"
  },
  {
    "text": "Otterbein",
    "value": "otterbein"
  },
  {
    "text": "Ottertail",
    "value": "ottertail"
  },
  {
    "text": "Otterville",
    "value": "otterville"
  },
  {
    "text": "Ottine",
    "value": "ottine"
  },
  {
    "text": "Otto",
    "value": "otto"
  },
  {
    "text": "Ottosen",
    "value": "ottosen"
  },
  {
    "text": "Ottoville",
    "value": "ottoville"
  },
  {
    "text": "Ottsville",
    "value": "ottsville"
  },
  {
    "text": "Ottumwa",
    "value": "ottumwa"
  },
  {
    "text": "Otway",
    "value": "otway"
  },
  {
    "text": "Otwell",
    "value": "otwell"
  },
  {
    "text": "Ouray",
    "value": "ouray"
  },
  {
    "text": "Outing",
    "value": "outing"
  },
  {
    "text": "Outlook",
    "value": "outlook"
  },
  {
    "text": "Ovalo",
    "value": "ovalo"
  },
  {
    "text": "Ovando",
    "value": "ovando"
  },
  {
    "text": "Overbrook",
    "value": "overbrook"
  },
  {
    "text": "Overgaard",
    "value": "overgaard"
  },
  {
    "text": "Overland",
    "value": "overland"
  },
  {
    "text": "Overland Park",
    "value": "overland park"
  },
  {
    "text": "Overton",
    "value": "overton"
  },
  {
    "text": "Ovett",
    "value": "ovett"
  },
  {
    "text": "Ovid",
    "value": "ovid"
  },
  {
    "text": "Oviedo",
    "value": "oviedo"
  },
  {
    "text": "Ovilla",
    "value": "ovilla"
  },
  {
    "text": "Owaneco",
    "value": "owaneco"
  },
  {
    "text": "Owanka",
    "value": "owanka"
  },
  {
    "text": "Owasso",
    "value": "owasso"
  },
  {
    "text": "Owatonna",
    "value": "owatonna"
  },
  {
    "text": "Owego",
    "value": "owego"
  },
  {
    "text": "Owen",
    "value": "owen"
  },
  {
    "text": "Owendale",
    "value": "owendale"
  },
  {
    "text": "Owens Cross Roads",
    "value": "owens cross roads"
  },
  {
    "text": "Owensboro",
    "value": "owensboro"
  },
  {
    "text": "Owensburg",
    "value": "owensburg"
  },
  {
    "text": "Owensville",
    "value": "owensville"
  },
  {
    "text": "Owenton",
    "value": "owenton"
  },
  {
    "text": "Owings",
    "value": "owings"
  },
  {
    "text": "Owings Mills",
    "value": "owings mills"
  },
  {
    "text": "Owingsville",
    "value": "owingsville"
  },
  {
    "text": "Owls Head",
    "value": "owls head"
  },
  {
    "text": "Owosso",
    "value": "owosso"
  },
  {
    "text": "Owyhee",
    "value": "owyhee"
  },
  {
    "text": "Oxbow",
    "value": "oxbow"
  },
  {
    "text": "Oxford",
    "value": "oxford"
  },
  {
    "text": "Oxford Junction",
    "value": "oxford junction"
  },
  {
    "text": "Oxnard",
    "value": "oxnard"
  },
  {
    "text": "Oxon Hill",
    "value": "oxon hill"
  },
  {
    "text": "Oyens",
    "value": "oyens"
  },
  {
    "text": "Oyster Bay",
    "value": "oyster bay"
  },
  {
    "text": "Oyster Creek",
    "value": "oyster creek"
  },
  {
    "text": "Ozan",
    "value": "ozan"
  },
  {
    "text": "Ozark",
    "value": "ozark"
  },
  {
    "text": "Ozawkie",
    "value": "ozawkie"
  },
  {
    "text": "Ozona",
    "value": "ozona"
  },
  {
    "text": "Ozone",
    "value": "ozone"
  },
  {
    "text": "Ozone Park",
    "value": "ozone park"
  },
  {
    "text": "Paauilo",
    "value": "paauilo"
  },
  {
    "text": "Pablo",
    "value": "pablo"
  },
  {
    "text": "Pace",
    "value": "pace"
  },
  {
    "text": "Pacheco",
    "value": "pacheco"
  },
  {
    "text": "Pachuta",
    "value": "pachuta"
  },
  {
    "text": "Pacific",
    "value": "pacific"
  },
  {
    "text": "Pacific Beach",
    "value": "pacific beach"
  },
  {
    "text": "Pacific City",
    "value": "pacific city"
  },
  {
    "text": "Pacific Grove",
    "value": "pacific grove"
  },
  {
    "text": "Pacific Junction",
    "value": "pacific junction"
  },
  {
    "text": "Pacific Palisades",
    "value": "pacific palisades"
  },
  {
    "text": "Pacifica",
    "value": "pacifica"
  },
  {
    "text": "Packwaukee",
    "value": "packwaukee"
  },
  {
    "text": "Packwood",
    "value": "packwood"
  },
  {
    "text": "Pacoima",
    "value": "pacoima"
  },
  {
    "text": "Pacolet",
    "value": "pacolet"
  },
  {
    "text": "Paddock Lake",
    "value": "paddock lake"
  },
  {
    "text": "Paden",
    "value": "paden"
  },
  {
    "text": "Paden City",
    "value": "paden city"
  },
  {
    "text": "Paducah",
    "value": "paducah"
  },
  {
    "text": "Paeonian Springs",
    "value": "paeonian springs"
  },
  {
    "text": "Page",
    "value": "page"
  },
  {
    "text": "Pagedale",
    "value": "pagedale"
  },
  {
    "text": "Pageland",
    "value": "pageland"
  },
  {
    "text": "Pagosa Springs",
    "value": "pagosa springs"
  },
  {
    "text": "Paguate",
    "value": "paguate"
  },
  {
    "text": "Pahala",
    "value": "pahala"
  },
  {
    "text": "Pahoa",
    "value": "pahoa"
  },
  {
    "text": "Pahokee",
    "value": "pahokee"
  },
  {
    "text": "Pahrump",
    "value": "pahrump"
  },
  {
    "text": "Paia",
    "value": "paia"
  },
  {
    "text": "Paicines",
    "value": "paicines"
  },
  {
    "text": "Paige",
    "value": "paige"
  },
  {
    "text": "Paincourtville",
    "value": "paincourtville"
  },
  {
    "text": "Painesville",
    "value": "painesville"
  },
  {
    "text": "Paint",
    "value": "paint"
  },
  {
    "text": "Paint Lick",
    "value": "paint lick"
  },
  {
    "text": "Paint Rock",
    "value": "paint rock"
  },
  {
    "text": "Painted Post",
    "value": "painted post"
  },
  {
    "text": "Painter",
    "value": "painter"
  },
  {
    "text": "Paintsville",
    "value": "paintsville"
  },
  {
    "text": "Paisley",
    "value": "paisley"
  },
  {
    "text": "Pala",
    "value": "pala"
  },
  {
    "text": "Palacios",
    "value": "palacios"
  },
  {
    "text": "Palatine",
    "value": "palatine"
  },
  {
    "text": "Palatine Bridge",
    "value": "palatine bridge"
  },
  {
    "text": "Palatka",
    "value": "palatka"
  },
  {
    "text": "Palenville",
    "value": "palenville"
  },
  {
    "text": "Palermo",
    "value": "palermo"
  },
  {
    "text": "Palestine",
    "value": "palestine"
  },
  {
    "text": "Palisade",
    "value": "palisade"
  },
  {
    "text": "Palisades",
    "value": "palisades"
  },
  {
    "text": "Palisades Park",
    "value": "palisades park"
  },
  {
    "text": "Pall Mall",
    "value": "pall mall"
  },
  {
    "text": "Palm",
    "value": "palm"
  },
  {
    "text": "Palm Bay",
    "value": "palm bay"
  },
  {
    "text": "Palm Beach",
    "value": "palm beach"
  },
  {
    "text": "Palm Beach Gardens",
    "value": "palm beach gardens"
  },
  {
    "text": "Palm Beach Shores",
    "value": "palm beach shores"
  },
  {
    "text": "Palm City",
    "value": "palm city"
  },
  {
    "text": "Palm Coast",
    "value": "palm coast"
  },
  {
    "text": "Palm Desert",
    "value": "palm desert"
  },
  {
    "text": "Palm Harbor",
    "value": "palm harbor"
  },
  {
    "text": "Palm River-Clair Mel",
    "value": "palm river-clair mel"
  },
  {
    "text": "Palm Springs",
    "value": "palm springs"
  },
  {
    "text": "Palmdale",
    "value": "palmdale"
  },
  {
    "text": "Palmer",
    "value": "palmer"
  },
  {
    "text": "Palmer Lake",
    "value": "palmer lake"
  },
  {
    "text": "Palmerdale",
    "value": "palmerdale"
  },
  {
    "text": "Palmersville",
    "value": "palmersville"
  },
  {
    "text": "Palmerton",
    "value": "palmerton"
  },
  {
    "text": "Palmertown",
    "value": "palmertown"
  },
  {
    "text": "Palmetto",
    "value": "palmetto"
  },
  {
    "text": "Palmetto Bay",
    "value": "palmetto bay"
  },
  {
    "text": "Palmhurst",
    "value": "palmhurst"
  },
  {
    "text": "Palms",
    "value": "palms"
  },
  {
    "text": "Palmview",
    "value": "palmview"
  },
  {
    "text": "Palmyra",
    "value": "palmyra"
  },
  {
    "text": "Palo",
    "value": "palo"
  },
  {
    "text": "Palo Alto",
    "value": "palo alto"
  },
  {
    "text": "Palo Cedro",
    "value": "palo cedro"
  },
  {
    "text": "Palo Pinto",
    "value": "palo pinto"
  },
  {
    "text": "Palo Verde",
    "value": "palo verde"
  },
  {
    "text": "Palomar Mountain",
    "value": "palomar mountain"
  },
  {
    "text": "Palos Heights",
    "value": "palos heights"
  },
  {
    "text": "Palos Hills",
    "value": "palos hills"
  },
  {
    "text": "Palos Park",
    "value": "palos park"
  },
  {
    "text": "Palos Verdes Estates",
    "value": "palos verdes estates"
  },
  {
    "text": "Palos Verdes Peninsula",
    "value": "palos verdes peninsula"
  },
  {
    "text": "Palouse",
    "value": "palouse"
  },
  {
    "text": "Pampa",
    "value": "pampa"
  },
  {
    "text": "Pamplico",
    "value": "pamplico"
  },
  {
    "text": "Pamplin",
    "value": "pamplin"
  },
  {
    "text": "Pana",
    "value": "pana"
  },
  {
    "text": "Panaca",
    "value": "panaca"
  },
  {
    "text": "Panacea",
    "value": "panacea"
  },
  {
    "text": "Panama",
    "value": "panama"
  },
  {
    "text": "Panama City",
    "value": "panama city"
  },
  {
    "text": "Panama City Beach",
    "value": "panama city beach"
  },
  {
    "text": "Pandora",
    "value": "pandora"
  },
  {
    "text": "Pangburn",
    "value": "pangburn"
  },
  {
    "text": "Panguitch",
    "value": "panguitch"
  },
  {
    "text": "Panhandle",
    "value": "panhandle"
  },
  {
    "text": "Panna Maria",
    "value": "panna maria"
  },
  {
    "text": "Pannill Fork",
    "value": "pannill fork"
  },
  {
    "text": "Panora",
    "value": "panora"
  },
  {
    "text": "Panorama City",
    "value": "panorama city"
  },
  {
    "text": "Pansey",
    "value": "pansey"
  },
  {
    "text": "Pantego",
    "value": "pantego"
  },
  {
    "text": "Panther",
    "value": "panther"
  },
  {
    "text": "Paola",
    "value": "paola"
  },
  {
    "text": "Paoli",
    "value": "paoli"
  },
  {
    "text": "Paonia",
    "value": "paonia"
  },
  {
    "text": "Papa'aloa",
    "value": "papa'aloa"
  },
  {
    "text": "Papaikou",
    "value": "papaikou"
  },
  {
    "text": "Papillion",
    "value": "papillion"
  },
  {
    "text": "Papineau",
    "value": "papineau"
  },
  {
    "text": "Parachute",
    "value": "parachute"
  },
  {
    "text": "Paradis",
    "value": "paradis"
  },
  {
    "text": "Paradise",
    "value": "paradise"
  },
  {
    "text": "Paradise Hills",
    "value": "paradise hills"
  },
  {
    "text": "Paradise Valley",
    "value": "paradise valley"
  },
  {
    "text": "Paradox",
    "value": "paradox"
  },
  {
    "text": "Paragon",
    "value": "paragon"
  },
  {
    "text": "Paragonah",
    "value": "paragonah"
  },
  {
    "text": "Paragould",
    "value": "paragould"
  },
  {
    "text": "Paramount",
    "value": "paramount"
  },
  {
    "text": "Paramount-Long Meadow",
    "value": "paramount-long meadow"
  },
  {
    "text": "Paramus",
    "value": "paramus"
  },
  {
    "text": "Parchman",
    "value": "parchman"
  },
  {
    "text": "Parchment",
    "value": "parchment"
  },
  {
    "text": "Pardeeville",
    "value": "pardeeville"
  },
  {
    "text": "Paris",
    "value": "paris"
  },
  {
    "text": "Paris Crossing",
    "value": "paris crossing"
  },
  {
    "text": "Parish",
    "value": "parish"
  },
  {
    "text": "Parishville",
    "value": "parishville"
  },
  {
    "text": "Park",
    "value": "park"
  },
  {
    "text": "Park City",
    "value": "park city"
  },
  {
    "text": "Park Falls",
    "value": "park falls"
  },
  {
    "text": "Park Forest",
    "value": "park forest"
  },
  {
    "text": "Park Forest Village",
    "value": "park forest village"
  },
  {
    "text": "Park Hall Estates",
    "value": "park hall estates"
  },
  {
    "text": "Park Hill",
    "value": "park hill"
  },
  {
    "text": "Park Hills",
    "value": "park hills"
  },
  {
    "text": "Park Rapids",
    "value": "park rapids"
  },
  {
    "text": "Park Ridge",
    "value": "park ridge"
  },
  {
    "text": "Park River",
    "value": "park river"
  },
  {
    "text": "Park Valley",
    "value": "park valley"
  },
  {
    "text": "Parkdale",
    "value": "parkdale"
  },
  {
    "text": "Parker",
    "value": "parker"
  },
  {
    "text": "Parker City",
    "value": "parker city"
  },
  {
    "text": "Parker Dam",
    "value": "parker dam"
  },
  {
    "text": "Parker Ford",
    "value": "parker ford"
  },
  {
    "text": "Parkers Lake",
    "value": "parkers lake"
  },
  {
    "text": "Parkers Prairie",
    "value": "parkers prairie"
  },
  {
    "text": "Parkersburg",
    "value": "parkersburg"
  },
  {
    "text": "Parkesburg",
    "value": "parkesburg"
  },
  {
    "text": "Parkin",
    "value": "parkin"
  },
  {
    "text": "Parkland",
    "value": "parkland"
  },
  {
    "text": "Parkman",
    "value": "parkman"
  },
  {
    "text": "Parks",
    "value": "parks"
  },
  {
    "text": "Parksley",
    "value": "parksley"
  },
  {
    "text": "Parkston",
    "value": "parkston"
  },
  {
    "text": "Parksville",
    "value": "parksville"
  },
  {
    "text": "Parkton",
    "value": "parkton"
  },
  {
    "text": "Parkville",
    "value": "parkville"
  },
  {
    "text": "Parkway",
    "value": "parkway"
  },
  {
    "text": "Parlier",
    "value": "parlier"
  },
  {
    "text": "Parlin",
    "value": "parlin"
  },
  {
    "text": "Parma",
    "value": "parma"
  },
  {
    "text": "Parma Heights",
    "value": "parma heights"
  },
  {
    "text": "Parmelee",
    "value": "parmelee"
  },
  {
    "text": "Parnell",
    "value": "parnell"
  },
  {
    "text": "Paron",
    "value": "paron"
  },
  {
    "text": "Parowan",
    "value": "parowan"
  },
  {
    "text": "Parrish",
    "value": "parrish"
  },
  {
    "text": "Parrott",
    "value": "parrott"
  },
  {
    "text": "Parrottsville",
    "value": "parrottsville"
  },
  {
    "text": "Parshall",
    "value": "parshall"
  },
  {
    "text": "Parsippany",
    "value": "parsippany"
  },
  {
    "text": "Parsons",
    "value": "parsons"
  },
  {
    "text": "Parsonsburg",
    "value": "parsonsburg"
  },
  {
    "text": "Parsonsfield",
    "value": "parsonsfield"
  },
  {
    "text": "Parthenon",
    "value": "parthenon"
  },
  {
    "text": "Partlow",
    "value": "partlow"
  },
  {
    "text": "Partridge",
    "value": "partridge"
  },
  {
    "text": "Pasadena",
    "value": "pasadena"
  },
  {
    "text": "Pasatiempo",
    "value": "pasatiempo"
  },
  {
    "text": "Pascagoula",
    "value": "pascagoula"
  },
  {
    "text": "Pasco",
    "value": "pasco"
  },
  {
    "text": "Pascoag",
    "value": "pascoag"
  },
  {
    "text": "Paskenta",
    "value": "paskenta"
  },
  {
    "text": "Paso Robles",
    "value": "paso robles"
  },
  {
    "text": "Pass Christian",
    "value": "pass christian"
  },
  {
    "text": "Passaic",
    "value": "passaic"
  },
  {
    "text": "Patagonia",
    "value": "patagonia"
  },
  {
    "text": "Pataskala",
    "value": "pataskala"
  },
  {
    "text": "Patch Grove",
    "value": "patch grove"
  },
  {
    "text": "Patchogue",
    "value": "patchogue"
  },
  {
    "text": "Pateros",
    "value": "pateros"
  },
  {
    "text": "Paterson",
    "value": "paterson"
  },
  {
    "text": "Pathfork",
    "value": "pathfork"
  },
  {
    "text": "Patoka",
    "value": "patoka"
  },
  {
    "text": "Paton",
    "value": "paton"
  },
  {
    "text": "Patrick",
    "value": "patrick"
  },
  {
    "text": "Patrick Air Force Base",
    "value": "patrick air force base"
  },
  {
    "text": "Patrick Springs",
    "value": "patrick springs"
  },
  {
    "text": "Patricksburg",
    "value": "patricksburg"
  },
  {
    "text": "Patriot",
    "value": "patriot"
  },
  {
    "text": "Patten",
    "value": "patten"
  },
  {
    "text": "Patterson",
    "value": "patterson"
  },
  {
    "text": "Pattersonville",
    "value": "pattersonville"
  },
  {
    "text": "Pattison",
    "value": "pattison"
  },
  {
    "text": "Patton",
    "value": "patton"
  },
  {
    "text": "Patton Village",
    "value": "patton village"
  },
  {
    "text": "Pattonsburg",
    "value": "pattonsburg"
  },
  {
    "text": "Pattonville",
    "value": "pattonville"
  },
  {
    "text": "Patuxent River",
    "value": "patuxent river"
  },
  {
    "text": "Paul",
    "value": "paul"
  },
  {
    "text": "Paul Smiths",
    "value": "paul smiths"
  },
  {
    "text": "Paulden",
    "value": "paulden"
  },
  {
    "text": "Paulding",
    "value": "paulding"
  },
  {
    "text": "Paulina",
    "value": "paulina"
  },
  {
    "text": "Pauline",
    "value": "pauline"
  },
  {
    "text": "Paullina",
    "value": "paullina"
  },
  {
    "text": "Pauls Valley",
    "value": "pauls valley"
  },
  {
    "text": "Paulsboro",
    "value": "paulsboro"
  },
  {
    "text": "Pauma Valley",
    "value": "pauma valley"
  },
  {
    "text": "Paupack",
    "value": "paupack"
  },
  {
    "text": "Pavilion",
    "value": "pavilion"
  },
  {
    "text": "Pavillion",
    "value": "pavillion"
  },
  {
    "text": "Pavo",
    "value": "pavo"
  },
  {
    "text": "Paw Creek",
    "value": "paw creek"
  },
  {
    "text": "Paw Paw",
    "value": "paw paw"
  },
  {
    "text": "Paw Paw Lake",
    "value": "paw paw lake"
  },
  {
    "text": "Pawcatuck",
    "value": "pawcatuck"
  },
  {
    "text": "Pawhuska",
    "value": "pawhuska"
  },
  {
    "text": "Pawlet",
    "value": "pawlet"
  },
  {
    "text": "Pawleys Island",
    "value": "pawleys island"
  },
  {
    "text": "Pawling",
    "value": "pawling"
  },
  {
    "text": "Pawnee",
    "value": "pawnee"
  },
  {
    "text": "Pawnee City",
    "value": "pawnee city"
  },
  {
    "text": "Pawnee Rock",
    "value": "pawnee rock"
  },
  {
    "text": "Pawtucket",
    "value": "pawtucket"
  },
  {
    "text": "Paxico",
    "value": "paxico"
  },
  {
    "text": "Paxinos",
    "value": "paxinos"
  },
  {
    "text": "Paxton",
    "value": "paxton"
  },
  {
    "text": "Payette",
    "value": "payette"
  },
  {
    "text": "Payne",
    "value": "payne"
  },
  {
    "text": "Paynesville",
    "value": "paynesville"
  },
  {
    "text": "Payneville",
    "value": "payneville"
  },
  {
    "text": "Payson",
    "value": "payson"
  },
  {
    "text": "Pe Ell",
    "value": "pe ell"
  },
  {
    "text": "Pea Ridge",
    "value": "pea ridge"
  },
  {
    "text": "Peabody",
    "value": "peabody"
  },
  {
    "text": "Peace Dale",
    "value": "peace dale"
  },
  {
    "text": "Peace Valley",
    "value": "peace valley"
  },
  {
    "text": "Peach Bottom",
    "value": "peach bottom"
  },
  {
    "text": "Peach Creek",
    "value": "peach creek"
  },
  {
    "text": "Peach Glen",
    "value": "peach glen"
  },
  {
    "text": "Peach Orchard",
    "value": "peach orchard"
  },
  {
    "text": "Peach Springs",
    "value": "peach springs"
  },
  {
    "text": "Peacham",
    "value": "peacham"
  },
  {
    "text": "Peachland",
    "value": "peachland"
  },
  {
    "text": "Peachtree City",
    "value": "peachtree city"
  },
  {
    "text": "Peachtree Corners",
    "value": "peachtree corners"
  },
  {
    "text": "Peak",
    "value": "peak"
  },
  {
    "text": "Peaks Island",
    "value": "peaks island"
  },
  {
    "text": "Peapack",
    "value": "peapack"
  },
  {
    "text": "Pearblossom",
    "value": "pearblossom"
  },
  {
    "text": "Pearce",
    "value": "pearce"
  },
  {
    "text": "Pearcy",
    "value": "pearcy"
  },
  {
    "text": "Pearisburg",
    "value": "pearisburg"
  },
  {
    "text": "Pearl",
    "value": "pearl"
  },
  {
    "text": "Pearl City",
    "value": "pearl city"
  },
  {
    "text": "Pearl Harbor",
    "value": "pearl harbor"
  },
  {
    "text": "Pearl River",
    "value": "pearl river"
  },
  {
    "text": "Pearland",
    "value": "pearland"
  },
  {
    "text": "Pearlington",
    "value": "pearlington"
  },
  {
    "text": "Pearsall",
    "value": "pearsall"
  },
  {
    "text": "Pearson",
    "value": "pearson"
  },
  {
    "text": "Pease",
    "value": "pease"
  },
  {
    "text": "Peaster",
    "value": "peaster"
  },
  {
    "text": "Pebble Beach",
    "value": "pebble beach"
  },
  {
    "text": "Pecan Gap",
    "value": "pecan gap"
  },
  {
    "text": "Pecan Plantation",
    "value": "pecan plantation"
  },
  {
    "text": "Pecatonica",
    "value": "pecatonica"
  },
  {
    "text": "Peck",
    "value": "peck"
  },
  {
    "text": "Pecks Mill",
    "value": "pecks mill"
  },
  {
    "text": "Peckville",
    "value": "peckville"
  },
  {
    "text": "Peconic",
    "value": "peconic"
  },
  {
    "text": "Pecos",
    "value": "pecos"
  },
  {
    "text": "Peculiar",
    "value": "peculiar"
  },
  {
    "text": "Pedricktown",
    "value": "pedricktown"
  },
  {
    "text": "Pedro",
    "value": "pedro"
  },
  {
    "text": "Peebles",
    "value": "peebles"
  },
  {
    "text": "Peekskill",
    "value": "peekskill"
  },
  {
    "text": "Peeksville",
    "value": "peeksville"
  },
  {
    "text": "Peel",
    "value": "peel"
  },
  {
    "text": "Peerless",
    "value": "peerless"
  },
  {
    "text": "Peetz",
    "value": "peetz"
  },
  {
    "text": "Peever",
    "value": "peever"
  },
  {
    "text": "Peggs",
    "value": "peggs"
  },
  {
    "text": "Peggy",
    "value": "peggy"
  },
  {
    "text": "Pegram",
    "value": "pegram"
  },
  {
    "text": "Pekin",
    "value": "pekin"
  },
  {
    "text": "Pelahatchie",
    "value": "pelahatchie"
  },
  {
    "text": "Pelham",
    "value": "pelham"
  },
  {
    "text": "Pelican",
    "value": "pelican"
  },
  {
    "text": "Pelican Lake",
    "value": "pelican lake"
  },
  {
    "text": "Pelican Rapids",
    "value": "pelican rapids"
  },
  {
    "text": "Pelion",
    "value": "pelion"
  },
  {
    "text": "Pelkie",
    "value": "pelkie"
  },
  {
    "text": "Pell City",
    "value": "pell city"
  },
  {
    "text": "Pell Lake",
    "value": "pell lake"
  },
  {
    "text": "Pella",
    "value": "pella"
  },
  {
    "text": "Pellston",
    "value": "pellston"
  },
  {
    "text": "Pelzer",
    "value": "pelzer"
  },
  {
    "text": "Pemaquid",
    "value": "pemaquid"
  },
  {
    "text": "Pemberton",
    "value": "pemberton"
  },
  {
    "text": "Pemberville",
    "value": "pemberville"
  },
  {
    "text": "Pembina",
    "value": "pembina"
  },
  {
    "text": "Pembine",
    "value": "pembine"
  },
  {
    "text": "Pembroke",
    "value": "pembroke"
  },
  {
    "text": "Pembroke Park",
    "value": "pembroke park"
  },
  {
    "text": "Pembroke Pines",
    "value": "pembroke pines"
  },
  {
    "text": "Pembroke Township",
    "value": "pembroke township"
  },
  {
    "text": "Pen Argyl",
    "value": "pen argyl"
  },
  {
    "text": "Pence Springs",
    "value": "pence springs"
  },
  {
    "text": "Pencil Bluff",
    "value": "pencil bluff"
  },
  {
    "text": "Pender",
    "value": "pender"
  },
  {
    "text": "Pendergrass",
    "value": "pendergrass"
  },
  {
    "text": "Pendleton",
    "value": "pendleton"
  },
  {
    "text": "Pendroy",
    "value": "pendroy"
  },
  {
    "text": "Penelope",
    "value": "penelope"
  },
  {
    "text": "Penfield",
    "value": "penfield"
  },
  {
    "text": "Pengilly",
    "value": "pengilly"
  },
  {
    "text": "Penhook",
    "value": "penhook"
  },
  {
    "text": "Peninsula",
    "value": "peninsula"
  },
  {
    "text": "Penitas",
    "value": "penitas"
  },
  {
    "text": "Penn",
    "value": "penn"
  },
  {
    "text": "Penn Hills",
    "value": "penn hills"
  },
  {
    "text": "Penn Laird",
    "value": "penn laird"
  },
  {
    "text": "Penn Run",
    "value": "penn run"
  },
  {
    "text": "Penn Valley",
    "value": "penn valley"
  },
  {
    "text": "Penn Yan",
    "value": "penn yan"
  },
  {
    "text": "Penndel",
    "value": "penndel"
  },
  {
    "text": "Pennellville",
    "value": "pennellville"
  },
  {
    "text": "Penney Farms",
    "value": "penney farms"
  },
  {
    "text": "Penngrove",
    "value": "penngrove"
  },
  {
    "text": "Pennington",
    "value": "pennington"
  },
  {
    "text": "Pennington Gap",
    "value": "pennington gap"
  },
  {
    "text": "Pennock",
    "value": "pennock"
  },
  {
    "text": "Penns Grove",
    "value": "penns grove"
  },
  {
    "text": "Penns Park",
    "value": "penns park"
  },
  {
    "text": "Pennsauken",
    "value": "pennsauken"
  },
  {
    "text": "Pennsboro",
    "value": "pennsboro"
  },
  {
    "text": "Pennsburg",
    "value": "pennsburg"
  },
  {
    "text": "Pennsville",
    "value": "pennsville"
  },
  {
    "text": "Pennsylvania Furnace",
    "value": "pennsylvania furnace"
  },
  {
    "text": "Pennville",
    "value": "pennville"
  },
  {
    "text": "Penobscot",
    "value": "penobscot"
  },
  {
    "text": "Penrose",
    "value": "penrose"
  },
  {
    "text": "Penryn",
    "value": "penryn"
  },
  {
    "text": "Pensacola",
    "value": "pensacola"
  },
  {
    "text": "Pensacola Beach",
    "value": "pensacola beach"
  },
  {
    "text": "Pentress",
    "value": "pentress"
  },
  {
    "text": "Pentwater",
    "value": "pentwater"
  },
  {
    "text": "Penwell",
    "value": "penwell"
  },
  {
    "text": "Peoa",
    "value": "peoa"
  },
  {
    "text": "Peoria",
    "value": "peoria"
  },
  {
    "text": "Peoria Heights",
    "value": "peoria heights"
  },
  {
    "text": "Peosta",
    "value": "peosta"
  },
  {
    "text": "Peotone",
    "value": "peotone"
  },
  {
    "text": "Pepeekeo",
    "value": "pepeekeo"
  },
  {
    "text": "Pepin",
    "value": "pepin"
  },
  {
    "text": "Pepper Pike",
    "value": "pepper pike"
  },
  {
    "text": "Pepperell",
    "value": "pepperell"
  },
  {
    "text": "Pequannock",
    "value": "pequannock"
  },
  {
    "text": "Pequea",
    "value": "pequea"
  },
  {
    "text": "Pequot Lakes",
    "value": "pequot lakes"
  },
  {
    "text": "Peralta",
    "value": "peralta"
  },
  {
    "text": "Percival",
    "value": "percival"
  },
  {
    "text": "Percy",
    "value": "percy"
  },
  {
    "text": "Perdido",
    "value": "perdido"
  },
  {
    "text": "Perdido Key",
    "value": "perdido key"
  },
  {
    "text": "Perdue Hill",
    "value": "perdue hill"
  },
  {
    "text": "Perham",
    "value": "perham"
  },
  {
    "text": "Peridot",
    "value": "peridot"
  },
  {
    "text": "Perkasie",
    "value": "perkasie"
  },
  {
    "text": "Perkins",
    "value": "perkins"
  },
  {
    "text": "Perkinston",
    "value": "perkinston"
  },
  {
    "text": "Perkinsville",
    "value": "perkinsville"
  },
  {
    "text": "Perkiomenville",
    "value": "perkiomenville"
  },
  {
    "text": "Perley",
    "value": "perley"
  },
  {
    "text": "Perote",
    "value": "perote"
  },
  {
    "text": "Perrin",
    "value": "perrin"
  },
  {
    "text": "Perrinton",
    "value": "perrinton"
  },
  {
    "text": "Perris",
    "value": "perris"
  },
  {
    "text": "Perry",
    "value": "perry"
  },
  {
    "text": "Perry Hall",
    "value": "perry hall"
  },
  {
    "text": "Perry Heights",
    "value": "perry heights"
  },
  {
    "text": "Perry Point",
    "value": "perry point"
  },
  {
    "text": "Perryopolis",
    "value": "perryopolis"
  },
  {
    "text": "Perrysburg",
    "value": "perrysburg"
  },
  {
    "text": "Perrysville",
    "value": "perrysville"
  },
  {
    "text": "Perryton",
    "value": "perryton"
  },
  {
    "text": "Perryville",
    "value": "perryville"
  },
  {
    "text": "Pershing",
    "value": "pershing"
  },
  {
    "text": "Persia",
    "value": "persia"
  },
  {
    "text": "Perth",
    "value": "perth"
  },
  {
    "text": "Perth Amboy",
    "value": "perth amboy"
  },
  {
    "text": "Peru",
    "value": "peru"
  },
  {
    "text": "Pescadero",
    "value": "pescadero"
  },
  {
    "text": "Peshastin",
    "value": "peshastin"
  },
  {
    "text": "Peshtigo",
    "value": "peshtigo"
  },
  {
    "text": "Pesotum",
    "value": "pesotum"
  },
  {
    "text": "Petaca",
    "value": "petaca"
  },
  {
    "text": "Petal",
    "value": "petal"
  },
  {
    "text": "Petaluma",
    "value": "petaluma"
  },
  {
    "text": "Peterborough",
    "value": "peterborough"
  },
  {
    "text": "Peterman",
    "value": "peterman"
  },
  {
    "text": "Peters",
    "value": "peters"
  },
  {
    "text": "Petersburg",
    "value": "petersburg"
  },
  {
    "text": "Petersham",
    "value": "petersham"
  },
  {
    "text": "Peterson",
    "value": "peterson"
  },
  {
    "text": "Peterstown",
    "value": "peterstown"
  },
  {
    "text": "Petoskey",
    "value": "petoskey"
  },
  {
    "text": "Petrified Forest National Park",
    "value": "petrified forest national park"
  },
  {
    "text": "Petroleum",
    "value": "petroleum"
  },
  {
    "text": "Petrolia",
    "value": "petrolia"
  },
  {
    "text": "Petros",
    "value": "petros"
  },
  {
    "text": "Pettisville",
    "value": "pettisville"
  },
  {
    "text": "Pettus",
    "value": "pettus"
  },
  {
    "text": "Petty",
    "value": "petty"
  },
  {
    "text": "Pevely",
    "value": "pevely"
  },
  {
    "text": "Pewamo",
    "value": "pewamo"
  },
  {
    "text": "Pewaukee",
    "value": "pewaukee"
  },
  {
    "text": "Pewee Valley",
    "value": "pewee valley"
  },
  {
    "text": "Peyton",
    "value": "peyton"
  },
  {
    "text": "Peytona",
    "value": "peytona"
  },
  {
    "text": "Peña Blanca",
    "value": "peña blanca"
  },
  {
    "text": "Peñasco",
    "value": "peñasco"
  },
  {
    "text": "Pfafftown",
    "value": "pfafftown"
  },
  {
    "text": "Pflugerville",
    "value": "pflugerville"
  },
  {
    "text": "Pharr",
    "value": "pharr"
  },
  {
    "text": "Pheba",
    "value": "pheba"
  },
  {
    "text": "Phelan",
    "value": "phelan"
  },
  {
    "text": "Phelps",
    "value": "phelps"
  },
  {
    "text": "Phenix",
    "value": "phenix"
  },
  {
    "text": "Phenix City",
    "value": "phenix city"
  },
  {
    "text": "Phil Campbell",
    "value": "phil campbell"
  },
  {
    "text": "Philadelphia",
    "value": "philadelphia"
  },
  {
    "text": "Philip",
    "value": "philip"
  },
  {
    "text": "Philipp",
    "value": "philipp"
  },
  {
    "text": "Philippi",
    "value": "philippi"
  },
  {
    "text": "Philipsburg",
    "value": "philipsburg"
  },
  {
    "text": "Phillips",
    "value": "phillips"
  },
  {
    "text": "Phillipsburg",
    "value": "phillipsburg"
  },
  {
    "text": "Phillipston",
    "value": "phillipston"
  },
  {
    "text": "Phillipsville",
    "value": "phillipsville"
  },
  {
    "text": "Philmont",
    "value": "philmont"
  },
  {
    "text": "Philo",
    "value": "philo"
  },
  {
    "text": "Philomath",
    "value": "philomath"
  },
  {
    "text": "Philpot",
    "value": "philpot"
  },
  {
    "text": "Phippsburg",
    "value": "phippsburg"
  },
  {
    "text": "Phoenicia",
    "value": "phoenicia"
  },
  {
    "text": "Phoenix",
    "value": "phoenix"
  },
  {
    "text": "Phoenixville",
    "value": "phoenixville"
  },
  {
    "text": "Phyllis",
    "value": "phyllis"
  },
  {
    "text": "Piasa",
    "value": "piasa"
  },
  {
    "text": "Picabo",
    "value": "picabo"
  },
  {
    "text": "Picatinny Arsenal",
    "value": "picatinny arsenal"
  },
  {
    "text": "Picayune",
    "value": "picayune"
  },
  {
    "text": "Picher",
    "value": "picher"
  },
  {
    "text": "Pickens",
    "value": "pickens"
  },
  {
    "text": "Pickerel",
    "value": "pickerel"
  },
  {
    "text": "Pickering",
    "value": "pickering"
  },
  {
    "text": "Pickerington",
    "value": "pickerington"
  },
  {
    "text": "Pickett",
    "value": "pickett"
  },
  {
    "text": "Pickford",
    "value": "pickford"
  },
  {
    "text": "Pickrell",
    "value": "pickrell"
  },
  {
    "text": "Pickstown",
    "value": "pickstown"
  },
  {
    "text": "Pickton",
    "value": "pickton"
  },
  {
    "text": "Pico Rivera",
    "value": "pico rivera"
  },
  {
    "text": "Picture Rocks",
    "value": "picture rocks"
  },
  {
    "text": "Pie Town",
    "value": "pie town"
  },
  {
    "text": "Piedmont",
    "value": "piedmont"
  },
  {
    "text": "Piedra",
    "value": "piedra"
  },
  {
    "text": "Pierce",
    "value": "pierce"
  },
  {
    "text": "Pierce City",
    "value": "pierce city"
  },
  {
    "text": "Piercefield",
    "value": "piercefield"
  },
  {
    "text": "Pierceton",
    "value": "pierceton"
  },
  {
    "text": "Pierceville",
    "value": "pierceville"
  },
  {
    "text": "Piermont",
    "value": "piermont"
  },
  {
    "text": "Pierpont",
    "value": "pierpont"
  },
  {
    "text": "Pierre",
    "value": "pierre"
  },
  {
    "text": "Pierre Part",
    "value": "pierre part"
  },
  {
    "text": "Pierron",
    "value": "pierron"
  },
  {
    "text": "Pierson",
    "value": "pierson"
  },
  {
    "text": "Pierz",
    "value": "pierz"
  },
  {
    "text": "Piffard",
    "value": "piffard"
  },
  {
    "text": "Pigeon",
    "value": "pigeon"
  },
  {
    "text": "Pigeon Falls",
    "value": "pigeon falls"
  },
  {
    "text": "Pigeon Forge",
    "value": "pigeon forge"
  },
  {
    "text": "Piggott",
    "value": "piggott"
  },
  {
    "text": "Pike",
    "value": "pike"
  },
  {
    "text": "Pike Road",
    "value": "pike road"
  },
  {
    "text": "Pikesville",
    "value": "pikesville"
  },
  {
    "text": "Piketon",
    "value": "piketon"
  },
  {
    "text": "Pikeville",
    "value": "pikeville"
  },
  {
    "text": "Pillager",
    "value": "pillager"
  },
  {
    "text": "Pilot",
    "value": "pilot"
  },
  {
    "text": "Pilot Grove",
    "value": "pilot grove"
  },
  {
    "text": "Pilot Hill",
    "value": "pilot hill"
  },
  {
    "text": "Pilot Knob",
    "value": "pilot knob"
  },
  {
    "text": "Pilot Mound",
    "value": "pilot mound"
  },
  {
    "text": "Pilot Mountain",
    "value": "pilot mountain"
  },
  {
    "text": "Pilot Point",
    "value": "pilot point"
  },
  {
    "text": "Pilot Rock",
    "value": "pilot rock"
  },
  {
    "text": "Pilot Station",
    "value": "pilot station"
  },
  {
    "text": "Pilottown",
    "value": "pilottown"
  },
  {
    "text": "Pima",
    "value": "pima"
  },
  {
    "text": "Pimento",
    "value": "pimento"
  },
  {
    "text": "Pimmit Hills",
    "value": "pimmit hills"
  },
  {
    "text": "Pinckard",
    "value": "pinckard"
  },
  {
    "text": "Pinckney",
    "value": "pinckney"
  },
  {
    "text": "Pinckneyville",
    "value": "pinckneyville"
  },
  {
    "text": "Pinconning",
    "value": "pinconning"
  },
  {
    "text": "Pine",
    "value": "pine"
  },
  {
    "text": "Pine Apple",
    "value": "pine apple"
  },
  {
    "text": "Pine Beach",
    "value": "pine beach"
  },
  {
    "text": "Pine Bluff",
    "value": "pine bluff"
  },
  {
    "text": "Pine Bluffs",
    "value": "pine bluffs"
  },
  {
    "text": "Pine Brook",
    "value": "pine brook"
  },
  {
    "text": "Pine Bush",
    "value": "pine bush"
  },
  {
    "text": "Pine Castle",
    "value": "pine castle"
  },
  {
    "text": "Pine City",
    "value": "pine city"
  },
  {
    "text": "Pine Forge",
    "value": "pine forge"
  },
  {
    "text": "Pine Grove",
    "value": "pine grove"
  },
  {
    "text": "Pine Grove Mills",
    "value": "pine grove mills"
  },
  {
    "text": "Pine Hall",
    "value": "pine hall"
  },
  {
    "text": "Pine Hill",
    "value": "pine hill"
  },
  {
    "text": "Pine Hills",
    "value": "pine hills"
  },
  {
    "text": "Pine Island",
    "value": "pine island"
  },
  {
    "text": "Pine Knoll Shores",
    "value": "pine knoll shores"
  },
  {
    "text": "Pine Knot",
    "value": "pine knot"
  },
  {
    "text": "Pine Lake",
    "value": "pine lake"
  },
  {
    "text": "Pine Lawn",
    "value": "pine lawn"
  },
  {
    "text": "Pine Level",
    "value": "pine level"
  },
  {
    "text": "Pine Meadow",
    "value": "pine meadow"
  },
  {
    "text": "Pine Mountain",
    "value": "pine mountain"
  },
  {
    "text": "Pine Mountain Club",
    "value": "pine mountain club"
  },
  {
    "text": "Pine Mountain Valley",
    "value": "pine mountain valley"
  },
  {
    "text": "Pine Plains",
    "value": "pine plains"
  },
  {
    "text": "Pine Prairie",
    "value": "pine prairie"
  },
  {
    "text": "Pine Ridge",
    "value": "pine ridge"
  },
  {
    "text": "Pine River",
    "value": "pine river"
  },
  {
    "text": "Pine Top",
    "value": "pine top"
  },
  {
    "text": "Pine Valley",
    "value": "pine valley"
  },
  {
    "text": "Pine Village",
    "value": "pine village"
  },
  {
    "text": "Pinebluff",
    "value": "pinebluff"
  },
  {
    "text": "Pinecliffe",
    "value": "pinecliffe"
  },
  {
    "text": "Pinecrest",
    "value": "pinecrest"
  },
  {
    "text": "Pinedale",
    "value": "pinedale"
  },
  {
    "text": "Pinehill",
    "value": "pinehill"
  },
  {
    "text": "Pinehurst",
    "value": "pinehurst"
  },
  {
    "text": "Pineland",
    "value": "pineland"
  },
  {
    "text": "Pinellas Park",
    "value": "pinellas park"
  },
  {
    "text": "Pineridge",
    "value": "pineridge"
  },
  {
    "text": "Pinesdale",
    "value": "pinesdale"
  },
  {
    "text": "Pinetop",
    "value": "pinetop"
  },
  {
    "text": "Pinetop-Lakeside",
    "value": "pinetop-lakeside"
  },
  {
    "text": "Pinetops",
    "value": "pinetops"
  },
  {
    "text": "Pinetown",
    "value": "pinetown"
  },
  {
    "text": "Pinetta",
    "value": "pinetta"
  },
  {
    "text": "Pineview",
    "value": "pineview"
  },
  {
    "text": "Pineville",
    "value": "pineville"
  },
  {
    "text": "Pinewood",
    "value": "pinewood"
  },
  {
    "text": "Piney Creek",
    "value": "piney creek"
  },
  {
    "text": "Piney Flats",
    "value": "piney flats"
  },
  {
    "text": "Piney Point",
    "value": "piney point"
  },
  {
    "text": "Piney Point Village",
    "value": "piney point village"
  },
  {
    "text": "Piney River",
    "value": "piney river"
  },
  {
    "text": "Piney View",
    "value": "piney view"
  },
  {
    "text": "Pingree",
    "value": "pingree"
  },
  {
    "text": "Pingree Grove",
    "value": "pingree grove"
  },
  {
    "text": "Pink Hill",
    "value": "pink hill"
  },
  {
    "text": "Pinnacle",
    "value": "pinnacle"
  },
  {
    "text": "Pinola",
    "value": "pinola"
  },
  {
    "text": "Pinole",
    "value": "pinole"
  },
  {
    "text": "Pinon",
    "value": "pinon"
  },
  {
    "text": "Pinon Hills",
    "value": "pinon hills"
  },
  {
    "text": "Pinopolis",
    "value": "pinopolis"
  },
  {
    "text": "Pinos Altos",
    "value": "pinos altos"
  },
  {
    "text": "Pinson",
    "value": "pinson"
  },
  {
    "text": "Pinsonfork",
    "value": "pinsonfork"
  },
  {
    "text": "Pioche",
    "value": "pioche"
  },
  {
    "text": "Pioneer",
    "value": "pioneer"
  },
  {
    "text": "Pioneer Village",
    "value": "pioneer village"
  },
  {
    "text": "Pioneertown",
    "value": "pioneertown"
  },
  {
    "text": "Pipe Creek",
    "value": "pipe creek"
  },
  {
    "text": "Piper City",
    "value": "piper city"
  },
  {
    "text": "Pipersville",
    "value": "pipersville"
  },
  {
    "text": "Piperton",
    "value": "piperton"
  },
  {
    "text": "Pipestem",
    "value": "pipestem"
  },
  {
    "text": "Pipestone",
    "value": "pipestone"
  },
  {
    "text": "Pippa Passes",
    "value": "pippa passes"
  },
  {
    "text": "Piqua",
    "value": "piqua"
  },
  {
    "text": "Pirtleville",
    "value": "pirtleville"
  },
  {
    "text": "Piru",
    "value": "piru"
  },
  {
    "text": "Piscataway",
    "value": "piscataway"
  },
  {
    "text": "Piseco",
    "value": "piseco"
  },
  {
    "text": "Pisek",
    "value": "pisek"
  },
  {
    "text": "Pisgah",
    "value": "pisgah"
  },
  {
    "text": "Pisgah Forest",
    "value": "pisgah forest"
  },
  {
    "text": "Pismo Beach",
    "value": "pismo beach"
  },
  {
    "text": "Pitcairn",
    "value": "pitcairn"
  },
  {
    "text": "Pitcher",
    "value": "pitcher"
  },
  {
    "text": "Pitkin",
    "value": "pitkin"
  },
  {
    "text": "Pitman",
    "value": "pitman"
  },
  {
    "text": "Pitts",
    "value": "pitts"
  },
  {
    "text": "Pittsboro",
    "value": "pittsboro"
  },
  {
    "text": "Pittsburg",
    "value": "pittsburg"
  },
  {
    "text": "Pittsburgh",
    "value": "pittsburgh"
  },
  {
    "text": "Pittsfield",
    "value": "pittsfield"
  },
  {
    "text": "Pittsford",
    "value": "pittsford"
  },
  {
    "text": "Pittston",
    "value": "pittston"
  },
  {
    "text": "Pittstown",
    "value": "pittstown"
  },
  {
    "text": "Pittsview",
    "value": "pittsview"
  },
  {
    "text": "Pittsville",
    "value": "pittsville"
  },
  {
    "text": "Pixley",
    "value": "pixley"
  },
  {
    "text": "Piñon",
    "value": "piñon"
  },
  {
    "text": "Piñon Hills",
    "value": "piñon hills"
  },
  {
    "text": "Placentia",
    "value": "placentia"
  },
  {
    "text": "Placerville",
    "value": "placerville"
  },
  {
    "text": "Placid Lakes",
    "value": "placid lakes"
  },
  {
    "text": "Placida",
    "value": "placida"
  },
  {
    "text": "Placitas",
    "value": "placitas"
  },
  {
    "text": "Plain",
    "value": "plain"
  },
  {
    "text": "Plain City",
    "value": "plain city"
  },
  {
    "text": "Plain Dealing",
    "value": "plain dealing"
  },
  {
    "text": "Plainfield",
    "value": "plainfield"
  },
  {
    "text": "Plains",
    "value": "plains"
  },
  {
    "text": "Plainsboro",
    "value": "plainsboro"
  },
  {
    "text": "Plainview",
    "value": "plainview"
  },
  {
    "text": "Plainville",
    "value": "plainville"
  },
  {
    "text": "Plainwell",
    "value": "plainwell"
  },
  {
    "text": "Plaistow",
    "value": "plaistow"
  },
  {
    "text": "Planada",
    "value": "planada"
  },
  {
    "text": "Plandome",
    "value": "plandome"
  },
  {
    "text": "Plankinton",
    "value": "plankinton"
  },
  {
    "text": "Plano",
    "value": "plano"
  },
  {
    "text": "Plant City",
    "value": "plant city"
  },
  {
    "text": "Plantation",
    "value": "plantation"
  },
  {
    "text": "Plantersville",
    "value": "plantersville"
  },
  {
    "text": "Plantsville",
    "value": "plantsville"
  },
  {
    "text": "Plaquemine",
    "value": "plaquemine"
  },
  {
    "text": "Platina",
    "value": "platina"
  },
  {
    "text": "Plato",
    "value": "plato"
  },
  {
    "text": "Platte",
    "value": "platte"
  },
  {
    "text": "Platte Center",
    "value": "platte center"
  },
  {
    "text": "Platte City",
    "value": "platte city"
  },
  {
    "text": "Plattekill",
    "value": "plattekill"
  },
  {
    "text": "Plattenville",
    "value": "plattenville"
  },
  {
    "text": "Platteville",
    "value": "platteville"
  },
  {
    "text": "Plattsburg",
    "value": "plattsburg"
  },
  {
    "text": "Plattsburgh",
    "value": "plattsburgh"
  },
  {
    "text": "Plattsmouth",
    "value": "plattsmouth"
  },
  {
    "text": "Plaucheville",
    "value": "plaucheville"
  },
  {
    "text": "Playa Vista",
    "value": "playa vista"
  },
  {
    "text": "Playa del Rey",
    "value": "playa del rey"
  },
  {
    "text": "Plaza",
    "value": "plaza"
  },
  {
    "text": "Pleak",
    "value": "pleak"
  },
  {
    "text": "Pleasant City",
    "value": "pleasant city"
  },
  {
    "text": "Pleasant Dale",
    "value": "pleasant dale"
  },
  {
    "text": "Pleasant Gap",
    "value": "pleasant gap"
  },
  {
    "text": "Pleasant Garden",
    "value": "pleasant garden"
  },
  {
    "text": "Pleasant Grove",
    "value": "pleasant grove"
  },
  {
    "text": "Pleasant Hall",
    "value": "pleasant hall"
  },
  {
    "text": "Pleasant Hill",
    "value": "pleasant hill"
  },
  {
    "text": "Pleasant Hills",
    "value": "pleasant hills"
  },
  {
    "text": "Pleasant Hope",
    "value": "pleasant hope"
  },
  {
    "text": "Pleasant Lake",
    "value": "pleasant lake"
  },
  {
    "text": "Pleasant Mills",
    "value": "pleasant mills"
  },
  {
    "text": "Pleasant Mount",
    "value": "pleasant mount"
  },
  {
    "text": "Pleasant Plain",
    "value": "pleasant plain"
  },
  {
    "text": "Pleasant Plains",
    "value": "pleasant plains"
  },
  {
    "text": "Pleasant Prairie",
    "value": "pleasant prairie"
  },
  {
    "text": "Pleasant Ridge",
    "value": "pleasant ridge"
  },
  {
    "text": "Pleasant Shade",
    "value": "pleasant shade"
  },
  {
    "text": "Pleasant Unity",
    "value": "pleasant unity"
  },
  {
    "text": "Pleasant Valley",
    "value": "pleasant valley"
  },
  {
    "text": "Pleasant View",
    "value": "pleasant view"
  },
  {
    "text": "Pleasanton",
    "value": "pleasanton"
  },
  {
    "text": "Pleasantville",
    "value": "pleasantville"
  },
  {
    "text": "Pleasureville",
    "value": "pleasureville"
  },
  {
    "text": "Plentywood",
    "value": "plentywood"
  },
  {
    "text": "Plevna",
    "value": "plevna"
  },
  {
    "text": "Plover",
    "value": "plover"
  },
  {
    "text": "Pluckemin",
    "value": "pluckemin"
  },
  {
    "text": "Plum",
    "value": "plum"
  },
  {
    "text": "Plum Branch",
    "value": "plum branch"
  },
  {
    "text": "Plum City",
    "value": "plum city"
  },
  {
    "text": "Plumerville",
    "value": "plumerville"
  },
  {
    "text": "Plummer",
    "value": "plummer"
  },
  {
    "text": "Plummers Landing",
    "value": "plummers landing"
  },
  {
    "text": "Plumsteadville",
    "value": "plumsteadville"
  },
  {
    "text": "Plumtree",
    "value": "plumtree"
  },
  {
    "text": "Plumville",
    "value": "plumville"
  },
  {
    "text": "Plush",
    "value": "plush"
  },
  {
    "text": "Plymouth",
    "value": "plymouth"
  },
  {
    "text": "Plymouth Meeting",
    "value": "plymouth meeting"
  },
  {
    "text": "Plympton",
    "value": "plympton"
  },
  {
    "text": "Poca",
    "value": "poca"
  },
  {
    "text": "Pocahontas",
    "value": "pocahontas"
  },
  {
    "text": "Pocasset",
    "value": "pocasset"
  },
  {
    "text": "Pocatello",
    "value": "pocatello"
  },
  {
    "text": "Pocola",
    "value": "pocola"
  },
  {
    "text": "Pocomoke City",
    "value": "pocomoke city"
  },
  {
    "text": "Pocono Lake",
    "value": "pocono lake"
  },
  {
    "text": "Pocono Manor",
    "value": "pocono manor"
  },
  {
    "text": "Pocono Pines",
    "value": "pocono pines"
  },
  {
    "text": "Pocono Ranch Lands",
    "value": "pocono ranch lands"
  },
  {
    "text": "Pocono Summit",
    "value": "pocono summit"
  },
  {
    "text": "Pocopson",
    "value": "pocopson"
  },
  {
    "text": "Poestenkill",
    "value": "poestenkill"
  },
  {
    "text": "Poetry",
    "value": "poetry"
  },
  {
    "text": "Poinciana",
    "value": "poinciana"
  },
  {
    "text": "Point",
    "value": "point"
  },
  {
    "text": "Point Arena",
    "value": "point arena"
  },
  {
    "text": "Point Clear",
    "value": "point clear"
  },
  {
    "text": "Point Comfort",
    "value": "point comfort"
  },
  {
    "text": "Point Harbor",
    "value": "point harbor"
  },
  {
    "text": "Point Hope",
    "value": "point hope"
  },
  {
    "text": "Point Lookout",
    "value": "point lookout"
  },
  {
    "text": "Point Marion",
    "value": "point marion"
  },
  {
    "text": "Point Mugu Nawc",
    "value": "point mugu nawc"
  },
  {
    "text": "Point Pleasant",
    "value": "point pleasant"
  },
  {
    "text": "Point Pleasant Beach",
    "value": "point pleasant beach"
  },
  {
    "text": "Point Reyes Station",
    "value": "point reyes station"
  },
  {
    "text": "Point Richmond",
    "value": "point richmond"
  },
  {
    "text": "Point Roberts",
    "value": "point roberts"
  },
  {
    "text": "Point of Rocks",
    "value": "point of rocks"
  },
  {
    "text": "Pointblank",
    "value": "pointblank"
  },
  {
    "text": "Pointe Aux Pins",
    "value": "pointe aux pins"
  },
  {
    "text": "Pointe a la Hache",
    "value": "pointe a la hache"
  },
  {
    "text": "Points",
    "value": "points"
  },
  {
    "text": "Polacca",
    "value": "polacca"
  },
  {
    "text": "Poland",
    "value": "poland"
  },
  {
    "text": "Polaris",
    "value": "polaris"
  },
  {
    "text": "Polk",
    "value": "polk"
  },
  {
    "text": "Polk City",
    "value": "polk city"
  },
  {
    "text": "Polkton",
    "value": "polkton"
  },
  {
    "text": "Pollock",
    "value": "pollock"
  },
  {
    "text": "Pollock Pines",
    "value": "pollock pines"
  },
  {
    "text": "Pollocksville",
    "value": "pollocksville"
  },
  {
    "text": "Pollok",
    "value": "pollok"
  },
  {
    "text": "Polo",
    "value": "polo"
  },
  {
    "text": "Polson",
    "value": "polson"
  },
  {
    "text": "Polvadera",
    "value": "polvadera"
  },
  {
    "text": "Pomaria",
    "value": "pomaria"
  },
  {
    "text": "Pomeroy",
    "value": "pomeroy"
  },
  {
    "text": "Pomfret",
    "value": "pomfret"
  },
  {
    "text": "Pomfret Center",
    "value": "pomfret center"
  },
  {
    "text": "Pomona",
    "value": "pomona"
  },
  {
    "text": "Pomona Park",
    "value": "pomona park"
  },
  {
    "text": "Pompano Beach",
    "value": "pompano beach"
  },
  {
    "text": "Pompeii",
    "value": "pompeii"
  },
  {
    "text": "Pompey",
    "value": "pompey"
  },
  {
    "text": "Pompton Lakes",
    "value": "pompton lakes"
  },
  {
    "text": "Pompton Plains",
    "value": "pompton plains"
  },
  {
    "text": "Ponca",
    "value": "ponca"
  },
  {
    "text": "Ponca City",
    "value": "ponca city"
  },
  {
    "text": "Ponce Inlet",
    "value": "ponce inlet"
  },
  {
    "text": "Ponce de Leon",
    "value": "ponce de leon"
  },
  {
    "text": "Poncha Springs",
    "value": "poncha springs"
  },
  {
    "text": "Ponchatoula",
    "value": "ponchatoula"
  },
  {
    "text": "Pond",
    "value": "pond"
  },
  {
    "text": "Pond Creek",
    "value": "pond creek"
  },
  {
    "text": "Ponder",
    "value": "ponder"
  },
  {
    "text": "Ponderay",
    "value": "ponderay"
  },
  {
    "text": "Ponemah",
    "value": "ponemah"
  },
  {
    "text": "Poneto",
    "value": "poneto"
  },
  {
    "text": "Ponsford",
    "value": "ponsford"
  },
  {
    "text": "Ponte Vedra",
    "value": "ponte vedra"
  },
  {
    "text": "Ponte Vedra Beach",
    "value": "ponte vedra beach"
  },
  {
    "text": "Pontiac",
    "value": "pontiac"
  },
  {
    "text": "Pontoon Beach",
    "value": "pontoon beach"
  },
  {
    "text": "Pontotoc",
    "value": "pontotoc"
  },
  {
    "text": "Pony",
    "value": "pony"
  },
  {
    "text": "Pool",
    "value": "pool"
  },
  {
    "text": "Poole",
    "value": "poole"
  },
  {
    "text": "Pooler",
    "value": "pooler"
  },
  {
    "text": "Poolesville",
    "value": "poolesville"
  },
  {
    "text": "Poolville",
    "value": "poolville"
  },
  {
    "text": "Pope",
    "value": "pope"
  },
  {
    "text": "Pope Air Force Base",
    "value": "pope air force base"
  },
  {
    "text": "Pope Valley",
    "value": "pope valley"
  },
  {
    "text": "Popejoy",
    "value": "popejoy"
  },
  {
    "text": "Poplar",
    "value": "poplar"
  },
  {
    "text": "Poplar Bluff",
    "value": "poplar bluff"
  },
  {
    "text": "Poplar Branch",
    "value": "poplar branch"
  },
  {
    "text": "Poplar Grove",
    "value": "poplar grove"
  },
  {
    "text": "Poplar Ridge",
    "value": "poplar ridge"
  },
  {
    "text": "Poplarville",
    "value": "poplarville"
  },
  {
    "text": "Poquonock",
    "value": "poquonock"
  },
  {
    "text": "Poquoson",
    "value": "poquoson"
  },
  {
    "text": "Porcupine",
    "value": "porcupine"
  },
  {
    "text": "Port Allegany",
    "value": "port allegany"
  },
  {
    "text": "Port Allen",
    "value": "port allen"
  },
  {
    "text": "Port Alsworth",
    "value": "port alsworth"
  },
  {
    "text": "Port Angeles",
    "value": "port angeles"
  },
  {
    "text": "Port Angeles East",
    "value": "port angeles east"
  },
  {
    "text": "Port Aransas",
    "value": "port aransas"
  },
  {
    "text": "Port Arthur",
    "value": "port arthur"
  },
  {
    "text": "Port Austin",
    "value": "port austin"
  },
  {
    "text": "Port Barre",
    "value": "port barre"
  },
  {
    "text": "Port Barrington",
    "value": "port barrington"
  },
  {
    "text": "Port Bolivar",
    "value": "port bolivar"
  },
  {
    "text": "Port Byron",
    "value": "port byron"
  },
  {
    "text": "Port Carbon",
    "value": "port carbon"
  },
  {
    "text": "Port Charlotte",
    "value": "port charlotte"
  },
  {
    "text": "Port Chester",
    "value": "port chester"
  },
  {
    "text": "Port Clinton",
    "value": "port clinton"
  },
  {
    "text": "Port Clyde",
    "value": "port clyde"
  },
  {
    "text": "Port Costa",
    "value": "port costa"
  },
  {
    "text": "Port Crane",
    "value": "port crane"
  },
  {
    "text": "Port Deposit",
    "value": "port deposit"
  },
  {
    "text": "Port Edwards",
    "value": "port edwards"
  },
  {
    "text": "Port Elizabeth",
    "value": "port elizabeth"
  },
  {
    "text": "Port Ewen",
    "value": "port ewen"
  },
  {
    "text": "Port Gamble",
    "value": "port gamble"
  },
  {
    "text": "Port Gibson",
    "value": "port gibson"
  },
  {
    "text": "Port Hadlock",
    "value": "port hadlock"
  },
  {
    "text": "Port Haywood",
    "value": "port haywood"
  },
  {
    "text": "Port Henry",
    "value": "port henry"
  },
  {
    "text": "Port Hope",
    "value": "port hope"
  },
  {
    "text": "Port Hueneme",
    "value": "port hueneme"
  },
  {
    "text": "Port Hueneme Cbc Base",
    "value": "port hueneme cbc base"
  },
  {
    "text": "Port Huron",
    "value": "port huron"
  },
  {
    "text": "Port Isabel",
    "value": "port isabel"
  },
  {
    "text": "Port Jefferson",
    "value": "port jefferson"
  },
  {
    "text": "Port Jefferson Station",
    "value": "port jefferson station"
  },
  {
    "text": "Port Jervis",
    "value": "port jervis"
  },
  {
    "text": "Port Kent",
    "value": "port kent"
  },
  {
    "text": "Port LaBelle",
    "value": "port labelle"
  },
  {
    "text": "Port Lavaca",
    "value": "port lavaca"
  },
  {
    "text": "Port Leyden",
    "value": "port leyden"
  },
  {
    "text": "Port Ludlow",
    "value": "port ludlow"
  },
  {
    "text": "Port Mansfield",
    "value": "port mansfield"
  },
  {
    "text": "Port Matilda",
    "value": "port matilda"
  },
  {
    "text": "Port Monmouth",
    "value": "port monmouth"
  },
  {
    "text": "Port Murray",
    "value": "port murray"
  },
  {
    "text": "Port Neches",
    "value": "port neches"
  },
  {
    "text": "Port Norris",
    "value": "port norris"
  },
  {
    "text": "Port O'Connor",
    "value": "port o'connor"
  },
  {
    "text": "Port Orange",
    "value": "port orange"
  },
  {
    "text": "Port Orchard",
    "value": "port orchard"
  },
  {
    "text": "Port Orford",
    "value": "port orford"
  },
  {
    "text": "Port Reading",
    "value": "port reading"
  },
  {
    "text": "Port Republic",
    "value": "port republic"
  },
  {
    "text": "Port Richey",
    "value": "port richey"
  },
  {
    "text": "Port Royal",
    "value": "port royal"
  },
  {
    "text": "Port Saint Joe",
    "value": "port saint joe"
  },
  {
    "text": "Port Saint John",
    "value": "port saint john"
  },
  {
    "text": "Port Saint Lucie",
    "value": "port saint lucie"
  },
  {
    "text": "Port Salerno",
    "value": "port salerno"
  },
  {
    "text": "Port Sanilac",
    "value": "port sanilac"
  },
  {
    "text": "Port Sulphur",
    "value": "port sulphur"
  },
  {
    "text": "Port Tobacco",
    "value": "port tobacco"
  },
  {
    "text": "Port Townsend",
    "value": "port townsend"
  },
  {
    "text": "Port Trevorton",
    "value": "port trevorton"
  },
  {
    "text": "Port Washington",
    "value": "port washington"
  },
  {
    "text": "Port Washington North",
    "value": "port washington north"
  },
  {
    "text": "Port Wentworth",
    "value": "port wentworth"
  },
  {
    "text": "Port Wing",
    "value": "port wing"
  },
  {
    "text": "Portage",
    "value": "portage"
  },
  {
    "text": "Portage Des Sioux",
    "value": "portage des sioux"
  },
  {
    "text": "Portage Lakes",
    "value": "portage lakes"
  },
  {
    "text": "Portageville",
    "value": "portageville"
  },
  {
    "text": "Portal",
    "value": "portal"
  },
  {
    "text": "Portales",
    "value": "portales"
  },
  {
    "text": "Porter",
    "value": "porter"
  },
  {
    "text": "Porter Corners",
    "value": "porter corners"
  },
  {
    "text": "Porter Heights",
    "value": "porter heights"
  },
  {
    "text": "Porter Ranch",
    "value": "porter ranch"
  },
  {
    "text": "Porterdale",
    "value": "porterdale"
  },
  {
    "text": "Porterfield",
    "value": "porterfield"
  },
  {
    "text": "Portersville",
    "value": "portersville"
  },
  {
    "text": "Porterville",
    "value": "porterville"
  },
  {
    "text": "Porthill",
    "value": "porthill"
  },
  {
    "text": "Portia",
    "value": "portia"
  },
  {
    "text": "Portis",
    "value": "portis"
  },
  {
    "text": "Portland",
    "value": "portland"
  },
  {
    "text": "Portola",
    "value": "portola"
  },
  {
    "text": "Portola Valley",
    "value": "portola valley"
  },
  {
    "text": "Portsmouth",
    "value": "portsmouth"
  },
  {
    "text": "Portville",
    "value": "portville"
  },
  {
    "text": "Porum",
    "value": "porum"
  },
  {
    "text": "Posen",
    "value": "posen"
  },
  {
    "text": "Poseyville",
    "value": "poseyville"
  },
  {
    "text": "Post",
    "value": "post"
  },
  {
    "text": "Post Falls",
    "value": "post falls"
  },
  {
    "text": "Post Mills",
    "value": "post mills"
  },
  {
    "text": "Postville",
    "value": "postville"
  },
  {
    "text": "Poteau",
    "value": "poteau"
  },
  {
    "text": "Potecasi",
    "value": "potecasi"
  },
  {
    "text": "Poteet",
    "value": "poteet"
  },
  {
    "text": "Poth",
    "value": "poth"
  },
  {
    "text": "Potlatch",
    "value": "potlatch"
  },
  {
    "text": "Potomac",
    "value": "potomac"
  },
  {
    "text": "Potomac Farms",
    "value": "potomac farms"
  },
  {
    "text": "Potomac Mills",
    "value": "potomac mills"
  },
  {
    "text": "Potosi",
    "value": "potosi"
  },
  {
    "text": "Potrero",
    "value": "potrero"
  },
  {
    "text": "Potsdam",
    "value": "potsdam"
  },
  {
    "text": "Potter",
    "value": "potter"
  },
  {
    "text": "Potter Valley",
    "value": "potter valley"
  },
  {
    "text": "Pottersdale",
    "value": "pottersdale"
  },
  {
    "text": "Pottersville",
    "value": "pottersville"
  },
  {
    "text": "Potterville",
    "value": "potterville"
  },
  {
    "text": "Potts Camp",
    "value": "potts camp"
  },
  {
    "text": "Pottsboro",
    "value": "pottsboro"
  },
  {
    "text": "Pottstown",
    "value": "pottstown"
  },
  {
    "text": "Pottsville",
    "value": "pottsville"
  },
  {
    "text": "Potwin",
    "value": "potwin"
  },
  {
    "text": "Poughkeepsie",
    "value": "poughkeepsie"
  },
  {
    "text": "Poughquag",
    "value": "poughquag"
  },
  {
    "text": "Poulan",
    "value": "poulan"
  },
  {
    "text": "Poulsbo",
    "value": "poulsbo"
  },
  {
    "text": "Poultney",
    "value": "poultney"
  },
  {
    "text": "Pound",
    "value": "pound"
  },
  {
    "text": "Pound Ridge",
    "value": "pound ridge"
  },
  {
    "text": "Pounding Mill",
    "value": "pounding mill"
  },
  {
    "text": "Poway",
    "value": "poway"
  },
  {
    "text": "Powder Springs",
    "value": "powder springs"
  },
  {
    "text": "Powderly",
    "value": "powderly"
  },
  {
    "text": "Powdersville",
    "value": "powdersville"
  },
  {
    "text": "Powderville",
    "value": "powderville"
  },
  {
    "text": "Powell",
    "value": "powell"
  },
  {
    "text": "Powell Butte",
    "value": "powell butte"
  },
  {
    "text": "Powells Point",
    "value": "powells point"
  },
  {
    "text": "Powellton",
    "value": "powellton"
  },
  {
    "text": "Power",
    "value": "power"
  },
  {
    "text": "Powers",
    "value": "powers"
  },
  {
    "text": "Powers Lake",
    "value": "powers lake"
  },
  {
    "text": "Powersite",
    "value": "powersite"
  },
  {
    "text": "Powersville",
    "value": "powersville"
  },
  {
    "text": "Powhatan",
    "value": "powhatan"
  },
  {
    "text": "Powhatan Point",
    "value": "powhatan point"
  },
  {
    "text": "Powhattan",
    "value": "powhattan"
  },
  {
    "text": "Pownal",
    "value": "pownal"
  },
  {
    "text": "Pownal Center",
    "value": "pownal center"
  },
  {
    "text": "Poy Sippi",
    "value": "poy sippi"
  },
  {
    "text": "Poyen",
    "value": "poyen"
  },
  {
    "text": "Poynette",
    "value": "poynette"
  },
  {
    "text": "Prague",
    "value": "prague"
  },
  {
    "text": "Prairie",
    "value": "prairie"
  },
  {
    "text": "Prairie City",
    "value": "prairie city"
  },
  {
    "text": "Prairie Farm",
    "value": "prairie farm"
  },
  {
    "text": "Prairie Grove",
    "value": "prairie grove"
  },
  {
    "text": "Prairie Hill",
    "value": "prairie hill"
  },
  {
    "text": "Prairie Home",
    "value": "prairie home"
  },
  {
    "text": "Prairie Lea",
    "value": "prairie lea"
  },
  {
    "text": "Prairie View",
    "value": "prairie view"
  },
  {
    "text": "Prairie Village",
    "value": "prairie village"
  },
  {
    "text": "Prairie du Chien",
    "value": "prairie du chien"
  },
  {
    "text": "Prairie du Rocher",
    "value": "prairie du rocher"
  },
  {
    "text": "Prairie du Sac",
    "value": "prairie du sac"
  },
  {
    "text": "Prairieburg",
    "value": "prairieburg"
  },
  {
    "text": "Prairieville",
    "value": "prairieville"
  },
  {
    "text": "Prather",
    "value": "prather"
  },
  {
    "text": "Pratt",
    "value": "pratt"
  },
  {
    "text": "Prattsburgh",
    "value": "prattsburgh"
  },
  {
    "text": "Prattsville",
    "value": "prattsville"
  },
  {
    "text": "Prattville",
    "value": "prattville"
  },
  {
    "text": "Pray",
    "value": "pray"
  },
  {
    "text": "Preble",
    "value": "preble"
  },
  {
    "text": "Preemption",
    "value": "preemption"
  },
  {
    "text": "Premium",
    "value": "premium"
  },
  {
    "text": "Premont",
    "value": "premont"
  },
  {
    "text": "Prentice",
    "value": "prentice"
  },
  {
    "text": "Prentiss",
    "value": "prentiss"
  },
  {
    "text": "Prescott",
    "value": "prescott"
  },
  {
    "text": "Prescott Valley",
    "value": "prescott valley"
  },
  {
    "text": "Presho",
    "value": "presho"
  },
  {
    "text": "Presidio",
    "value": "presidio"
  },
  {
    "text": "Presque Isle",
    "value": "presque isle"
  },
  {
    "text": "Presto",
    "value": "presto"
  },
  {
    "text": "Preston",
    "value": "preston"
  },
  {
    "text": "Preston City",
    "value": "preston city"
  },
  {
    "text": "Preston Hollow",
    "value": "preston hollow"
  },
  {
    "text": "Prestonsburg",
    "value": "prestonsburg"
  },
  {
    "text": "Pretty Prairie",
    "value": "pretty prairie"
  },
  {
    "text": "Prewitt",
    "value": "prewitt"
  },
  {
    "text": "Price",
    "value": "price"
  },
  {
    "text": "Priceville",
    "value": "priceville"
  },
  {
    "text": "Prichard",
    "value": "prichard"
  },
  {
    "text": "Pride",
    "value": "pride"
  },
  {
    "text": "Prides Crossing",
    "value": "prides crossing"
  },
  {
    "text": "Priest River",
    "value": "priest river"
  },
  {
    "text": "Prim",
    "value": "prim"
  },
  {
    "text": "Primghar",
    "value": "primghar"
  },
  {
    "text": "Primm Springs",
    "value": "primm springs"
  },
  {
    "text": "Primrose",
    "value": "primrose"
  },
  {
    "text": "Prince",
    "value": "prince"
  },
  {
    "text": "Prince Frederick",
    "value": "prince frederick"
  },
  {
    "text": "Prince George",
    "value": "prince george"
  },
  {
    "text": "Princess Anne",
    "value": "princess anne"
  },
  {
    "text": "Princeton",
    "value": "princeton"
  },
  {
    "text": "Princeton Junction",
    "value": "princeton junction"
  },
  {
    "text": "Princeville",
    "value": "princeville"
  },
  {
    "text": "Princewick",
    "value": "princewick"
  },
  {
    "text": "Prineville",
    "value": "prineville"
  },
  {
    "text": "Pringle",
    "value": "pringle"
  },
  {
    "text": "Prinsburg",
    "value": "prinsburg"
  },
  {
    "text": "Printer",
    "value": "printer"
  },
  {
    "text": "Prior Lake",
    "value": "prior lake"
  },
  {
    "text": "Pritchett",
    "value": "pritchett"
  },
  {
    "text": "Proberta",
    "value": "proberta"
  },
  {
    "text": "Procious",
    "value": "procious"
  },
  {
    "text": "Proctor",
    "value": "proctor"
  },
  {
    "text": "Proctorsville",
    "value": "proctorsville"
  },
  {
    "text": "Proctorville",
    "value": "proctorville"
  },
  {
    "text": "Progreso",
    "value": "progreso"
  },
  {
    "text": "Progress Village",
    "value": "progress village"
  },
  {
    "text": "Prole",
    "value": "prole"
  },
  {
    "text": "Promise City",
    "value": "promise city"
  },
  {
    "text": "Prophetstown",
    "value": "prophetstown"
  },
  {
    "text": "Prospect",
    "value": "prospect"
  },
  {
    "text": "Prospect Harbor",
    "value": "prospect harbor"
  },
  {
    "text": "Prospect Heights",
    "value": "prospect heights"
  },
  {
    "text": "Prospect Hill",
    "value": "prospect hill"
  },
  {
    "text": "Prospect Park",
    "value": "prospect park"
  },
  {
    "text": "Prosper",
    "value": "prosper"
  },
  {
    "text": "Prosperity",
    "value": "prosperity"
  },
  {
    "text": "Prosser",
    "value": "prosser"
  },
  {
    "text": "Protection",
    "value": "protection"
  },
  {
    "text": "Protem",
    "value": "protem"
  },
  {
    "text": "Protivin",
    "value": "protivin"
  },
  {
    "text": "Provencal",
    "value": "provencal"
  },
  {
    "text": "Providence",
    "value": "providence"
  },
  {
    "text": "Providence Forge",
    "value": "providence forge"
  },
  {
    "text": "Provincetown",
    "value": "provincetown"
  },
  {
    "text": "Provo",
    "value": "provo"
  },
  {
    "text": "Prudenville",
    "value": "prudenville"
  },
  {
    "text": "Prudhoe Bay",
    "value": "prudhoe bay"
  },
  {
    "text": "Prue",
    "value": "prue"
  },
  {
    "text": "Pryor",
    "value": "pryor"
  },
  {
    "text": "Pueblo",
    "value": "pueblo"
  },
  {
    "text": "Pueblo West",
    "value": "pueblo west"
  },
  {
    "text": "Puhi",
    "value": "puhi"
  },
  {
    "text": "Pukalani",
    "value": "pukalani"
  },
  {
    "text": "Pukwana",
    "value": "pukwana"
  },
  {
    "text": "Pulaski",
    "value": "pulaski"
  },
  {
    "text": "Pullman",
    "value": "pullman"
  },
  {
    "text": "Pumphrey",
    "value": "pumphrey"
  },
  {
    "text": "Punaluu",
    "value": "punaluu"
  },
  {
    "text": "Punta Gorda",
    "value": "punta gorda"
  },
  {
    "text": "Punxsutawney",
    "value": "punxsutawney"
  },
  {
    "text": "Puposky",
    "value": "puposky"
  },
  {
    "text": "Purcell",
    "value": "purcell"
  },
  {
    "text": "Purcellville",
    "value": "purcellville"
  },
  {
    "text": "Purchase",
    "value": "purchase"
  },
  {
    "text": "Purdin",
    "value": "purdin"
  },
  {
    "text": "Purdon",
    "value": "purdon"
  },
  {
    "text": "Purdum",
    "value": "purdum"
  },
  {
    "text": "Purdy",
    "value": "purdy"
  },
  {
    "text": "Purdys",
    "value": "purdys"
  },
  {
    "text": "Purgatory",
    "value": "purgatory"
  },
  {
    "text": "Purgitsville",
    "value": "purgitsville"
  },
  {
    "text": "Purlear",
    "value": "purlear"
  },
  {
    "text": "Purling",
    "value": "purling"
  },
  {
    "text": "Purmela",
    "value": "purmela"
  },
  {
    "text": "Pursglove",
    "value": "pursglove"
  },
  {
    "text": "Purvis",
    "value": "purvis"
  },
  {
    "text": "Puryear",
    "value": "puryear"
  },
  {
    "text": "Put-in-Bay",
    "value": "put-in-bay"
  },
  {
    "text": "Putnam",
    "value": "putnam"
  },
  {
    "text": "Putnam Station",
    "value": "putnam station"
  },
  {
    "text": "Putnam Valley",
    "value": "putnam valley"
  },
  {
    "text": "Putney",
    "value": "putney"
  },
  {
    "text": "Puunene",
    "value": "puunene"
  },
  {
    "text": "Puxico",
    "value": "puxico"
  },
  {
    "text": "Puyallup",
    "value": "puyallup"
  },
  {
    "text": "Puʻunēnē",
    "value": "puʻunēnē"
  },
  {
    "text": "Pyatt",
    "value": "pyatt"
  },
  {
    "text": "Pylesville",
    "value": "pylesville"
  },
  {
    "text": "Pyote",
    "value": "pyote"
  },
  {
    "text": "Pāhala",
    "value": "pāhala"
  },
  {
    "text": "Quail Valley",
    "value": "quail valley"
  },
  {
    "text": "Quakake",
    "value": "quakake"
  },
  {
    "text": "Quaker City",
    "value": "quaker city"
  },
  {
    "text": "Quaker Hill",
    "value": "quaker hill"
  },
  {
    "text": "Quakertown",
    "value": "quakertown"
  },
  {
    "text": "Quanah",
    "value": "quanah"
  },
  {
    "text": "Quantico",
    "value": "quantico"
  },
  {
    "text": "Quapaw",
    "value": "quapaw"
  },
  {
    "text": "Quarryville",
    "value": "quarryville"
  },
  {
    "text": "Quartz Hill",
    "value": "quartz hill"
  },
  {
    "text": "Quartzsite",
    "value": "quartzsite"
  },
  {
    "text": "Quasqueton",
    "value": "quasqueton"
  },
  {
    "text": "Quay",
    "value": "quay"
  },
  {
    "text": "Quebeck",
    "value": "quebeck"
  },
  {
    "text": "Quechee",
    "value": "quechee"
  },
  {
    "text": "Quecreek",
    "value": "quecreek"
  },
  {
    "text": "Queen",
    "value": "queen"
  },
  {
    "text": "Queen Anne",
    "value": "queen anne"
  },
  {
    "text": "Queen City",
    "value": "queen city"
  },
  {
    "text": "Queen Creek",
    "value": "queen creek"
  },
  {
    "text": "Queens",
    "value": "queens"
  },
  {
    "text": "Queens Village",
    "value": "queens village"
  },
  {
    "text": "Queensbury",
    "value": "queensbury"
  },
  {
    "text": "Queenstown",
    "value": "queenstown"
  },
  {
    "text": "Quemado",
    "value": "quemado"
  },
  {
    "text": "Quenemo",
    "value": "quenemo"
  },
  {
    "text": "Questa",
    "value": "questa"
  },
  {
    "text": "Quilcene",
    "value": "quilcene"
  },
  {
    "text": "Quinault",
    "value": "quinault"
  },
  {
    "text": "Quinby",
    "value": "quinby"
  },
  {
    "text": "Quincy",
    "value": "quincy"
  },
  {
    "text": "Quinhagak",
    "value": "quinhagak"
  },
  {
    "text": "Quinlan",
    "value": "quinlan"
  },
  {
    "text": "Quinn",
    "value": "quinn"
  },
  {
    "text": "Quinnesec",
    "value": "quinnesec"
  },
  {
    "text": "Quinter",
    "value": "quinter"
  },
  {
    "text": "Quinton",
    "value": "quinton"
  },
  {
    "text": "Quinwood",
    "value": "quinwood"
  },
  {
    "text": "Quitaque",
    "value": "quitaque"
  },
  {
    "text": "Quitman",
    "value": "quitman"
  },
  {
    "text": "Qulin",
    "value": "qulin"
  },
  {
    "text": "Quogue",
    "value": "quogue"
  },
  {
    "text": "Rabun Gap",
    "value": "rabun gap"
  },
  {
    "text": "Raccoon",
    "value": "raccoon"
  },
  {
    "text": "Raceland",
    "value": "raceland"
  },
  {
    "text": "Rachel",
    "value": "rachel"
  },
  {
    "text": "Racine",
    "value": "racine"
  },
  {
    "text": "Radcliff",
    "value": "radcliff"
  },
  {
    "text": "Radcliffe",
    "value": "radcliffe"
  },
  {
    "text": "Radford",
    "value": "radford"
  },
  {
    "text": "Radiant",
    "value": "radiant"
  },
  {
    "text": "Radisson",
    "value": "radisson"
  },
  {
    "text": "Radium",
    "value": "radium"
  },
  {
    "text": "Radium Springs",
    "value": "radium springs"
  },
  {
    "text": "Radnor",
    "value": "radnor"
  },
  {
    "text": "Radom",
    "value": "radom"
  },
  {
    "text": "Raeford",
    "value": "raeford"
  },
  {
    "text": "Ragland",
    "value": "ragland"
  },
  {
    "text": "Ragley",
    "value": "ragley"
  },
  {
    "text": "Rahway",
    "value": "rahway"
  },
  {
    "text": "Raiford",
    "value": "raiford"
  },
  {
    "text": "Rail Road Flat",
    "value": "rail road flat"
  },
  {
    "text": "Railroad",
    "value": "railroad"
  },
  {
    "text": "Rainbow",
    "value": "rainbow"
  },
  {
    "text": "Rainbow City",
    "value": "rainbow city"
  },
  {
    "text": "Rainbow Lake",
    "value": "rainbow lake"
  },
  {
    "text": "Rainelle",
    "value": "rainelle"
  },
  {
    "text": "Rainier",
    "value": "rainier"
  },
  {
    "text": "Rainsville",
    "value": "rainsville"
  },
  {
    "text": "Raisin City",
    "value": "raisin city"
  },
  {
    "text": "Raleigh",
    "value": "raleigh"
  },
  {
    "text": "Raleigh Hills",
    "value": "raleigh hills"
  },
  {
    "text": "Ralls",
    "value": "ralls"
  },
  {
    "text": "Ralph",
    "value": "ralph"
  },
  {
    "text": "Ralston",
    "value": "ralston"
  },
  {
    "text": "Ramah",
    "value": "ramah"
  },
  {
    "text": "Ramblewood",
    "value": "ramblewood"
  },
  {
    "text": "Ramer",
    "value": "ramer"
  },
  {
    "text": "Ramey",
    "value": "ramey"
  },
  {
    "text": "Ramona",
    "value": "ramona"
  },
  {
    "text": "Rampart",
    "value": "rampart"
  },
  {
    "text": "Ramsay",
    "value": "ramsay"
  },
  {
    "text": "Ramseur",
    "value": "ramseur"
  },
  {
    "text": "Ramsey",
    "value": "ramsey"
  },
  {
    "text": "Ranburne",
    "value": "ranburne"
  },
  {
    "text": "Ranchester",
    "value": "ranchester"
  },
  {
    "text": "Ranchettes",
    "value": "ranchettes"
  },
  {
    "text": "Ranchita",
    "value": "ranchita"
  },
  {
    "text": "Rancho Bernardo",
    "value": "rancho bernardo"
  },
  {
    "text": "Rancho Cordova",
    "value": "rancho cordova"
  },
  {
    "text": "Rancho Cucamonga",
    "value": "rancho cucamonga"
  },
  {
    "text": "Rancho Mirage",
    "value": "rancho mirage"
  },
  {
    "text": "Rancho Murieta",
    "value": "rancho murieta"
  },
  {
    "text": "Rancho Palos Verdes",
    "value": "rancho palos verdes"
  },
  {
    "text": "Rancho Santa Fe",
    "value": "rancho santa fe"
  },
  {
    "text": "Rancho Santa Margarita",
    "value": "rancho santa margarita"
  },
  {
    "text": "Rancho Viejo",
    "value": "rancho viejo"
  },
  {
    "text": "Ranchos de Taos",
    "value": "ranchos de taos"
  },
  {
    "text": "Rancocas",
    "value": "rancocas"
  },
  {
    "text": "Randall",
    "value": "randall"
  },
  {
    "text": "Randallstown",
    "value": "randallstown"
  },
  {
    "text": "Randle",
    "value": "randle"
  },
  {
    "text": "Randleman",
    "value": "randleman"
  },
  {
    "text": "Randlett",
    "value": "randlett"
  },
  {
    "text": "Randolph",
    "value": "randolph"
  },
  {
    "text": "Randolph Center",
    "value": "randolph center"
  },
  {
    "text": "Randolph Township",
    "value": "randolph township"
  },
  {
    "text": "Random Lake",
    "value": "random lake"
  },
  {
    "text": "Range",
    "value": "range"
  },
  {
    "text": "Rangeley",
    "value": "rangeley"
  },
  {
    "text": "Rangely",
    "value": "rangely"
  },
  {
    "text": "Ranger",
    "value": "ranger"
  },
  {
    "text": "Ranier",
    "value": "ranier"
  },
  {
    "text": "Rankin",
    "value": "rankin"
  },
  {
    "text": "Ranlo",
    "value": "ranlo"
  },
  {
    "text": "Ransom",
    "value": "ransom"
  },
  {
    "text": "Ransom Canyon",
    "value": "ransom canyon"
  },
  {
    "text": "Ransomville",
    "value": "ransomville"
  },
  {
    "text": "Ranson",
    "value": "ranson"
  },
  {
    "text": "Rantoul",
    "value": "rantoul"
  },
  {
    "text": "Raoul",
    "value": "raoul"
  },
  {
    "text": "Rapelje",
    "value": "rapelje"
  },
  {
    "text": "Raphine",
    "value": "raphine"
  },
  {
    "text": "Rapid City",
    "value": "rapid city"
  },
  {
    "text": "Rapid River",
    "value": "rapid river"
  },
  {
    "text": "Rapidan",
    "value": "rapidan"
  },
  {
    "text": "Rapids",
    "value": "rapids"
  },
  {
    "text": "Rapids City",
    "value": "rapids city"
  },
  {
    "text": "Raquette Lake",
    "value": "raquette lake"
  },
  {
    "text": "Rarden",
    "value": "rarden"
  },
  {
    "text": "Raritan",
    "value": "raritan"
  },
  {
    "text": "Ratcliff",
    "value": "ratcliff"
  },
  {
    "text": "Rathdrum",
    "value": "rathdrum"
  },
  {
    "text": "Ratliff City",
    "value": "ratliff city"
  },
  {
    "text": "Raton",
    "value": "raton"
  },
  {
    "text": "Rattan",
    "value": "rattan"
  },
  {
    "text": "Ravalli",
    "value": "ravalli"
  },
  {
    "text": "Raven",
    "value": "raven"
  },
  {
    "text": "Ravena",
    "value": "ravena"
  },
  {
    "text": "Ravencliff",
    "value": "ravencliff"
  },
  {
    "text": "Ravenden",
    "value": "ravenden"
  },
  {
    "text": "Ravenden Springs",
    "value": "ravenden springs"
  },
  {
    "text": "Ravenel",
    "value": "ravenel"
  },
  {
    "text": "Ravenna",
    "value": "ravenna"
  },
  {
    "text": "Ravensdale",
    "value": "ravensdale"
  },
  {
    "text": "Ravenswood",
    "value": "ravenswood"
  },
  {
    "text": "Ravenwood",
    "value": "ravenwood"
  },
  {
    "text": "Ravia",
    "value": "ravia"
  },
  {
    "text": "Rawlings",
    "value": "rawlings"
  },
  {
    "text": "Rawlins",
    "value": "rawlins"
  },
  {
    "text": "Rawson",
    "value": "rawson"
  },
  {
    "text": "Ray",
    "value": "ray"
  },
  {
    "text": "Ray Brook",
    "value": "ray brook"
  },
  {
    "text": "Ray Center",
    "value": "ray center"
  },
  {
    "text": "Ray City",
    "value": "ray city"
  },
  {
    "text": "Rayland",
    "value": "rayland"
  },
  {
    "text": "Rayle",
    "value": "rayle"
  },
  {
    "text": "Raymond",
    "value": "raymond"
  },
  {
    "text": "Raymondville",
    "value": "raymondville"
  },
  {
    "text": "Raymore",
    "value": "raymore"
  },
  {
    "text": "Rayne",
    "value": "rayne"
  },
  {
    "text": "Raynesford",
    "value": "raynesford"
  },
  {
    "text": "Raynham",
    "value": "raynham"
  },
  {
    "text": "Raysal",
    "value": "raysal"
  },
  {
    "text": "Raytown",
    "value": "raytown"
  },
  {
    "text": "Rayville",
    "value": "rayville"
  },
  {
    "text": "Raywick",
    "value": "raywick"
  },
  {
    "text": "Raywood",
    "value": "raywood"
  },
  {
    "text": "Rea",
    "value": "rea"
  },
  {
    "text": "Reader",
    "value": "reader"
  },
  {
    "text": "Readfield",
    "value": "readfield"
  },
  {
    "text": "Reading",
    "value": "reading"
  },
  {
    "text": "Reading Center",
    "value": "reading center"
  },
  {
    "text": "Readington",
    "value": "readington"
  },
  {
    "text": "Readlyn",
    "value": "readlyn"
  },
  {
    "text": "Reads Landing",
    "value": "reads landing"
  },
  {
    "text": "Readsboro",
    "value": "readsboro"
  },
  {
    "text": "Readstown",
    "value": "readstown"
  },
  {
    "text": "Readville",
    "value": "readville"
  },
  {
    "text": "Readyville",
    "value": "readyville"
  },
  {
    "text": "Reagan",
    "value": "reagan"
  },
  {
    "text": "Realitos",
    "value": "realitos"
  },
  {
    "text": "Reamstown",
    "value": "reamstown"
  },
  {
    "text": "Reardan",
    "value": "reardan"
  },
  {
    "text": "Reasnor",
    "value": "reasnor"
  },
  {
    "text": "Rebecca",
    "value": "rebecca"
  },
  {
    "text": "Rebersburg",
    "value": "rebersburg"
  },
  {
    "text": "Recluse",
    "value": "recluse"
  },
  {
    "text": "Rector",
    "value": "rector"
  },
  {
    "text": "Red Bank",
    "value": "red bank"
  },
  {
    "text": "Red Banks",
    "value": "red banks"
  },
  {
    "text": "Red Bay",
    "value": "red bay"
  },
  {
    "text": "Red Bluff",
    "value": "red bluff"
  },
  {
    "text": "Red Boiling Springs",
    "value": "red boiling springs"
  },
  {
    "text": "Red Bud",
    "value": "red bud"
  },
  {
    "text": "Red Cliff",
    "value": "red cliff"
  },
  {
    "text": "Red Cloud",
    "value": "red cloud"
  },
  {
    "text": "Red Creek",
    "value": "red creek"
  },
  {
    "text": "Red Feather Lakes",
    "value": "red feather lakes"
  },
  {
    "text": "Red Hill",
    "value": "red hill"
  },
  {
    "text": "Red Hook",
    "value": "red hook"
  },
  {
    "text": "Red House",
    "value": "red house"
  },
  {
    "text": "Red Jacket",
    "value": "red jacket"
  },
  {
    "text": "Red Lake",
    "value": "red lake"
  },
  {
    "text": "Red Lake Falls",
    "value": "red lake falls"
  },
  {
    "text": "Red Level",
    "value": "red level"
  },
  {
    "text": "Red Lion",
    "value": "red lion"
  },
  {
    "text": "Red Lodge",
    "value": "red lodge"
  },
  {
    "text": "Red Oak",
    "value": "red oak"
  },
  {
    "text": "Red River",
    "value": "red river"
  },
  {
    "text": "Red Rock",
    "value": "red rock"
  },
  {
    "text": "Red Springs",
    "value": "red springs"
  },
  {
    "text": "Red Wing",
    "value": "red wing"
  },
  {
    "text": "Redan",
    "value": "redan"
  },
  {
    "text": "Redby",
    "value": "redby"
  },
  {
    "text": "Redcrest",
    "value": "redcrest"
  },
  {
    "text": "Reddick",
    "value": "reddick"
  },
  {
    "text": "Redding",
    "value": "redding"
  },
  {
    "text": "Redfield",
    "value": "redfield"
  },
  {
    "text": "Redford",
    "value": "redford"
  },
  {
    "text": "Redfox",
    "value": "redfox"
  },
  {
    "text": "Redgranite",
    "value": "redgranite"
  },
  {
    "text": "Redington Beach",
    "value": "redington beach"
  },
  {
    "text": "Redington Shores",
    "value": "redington shores"
  },
  {
    "text": "Redkey",
    "value": "redkey"
  },
  {
    "text": "Redland",
    "value": "redland"
  },
  {
    "text": "Redlands",
    "value": "redlands"
  },
  {
    "text": "Redmon",
    "value": "redmon"
  },
  {
    "text": "Redmond",
    "value": "redmond"
  },
  {
    "text": "Redondo Beach",
    "value": "redondo beach"
  },
  {
    "text": "Redstone",
    "value": "redstone"
  },
  {
    "text": "Redstone Arsenal",
    "value": "redstone arsenal"
  },
  {
    "text": "Redwater",
    "value": "redwater"
  },
  {
    "text": "Redway",
    "value": "redway"
  },
  {
    "text": "Redwood",
    "value": "redwood"
  },
  {
    "text": "Redwood City",
    "value": "redwood city"
  },
  {
    "text": "Redwood Estates",
    "value": "redwood estates"
  },
  {
    "text": "Redwood Falls",
    "value": "redwood falls"
  },
  {
    "text": "Redwood Shores",
    "value": "redwood shores"
  },
  {
    "text": "Redwood Valley",
    "value": "redwood valley"
  },
  {
    "text": "Ree Heights",
    "value": "ree heights"
  },
  {
    "text": "Reed",
    "value": "reed"
  },
  {
    "text": "Reed City",
    "value": "reed city"
  },
  {
    "text": "Reed Creek",
    "value": "reed creek"
  },
  {
    "text": "Reed Point",
    "value": "reed point"
  },
  {
    "text": "Reeder",
    "value": "reeder"
  },
  {
    "text": "Reedley",
    "value": "reedley"
  },
  {
    "text": "Reeds",
    "value": "reeds"
  },
  {
    "text": "Reeds Spring",
    "value": "reeds spring"
  },
  {
    "text": "Reedsburg",
    "value": "reedsburg"
  },
  {
    "text": "Reedsport",
    "value": "reedsport"
  },
  {
    "text": "Reedsville",
    "value": "reedsville"
  },
  {
    "text": "Reedville",
    "value": "reedville"
  },
  {
    "text": "Reedy",
    "value": "reedy"
  },
  {
    "text": "Reelsville",
    "value": "reelsville"
  },
  {
    "text": "Reeman",
    "value": "reeman"
  },
  {
    "text": "Reese",
    "value": "reese"
  },
  {
    "text": "Reeseville",
    "value": "reeseville"
  },
  {
    "text": "Reeves",
    "value": "reeves"
  },
  {
    "text": "Reevesville",
    "value": "reevesville"
  },
  {
    "text": "Reform",
    "value": "reform"
  },
  {
    "text": "Refugio",
    "value": "refugio"
  },
  {
    "text": "Regency of Iowa Mobile Home Park",
    "value": "regency of iowa mobile home park"
  },
  {
    "text": "Regent",
    "value": "regent"
  },
  {
    "text": "Regina",
    "value": "regina"
  },
  {
    "text": "Register",
    "value": "register"
  },
  {
    "text": "Rego Park",
    "value": "rego park"
  },
  {
    "text": "Rehobeth",
    "value": "rehobeth"
  },
  {
    "text": "Rehoboth",
    "value": "rehoboth"
  },
  {
    "text": "Rehoboth Beach",
    "value": "rehoboth beach"
  },
  {
    "text": "Rehrersburg",
    "value": "rehrersburg"
  },
  {
    "text": "Reidsville",
    "value": "reidsville"
  },
  {
    "text": "Reidville",
    "value": "reidville"
  },
  {
    "text": "Reinbeck",
    "value": "reinbeck"
  },
  {
    "text": "Reinholds",
    "value": "reinholds"
  },
  {
    "text": "Reisterstown",
    "value": "reisterstown"
  },
  {
    "text": "Reklaw",
    "value": "reklaw"
  },
  {
    "text": "Reliance",
    "value": "reliance"
  },
  {
    "text": "Rembert",
    "value": "rembert"
  },
  {
    "text": "Rembrandt",
    "value": "rembrandt"
  },
  {
    "text": "Remer",
    "value": "remer"
  },
  {
    "text": "Remerton",
    "value": "remerton"
  },
  {
    "text": "Reminderville",
    "value": "reminderville"
  },
  {
    "text": "Remington",
    "value": "remington"
  },
  {
    "text": "Remlap",
    "value": "remlap"
  },
  {
    "text": "Remsen",
    "value": "remsen"
  },
  {
    "text": "Remsenburg",
    "value": "remsenburg"
  },
  {
    "text": "Remus",
    "value": "remus"
  },
  {
    "text": "Renfrew",
    "value": "renfrew"
  },
  {
    "text": "Renick",
    "value": "renick"
  },
  {
    "text": "Renner",
    "value": "renner"
  },
  {
    "text": "Reno",
    "value": "reno"
  },
  {
    "text": "Renovo",
    "value": "renovo"
  },
  {
    "text": "Rensselaer",
    "value": "rensselaer"
  },
  {
    "text": "Rensselaer Falls",
    "value": "rensselaer falls"
  },
  {
    "text": "Rensselaerville",
    "value": "rensselaerville"
  },
  {
    "text": "Renton",
    "value": "renton"
  },
  {
    "text": "Rentz",
    "value": "rentz"
  },
  {
    "text": "Renville",
    "value": "renville"
  },
  {
    "text": "Renwick",
    "value": "renwick"
  },
  {
    "text": "Represa",
    "value": "represa"
  },
  {
    "text": "Repton",
    "value": "repton"
  },
  {
    "text": "Republic",
    "value": "republic"
  },
  {
    "text": "Republican City",
    "value": "republican city"
  },
  {
    "text": "Resaca",
    "value": "resaca"
  },
  {
    "text": "Rescue",
    "value": "rescue"
  },
  {
    "text": "Reseda",
    "value": "reseda"
  },
  {
    "text": "Reserve",
    "value": "reserve"
  },
  {
    "text": "Reston",
    "value": "reston"
  },
  {
    "text": "Retsof",
    "value": "retsof"
  },
  {
    "text": "Reubens",
    "value": "reubens"
  },
  {
    "text": "Reva",
    "value": "reva"
  },
  {
    "text": "Revelo",
    "value": "revelo"
  },
  {
    "text": "Revere",
    "value": "revere"
  },
  {
    "text": "Revillo",
    "value": "revillo"
  },
  {
    "text": "Revloc",
    "value": "revloc"
  },
  {
    "text": "Rew",
    "value": "rew"
  },
  {
    "text": "Rewey",
    "value": "rewey"
  },
  {
    "text": "Rex",
    "value": "rex"
  },
  {
    "text": "Rexburg",
    "value": "rexburg"
  },
  {
    "text": "Rexford",
    "value": "rexford"
  },
  {
    "text": "Reydon",
    "value": "reydon"
  },
  {
    "text": "Reyno",
    "value": "reyno"
  },
  {
    "text": "Reynolds",
    "value": "reynolds"
  },
  {
    "text": "Reynoldsburg",
    "value": "reynoldsburg"
  },
  {
    "text": "Reynoldsville",
    "value": "reynoldsville"
  },
  {
    "text": "Rhame",
    "value": "rhame"
  },
  {
    "text": "Rheems",
    "value": "rheems"
  },
  {
    "text": "Rhine",
    "value": "rhine"
  },
  {
    "text": "Rhinebeck",
    "value": "rhinebeck"
  },
  {
    "text": "Rhineland",
    "value": "rhineland"
  },
  {
    "text": "Rhinelander",
    "value": "rhinelander"
  },
  {
    "text": "Rhoadesville",
    "value": "rhoadesville"
  },
  {
    "text": "Rhodelia",
    "value": "rhodelia"
  },
  {
    "text": "Rhodell",
    "value": "rhodell"
  },
  {
    "text": "Rhodes",
    "value": "rhodes"
  },
  {
    "text": "Rhodesdale",
    "value": "rhodesdale"
  },
  {
    "text": "Rhodhiss",
    "value": "rhodhiss"
  },
  {
    "text": "Rhododendron",
    "value": "rhododendron"
  },
  {
    "text": "Rhome",
    "value": "rhome"
  },
  {
    "text": "Rialto",
    "value": "rialto"
  },
  {
    "text": "Rib Lake",
    "value": "rib lake"
  },
  {
    "text": "Rib Mountain",
    "value": "rib mountain"
  },
  {
    "text": "Ribera",
    "value": "ribera"
  },
  {
    "text": "Rice",
    "value": "rice"
  },
  {
    "text": "Rice Lake",
    "value": "rice lake"
  },
  {
    "text": "Riceboro",
    "value": "riceboro"
  },
  {
    "text": "Rices Landing",
    "value": "rices landing"
  },
  {
    "text": "Riceville",
    "value": "riceville"
  },
  {
    "text": "Rich Creek",
    "value": "rich creek"
  },
  {
    "text": "Rich Hill",
    "value": "rich hill"
  },
  {
    "text": "Rich Square",
    "value": "rich square"
  },
  {
    "text": "Richards",
    "value": "richards"
  },
  {
    "text": "Richardson",
    "value": "richardson"
  },
  {
    "text": "Richardsville",
    "value": "richardsville"
  },
  {
    "text": "Richardton",
    "value": "richardton"
  },
  {
    "text": "Richboro",
    "value": "richboro"
  },
  {
    "text": "Richburg",
    "value": "richburg"
  },
  {
    "text": "Richey",
    "value": "richey"
  },
  {
    "text": "Richeyville",
    "value": "richeyville"
  },
  {
    "text": "Richfield",
    "value": "richfield"
  },
  {
    "text": "Richfield Springs",
    "value": "richfield springs"
  },
  {
    "text": "Richford",
    "value": "richford"
  },
  {
    "text": "Richgrove",
    "value": "richgrove"
  },
  {
    "text": "Richland",
    "value": "richland"
  },
  {
    "text": "Richland Center",
    "value": "richland center"
  },
  {
    "text": "Richland City",
    "value": "richland city"
  },
  {
    "text": "Richland Hills",
    "value": "richland hills"
  },
  {
    "text": "Richland Springs",
    "value": "richland springs"
  },
  {
    "text": "Richlands",
    "value": "richlands"
  },
  {
    "text": "Richlandtown",
    "value": "richlandtown"
  },
  {
    "text": "Richmond",
    "value": "richmond"
  },
  {
    "text": "Richmond Beach",
    "value": "richmond beach"
  },
  {
    "text": "Richmond Dale",
    "value": "richmond dale"
  },
  {
    "text": "Richmond Heights",
    "value": "richmond heights"
  },
  {
    "text": "Richmond Hill",
    "value": "richmond hill"
  },
  {
    "text": "Richmondville",
    "value": "richmondville"
  },
  {
    "text": "Richton",
    "value": "richton"
  },
  {
    "text": "Richton Park",
    "value": "richton park"
  },
  {
    "text": "Richvale",
    "value": "richvale"
  },
  {
    "text": "Richview",
    "value": "richview"
  },
  {
    "text": "Richville",
    "value": "richville"
  },
  {
    "text": "Richwood",
    "value": "richwood"
  },
  {
    "text": "Richwoods",
    "value": "richwoods"
  },
  {
    "text": "Rickman",
    "value": "rickman"
  },
  {
    "text": "Rickreall",
    "value": "rickreall"
  },
  {
    "text": "Rico",
    "value": "rico"
  },
  {
    "text": "Riddle",
    "value": "riddle"
  },
  {
    "text": "Riddlesburg",
    "value": "riddlesburg"
  },
  {
    "text": "Riddleton",
    "value": "riddleton"
  },
  {
    "text": "Ridge",
    "value": "ridge"
  },
  {
    "text": "Ridge Manor",
    "value": "ridge manor"
  },
  {
    "text": "Ridge Spring",
    "value": "ridge spring"
  },
  {
    "text": "Ridge Wood Heights",
    "value": "ridge wood heights"
  },
  {
    "text": "Ridgecrest",
    "value": "ridgecrest"
  },
  {
    "text": "Ridgedale",
    "value": "ridgedale"
  },
  {
    "text": "Ridgefield",
    "value": "ridgefield"
  },
  {
    "text": "Ridgefield Park",
    "value": "ridgefield park"
  },
  {
    "text": "Ridgeland",
    "value": "ridgeland"
  },
  {
    "text": "Ridgeley",
    "value": "ridgeley"
  },
  {
    "text": "Ridgely",
    "value": "ridgely"
  },
  {
    "text": "Ridgeview",
    "value": "ridgeview"
  },
  {
    "text": "Ridgeville",
    "value": "ridgeville"
  },
  {
    "text": "Ridgeville Corners",
    "value": "ridgeville corners"
  },
  {
    "text": "Ridgeway",
    "value": "ridgeway"
  },
  {
    "text": "Ridgewood",
    "value": "ridgewood"
  },
  {
    "text": "Ridgway",
    "value": "ridgway"
  },
  {
    "text": "Ridley Park",
    "value": "ridley park"
  },
  {
    "text": "Ridott",
    "value": "ridott"
  },
  {
    "text": "Riegelsville",
    "value": "riegelsville"
  },
  {
    "text": "Riegelwood",
    "value": "riegelwood"
  },
  {
    "text": "Rienzi",
    "value": "rienzi"
  },
  {
    "text": "Riesel",
    "value": "riesel"
  },
  {
    "text": "Rifle",
    "value": "rifle"
  },
  {
    "text": "Rifton",
    "value": "rifton"
  },
  {
    "text": "Riga",
    "value": "riga"
  },
  {
    "text": "Rigby",
    "value": "rigby"
  },
  {
    "text": "Riggins",
    "value": "riggins"
  },
  {
    "text": "Riley",
    "value": "riley"
  },
  {
    "text": "Rileyville",
    "value": "rileyville"
  },
  {
    "text": "Rillito",
    "value": "rillito"
  },
  {
    "text": "Rillton",
    "value": "rillton"
  },
  {
    "text": "Rimersburg",
    "value": "rimersburg"
  },
  {
    "text": "Rimforest",
    "value": "rimforest"
  },
  {
    "text": "Rimrock",
    "value": "rimrock"
  },
  {
    "text": "Rinard",
    "value": "rinard"
  },
  {
    "text": "Rincon",
    "value": "rincon"
  },
  {
    "text": "Rindge",
    "value": "rindge"
  },
  {
    "text": "Riner",
    "value": "riner"
  },
  {
    "text": "Rineyville",
    "value": "rineyville"
  },
  {
    "text": "Ringgold",
    "value": "ringgold"
  },
  {
    "text": "Ringle",
    "value": "ringle"
  },
  {
    "text": "Ringling",
    "value": "ringling"
  },
  {
    "text": "Ringoes",
    "value": "ringoes"
  },
  {
    "text": "Ringold",
    "value": "ringold"
  },
  {
    "text": "Ringsted",
    "value": "ringsted"
  },
  {
    "text": "Ringtown",
    "value": "ringtown"
  },
  {
    "text": "Ringwood",
    "value": "ringwood"
  },
  {
    "text": "Rio",
    "value": "rio"
  },
  {
    "text": "Rio Bravo",
    "value": "rio bravo"
  },
  {
    "text": "Rio Communities",
    "value": "rio communities"
  },
  {
    "text": "Rio Dell",
    "value": "rio dell"
  },
  {
    "text": "Rio Grande",
    "value": "rio grande"
  },
  {
    "text": "Rio Grande City",
    "value": "rio grande city"
  },
  {
    "text": "Rio Hondo",
    "value": "rio hondo"
  },
  {
    "text": "Rio Linda",
    "value": "rio linda"
  },
  {
    "text": "Rio Medina",
    "value": "rio medina"
  },
  {
    "text": "Rio Oso",
    "value": "rio oso"
  },
  {
    "text": "Rio Rancho",
    "value": "rio rancho"
  },
  {
    "text": "Rio Rico",
    "value": "rio rico"
  },
  {
    "text": "Rio Verde",
    "value": "rio verde"
  },
  {
    "text": "Rio Vista",
    "value": "rio vista"
  },
  {
    "text": "Riomedina",
    "value": "riomedina"
  },
  {
    "text": "Ripley",
    "value": "ripley"
  },
  {
    "text": "Ripon",
    "value": "ripon"
  },
  {
    "text": "Rippey",
    "value": "rippey"
  },
  {
    "text": "Ripplemead",
    "value": "ripplemead"
  },
  {
    "text": "Ripton",
    "value": "ripton"
  },
  {
    "text": "Ririe",
    "value": "ririe"
  },
  {
    "text": "Risco",
    "value": "risco"
  },
  {
    "text": "Rising City",
    "value": "rising city"
  },
  {
    "text": "Rising Fawn",
    "value": "rising fawn"
  },
  {
    "text": "Rising Star",
    "value": "rising star"
  },
  {
    "text": "Rising Sun",
    "value": "rising sun"
  },
  {
    "text": "Risingsun",
    "value": "risingsun"
  },
  {
    "text": "Rison",
    "value": "rison"
  },
  {
    "text": "Rittman",
    "value": "rittman"
  },
  {
    "text": "Ritzville",
    "value": "ritzville"
  },
  {
    "text": "Riva",
    "value": "riva"
  },
  {
    "text": "River Bend",
    "value": "river bend"
  },
  {
    "text": "River Edge",
    "value": "river edge"
  },
  {
    "text": "River Falls",
    "value": "river falls"
  },
  {
    "text": "River Forest",
    "value": "river forest"
  },
  {
    "text": "River Grove",
    "value": "river grove"
  },
  {
    "text": "River Heights",
    "value": "river heights"
  },
  {
    "text": "River Hills",
    "value": "river hills"
  },
  {
    "text": "River Oaks",
    "value": "river oaks"
  },
  {
    "text": "River Pines",
    "value": "river pines"
  },
  {
    "text": "River Ranch",
    "value": "river ranch"
  },
  {
    "text": "River Ridge",
    "value": "river ridge"
  },
  {
    "text": "River Rouge",
    "value": "river rouge"
  },
  {
    "text": "River Vale",
    "value": "river vale"
  },
  {
    "text": "River View Park",
    "value": "river view park"
  },
  {
    "text": "Riverbank",
    "value": "riverbank"
  },
  {
    "text": "Riverdale",
    "value": "riverdale"
  },
  {
    "text": "Riverdale Park",
    "value": "riverdale park"
  },
  {
    "text": "Rivergate",
    "value": "rivergate"
  },
  {
    "text": "Riverhead",
    "value": "riverhead"
  },
  {
    "text": "Riverside",
    "value": "riverside"
  },
  {
    "text": "Riverside Park",
    "value": "riverside park"
  },
  {
    "text": "Riverton",
    "value": "riverton"
  },
  {
    "text": "Riverview",
    "value": "riverview"
  },
  {
    "text": "Riverwoods",
    "value": "riverwoods"
  },
  {
    "text": "Rives",
    "value": "rives"
  },
  {
    "text": "Rives Junction",
    "value": "rives junction"
  },
  {
    "text": "Rivesville",
    "value": "rivesville"
  },
  {
    "text": "Riviera",
    "value": "riviera"
  },
  {
    "text": "Riviera Beach",
    "value": "riviera beach"
  },
  {
    "text": "Rixeyville",
    "value": "rixeyville"
  },
  {
    "text": "Rixford",
    "value": "rixford"
  },
  {
    "text": "Roach",
    "value": "roach"
  },
  {
    "text": "Roachdale",
    "value": "roachdale"
  },
  {
    "text": "Roan Mountain",
    "value": "roan mountain"
  },
  {
    "text": "Roann",
    "value": "roann"
  },
  {
    "text": "Roanoke",
    "value": "roanoke"
  },
  {
    "text": "Roanoke Rapids",
    "value": "roanoke rapids"
  },
  {
    "text": "Roaring Branch",
    "value": "roaring branch"
  },
  {
    "text": "Roaring Gap",
    "value": "roaring gap"
  },
  {
    "text": "Roaring River",
    "value": "roaring river"
  },
  {
    "text": "Roaring Spring",
    "value": "roaring spring"
  },
  {
    "text": "Roaring Springs",
    "value": "roaring springs"
  },
  {
    "text": "Robards",
    "value": "robards"
  },
  {
    "text": "Robbins",
    "value": "robbins"
  },
  {
    "text": "Robbinsdale",
    "value": "robbinsdale"
  },
  {
    "text": "Robbinston",
    "value": "robbinston"
  },
  {
    "text": "Robbinsville",
    "value": "robbinsville"
  },
  {
    "text": "Robeline",
    "value": "robeline"
  },
  {
    "text": "Robersonville",
    "value": "robersonville"
  },
  {
    "text": "Robert",
    "value": "robert"
  },
  {
    "text": "Robert Lee",
    "value": "robert lee"
  },
  {
    "text": "Roberta",
    "value": "roberta"
  },
  {
    "text": "Roberts",
    "value": "roberts"
  },
  {
    "text": "Robertsdale",
    "value": "robertsdale"
  },
  {
    "text": "Robertson",
    "value": "robertson"
  },
  {
    "text": "Robertsville",
    "value": "robertsville"
  },
  {
    "text": "Robesonia",
    "value": "robesonia"
  },
  {
    "text": "Robins",
    "value": "robins"
  },
  {
    "text": "Robins Air Force Base",
    "value": "robins air force base"
  },
  {
    "text": "Robinson",
    "value": "robinson"
  },
  {
    "text": "Robinson Creek",
    "value": "robinson creek"
  },
  {
    "text": "Robinsonville",
    "value": "robinsonville"
  },
  {
    "text": "Robson",
    "value": "robson"
  },
  {
    "text": "Robstown",
    "value": "robstown"
  },
  {
    "text": "Roby",
    "value": "roby"
  },
  {
    "text": "Roca",
    "value": "roca"
  },
  {
    "text": "Rochdale",
    "value": "rochdale"
  },
  {
    "text": "Rochelle",
    "value": "rochelle"
  },
  {
    "text": "Rochelle Park",
    "value": "rochelle park"
  },
  {
    "text": "Rocheport",
    "value": "rocheport"
  },
  {
    "text": "Rochert",
    "value": "rochert"
  },
  {
    "text": "Rochester",
    "value": "rochester"
  },
  {
    "text": "Rochester Hills",
    "value": "rochester hills"
  },
  {
    "text": "Rochester Mills",
    "value": "rochester mills"
  },
  {
    "text": "Rock",
    "value": "rock"
  },
  {
    "text": "Rock Cave",
    "value": "rock cave"
  },
  {
    "text": "Rock City",
    "value": "rock city"
  },
  {
    "text": "Rock City Falls",
    "value": "rock city falls"
  },
  {
    "text": "Rock Creek",
    "value": "rock creek"
  },
  {
    "text": "Rock Falls",
    "value": "rock falls"
  },
  {
    "text": "Rock Glen",
    "value": "rock glen"
  },
  {
    "text": "Rock Hall",
    "value": "rock hall"
  },
  {
    "text": "Rock Hill",
    "value": "rock hill"
  },
  {
    "text": "Rock Island",
    "value": "rock island"
  },
  {
    "text": "Rock Lake",
    "value": "rock lake"
  },
  {
    "text": "Rock Port",
    "value": "rock port"
  },
  {
    "text": "Rock Rapids",
    "value": "rock rapids"
  },
  {
    "text": "Rock River",
    "value": "rock river"
  },
  {
    "text": "Rock Spring",
    "value": "rock spring"
  },
  {
    "text": "Rock Springs",
    "value": "rock springs"
  },
  {
    "text": "Rock Stream",
    "value": "rock stream"
  },
  {
    "text": "Rock Tavern",
    "value": "rock tavern"
  },
  {
    "text": "Rock Valley",
    "value": "rock valley"
  },
  {
    "text": "Rock View",
    "value": "rock view"
  },
  {
    "text": "Rockaway",
    "value": "rockaway"
  },
  {
    "text": "Rockaway Beach",
    "value": "rockaway beach"
  },
  {
    "text": "Rockaway Park",
    "value": "rockaway park"
  },
  {
    "text": "Rockbridge",
    "value": "rockbridge"
  },
  {
    "text": "Rockcreek",
    "value": "rockcreek"
  },
  {
    "text": "Rockdale",
    "value": "rockdale"
  },
  {
    "text": "Rockfall",
    "value": "rockfall"
  },
  {
    "text": "Rockfield",
    "value": "rockfield"
  },
  {
    "text": "Rockfish",
    "value": "rockfish"
  },
  {
    "text": "Rockford",
    "value": "rockford"
  },
  {
    "text": "Rockham",
    "value": "rockham"
  },
  {
    "text": "Rockhill",
    "value": "rockhill"
  },
  {
    "text": "Rockholds",
    "value": "rockholds"
  },
  {
    "text": "Rockingham",
    "value": "rockingham"
  },
  {
    "text": "Rockland",
    "value": "rockland"
  },
  {
    "text": "Rockledge",
    "value": "rockledge"
  },
  {
    "text": "Rocklin",
    "value": "rocklin"
  },
  {
    "text": "Rockmart",
    "value": "rockmart"
  },
  {
    "text": "Rockport",
    "value": "rockport"
  },
  {
    "text": "Rocksprings",
    "value": "rocksprings"
  },
  {
    "text": "Rockton",
    "value": "rockton"
  },
  {
    "text": "Rockvale",
    "value": "rockvale"
  },
  {
    "text": "Rockville",
    "value": "rockville"
  },
  {
    "text": "Rockville Centre",
    "value": "rockville centre"
  },
  {
    "text": "Rockwall",
    "value": "rockwall"
  },
  {
    "text": "Rockwell",
    "value": "rockwell"
  },
  {
    "text": "Rockwell City",
    "value": "rockwell city"
  },
  {
    "text": "Rockwood",
    "value": "rockwood"
  },
  {
    "text": "Rocky",
    "value": "rocky"
  },
  {
    "text": "Rocky Face",
    "value": "rocky face"
  },
  {
    "text": "Rocky Ford",
    "value": "rocky ford"
  },
  {
    "text": "Rocky Gap",
    "value": "rocky gap"
  },
  {
    "text": "Rocky Hill",
    "value": "rocky hill"
  },
  {
    "text": "Rocky Mount",
    "value": "rocky mount"
  },
  {
    "text": "Rocky Point",
    "value": "rocky point"
  },
  {
    "text": "Rocky Ridge",
    "value": "rocky ridge"
  },
  {
    "text": "Rocky River",
    "value": "rocky river"
  },
  {
    "text": "Rocky Top",
    "value": "rocky top"
  },
  {
    "text": "Rodanthe",
    "value": "rodanthe"
  },
  {
    "text": "Rodeo",
    "value": "rodeo"
  },
  {
    "text": "Roderfield",
    "value": "roderfield"
  },
  {
    "text": "Rodessa",
    "value": "rodessa"
  },
  {
    "text": "Rodman",
    "value": "rodman"
  },
  {
    "text": "Rodney",
    "value": "rodney"
  },
  {
    "text": "Roduco",
    "value": "roduco"
  },
  {
    "text": "Roebling",
    "value": "roebling"
  },
  {
    "text": "Roebuck",
    "value": "roebuck"
  },
  {
    "text": "Roeland Park",
    "value": "roeland park"
  },
  {
    "text": "Roff",
    "value": "roff"
  },
  {
    "text": "Rogers",
    "value": "rogers"
  },
  {
    "text": "Rogers City",
    "value": "rogers city"
  },
  {
    "text": "Rogerson",
    "value": "rogerson"
  },
  {
    "text": "Rogersville",
    "value": "rogersville"
  },
  {
    "text": "Roggen",
    "value": "roggen"
  },
  {
    "text": "Rogue River",
    "value": "rogue river"
  },
  {
    "text": "Rohnert Park",
    "value": "rohnert park"
  },
  {
    "text": "Rohrersville",
    "value": "rohrersville"
  },
  {
    "text": "Roland",
    "value": "roland"
  },
  {
    "text": "Rolesville",
    "value": "rolesville"
  },
  {
    "text": "Rolette",
    "value": "rolette"
  },
  {
    "text": "Rolfe",
    "value": "rolfe"
  },
  {
    "text": "Roll",
    "value": "roll"
  },
  {
    "text": "Rolla",
    "value": "rolla"
  },
  {
    "text": "Rolling Fork",
    "value": "rolling fork"
  },
  {
    "text": "Rolling Hills",
    "value": "rolling hills"
  },
  {
    "text": "Rolling Hills Estates",
    "value": "rolling hills estates"
  },
  {
    "text": "Rolling Meadows",
    "value": "rolling meadows"
  },
  {
    "text": "Rolling Prairie",
    "value": "rolling prairie"
  },
  {
    "text": "Rollingbay",
    "value": "rollingbay"
  },
  {
    "text": "Rollingstone",
    "value": "rollingstone"
  },
  {
    "text": "Rollingwood",
    "value": "rollingwood"
  },
  {
    "text": "Rollins",
    "value": "rollins"
  },
  {
    "text": "Rollinsford",
    "value": "rollinsford"
  },
  {
    "text": "Rollinsville",
    "value": "rollinsville"
  },
  {
    "text": "Roma",
    "value": "roma"
  },
  {
    "text": "Roma-Los Saenz",
    "value": "roma-los saenz"
  },
  {
    "text": "Romance",
    "value": "romance"
  },
  {
    "text": "Romayor",
    "value": "romayor"
  },
  {
    "text": "Rome",
    "value": "rome"
  },
  {
    "text": "Rome City",
    "value": "rome city"
  },
  {
    "text": "Romeo",
    "value": "romeo"
  },
  {
    "text": "Romeoville",
    "value": "romeoville"
  },
  {
    "text": "Romney",
    "value": "romney"
  },
  {
    "text": "Romoland",
    "value": "romoland"
  },
  {
    "text": "Romulus",
    "value": "romulus"
  },
  {
    "text": "Ronald",
    "value": "ronald"
  },
  {
    "text": "Ronan",
    "value": "ronan"
  },
  {
    "text": "Ronceverte",
    "value": "ronceverte"
  },
  {
    "text": "Ronco",
    "value": "ronco"
  },
  {
    "text": "Ronda",
    "value": "ronda"
  },
  {
    "text": "Ronkonkoma",
    "value": "ronkonkoma"
  },
  {
    "text": "Ronks",
    "value": "ronks"
  },
  {
    "text": "Roodhouse",
    "value": "roodhouse"
  },
  {
    "text": "Roopville",
    "value": "roopville"
  },
  {
    "text": "Roosevelt",
    "value": "roosevelt"
  },
  {
    "text": "Roosevelt Park",
    "value": "roosevelt park"
  },
  {
    "text": "Rooseveltown",
    "value": "rooseveltown"
  },
  {
    "text": "Rootstown",
    "value": "rootstown"
  },
  {
    "text": "Roper",
    "value": "roper"
  },
  {
    "text": "Ropesville",
    "value": "ropesville"
  },
  {
    "text": "Rosalia",
    "value": "rosalia"
  },
  {
    "text": "Rosalie",
    "value": "rosalie"
  },
  {
    "text": "Rosamond",
    "value": "rosamond"
  },
  {
    "text": "Rosanky",
    "value": "rosanky"
  },
  {
    "text": "Rosburg",
    "value": "rosburg"
  },
  {
    "text": "Roscoe",
    "value": "roscoe"
  },
  {
    "text": "Roscommon",
    "value": "roscommon"
  },
  {
    "text": "Rose",
    "value": "rose"
  },
  {
    "text": "Rose Bud",
    "value": "rose bud"
  },
  {
    "text": "Rose City",
    "value": "rose city"
  },
  {
    "text": "Rose Creek",
    "value": "rose creek"
  },
  {
    "text": "Rose Hill",
    "value": "rose hill"
  },
  {
    "text": "Roseau",
    "value": "roseau"
  },
  {
    "text": "Roseboom",
    "value": "roseboom"
  },
  {
    "text": "Roseboro",
    "value": "roseboro"
  },
  {
    "text": "Rosebud",
    "value": "rosebud"
  },
  {
    "text": "Roseburg",
    "value": "roseburg"
  },
  {
    "text": "Rosebush",
    "value": "rosebush"
  },
  {
    "text": "Rosedale",
    "value": "rosedale"
  },
  {
    "text": "Roseglen",
    "value": "roseglen"
  },
  {
    "text": "Roseland",
    "value": "roseland"
  },
  {
    "text": "Roselle",
    "value": "roselle"
  },
  {
    "text": "Roselle Park",
    "value": "roselle park"
  },
  {
    "text": "Rosemary Beach",
    "value": "rosemary beach"
  },
  {
    "text": "Rosemead",
    "value": "rosemead"
  },
  {
    "text": "Rosemont",
    "value": "rosemont"
  },
  {
    "text": "Rosemount",
    "value": "rosemount"
  },
  {
    "text": "Rosenberg",
    "value": "rosenberg"
  },
  {
    "text": "Rosendale",
    "value": "rosendale"
  },
  {
    "text": "Rosenhayn",
    "value": "rosenhayn"
  },
  {
    "text": "Rosepine",
    "value": "rosepine"
  },
  {
    "text": "Roseville",
    "value": "roseville"
  },
  {
    "text": "Rosewood",
    "value": "rosewood"
  },
  {
    "text": "Rosewood Heights",
    "value": "rosewood heights"
  },
  {
    "text": "Rosharon",
    "value": "rosharon"
  },
  {
    "text": "Rosholt",
    "value": "rosholt"
  },
  {
    "text": "Rosiclare",
    "value": "rosiclare"
  },
  {
    "text": "Rosie",
    "value": "rosie"
  },
  {
    "text": "Rosita South",
    "value": "rosita south"
  },
  {
    "text": "Roslindale",
    "value": "roslindale"
  },
  {
    "text": "Roslyn",
    "value": "roslyn"
  },
  {
    "text": "Roslyn Estates",
    "value": "roslyn estates"
  },
  {
    "text": "Roslyn Heights",
    "value": "roslyn heights"
  },
  {
    "text": "Rosman",
    "value": "rosman"
  },
  {
    "text": "Ross",
    "value": "ross"
  },
  {
    "text": "Ross Township",
    "value": "ross township"
  },
  {
    "text": "Rossburg",
    "value": "rossburg"
  },
  {
    "text": "Rosser",
    "value": "rosser"
  },
  {
    "text": "Rossford",
    "value": "rossford"
  },
  {
    "text": "Rossiter",
    "value": "rossiter"
  },
  {
    "text": "Rossmoor",
    "value": "rossmoor"
  },
  {
    "text": "Rossmoyne",
    "value": "rossmoyne"
  },
  {
    "text": "Rosston",
    "value": "rosston"
  },
  {
    "text": "Rossville",
    "value": "rossville"
  },
  {
    "text": "Roswell",
    "value": "roswell"
  },
  {
    "text": "Rotan",
    "value": "rotan"
  },
  {
    "text": "Rothbury",
    "value": "rothbury"
  },
  {
    "text": "Rothsay",
    "value": "rothsay"
  },
  {
    "text": "Rothschild",
    "value": "rothschild"
  },
  {
    "text": "Rothville",
    "value": "rothville"
  },
  {
    "text": "Rotonda West",
    "value": "rotonda west"
  },
  {
    "text": "Rotterdam",
    "value": "rotterdam"
  },
  {
    "text": "Rotterdam Junction",
    "value": "rotterdam junction"
  },
  {
    "text": "Rougemont",
    "value": "rougemont"
  },
  {
    "text": "Rough and Ready",
    "value": "rough and ready"
  },
  {
    "text": "Rougon",
    "value": "rougon"
  },
  {
    "text": "Roulette",
    "value": "roulette"
  },
  {
    "text": "Round Hill",
    "value": "round hill"
  },
  {
    "text": "Round Lake",
    "value": "round lake"
  },
  {
    "text": "Round Lake Beach",
    "value": "round lake beach"
  },
  {
    "text": "Round Lake Heights",
    "value": "round lake heights"
  },
  {
    "text": "Round Lake Park",
    "value": "round lake park"
  },
  {
    "text": "Round Mountain",
    "value": "round mountain"
  },
  {
    "text": "Round O",
    "value": "round o"
  },
  {
    "text": "Round Pond",
    "value": "round pond"
  },
  {
    "text": "Round Rock",
    "value": "round rock"
  },
  {
    "text": "Round Top",
    "value": "round top"
  },
  {
    "text": "Roundhead",
    "value": "roundhead"
  },
  {
    "text": "Roundhill",
    "value": "roundhill"
  },
  {
    "text": "Roundup",
    "value": "roundup"
  },
  {
    "text": "Rouses Point",
    "value": "rouses point"
  },
  {
    "text": "Rouseville",
    "value": "rouseville"
  },
  {
    "text": "Rouzerville",
    "value": "rouzerville"
  },
  {
    "text": "Rowan",
    "value": "rowan"
  },
  {
    "text": "Rowayton",
    "value": "rowayton"
  },
  {
    "text": "Rowe",
    "value": "rowe"
  },
  {
    "text": "Rowena",
    "value": "rowena"
  },
  {
    "text": "Rowesville",
    "value": "rowesville"
  },
  {
    "text": "Rowland",
    "value": "rowland"
  },
  {
    "text": "Rowland Heights",
    "value": "rowland heights"
  },
  {
    "text": "Rowlesburg",
    "value": "rowlesburg"
  },
  {
    "text": "Rowlett",
    "value": "rowlett"
  },
  {
    "text": "Rowley",
    "value": "rowley"
  },
  {
    "text": "Roxana",
    "value": "roxana"
  },
  {
    "text": "Roxboro",
    "value": "roxboro"
  },
  {
    "text": "Roxbury",
    "value": "roxbury"
  },
  {
    "text": "Roxbury Crossing",
    "value": "roxbury crossing"
  },
  {
    "text": "Roxie",
    "value": "roxie"
  },
  {
    "text": "Roxobel",
    "value": "roxobel"
  },
  {
    "text": "Roxton",
    "value": "roxton"
  },
  {
    "text": "Roy",
    "value": "roy"
  },
  {
    "text": "Royal",
    "value": "royal"
  },
  {
    "text": "Royal Center",
    "value": "royal center"
  },
  {
    "text": "Royal City",
    "value": "royal city"
  },
  {
    "text": "Royal Kunia",
    "value": "royal kunia"
  },
  {
    "text": "Royal Oak",
    "value": "royal oak"
  },
  {
    "text": "Royal Palm Beach",
    "value": "royal palm beach"
  },
  {
    "text": "Royalston",
    "value": "royalston"
  },
  {
    "text": "Royalton",
    "value": "royalton"
  },
  {
    "text": "Royersford",
    "value": "royersford"
  },
  {
    "text": "Royse City",
    "value": "royse city"
  },
  {
    "text": "Royston",
    "value": "royston"
  },
  {
    "text": "Rozel",
    "value": "rozel"
  },
  {
    "text": "Rozet",
    "value": "rozet"
  },
  {
    "text": "Rubicon",
    "value": "rubicon"
  },
  {
    "text": "Ruby",
    "value": "ruby"
  },
  {
    "text": "Ruckersville",
    "value": "ruckersville"
  },
  {
    "text": "Rudd",
    "value": "rudd"
  },
  {
    "text": "Rudolph",
    "value": "rudolph"
  },
  {
    "text": "Rudy",
    "value": "rudy"
  },
  {
    "text": "Rudyard",
    "value": "rudyard"
  },
  {
    "text": "Ruffin",
    "value": "ruffin"
  },
  {
    "text": "Ruffs Dale",
    "value": "ruffs dale"
  },
  {
    "text": "Rufus",
    "value": "rufus"
  },
  {
    "text": "Rugby",
    "value": "rugby"
  },
  {
    "text": "Ruidoso",
    "value": "ruidoso"
  },
  {
    "text": "Ruidoso Downs",
    "value": "ruidoso downs"
  },
  {
    "text": "Rule",
    "value": "rule"
  },
  {
    "text": "Ruleville",
    "value": "ruleville"
  },
  {
    "text": "Rulo",
    "value": "rulo"
  },
  {
    "text": "Rumely",
    "value": "rumely"
  },
  {
    "text": "Rumford",
    "value": "rumford"
  },
  {
    "text": "Rumney",
    "value": "rumney"
  },
  {
    "text": "Rumsey",
    "value": "rumsey"
  },
  {
    "text": "Rumson",
    "value": "rumson"
  },
  {
    "text": "Runaway Bay",
    "value": "runaway bay"
  },
  {
    "text": "Runge",
    "value": "runge"
  },
  {
    "text": "Runnells",
    "value": "runnells"
  },
  {
    "text": "Runnemede",
    "value": "runnemede"
  },
  {
    "text": "Running Springs",
    "value": "running springs"
  },
  {
    "text": "Rupert",
    "value": "rupert"
  },
  {
    "text": "Rural Hall",
    "value": "rural hall"
  },
  {
    "text": "Rural Retreat",
    "value": "rural retreat"
  },
  {
    "text": "Rural Valley",
    "value": "rural valley"
  },
  {
    "text": "Rush",
    "value": "rush"
  },
  {
    "text": "Rush Center",
    "value": "rush center"
  },
  {
    "text": "Rush City",
    "value": "rush city"
  },
  {
    "text": "Rush Springs",
    "value": "rush springs"
  },
  {
    "text": "Rush Valley",
    "value": "rush valley"
  },
  {
    "text": "Rushford",
    "value": "rushford"
  },
  {
    "text": "Rushmore",
    "value": "rushmore"
  },
  {
    "text": "Rushsylvania",
    "value": "rushsylvania"
  },
  {
    "text": "Rushville",
    "value": "rushville"
  },
  {
    "text": "Rusk",
    "value": "rusk"
  },
  {
    "text": "Ruskin",
    "value": "ruskin"
  },
  {
    "text": "Ruso",
    "value": "ruso"
  },
  {
    "text": "Russell",
    "value": "russell"
  },
  {
    "text": "Russell Springs",
    "value": "russell springs"
  },
  {
    "text": "Russells Mills",
    "value": "russells mills"
  },
  {
    "text": "Russells Point",
    "value": "russells point"
  },
  {
    "text": "Russellton",
    "value": "russellton"
  },
  {
    "text": "Russellville",
    "value": "russellville"
  },
  {
    "text": "Russia",
    "value": "russia"
  },
  {
    "text": "Russiaville",
    "value": "russiaville"
  },
  {
    "text": "Rustburg",
    "value": "rustburg"
  },
  {
    "text": "Ruston",
    "value": "ruston"
  },
  {
    "text": "Ruth",
    "value": "ruth"
  },
  {
    "text": "Ruther Glen",
    "value": "ruther glen"
  },
  {
    "text": "Rutherford",
    "value": "rutherford"
  },
  {
    "text": "Rutherford College",
    "value": "rutherford college"
  },
  {
    "text": "Rutherfordton",
    "value": "rutherfordton"
  },
  {
    "text": "Ruthton",
    "value": "ruthton"
  },
  {
    "text": "Ruthven",
    "value": "ruthven"
  },
  {
    "text": "Ruthville",
    "value": "ruthville"
  },
  {
    "text": "Rutland",
    "value": "rutland"
  },
  {
    "text": "Rutledge",
    "value": "rutledge"
  },
  {
    "text": "Ryan",
    "value": "ryan"
  },
  {
    "text": "Rydal",
    "value": "rydal"
  },
  {
    "text": "Ryde",
    "value": "ryde"
  },
  {
    "text": "Ryder",
    "value": "ryder"
  },
  {
    "text": "Rye",
    "value": "rye"
  },
  {
    "text": "Rye Beach",
    "value": "rye beach"
  },
  {
    "text": "Rye Brook",
    "value": "rye brook"
  },
  {
    "text": "Ryegate",
    "value": "ryegate"
  },
  {
    "text": "Sabael",
    "value": "sabael"
  },
  {
    "text": "Sabattus",
    "value": "sabattus"
  },
  {
    "text": "Sabetha",
    "value": "sabetha"
  },
  {
    "text": "Sabillasville",
    "value": "sabillasville"
  },
  {
    "text": "Sabin",
    "value": "sabin"
  },
  {
    "text": "Sabina",
    "value": "sabina"
  },
  {
    "text": "Sabinal",
    "value": "sabinal"
  },
  {
    "text": "Sabine Pass",
    "value": "sabine pass"
  },
  {
    "text": "Sabinsville",
    "value": "sabinsville"
  },
  {
    "text": "Sabula",
    "value": "sabula"
  },
  {
    "text": "Sac City",
    "value": "sac city"
  },
  {
    "text": "Sacaton",
    "value": "sacaton"
  },
  {
    "text": "Sachse",
    "value": "sachse"
  },
  {
    "text": "Sackets Harbor",
    "value": "sackets harbor"
  },
  {
    "text": "Saco",
    "value": "saco"
  },
  {
    "text": "Sacramento",
    "value": "sacramento"
  },
  {
    "text": "Sacred Heart",
    "value": "sacred heart"
  },
  {
    "text": "Sacul",
    "value": "sacul"
  },
  {
    "text": "Saddle Brook",
    "value": "saddle brook"
  },
  {
    "text": "Saddle River",
    "value": "saddle river"
  },
  {
    "text": "Saddlebrooke",
    "value": "saddlebrooke"
  },
  {
    "text": "Sadieville",
    "value": "sadieville"
  },
  {
    "text": "Sadler",
    "value": "sadler"
  },
  {
    "text": "Sadorus",
    "value": "sadorus"
  },
  {
    "text": "Saegertown",
    "value": "saegertown"
  },
  {
    "text": "Safety Harbor",
    "value": "safety harbor"
  },
  {
    "text": "Saffell",
    "value": "saffell"
  },
  {
    "text": "Safford",
    "value": "safford"
  },
  {
    "text": "Sag Harbor",
    "value": "sag harbor"
  },
  {
    "text": "Sagamore",
    "value": "sagamore"
  },
  {
    "text": "Sagamore Beach",
    "value": "sagamore beach"
  },
  {
    "text": "Sagaponack",
    "value": "sagaponack"
  },
  {
    "text": "Saginaw",
    "value": "saginaw"
  },
  {
    "text": "Sagle",
    "value": "sagle"
  },
  {
    "text": "Sagola",
    "value": "sagola"
  },
  {
    "text": "Saguache",
    "value": "saguache"
  },
  {
    "text": "Sahuarita",
    "value": "sahuarita"
  },
  {
    "text": "Saint Agatha",
    "value": "saint agatha"
  },
  {
    "text": "Saint Albans",
    "value": "saint albans"
  },
  {
    "text": "Saint Albans Bay",
    "value": "saint albans bay"
  },
  {
    "text": "Saint Amant",
    "value": "saint amant"
  },
  {
    "text": "Saint Ann",
    "value": "saint ann"
  },
  {
    "text": "Saint Anne",
    "value": "saint anne"
  },
  {
    "text": "Saint Ansgar",
    "value": "saint ansgar"
  },
  {
    "text": "Saint Anthony",
    "value": "saint anthony"
  },
  {
    "text": "Saint Augusta",
    "value": "saint augusta"
  },
  {
    "text": "Saint Augustine",
    "value": "saint augustine"
  },
  {
    "text": "Saint Augustine Beach",
    "value": "saint augustine beach"
  },
  {
    "text": "Saint Benedict",
    "value": "saint benedict"
  },
  {
    "text": "Saint Bernard",
    "value": "saint bernard"
  },
  {
    "text": "Saint Bernice",
    "value": "saint bernice"
  },
  {
    "text": "Saint Bonaventure",
    "value": "saint bonaventure"
  },
  {
    "text": "Saint Bonifacius",
    "value": "saint bonifacius"
  },
  {
    "text": "Saint Catharine",
    "value": "saint catharine"
  },
  {
    "text": "Saint Charles",
    "value": "saint charles"
  },
  {
    "text": "Saint Clair",
    "value": "saint clair"
  },
  {
    "text": "Saint Clair Shores",
    "value": "saint clair shores"
  },
  {
    "text": "Saint Clairsville",
    "value": "saint clairsville"
  },
  {
    "text": "Saint Cloud",
    "value": "saint cloud"
  },
  {
    "text": "Saint Croix",
    "value": "saint croix"
  },
  {
    "text": "Saint Croix Falls",
    "value": "saint croix falls"
  },
  {
    "text": "Saint David",
    "value": "saint david"
  },
  {
    "text": "Saint Edward",
    "value": "saint edward"
  },
  {
    "text": "Saint Elizabeth",
    "value": "saint elizabeth"
  },
  {
    "text": "Saint Elmo",
    "value": "saint elmo"
  },
  {
    "text": "Saint Francis",
    "value": "saint francis"
  },
  {
    "text": "Saint Francisville",
    "value": "saint francisville"
  },
  {
    "text": "Saint Gabriel",
    "value": "saint gabriel"
  },
  {
    "text": "Saint George",
    "value": "saint george"
  },
  {
    "text": "Saint Georges",
    "value": "saint georges"
  },
  {
    "text": "Saint Germain",
    "value": "saint germain"
  },
  {
    "text": "Saint Hedwig",
    "value": "saint hedwig"
  },
  {
    "text": "Saint Helen",
    "value": "saint helen"
  },
  {
    "text": "Saint Helena",
    "value": "saint helena"
  },
  {
    "text": "Saint Helena Island",
    "value": "saint helena island"
  },
  {
    "text": "Saint Helens",
    "value": "saint helens"
  },
  {
    "text": "Saint Henry",
    "value": "saint henry"
  },
  {
    "text": "Saint Hilaire",
    "value": "saint hilaire"
  },
  {
    "text": "Saint Ignace",
    "value": "saint ignace"
  },
  {
    "text": "Saint Ignatius",
    "value": "saint ignatius"
  },
  {
    "text": "Saint Inigoes Shores",
    "value": "saint inigoes shores"
  },
  {
    "text": "Saint Jacob",
    "value": "saint jacob"
  },
  {
    "text": "Saint James",
    "value": "saint james"
  },
  {
    "text": "Saint James City",
    "value": "saint james city"
  },
  {
    "text": "Saint Jo",
    "value": "saint jo"
  },
  {
    "text": "Saint Joe",
    "value": "saint joe"
  },
  {
    "text": "Saint John",
    "value": "saint john"
  },
  {
    "text": "Saint Johns",
    "value": "saint johns"
  },
  {
    "text": "Saint Johnsbury",
    "value": "saint johnsbury"
  },
  {
    "text": "Saint Johnsville",
    "value": "saint johnsville"
  },
  {
    "text": "Saint Joseph",
    "value": "saint joseph"
  },
  {
    "text": "Saint Landry",
    "value": "saint landry"
  },
  {
    "text": "Saint Lawrence",
    "value": "saint lawrence"
  },
  {
    "text": "Saint Leo",
    "value": "saint leo"
  },
  {
    "text": "Saint Leonard",
    "value": "saint leonard"
  },
  {
    "text": "Saint Libory",
    "value": "saint libory"
  },
  {
    "text": "Saint Louis",
    "value": "saint louis"
  },
  {
    "text": "Saint Louis Park",
    "value": "saint louis park"
  },
  {
    "text": "Saint Louisville",
    "value": "saint louisville"
  },
  {
    "text": "Saint Marie",
    "value": "saint marie"
  },
  {
    "text": "Saint Maries",
    "value": "saint maries"
  },
  {
    "text": "Saint Martin",
    "value": "saint martin"
  },
  {
    "text": "Saint Martins",
    "value": "saint martins"
  },
  {
    "text": "Saint Martinville",
    "value": "saint martinville"
  },
  {
    "text": "Saint Mary",
    "value": "saint mary"
  },
  {
    "text": "Saint Mary-of-the-Woods",
    "value": "saint mary-of-the-woods"
  },
  {
    "text": "Saint Marys",
    "value": "saint marys"
  },
  {
    "text": "Saint Marys City",
    "value": "saint marys city"
  },
  {
    "text": "Saint Matthews",
    "value": "saint matthews"
  },
  {
    "text": "Saint Meinrad",
    "value": "saint meinrad"
  },
  {
    "text": "Saint Michael",
    "value": "saint michael"
  },
  {
    "text": "Saint Michaels",
    "value": "saint michaels"
  },
  {
    "text": "Saint Nazianz",
    "value": "saint nazianz"
  },
  {
    "text": "Saint Olaf",
    "value": "saint olaf"
  },
  {
    "text": "Saint Onge",
    "value": "saint onge"
  },
  {
    "text": "Saint Paris",
    "value": "saint paris"
  },
  {
    "text": "Saint Patrick",
    "value": "saint patrick"
  },
  {
    "text": "Saint Paul",
    "value": "saint paul"
  },
  {
    "text": "Saint Paul Park",
    "value": "saint paul park"
  },
  {
    "text": "Saint Pauls",
    "value": "saint pauls"
  },
  {
    "text": "Saint Pete Beach",
    "value": "saint pete beach"
  },
  {
    "text": "Saint Peter",
    "value": "saint peter"
  },
  {
    "text": "Saint Peters",
    "value": "saint peters"
  },
  {
    "text": "Saint Petersburg",
    "value": "saint petersburg"
  },
  {
    "text": "Saint Regis",
    "value": "saint regis"
  },
  {
    "text": "Saint Regis Falls",
    "value": "saint regis falls"
  },
  {
    "text": "Saint Robert",
    "value": "saint robert"
  },
  {
    "text": "Saint Rose",
    "value": "saint rose"
  },
  {
    "text": "Saint Simon Mills",
    "value": "saint simon mills"
  },
  {
    "text": "Saint Simons",
    "value": "saint simons"
  },
  {
    "text": "Saint Simons Island",
    "value": "saint simons island"
  },
  {
    "text": "Saint Stephen",
    "value": "saint stephen"
  },
  {
    "text": "Saint Stephens",
    "value": "saint stephens"
  },
  {
    "text": "Saint Stephens Church",
    "value": "saint stephens church"
  },
  {
    "text": "Saint Stephens Church District",
    "value": "saint stephens church district"
  },
  {
    "text": "Saint Thomas",
    "value": "saint thomas"
  },
  {
    "text": "Saint Vincent",
    "value": "saint vincent"
  },
  {
    "text": "Saint Xavier",
    "value": "saint xavier"
  },
  {
    "text": "Sainte Genevieve",
    "value": "sainte genevieve"
  },
  {
    "text": "Salado",
    "value": "salado"
  },
  {
    "text": "Salamanca",
    "value": "salamanca"
  },
  {
    "text": "Salamonia",
    "value": "salamonia"
  },
  {
    "text": "Salcha",
    "value": "salcha"
  },
  {
    "text": "Sale City",
    "value": "sale city"
  },
  {
    "text": "Sale Creek",
    "value": "sale creek"
  },
  {
    "text": "Salem",
    "value": "salem"
  },
  {
    "text": "Salem Heights",
    "value": "salem heights"
  },
  {
    "text": "Salemburg",
    "value": "salemburg"
  },
  {
    "text": "Salesville",
    "value": "salesville"
  },
  {
    "text": "Salford",
    "value": "salford"
  },
  {
    "text": "Salida",
    "value": "salida"
  },
  {
    "text": "Salina",
    "value": "salina"
  },
  {
    "text": "Salinas",
    "value": "salinas"
  },
  {
    "text": "Saline",
    "value": "saline"
  },
  {
    "text": "Salineville",
    "value": "salineville"
  },
  {
    "text": "Salisbury",
    "value": "salisbury"
  },
  {
    "text": "Salisbury Center",
    "value": "salisbury center"
  },
  {
    "text": "Salisbury Mills",
    "value": "salisbury mills"
  },
  {
    "text": "Salix",
    "value": "salix"
  },
  {
    "text": "Salkum",
    "value": "salkum"
  },
  {
    "text": "Salley",
    "value": "salley"
  },
  {
    "text": "Sallis",
    "value": "sallis"
  },
  {
    "text": "Sallisaw",
    "value": "sallisaw"
  },
  {
    "text": "Salmon",
    "value": "salmon"
  },
  {
    "text": "Salol",
    "value": "salol"
  },
  {
    "text": "Salome",
    "value": "salome"
  },
  {
    "text": "Salt Flat",
    "value": "salt flat"
  },
  {
    "text": "Salt Lake",
    "value": "salt lake"
  },
  {
    "text": "Salt Lake City",
    "value": "salt lake city"
  },
  {
    "text": "Salt Lick",
    "value": "salt lick"
  },
  {
    "text": "Salt Point",
    "value": "salt point"
  },
  {
    "text": "Salt Rock",
    "value": "salt rock"
  },
  {
    "text": "Salters",
    "value": "salters"
  },
  {
    "text": "Saltillo",
    "value": "saltillo"
  },
  {
    "text": "Salton City",
    "value": "salton city"
  },
  {
    "text": "Saltsburg",
    "value": "saltsburg"
  },
  {
    "text": "Saltville",
    "value": "saltville"
  },
  {
    "text": "Saluda",
    "value": "saluda"
  },
  {
    "text": "Salunga",
    "value": "salunga"
  },
  {
    "text": "Salvisa",
    "value": "salvisa"
  },
  {
    "text": "Salyer",
    "value": "salyer"
  },
  {
    "text": "Salyersville",
    "value": "salyersville"
  },
  {
    "text": "Samaria",
    "value": "samaria"
  },
  {
    "text": "Samburg",
    "value": "samburg"
  },
  {
    "text": "Sammamish",
    "value": "sammamish"
  },
  {
    "text": "Samoa",
    "value": "samoa"
  },
  {
    "text": "Samson",
    "value": "samson"
  },
  {
    "text": "San Acacia",
    "value": "san acacia"
  },
  {
    "text": "San Andreas",
    "value": "san andreas"
  },
  {
    "text": "San Angelo",
    "value": "san angelo"
  },
  {
    "text": "San Anselmo",
    "value": "san anselmo"
  },
  {
    "text": "San Antonio",
    "value": "san antonio"
  },
  {
    "text": "San Ardo",
    "value": "san ardo"
  },
  {
    "text": "San Augustine",
    "value": "san augustine"
  },
  {
    "text": "San Benito",
    "value": "san benito"
  },
  {
    "text": "San Bernardino",
    "value": "san bernardino"
  },
  {
    "text": "San Bruno",
    "value": "san bruno"
  },
  {
    "text": "San Carlos",
    "value": "san carlos"
  },
  {
    "text": "San Clemente",
    "value": "san clemente"
  },
  {
    "text": "San Cristobal",
    "value": "san cristobal"
  },
  {
    "text": "San Diego",
    "value": "san diego"
  },
  {
    "text": "San Dimas",
    "value": "san dimas"
  },
  {
    "text": "San Elizario",
    "value": "san elizario"
  },
  {
    "text": "San Felipe",
    "value": "san felipe"
  },
  {
    "text": "San Felipe Pueblo",
    "value": "san felipe pueblo"
  },
  {
    "text": "San Felipe de Austin",
    "value": "san felipe de austin"
  },
  {
    "text": "San Fernando",
    "value": "san fernando"
  },
  {
    "text": "San Fidel",
    "value": "san fidel"
  },
  {
    "text": "San Francisco",
    "value": "san francisco"
  },
  {
    "text": "San Francisco De Las Llagas",
    "value": "san francisco de las llagas"
  },
  {
    "text": "San Francisco Naval Communication Station - Stockton",
    "value": "san francisco naval communication station - stockton"
  },
  {
    "text": "San Gabriel",
    "value": "san gabriel"
  },
  {
    "text": "San Geronimo",
    "value": "san geronimo"
  },
  {
    "text": "San Gregorio",
    "value": "san gregorio"
  },
  {
    "text": "San Isidro",
    "value": "san isidro"
  },
  {
    "text": "San Jacinto",
    "value": "san jacinto"
  },
  {
    "text": "San Joaquin",
    "value": "san joaquin"
  },
  {
    "text": "San Jon",
    "value": "san jon"
  },
  {
    "text": "San Jose",
    "value": "san jose"
  },
  {
    "text": "San Juan",
    "value": "san juan"
  },
  {
    "text": "San Juan Bautista",
    "value": "san juan bautista"
  },
  {
    "text": "San Juan Capistrano",
    "value": "san juan capistrano"
  },
  {
    "text": "San Leandro",
    "value": "san leandro"
  },
  {
    "text": "San Lorenzo",
    "value": "san lorenzo"
  },
  {
    "text": "San Luis",
    "value": "san luis"
  },
  {
    "text": "San Luis Obispo",
    "value": "san luis obispo"
  },
  {
    "text": "San Luis Rey",
    "value": "san luis rey"
  },
  {
    "text": "San Manuel",
    "value": "san manuel"
  },
  {
    "text": "San Marcos",
    "value": "san marcos"
  },
  {
    "text": "San Marino",
    "value": "san marino"
  },
  {
    "text": "San Martin",
    "value": "san martin"
  },
  {
    "text": "San Mateo",
    "value": "san mateo"
  },
  {
    "text": "San Miguel",
    "value": "san miguel"
  },
  {
    "text": "San Pablo",
    "value": "san pablo"
  },
  {
    "text": "San Patricio",
    "value": "san patricio"
  },
  {
    "text": "San Pedro",
    "value": "san pedro"
  },
  {
    "text": "San Perlita",
    "value": "san perlita"
  },
  {
    "text": "San Pierre",
    "value": "san pierre"
  },
  {
    "text": "San Quentin",
    "value": "san quentin"
  },
  {
    "text": "San Rafael",
    "value": "san rafael"
  },
  {
    "text": "San Ramon",
    "value": "san ramon"
  },
  {
    "text": "San Saba",
    "value": "san saba"
  },
  {
    "text": "San Simeon",
    "value": "san simeon"
  },
  {
    "text": "San Simon",
    "value": "san simon"
  },
  {
    "text": "San Tan Valley",
    "value": "san tan valley"
  },
  {
    "text": "San Ygnacio",
    "value": "san ygnacio"
  },
  {
    "text": "San Ysidro",
    "value": "san ysidro"
  },
  {
    "text": "Sanatoga",
    "value": "sanatoga"
  },
  {
    "text": "Sanborn",
    "value": "sanborn"
  },
  {
    "text": "Sanbornton",
    "value": "sanbornton"
  },
  {
    "text": "Sanbornville",
    "value": "sanbornville"
  },
  {
    "text": "Sand Coulee",
    "value": "sand coulee"
  },
  {
    "text": "Sand Creek",
    "value": "sand creek"
  },
  {
    "text": "Sand Fork",
    "value": "sand fork"
  },
  {
    "text": "Sand Lake",
    "value": "sand lake"
  },
  {
    "text": "Sand Point",
    "value": "sand point"
  },
  {
    "text": "Sand Springs",
    "value": "sand springs"
  },
  {
    "text": "Sandalfoot Cove",
    "value": "sandalfoot cove"
  },
  {
    "text": "Sandborn",
    "value": "sandborn"
  },
  {
    "text": "Sanders",
    "value": "sanders"
  },
  {
    "text": "Sanderson",
    "value": "sanderson"
  },
  {
    "text": "Sandersville",
    "value": "sandersville"
  },
  {
    "text": "Sandia",
    "value": "sandia"
  },
  {
    "text": "Sandia Knolls",
    "value": "sandia knolls"
  },
  {
    "text": "Sandia Park",
    "value": "sandia park"
  },
  {
    "text": "Sandisfield",
    "value": "sandisfield"
  },
  {
    "text": "Sandoval",
    "value": "sandoval"
  },
  {
    "text": "Sandown",
    "value": "sandown"
  },
  {
    "text": "Sandpoint",
    "value": "sandpoint"
  },
  {
    "text": "Sands Point",
    "value": "sands point"
  },
  {
    "text": "Sandston",
    "value": "sandston"
  },
  {
    "text": "Sandstone",
    "value": "sandstone"
  },
  {
    "text": "Sandtown",
    "value": "sandtown"
  },
  {
    "text": "Sandusky",
    "value": "sandusky"
  },
  {
    "text": "Sandwich",
    "value": "sandwich"
  },
  {
    "text": "Sandy",
    "value": "sandy"
  },
  {
    "text": "Sandy Creek",
    "value": "sandy creek"
  },
  {
    "text": "Sandy Hook",
    "value": "sandy hook"
  },
  {
    "text": "Sandy Lake",
    "value": "sandy lake"
  },
  {
    "text": "Sandy Level",
    "value": "sandy level"
  },
  {
    "text": "Sandy Ridge",
    "value": "sandy ridge"
  },
  {
    "text": "Sandy Spring",
    "value": "sandy spring"
  },
  {
    "text": "Sandy Springs",
    "value": "sandy springs"
  },
  {
    "text": "Sandy Valley",
    "value": "sandy valley"
  },
  {
    "text": "Sandyville",
    "value": "sandyville"
  },
  {
    "text": "Sanford",
    "value": "sanford"
  },
  {
    "text": "Sanger",
    "value": "sanger"
  },
  {
    "text": "Sangerfield",
    "value": "sangerfield"
  },
  {
    "text": "Sangerville",
    "value": "sangerville"
  },
  {
    "text": "Sanibel",
    "value": "sanibel"
  },
  {
    "text": "Sanilac",
    "value": "sanilac"
  },
  {
    "text": "Sansom Park",
    "value": "sansom park"
  },
  {
    "text": "Santa",
    "value": "santa"
  },
  {
    "text": "Santa Ana",
    "value": "santa ana"
  },
  {
    "text": "Santa Ana Heights",
    "value": "santa ana heights"
  },
  {
    "text": "Santa Anna",
    "value": "santa anna"
  },
  {
    "text": "Santa Barbara",
    "value": "santa barbara"
  },
  {
    "text": "Santa Clara",
    "value": "santa clara"
  },
  {
    "text": "Santa Clarita",
    "value": "santa clarita"
  },
  {
    "text": "Santa Claus",
    "value": "santa claus"
  },
  {
    "text": "Santa Cruz",
    "value": "santa cruz"
  },
  {
    "text": "Santa Elena",
    "value": "santa elena"
  },
  {
    "text": "Santa Fe",
    "value": "santa fe"
  },
  {
    "text": "Santa Fe Springs",
    "value": "santa fe springs"
  },
  {
    "text": "Santa Margarita",
    "value": "santa margarita"
  },
  {
    "text": "Santa Maria",
    "value": "santa maria"
  },
  {
    "text": "Santa Monica",
    "value": "santa monica"
  },
  {
    "text": "Santa Nella",
    "value": "santa nella"
  },
  {
    "text": "Santa Nella Village",
    "value": "santa nella village"
  },
  {
    "text": "Santa Paula",
    "value": "santa paula"
  },
  {
    "text": "Santa Rosa",
    "value": "santa rosa"
  },
  {
    "text": "Santa Rosa Beach",
    "value": "santa rosa beach"
  },
  {
    "text": "Santa Teresa",
    "value": "santa teresa"
  },
  {
    "text": "Santa Venetia",
    "value": "santa venetia"
  },
  {
    "text": "Santa Ynez",
    "value": "santa ynez"
  },
  {
    "text": "Santa Ysabel",
    "value": "santa ysabel"
  },
  {
    "text": "Santaquin",
    "value": "santaquin"
  },
  {
    "text": "Santee",
    "value": "santee"
  },
  {
    "text": "Santo",
    "value": "santo"
  },
  {
    "text": "Santo Domingo Pueblo",
    "value": "santo domingo pueblo"
  },
  {
    "text": "Sapello",
    "value": "sapello"
  },
  {
    "text": "Sapphire",
    "value": "sapphire"
  },
  {
    "text": "Sappington",
    "value": "sappington"
  },
  {
    "text": "Sapulpa",
    "value": "sapulpa"
  },
  {
    "text": "Saragosa",
    "value": "saragosa"
  },
  {
    "text": "Sarah",
    "value": "sarah"
  },
  {
    "text": "Sarahsville",
    "value": "sarahsville"
  },
  {
    "text": "Saraland",
    "value": "saraland"
  },
  {
    "text": "Saranac",
    "value": "saranac"
  },
  {
    "text": "Saranac Lake",
    "value": "saranac lake"
  },
  {
    "text": "Sarasota",
    "value": "sarasota"
  },
  {
    "text": "Saratoga",
    "value": "saratoga"
  },
  {
    "text": "Saratoga Springs",
    "value": "saratoga springs"
  },
  {
    "text": "Sarcoxie",
    "value": "sarcoxie"
  },
  {
    "text": "Sardinia",
    "value": "sardinia"
  },
  {
    "text": "Sardis",
    "value": "sardis"
  },
  {
    "text": "Sardis City",
    "value": "sardis city"
  },
  {
    "text": "Sarepta",
    "value": "sarepta"
  },
  {
    "text": "Sargent",
    "value": "sargent"
  },
  {
    "text": "Sargents",
    "value": "sargents"
  },
  {
    "text": "Sargentville",
    "value": "sargentville"
  },
  {
    "text": "Sarita",
    "value": "sarita"
  },
  {
    "text": "Sarles",
    "value": "sarles"
  },
  {
    "text": "Sarona",
    "value": "sarona"
  },
  {
    "text": "Saronville",
    "value": "saronville"
  },
  {
    "text": "Sartell",
    "value": "sartell"
  },
  {
    "text": "Sarver",
    "value": "sarver"
  },
  {
    "text": "Sasabe",
    "value": "sasabe"
  },
  {
    "text": "Sasakwa",
    "value": "sasakwa"
  },
  {
    "text": "Sassafras",
    "value": "sassafras"
  },
  {
    "text": "Sassamansville",
    "value": "sassamansville"
  },
  {
    "text": "Sasser",
    "value": "sasser"
  },
  {
    "text": "Satanta",
    "value": "satanta"
  },
  {
    "text": "Satellite Beach",
    "value": "satellite beach"
  },
  {
    "text": "Saticoy",
    "value": "saticoy"
  },
  {
    "text": "Satsop",
    "value": "satsop"
  },
  {
    "text": "Satsuma",
    "value": "satsuma"
  },
  {
    "text": "Saucier",
    "value": "saucier"
  },
  {
    "text": "Saugatuck",
    "value": "saugatuck"
  },
  {
    "text": "Saugerties",
    "value": "saugerties"
  },
  {
    "text": "Saugus",
    "value": "saugus"
  },
  {
    "text": "Sauk Centre",
    "value": "sauk centre"
  },
  {
    "text": "Sauk City",
    "value": "sauk city"
  },
  {
    "text": "Sauk Rapids",
    "value": "sauk rapids"
  },
  {
    "text": "Sauk Village",
    "value": "sauk village"
  },
  {
    "text": "Saukville",
    "value": "saukville"
  },
  {
    "text": "Saul",
    "value": "saul"
  },
  {
    "text": "Saulsbury",
    "value": "saulsbury"
  },
  {
    "text": "Saulsville",
    "value": "saulsville"
  },
  {
    "text": "Sault Ste. Marie",
    "value": "sault ste. marie"
  },
  {
    "text": "Saunderstown",
    "value": "saunderstown"
  },
  {
    "text": "Saunemin",
    "value": "saunemin"
  },
  {
    "text": "Sauquoit",
    "value": "sauquoit"
  },
  {
    "text": "Sausalito",
    "value": "sausalito"
  },
  {
    "text": "Sautee",
    "value": "sautee"
  },
  {
    "text": "Sautee Nacoochee",
    "value": "sautee nacoochee"
  },
  {
    "text": "Savage",
    "value": "savage"
  },
  {
    "text": "Savanna",
    "value": "savanna"
  },
  {
    "text": "Savannah",
    "value": "savannah"
  },
  {
    "text": "Savery",
    "value": "savery"
  },
  {
    "text": "Savona",
    "value": "savona"
  },
  {
    "text": "Savonburg",
    "value": "savonburg"
  },
  {
    "text": "Savoy",
    "value": "savoy"
  },
  {
    "text": "Saw Creek",
    "value": "saw creek"
  },
  {
    "text": "Sawyer",
    "value": "sawyer"
  },
  {
    "text": "Sawyerville",
    "value": "sawyerville"
  },
  {
    "text": "Saxapahaw",
    "value": "saxapahaw"
  },
  {
    "text": "Saxe",
    "value": "saxe"
  },
  {
    "text": "Saxis",
    "value": "saxis"
  },
  {
    "text": "Saxon",
    "value": "saxon"
  },
  {
    "text": "Saxonburg",
    "value": "saxonburg"
  },
  {
    "text": "Saxton",
    "value": "saxton"
  },
  {
    "text": "Saxtons River",
    "value": "saxtons river"
  },
  {
    "text": "Saybrook",
    "value": "saybrook"
  },
  {
    "text": "Saylorsburg",
    "value": "saylorsburg"
  },
  {
    "text": "Sayner",
    "value": "sayner"
  },
  {
    "text": "Sayre",
    "value": "sayre"
  },
  {
    "text": "Sayreville",
    "value": "sayreville"
  },
  {
    "text": "Sayville",
    "value": "sayville"
  },
  {
    "text": "Scales Mound",
    "value": "scales mound"
  },
  {
    "text": "Scaly Mountain",
    "value": "scaly mountain"
  },
  {
    "text": "Scammon",
    "value": "scammon"
  },
  {
    "text": "Scammon Bay",
    "value": "scammon bay"
  },
  {
    "text": "Scandia",
    "value": "scandia"
  },
  {
    "text": "Scandinavia",
    "value": "scandinavia"
  },
  {
    "text": "Scappoose",
    "value": "scappoose"
  },
  {
    "text": "Scarborough",
    "value": "scarborough"
  },
  {
    "text": "Scarbro",
    "value": "scarbro"
  },
  {
    "text": "Scarsdale",
    "value": "scarsdale"
  },
  {
    "text": "Scarville",
    "value": "scarville"
  },
  {
    "text": "Scenery Hill",
    "value": "scenery hill"
  },
  {
    "text": "Scenic",
    "value": "scenic"
  },
  {
    "text": "Scenic Oaks",
    "value": "scenic oaks"
  },
  {
    "text": "Schaefferstown",
    "value": "schaefferstown"
  },
  {
    "text": "Schaghticoke",
    "value": "schaghticoke"
  },
  {
    "text": "Schaller",
    "value": "schaller"
  },
  {
    "text": "Schaumburg",
    "value": "schaumburg"
  },
  {
    "text": "Schell City",
    "value": "schell city"
  },
  {
    "text": "Scheller",
    "value": "scheller"
  },
  {
    "text": "Schellsburg",
    "value": "schellsburg"
  },
  {
    "text": "Schenectady",
    "value": "schenectady"
  },
  {
    "text": "Schenevus",
    "value": "schenevus"
  },
  {
    "text": "Schererville",
    "value": "schererville"
  },
  {
    "text": "Schertz",
    "value": "schertz"
  },
  {
    "text": "Schiller Park",
    "value": "schiller park"
  },
  {
    "text": "Schlater",
    "value": "schlater"
  },
  {
    "text": "Schleswig",
    "value": "schleswig"
  },
  {
    "text": "Schlusser",
    "value": "schlusser"
  },
  {
    "text": "Schnecksville",
    "value": "schnecksville"
  },
  {
    "text": "Schneider",
    "value": "schneider"
  },
  {
    "text": "Schodack Landing",
    "value": "schodack landing"
  },
  {
    "text": "Schofield",
    "value": "schofield"
  },
  {
    "text": "Schofield Barracks",
    "value": "schofield barracks"
  },
  {
    "text": "Schoharie",
    "value": "schoharie"
  },
  {
    "text": "Schoolcraft",
    "value": "schoolcraft"
  },
  {
    "text": "Schriever",
    "value": "schriever"
  },
  {
    "text": "Schroeder",
    "value": "schroeder"
  },
  {
    "text": "Schroon Lake",
    "value": "schroon lake"
  },
  {
    "text": "Schulenburg",
    "value": "schulenburg"
  },
  {
    "text": "Schulter",
    "value": "schulter"
  },
  {
    "text": "Schurz",
    "value": "schurz"
  },
  {
    "text": "Schuyler",
    "value": "schuyler"
  },
  {
    "text": "Schuyler Falls",
    "value": "schuyler falls"
  },
  {
    "text": "Schuylerville",
    "value": "schuylerville"
  },
  {
    "text": "Schuylkill Haven",
    "value": "schuylkill haven"
  },
  {
    "text": "Schwenksville",
    "value": "schwenksville"
  },
  {
    "text": "Science Hill",
    "value": "science hill"
  },
  {
    "text": "Scio",
    "value": "scio"
  },
  {
    "text": "Sciota",
    "value": "sciota"
  },
  {
    "text": "Scipio",
    "value": "scipio"
  },
  {
    "text": "Scipio Center",
    "value": "scipio center"
  },
  {
    "text": "Scituate",
    "value": "scituate"
  },
  {
    "text": "Scobey",
    "value": "scobey"
  },
  {
    "text": "Scooba",
    "value": "scooba"
  },
  {
    "text": "Scotch Plains",
    "value": "scotch plains"
  },
  {
    "text": "Scotchtown",
    "value": "scotchtown"
  },
  {
    "text": "Scotia",
    "value": "scotia"
  },
  {
    "text": "Scotland",
    "value": "scotland"
  },
  {
    "text": "Scotland Neck",
    "value": "scotland neck"
  },
  {
    "text": "Scotrun",
    "value": "scotrun"
  },
  {
    "text": "Scott",
    "value": "scott"
  },
  {
    "text": "Scott Air Force Base",
    "value": "scott air force base"
  },
  {
    "text": "Scott City",
    "value": "scott city"
  },
  {
    "text": "Scott Depot",
    "value": "scott depot"
  },
  {
    "text": "Scott Lake",
    "value": "scott lake"
  },
  {
    "text": "Scottdale",
    "value": "scottdale"
  },
  {
    "text": "Scottown",
    "value": "scottown"
  },
  {
    "text": "Scotts",
    "value": "scotts"
  },
  {
    "text": "Scotts Hill",
    "value": "scotts hill"
  },
  {
    "text": "Scotts Mills",
    "value": "scotts mills"
  },
  {
    "text": "Scotts Valley",
    "value": "scotts valley"
  },
  {
    "text": "Scottsbluff",
    "value": "scottsbluff"
  },
  {
    "text": "Scottsboro",
    "value": "scottsboro"
  },
  {
    "text": "Scottsburg",
    "value": "scottsburg"
  },
  {
    "text": "Scottsdale",
    "value": "scottsdale"
  },
  {
    "text": "Scottsville",
    "value": "scottsville"
  },
  {
    "text": "Scottville",
    "value": "scottville"
  },
  {
    "text": "Scranton",
    "value": "scranton"
  },
  {
    "text": "Screven",
    "value": "screven"
  },
  {
    "text": "Scribner",
    "value": "scribner"
  },
  {
    "text": "Scroggins",
    "value": "scroggins"
  },
  {
    "text": "Scuddy",
    "value": "scuddy"
  },
  {
    "text": "Scurry",
    "value": "scurry"
  },
  {
    "text": "Sea Bright",
    "value": "sea bright"
  },
  {
    "text": "Sea Cliff",
    "value": "sea cliff"
  },
  {
    "text": "Sea Girt",
    "value": "sea girt"
  },
  {
    "text": "Sea Island",
    "value": "sea island"
  },
  {
    "text": "Sea Isle City",
    "value": "sea isle city"
  },
  {
    "text": "Sea Ranch",
    "value": "sea ranch"
  },
  {
    "text": "SeaTac",
    "value": "seatac"
  },
  {
    "text": "Seabeck",
    "value": "seabeck"
  },
  {
    "text": "Seaboard",
    "value": "seaboard"
  },
  {
    "text": "Seabrook",
    "value": "seabrook"
  },
  {
    "text": "Seabrook Island",
    "value": "seabrook island"
  },
  {
    "text": "Seacrest",
    "value": "seacrest"
  },
  {
    "text": "Seadrift",
    "value": "seadrift"
  },
  {
    "text": "Seaford",
    "value": "seaford"
  },
  {
    "text": "Seaforth",
    "value": "seaforth"
  },
  {
    "text": "Seagoville",
    "value": "seagoville"
  },
  {
    "text": "Seagraves",
    "value": "seagraves"
  },
  {
    "text": "Seagrove",
    "value": "seagrove"
  },
  {
    "text": "Seahurst",
    "value": "seahurst"
  },
  {
    "text": "Seal Beach",
    "value": "seal beach"
  },
  {
    "text": "Seal Harbor",
    "value": "seal harbor"
  },
  {
    "text": "Seal Rock",
    "value": "seal rock"
  },
  {
    "text": "Seale",
    "value": "seale"
  },
  {
    "text": "Sealy",
    "value": "sealy"
  },
  {
    "text": "Seaman",
    "value": "seaman"
  },
  {
    "text": "Searchlight",
    "value": "searchlight"
  },
  {
    "text": "Searcy",
    "value": "searcy"
  },
  {
    "text": "Searingtown",
    "value": "searingtown"
  },
  {
    "text": "Searles Valley",
    "value": "searles valley"
  },
  {
    "text": "Sears",
    "value": "sears"
  },
  {
    "text": "Searsboro",
    "value": "searsboro"
  },
  {
    "text": "Searsmont",
    "value": "searsmont"
  },
  {
    "text": "Searsport",
    "value": "searsport"
  },
  {
    "text": "Seaside",
    "value": "seaside"
  },
  {
    "text": "Seaside Heights",
    "value": "seaside heights"
  },
  {
    "text": "Seaside Park",
    "value": "seaside park"
  },
  {
    "text": "Seat Pleasant",
    "value": "seat pleasant"
  },
  {
    "text": "Seaton",
    "value": "seaton"
  },
  {
    "text": "Seatonville",
    "value": "seatonville"
  },
  {
    "text": "Seattle",
    "value": "seattle"
  },
  {
    "text": "Seaview",
    "value": "seaview"
  },
  {
    "text": "Sebago",
    "value": "sebago"
  },
  {
    "text": "Sebago Center",
    "value": "sebago center"
  },
  {
    "text": "Sebastian",
    "value": "sebastian"
  },
  {
    "text": "Sebastopol",
    "value": "sebastopol"
  },
  {
    "text": "Sebec",
    "value": "sebec"
  },
  {
    "text": "Sebeka",
    "value": "sebeka"
  },
  {
    "text": "Sebewaing",
    "value": "sebewaing"
  },
  {
    "text": "Sebree",
    "value": "sebree"
  },
  {
    "text": "Sebring",
    "value": "sebring"
  },
  {
    "text": "Secaucus",
    "value": "secaucus"
  },
  {
    "text": "Second Mesa",
    "value": "second mesa"
  },
  {
    "text": "Secondcreek",
    "value": "secondcreek"
  },
  {
    "text": "Secor",
    "value": "secor"
  },
  {
    "text": "Secretary",
    "value": "secretary"
  },
  {
    "text": "Section",
    "value": "section"
  },
  {
    "text": "Security-Widefield",
    "value": "security-widefield"
  },
  {
    "text": "Sedalia",
    "value": "sedalia"
  },
  {
    "text": "Sedan",
    "value": "sedan"
  },
  {
    "text": "Sedgewickville",
    "value": "sedgewickville"
  },
  {
    "text": "Sedgwick",
    "value": "sedgwick"
  },
  {
    "text": "Sedley",
    "value": "sedley"
  },
  {
    "text": "Sedona",
    "value": "sedona"
  },
  {
    "text": "Sedro-Woolley",
    "value": "sedro-woolley"
  },
  {
    "text": "Seekonk",
    "value": "seekonk"
  },
  {
    "text": "Seeley",
    "value": "seeley"
  },
  {
    "text": "Seeley Lake",
    "value": "seeley lake"
  },
  {
    "text": "Seffner",
    "value": "seffner"
  },
  {
    "text": "Seguin",
    "value": "seguin"
  },
  {
    "text": "Seiad Valley",
    "value": "seiad valley"
  },
  {
    "text": "Seibert",
    "value": "seibert"
  },
  {
    "text": "Seiling",
    "value": "seiling"
  },
  {
    "text": "Selah",
    "value": "selah"
  },
  {
    "text": "Selby",
    "value": "selby"
  },
  {
    "text": "Selbyville",
    "value": "selbyville"
  },
  {
    "text": "Selden",
    "value": "selden"
  },
  {
    "text": "Seldovia",
    "value": "seldovia"
  },
  {
    "text": "Selfridge",
    "value": "selfridge"
  },
  {
    "text": "Seligman",
    "value": "seligman"
  },
  {
    "text": "Selinsgrove",
    "value": "selinsgrove"
  },
  {
    "text": "Selkirk",
    "value": "selkirk"
  },
  {
    "text": "Sellers",
    "value": "sellers"
  },
  {
    "text": "Sellersburg",
    "value": "sellersburg"
  },
  {
    "text": "Sellersville",
    "value": "sellersville"
  },
  {
    "text": "Sells",
    "value": "sells"
  },
  {
    "text": "Selma",
    "value": "selma"
  },
  {
    "text": "Selmer",
    "value": "selmer"
  },
  {
    "text": "Seminary",
    "value": "seminary"
  },
  {
    "text": "Seminole",
    "value": "seminole"
  },
  {
    "text": "Seminole Manor",
    "value": "seminole manor"
  },
  {
    "text": "Semmes",
    "value": "semmes"
  },
  {
    "text": "Semora",
    "value": "semora"
  },
  {
    "text": "Senath",
    "value": "senath"
  },
  {
    "text": "Senatobia",
    "value": "senatobia"
  },
  {
    "text": "Seneca",
    "value": "seneca"
  },
  {
    "text": "Seneca Castle",
    "value": "seneca castle"
  },
  {
    "text": "Seneca Falls",
    "value": "seneca falls"
  },
  {
    "text": "Seneca Rocks",
    "value": "seneca rocks"
  },
  {
    "text": "Senecaville",
    "value": "senecaville"
  },
  {
    "text": "Seney",
    "value": "seney"
  },
  {
    "text": "Senoia",
    "value": "senoia"
  },
  {
    "text": "Sentinel",
    "value": "sentinel"
  },
  {
    "text": "Sentinel Butte",
    "value": "sentinel butte"
  },
  {
    "text": "Sequatchie",
    "value": "sequatchie"
  },
  {
    "text": "Sequim",
    "value": "sequim"
  },
  {
    "text": "Sequoia National Park",
    "value": "sequoia national park"
  },
  {
    "text": "Serafina",
    "value": "serafina"
  },
  {
    "text": "Serena",
    "value": "serena"
  },
  {
    "text": "Sergeant Bluff",
    "value": "sergeant bluff"
  },
  {
    "text": "Sergeantsville",
    "value": "sergeantsville"
  },
  {
    "text": "Sesser",
    "value": "sesser"
  },
  {
    "text": "Setauket",
    "value": "setauket"
  },
  {
    "text": "Setauket-East Setauket",
    "value": "setauket-east setauket"
  },
  {
    "text": "Seth",
    "value": "seth"
  },
  {
    "text": "Seven Corners",
    "value": "seven corners"
  },
  {
    "text": "Seven Fields",
    "value": "seven fields"
  },
  {
    "text": "Seven Hills",
    "value": "seven hills"
  },
  {
    "text": "Seven Lakes",
    "value": "seven lakes"
  },
  {
    "text": "Seven Mile",
    "value": "seven mile"
  },
  {
    "text": "Seven Oaks",
    "value": "seven oaks"
  },
  {
    "text": "Seven Springs",
    "value": "seven springs"
  },
  {
    "text": "Seven Trees",
    "value": "seven trees"
  },
  {
    "text": "Seven Valleys",
    "value": "seven valleys"
  },
  {
    "text": "Severance",
    "value": "severance"
  },
  {
    "text": "Severn",
    "value": "severn"
  },
  {
    "text": "Severna Park",
    "value": "severna park"
  },
  {
    "text": "Severy",
    "value": "severy"
  },
  {
    "text": "Sevier",
    "value": "sevier"
  },
  {
    "text": "Sevierville",
    "value": "sevierville"
  },
  {
    "text": "Seville",
    "value": "seville"
  },
  {
    "text": "Sewanee",
    "value": "sewanee"
  },
  {
    "text": "Seward",
    "value": "seward"
  },
  {
    "text": "Sewaren",
    "value": "sewaren"
  },
  {
    "text": "Sewell",
    "value": "sewell"
  },
  {
    "text": "Sewickley",
    "value": "sewickley"
  },
  {
    "text": "Sextons Creek",
    "value": "sextons creek"
  },
  {
    "text": "Seymour",
    "value": "seymour"
  },
  {
    "text": "Shabbona",
    "value": "shabbona"
  },
  {
    "text": "Shacklefords",
    "value": "shacklefords"
  },
  {
    "text": "Shade",
    "value": "shade"
  },
  {
    "text": "Shade Gap",
    "value": "shade gap"
  },
  {
    "text": "Shady Cove",
    "value": "shady cove"
  },
  {
    "text": "Shady Dale",
    "value": "shady dale"
  },
  {
    "text": "Shady Grove",
    "value": "shady grove"
  },
  {
    "text": "Shady Hills",
    "value": "shady hills"
  },
  {
    "text": "Shady Point",
    "value": "shady point"
  },
  {
    "text": "Shady Shores",
    "value": "shady shores"
  },
  {
    "text": "Shady Side",
    "value": "shady side"
  },
  {
    "text": "Shady Spring",
    "value": "shady spring"
  },
  {
    "text": "Shady Valley",
    "value": "shady valley"
  },
  {
    "text": "Shadyside",
    "value": "shadyside"
  },
  {
    "text": "Shafer",
    "value": "shafer"
  },
  {
    "text": "Shafter",
    "value": "shafter"
  },
  {
    "text": "Shaftsbury",
    "value": "shaftsbury"
  },
  {
    "text": "Shageluk",
    "value": "shageluk"
  },
  {
    "text": "Shaker Heights",
    "value": "shaker heights"
  },
  {
    "text": "Shakopee",
    "value": "shakopee"
  },
  {
    "text": "Shalimar",
    "value": "shalimar"
  },
  {
    "text": "Shallotte",
    "value": "shallotte"
  },
  {
    "text": "Shallowater",
    "value": "shallowater"
  },
  {
    "text": "Shambaugh",
    "value": "shambaugh"
  },
  {
    "text": "Shamokin",
    "value": "shamokin"
  },
  {
    "text": "Shamokin Dam",
    "value": "shamokin dam"
  },
  {
    "text": "Shamrock",
    "value": "shamrock"
  },
  {
    "text": "Shandaken",
    "value": "shandaken"
  },
  {
    "text": "Shandon",
    "value": "shandon"
  },
  {
    "text": "Shanksville",
    "value": "shanksville"
  },
  {
    "text": "Shannock",
    "value": "shannock"
  },
  {
    "text": "Shannon",
    "value": "shannon"
  },
  {
    "text": "Shannon City",
    "value": "shannon city"
  },
  {
    "text": "Shapleigh",
    "value": "shapleigh"
  },
  {
    "text": "Shark River Hills",
    "value": "shark river hills"
  },
  {
    "text": "Sharon",
    "value": "sharon"
  },
  {
    "text": "Sharon Center",
    "value": "sharon center"
  },
  {
    "text": "Sharon Hill",
    "value": "sharon hill"
  },
  {
    "text": "Sharon Springs",
    "value": "sharon springs"
  },
  {
    "text": "Sharonville",
    "value": "sharonville"
  },
  {
    "text": "Sharpes",
    "value": "sharpes"
  },
  {
    "text": "Sharples",
    "value": "sharples"
  },
  {
    "text": "Sharps Chapel",
    "value": "sharps chapel"
  },
  {
    "text": "Sharpsburg",
    "value": "sharpsburg"
  },
  {
    "text": "Sharpsville",
    "value": "sharpsville"
  },
  {
    "text": "Sharptown",
    "value": "sharptown"
  },
  {
    "text": "Shartlesville",
    "value": "shartlesville"
  },
  {
    "text": "Shasta",
    "value": "shasta"
  },
  {
    "text": "Shasta Lake",
    "value": "shasta lake"
  },
  {
    "text": "Shattuck",
    "value": "shattuck"
  },
  {
    "text": "Shavano Park",
    "value": "shavano park"
  },
  {
    "text": "Shaver Lake",
    "value": "shaver lake"
  },
  {
    "text": "Shavertown",
    "value": "shavertown"
  },
  {
    "text": "Shaw",
    "value": "shaw"
  },
  {
    "text": "Shaw Air Force Base",
    "value": "shaw air force base"
  },
  {
    "text": "Shaw Island",
    "value": "shaw island"
  },
  {
    "text": "Shawanee",
    "value": "shawanee"
  },
  {
    "text": "Shawano",
    "value": "shawano"
  },
  {
    "text": "Shawboro",
    "value": "shawboro"
  },
  {
    "text": "Shawnee",
    "value": "shawnee"
  },
  {
    "text": "Shawnee Mission",
    "value": "shawnee mission"
  },
  {
    "text": "Shawnee on Delaware",
    "value": "shawnee on delaware"
  },
  {
    "text": "Shawneetown",
    "value": "shawneetown"
  },
  {
    "text": "Shawsville",
    "value": "shawsville"
  },
  {
    "text": "Shawville",
    "value": "shawville"
  },
  {
    "text": "Sheboygan",
    "value": "sheboygan"
  },
  {
    "text": "Sheboygan Falls",
    "value": "sheboygan falls"
  },
  {
    "text": "Shedd",
    "value": "shedd"
  },
  {
    "text": "Sheep Springs",
    "value": "sheep springs"
  },
  {
    "text": "Sheepshead Bay",
    "value": "sheepshead bay"
  },
  {
    "text": "Sheffield",
    "value": "sheffield"
  },
  {
    "text": "Sheffield Lake",
    "value": "sheffield lake"
  },
  {
    "text": "Shelbiana",
    "value": "shelbiana"
  },
  {
    "text": "Shelbina",
    "value": "shelbina"
  },
  {
    "text": "Shelburn",
    "value": "shelburn"
  },
  {
    "text": "Shelburne",
    "value": "shelburne"
  },
  {
    "text": "Shelburne Falls",
    "value": "shelburne falls"
  },
  {
    "text": "Shelby",
    "value": "shelby"
  },
  {
    "text": "Shelbyville",
    "value": "shelbyville"
  },
  {
    "text": "Sheldahl",
    "value": "sheldahl"
  },
  {
    "text": "Sheldon",
    "value": "sheldon"
  },
  {
    "text": "Sheldon Springs",
    "value": "sheldon springs"
  },
  {
    "text": "Shell",
    "value": "shell"
  },
  {
    "text": "Shell Knob",
    "value": "shell knob"
  },
  {
    "text": "Shell Lake",
    "value": "shell lake"
  },
  {
    "text": "Shell Rock",
    "value": "shell rock"
  },
  {
    "text": "Shell Valley",
    "value": "shell valley"
  },
  {
    "text": "Shelley",
    "value": "shelley"
  },
  {
    "text": "Shellman",
    "value": "shellman"
  },
  {
    "text": "Shellsburg",
    "value": "shellsburg"
  },
  {
    "text": "Shelly",
    "value": "shelly"
  },
  {
    "text": "Shelocta",
    "value": "shelocta"
  },
  {
    "text": "Shelter Island",
    "value": "shelter island"
  },
  {
    "text": "Shelter Island Heights",
    "value": "shelter island heights"
  },
  {
    "text": "Shelton",
    "value": "shelton"
  },
  {
    "text": "Shenandoah",
    "value": "shenandoah"
  },
  {
    "text": "Shenandoah Junction",
    "value": "shenandoah junction"
  },
  {
    "text": "Shenango",
    "value": "shenango"
  },
  {
    "text": "Shepardsville",
    "value": "shepardsville"
  },
  {
    "text": "Shepherd",
    "value": "shepherd"
  },
  {
    "text": "Shepherdstown",
    "value": "shepherdstown"
  },
  {
    "text": "Shepherdsville",
    "value": "shepherdsville"
  },
  {
    "text": "Sheppard Air Force Base",
    "value": "sheppard air force base"
  },
  {
    "text": "Sheppton",
    "value": "sheppton"
  },
  {
    "text": "Sherack",
    "value": "sherack"
  },
  {
    "text": "Sherborn",
    "value": "sherborn"
  },
  {
    "text": "Sherburn",
    "value": "sherburn"
  },
  {
    "text": "Sherburne",
    "value": "sherburne"
  },
  {
    "text": "Sheridan",
    "value": "sheridan"
  },
  {
    "text": "Sheridan Lake",
    "value": "sheridan lake"
  },
  {
    "text": "Sherman",
    "value": "sherman"
  },
  {
    "text": "Sherman Oaks",
    "value": "sherman oaks"
  },
  {
    "text": "Shermans Dale",
    "value": "shermans dale"
  },
  {
    "text": "Sherrard",
    "value": "sherrard"
  },
  {
    "text": "Sherrelwood",
    "value": "sherrelwood"
  },
  {
    "text": "Sherrill",
    "value": "sherrill"
  },
  {
    "text": "Sherrills Ford",
    "value": "sherrills ford"
  },
  {
    "text": "Sherrodsville",
    "value": "sherrodsville"
  },
  {
    "text": "Sherwood",
    "value": "sherwood"
  },
  {
    "text": "Shevlin",
    "value": "shevlin"
  },
  {
    "text": "Sheyenne",
    "value": "sheyenne"
  },
  {
    "text": "Shickley",
    "value": "shickley"
  },
  {
    "text": "Shickshinny",
    "value": "shickshinny"
  },
  {
    "text": "Shidler",
    "value": "shidler"
  },
  {
    "text": "Shields",
    "value": "shields"
  },
  {
    "text": "Shillington",
    "value": "shillington"
  },
  {
    "text": "Shiloh",
    "value": "shiloh"
  },
  {
    "text": "Shiner",
    "value": "shiner"
  },
  {
    "text": "Shingle Springs",
    "value": "shingle springs"
  },
  {
    "text": "Shinglehouse",
    "value": "shinglehouse"
  },
  {
    "text": "Shingleton",
    "value": "shingleton"
  },
  {
    "text": "Shingletown",
    "value": "shingletown"
  },
  {
    "text": "Shinnecock Hills",
    "value": "shinnecock hills"
  },
  {
    "text": "Shinnston",
    "value": "shinnston"
  },
  {
    "text": "Shiocton",
    "value": "shiocton"
  },
  {
    "text": "Ship Bottom",
    "value": "ship bottom"
  },
  {
    "text": "Shipman",
    "value": "shipman"
  },
  {
    "text": "Shippensburg",
    "value": "shippensburg"
  },
  {
    "text": "Shippenville",
    "value": "shippenville"
  },
  {
    "text": "Shippingport",
    "value": "shippingport"
  },
  {
    "text": "Shiprock",
    "value": "shiprock"
  },
  {
    "text": "Shipshewana",
    "value": "shipshewana"
  },
  {
    "text": "Shiremanstown",
    "value": "shiremanstown"
  },
  {
    "text": "Shirley",
    "value": "shirley"
  },
  {
    "text": "Shirley Mills",
    "value": "shirley mills"
  },
  {
    "text": "Shirleysburg",
    "value": "shirleysburg"
  },
  {
    "text": "Shiro",
    "value": "shiro"
  },
  {
    "text": "Shishmaref",
    "value": "shishmaref"
  },
  {
    "text": "Shively",
    "value": "shively"
  },
  {
    "text": "Shoals",
    "value": "shoals"
  },
  {
    "text": "Shobonier",
    "value": "shobonier"
  },
  {
    "text": "Shock",
    "value": "shock"
  },
  {
    "text": "Shoemakersville",
    "value": "shoemakersville"
  },
  {
    "text": "Shohola",
    "value": "shohola"
  },
  {
    "text": "Shokan",
    "value": "shokan"
  },
  {
    "text": "Shongaloo",
    "value": "shongaloo"
  },
  {
    "text": "Shonto",
    "value": "shonto"
  },
  {
    "text": "Shoreham",
    "value": "shoreham"
  },
  {
    "text": "Shoreline",
    "value": "shoreline"
  },
  {
    "text": "Shoreview",
    "value": "shoreview"
  },
  {
    "text": "Shorewood",
    "value": "shorewood"
  },
  {
    "text": "Short Hills",
    "value": "short hills"
  },
  {
    "text": "Short Pump",
    "value": "short pump"
  },
  {
    "text": "Shorter",
    "value": "shorter"
  },
  {
    "text": "Shorterville",
    "value": "shorterville"
  },
  {
    "text": "Shortsville",
    "value": "shortsville"
  },
  {
    "text": "Shortt Gap",
    "value": "shortt gap"
  },
  {
    "text": "Shoshone",
    "value": "shoshone"
  },
  {
    "text": "Shoshoni",
    "value": "shoshoni"
  },
  {
    "text": "Show Low",
    "value": "show low"
  },
  {
    "text": "Showell",
    "value": "showell"
  },
  {
    "text": "Shreve",
    "value": "shreve"
  },
  {
    "text": "Shreveport",
    "value": "shreveport"
  },
  {
    "text": "Shrewsbury",
    "value": "shrewsbury"
  },
  {
    "text": "Shrub Oak",
    "value": "shrub oak"
  },
  {
    "text": "Shubert",
    "value": "shubert"
  },
  {
    "text": "Shubuta",
    "value": "shubuta"
  },
  {
    "text": "Shullsburg",
    "value": "shullsburg"
  },
  {
    "text": "Shumway",
    "value": "shumway"
  },
  {
    "text": "Shungnak",
    "value": "shungnak"
  },
  {
    "text": "Shungopavi",
    "value": "shungopavi"
  },
  {
    "text": "Shunk",
    "value": "shunk"
  },
  {
    "text": "Shuqualak",
    "value": "shuqualak"
  },
  {
    "text": "Shushan",
    "value": "shushan"
  },
  {
    "text": "Shutesbury",
    "value": "shutesbury"
  },
  {
    "text": "Siasconset",
    "value": "siasconset"
  },
  {
    "text": "Sibley",
    "value": "sibley"
  },
  {
    "text": "Sicily Island",
    "value": "sicily island"
  },
  {
    "text": "Sicklerville",
    "value": "sicklerville"
  },
  {
    "text": "Side Lake",
    "value": "side lake"
  },
  {
    "text": "Sidell",
    "value": "sidell"
  },
  {
    "text": "Sidman",
    "value": "sidman"
  },
  {
    "text": "Sidnaw",
    "value": "sidnaw"
  },
  {
    "text": "Sidney",
    "value": "sidney"
  },
  {
    "text": "Sidney Center",
    "value": "sidney center"
  },
  {
    "text": "Sidon",
    "value": "sidon"
  },
  {
    "text": "Sienna Plantation",
    "value": "sienna plantation"
  },
  {
    "text": "Sieper",
    "value": "sieper"
  },
  {
    "text": "Sierra Blanca",
    "value": "sierra blanca"
  },
  {
    "text": "Sierra City",
    "value": "sierra city"
  },
  {
    "text": "Sierra Madre",
    "value": "sierra madre"
  },
  {
    "text": "Sierra Vista",
    "value": "sierra vista"
  },
  {
    "text": "Sierraville",
    "value": "sierraville"
  },
  {
    "text": "Siesta Key",
    "value": "siesta key"
  },
  {
    "text": "Sigel",
    "value": "sigel"
  },
  {
    "text": "Signal Hill",
    "value": "signal hill"
  },
  {
    "text": "Signal Mountain",
    "value": "signal mountain"
  },
  {
    "text": "Sigourney",
    "value": "sigourney"
  },
  {
    "text": "Sigurd",
    "value": "sigurd"
  },
  {
    "text": "Sikes",
    "value": "sikes"
  },
  {
    "text": "Sikeston",
    "value": "sikeston"
  },
  {
    "text": "Silas",
    "value": "silas"
  },
  {
    "text": "Siler",
    "value": "siler"
  },
  {
    "text": "Siler City",
    "value": "siler city"
  },
  {
    "text": "Siletz",
    "value": "siletz"
  },
  {
    "text": "Silex",
    "value": "silex"
  },
  {
    "text": "Siloam",
    "value": "siloam"
  },
  {
    "text": "Siloam Springs",
    "value": "siloam springs"
  },
  {
    "text": "Silsbee",
    "value": "silsbee"
  },
  {
    "text": "Silt",
    "value": "silt"
  },
  {
    "text": "Siluria",
    "value": "siluria"
  },
  {
    "text": "Silva",
    "value": "silva"
  },
  {
    "text": "Silvana",
    "value": "silvana"
  },
  {
    "text": "Silver Bay",
    "value": "silver bay"
  },
  {
    "text": "Silver City",
    "value": "silver city"
  },
  {
    "text": "Silver Creek",
    "value": "silver creek"
  },
  {
    "text": "Silver Firs",
    "value": "silver firs"
  },
  {
    "text": "Silver Grove",
    "value": "silver grove"
  },
  {
    "text": "Silver Lake",
    "value": "silver lake"
  },
  {
    "text": "Silver Peak",
    "value": "silver peak"
  },
  {
    "text": "Silver Point",
    "value": "silver point"
  },
  {
    "text": "Silver Spring",
    "value": "silver spring"
  },
  {
    "text": "Silver Springs",
    "value": "silver springs"
  },
  {
    "text": "Silver Star",
    "value": "silver star"
  },
  {
    "text": "Silverado",
    "value": "silverado"
  },
  {
    "text": "Silverdale",
    "value": "silverdale"
  },
  {
    "text": "Silverhill",
    "value": "silverhill"
  },
  {
    "text": "Silverstreet",
    "value": "silverstreet"
  },
  {
    "text": "Silverthorne",
    "value": "silverthorne"
  },
  {
    "text": "Silverton",
    "value": "silverton"
  },
  {
    "text": "Silverwood",
    "value": "silverwood"
  },
  {
    "text": "Silvis",
    "value": "silvis"
  },
  {
    "text": "Simi Valley",
    "value": "simi valley"
  },
  {
    "text": "Simla",
    "value": "simla"
  },
  {
    "text": "Simmesport",
    "value": "simmesport"
  },
  {
    "text": "Simms",
    "value": "simms"
  },
  {
    "text": "Simon",
    "value": "simon"
  },
  {
    "text": "Simonton",
    "value": "simonton"
  },
  {
    "text": "Simpson",
    "value": "simpson"
  },
  {
    "text": "Simpsonville",
    "value": "simpsonville"
  },
  {
    "text": "Sims",
    "value": "sims"
  },
  {
    "text": "Simsboro",
    "value": "simsboro"
  },
  {
    "text": "Simsbury",
    "value": "simsbury"
  },
  {
    "text": "Sinai",
    "value": "sinai"
  },
  {
    "text": "Sinclair",
    "value": "sinclair"
  },
  {
    "text": "Sinclairville",
    "value": "sinclairville"
  },
  {
    "text": "Singer",
    "value": "singer"
  },
  {
    "text": "Singers Glen",
    "value": "singers glen"
  },
  {
    "text": "Sinking Spring",
    "value": "sinking spring"
  },
  {
    "text": "Sinks Grove",
    "value": "sinks grove"
  },
  {
    "text": "Sinnemahoning",
    "value": "sinnemahoning"
  },
  {
    "text": "Sinton",
    "value": "sinton"
  },
  {
    "text": "Sioux Center",
    "value": "sioux center"
  },
  {
    "text": "Sioux City",
    "value": "sioux city"
  },
  {
    "text": "Sioux Falls",
    "value": "sioux falls"
  },
  {
    "text": "Sioux Rapids",
    "value": "sioux rapids"
  },
  {
    "text": "Sipsey",
    "value": "sipsey"
  },
  {
    "text": "Siren",
    "value": "siren"
  },
  {
    "text": "Sisseton",
    "value": "sisseton"
  },
  {
    "text": "Sissonville",
    "value": "sissonville"
  },
  {
    "text": "Sister Bay",
    "value": "sister bay"
  },
  {
    "text": "Sisters",
    "value": "sisters"
  },
  {
    "text": "Sistersville",
    "value": "sistersville"
  },
  {
    "text": "Sitka",
    "value": "sitka"
  },
  {
    "text": "Six Lakes",
    "value": "six lakes"
  },
  {
    "text": "Six Mile",
    "value": "six mile"
  },
  {
    "text": "Sixes",
    "value": "sixes"
  },
  {
    "text": "Sixteen Mile Stand",
    "value": "sixteen mile stand"
  },
  {
    "text": "Sizerock",
    "value": "sizerock"
  },
  {
    "text": "Skagway",
    "value": "skagway"
  },
  {
    "text": "Skamokawa",
    "value": "skamokawa"
  },
  {
    "text": "Skandia",
    "value": "skandia"
  },
  {
    "text": "Skaneateles",
    "value": "skaneateles"
  },
  {
    "text": "Skaneateles Falls",
    "value": "skaneateles falls"
  },
  {
    "text": "Skanee",
    "value": "skanee"
  },
  {
    "text": "Skellytown",
    "value": "skellytown"
  },
  {
    "text": "Skiatook",
    "value": "skiatook"
  },
  {
    "text": "Skidmore",
    "value": "skidmore"
  },
  {
    "text": "Skillman",
    "value": "skillman"
  },
  {
    "text": "Skippack",
    "value": "skippack"
  },
  {
    "text": "Skipperville",
    "value": "skipperville"
  },
  {
    "text": "Skipwith",
    "value": "skipwith"
  },
  {
    "text": "Skokie",
    "value": "skokie"
  },
  {
    "text": "Skowhegan",
    "value": "skowhegan"
  },
  {
    "text": "Skull Valley",
    "value": "skull valley"
  },
  {
    "text": "Skwentna",
    "value": "skwentna"
  },
  {
    "text": "Sky Lake",
    "value": "sky lake"
  },
  {
    "text": "Sky Valley",
    "value": "sky valley"
  },
  {
    "text": "Skyforest",
    "value": "skyforest"
  },
  {
    "text": "Skykomish",
    "value": "skykomish"
  },
  {
    "text": "Skyland",
    "value": "skyland"
  },
  {
    "text": "Skytop",
    "value": "skytop"
  },
  {
    "text": "Slade",
    "value": "slade"
  },
  {
    "text": "Slagle",
    "value": "slagle"
  },
  {
    "text": "Slanesville",
    "value": "slanesville"
  },
  {
    "text": "Slate Hill",
    "value": "slate hill"
  },
  {
    "text": "Slater",
    "value": "slater"
  },
  {
    "text": "Slatersville",
    "value": "slatersville"
  },
  {
    "text": "Slaterville Springs",
    "value": "slaterville springs"
  },
  {
    "text": "Slatington",
    "value": "slatington"
  },
  {
    "text": "Slaton",
    "value": "slaton"
  },
  {
    "text": "Slaty Fork",
    "value": "slaty fork"
  },
  {
    "text": "Slaughter",
    "value": "slaughter"
  },
  {
    "text": "Slaughters",
    "value": "slaughters"
  },
  {
    "text": "Slayton",
    "value": "slayton"
  },
  {
    "text": "Sledge",
    "value": "sledge"
  },
  {
    "text": "Sleepy Eye",
    "value": "sleepy eye"
  },
  {
    "text": "Sleepy Hollow",
    "value": "sleepy hollow"
  },
  {
    "text": "Slemp",
    "value": "slemp"
  },
  {
    "text": "Slick",
    "value": "slick"
  },
  {
    "text": "Slickville",
    "value": "slickville"
  },
  {
    "text": "Slidell",
    "value": "slidell"
  },
  {
    "text": "Sligo",
    "value": "sligo"
  },
  {
    "text": "Slinger",
    "value": "slinger"
  },
  {
    "text": "Slingerlands",
    "value": "slingerlands"
  },
  {
    "text": "Slippery Rock",
    "value": "slippery rock"
  },
  {
    "text": "Sloan",
    "value": "sloan"
  },
  {
    "text": "Sloansville",
    "value": "sloansville"
  },
  {
    "text": "Sloatsburg",
    "value": "sloatsburg"
  },
  {
    "text": "Slocomb",
    "value": "slocomb"
  },
  {
    "text": "Slocum",
    "value": "slocum"
  },
  {
    "text": "Sloughhouse",
    "value": "sloughhouse"
  },
  {
    "text": "Smackover",
    "value": "smackover"
  },
  {
    "text": "Smallwood",
    "value": "smallwood"
  },
  {
    "text": "Smartsville",
    "value": "smartsville"
  },
  {
    "text": "Smartt",
    "value": "smartt"
  },
  {
    "text": "Smelterville",
    "value": "smelterville"
  },
  {
    "text": "Smethport",
    "value": "smethport"
  },
  {
    "text": "Smicksburg",
    "value": "smicksburg"
  },
  {
    "text": "Smilax",
    "value": "smilax"
  },
  {
    "text": "Smiley",
    "value": "smiley"
  },
  {
    "text": "Smith",
    "value": "smith"
  },
  {
    "text": "Smith Center",
    "value": "smith center"
  },
  {
    "text": "Smith Lake",
    "value": "smith lake"
  },
  {
    "text": "Smith Mills",
    "value": "smith mills"
  },
  {
    "text": "Smith River",
    "value": "smith river"
  },
  {
    "text": "Smith Valley",
    "value": "smith valley"
  },
  {
    "text": "Smithboro",
    "value": "smithboro"
  },
  {
    "text": "Smithburg",
    "value": "smithburg"
  },
  {
    "text": "Smithdale",
    "value": "smithdale"
  },
  {
    "text": "Smithers",
    "value": "smithers"
  },
  {
    "text": "Smithfield",
    "value": "smithfield"
  },
  {
    "text": "Smithland",
    "value": "smithland"
  },
  {
    "text": "Smithmill",
    "value": "smithmill"
  },
  {
    "text": "Smiths Creek",
    "value": "smiths creek"
  },
  {
    "text": "Smiths Grove",
    "value": "smiths grove"
  },
  {
    "text": "Smiths Station",
    "value": "smiths station"
  },
  {
    "text": "Smithsburg",
    "value": "smithsburg"
  },
  {
    "text": "Smithshire",
    "value": "smithshire"
  },
  {
    "text": "Smithton",
    "value": "smithton"
  },
  {
    "text": "Smithtown",
    "value": "smithtown"
  },
  {
    "text": "Smithville",
    "value": "smithville"
  },
  {
    "text": "Smithville Flats",
    "value": "smithville flats"
  },
  {
    "text": "Smithwick",
    "value": "smithwick"
  },
  {
    "text": "Smoaks",
    "value": "smoaks"
  },
  {
    "text": "Smock",
    "value": "smock"
  },
  {
    "text": "Smoot",
    "value": "smoot"
  },
  {
    "text": "Smyer",
    "value": "smyer"
  },
  {
    "text": "Smyrna",
    "value": "smyrna"
  },
  {
    "text": "Smyrna Mills",
    "value": "smyrna mills"
  },
  {
    "text": "Sneads",
    "value": "sneads"
  },
  {
    "text": "Sneads Ferry",
    "value": "sneads ferry"
  },
  {
    "text": "Sneedville",
    "value": "sneedville"
  },
  {
    "text": "Snelling",
    "value": "snelling"
  },
  {
    "text": "Snellville",
    "value": "snellville"
  },
  {
    "text": "Snohomish",
    "value": "snohomish"
  },
  {
    "text": "Snook",
    "value": "snook"
  },
  {
    "text": "Snoqualmie",
    "value": "snoqualmie"
  },
  {
    "text": "Snoqualmie Pass",
    "value": "snoqualmie pass"
  },
  {
    "text": "Snover",
    "value": "snover"
  },
  {
    "text": "Snow",
    "value": "snow"
  },
  {
    "text": "Snow Camp",
    "value": "snow camp"
  },
  {
    "text": "Snow Hill",
    "value": "snow hill"
  },
  {
    "text": "Snow Shoe",
    "value": "snow shoe"
  },
  {
    "text": "Snowflake",
    "value": "snowflake"
  },
  {
    "text": "Snowmass",
    "value": "snowmass"
  },
  {
    "text": "Snowmass Village",
    "value": "snowmass village"
  },
  {
    "text": "Snowshoe",
    "value": "snowshoe"
  },
  {
    "text": "Snowville",
    "value": "snowville"
  },
  {
    "text": "Snyder",
    "value": "snyder"
  },
  {
    "text": "Snydertown",
    "value": "snydertown"
  },
  {
    "text": "Soap Lake",
    "value": "soap lake"
  },
  {
    "text": "Sobieski",
    "value": "sobieski"
  },
  {
    "text": "Socastee",
    "value": "socastee"
  },
  {
    "text": "Social Circle",
    "value": "social circle"
  },
  {
    "text": "Society Hill",
    "value": "society hill"
  },
  {
    "text": "Socorro",
    "value": "socorro"
  },
  {
    "text": "Sod",
    "value": "sod"
  },
  {
    "text": "Soda Bay",
    "value": "soda bay"
  },
  {
    "text": "Soda Springs",
    "value": "soda springs"
  },
  {
    "text": "Soddy-Daisy",
    "value": "soddy-daisy"
  },
  {
    "text": "Sodus",
    "value": "sodus"
  },
  {
    "text": "Sodus Point",
    "value": "sodus point"
  },
  {
    "text": "Solana Beach",
    "value": "solana beach"
  },
  {
    "text": "Soldier",
    "value": "soldier"
  },
  {
    "text": "Soldiers Grove",
    "value": "soldiers grove"
  },
  {
    "text": "Soldotna",
    "value": "soldotna"
  },
  {
    "text": "Solebury",
    "value": "solebury"
  },
  {
    "text": "Soledad",
    "value": "soledad"
  },
  {
    "text": "Solen",
    "value": "solen"
  },
  {
    "text": "Solgohachia",
    "value": "solgohachia"
  },
  {
    "text": "Solo",
    "value": "solo"
  },
  {
    "text": "Solomon",
    "value": "solomon"
  },
  {
    "text": "Solomons",
    "value": "solomons"
  },
  {
    "text": "Solon",
    "value": "solon"
  },
  {
    "text": "Solon Springs",
    "value": "solon springs"
  },
  {
    "text": "Solsberry",
    "value": "solsberry"
  },
  {
    "text": "Solvang",
    "value": "solvang"
  },
  {
    "text": "Solvay",
    "value": "solvay"
  },
  {
    "text": "Solway",
    "value": "solway"
  },
  {
    "text": "Somerdale",
    "value": "somerdale"
  },
  {
    "text": "Somers",
    "value": "somers"
  },
  {
    "text": "Somers Point",
    "value": "somers point"
  },
  {
    "text": "Somerset",
    "value": "somerset"
  },
  {
    "text": "Somersworth",
    "value": "somersworth"
  },
  {
    "text": "Somerton",
    "value": "somerton"
  },
  {
    "text": "Somerville",
    "value": "somerville"
  },
  {
    "text": "Somes Bar",
    "value": "somes bar"
  },
  {
    "text": "Somesville",
    "value": "somesville"
  },
  {
    "text": "Somis",
    "value": "somis"
  },
  {
    "text": "Somonauk",
    "value": "somonauk"
  },
  {
    "text": "Sondheimer",
    "value": "sondheimer"
  },
  {
    "text": "Sonoita",
    "value": "sonoita"
  },
  {
    "text": "Sonoma",
    "value": "sonoma"
  },
  {
    "text": "Sonora",
    "value": "sonora"
  },
  {
    "text": "Sontag",
    "value": "sontag"
  },
  {
    "text": "Sopchoppy",
    "value": "sopchoppy"
  },
  {
    "text": "Soper",
    "value": "soper"
  },
  {
    "text": "Soperton",
    "value": "soperton"
  },
  {
    "text": "Sophia",
    "value": "sophia"
  },
  {
    "text": "Soquel",
    "value": "soquel"
  },
  {
    "text": "Sorento",
    "value": "sorento"
  },
  {
    "text": "Sorrento",
    "value": "sorrento"
  },
  {
    "text": "Soso",
    "value": "soso"
  },
  {
    "text": "Soudan",
    "value": "soudan"
  },
  {
    "text": "Souderton",
    "value": "souderton"
  },
  {
    "text": "Soulsbyville",
    "value": "soulsbyville"
  },
  {
    "text": "Sound Beach",
    "value": "sound beach"
  },
  {
    "text": "Sour Lake",
    "value": "sour lake"
  },
  {
    "text": "Souris",
    "value": "souris"
  },
  {
    "text": "South Acworth",
    "value": "south acworth"
  },
  {
    "text": "South Amana",
    "value": "south amana"
  },
  {
    "text": "South Amboy",
    "value": "south amboy"
  },
  {
    "text": "South Amherst",
    "value": "south amherst"
  },
  {
    "text": "South Apopka",
    "value": "south apopka"
  },
  {
    "text": "South Barre",
    "value": "south barre"
  },
  {
    "text": "South Barrington",
    "value": "south barrington"
  },
  {
    "text": "South Bay",
    "value": "south bay"
  },
  {
    "text": "South Beach",
    "value": "south beach"
  },
  {
    "text": "South Bel Air",
    "value": "south bel air"
  },
  {
    "text": "South Beloit",
    "value": "south beloit"
  },
  {
    "text": "South Bend",
    "value": "south bend"
  },
  {
    "text": "South Berwick",
    "value": "south berwick"
  },
  {
    "text": "South Bethlehem",
    "value": "south bethlehem"
  },
  {
    "text": "South Bloomingville",
    "value": "south bloomingville"
  },
  {
    "text": "South Boardman",
    "value": "south boardman"
  },
  {
    "text": "South Boston",
    "value": "south boston"
  },
  {
    "text": "South Bound Brook",
    "value": "south bound brook"
  },
  {
    "text": "South Bradenton",
    "value": "south bradenton"
  },
  {
    "text": "South Branch",
    "value": "south branch"
  },
  {
    "text": "South Bristol",
    "value": "south bristol"
  },
  {
    "text": "South Burlington",
    "value": "south burlington"
  },
  {
    "text": "South Cairo",
    "value": "south cairo"
  },
  {
    "text": "South Canaan",
    "value": "south canaan"
  },
  {
    "text": "South Charleston",
    "value": "south charleston"
  },
  {
    "text": "South Chicago Heights",
    "value": "south chicago heights"
  },
  {
    "text": "South China",
    "value": "south china"
  },
  {
    "text": "South Cle Elum",
    "value": "south cle elum"
  },
  {
    "text": "South Coatesville",
    "value": "south coatesville"
  },
  {
    "text": "South Coffeyville",
    "value": "south coffeyville"
  },
  {
    "text": "South Colby",
    "value": "south colby"
  },
  {
    "text": "South Colton",
    "value": "south colton"
  },
  {
    "text": "South Dartmouth",
    "value": "south dartmouth"
  },
  {
    "text": "South Dayton",
    "value": "south dayton"
  },
  {
    "text": "South Daytona",
    "value": "south daytona"
  },
  {
    "text": "South Deerfield",
    "value": "south deerfield"
  },
  {
    "text": "South Dennis",
    "value": "south dennis"
  },
  {
    "text": "South Dos Palos",
    "value": "south dos palos"
  },
  {
    "text": "South Easton",
    "value": "south easton"
  },
  {
    "text": "South Egremont",
    "value": "south egremont"
  },
  {
    "text": "South El Monte",
    "value": "south el monte"
  },
  {
    "text": "South Elgin",
    "value": "south elgin"
  },
  {
    "text": "South Eliot",
    "value": "south eliot"
  },
  {
    "text": "South English",
    "value": "south english"
  },
  {
    "text": "South Euclid",
    "value": "south euclid"
  },
  {
    "text": "South Fallsburg",
    "value": "south fallsburg"
  },
  {
    "text": "South Fork",
    "value": "south fork"
  },
  {
    "text": "South Freeport",
    "value": "south freeport"
  },
  {
    "text": "South Fulton",
    "value": "south fulton"
  },
  {
    "text": "South Gardiner",
    "value": "south gardiner"
  },
  {
    "text": "South Gate",
    "value": "south gate"
  },
  {
    "text": "South Gate Ridge",
    "value": "south gate ridge"
  },
  {
    "text": "South Gibson",
    "value": "south gibson"
  },
  {
    "text": "South Glastonbury",
    "value": "south glastonbury"
  },
  {
    "text": "South Glens Falls",
    "value": "south glens falls"
  },
  {
    "text": "South Grafton",
    "value": "south grafton"
  },
  {
    "text": "South Greensburg",
    "value": "south greensburg"
  },
  {
    "text": "South Hackensack",
    "value": "south hackensack"
  },
  {
    "text": "South Hadley",
    "value": "south hadley"
  },
  {
    "text": "South Hamilton",
    "value": "south hamilton"
  },
  {
    "text": "South Harwich",
    "value": "south harwich"
  },
  {
    "text": "South Haven",
    "value": "south haven"
  },
  {
    "text": "South Heart",
    "value": "south heart"
  },
  {
    "text": "South Heights",
    "value": "south heights"
  },
  {
    "text": "South Henderson",
    "value": "south henderson"
  },
  {
    "text": "South Hero",
    "value": "south hero"
  },
  {
    "text": "South Highpoint",
    "value": "south highpoint"
  },
  {
    "text": "South Hill",
    "value": "south hill"
  },
  {
    "text": "South Holland",
    "value": "south holland"
  },
  {
    "text": "South Hooksett",
    "value": "south hooksett"
  },
  {
    "text": "South Houston",
    "value": "south houston"
  },
  {
    "text": "South Huntington",
    "value": "south huntington"
  },
  {
    "text": "South Hutchinson",
    "value": "south hutchinson"
  },
  {
    "text": "South Jacksonville",
    "value": "south jacksonville"
  },
  {
    "text": "South Jamesport",
    "value": "south jamesport"
  },
  {
    "text": "South Jordan",
    "value": "south jordan"
  },
  {
    "text": "South Kent",
    "value": "south kent"
  },
  {
    "text": "South Kingstown",
    "value": "south kingstown"
  },
  {
    "text": "South Kortright",
    "value": "south kortright"
  },
  {
    "text": "South Lake Tahoe",
    "value": "south lake tahoe"
  },
  {
    "text": "South Lancaster",
    "value": "south lancaster"
  },
  {
    "text": "South Lebanon",
    "value": "south lebanon"
  },
  {
    "text": "South Lee",
    "value": "south lee"
  },
  {
    "text": "South Lockport",
    "value": "south lockport"
  },
  {
    "text": "South Londonderry",
    "value": "south londonderry"
  },
  {
    "text": "South Lyme",
    "value": "south lyme"
  },
  {
    "text": "South Lyon",
    "value": "south lyon"
  },
  {
    "text": "South Miami",
    "value": "south miami"
  },
  {
    "text": "South Milford",
    "value": "south milford"
  },
  {
    "text": "South Mills",
    "value": "south mills"
  },
  {
    "text": "South Milwaukee",
    "value": "south milwaukee"
  },
  {
    "text": "South Montrose",
    "value": "south montrose"
  },
  {
    "text": "South Mountain",
    "value": "south mountain"
  },
  {
    "text": "South New Berlin",
    "value": "south new berlin"
  },
  {
    "text": "South Newfane",
    "value": "south newfane"
  },
  {
    "text": "South Nyack",
    "value": "south nyack"
  },
  {
    "text": "South Ogden",
    "value": "south ogden"
  },
  {
    "text": "South Orange",
    "value": "south orange"
  },
  {
    "text": "South Orleans",
    "value": "south orleans"
  },
  {
    "text": "South Otselic",
    "value": "south otselic"
  },
  {
    "text": "South Ozone Park",
    "value": "south ozone park"
  },
  {
    "text": "South Padre Island",
    "value": "south padre island"
  },
  {
    "text": "South Palm Beach",
    "value": "south palm beach"
  },
  {
    "text": "South Paris",
    "value": "south paris"
  },
  {
    "text": "South Park",
    "value": "south park"
  },
  {
    "text": "South Park Township",
    "value": "south park township"
  },
  {
    "text": "South Pasadena",
    "value": "south pasadena"
  },
  {
    "text": "South Peabody",
    "value": "south peabody"
  },
  {
    "text": "South Pekin",
    "value": "south pekin"
  },
  {
    "text": "South Pittsburg",
    "value": "south pittsburg"
  },
  {
    "text": "South Plainfield",
    "value": "south plainfield"
  },
  {
    "text": "South Plymouth",
    "value": "south plymouth"
  },
  {
    "text": "South Point",
    "value": "south point"
  },
  {
    "text": "South Pomfret",
    "value": "south pomfret"
  },
  {
    "text": "South Portland",
    "value": "south portland"
  },
  {
    "text": "South Portsmouth",
    "value": "south portsmouth"
  },
  {
    "text": "South Range",
    "value": "south range"
  },
  {
    "text": "South Richmond Hill",
    "value": "south richmond hill"
  },
  {
    "text": "South Riding",
    "value": "south riding"
  },
  {
    "text": "South River",
    "value": "south river"
  },
  {
    "text": "South Rockwood",
    "value": "south rockwood"
  },
  {
    "text": "South Roxana",
    "value": "south roxana"
  },
  {
    "text": "South Royalton",
    "value": "south royalton"
  },
  {
    "text": "South Russell",
    "value": "south russell"
  },
  {
    "text": "South Ryegate",
    "value": "south ryegate"
  },
  {
    "text": "South Saint Paul",
    "value": "south saint paul"
  },
  {
    "text": "South Salem",
    "value": "south salem"
  },
  {
    "text": "South Salt Lake",
    "value": "south salt lake"
  },
  {
    "text": "South San Francisco",
    "value": "south san francisco"
  },
  {
    "text": "South San Jose Hills",
    "value": "south san jose hills"
  },
  {
    "text": "South Sarasota",
    "value": "south sarasota"
  },
  {
    "text": "South Seaside Park",
    "value": "south seaside park"
  },
  {
    "text": "South Shaftsbury",
    "value": "south shaftsbury"
  },
  {
    "text": "South Shore",
    "value": "south shore"
  },
  {
    "text": "South Sioux City",
    "value": "south sioux city"
  },
  {
    "text": "South Solon",
    "value": "south solon"
  },
  {
    "text": "South Strafford",
    "value": "south strafford"
  },
  {
    "text": "South Sutton",
    "value": "south sutton"
  },
  {
    "text": "South Tamworth",
    "value": "south tamworth"
  },
  {
    "text": "South Thomaston",
    "value": "south thomaston"
  },
  {
    "text": "South Tucson",
    "value": "south tucson"
  },
  {
    "text": "South Union",
    "value": "south union"
  },
  {
    "text": "South Uniontown",
    "value": "south uniontown"
  },
  {
    "text": "South Valley",
    "value": "south valley"
  },
  {
    "text": "South Valley Stream",
    "value": "south valley stream"
  },
  {
    "text": "South Venice",
    "value": "south venice"
  },
  {
    "text": "South Vienna",
    "value": "south vienna"
  },
  {
    "text": "South Vineland",
    "value": "south vineland"
  },
  {
    "text": "South Wales",
    "value": "south wales"
  },
  {
    "text": "South Walpole",
    "value": "south walpole"
  },
  {
    "text": "South Wayne",
    "value": "south wayne"
  },
  {
    "text": "South Weber",
    "value": "south weber"
  },
  {
    "text": "South Webster",
    "value": "south webster"
  },
  {
    "text": "South Wellfleet",
    "value": "south wellfleet"
  },
  {
    "text": "South West Bend",
    "value": "south west bend"
  },
  {
    "text": "South West City",
    "value": "south west city"
  },
  {
    "text": "South Weymouth",
    "value": "south weymouth"
  },
  {
    "text": "South Whitley",
    "value": "south whitley"
  },
  {
    "text": "South Whittier",
    "value": "south whittier"
  },
  {
    "text": "South Williamson",
    "value": "south williamson"
  },
  {
    "text": "South Williamsport",
    "value": "south williamsport"
  },
  {
    "text": "South Wilmington",
    "value": "south wilmington"
  },
  {
    "text": "South Windham",
    "value": "south windham"
  },
  {
    "text": "South Windsor",
    "value": "south windsor"
  },
  {
    "text": "South Woodstock",
    "value": "south woodstock"
  },
  {
    "text": "South Yarmouth",
    "value": "south yarmouth"
  },
  {
    "text": "South Zanesville",
    "value": "south zanesville"
  },
  {
    "text": "Southampton",
    "value": "southampton"
  },
  {
    "text": "Southampton Township",
    "value": "southampton township"
  },
  {
    "text": "Southard",
    "value": "southard"
  },
  {
    "text": "Southaven",
    "value": "southaven"
  },
  {
    "text": "Southborough",
    "value": "southborough"
  },
  {
    "text": "Southbridge",
    "value": "southbridge"
  },
  {
    "text": "Southbury",
    "value": "southbury"
  },
  {
    "text": "Southeastern",
    "value": "southeastern"
  },
  {
    "text": "Southern Pines",
    "value": "southern pines"
  },
  {
    "text": "Southern Shores",
    "value": "southern shores"
  },
  {
    "text": "Southern View",
    "value": "southern view"
  },
  {
    "text": "Southfield",
    "value": "southfield"
  },
  {
    "text": "Southfields",
    "value": "southfields"
  },
  {
    "text": "Southgate",
    "value": "southgate"
  },
  {
    "text": "Southington",
    "value": "southington"
  },
  {
    "text": "Southlake",
    "value": "southlake"
  },
  {
    "text": "Southmayd",
    "value": "southmayd"
  },
  {
    "text": "Southmont",
    "value": "southmont"
  },
  {
    "text": "Southold",
    "value": "southold"
  },
  {
    "text": "Southport",
    "value": "southport"
  },
  {
    "text": "Southside",
    "value": "southside"
  },
  {
    "text": "Southside Place",
    "value": "southside place"
  },
  {
    "text": "Southview",
    "value": "southview"
  },
  {
    "text": "Southwest",
    "value": "southwest"
  },
  {
    "text": "Southwest Harbor",
    "value": "southwest harbor"
  },
  {
    "text": "Southwest Ranches",
    "value": "southwest ranches"
  },
  {
    "text": "Southwick",
    "value": "southwick"
  },
  {
    "text": "Spackenkill",
    "value": "spackenkill"
  },
  {
    "text": "Spade",
    "value": "spade"
  },
  {
    "text": "Spalding",
    "value": "spalding"
  },
  {
    "text": "Spanaway",
    "value": "spanaway"
  },
  {
    "text": "Spangle",
    "value": "spangle"
  },
  {
    "text": "Spangler",
    "value": "spangler"
  },
  {
    "text": "Spanish Fork",
    "value": "spanish fork"
  },
  {
    "text": "Spanish Fort",
    "value": "spanish fort"
  },
  {
    "text": "Spanish Lake",
    "value": "spanish lake"
  },
  {
    "text": "Spanish Springs",
    "value": "spanish springs"
  },
  {
    "text": "Sparkill",
    "value": "sparkill"
  },
  {
    "text": "Sparkman",
    "value": "sparkman"
  },
  {
    "text": "Sparks",
    "value": "sparks"
  },
  {
    "text": "Sparks Glencoe",
    "value": "sparks glencoe"
  },
  {
    "text": "Sparland",
    "value": "sparland"
  },
  {
    "text": "Sparrow Bush",
    "value": "sparrow bush"
  },
  {
    "text": "Sparrows Point",
    "value": "sparrows point"
  },
  {
    "text": "Sparta",
    "value": "sparta"
  },
  {
    "text": "Spartanburg",
    "value": "spartanburg"
  },
  {
    "text": "Spartansburg",
    "value": "spartansburg"
  },
  {
    "text": "Spavinaw",
    "value": "spavinaw"
  },
  {
    "text": "Spearfish",
    "value": "spearfish"
  },
  {
    "text": "Spearman",
    "value": "spearman"
  },
  {
    "text": "Spearsville",
    "value": "spearsville"
  },
  {
    "text": "Spearville",
    "value": "spearville"
  },
  {
    "text": "Speculator",
    "value": "speculator"
  },
  {
    "text": "Speed",
    "value": "speed"
  },
  {
    "text": "Speedway",
    "value": "speedway"
  },
  {
    "text": "Speedwell",
    "value": "speedwell"
  },
  {
    "text": "Speer",
    "value": "speer"
  },
  {
    "text": "Spelter",
    "value": "spelter"
  },
  {
    "text": "Spencer",
    "value": "spencer"
  },
  {
    "text": "Spencerport",
    "value": "spencerport"
  },
  {
    "text": "Spencertown",
    "value": "spencertown"
  },
  {
    "text": "Spencerville",
    "value": "spencerville"
  },
  {
    "text": "Speonk",
    "value": "speonk"
  },
  {
    "text": "Sperry",
    "value": "sperry"
  },
  {
    "text": "Sperryville",
    "value": "sperryville"
  },
  {
    "text": "Spiceland",
    "value": "spiceland"
  },
  {
    "text": "Spicer",
    "value": "spicer"
  },
  {
    "text": "Spicewood",
    "value": "spicewood"
  },
  {
    "text": "Spickard",
    "value": "spickard"
  },
  {
    "text": "Spillville",
    "value": "spillville"
  },
  {
    "text": "Spindale",
    "value": "spindale"
  },
  {
    "text": "Spirit Lake",
    "value": "spirit lake"
  },
  {
    "text": "Spiritwood",
    "value": "spiritwood"
  },
  {
    "text": "Spiro",
    "value": "spiro"
  },
  {
    "text": "Spivey",
    "value": "spivey"
  },
  {
    "text": "Splendora",
    "value": "splendora"
  },
  {
    "text": "Spofford",
    "value": "spofford"
  },
  {
    "text": "Spokane",
    "value": "spokane"
  },
  {
    "text": "Spokane Valley",
    "value": "spokane valley"
  },
  {
    "text": "Spooner",
    "value": "spooner"
  },
  {
    "text": "Spotswood",
    "value": "spotswood"
  },
  {
    "text": "Spotsylvania",
    "value": "spotsylvania"
  },
  {
    "text": "Spotsylvania Courthouse",
    "value": "spotsylvania courthouse"
  },
  {
    "text": "Spout Spring",
    "value": "spout spring"
  },
  {
    "text": "Spraggs",
    "value": "spraggs"
  },
  {
    "text": "Sprague",
    "value": "sprague"
  },
  {
    "text": "Sprakers",
    "value": "sprakers"
  },
  {
    "text": "Sprankle Mills",
    "value": "sprankle mills"
  },
  {
    "text": "Spray",
    "value": "spray"
  },
  {
    "text": "Spreckels",
    "value": "spreckels"
  },
  {
    "text": "Spring",
    "value": "spring"
  },
  {
    "text": "Spring Arbor",
    "value": "spring arbor"
  },
  {
    "text": "Spring Bay",
    "value": "spring bay"
  },
  {
    "text": "Spring Branch",
    "value": "spring branch"
  },
  {
    "text": "Spring Brook",
    "value": "spring brook"
  },
  {
    "text": "Spring Church",
    "value": "spring church"
  },
  {
    "text": "Spring City",
    "value": "spring city"
  },
  {
    "text": "Spring Creek",
    "value": "spring creek"
  },
  {
    "text": "Spring Dale",
    "value": "spring dale"
  },
  {
    "text": "Spring Glen",
    "value": "spring glen"
  },
  {
    "text": "Spring Green",
    "value": "spring green"
  },
  {
    "text": "Spring Grove",
    "value": "spring grove"
  },
  {
    "text": "Spring Hill",
    "value": "spring hill"
  },
  {
    "text": "Spring Hope",
    "value": "spring hope"
  },
  {
    "text": "Spring House",
    "value": "spring house"
  },
  {
    "text": "Spring Lake",
    "value": "spring lake"
  },
  {
    "text": "Spring Lake Heights",
    "value": "spring lake heights"
  },
  {
    "text": "Spring Lake Park",
    "value": "spring lake park"
  },
  {
    "text": "Spring Mills",
    "value": "spring mills"
  },
  {
    "text": "Spring Mount",
    "value": "spring mount"
  },
  {
    "text": "Spring Park",
    "value": "spring park"
  },
  {
    "text": "Spring Ridge",
    "value": "spring ridge"
  },
  {
    "text": "Spring Run",
    "value": "spring run"
  },
  {
    "text": "Spring Valley",
    "value": "spring valley"
  },
  {
    "text": "Springboro",
    "value": "springboro"
  },
  {
    "text": "Springbrook",
    "value": "springbrook"
  },
  {
    "text": "Springdale",
    "value": "springdale"
  },
  {
    "text": "Springer",
    "value": "springer"
  },
  {
    "text": "Springerton",
    "value": "springerton"
  },
  {
    "text": "Springerville",
    "value": "springerville"
  },
  {
    "text": "Springfield",
    "value": "springfield"
  },
  {
    "text": "Springfield Center",
    "value": "springfield center"
  },
  {
    "text": "Springfield Gardens",
    "value": "springfield gardens"
  },
  {
    "text": "Springhill",
    "value": "springhill"
  },
  {
    "text": "Springlake",
    "value": "springlake"
  },
  {
    "text": "Springport",
    "value": "springport"
  },
  {
    "text": "Springs",
    "value": "springs"
  },
  {
    "text": "Springtown",
    "value": "springtown"
  },
  {
    "text": "Springvale",
    "value": "springvale"
  },
  {
    "text": "Springview",
    "value": "springview"
  },
  {
    "text": "Springville",
    "value": "springville"
  },
  {
    "text": "Springwater",
    "value": "springwater"
  },
  {
    "text": "Sproul",
    "value": "sproul"
  },
  {
    "text": "Spruce",
    "value": "spruce"
  },
  {
    "text": "Spruce Creek",
    "value": "spruce creek"
  },
  {
    "text": "Spruce Head",
    "value": "spruce head"
  },
  {
    "text": "Spruce Pine",
    "value": "spruce pine"
  },
  {
    "text": "Spur",
    "value": "spur"
  },
  {
    "text": "Spurger",
    "value": "spurger"
  },
  {
    "text": "Spurlockville",
    "value": "spurlockville"
  },
  {
    "text": "Spurrs Corner",
    "value": "spurrs corner"
  },
  {
    "text": "Squaw Lake",
    "value": "squaw lake"
  },
  {
    "text": "Squaw Valley",
    "value": "squaw valley"
  },
  {
    "text": "Squires",
    "value": "squires"
  },
  {
    "text": "St Johnsbury",
    "value": "st johnsbury"
  },
  {
    "text": "St Louis",
    "value": "st louis"
  },
  {
    "text": "St. Cloud",
    "value": "st. cloud"
  },
  {
    "text": "St. George",
    "value": "st. george"
  },
  {
    "text": "St. Helena",
    "value": "st. helena"
  },
  {
    "text": "St. Johnsbury",
    "value": "st. johnsbury"
  },
  {
    "text": "St. Mary's",
    "value": "st. mary's"
  },
  {
    "text": "St. Marys",
    "value": "st. marys"
  },
  {
    "text": "St. Petersburg",
    "value": "st. petersburg"
  },
  {
    "text": "Staatsburg",
    "value": "staatsburg"
  },
  {
    "text": "Stacy",
    "value": "stacy"
  },
  {
    "text": "Stacyville",
    "value": "stacyville"
  },
  {
    "text": "Stafford",
    "value": "stafford"
  },
  {
    "text": "Stafford Springs",
    "value": "stafford springs"
  },
  {
    "text": "Staffordsville",
    "value": "staffordsville"
  },
  {
    "text": "Stagecoach",
    "value": "stagecoach"
  },
  {
    "text": "Stahlstown",
    "value": "stahlstown"
  },
  {
    "text": "Staley",
    "value": "staley"
  },
  {
    "text": "Stallings",
    "value": "stallings"
  },
  {
    "text": "Stallion Springs",
    "value": "stallion springs"
  },
  {
    "text": "Stambaugh",
    "value": "stambaugh"
  },
  {
    "text": "Stamford",
    "value": "stamford"
  },
  {
    "text": "Stamping Ground",
    "value": "stamping ground"
  },
  {
    "text": "Stamps",
    "value": "stamps"
  },
  {
    "text": "Stanardsville",
    "value": "stanardsville"
  },
  {
    "text": "Stanberry",
    "value": "stanberry"
  },
  {
    "text": "Stanchfield",
    "value": "stanchfield"
  },
  {
    "text": "Standard",
    "value": "standard"
  },
  {
    "text": "Standish",
    "value": "standish"
  },
  {
    "text": "Stanfield",
    "value": "stanfield"
  },
  {
    "text": "Stanford",
    "value": "stanford"
  },
  {
    "text": "Stanfordville",
    "value": "stanfordville"
  },
  {
    "text": "Stanhope",
    "value": "stanhope"
  },
  {
    "text": "Stanley",
    "value": "stanley"
  },
  {
    "text": "Stanleytown",
    "value": "stanleytown"
  },
  {
    "text": "Stansbury park",
    "value": "stansbury park"
  },
  {
    "text": "Stanton",
    "value": "stanton"
  },
  {
    "text": "Stantonsburg",
    "value": "stantonsburg"
  },
  {
    "text": "Stantonville",
    "value": "stantonville"
  },
  {
    "text": "Stanville",
    "value": "stanville"
  },
  {
    "text": "Stanwood",
    "value": "stanwood"
  },
  {
    "text": "Staplehurst",
    "value": "staplehurst"
  },
  {
    "text": "Staples",
    "value": "staples"
  },
  {
    "text": "Stapleton",
    "value": "stapleton"
  },
  {
    "text": "Star",
    "value": "star"
  },
  {
    "text": "Star City",
    "value": "star city"
  },
  {
    "text": "Star Junction",
    "value": "star junction"
  },
  {
    "text": "Star Lake",
    "value": "star lake"
  },
  {
    "text": "Star Prairie",
    "value": "star prairie"
  },
  {
    "text": "Star Valley",
    "value": "star valley"
  },
  {
    "text": "Starbuck",
    "value": "starbuck"
  },
  {
    "text": "Starford",
    "value": "starford"
  },
  {
    "text": "Stark",
    "value": "stark"
  },
  {
    "text": "Starke",
    "value": "starke"
  },
  {
    "text": "Starks",
    "value": "starks"
  },
  {
    "text": "Starksboro",
    "value": "starksboro"
  },
  {
    "text": "Starkville",
    "value": "starkville"
  },
  {
    "text": "Starkweather",
    "value": "starkweather"
  },
  {
    "text": "Starr",
    "value": "starr"
  },
  {
    "text": "Starrucca",
    "value": "starrucca"
  },
  {
    "text": "Start",
    "value": "start"
  },
  {
    "text": "Startex",
    "value": "startex"
  },
  {
    "text": "State Center",
    "value": "state center"
  },
  {
    "text": "State College",
    "value": "state college"
  },
  {
    "text": "State Farm",
    "value": "state farm"
  },
  {
    "text": "State Line",
    "value": "state line"
  },
  {
    "text": "State Road",
    "value": "state road"
  },
  {
    "text": "State University",
    "value": "state university"
  },
  {
    "text": "Stateline",
    "value": "stateline"
  },
  {
    "text": "Staten Island",
    "value": "staten island"
  },
  {
    "text": "Statenville",
    "value": "statenville"
  },
  {
    "text": "Statesboro",
    "value": "statesboro"
  },
  {
    "text": "Statesville",
    "value": "statesville"
  },
  {
    "text": "Statham",
    "value": "statham"
  },
  {
    "text": "Staunton",
    "value": "staunton"
  },
  {
    "text": "Stayton",
    "value": "stayton"
  },
  {
    "text": "Steamboat Rock",
    "value": "steamboat rock"
  },
  {
    "text": "Steamboat Springs",
    "value": "steamboat springs"
  },
  {
    "text": "Steamburg",
    "value": "steamburg"
  },
  {
    "text": "Stearns",
    "value": "stearns"
  },
  {
    "text": "Stedman",
    "value": "stedman"
  },
  {
    "text": "Steedman",
    "value": "steedman"
  },
  {
    "text": "Steele",
    "value": "steele"
  },
  {
    "text": "Steele City",
    "value": "steele city"
  },
  {
    "text": "Steele Creek",
    "value": "steele creek"
  },
  {
    "text": "Steeles",
    "value": "steeles"
  },
  {
    "text": "Steeles Tavern",
    "value": "steeles tavern"
  },
  {
    "text": "Steeleville",
    "value": "steeleville"
  },
  {
    "text": "Steelton",
    "value": "steelton"
  },
  {
    "text": "Steelville",
    "value": "steelville"
  },
  {
    "text": "Steen",
    "value": "steen"
  },
  {
    "text": "Steens",
    "value": "steens"
  },
  {
    "text": "Steep Falls",
    "value": "steep falls"
  },
  {
    "text": "Steger",
    "value": "steger"
  },
  {
    "text": "Steilacoom",
    "value": "steilacoom"
  },
  {
    "text": "Steinauer",
    "value": "steinauer"
  },
  {
    "text": "Steinhatchee",
    "value": "steinhatchee"
  },
  {
    "text": "Stella",
    "value": "stella"
  },
  {
    "text": "Stella Niagara",
    "value": "stella niagara"
  },
  {
    "text": "Stem",
    "value": "stem"
  },
  {
    "text": "Stendal",
    "value": "stendal"
  },
  {
    "text": "Stennis Space Center",
    "value": "stennis space center"
  },
  {
    "text": "Stephan",
    "value": "stephan"
  },
  {
    "text": "Stephen",
    "value": "stephen"
  },
  {
    "text": "Stephens",
    "value": "stephens"
  },
  {
    "text": "Stephens City",
    "value": "stephens city"
  },
  {
    "text": "Stephenson",
    "value": "stephenson"
  },
  {
    "text": "Stephensport",
    "value": "stephensport"
  },
  {
    "text": "Stephentown",
    "value": "stephentown"
  },
  {
    "text": "Stephenville",
    "value": "stephenville"
  },
  {
    "text": "Steptoe",
    "value": "steptoe"
  },
  {
    "text": "Sterling",
    "value": "sterling"
  },
  {
    "text": "Sterling City",
    "value": "sterling city"
  },
  {
    "text": "Sterling Forest",
    "value": "sterling forest"
  },
  {
    "text": "Sterling Heights",
    "value": "sterling heights"
  },
  {
    "text": "Sterlington",
    "value": "sterlington"
  },
  {
    "text": "Sterrett",
    "value": "sterrett"
  },
  {
    "text": "Stetson",
    "value": "stetson"
  },
  {
    "text": "Stetsonville",
    "value": "stetsonville"
  },
  {
    "text": "Steuben",
    "value": "steuben"
  },
  {
    "text": "Steubenville",
    "value": "steubenville"
  },
  {
    "text": "Stevens",
    "value": "stevens"
  },
  {
    "text": "Stevens Point",
    "value": "stevens point"
  },
  {
    "text": "Stevensburg",
    "value": "stevensburg"
  },
  {
    "text": "Stevenson",
    "value": "stevenson"
  },
  {
    "text": "Stevenson Ranch",
    "value": "stevenson ranch"
  },
  {
    "text": "Stevensville",
    "value": "stevensville"
  },
  {
    "text": "Stevinson",
    "value": "stevinson"
  },
  {
    "text": "Steward",
    "value": "steward"
  },
  {
    "text": "Stewardson",
    "value": "stewardson"
  },
  {
    "text": "Stewart",
    "value": "stewart"
  },
  {
    "text": "Stewarts Point",
    "value": "stewarts point"
  },
  {
    "text": "Stewartstown",
    "value": "stewartstown"
  },
  {
    "text": "Stewartsville",
    "value": "stewartsville"
  },
  {
    "text": "Stewartville",
    "value": "stewartville"
  },
  {
    "text": "Stickney",
    "value": "stickney"
  },
  {
    "text": "Stigler",
    "value": "stigler"
  },
  {
    "text": "Stilesville",
    "value": "stilesville"
  },
  {
    "text": "Stillman Valley",
    "value": "stillman valley"
  },
  {
    "text": "Stillwater",
    "value": "stillwater"
  },
  {
    "text": "Stilwell",
    "value": "stilwell"
  },
  {
    "text": "Stinnett",
    "value": "stinnett"
  },
  {
    "text": "Stinson Beach",
    "value": "stinson beach"
  },
  {
    "text": "Stirling",
    "value": "stirling"
  },
  {
    "text": "Stirling City",
    "value": "stirling city"
  },
  {
    "text": "Stirum",
    "value": "stirum"
  },
  {
    "text": "Stites",
    "value": "stites"
  },
  {
    "text": "Stittville",
    "value": "stittville"
  },
  {
    "text": "Stitzer",
    "value": "stitzer"
  },
  {
    "text": "Stock Island",
    "value": "stock island"
  },
  {
    "text": "Stockbridge",
    "value": "stockbridge"
  },
  {
    "text": "Stockdale",
    "value": "stockdale"
  },
  {
    "text": "Stockertown",
    "value": "stockertown"
  },
  {
    "text": "Stockett",
    "value": "stockett"
  },
  {
    "text": "Stockholm",
    "value": "stockholm"
  },
  {
    "text": "Stockport",
    "value": "stockport"
  },
  {
    "text": "Stockton",
    "value": "stockton"
  },
  {
    "text": "Stockton Springs",
    "value": "stockton springs"
  },
  {
    "text": "Stockville",
    "value": "stockville"
  },
  {
    "text": "Stockwell",
    "value": "stockwell"
  },
  {
    "text": "Stoddard",
    "value": "stoddard"
  },
  {
    "text": "Stokes",
    "value": "stokes"
  },
  {
    "text": "Stokesdale",
    "value": "stokesdale"
  },
  {
    "text": "Stollings",
    "value": "stollings"
  },
  {
    "text": "Stone",
    "value": "stone"
  },
  {
    "text": "Stone Creek",
    "value": "stone creek"
  },
  {
    "text": "Stone Harbor",
    "value": "stone harbor"
  },
  {
    "text": "Stone Lake",
    "value": "stone lake"
  },
  {
    "text": "Stone Mountain",
    "value": "stone mountain"
  },
  {
    "text": "Stone Park",
    "value": "stone park"
  },
  {
    "text": "Stone Ridge",
    "value": "stone ridge"
  },
  {
    "text": "Stoneboro",
    "value": "stoneboro"
  },
  {
    "text": "Stonecrest",
    "value": "stonecrest"
  },
  {
    "text": "Stonefort",
    "value": "stonefort"
  },
  {
    "text": "Stonegate",
    "value": "stonegate"
  },
  {
    "text": "Stoneham",
    "value": "stoneham"
  },
  {
    "text": "Stoneville",
    "value": "stoneville"
  },
  {
    "text": "Stonewall",
    "value": "stonewall"
  },
  {
    "text": "Stonewood",
    "value": "stonewood"
  },
  {
    "text": "Stoney Fork",
    "value": "stoney fork"
  },
  {
    "text": "Stonington",
    "value": "stonington"
  },
  {
    "text": "Stony Brook",
    "value": "stony brook"
  },
  {
    "text": "Stony Creek",
    "value": "stony creek"
  },
  {
    "text": "Stony Point",
    "value": "stony point"
  },
  {
    "text": "Stony Ridge",
    "value": "stony ridge"
  },
  {
    "text": "Stonyford",
    "value": "stonyford"
  },
  {
    "text": "Stopover",
    "value": "stopover"
  },
  {
    "text": "Storden",
    "value": "storden"
  },
  {
    "text": "Storm Lake",
    "value": "storm lake"
  },
  {
    "text": "Stormville",
    "value": "stormville"
  },
  {
    "text": "Storrs",
    "value": "storrs"
  },
  {
    "text": "Story",
    "value": "story"
  },
  {
    "text": "Story City",
    "value": "story city"
  },
  {
    "text": "Stotts City",
    "value": "stotts city"
  },
  {
    "text": "Stoughton",
    "value": "stoughton"
  },
  {
    "text": "Stout",
    "value": "stout"
  },
  {
    "text": "Stoutland",
    "value": "stoutland"
  },
  {
    "text": "Stoutsville",
    "value": "stoutsville"
  },
  {
    "text": "Stovall",
    "value": "stovall"
  },
  {
    "text": "Stover",
    "value": "stover"
  },
  {
    "text": "Stow",
    "value": "stow"
  },
  {
    "text": "Stowe",
    "value": "stowe"
  },
  {
    "text": "Stowell",
    "value": "stowell"
  },
  {
    "text": "Stoy",
    "value": "stoy"
  },
  {
    "text": "Stoystown",
    "value": "stoystown"
  },
  {
    "text": "Strabane",
    "value": "strabane"
  },
  {
    "text": "Strafford",
    "value": "strafford"
  },
  {
    "text": "Strandquist",
    "value": "strandquist"
  },
  {
    "text": "Strang",
    "value": "strang"
  },
  {
    "text": "Strasburg",
    "value": "strasburg"
  },
  {
    "text": "Stratford",
    "value": "stratford"
  },
  {
    "text": "Stratham",
    "value": "stratham"
  },
  {
    "text": "Strathcona",
    "value": "strathcona"
  },
  {
    "text": "Strathmere",
    "value": "strathmere"
  },
  {
    "text": "Strathmore",
    "value": "strathmore"
  },
  {
    "text": "Strattanville",
    "value": "strattanville"
  },
  {
    "text": "Stratton",
    "value": "stratton"
  },
  {
    "text": "Straughn",
    "value": "straughn"
  },
  {
    "text": "Strausstown",
    "value": "strausstown"
  },
  {
    "text": "Strawberry",
    "value": "strawberry"
  },
  {
    "text": "Strawberry Plains",
    "value": "strawberry plains"
  },
  {
    "text": "Strawberry Point",
    "value": "strawberry point"
  },
  {
    "text": "Strawn",
    "value": "strawn"
  },
  {
    "text": "Streamwood",
    "value": "streamwood"
  },
  {
    "text": "Streator",
    "value": "streator"
  },
  {
    "text": "Street",
    "value": "street"
  },
  {
    "text": "Streeter",
    "value": "streeter"
  },
  {
    "text": "Streetman",
    "value": "streetman"
  },
  {
    "text": "Streetsboro",
    "value": "streetsboro"
  },
  {
    "text": "Stringer",
    "value": "stringer"
  },
  {
    "text": "Stringtown",
    "value": "stringtown"
  },
  {
    "text": "Stroh",
    "value": "stroh"
  },
  {
    "text": "Stromsburg",
    "value": "stromsburg"
  },
  {
    "text": "Strong",
    "value": "strong"
  },
  {
    "text": "Strong City",
    "value": "strong city"
  },
  {
    "text": "Stronghurst",
    "value": "stronghurst"
  },
  {
    "text": "Strongstown",
    "value": "strongstown"
  },
  {
    "text": "Strongsville",
    "value": "strongsville"
  },
  {
    "text": "Stroud",
    "value": "stroud"
  },
  {
    "text": "Stroudsburg",
    "value": "stroudsburg"
  },
  {
    "text": "Strum",
    "value": "strum"
  },
  {
    "text": "Strunk",
    "value": "strunk"
  },
  {
    "text": "Struthers",
    "value": "struthers"
  },
  {
    "text": "Stryker",
    "value": "stryker"
  },
  {
    "text": "Strykersville",
    "value": "strykersville"
  },
  {
    "text": "Stuart",
    "value": "stuart"
  },
  {
    "text": "Stuarts Draft",
    "value": "stuarts draft"
  },
  {
    "text": "Studio City",
    "value": "studio city"
  },
  {
    "text": "Studley",
    "value": "studley"
  },
  {
    "text": "Stump Creek",
    "value": "stump creek"
  },
  {
    "text": "Sturbridge",
    "value": "sturbridge"
  },
  {
    "text": "Sturdivant",
    "value": "sturdivant"
  },
  {
    "text": "Sturgeon",
    "value": "sturgeon"
  },
  {
    "text": "Sturgeon Bay",
    "value": "sturgeon bay"
  },
  {
    "text": "Sturgeon Lake",
    "value": "sturgeon lake"
  },
  {
    "text": "Sturgis",
    "value": "sturgis"
  },
  {
    "text": "Sturtevant",
    "value": "sturtevant"
  },
  {
    "text": "Stuttgart",
    "value": "stuttgart"
  },
  {
    "text": "Stuyvesant",
    "value": "stuyvesant"
  },
  {
    "text": "Suamico",
    "value": "suamico"
  },
  {
    "text": "Subiaco",
    "value": "subiaco"
  },
  {
    "text": "Sublette",
    "value": "sublette"
  },
  {
    "text": "Sublime",
    "value": "sublime"
  },
  {
    "text": "Sublimity",
    "value": "sublimity"
  },
  {
    "text": "Succasunna",
    "value": "succasunna"
  },
  {
    "text": "Success",
    "value": "success"
  },
  {
    "text": "Suches",
    "value": "suches"
  },
  {
    "text": "Sudan",
    "value": "sudan"
  },
  {
    "text": "Sudbury",
    "value": "sudbury"
  },
  {
    "text": "Sudlersville",
    "value": "sudlersville"
  },
  {
    "text": "Suffern",
    "value": "suffern"
  },
  {
    "text": "Suffield",
    "value": "suffield"
  },
  {
    "text": "Suffolk",
    "value": "suffolk"
  },
  {
    "text": "Sugar City",
    "value": "sugar city"
  },
  {
    "text": "Sugar Creek",
    "value": "sugar creek"
  },
  {
    "text": "Sugar Grove",
    "value": "sugar grove"
  },
  {
    "text": "Sugar Hill",
    "value": "sugar hill"
  },
  {
    "text": "Sugar Land",
    "value": "sugar land"
  },
  {
    "text": "Sugar Loaf",
    "value": "sugar loaf"
  },
  {
    "text": "Sugar Run",
    "value": "sugar run"
  },
  {
    "text": "Sugar Tree",
    "value": "sugar tree"
  },
  {
    "text": "Sugar Valley",
    "value": "sugar valley"
  },
  {
    "text": "Sugarcreek",
    "value": "sugarcreek"
  },
  {
    "text": "Sugarland Run",
    "value": "sugarland run"
  },
  {
    "text": "Sugarloaf",
    "value": "sugarloaf"
  },
  {
    "text": "Sugartown",
    "value": "sugartown"
  },
  {
    "text": "Suisun",
    "value": "suisun"
  },
  {
    "text": "Suisun City",
    "value": "suisun city"
  },
  {
    "text": "Suitland",
    "value": "suitland"
  },
  {
    "text": "Suitland-Silver Hill",
    "value": "suitland-silver hill"
  },
  {
    "text": "Sula",
    "value": "sula"
  },
  {
    "text": "Sulligent",
    "value": "sulligent"
  },
  {
    "text": "Sullivan",
    "value": "sullivan"
  },
  {
    "text": "Sullivan City",
    "value": "sullivan city"
  },
  {
    "text": "Sullivans Island",
    "value": "sullivans island"
  },
  {
    "text": "Sully",
    "value": "sully"
  },
  {
    "text": "Sulphur",
    "value": "sulphur"
  },
  {
    "text": "Sulphur Bluff",
    "value": "sulphur bluff"
  },
  {
    "text": "Sulphur Rock",
    "value": "sulphur rock"
  },
  {
    "text": "Sulphur Springs",
    "value": "sulphur springs"
  },
  {
    "text": "Sultan",
    "value": "sultan"
  },
  {
    "text": "Sultana",
    "value": "sultana"
  },
  {
    "text": "Sumas",
    "value": "sumas"
  },
  {
    "text": "Sumerduck",
    "value": "sumerduck"
  },
  {
    "text": "Sumiton",
    "value": "sumiton"
  },
  {
    "text": "Summer Lake",
    "value": "summer lake"
  },
  {
    "text": "Summer Shade",
    "value": "summer shade"
  },
  {
    "text": "Summerdale",
    "value": "summerdale"
  },
  {
    "text": "Summerfield",
    "value": "summerfield"
  },
  {
    "text": "Summerhaven",
    "value": "summerhaven"
  },
  {
    "text": "Summerhill",
    "value": "summerhill"
  },
  {
    "text": "Summerland",
    "value": "summerland"
  },
  {
    "text": "Summerland Key",
    "value": "summerland key"
  },
  {
    "text": "Summers",
    "value": "summers"
  },
  {
    "text": "Summersville",
    "value": "summersville"
  },
  {
    "text": "Summerton",
    "value": "summerton"
  },
  {
    "text": "Summertown",
    "value": "summertown"
  },
  {
    "text": "Summerville",
    "value": "summerville"
  },
  {
    "text": "Summit",
    "value": "summit"
  },
  {
    "text": "Summit Argo",
    "value": "summit argo"
  },
  {
    "text": "Summit Hill",
    "value": "summit hill"
  },
  {
    "text": "Summit Lake",
    "value": "summit lake"
  },
  {
    "text": "Summit Point",
    "value": "summit point"
  },
  {
    "text": "Summit Station",
    "value": "summit station"
  },
  {
    "text": "Summitville",
    "value": "summitville"
  },
  {
    "text": "Sumner",
    "value": "sumner"
  },
  {
    "text": "Sumneytown",
    "value": "sumneytown"
  },
  {
    "text": "Sumpter",
    "value": "sumpter"
  },
  {
    "text": "Sumrall",
    "value": "sumrall"
  },
  {
    "text": "Sumter",
    "value": "sumter"
  },
  {
    "text": "Sumterville",
    "value": "sumterville"
  },
  {
    "text": "Sun",
    "value": "sun"
  },
  {
    "text": "Sun City",
    "value": "sun city"
  },
  {
    "text": "Sun City Center",
    "value": "sun city center"
  },
  {
    "text": "Sun City West",
    "value": "sun city west"
  },
  {
    "text": "Sun Lakes",
    "value": "sun lakes"
  },
  {
    "text": "Sun Prairie",
    "value": "sun prairie"
  },
  {
    "text": "Sun River",
    "value": "sun river"
  },
  {
    "text": "Sun Valley",
    "value": "sun valley"
  },
  {
    "text": "Sunapee",
    "value": "sunapee"
  },
  {
    "text": "Sunbright",
    "value": "sunbright"
  },
  {
    "text": "Sunburg",
    "value": "sunburg"
  },
  {
    "text": "Sunburst",
    "value": "sunburst"
  },
  {
    "text": "Sunbury",
    "value": "sunbury"
  },
  {
    "text": "Suncook",
    "value": "suncook"
  },
  {
    "text": "Sundance",
    "value": "sundance"
  },
  {
    "text": "Sunderland",
    "value": "sunderland"
  },
  {
    "text": "Sundown",
    "value": "sundown"
  },
  {
    "text": "Sunfield",
    "value": "sunfield"
  },
  {
    "text": "Sunflower",
    "value": "sunflower"
  },
  {
    "text": "Sunland",
    "value": "sunland"
  },
  {
    "text": "Sunland Park",
    "value": "sunland park"
  },
  {
    "text": "Sunman",
    "value": "sunman"
  },
  {
    "text": "Sunny Isles Beach",
    "value": "sunny isles beach"
  },
  {
    "text": "Sunnyside",
    "value": "sunnyside"
  },
  {
    "text": "Sunnyvale",
    "value": "sunnyvale"
  },
  {
    "text": "Sunol",
    "value": "sunol"
  },
  {
    "text": "Sunray",
    "value": "sunray"
  },
  {
    "text": "Sunrise",
    "value": "sunrise"
  },
  {
    "text": "Sunrise Beach",
    "value": "sunrise beach"
  },
  {
    "text": "Sunrise Manor",
    "value": "sunrise manor"
  },
  {
    "text": "Sunriver",
    "value": "sunriver"
  },
  {
    "text": "Sunset",
    "value": "sunset"
  },
  {
    "text": "Sunset Beach",
    "value": "sunset beach"
  },
  {
    "text": "Sunset Hills",
    "value": "sunset hills"
  },
  {
    "text": "Sunset Park",
    "value": "sunset park"
  },
  {
    "text": "Sunshine",
    "value": "sunshine"
  },
  {
    "text": "Sunspot",
    "value": "sunspot"
  },
  {
    "text": "Supai",
    "value": "supai"
  },
  {
    "text": "Superior",
    "value": "superior"
  },
  {
    "text": "Supply",
    "value": "supply"
  },
  {
    "text": "Supreme",
    "value": "supreme"
  },
  {
    "text": "Suquamish",
    "value": "suquamish"
  },
  {
    "text": "Surf City",
    "value": "surf city"
  },
  {
    "text": "Surfside",
    "value": "surfside"
  },
  {
    "text": "Surfside Beach",
    "value": "surfside beach"
  },
  {
    "text": "Surgoinsville",
    "value": "surgoinsville"
  },
  {
    "text": "Suring",
    "value": "suring"
  },
  {
    "text": "Surprise",
    "value": "surprise"
  },
  {
    "text": "Surrency",
    "value": "surrency"
  },
  {
    "text": "Surrey",
    "value": "surrey"
  },
  {
    "text": "Surry",
    "value": "surry"
  },
  {
    "text": "Surveyor",
    "value": "surveyor"
  },
  {
    "text": "Susan",
    "value": "susan"
  },
  {
    "text": "Susanville",
    "value": "susanville"
  },
  {
    "text": "Susquehanna",
    "value": "susquehanna"
  },
  {
    "text": "Sussex",
    "value": "sussex"
  },
  {
    "text": "Sutersville",
    "value": "sutersville"
  },
  {
    "text": "Sutherland",
    "value": "sutherland"
  },
  {
    "text": "Sutherland Springs",
    "value": "sutherland springs"
  },
  {
    "text": "Sutherlin",
    "value": "sutherlin"
  },
  {
    "text": "Sutter",
    "value": "sutter"
  },
  {
    "text": "Sutter Creek",
    "value": "sutter creek"
  },
  {
    "text": "Sutton",
    "value": "sutton"
  },
  {
    "text": "Sutton-Alpine",
    "value": "sutton-alpine"
  },
  {
    "text": "Suttons Bay",
    "value": "suttons bay"
  },
  {
    "text": "Suwanee",
    "value": "suwanee"
  },
  {
    "text": "Suwannee",
    "value": "suwannee"
  },
  {
    "text": "Swain",
    "value": "swain"
  },
  {
    "text": "Swainsboro",
    "value": "swainsboro"
  },
  {
    "text": "Swampscott",
    "value": "swampscott"
  },
  {
    "text": "Swan",
    "value": "swan"
  },
  {
    "text": "Swan Lake",
    "value": "swan lake"
  },
  {
    "text": "Swan Point",
    "value": "swan point"
  },
  {
    "text": "Swan Valley",
    "value": "swan valley"
  },
  {
    "text": "Swannanoa",
    "value": "swannanoa"
  },
  {
    "text": "Swanquarter",
    "value": "swanquarter"
  },
  {
    "text": "Swans Island",
    "value": "swans island"
  },
  {
    "text": "Swansboro",
    "value": "swansboro"
  },
  {
    "text": "Swansea",
    "value": "swansea"
  },
  {
    "text": "Swanton",
    "value": "swanton"
  },
  {
    "text": "Swanville",
    "value": "swanville"
  },
  {
    "text": "Swanzey",
    "value": "swanzey"
  },
  {
    "text": "Swarthmore",
    "value": "swarthmore"
  },
  {
    "text": "Swartz Creek",
    "value": "swartz creek"
  },
  {
    "text": "Swatara",
    "value": "swatara"
  },
  {
    "text": "Swayzee",
    "value": "swayzee"
  },
  {
    "text": "Swea City",
    "value": "swea city"
  },
  {
    "text": "Swedesboro",
    "value": "swedesboro"
  },
  {
    "text": "Sweeden",
    "value": "sweeden"
  },
  {
    "text": "Sweeny",
    "value": "sweeny"
  },
  {
    "text": "Sweet",
    "value": "sweet"
  },
  {
    "text": "Sweet Briar",
    "value": "sweet briar"
  },
  {
    "text": "Sweet Briar Station",
    "value": "sweet briar station"
  },
  {
    "text": "Sweet Grass",
    "value": "sweet grass"
  },
  {
    "text": "Sweet Home",
    "value": "sweet home"
  },
  {
    "text": "Sweet Springs",
    "value": "sweet springs"
  },
  {
    "text": "Sweet Valley",
    "value": "sweet valley"
  },
  {
    "text": "Sweet Water",
    "value": "sweet water"
  },
  {
    "text": "Sweetser",
    "value": "sweetser"
  },
  {
    "text": "Sweetwater",
    "value": "sweetwater"
  },
  {
    "text": "Swepsonville",
    "value": "swepsonville"
  },
  {
    "text": "Swift",
    "value": "swift"
  },
  {
    "text": "Swifton",
    "value": "swifton"
  },
  {
    "text": "Swiftwater",
    "value": "swiftwater"
  },
  {
    "text": "Swink",
    "value": "swink"
  },
  {
    "text": "Swisher",
    "value": "swisher"
  },
  {
    "text": "Swiss",
    "value": "swiss"
  },
  {
    "text": "Swisshome",
    "value": "swisshome"
  },
  {
    "text": "Swissvale",
    "value": "swissvale"
  },
  {
    "text": "Switchback",
    "value": "switchback"
  },
  {
    "text": "Switz City",
    "value": "switz city"
  },
  {
    "text": "Swoope",
    "value": "swoope"
  },
  {
    "text": "Swords Creek",
    "value": "swords creek"
  },
  {
    "text": "Swoyersville",
    "value": "swoyersville"
  },
  {
    "text": "Sycamore",
    "value": "sycamore"
  },
  {
    "text": "Sydney",
    "value": "sydney"
  },
  {
    "text": "Sykeston",
    "value": "sykeston"
  },
  {
    "text": "Sykesville",
    "value": "sykesville"
  },
  {
    "text": "Sylacauga",
    "value": "sylacauga"
  },
  {
    "text": "Sylmar",
    "value": "sylmar"
  },
  {
    "text": "Sylva",
    "value": "sylva"
  },
  {
    "text": "Sylvan Beach",
    "value": "sylvan beach"
  },
  {
    "text": "Sylvan Grove",
    "value": "sylvan grove"
  },
  {
    "text": "Sylvan Lake",
    "value": "sylvan lake"
  },
  {
    "text": "Sylvan Springs",
    "value": "sylvan springs"
  },
  {
    "text": "Sylvania",
    "value": "sylvania"
  },
  {
    "text": "Sylvester",
    "value": "sylvester"
  },
  {
    "text": "Sylvia",
    "value": "sylvia"
  },
  {
    "text": "Symsonia",
    "value": "symsonia"
  },
  {
    "text": "Syosset",
    "value": "syosset"
  },
  {
    "text": "Syracuse",
    "value": "syracuse"
  },
  {
    "text": "Syria",
    "value": "syria"
  },
  {
    "text": "Taberg",
    "value": "taberg"
  },
  {
    "text": "Tabernash",
    "value": "tabernash"
  },
  {
    "text": "Tabiona",
    "value": "tabiona"
  },
  {
    "text": "Table Grove",
    "value": "table grove"
  },
  {
    "text": "Table Rock",
    "value": "table rock"
  },
  {
    "text": "Tabor",
    "value": "tabor"
  },
  {
    "text": "Tabor City",
    "value": "tabor city"
  },
  {
    "text": "Tacna",
    "value": "tacna"
  },
  {
    "text": "Tacoma",
    "value": "tacoma"
  },
  {
    "text": "Taconic",
    "value": "taconic"
  },
  {
    "text": "Taft",
    "value": "taft"
  },
  {
    "text": "Tafton",
    "value": "tafton"
  },
  {
    "text": "Taftville",
    "value": "taftville"
  },
  {
    "text": "Tahlequah",
    "value": "tahlequah"
  },
  {
    "text": "Tahoe City",
    "value": "tahoe city"
  },
  {
    "text": "Tahoe Vista",
    "value": "tahoe vista"
  },
  {
    "text": "Tahoka",
    "value": "tahoka"
  },
  {
    "text": "Taholah",
    "value": "taholah"
  },
  {
    "text": "Tahoma",
    "value": "tahoma"
  },
  {
    "text": "Tahuya",
    "value": "tahuya"
  },
  {
    "text": "Taiban",
    "value": "taiban"
  },
  {
    "text": "Takoma Park",
    "value": "takoma park"
  },
  {
    "text": "Talala",
    "value": "talala"
  },
  {
    "text": "Talbott",
    "value": "talbott"
  },
  {
    "text": "Talbotton",
    "value": "talbotton"
  },
  {
    "text": "Talco",
    "value": "talco"
  },
  {
    "text": "Talcott",
    "value": "talcott"
  },
  {
    "text": "Talent",
    "value": "talent"
  },
  {
    "text": "Talihina",
    "value": "talihina"
  },
  {
    "text": "Talkeetna",
    "value": "talkeetna"
  },
  {
    "text": "Talking Rock",
    "value": "talking rock"
  },
  {
    "text": "Tall Timbers",
    "value": "tall timbers"
  },
  {
    "text": "Talladega",
    "value": "talladega"
  },
  {
    "text": "Tallahassee",
    "value": "tallahassee"
  },
  {
    "text": "Tallapoosa",
    "value": "tallapoosa"
  },
  {
    "text": "Tallassee",
    "value": "tallassee"
  },
  {
    "text": "Tallevast",
    "value": "tallevast"
  },
  {
    "text": "Tallmadge",
    "value": "tallmadge"
  },
  {
    "text": "Tallman",
    "value": "tallman"
  },
  {
    "text": "Tallmansville",
    "value": "tallmansville"
  },
  {
    "text": "Tallula",
    "value": "tallula"
  },
  {
    "text": "Tallulah",
    "value": "tallulah"
  },
  {
    "text": "Tallulah Falls",
    "value": "tallulah falls"
  },
  {
    "text": "Talmage",
    "value": "talmage"
  },
  {
    "text": "Talmo",
    "value": "talmo"
  },
  {
    "text": "Talmoon",
    "value": "talmoon"
  },
  {
    "text": "Taloga",
    "value": "taloga"
  },
  {
    "text": "Talpa",
    "value": "talpa"
  },
  {
    "text": "Talty",
    "value": "talty"
  },
  {
    "text": "Tama",
    "value": "tama"
  },
  {
    "text": "Tamaqua",
    "value": "tamaqua"
  },
  {
    "text": "Tamarac",
    "value": "tamarac"
  },
  {
    "text": "Tamarack",
    "value": "tamarack"
  },
  {
    "text": "Tamaroa",
    "value": "tamaroa"
  },
  {
    "text": "Tamassee",
    "value": "tamassee"
  },
  {
    "text": "Tamiami",
    "value": "tamiami"
  },
  {
    "text": "Tamiment",
    "value": "tamiment"
  },
  {
    "text": "Tamms",
    "value": "tamms"
  },
  {
    "text": "Tampa",
    "value": "tampa"
  },
  {
    "text": "Tampico",
    "value": "tampico"
  },
  {
    "text": "Tamworth",
    "value": "tamworth"
  },
  {
    "text": "Tanaina",
    "value": "tanaina"
  },
  {
    "text": "Tanana",
    "value": "tanana"
  },
  {
    "text": "Taneytown",
    "value": "taneytown"
  },
  {
    "text": "Taneyville",
    "value": "taneyville"
  },
  {
    "text": "Tangent",
    "value": "tangent"
  },
  {
    "text": "Tangerine",
    "value": "tangerine"
  },
  {
    "text": "Tangier",
    "value": "tangier"
  },
  {
    "text": "Tanner",
    "value": "tanner"
  },
  {
    "text": "Tannersville",
    "value": "tannersville"
  },
  {
    "text": "Tannery",
    "value": "tannery"
  },
  {
    "text": "Taos",
    "value": "taos"
  },
  {
    "text": "Taos Pueblo",
    "value": "taos pueblo"
  },
  {
    "text": "Taos Ski Valley",
    "value": "taos ski valley"
  },
  {
    "text": "Tappahannock",
    "value": "tappahannock"
  },
  {
    "text": "Tappan",
    "value": "tappan"
  },
  {
    "text": "Tappen",
    "value": "tappen"
  },
  {
    "text": "Tar Heel",
    "value": "tar heel"
  },
  {
    "text": "Tarboro",
    "value": "tarboro"
  },
  {
    "text": "Tarentum",
    "value": "tarentum"
  },
  {
    "text": "Tariffville",
    "value": "tariffville"
  },
  {
    "text": "Tarkio",
    "value": "tarkio"
  },
  {
    "text": "Tarlton",
    "value": "tarlton"
  },
  {
    "text": "Tarpley",
    "value": "tarpley"
  },
  {
    "text": "Tarpon Springs",
    "value": "tarpon springs"
  },
  {
    "text": "Tarrant",
    "value": "tarrant"
  },
  {
    "text": "Tarrs",
    "value": "tarrs"
  },
  {
    "text": "Tarrytown",
    "value": "tarrytown"
  },
  {
    "text": "Tarzan",
    "value": "tarzan"
  },
  {
    "text": "Tarzana",
    "value": "tarzana"
  },
  {
    "text": "Tasley",
    "value": "tasley"
  },
  {
    "text": "Taswell",
    "value": "taswell"
  },
  {
    "text": "Tate",
    "value": "tate"
  },
  {
    "text": "Tateville",
    "value": "tateville"
  },
  {
    "text": "Tatitlek",
    "value": "tatitlek"
  },
  {
    "text": "Tatum",
    "value": "tatum"
  },
  {
    "text": "Tatums",
    "value": "tatums"
  },
  {
    "text": "Taunton",
    "value": "taunton"
  },
  {
    "text": "Tavares",
    "value": "tavares"
  },
  {
    "text": "Tavernier",
    "value": "tavernier"
  },
  {
    "text": "Tawas City",
    "value": "tawas city"
  },
  {
    "text": "Taylor",
    "value": "taylor"
  },
  {
    "text": "Taylor Lake Village",
    "value": "taylor lake village"
  },
  {
    "text": "Taylor Mill",
    "value": "taylor mill"
  },
  {
    "text": "Taylor Ridge",
    "value": "taylor ridge"
  },
  {
    "text": "Taylor Springs",
    "value": "taylor springs"
  },
  {
    "text": "Taylors",
    "value": "taylors"
  },
  {
    "text": "Taylors Falls",
    "value": "taylors falls"
  },
  {
    "text": "Taylorsville",
    "value": "taylorsville"
  },
  {
    "text": "Taylorville",
    "value": "taylorville"
  },
  {
    "text": "Tazewell",
    "value": "tazewell"
  },
  {
    "text": "Tchula",
    "value": "tchula"
  },
  {
    "text": "Tea",
    "value": "tea"
  },
  {
    "text": "Teaberry",
    "value": "teaberry"
  },
  {
    "text": "Teachey",
    "value": "teachey"
  },
  {
    "text": "Teague",
    "value": "teague"
  },
  {
    "text": "Teaneck",
    "value": "teaneck"
  },
  {
    "text": "Teasdale",
    "value": "teasdale"
  },
  {
    "text": "Teaticket",
    "value": "teaticket"
  },
  {
    "text": "Teays Valley",
    "value": "teays valley"
  },
  {
    "text": "Tebbetts",
    "value": "tebbetts"
  },
  {
    "text": "Tecate",
    "value": "tecate"
  },
  {
    "text": "Tecopa",
    "value": "tecopa"
  },
  {
    "text": "Tecumseh",
    "value": "tecumseh"
  },
  {
    "text": "Teec Nos Pos",
    "value": "teec nos pos"
  },
  {
    "text": "Tega Cay",
    "value": "tega cay"
  },
  {
    "text": "Tehachapi",
    "value": "tehachapi"
  },
  {
    "text": "Tehama",
    "value": "tehama"
  },
  {
    "text": "Tehuacana",
    "value": "tehuacana"
  },
  {
    "text": "Tekamah",
    "value": "tekamah"
  },
  {
    "text": "Tekoa",
    "value": "tekoa"
  },
  {
    "text": "Tekonsha",
    "value": "tekonsha"
  },
  {
    "text": "Telephone",
    "value": "telephone"
  },
  {
    "text": "Telferner",
    "value": "telferner"
  },
  {
    "text": "Telford",
    "value": "telford"
  },
  {
    "text": "Tell City",
    "value": "tell city"
  },
  {
    "text": "Tellico Plains",
    "value": "tellico plains"
  },
  {
    "text": "Telluride",
    "value": "telluride"
  },
  {
    "text": "Temecula",
    "value": "temecula"
  },
  {
    "text": "Tempe",
    "value": "tempe"
  },
  {
    "text": "Tempe Junction",
    "value": "tempe junction"
  },
  {
    "text": "Temperance",
    "value": "temperance"
  },
  {
    "text": "Temperanceville",
    "value": "temperanceville"
  },
  {
    "text": "Temple",
    "value": "temple"
  },
  {
    "text": "Temple City",
    "value": "temple city"
  },
  {
    "text": "Temple Hills",
    "value": "temple hills"
  },
  {
    "text": "Temple Terrace",
    "value": "temple terrace"
  },
  {
    "text": "Templeton",
    "value": "templeton"
  },
  {
    "text": "Templeville",
    "value": "templeville"
  },
  {
    "text": "Ten Mile",
    "value": "ten mile"
  },
  {
    "text": "Ten Sleep",
    "value": "ten sleep"
  },
  {
    "text": "Tenafly",
    "value": "tenafly"
  },
  {
    "text": "Tenaha",
    "value": "tenaha"
  },
  {
    "text": "Tenants Harbor",
    "value": "tenants harbor"
  },
  {
    "text": "Tendoy",
    "value": "tendoy"
  },
  {
    "text": "Tenino",
    "value": "tenino"
  },
  {
    "text": "Tennent",
    "value": "tennent"
  },
  {
    "text": "Tennessee Colony",
    "value": "tennessee colony"
  },
  {
    "text": "Tennessee Ridge",
    "value": "tennessee ridge"
  },
  {
    "text": "Tennille",
    "value": "tennille"
  },
  {
    "text": "Tennyson",
    "value": "tennyson"
  },
  {
    "text": "Tensed",
    "value": "tensed"
  },
  {
    "text": "Tenstrike",
    "value": "tenstrike"
  },
  {
    "text": "Tequesta",
    "value": "tequesta"
  },
  {
    "text": "Terlingua",
    "value": "terlingua"
  },
  {
    "text": "Terlton",
    "value": "terlton"
  },
  {
    "text": "Terra Alta",
    "value": "terra alta"
  },
  {
    "text": "Terra Bella",
    "value": "terra bella"
  },
  {
    "text": "Terra Ceia",
    "value": "terra ceia"
  },
  {
    "text": "Terrace Park",
    "value": "terrace park"
  },
  {
    "text": "Terral",
    "value": "terral"
  },
  {
    "text": "Terre Haute",
    "value": "terre haute"
  },
  {
    "text": "Terre Hill",
    "value": "terre hill"
  },
  {
    "text": "Terrebonne",
    "value": "terrebonne"
  },
  {
    "text": "Terrell",
    "value": "terrell"
  },
  {
    "text": "Terrell Hills",
    "value": "terrell hills"
  },
  {
    "text": "Terreton",
    "value": "terreton"
  },
  {
    "text": "Terril",
    "value": "terril"
  },
  {
    "text": "Terry",
    "value": "terry"
  },
  {
    "text": "Terrytown",
    "value": "terrytown"
  },
  {
    "text": "Terryville",
    "value": "terryville"
  },
  {
    "text": "Tescott",
    "value": "tescott"
  },
  {
    "text": "Tesuque",
    "value": "tesuque"
  },
  {
    "text": "Teterboro",
    "value": "teterboro"
  },
  {
    "text": "Teton",
    "value": "teton"
  },
  {
    "text": "Teton Village",
    "value": "teton village"
  },
  {
    "text": "Tetonia",
    "value": "tetonia"
  },
  {
    "text": "Teutopolis",
    "value": "teutopolis"
  },
  {
    "text": "Teviston",
    "value": "teviston"
  },
  {
    "text": "Tewksbury",
    "value": "tewksbury"
  },
  {
    "text": "Texarkana",
    "value": "texarkana"
  },
  {
    "text": "Texas City",
    "value": "texas city"
  },
  {
    "text": "Texhoma",
    "value": "texhoma"
  },
  {
    "text": "Texico",
    "value": "texico"
  },
  {
    "text": "Texline",
    "value": "texline"
  },
  {
    "text": "Thackerville",
    "value": "thackerville"
  },
  {
    "text": "Thatcher",
    "value": "thatcher"
  },
  {
    "text": "Thawville",
    "value": "thawville"
  },
  {
    "text": "Thaxton",
    "value": "thaxton"
  },
  {
    "text": "Thayer",
    "value": "thayer"
  },
  {
    "text": "Thayne",
    "value": "thayne"
  },
  {
    "text": "The Bronx",
    "value": "the bronx"
  },
  {
    "text": "The Colony",
    "value": "the colony"
  },
  {
    "text": "The Dalles",
    "value": "the dalles"
  },
  {
    "text": "The Hammocks",
    "value": "the hammocks"
  },
  {
    "text": "The Hills",
    "value": "the hills"
  },
  {
    "text": "The Lakes",
    "value": "the lakes"
  },
  {
    "text": "The Plains",
    "value": "the plains"
  },
  {
    "text": "The Rock",
    "value": "the rock"
  },
  {
    "text": "The Sea Ranch",
    "value": "the sea ranch"
  },
  {
    "text": "The Village",
    "value": "the village"
  },
  {
    "text": "The Villages",
    "value": "the villages"
  },
  {
    "text": "The Woodlands",
    "value": "the woodlands"
  },
  {
    "text": "Thebes",
    "value": "thebes"
  },
  {
    "text": "Thedford",
    "value": "thedford"
  },
  {
    "text": "Thendara",
    "value": "thendara"
  },
  {
    "text": "Theodore",
    "value": "theodore"
  },
  {
    "text": "Theodosia",
    "value": "theodosia"
  },
  {
    "text": "Theresa",
    "value": "theresa"
  },
  {
    "text": "Theriot",
    "value": "theriot"
  },
  {
    "text": "Thermal",
    "value": "thermal"
  },
  {
    "text": "Thermopolis",
    "value": "thermopolis"
  },
  {
    "text": "Thetford",
    "value": "thetford"
  },
  {
    "text": "Thetford Center",
    "value": "thetford center"
  },
  {
    "text": "Thibodaux",
    "value": "thibodaux"
  },
  {
    "text": "Thicket",
    "value": "thicket"
  },
  {
    "text": "Thief River Falls",
    "value": "thief river falls"
  },
  {
    "text": "Thiells",
    "value": "thiells"
  },
  {
    "text": "Thiensville",
    "value": "thiensville"
  },
  {
    "text": "Third Lake",
    "value": "third lake"
  },
  {
    "text": "Thomas",
    "value": "thomas"
  },
  {
    "text": "Thomasboro",
    "value": "thomasboro"
  },
  {
    "text": "Thomaston",
    "value": "thomaston"
  },
  {
    "text": "Thomasville",
    "value": "thomasville"
  },
  {
    "text": "Thompson",
    "value": "thompson"
  },
  {
    "text": "Thompson Falls",
    "value": "thompson falls"
  },
  {
    "text": "Thompson's Station",
    "value": "thompson's station"
  },
  {
    "text": "Thompsons",
    "value": "thompsons"
  },
  {
    "text": "Thompsontown",
    "value": "thompsontown"
  },
  {
    "text": "Thompsonville",
    "value": "thompsonville"
  },
  {
    "text": "Thomson",
    "value": "thomson"
  },
  {
    "text": "Thonotosassa",
    "value": "thonotosassa"
  },
  {
    "text": "Thor",
    "value": "thor"
  },
  {
    "text": "Thoreau",
    "value": "thoreau"
  },
  {
    "text": "Thorn Hill",
    "value": "thorn hill"
  },
  {
    "text": "Thornburg",
    "value": "thornburg"
  },
  {
    "text": "Thorndale",
    "value": "thorndale"
  },
  {
    "text": "Thorndike",
    "value": "thorndike"
  },
  {
    "text": "Thorne Bay",
    "value": "thorne bay"
  },
  {
    "text": "Thornton",
    "value": "thornton"
  },
  {
    "text": "Thorntown",
    "value": "thorntown"
  },
  {
    "text": "Thornville",
    "value": "thornville"
  },
  {
    "text": "Thornwood",
    "value": "thornwood"
  },
  {
    "text": "Thorofare",
    "value": "thorofare"
  },
  {
    "text": "Thorp",
    "value": "thorp"
  },
  {
    "text": "Thorsby",
    "value": "thorsby"
  },
  {
    "text": "Thousand Oaks",
    "value": "thousand oaks"
  },
  {
    "text": "Thousand Palms",
    "value": "thousand palms"
  },
  {
    "text": "Thousandsticks",
    "value": "thousandsticks"
  },
  {
    "text": "Thrall",
    "value": "thrall"
  },
  {
    "text": "Three Bridges",
    "value": "three bridges"
  },
  {
    "text": "Three Forks",
    "value": "three forks"
  },
  {
    "text": "Three Lakes",
    "value": "three lakes"
  },
  {
    "text": "Three Mile Bay",
    "value": "three mile bay"
  },
  {
    "text": "Three Oaks",
    "value": "three oaks"
  },
  {
    "text": "Three Rivers",
    "value": "three rivers"
  },
  {
    "text": "Three Springs",
    "value": "three springs"
  },
  {
    "text": "Throckmorton",
    "value": "throckmorton"
  },
  {
    "text": "Throop",
    "value": "throop"
  },
  {
    "text": "Thunderbolt",
    "value": "thunderbolt"
  },
  {
    "text": "Thurman",
    "value": "thurman"
  },
  {
    "text": "Thurmond",
    "value": "thurmond"
  },
  {
    "text": "Thurmont",
    "value": "thurmont"
  },
  {
    "text": "Thurston",
    "value": "thurston"
  },
  {
    "text": "Tiburon",
    "value": "tiburon"
  },
  {
    "text": "Tice",
    "value": "tice"
  },
  {
    "text": "Tichnor",
    "value": "tichnor"
  },
  {
    "text": "Tickfaw",
    "value": "tickfaw"
  },
  {
    "text": "Ticonderoga",
    "value": "ticonderoga"
  },
  {
    "text": "Tidewater",
    "value": "tidewater"
  },
  {
    "text": "Tidioute",
    "value": "tidioute"
  },
  {
    "text": "Tierra Amarilla",
    "value": "tierra amarilla"
  },
  {
    "text": "Tierra Verde",
    "value": "tierra verde"
  },
  {
    "text": "Tieton",
    "value": "tieton"
  },
  {
    "text": "Tiff",
    "value": "tiff"
  },
  {
    "text": "Tiffin",
    "value": "tiffin"
  },
  {
    "text": "Tifton",
    "value": "tifton"
  },
  {
    "text": "Tigard",
    "value": "tigard"
  },
  {
    "text": "Tiger",
    "value": "tiger"
  },
  {
    "text": "Tigerton",
    "value": "tigerton"
  },
  {
    "text": "Tigerville",
    "value": "tigerville"
  },
  {
    "text": "Tignall",
    "value": "tignall"
  },
  {
    "text": "Tijeras",
    "value": "tijeras"
  },
  {
    "text": "Tilden",
    "value": "tilden"
  },
  {
    "text": "Tilghman",
    "value": "tilghman"
  },
  {
    "text": "Tillamook",
    "value": "tillamook"
  },
  {
    "text": "Tillar",
    "value": "tillar"
  },
  {
    "text": "Tillatoba",
    "value": "tillatoba"
  },
  {
    "text": "Tiller",
    "value": "tiller"
  },
  {
    "text": "Tillman",
    "value": "tillman"
  },
  {
    "text": "Tillson",
    "value": "tillson"
  },
  {
    "text": "Tilton",
    "value": "tilton"
  },
  {
    "text": "Tiltonsville",
    "value": "tiltonsville"
  },
  {
    "text": "Timber",
    "value": "timber"
  },
  {
    "text": "Timber Lake",
    "value": "timber lake"
  },
  {
    "text": "Timberlake",
    "value": "timberlake"
  },
  {
    "text": "Timberon",
    "value": "timberon"
  },
  {
    "text": "Timberville",
    "value": "timberville"
  },
  {
    "text": "Timberwood Park",
    "value": "timberwood park"
  },
  {
    "text": "Timblin",
    "value": "timblin"
  },
  {
    "text": "Timbo",
    "value": "timbo"
  },
  {
    "text": "Timewell",
    "value": "timewell"
  },
  {
    "text": "Timmonsville",
    "value": "timmonsville"
  },
  {
    "text": "Timnath",
    "value": "timnath"
  },
  {
    "text": "Timonium",
    "value": "timonium"
  },
  {
    "text": "Timpson",
    "value": "timpson"
  },
  {
    "text": "Tina",
    "value": "tina"
  },
  {
    "text": "Tingley",
    "value": "tingley"
  },
  {
    "text": "Tinicum",
    "value": "tinicum"
  },
  {
    "text": "Tinley Park",
    "value": "tinley park"
  },
  {
    "text": "Tinnie",
    "value": "tinnie"
  },
  {
    "text": "Tintah",
    "value": "tintah"
  },
  {
    "text": "Tinton Falls",
    "value": "tinton falls"
  },
  {
    "text": "Tioga",
    "value": "tioga"
  },
  {
    "text": "Tioga Center",
    "value": "tioga center"
  },
  {
    "text": "Tiona",
    "value": "tiona"
  },
  {
    "text": "Tionesta",
    "value": "tionesta"
  },
  {
    "text": "Tiplersville",
    "value": "tiplersville"
  },
  {
    "text": "Tipp City",
    "value": "tipp city"
  },
  {
    "text": "Tippecanoe",
    "value": "tippecanoe"
  },
  {
    "text": "Tipton",
    "value": "tipton"
  },
  {
    "text": "Tiptonville",
    "value": "tiptonville"
  },
  {
    "text": "Tiro",
    "value": "tiro"
  },
  {
    "text": "Tisch Mills",
    "value": "tisch mills"
  },
  {
    "text": "Tishomingo",
    "value": "tishomingo"
  },
  {
    "text": "Tiskilwa",
    "value": "tiskilwa"
  },
  {
    "text": "Titonka",
    "value": "titonka"
  },
  {
    "text": "Titus",
    "value": "titus"
  },
  {
    "text": "Titusville",
    "value": "titusville"
  },
  {
    "text": "Tiverton",
    "value": "tiverton"
  },
  {
    "text": "Tivoli",
    "value": "tivoli"
  },
  {
    "text": "Toano",
    "value": "toano"
  },
  {
    "text": "Toast",
    "value": "toast"
  },
  {
    "text": "Tobaccoville",
    "value": "tobaccoville"
  },
  {
    "text": "Tobias",
    "value": "tobias"
  },
  {
    "text": "Tobyhanna",
    "value": "tobyhanna"
  },
  {
    "text": "Toccoa",
    "value": "toccoa"
  },
  {
    "text": "Toccoa Falls",
    "value": "toccoa falls"
  },
  {
    "text": "Todd",
    "value": "todd"
  },
  {
    "text": "Toddville",
    "value": "toddville"
  },
  {
    "text": "Toeterville",
    "value": "toeterville"
  },
  {
    "text": "Tofte",
    "value": "tofte"
  },
  {
    "text": "Tohatchi",
    "value": "tohatchi"
  },
  {
    "text": "Toivola",
    "value": "toivola"
  },
  {
    "text": "Tok",
    "value": "tok"
  },
  {
    "text": "Tokeland",
    "value": "tokeland"
  },
  {
    "text": "Tokio",
    "value": "tokio"
  },
  {
    "text": "Toklat",
    "value": "toklat"
  },
  {
    "text": "Toksook Bay",
    "value": "toksook bay"
  },
  {
    "text": "Tolar",
    "value": "tolar"
  },
  {
    "text": "Toledo",
    "value": "toledo"
  },
  {
    "text": "Tolland",
    "value": "tolland"
  },
  {
    "text": "Tollesboro",
    "value": "tollesboro"
  },
  {
    "text": "Tolleson",
    "value": "tolleson"
  },
  {
    "text": "Tolley",
    "value": "tolley"
  },
  {
    "text": "Tollhouse",
    "value": "tollhouse"
  },
  {
    "text": "Tolna",
    "value": "tolna"
  },
  {
    "text": "Tolono",
    "value": "tolono"
  },
  {
    "text": "Tolovana Park",
    "value": "tolovana park"
  },
  {
    "text": "Toluca",
    "value": "toluca"
  },
  {
    "text": "Toluca Lake",
    "value": "toluca lake"
  },
  {
    "text": "Tom Bean",
    "value": "tom bean"
  },
  {
    "text": "Tomah",
    "value": "tomah"
  },
  {
    "text": "Tomahawk",
    "value": "tomahawk"
  },
  {
    "text": "Tomball",
    "value": "tomball"
  },
  {
    "text": "Tombstone",
    "value": "tombstone"
  },
  {
    "text": "Tome",
    "value": "tome"
  },
  {
    "text": "Tomkins Cove",
    "value": "tomkins cove"
  },
  {
    "text": "Tompkinsville",
    "value": "tompkinsville"
  },
  {
    "text": "Toms Brook",
    "value": "toms brook"
  },
  {
    "text": "Toms River",
    "value": "toms river"
  },
  {
    "text": "Tonalea",
    "value": "tonalea"
  },
  {
    "text": "Tonasket",
    "value": "tonasket"
  },
  {
    "text": "Tonawanda",
    "value": "tonawanda"
  },
  {
    "text": "Toney",
    "value": "toney"
  },
  {
    "text": "Tonganoxie",
    "value": "tonganoxie"
  },
  {
    "text": "Tonica",
    "value": "tonica"
  },
  {
    "text": "Tonkawa",
    "value": "tonkawa"
  },
  {
    "text": "Tonopah",
    "value": "tonopah"
  },
  {
    "text": "Tontitown",
    "value": "tontitown"
  },
  {
    "text": "Tonto Basin",
    "value": "tonto basin"
  },
  {
    "text": "Tontogany",
    "value": "tontogany"
  },
  {
    "text": "Tony",
    "value": "tony"
  },
  {
    "text": "Tooele",
    "value": "tooele"
  },
  {
    "text": "Tool",
    "value": "tool"
  },
  {
    "text": "Toomsboro",
    "value": "toomsboro"
  },
  {
    "text": "Toomsuba",
    "value": "toomsuba"
  },
  {
    "text": "Toone",
    "value": "toone"
  },
  {
    "text": "Topanga",
    "value": "topanga"
  },
  {
    "text": "Topeka",
    "value": "topeka"
  },
  {
    "text": "Topinabee",
    "value": "topinabee"
  },
  {
    "text": "Topmost",
    "value": "topmost"
  },
  {
    "text": "Topock",
    "value": "topock"
  },
  {
    "text": "Toppenish",
    "value": "toppenish"
  },
  {
    "text": "Topping",
    "value": "topping"
  },
  {
    "text": "Topsfield",
    "value": "topsfield"
  },
  {
    "text": "Topsham",
    "value": "topsham"
  },
  {
    "text": "Topton",
    "value": "topton"
  },
  {
    "text": "Toquerville",
    "value": "toquerville"
  },
  {
    "text": "Tornado",
    "value": "tornado"
  },
  {
    "text": "Tornillo",
    "value": "tornillo"
  },
  {
    "text": "Toronto",
    "value": "toronto"
  },
  {
    "text": "Torrance",
    "value": "torrance"
  },
  {
    "text": "Torreon",
    "value": "torreon"
  },
  {
    "text": "Torresdale",
    "value": "torresdale"
  },
  {
    "text": "Torrey",
    "value": "torrey"
  },
  {
    "text": "Torrington",
    "value": "torrington"
  },
  {
    "text": "Toston",
    "value": "toston"
  },
  {
    "text": "Totowa",
    "value": "totowa"
  },
  {
    "text": "Totz",
    "value": "totz"
  },
  {
    "text": "Touchet",
    "value": "touchet"
  },
  {
    "text": "Tougaloo",
    "value": "tougaloo"
  },
  {
    "text": "Toughkenamon",
    "value": "toughkenamon"
  },
  {
    "text": "Toulon",
    "value": "toulon"
  },
  {
    "text": "Toutle",
    "value": "toutle"
  },
  {
    "text": "Tovey",
    "value": "tovey"
  },
  {
    "text": "Tow",
    "value": "tow"
  },
  {
    "text": "Towaco",
    "value": "towaco"
  },
  {
    "text": "Towanda",
    "value": "towanda"
  },
  {
    "text": "Towaoc",
    "value": "towaoc"
  },
  {
    "text": "Tower",
    "value": "tower"
  },
  {
    "text": "Tower City",
    "value": "tower city"
  },
  {
    "text": "Tower Hill",
    "value": "tower hill"
  },
  {
    "text": "Town 'n' Country",
    "value": "town 'n' country"
  },
  {
    "text": "Town Creek",
    "value": "town creek"
  },
  {
    "text": "Town and Country",
    "value": "town and country"
  },
  {
    "text": "Town of Holland",
    "value": "town of holland"
  },
  {
    "text": "Towner",
    "value": "towner"
  },
  {
    "text": "Townley",
    "value": "townley"
  },
  {
    "text": "Townsend",
    "value": "townsend"
  },
  {
    "text": "Townshend",
    "value": "townshend"
  },
  {
    "text": "Township Of Washington",
    "value": "township of washington"
  },
  {
    "text": "Township of Bernards",
    "value": "township of bernards"
  },
  {
    "text": "Township of Plain",
    "value": "township of plain"
  },
  {
    "text": "Township of Sugarloaf",
    "value": "township of sugarloaf"
  },
  {
    "text": "Townsville",
    "value": "townsville"
  },
  {
    "text": "Townville",
    "value": "townville"
  },
  {
    "text": "Towson",
    "value": "towson"
  },
  {
    "text": "Toxey",
    "value": "toxey"
  },
  {
    "text": "Toyah",
    "value": "toyah"
  },
  {
    "text": "Toyon",
    "value": "toyon"
  },
  {
    "text": "Trabuco Canyon",
    "value": "trabuco canyon"
  },
  {
    "text": "Tracy",
    "value": "tracy"
  },
  {
    "text": "Tracy City",
    "value": "tracy city"
  },
  {
    "text": "Tracys Landing",
    "value": "tracys landing"
  },
  {
    "text": "Trade",
    "value": "trade"
  },
  {
    "text": "Traer",
    "value": "traer"
  },
  {
    "text": "Trafalgar",
    "value": "trafalgar"
  },
  {
    "text": "Trafford",
    "value": "trafford"
  },
  {
    "text": "Trail",
    "value": "trail"
  },
  {
    "text": "Trail City",
    "value": "trail city"
  },
  {
    "text": "Trail Creek",
    "value": "trail creek"
  },
  {
    "text": "Trainer",
    "value": "trainer"
  },
  {
    "text": "Tram",
    "value": "tram"
  },
  {
    "text": "Tranquillity",
    "value": "tranquillity"
  },
  {
    "text": "Transfer",
    "value": "transfer"
  },
  {
    "text": "Transylvania",
    "value": "transylvania"
  },
  {
    "text": "Traphill",
    "value": "traphill"
  },
  {
    "text": "Trappe",
    "value": "trappe"
  },
  {
    "text": "Trapper Creek",
    "value": "trapper creek"
  },
  {
    "text": "Traskwood",
    "value": "traskwood"
  },
  {
    "text": "Travelers Rest",
    "value": "travelers rest"
  },
  {
    "text": "Traver",
    "value": "traver"
  },
  {
    "text": "Traverse City",
    "value": "traverse city"
  },
  {
    "text": "Travis AFB",
    "value": "travis afb"
  },
  {
    "text": "Travis Air Force Base",
    "value": "travis air force base"
  },
  {
    "text": "Treadwell",
    "value": "treadwell"
  },
  {
    "text": "Treasure Island",
    "value": "treasure island"
  },
  {
    "text": "Trego",
    "value": "trego"
  },
  {
    "text": "Treichlers",
    "value": "treichlers"
  },
  {
    "text": "Trementina",
    "value": "trementina"
  },
  {
    "text": "Tremont",
    "value": "tremont"
  },
  {
    "text": "Tremont City",
    "value": "tremont city"
  },
  {
    "text": "Tremonton",
    "value": "tremonton"
  },
  {
    "text": "Trempealeau",
    "value": "trempealeau"
  },
  {
    "text": "Trenary",
    "value": "trenary"
  },
  {
    "text": "Trent",
    "value": "trent"
  },
  {
    "text": "Trent Woods",
    "value": "trent woods"
  },
  {
    "text": "Trenton",
    "value": "trenton"
  },
  {
    "text": "Trentwood",
    "value": "trentwood"
  },
  {
    "text": "Tres Piedras",
    "value": "tres piedras"
  },
  {
    "text": "Tres Pinos",
    "value": "tres pinos"
  },
  {
    "text": "Tresckow",
    "value": "tresckow"
  },
  {
    "text": "Trevett",
    "value": "trevett"
  },
  {
    "text": "Trevor",
    "value": "trevor"
  },
  {
    "text": "Trevorton",
    "value": "trevorton"
  },
  {
    "text": "Trevose",
    "value": "trevose"
  },
  {
    "text": "Trexlertown",
    "value": "trexlertown"
  },
  {
    "text": "Treynor",
    "value": "treynor"
  },
  {
    "text": "Trezevant",
    "value": "trezevant"
  },
  {
    "text": "Tri-Cities",
    "value": "tri-cities"
  },
  {
    "text": "Triadelphia",
    "value": "triadelphia"
  },
  {
    "text": "Triangle",
    "value": "triangle"
  },
  {
    "text": "Tribes Hill",
    "value": "tribes hill"
  },
  {
    "text": "Tribune",
    "value": "tribune"
  },
  {
    "text": "Tridell",
    "value": "tridell"
  },
  {
    "text": "Trilla",
    "value": "trilla"
  },
  {
    "text": "Trimble",
    "value": "trimble"
  },
  {
    "text": "Trimont",
    "value": "trimont"
  },
  {
    "text": "Trinidad",
    "value": "trinidad"
  },
  {
    "text": "Trinity",
    "value": "trinity"
  },
  {
    "text": "Trinity Center",
    "value": "trinity center"
  },
  {
    "text": "Trion",
    "value": "trion"
  },
  {
    "text": "Tripler Army Medical Center",
    "value": "tripler army medical center"
  },
  {
    "text": "Triplett",
    "value": "triplett"
  },
  {
    "text": "Tripoli",
    "value": "tripoli"
  },
  {
    "text": "Tripp",
    "value": "tripp"
  },
  {
    "text": "Trivoli",
    "value": "trivoli"
  },
  {
    "text": "Trona",
    "value": "trona"
  },
  {
    "text": "Trooper",
    "value": "trooper"
  },
  {
    "text": "Trophy Club",
    "value": "trophy club"
  },
  {
    "text": "Tropic",
    "value": "tropic"
  },
  {
    "text": "Trosper",
    "value": "trosper"
  },
  {
    "text": "Trotwood",
    "value": "trotwood"
  },
  {
    "text": "Troup",
    "value": "troup"
  },
  {
    "text": "Troupsburg",
    "value": "troupsburg"
  },
  {
    "text": "Trout",
    "value": "trout"
  },
  {
    "text": "Trout Creek",
    "value": "trout creek"
  },
  {
    "text": "Trout Dale",
    "value": "trout dale"
  },
  {
    "text": "Trout Lake",
    "value": "trout lake"
  },
  {
    "text": "Trout Run",
    "value": "trout run"
  },
  {
    "text": "Troutdale",
    "value": "troutdale"
  },
  {
    "text": "Troutman",
    "value": "troutman"
  },
  {
    "text": "Troutville",
    "value": "troutville"
  },
  {
    "text": "Trowbridge",
    "value": "trowbridge"
  },
  {
    "text": "Troxelville",
    "value": "troxelville"
  },
  {
    "text": "Troy",
    "value": "troy"
  },
  {
    "text": "Troy Grove",
    "value": "troy grove"
  },
  {
    "text": "Troy Mills",
    "value": "troy mills"
  },
  {
    "text": "Truchas",
    "value": "truchas"
  },
  {
    "text": "Truckee",
    "value": "truckee"
  },
  {
    "text": "Trucksville",
    "value": "trucksville"
  },
  {
    "text": "Truesdale",
    "value": "truesdale"
  },
  {
    "text": "Trufant",
    "value": "trufant"
  },
  {
    "text": "Truman",
    "value": "truman"
  },
  {
    "text": "Trumann",
    "value": "trumann"
  },
  {
    "text": "Trumansburg",
    "value": "trumansburg"
  },
  {
    "text": "Trumbauersville",
    "value": "trumbauersville"
  },
  {
    "text": "Trumbull",
    "value": "trumbull"
  },
  {
    "text": "Truro",
    "value": "truro"
  },
  {
    "text": "Trussville",
    "value": "trussville"
  },
  {
    "text": "Truth or Consequences",
    "value": "truth or consequences"
  },
  {
    "text": "Truxton",
    "value": "truxton"
  },
  {
    "text": "Tryon",
    "value": "tryon"
  },
  {
    "text": "Tualatin",
    "value": "tualatin"
  },
  {
    "text": "Tuba City",
    "value": "tuba city"
  },
  {
    "text": "Tubac",
    "value": "tubac"
  },
  {
    "text": "Tuckahoe",
    "value": "tuckahoe"
  },
  {
    "text": "Tuckasegee",
    "value": "tuckasegee"
  },
  {
    "text": "Tucker",
    "value": "tucker"
  },
  {
    "text": "Tuckerman",
    "value": "tuckerman"
  },
  {
    "text": "Tuckerton",
    "value": "tuckerton"
  },
  {
    "text": "Tucson",
    "value": "tucson"
  },
  {
    "text": "Tucson Estates",
    "value": "tucson estates"
  },
  {
    "text": "Tucumcari",
    "value": "tucumcari"
  },
  {
    "text": "Tuftonboro",
    "value": "tuftonboro"
  },
  {
    "text": "Tujunga",
    "value": "tujunga"
  },
  {
    "text": "Tukwila",
    "value": "tukwila"
  },
  {
    "text": "Tulalip",
    "value": "tulalip"
  },
  {
    "text": "Tulare",
    "value": "tulare"
  },
  {
    "text": "Tularosa",
    "value": "tularosa"
  },
  {
    "text": "Tulelake",
    "value": "tulelake"
  },
  {
    "text": "Tuleta",
    "value": "tuleta"
  },
  {
    "text": "Tulia",
    "value": "tulia"
  },
  {
    "text": "Tullahoma",
    "value": "tullahoma"
  },
  {
    "text": "Tullos",
    "value": "tullos"
  },
  {
    "text": "Tully",
    "value": "tully"
  },
  {
    "text": "Tullytown",
    "value": "tullytown"
  },
  {
    "text": "Tulsa",
    "value": "tulsa"
  },
  {
    "text": "Tuluksak",
    "value": "tuluksak"
  },
  {
    "text": "Tumbling Shoals",
    "value": "tumbling shoals"
  },
  {
    "text": "Tumwater",
    "value": "tumwater"
  },
  {
    "text": "Tunas",
    "value": "tunas"
  },
  {
    "text": "Tunbridge",
    "value": "tunbridge"
  },
  {
    "text": "Tunica",
    "value": "tunica"
  },
  {
    "text": "Tunica Resorts",
    "value": "tunica resorts"
  },
  {
    "text": "Tunkhannock",
    "value": "tunkhannock"
  },
  {
    "text": "Tunnel",
    "value": "tunnel"
  },
  {
    "text": "Tunnel Hill",
    "value": "tunnel hill"
  },
  {
    "text": "Tunnelton",
    "value": "tunnelton"
  },
  {
    "text": "Tuntutuliak",
    "value": "tuntutuliak"
  },
  {
    "text": "Tununak",
    "value": "tununak"
  },
  {
    "text": "Tuolumne",
    "value": "tuolumne"
  },
  {
    "text": "Tuolumne City",
    "value": "tuolumne city"
  },
  {
    "text": "Tupelo",
    "value": "tupelo"
  },
  {
    "text": "Tupman",
    "value": "tupman"
  },
  {
    "text": "Tupper Lake",
    "value": "tupper lake"
  },
  {
    "text": "Turbeville",
    "value": "turbeville"
  },
  {
    "text": "Turbotville",
    "value": "turbotville"
  },
  {
    "text": "Turin",
    "value": "turin"
  },
  {
    "text": "Turkey",
    "value": "turkey"
  },
  {
    "text": "Turkey Creek",
    "value": "turkey creek"
  },
  {
    "text": "Turlock",
    "value": "turlock"
  },
  {
    "text": "Turner",
    "value": "turner"
  },
  {
    "text": "Turners",
    "value": "turners"
  },
  {
    "text": "Turners Falls",
    "value": "turners falls"
  },
  {
    "text": "Turners Station",
    "value": "turners station"
  },
  {
    "text": "Turnersville",
    "value": "turnersville"
  },
  {
    "text": "Turnerville",
    "value": "turnerville"
  },
  {
    "text": "Turney",
    "value": "turney"
  },
  {
    "text": "Turon",
    "value": "turon"
  },
  {
    "text": "Turpin",
    "value": "turpin"
  },
  {
    "text": "Turrell",
    "value": "turrell"
  },
  {
    "text": "Turtle Creek",
    "value": "turtle creek"
  },
  {
    "text": "Turtle Lake",
    "value": "turtle lake"
  },
  {
    "text": "Turtletown",
    "value": "turtletown"
  },
  {
    "text": "Turton",
    "value": "turton"
  },
  {
    "text": "Tusayan",
    "value": "tusayan"
  },
  {
    "text": "Tuscaloosa",
    "value": "tuscaloosa"
  },
  {
    "text": "Tuscarawas",
    "value": "tuscarawas"
  },
  {
    "text": "Tuscarora",
    "value": "tuscarora"
  },
  {
    "text": "Tuscola",
    "value": "tuscola"
  },
  {
    "text": "Tuscumbia",
    "value": "tuscumbia"
  },
  {
    "text": "Tuskahoma",
    "value": "tuskahoma"
  },
  {
    "text": "Tuskegee",
    "value": "tuskegee"
  },
  {
    "text": "Tustin",
    "value": "tustin"
  },
  {
    "text": "Tuthill",
    "value": "tuthill"
  },
  {
    "text": "Tuttle",
    "value": "tuttle"
  },
  {
    "text": "Tutwiler",
    "value": "tutwiler"
  },
  {
    "text": "Tuxedo",
    "value": "tuxedo"
  },
  {
    "text": "Tuxedo Park",
    "value": "tuxedo park"
  },
  {
    "text": "Twain",
    "value": "twain"
  },
  {
    "text": "Twain Harte",
    "value": "twain harte"
  },
  {
    "text": "Twelve Mile",
    "value": "twelve mile"
  },
  {
    "text": "Twentynine Palms",
    "value": "twentynine palms"
  },
  {
    "text": "Twin Bridges",
    "value": "twin bridges"
  },
  {
    "text": "Twin Brooks",
    "value": "twin brooks"
  },
  {
    "text": "Twin Cities",
    "value": "twin cities"
  },
  {
    "text": "Twin City",
    "value": "twin city"
  },
  {
    "text": "Twin Falls",
    "value": "twin falls"
  },
  {
    "text": "Twin Lake",
    "value": "twin lake"
  },
  {
    "text": "Twin Lakes",
    "value": "twin lakes"
  },
  {
    "text": "Twin Mountain",
    "value": "twin mountain"
  },
  {
    "text": "Twin Oaks",
    "value": "twin oaks"
  },
  {
    "text": "Twin Peaks",
    "value": "twin peaks"
  },
  {
    "text": "Twin Rocks",
    "value": "twin rocks"
  },
  {
    "text": "Twin Valley",
    "value": "twin valley"
  },
  {
    "text": "Twining",
    "value": "twining"
  },
  {
    "text": "Twinsburg",
    "value": "twinsburg"
  },
  {
    "text": "Twisp",
    "value": "twisp"
  },
  {
    "text": "Two Buttes",
    "value": "two buttes"
  },
  {
    "text": "Two Harbors",
    "value": "two harbors"
  },
  {
    "text": "Two Rivers",
    "value": "two rivers"
  },
  {
    "text": "Ty Ty",
    "value": "ty ty"
  },
  {
    "text": "Tyaskin",
    "value": "tyaskin"
  },
  {
    "text": "Tybee Island",
    "value": "tybee island"
  },
  {
    "text": "Tye",
    "value": "tye"
  },
  {
    "text": "Tygh Valley",
    "value": "tygh valley"
  },
  {
    "text": "Tyler",
    "value": "tyler"
  },
  {
    "text": "Tyler Hill",
    "value": "tyler hill"
  },
  {
    "text": "Tylertown",
    "value": "tylertown"
  },
  {
    "text": "Tynan",
    "value": "tynan"
  },
  {
    "text": "Tyndall",
    "value": "tyndall"
  },
  {
    "text": "Tyner",
    "value": "tyner"
  },
  {
    "text": "Tyngsboro",
    "value": "tyngsboro"
  },
  {
    "text": "Tyringham",
    "value": "tyringham"
  },
  {
    "text": "Tyro",
    "value": "tyro"
  },
  {
    "text": "Tyrone",
    "value": "tyrone"
  },
  {
    "text": "Tyronza",
    "value": "tyronza"
  },
  {
    "text": "Tysons Corner",
    "value": "tysons corner"
  },
  {
    "text": "Ubly",
    "value": "ubly"
  },
  {
    "text": "Ucon",
    "value": "ucon"
  },
  {
    "text": "Udall",
    "value": "udall"
  },
  {
    "text": "Udell",
    "value": "udell"
  },
  {
    "text": "Uhland",
    "value": "uhland"
  },
  {
    "text": "Uhrichsville",
    "value": "uhrichsville"
  },
  {
    "text": "Uintah",
    "value": "uintah"
  },
  {
    "text": "Ukiah",
    "value": "ukiah"
  },
  {
    "text": "Uledi",
    "value": "uledi"
  },
  {
    "text": "Ulen",
    "value": "ulen"
  },
  {
    "text": "Ullin",
    "value": "ullin"
  },
  {
    "text": "Ulm",
    "value": "ulm"
  },
  {
    "text": "Ulmer",
    "value": "ulmer"
  },
  {
    "text": "Ulster",
    "value": "ulster"
  },
  {
    "text": "Ulster Park",
    "value": "ulster park"
  },
  {
    "text": "Ulysses",
    "value": "ulysses"
  },
  {
    "text": "Umatilla",
    "value": "umatilla"
  },
  {
    "text": "Umbarger",
    "value": "umbarger"
  },
  {
    "text": "Umpire",
    "value": "umpire"
  },
  {
    "text": "Umpqua",
    "value": "umpqua"
  },
  {
    "text": "Una",
    "value": "una"
  },
  {
    "text": "Unadilla",
    "value": "unadilla"
  },
  {
    "text": "Unalakleet",
    "value": "unalakleet"
  },
  {
    "text": "Unalaska",
    "value": "unalaska"
  },
  {
    "text": "Uncasville",
    "value": "uncasville"
  },
  {
    "text": "Underhill",
    "value": "underhill"
  },
  {
    "text": "Underhill Center",
    "value": "underhill center"
  },
  {
    "text": "Underwood",
    "value": "underwood"
  },
  {
    "text": "Uneeda",
    "value": "uneeda"
  },
  {
    "text": "Unicoi",
    "value": "unicoi"
  },
  {
    "text": "Union",
    "value": "union"
  },
  {
    "text": "Union Beach",
    "value": "union beach"
  },
  {
    "text": "Union Bridge",
    "value": "union bridge"
  },
  {
    "text": "Union Center",
    "value": "union center"
  },
  {
    "text": "Union Church",
    "value": "union church"
  },
  {
    "text": "Union City",
    "value": "union city"
  },
  {
    "text": "Union Creek",
    "value": "union creek"
  },
  {
    "text": "Union Dale",
    "value": "union dale"
  },
  {
    "text": "Union Furnace",
    "value": "union furnace"
  },
  {
    "text": "Union Gap",
    "value": "union gap"
  },
  {
    "text": "Union Grove",
    "value": "union grove"
  },
  {
    "text": "Union Hall",
    "value": "union hall"
  },
  {
    "text": "Union Hill",
    "value": "union hill"
  },
  {
    "text": "Union Lake",
    "value": "union lake"
  },
  {
    "text": "Union Mills",
    "value": "union mills"
  },
  {
    "text": "Union Park",
    "value": "union park"
  },
  {
    "text": "Union Pier",
    "value": "union pier"
  },
  {
    "text": "Union Point",
    "value": "union point"
  },
  {
    "text": "Union Springs",
    "value": "union springs"
  },
  {
    "text": "Union Star",
    "value": "union star"
  },
  {
    "text": "Uniondale",
    "value": "uniondale"
  },
  {
    "text": "Uniontown",
    "value": "uniontown"
  },
  {
    "text": "Unionville",
    "value": "unionville"
  },
  {
    "text": "Unionville Center",
    "value": "unionville center"
  },
  {
    "text": "Unity",
    "value": "unity"
  },
  {
    "text": "Unity House",
    "value": "unity house"
  },
  {
    "text": "Unityville",
    "value": "unityville"
  },
  {
    "text": "Universal",
    "value": "universal"
  },
  {
    "text": "Universal City",
    "value": "universal city"
  },
  {
    "text": "University",
    "value": "university"
  },
  {
    "text": "University Center",
    "value": "university center"
  },
  {
    "text": "University City",
    "value": "university city"
  },
  {
    "text": "University Heights",
    "value": "university heights"
  },
  {
    "text": "University Park",
    "value": "university park"
  },
  {
    "text": "University Place",
    "value": "university place"
  },
  {
    "text": "Unorganized Territory of Wyman",
    "value": "unorganized territory of wyman"
  },
  {
    "text": "Upatoi",
    "value": "upatoi"
  },
  {
    "text": "Upham",
    "value": "upham"
  },
  {
    "text": "Upland",
    "value": "upland"
  },
  {
    "text": "Upper",
    "value": "upper"
  },
  {
    "text": "Upper Arlington",
    "value": "upper arlington"
  },
  {
    "text": "Upper Black Eddy",
    "value": "upper black eddy"
  },
  {
    "text": "Upper Brookville",
    "value": "upper brookville"
  },
  {
    "text": "Upper Darby",
    "value": "upper darby"
  },
  {
    "text": "Upper Fairmount",
    "value": "upper fairmount"
  },
  {
    "text": "Upper Falls",
    "value": "upper falls"
  },
  {
    "text": "Upper Lake",
    "value": "upper lake"
  },
  {
    "text": "Upper Marlboro",
    "value": "upper marlboro"
  },
  {
    "text": "Upper Merion",
    "value": "upper merion"
  },
  {
    "text": "Upper Montclair",
    "value": "upper montclair"
  },
  {
    "text": "Upper Saddle River",
    "value": "upper saddle river"
  },
  {
    "text": "Upper Saint Clair",
    "value": "upper saint clair"
  },
  {
    "text": "Upper Sandusky",
    "value": "upper sandusky"
  },
  {
    "text": "Upper Strasburg",
    "value": "upper strasburg"
  },
  {
    "text": "Upper Tract",
    "value": "upper tract"
  },
  {
    "text": "Upperco",
    "value": "upperco"
  },
  {
    "text": "Upperglade",
    "value": "upperglade"
  },
  {
    "text": "Upperville",
    "value": "upperville"
  },
  {
    "text": "Upsala",
    "value": "upsala"
  },
  {
    "text": "Upson",
    "value": "upson"
  },
  {
    "text": "Upton",
    "value": "upton"
  },
  {
    "text": "Urbana",
    "value": "urbana"
  },
  {
    "text": "Urbandale",
    "value": "urbandale"
  },
  {
    "text": "Urbanna",
    "value": "urbanna"
  },
  {
    "text": "Uriah",
    "value": "uriah"
  },
  {
    "text": "Urich",
    "value": "urich"
  },
  {
    "text": "Ursa",
    "value": "ursa"
  },
  {
    "text": "Usk",
    "value": "usk"
  },
  {
    "text": "Ute",
    "value": "ute"
  },
  {
    "text": "Ute Park",
    "value": "ute park"
  },
  {
    "text": "Utica",
    "value": "utica"
  },
  {
    "text": "Utopia",
    "value": "utopia"
  },
  {
    "text": "Uvalda",
    "value": "uvalda"
  },
  {
    "text": "Uvalde",
    "value": "uvalde"
  },
  {
    "text": "Uwchland",
    "value": "uwchland"
  },
  {
    "text": "Uxbridge",
    "value": "uxbridge"
  },
  {
    "text": "Vacaville",
    "value": "vacaville"
  },
  {
    "text": "Vacherie",
    "value": "vacherie"
  },
  {
    "text": "Vader",
    "value": "vader"
  },
  {
    "text": "Vadito",
    "value": "vadito"
  },
  {
    "text": "Vadnais Heights",
    "value": "vadnais heights"
  },
  {
    "text": "Vado",
    "value": "vado"
  },
  {
    "text": "Vaiden",
    "value": "vaiden"
  },
  {
    "text": "Vail",
    "value": "vail"
  },
  {
    "text": "Vails Gate",
    "value": "vails gate"
  },
  {
    "text": "Val Verde",
    "value": "val verde"
  },
  {
    "text": "Valatie",
    "value": "valatie"
  },
  {
    "text": "Valders",
    "value": "valders"
  },
  {
    "text": "Valdese",
    "value": "valdese"
  },
  {
    "text": "Valdez",
    "value": "valdez"
  },
  {
    "text": "Valdosta",
    "value": "valdosta"
  },
  {
    "text": "Vale",
    "value": "vale"
  },
  {
    "text": "Valencia",
    "value": "valencia"
  },
  {
    "text": "Valencia West",
    "value": "valencia west"
  },
  {
    "text": "Valentine",
    "value": "valentine"
  },
  {
    "text": "Valera",
    "value": "valera"
  },
  {
    "text": "Valhalla",
    "value": "valhalla"
  },
  {
    "text": "Valier",
    "value": "valier"
  },
  {
    "text": "Valle Vista",
    "value": "valle vista"
  },
  {
    "text": "Vallecito",
    "value": "vallecito"
  },
  {
    "text": "Vallecitos",
    "value": "vallecitos"
  },
  {
    "text": "Vallejo",
    "value": "vallejo"
  },
  {
    "text": "Valles Mines",
    "value": "valles mines"
  },
  {
    "text": "Valley",
    "value": "valley"
  },
  {
    "text": "Valley Bend",
    "value": "valley bend"
  },
  {
    "text": "Valley Center",
    "value": "valley center"
  },
  {
    "text": "Valley City",
    "value": "valley city"
  },
  {
    "text": "Valley Cottage",
    "value": "valley cottage"
  },
  {
    "text": "Valley Falls",
    "value": "valley falls"
  },
  {
    "text": "Valley Farms",
    "value": "valley farms"
  },
  {
    "text": "Valley Ford",
    "value": "valley ford"
  },
  {
    "text": "Valley Forge",
    "value": "valley forge"
  },
  {
    "text": "Valley Green",
    "value": "valley green"
  },
  {
    "text": "Valley Grove",
    "value": "valley grove"
  },
  {
    "text": "Valley Head",
    "value": "valley head"
  },
  {
    "text": "Valley Lee",
    "value": "valley lee"
  },
  {
    "text": "Valley Mills",
    "value": "valley mills"
  },
  {
    "text": "Valley Park",
    "value": "valley park"
  },
  {
    "text": "Valley Spring",
    "value": "valley spring"
  },
  {
    "text": "Valley Springs",
    "value": "valley springs"
  },
  {
    "text": "Valley Station",
    "value": "valley station"
  },
  {
    "text": "Valley Stream",
    "value": "valley stream"
  },
  {
    "text": "Valley View",
    "value": "valley view"
  },
  {
    "text": "Valley Village",
    "value": "valley village"
  },
  {
    "text": "Valleyford",
    "value": "valleyford"
  },
  {
    "text": "Valliant",
    "value": "valliant"
  },
  {
    "text": "Vallonia",
    "value": "vallonia"
  },
  {
    "text": "Valmeyer",
    "value": "valmeyer"
  },
  {
    "text": "Valmora",
    "value": "valmora"
  },
  {
    "text": "Valmy",
    "value": "valmy"
  },
  {
    "text": "Valparaiso",
    "value": "valparaiso"
  },
  {
    "text": "Valrico",
    "value": "valrico"
  },
  {
    "text": "Valyermo",
    "value": "valyermo"
  },
  {
    "text": "Van",
    "value": "van"
  },
  {
    "text": "Van Alstyne",
    "value": "van alstyne"
  },
  {
    "text": "Van Buren",
    "value": "van buren"
  },
  {
    "text": "Van Dyne",
    "value": "van dyne"
  },
  {
    "text": "Van Etten",
    "value": "van etten"
  },
  {
    "text": "Van Horn",
    "value": "van horn"
  },
  {
    "text": "Van Horne",
    "value": "van horne"
  },
  {
    "text": "Van Hornesville",
    "value": "van hornesville"
  },
  {
    "text": "Van Lear",
    "value": "van lear"
  },
  {
    "text": "Van Meter",
    "value": "van meter"
  },
  {
    "text": "Van Nuys",
    "value": "van nuys"
  },
  {
    "text": "Van Tassell",
    "value": "van tassell"
  },
  {
    "text": "Van Vleck",
    "value": "van vleck"
  },
  {
    "text": "Van Vleet",
    "value": "van vleet"
  },
  {
    "text": "Van Voorhis",
    "value": "van voorhis"
  },
  {
    "text": "Van Wert",
    "value": "van wert"
  },
  {
    "text": "Vance",
    "value": "vance"
  },
  {
    "text": "Vanceboro",
    "value": "vanceboro"
  },
  {
    "text": "Vanceburg",
    "value": "vanceburg"
  },
  {
    "text": "Vancleave",
    "value": "vancleave"
  },
  {
    "text": "Vancleve",
    "value": "vancleve"
  },
  {
    "text": "Vancourt",
    "value": "vancourt"
  },
  {
    "text": "Vancouver",
    "value": "vancouver"
  },
  {
    "text": "Vandalia",
    "value": "vandalia"
  },
  {
    "text": "Vandenberg SFB",
    "value": "vandenberg sfb"
  },
  {
    "text": "Vandenberg Village",
    "value": "vandenberg village"
  },
  {
    "text": "Vanderbilt",
    "value": "vanderbilt"
  },
  {
    "text": "Vandergrift",
    "value": "vandergrift"
  },
  {
    "text": "Vandervoort",
    "value": "vandervoort"
  },
  {
    "text": "Vanderwagen",
    "value": "vanderwagen"
  },
  {
    "text": "Vandiver",
    "value": "vandiver"
  },
  {
    "text": "Vanleer",
    "value": "vanleer"
  },
  {
    "text": "Vanlue",
    "value": "vanlue"
  },
  {
    "text": "Vansant",
    "value": "vansant"
  },
  {
    "text": "Vantage",
    "value": "vantage"
  },
  {
    "text": "Vardaman",
    "value": "vardaman"
  },
  {
    "text": "Varina",
    "value": "varina"
  },
  {
    "text": "Varna",
    "value": "varna"
  },
  {
    "text": "Varnell",
    "value": "varnell"
  },
  {
    "text": "Varney",
    "value": "varney"
  },
  {
    "text": "Varnville",
    "value": "varnville"
  },
  {
    "text": "Varysburg",
    "value": "varysburg"
  },
  {
    "text": "Vashon",
    "value": "vashon"
  },
  {
    "text": "Vass",
    "value": "vass"
  },
  {
    "text": "Vassalboro",
    "value": "vassalboro"
  },
  {
    "text": "Vassar",
    "value": "vassar"
  },
  {
    "text": "Vaughan",
    "value": "vaughan"
  },
  {
    "text": "Vaughn",
    "value": "vaughn"
  },
  {
    "text": "Vauxhall",
    "value": "vauxhall"
  },
  {
    "text": "Veazie",
    "value": "veazie"
  },
  {
    "text": "Veblen",
    "value": "veblen"
  },
  {
    "text": "Veedersburg",
    "value": "veedersburg"
  },
  {
    "text": "Vega",
    "value": "vega"
  },
  {
    "text": "Veguita",
    "value": "veguita"
  },
  {
    "text": "Velarde",
    "value": "velarde"
  },
  {
    "text": "Velma",
    "value": "velma"
  },
  {
    "text": "Velpen",
    "value": "velpen"
  },
  {
    "text": "Velva",
    "value": "velva"
  },
  {
    "text": "Venango",
    "value": "venango"
  },
  {
    "text": "Venedocia",
    "value": "venedocia"
  },
  {
    "text": "Veneta",
    "value": "veneta"
  },
  {
    "text": "Venetia",
    "value": "venetia"
  },
  {
    "text": "Venetie",
    "value": "venetie"
  },
  {
    "text": "Venice",
    "value": "venice"
  },
  {
    "text": "Ventnor City",
    "value": "ventnor city"
  },
  {
    "text": "Ventress",
    "value": "ventress"
  },
  {
    "text": "Ventura",
    "value": "ventura"
  },
  {
    "text": "Venus",
    "value": "venus"
  },
  {
    "text": "Veradale",
    "value": "veradale"
  },
  {
    "text": "Verbank",
    "value": "verbank"
  },
  {
    "text": "Verbena",
    "value": "verbena"
  },
  {
    "text": "Verden",
    "value": "verden"
  },
  {
    "text": "Verdi",
    "value": "verdi"
  },
  {
    "text": "Verdigre",
    "value": "verdigre"
  },
  {
    "text": "Verdigris",
    "value": "verdigris"
  },
  {
    "text": "Verdon",
    "value": "verdon"
  },
  {
    "text": "Verdugo City",
    "value": "verdugo city"
  },
  {
    "text": "Verdunville",
    "value": "verdunville"
  },
  {
    "text": "Vergas",
    "value": "vergas"
  },
  {
    "text": "Vergennes",
    "value": "vergennes"
  },
  {
    "text": "Vermilion",
    "value": "vermilion"
  },
  {
    "text": "Vermillion",
    "value": "vermillion"
  },
  {
    "text": "Vermont",
    "value": "vermont"
  },
  {
    "text": "Vermontville",
    "value": "vermontville"
  },
  {
    "text": "Vernal",
    "value": "vernal"
  },
  {
    "text": "Vernalis",
    "value": "vernalis"
  },
  {
    "text": "Verndale",
    "value": "verndale"
  },
  {
    "text": "Verner",
    "value": "verner"
  },
  {
    "text": "Vernon",
    "value": "vernon"
  },
  {
    "text": "Vernon Center",
    "value": "vernon center"
  },
  {
    "text": "Vernon Hill",
    "value": "vernon hill"
  },
  {
    "text": "Vernon Hills",
    "value": "vernon hills"
  },
  {
    "text": "Vernon Rockville",
    "value": "vernon rockville"
  },
  {
    "text": "Vernon Valley",
    "value": "vernon valley"
  },
  {
    "text": "Vernonia",
    "value": "vernonia"
  },
  {
    "text": "Vero Beach",
    "value": "vero beach"
  },
  {
    "text": "Verona",
    "value": "verona"
  },
  {
    "text": "Verona Beach",
    "value": "verona beach"
  },
  {
    "text": "Verplanck",
    "value": "verplanck"
  },
  {
    "text": "Versailles",
    "value": "versailles"
  },
  {
    "text": "Vershire",
    "value": "vershire"
  },
  {
    "text": "Vesper",
    "value": "vesper"
  },
  {
    "text": "Vest",
    "value": "vest"
  },
  {
    "text": "Vesta",
    "value": "vesta"
  },
  {
    "text": "Vestaburg",
    "value": "vestaburg"
  },
  {
    "text": "Vestal",
    "value": "vestal"
  },
  {
    "text": "Vestavia Hills",
    "value": "vestavia hills"
  },
  {
    "text": "Vesuvius",
    "value": "vesuvius"
  },
  {
    "text": "Vevay",
    "value": "vevay"
  },
  {
    "text": "Veyo",
    "value": "veyo"
  },
  {
    "text": "Vian",
    "value": "vian"
  },
  {
    "text": "Viborg",
    "value": "viborg"
  },
  {
    "text": "Viburnum",
    "value": "viburnum"
  },
  {
    "text": "Vicco",
    "value": "vicco"
  },
  {
    "text": "Vichy",
    "value": "vichy"
  },
  {
    "text": "Vici",
    "value": "vici"
  },
  {
    "text": "Vickery",
    "value": "vickery"
  },
  {
    "text": "Vicksburg",
    "value": "vicksburg"
  },
  {
    "text": "Victor",
    "value": "victor"
  },
  {
    "text": "Victoria",
    "value": "victoria"
  },
  {
    "text": "Victorville",
    "value": "victorville"
  },
  {
    "text": "Victory Mills",
    "value": "victory mills"
  },
  {
    "text": "Vida",
    "value": "vida"
  },
  {
    "text": "Vidalia",
    "value": "vidalia"
  },
  {
    "text": "Vidor",
    "value": "vidor"
  },
  {
    "text": "Vienna",
    "value": "vienna"
  },
  {
    "text": "Viera",
    "value": "viera"
  },
  {
    "text": "View Park-Windsor Hills",
    "value": "view park-windsor hills"
  },
  {
    "text": "Viewtown",
    "value": "viewtown"
  },
  {
    "text": "Viking",
    "value": "viking"
  },
  {
    "text": "Vilas",
    "value": "vilas"
  },
  {
    "text": "Villa Grove",
    "value": "villa grove"
  },
  {
    "text": "Villa Hills",
    "value": "villa hills"
  },
  {
    "text": "Villa Maria",
    "value": "villa maria"
  },
  {
    "text": "Villa Park",
    "value": "villa park"
  },
  {
    "text": "Villa Rica",
    "value": "villa rica"
  },
  {
    "text": "Villa Ridge",
    "value": "villa ridge"
  },
  {
    "text": "Village",
    "value": "village"
  },
  {
    "text": "Village Green",
    "value": "village green"
  },
  {
    "text": "Village Mills",
    "value": "village mills"
  },
  {
    "text": "Village of Campton Hills",
    "value": "village of campton hills"
  },
  {
    "text": "Villanova",
    "value": "villanova"
  },
  {
    "text": "Villard",
    "value": "villard"
  },
  {
    "text": "Villas",
    "value": "villas"
  },
  {
    "text": "Ville Platte",
    "value": "ville platte"
  },
  {
    "text": "Villisca",
    "value": "villisca"
  },
  {
    "text": "Vilonia",
    "value": "vilonia"
  },
  {
    "text": "Vina",
    "value": "vina"
  },
  {
    "text": "Vinalhaven",
    "value": "vinalhaven"
  },
  {
    "text": "Vincennes",
    "value": "vincennes"
  },
  {
    "text": "Vincent",
    "value": "vincent"
  },
  {
    "text": "Vincentown",
    "value": "vincentown"
  },
  {
    "text": "Vine Grove",
    "value": "vine grove"
  },
  {
    "text": "Vineland",
    "value": "vineland"
  },
  {
    "text": "Vinemont",
    "value": "vinemont"
  },
  {
    "text": "Vineyard",
    "value": "vineyard"
  },
  {
    "text": "Vineyard Haven",
    "value": "vineyard haven"
  },
  {
    "text": "Vining",
    "value": "vining"
  },
  {
    "text": "Vinings",
    "value": "vinings"
  },
  {
    "text": "Vinita",
    "value": "vinita"
  },
  {
    "text": "Vinita Park",
    "value": "vinita park"
  },
  {
    "text": "Vinton",
    "value": "vinton"
  },
  {
    "text": "Vintondale",
    "value": "vintondale"
  },
  {
    "text": "Viola",
    "value": "viola"
  },
  {
    "text": "Violet",
    "value": "violet"
  },
  {
    "text": "Viper",
    "value": "viper"
  },
  {
    "text": "Virden",
    "value": "virden"
  },
  {
    "text": "Virgie",
    "value": "virgie"
  },
  {
    "text": "Virgil",
    "value": "virgil"
  },
  {
    "text": "Virgilina",
    "value": "virgilina"
  },
  {
    "text": "Virgin",
    "value": "virgin"
  },
  {
    "text": "Virginia",
    "value": "virginia"
  },
  {
    "text": "Virginia Beach",
    "value": "virginia beach"
  },
  {
    "text": "Virginia City",
    "value": "virginia city"
  },
  {
    "text": "Virginia Gardens",
    "value": "virginia gardens"
  },
  {
    "text": "Viroqua",
    "value": "viroqua"
  },
  {
    "text": "Visalia",
    "value": "visalia"
  },
  {
    "text": "Vista",
    "value": "vista"
  },
  {
    "text": "Vista Santa Rosa",
    "value": "vista santa rosa"
  },
  {
    "text": "Vivian",
    "value": "vivian"
  },
  {
    "text": "Voca",
    "value": "voca"
  },
  {
    "text": "Volant",
    "value": "volant"
  },
  {
    "text": "Volcano",
    "value": "volcano"
  },
  {
    "text": "Volcano Village",
    "value": "volcano village"
  },
  {
    "text": "Volga",
    "value": "volga"
  },
  {
    "text": "Volin",
    "value": "volin"
  },
  {
    "text": "Volo",
    "value": "volo"
  },
  {
    "text": "Voluntown",
    "value": "voluntown"
  },
  {
    "text": "Von Ormy",
    "value": "von ormy"
  },
  {
    "text": "Vonore",
    "value": "vonore"
  },
  {
    "text": "Voorhees",
    "value": "voorhees"
  },
  {
    "text": "Voorhees Township",
    "value": "voorhees township"
  },
  {
    "text": "Voorheesville",
    "value": "voorheesville"
  },
  {
    "text": "Voss",
    "value": "voss"
  },
  {
    "text": "Vossburg",
    "value": "vossburg"
  },
  {
    "text": "Votaw",
    "value": "votaw"
  },
  {
    "text": "Vulcan",
    "value": "vulcan"
  },
  {
    "text": "WaKeeney",
    "value": "wakeeney"
  },
  {
    "text": "Waban",
    "value": "waban"
  },
  {
    "text": "Wabash",
    "value": "wabash"
  },
  {
    "text": "Wabasha",
    "value": "wabasha"
  },
  {
    "text": "Wabasso",
    "value": "wabasso"
  },
  {
    "text": "Wabbaseka",
    "value": "wabbaseka"
  },
  {
    "text": "Wabeno",
    "value": "wabeno"
  },
  {
    "text": "Waccabuc",
    "value": "waccabuc"
  },
  {
    "text": "Wachapreague",
    "value": "wachapreague"
  },
  {
    "text": "Waco",
    "value": "waco"
  },
  {
    "text": "Waconia",
    "value": "waconia"
  },
  {
    "text": "Wacousta",
    "value": "wacousta"
  },
  {
    "text": "Waddell",
    "value": "waddell"
  },
  {
    "text": "Waddington",
    "value": "waddington"
  },
  {
    "text": "Waddy",
    "value": "waddy"
  },
  {
    "text": "Wade",
    "value": "wade"
  },
  {
    "text": "Wade Hampton",
    "value": "wade hampton"
  },
  {
    "text": "Wadena",
    "value": "wadena"
  },
  {
    "text": "Wadesboro",
    "value": "wadesboro"
  },
  {
    "text": "Wadesville",
    "value": "wadesville"
  },
  {
    "text": "Wading River",
    "value": "wading river"
  },
  {
    "text": "Wadley",
    "value": "wadley"
  },
  {
    "text": "Wadmalaw Island",
    "value": "wadmalaw island"
  },
  {
    "text": "Wadsworth",
    "value": "wadsworth"
  },
  {
    "text": "Waelder",
    "value": "waelder"
  },
  {
    "text": "Wagarville",
    "value": "wagarville"
  },
  {
    "text": "Wagener",
    "value": "wagener"
  },
  {
    "text": "Waggaman",
    "value": "waggaman"
  },
  {
    "text": "Waggoner",
    "value": "waggoner"
  },
  {
    "text": "Wagner",
    "value": "wagner"
  },
  {
    "text": "Wagon Mound",
    "value": "wagon mound"
  },
  {
    "text": "Wagoner",
    "value": "wagoner"
  },
  {
    "text": "Wagram",
    "value": "wagram"
  },
  {
    "text": "Wahiawa",
    "value": "wahiawa"
  },
  {
    "text": "Wahkon",
    "value": "wahkon"
  },
  {
    "text": "Wahoo",
    "value": "wahoo"
  },
  {
    "text": "Wahpeton",
    "value": "wahpeton"
  },
  {
    "text": "Waialua",
    "value": "waialua"
  },
  {
    "text": "Waianae",
    "value": "waianae"
  },
  {
    "text": "Waikoloa",
    "value": "waikoloa"
  },
  {
    "text": "Waikoloa Village",
    "value": "waikoloa village"
  },
  {
    "text": "Wailua",
    "value": "wailua"
  },
  {
    "text": "Wailua Homesteads",
    "value": "wailua homesteads"
  },
  {
    "text": "Wailuku",
    "value": "wailuku"
  },
  {
    "text": "Waimalu",
    "value": "waimalu"
  },
  {
    "text": "Waimanalo",
    "value": "waimanalo"
  },
  {
    "text": "Waimea",
    "value": "waimea"
  },
  {
    "text": "Wainscott",
    "value": "wainscott"
  },
  {
    "text": "Wainwright",
    "value": "wainwright"
  },
  {
    "text": "Waipahu",
    "value": "waipahu"
  },
  {
    "text": "Waite",
    "value": "waite"
  },
  {
    "text": "Waite Park",
    "value": "waite park"
  },
  {
    "text": "Waiteville",
    "value": "waiteville"
  },
  {
    "text": "Waitsburg",
    "value": "waitsburg"
  },
  {
    "text": "Waitsfield",
    "value": "waitsfield"
  },
  {
    "text": "Wakarusa",
    "value": "wakarusa"
  },
  {
    "text": "Wake",
    "value": "wake"
  },
  {
    "text": "Wake Forest",
    "value": "wake forest"
  },
  {
    "text": "Wake Village",
    "value": "wake village"
  },
  {
    "text": "Wakefield",
    "value": "wakefield"
  },
  {
    "text": "Wakeman",
    "value": "wakeman"
  },
  {
    "text": "Wakita",
    "value": "wakita"
  },
  {
    "text": "Wakonda",
    "value": "wakonda"
  },
  {
    "text": "Wakpala",
    "value": "wakpala"
  },
  {
    "text": "Wakulla Springs",
    "value": "wakulla springs"
  },
  {
    "text": "Walbridge",
    "value": "walbridge"
  },
  {
    "text": "Walburg",
    "value": "walburg"
  },
  {
    "text": "Walcott",
    "value": "walcott"
  },
  {
    "text": "Walden",
    "value": "walden"
  },
  {
    "text": "Waldo",
    "value": "waldo"
  },
  {
    "text": "Waldoboro",
    "value": "waldoboro"
  },
  {
    "text": "Waldorf",
    "value": "waldorf"
  },
  {
    "text": "Waldport",
    "value": "waldport"
  },
  {
    "text": "Waldron",
    "value": "waldron"
  },
  {
    "text": "Waldwick",
    "value": "waldwick"
  },
  {
    "text": "Wales",
    "value": "wales"
  },
  {
    "text": "Waleska",
    "value": "waleska"
  },
  {
    "text": "Walford",
    "value": "walford"
  },
  {
    "text": "Walhalla",
    "value": "walhalla"
  },
  {
    "text": "Walhonding",
    "value": "walhonding"
  },
  {
    "text": "Walker",
    "value": "walker"
  },
  {
    "text": "Walkersville",
    "value": "walkersville"
  },
  {
    "text": "Walkerton",
    "value": "walkerton"
  },
  {
    "text": "Walkertown",
    "value": "walkertown"
  },
  {
    "text": "Walkerville",
    "value": "walkerville"
  },
  {
    "text": "Wall",
    "value": "wall"
  },
  {
    "text": "Wall Lake",
    "value": "wall lake"
  },
  {
    "text": "Wall Township",
    "value": "wall township"
  },
  {
    "text": "Walla Walla",
    "value": "walla walla"
  },
  {
    "text": "Wallace",
    "value": "wallace"
  },
  {
    "text": "Wallaceton",
    "value": "wallaceton"
  },
  {
    "text": "Wallagrass",
    "value": "wallagrass"
  },
  {
    "text": "Walland",
    "value": "walland"
  },
  {
    "text": "Wallback",
    "value": "wallback"
  },
  {
    "text": "Walled Lake",
    "value": "walled lake"
  },
  {
    "text": "Waller",
    "value": "waller"
  },
  {
    "text": "Wallingford",
    "value": "wallingford"
  },
  {
    "text": "Wallingford Center",
    "value": "wallingford center"
  },
  {
    "text": "Wallington",
    "value": "wallington"
  },
  {
    "text": "Wallins Creek",
    "value": "wallins creek"
  },
  {
    "text": "Wallis",
    "value": "wallis"
  },
  {
    "text": "Wallisville",
    "value": "wallisville"
  },
  {
    "text": "Wallkill",
    "value": "wallkill"
  },
  {
    "text": "Walloon Lake",
    "value": "walloon lake"
  },
  {
    "text": "Wallops Island",
    "value": "wallops island"
  },
  {
    "text": "Wallowa",
    "value": "wallowa"
  },
  {
    "text": "Walls",
    "value": "walls"
  },
  {
    "text": "Wallsburg",
    "value": "wallsburg"
  },
  {
    "text": "Walnut",
    "value": "walnut"
  },
  {
    "text": "Walnut Bottom",
    "value": "walnut bottom"
  },
  {
    "text": "Walnut Cove",
    "value": "walnut cove"
  },
  {
    "text": "Walnut Creek",
    "value": "walnut creek"
  },
  {
    "text": "Walnut Grove",
    "value": "walnut grove"
  },
  {
    "text": "Walnut Hill",
    "value": "walnut hill"
  },
  {
    "text": "Walnut Park",
    "value": "walnut park"
  },
  {
    "text": "Walnut Ridge",
    "value": "walnut ridge"
  },
  {
    "text": "Walnut Shade",
    "value": "walnut shade"
  },
  {
    "text": "Walnut Springs",
    "value": "walnut springs"
  },
  {
    "text": "Walnutport",
    "value": "walnutport"
  },
  {
    "text": "Walpole",
    "value": "walpole"
  },
  {
    "text": "Walsenburg",
    "value": "walsenburg"
  },
  {
    "text": "Walsh",
    "value": "walsh"
  },
  {
    "text": "Walshville",
    "value": "walshville"
  },
  {
    "text": "Walston",
    "value": "walston"
  },
  {
    "text": "Walstonburg",
    "value": "walstonburg"
  },
  {
    "text": "Walterboro",
    "value": "walterboro"
  },
  {
    "text": "Walters",
    "value": "walters"
  },
  {
    "text": "Walterville",
    "value": "walterville"
  },
  {
    "text": "Walthall",
    "value": "walthall"
  },
  {
    "text": "Waltham",
    "value": "waltham"
  },
  {
    "text": "Walthill",
    "value": "walthill"
  },
  {
    "text": "Walthourville",
    "value": "walthourville"
  },
  {
    "text": "Walton",
    "value": "walton"
  },
  {
    "text": "Walton Hills",
    "value": "walton hills"
  },
  {
    "text": "Waltonville",
    "value": "waltonville"
  },
  {
    "text": "Walworth",
    "value": "walworth"
  },
  {
    "text": "Wamego",
    "value": "wamego"
  },
  {
    "text": "Wampsville",
    "value": "wampsville"
  },
  {
    "text": "Wampum",
    "value": "wampum"
  },
  {
    "text": "Wamsutter",
    "value": "wamsutter"
  },
  {
    "text": "Wanakena",
    "value": "wanakena"
  },
  {
    "text": "Wanamassa",
    "value": "wanamassa"
  },
  {
    "text": "Wanamingo",
    "value": "wanamingo"
  },
  {
    "text": "Wanaque",
    "value": "wanaque"
  },
  {
    "text": "Wanatah",
    "value": "wanatah"
  },
  {
    "text": "Wanblee",
    "value": "wanblee"
  },
  {
    "text": "Wanchese",
    "value": "wanchese"
  },
  {
    "text": "Wanda",
    "value": "wanda"
  },
  {
    "text": "Wanette",
    "value": "wanette"
  },
  {
    "text": "Wann",
    "value": "wann"
  },
  {
    "text": "Wannaska",
    "value": "wannaska"
  },
  {
    "text": "Wantagh",
    "value": "wantagh"
  },
  {
    "text": "Wapakoneta",
    "value": "wapakoneta"
  },
  {
    "text": "Wapanucka",
    "value": "wapanucka"
  },
  {
    "text": "Wapato",
    "value": "wapato"
  },
  {
    "text": "Wapella",
    "value": "wapella"
  },
  {
    "text": "Wapello",
    "value": "wapello"
  },
  {
    "text": "Wapiti",
    "value": "wapiti"
  },
  {
    "text": "Wappapello",
    "value": "wappapello"
  },
  {
    "text": "Wappingers Falls",
    "value": "wappingers falls"
  },
  {
    "text": "Wapwallopen",
    "value": "wapwallopen"
  },
  {
    "text": "War",
    "value": "war"
  },
  {
    "text": "Warba",
    "value": "warba"
  },
  {
    "text": "Warbranch",
    "value": "warbranch"
  },
  {
    "text": "Ward",
    "value": "ward"
  },
  {
    "text": "Ward Cove",
    "value": "ward cove"
  },
  {
    "text": "Wardell",
    "value": "wardell"
  },
  {
    "text": "Warden",
    "value": "warden"
  },
  {
    "text": "Wardensville",
    "value": "wardensville"
  },
  {
    "text": "Wardsboro",
    "value": "wardsboro"
  },
  {
    "text": "Wardsville",
    "value": "wardsville"
  },
  {
    "text": "Ware",
    "value": "ware"
  },
  {
    "text": "Ware Shoals",
    "value": "ware shoals"
  },
  {
    "text": "Wareham",
    "value": "wareham"
  },
  {
    "text": "Waretown",
    "value": "waretown"
  },
  {
    "text": "Warfield",
    "value": "warfield"
  },
  {
    "text": "Warfordsburg",
    "value": "warfordsburg"
  },
  {
    "text": "Warm Springs",
    "value": "warm springs"
  },
  {
    "text": "Warminster",
    "value": "warminster"
  },
  {
    "text": "Warminster Heights",
    "value": "warminster heights"
  },
  {
    "text": "Warne",
    "value": "warne"
  },
  {
    "text": "Warner",
    "value": "warner"
  },
  {
    "text": "Warner Robins",
    "value": "warner robins"
  },
  {
    "text": "Warner Springs",
    "value": "warner springs"
  },
  {
    "text": "Warners",
    "value": "warners"
  },
  {
    "text": "Warnerville",
    "value": "warnerville"
  },
  {
    "text": "Warnock",
    "value": "warnock"
  },
  {
    "text": "Warr Acres",
    "value": "warr acres"
  },
  {
    "text": "Warren",
    "value": "warren"
  },
  {
    "text": "Warren Air Force Base",
    "value": "warren air force base"
  },
  {
    "text": "Warren Center",
    "value": "warren center"
  },
  {
    "text": "Warren Township",
    "value": "warren township"
  },
  {
    "text": "Warrendale",
    "value": "warrendale"
  },
  {
    "text": "Warrens",
    "value": "warrens"
  },
  {
    "text": "Warrensburg",
    "value": "warrensburg"
  },
  {
    "text": "Warrensville",
    "value": "warrensville"
  },
  {
    "text": "Warrensville Heights",
    "value": "warrensville heights"
  },
  {
    "text": "Warrenton",
    "value": "warrenton"
  },
  {
    "text": "Warrenville",
    "value": "warrenville"
  },
  {
    "text": "Warrington",
    "value": "warrington"
  },
  {
    "text": "Warrior",
    "value": "warrior"
  },
  {
    "text": "Warriors Mark",
    "value": "warriors mark"
  },
  {
    "text": "Warroad",
    "value": "warroad"
  },
  {
    "text": "Warsaw",
    "value": "warsaw"
  },
  {
    "text": "Warson Woods",
    "value": "warson woods"
  },
  {
    "text": "Wartburg",
    "value": "wartburg"
  },
  {
    "text": "Warthen",
    "value": "warthen"
  },
  {
    "text": "Wartrace",
    "value": "wartrace"
  },
  {
    "text": "Warwick",
    "value": "warwick"
  },
  {
    "text": "Wasco",
    "value": "wasco"
  },
  {
    "text": "Waseca",
    "value": "waseca"
  },
  {
    "text": "Washburn",
    "value": "washburn"
  },
  {
    "text": "Washington",
    "value": "washington"
  },
  {
    "text": "Washington Boro",
    "value": "washington boro"
  },
  {
    "text": "Washington Court House",
    "value": "washington court house"
  },
  {
    "text": "Washington Crossing",
    "value": "washington crossing"
  },
  {
    "text": "Washington Grove",
    "value": "washington grove"
  },
  {
    "text": "Washington Heights",
    "value": "washington heights"
  },
  {
    "text": "Washington Island",
    "value": "washington island"
  },
  {
    "text": "Washington Park",
    "value": "washington park"
  },
  {
    "text": "Washington Terrace",
    "value": "washington terrace"
  },
  {
    "text": "Washington Township",
    "value": "washington township"
  },
  {
    "text": "Washingtonville",
    "value": "washingtonville"
  },
  {
    "text": "Washoe Valley",
    "value": "washoe valley"
  },
  {
    "text": "Washougal",
    "value": "washougal"
  },
  {
    "text": "Washta",
    "value": "washta"
  },
  {
    "text": "Washtucna",
    "value": "washtucna"
  },
  {
    "text": "Wasilla",
    "value": "wasilla"
  },
  {
    "text": "Waskom",
    "value": "waskom"
  },
  {
    "text": "Wasola",
    "value": "wasola"
  },
  {
    "text": "Wassaic",
    "value": "wassaic"
  },
  {
    "text": "Wasta",
    "value": "wasta"
  },
  {
    "text": "Wataga",
    "value": "wataga"
  },
  {
    "text": "Watauga",
    "value": "watauga"
  },
  {
    "text": "Watchung",
    "value": "watchung"
  },
  {
    "text": "Water Mill",
    "value": "water mill"
  },
  {
    "text": "Water Valley",
    "value": "water valley"
  },
  {
    "text": "Water View",
    "value": "water view"
  },
  {
    "text": "Waterboro",
    "value": "waterboro"
  },
  {
    "text": "Waterbury",
    "value": "waterbury"
  },
  {
    "text": "Waterbury Center",
    "value": "waterbury center"
  },
  {
    "text": "Waterfall",
    "value": "waterfall"
  },
  {
    "text": "Waterflow",
    "value": "waterflow"
  },
  {
    "text": "Waterford",
    "value": "waterford"
  },
  {
    "text": "Waterford Flat",
    "value": "waterford flat"
  },
  {
    "text": "Waterford Works",
    "value": "waterford works"
  },
  {
    "text": "Waterloo",
    "value": "waterloo"
  },
  {
    "text": "Waterman",
    "value": "waterman"
  },
  {
    "text": "Waterport",
    "value": "waterport"
  },
  {
    "text": "Waterproof",
    "value": "waterproof"
  },
  {
    "text": "Waters",
    "value": "waters"
  },
  {
    "text": "Watersmeet",
    "value": "watersmeet"
  },
  {
    "text": "Watertown",
    "value": "watertown"
  },
  {
    "text": "Waterville",
    "value": "waterville"
  },
  {
    "text": "Waterville Valley",
    "value": "waterville valley"
  },
  {
    "text": "Watervliet",
    "value": "watervliet"
  },
  {
    "text": "Watford City",
    "value": "watford city"
  },
  {
    "text": "Wathena",
    "value": "wathena"
  },
  {
    "text": "Watkins",
    "value": "watkins"
  },
  {
    "text": "Watkins Glen",
    "value": "watkins glen"
  },
  {
    "text": "Watkinsville",
    "value": "watkinsville"
  },
  {
    "text": "Watonga",
    "value": "watonga"
  },
  {
    "text": "Watrous",
    "value": "watrous"
  },
  {
    "text": "Watseka",
    "value": "watseka"
  },
  {
    "text": "Watson",
    "value": "watson"
  },
  {
    "text": "Watsontown",
    "value": "watsontown"
  },
  {
    "text": "Watsonville",
    "value": "watsonville"
  },
  {
    "text": "Watton",
    "value": "watton"
  },
  {
    "text": "Watts",
    "value": "watts"
  },
  {
    "text": "Wattsburg",
    "value": "wattsburg"
  },
  {
    "text": "Wattsville",
    "value": "wattsville"
  },
  {
    "text": "Waubay",
    "value": "waubay"
  },
  {
    "text": "Waubun",
    "value": "waubun"
  },
  {
    "text": "Wauchula",
    "value": "wauchula"
  },
  {
    "text": "Waucoma",
    "value": "waucoma"
  },
  {
    "text": "Wauconda",
    "value": "wauconda"
  },
  {
    "text": "Waukee",
    "value": "waukee"
  },
  {
    "text": "Waukegan",
    "value": "waukegan"
  },
  {
    "text": "Waukena",
    "value": "waukena"
  },
  {
    "text": "Waukesha",
    "value": "waukesha"
  },
  {
    "text": "Waukomis",
    "value": "waukomis"
  },
  {
    "text": "Waukon",
    "value": "waukon"
  },
  {
    "text": "Wauna",
    "value": "wauna"
  },
  {
    "text": "Waunakee",
    "value": "waunakee"
  },
  {
    "text": "Wauneta",
    "value": "wauneta"
  },
  {
    "text": "Waupaca",
    "value": "waupaca"
  },
  {
    "text": "Waupun",
    "value": "waupun"
  },
  {
    "text": "Wauregan",
    "value": "wauregan"
  },
  {
    "text": "Waurika",
    "value": "waurika"
  },
  {
    "text": "Wausa",
    "value": "wausa"
  },
  {
    "text": "Wausau",
    "value": "wausau"
  },
  {
    "text": "Wausaukee",
    "value": "wausaukee"
  },
  {
    "text": "Wauseon",
    "value": "wauseon"
  },
  {
    "text": "Wautoma",
    "value": "wautoma"
  },
  {
    "text": "Wauwatosa",
    "value": "wauwatosa"
  },
  {
    "text": "Wauzeka",
    "value": "wauzeka"
  },
  {
    "text": "Waveland",
    "value": "waveland"
  },
  {
    "text": "Waverly",
    "value": "waverly"
  },
  {
    "text": "Waverly Hall",
    "value": "waverly hall"
  },
  {
    "text": "Waves",
    "value": "waves"
  },
  {
    "text": "Wawaka",
    "value": "wawaka"
  },
  {
    "text": "Wawarsing",
    "value": "wawarsing"
  },
  {
    "text": "Wawona",
    "value": "wawona"
  },
  {
    "text": "Waxahachie",
    "value": "waxahachie"
  },
  {
    "text": "Waxhaw",
    "value": "waxhaw"
  },
  {
    "text": "Waycross",
    "value": "waycross"
  },
  {
    "text": "Wayland",
    "value": "wayland"
  },
  {
    "text": "Waymart",
    "value": "waymart"
  },
  {
    "text": "Wayne",
    "value": "wayne"
  },
  {
    "text": "Wayne City",
    "value": "wayne city"
  },
  {
    "text": "Waynesboro",
    "value": "waynesboro"
  },
  {
    "text": "Waynesburg",
    "value": "waynesburg"
  },
  {
    "text": "Waynesfield",
    "value": "waynesfield"
  },
  {
    "text": "Waynesville",
    "value": "waynesville"
  },
  {
    "text": "Waynetown",
    "value": "waynetown"
  },
  {
    "text": "Waynoka",
    "value": "waynoka"
  },
  {
    "text": "Wayside",
    "value": "wayside"
  },
  {
    "text": "Wayzata",
    "value": "wayzata"
  },
  {
    "text": "Weare",
    "value": "weare"
  },
  {
    "text": "Weatherby",
    "value": "weatherby"
  },
  {
    "text": "Weatherby Lake",
    "value": "weatherby lake"
  },
  {
    "text": "Weatherford",
    "value": "weatherford"
  },
  {
    "text": "Weatherly",
    "value": "weatherly"
  },
  {
    "text": "Weatogue",
    "value": "weatogue"
  },
  {
    "text": "Weaubleau",
    "value": "weaubleau"
  },
  {
    "text": "Weaver",
    "value": "weaver"
  },
  {
    "text": "Weaverville",
    "value": "weaverville"
  },
  {
    "text": "Webb",
    "value": "webb"
  },
  {
    "text": "Webb City",
    "value": "webb city"
  },
  {
    "text": "Webbers Falls",
    "value": "webbers falls"
  },
  {
    "text": "Webberville",
    "value": "webberville"
  },
  {
    "text": "Webbville",
    "value": "webbville"
  },
  {
    "text": "Weber City",
    "value": "weber city"
  },
  {
    "text": "Webster",
    "value": "webster"
  },
  {
    "text": "Webster City",
    "value": "webster city"
  },
  {
    "text": "Webster Groves",
    "value": "webster groves"
  },
  {
    "text": "Webster Springs",
    "value": "webster springs"
  },
  {
    "text": "Websterville",
    "value": "websterville"
  },
  {
    "text": "Weddington",
    "value": "weddington"
  },
  {
    "text": "Wedgefield",
    "value": "wedgefield"
  },
  {
    "text": "Wedowee",
    "value": "wedowee"
  },
  {
    "text": "Weed",
    "value": "weed"
  },
  {
    "text": "Weedsport",
    "value": "weedsport"
  },
  {
    "text": "Weedville",
    "value": "weedville"
  },
  {
    "text": "Weehawken",
    "value": "weehawken"
  },
  {
    "text": "Weeki Wachee",
    "value": "weeki wachee"
  },
  {
    "text": "Weeksbury",
    "value": "weeksbury"
  },
  {
    "text": "Weems",
    "value": "weems"
  },
  {
    "text": "Weeping Water",
    "value": "weeping water"
  },
  {
    "text": "Weesatche",
    "value": "weesatche"
  },
  {
    "text": "Weidman",
    "value": "weidman"
  },
  {
    "text": "Weimar",
    "value": "weimar"
  },
  {
    "text": "Weiner",
    "value": "weiner"
  },
  {
    "text": "Weinert",
    "value": "weinert"
  },
  {
    "text": "Weippe",
    "value": "weippe"
  },
  {
    "text": "Weir",
    "value": "weir"
  },
  {
    "text": "Weirsdale",
    "value": "weirsdale"
  },
  {
    "text": "Weirton",
    "value": "weirton"
  },
  {
    "text": "Weirton Heights",
    "value": "weirton heights"
  },
  {
    "text": "Weiser",
    "value": "weiser"
  },
  {
    "text": "Wekiwa Springs",
    "value": "wekiwa springs"
  },
  {
    "text": "Welaka",
    "value": "welaka"
  },
  {
    "text": "Welch",
    "value": "welch"
  },
  {
    "text": "Welches",
    "value": "welches"
  },
  {
    "text": "Welcome",
    "value": "welcome"
  },
  {
    "text": "Welcome Acres",
    "value": "welcome acres"
  },
  {
    "text": "Weld",
    "value": "weld"
  },
  {
    "text": "Welda",
    "value": "welda"
  },
  {
    "text": "Weldon",
    "value": "weldon"
  },
  {
    "text": "Weldon Spring",
    "value": "weldon spring"
  },
  {
    "text": "Weldona",
    "value": "weldona"
  },
  {
    "text": "Weleetka",
    "value": "weleetka"
  },
  {
    "text": "Wellborn",
    "value": "wellborn"
  },
  {
    "text": "Wellborn, Bryan-College Station",
    "value": "wellborn, bryan-college station"
  },
  {
    "text": "Wellersburg",
    "value": "wellersburg"
  },
  {
    "text": "Wellesley",
    "value": "wellesley"
  },
  {
    "text": "Wellesley Hills",
    "value": "wellesley hills"
  },
  {
    "text": "Wellesley Island",
    "value": "wellesley island"
  },
  {
    "text": "Wellfleet",
    "value": "wellfleet"
  },
  {
    "text": "Wellford",
    "value": "wellford"
  },
  {
    "text": "Welling",
    "value": "welling"
  },
  {
    "text": "Wellington",
    "value": "wellington"
  },
  {
    "text": "Wellman",
    "value": "wellman"
  },
  {
    "text": "Wellpinit",
    "value": "wellpinit"
  },
  {
    "text": "Wells",
    "value": "wells"
  },
  {
    "text": "Wells Branch",
    "value": "wells branch"
  },
  {
    "text": "Wells River",
    "value": "wells river"
  },
  {
    "text": "Wells Tannery",
    "value": "wells tannery"
  },
  {
    "text": "Wellsboro",
    "value": "wellsboro"
  },
  {
    "text": "Wellsburg",
    "value": "wellsburg"
  },
  {
    "text": "Wellsley",
    "value": "wellsley"
  },
  {
    "text": "Wellston",
    "value": "wellston"
  },
  {
    "text": "Wellsville",
    "value": "wellsville"
  },
  {
    "text": "Wellton",
    "value": "wellton"
  },
  {
    "text": "Welsh",
    "value": "welsh"
  },
  {
    "text": "Welton",
    "value": "welton"
  },
  {
    "text": "Wenatchee",
    "value": "wenatchee"
  },
  {
    "text": "Wendel",
    "value": "wendel"
  },
  {
    "text": "Wendell",
    "value": "wendell"
  },
  {
    "text": "Wenden",
    "value": "wenden"
  },
  {
    "text": "Wendover",
    "value": "wendover"
  },
  {
    "text": "Wenham",
    "value": "wenham"
  },
  {
    "text": "Wenona",
    "value": "wenona"
  },
  {
    "text": "Wenonah",
    "value": "wenonah"
  },
  {
    "text": "Wentworth",
    "value": "wentworth"
  },
  {
    "text": "Wentzville",
    "value": "wentzville"
  },
  {
    "text": "Weogufka",
    "value": "weogufka"
  },
  {
    "text": "Weott",
    "value": "weott"
  },
  {
    "text": "Wernersville",
    "value": "wernersville"
  },
  {
    "text": "Wescosville",
    "value": "wescosville"
  },
  {
    "text": "Weskan",
    "value": "weskan"
  },
  {
    "text": "Weslaco",
    "value": "weslaco"
  },
  {
    "text": "Wesley",
    "value": "wesley"
  },
  {
    "text": "Wesley Chapel",
    "value": "wesley chapel"
  },
  {
    "text": "Wesley Hills",
    "value": "wesley hills"
  },
  {
    "text": "Wesleyville",
    "value": "wesleyville"
  },
  {
    "text": "Wessington",
    "value": "wessington"
  },
  {
    "text": "Wessington Springs",
    "value": "wessington springs"
  },
  {
    "text": "Wesson",
    "value": "wesson"
  },
  {
    "text": "West",
    "value": "west"
  },
  {
    "text": "West Alexander",
    "value": "west alexander"
  },
  {
    "text": "West Alexandria",
    "value": "west alexandria"
  },
  {
    "text": "West Allis",
    "value": "west allis"
  },
  {
    "text": "West Alton",
    "value": "west alton"
  },
  {
    "text": "West Augusta",
    "value": "west augusta"
  },
  {
    "text": "West Babylon",
    "value": "west babylon"
  },
  {
    "text": "West Baden Springs",
    "value": "west baden springs"
  },
  {
    "text": "West Baldwin",
    "value": "west baldwin"
  },
  {
    "text": "West Baraboo",
    "value": "west baraboo"
  },
  {
    "text": "West Barnstable",
    "value": "west barnstable"
  },
  {
    "text": "West Bend",
    "value": "west bend"
  },
  {
    "text": "West Berlin",
    "value": "west berlin"
  },
  {
    "text": "West Bishop",
    "value": "west bishop"
  },
  {
    "text": "West Blocton",
    "value": "west blocton"
  },
  {
    "text": "West Bloomfield",
    "value": "west bloomfield"
  },
  {
    "text": "West Boothbay Harbor",
    "value": "west boothbay harbor"
  },
  {
    "text": "West Bountiful",
    "value": "west bountiful"
  },
  {
    "text": "West Boylston",
    "value": "west boylston"
  },
  {
    "text": "West Bradenton",
    "value": "west bradenton"
  },
  {
    "text": "West Branch",
    "value": "west branch"
  },
  {
    "text": "West Brattleboro",
    "value": "west brattleboro"
  },
  {
    "text": "West Bridgewater",
    "value": "west bridgewater"
  },
  {
    "text": "West Brookfield",
    "value": "west brookfield"
  },
  {
    "text": "West Brooklyn",
    "value": "west brooklyn"
  },
  {
    "text": "West Buechel",
    "value": "west buechel"
  },
  {
    "text": "West Burke",
    "value": "west burke"
  },
  {
    "text": "West Burlington",
    "value": "west burlington"
  },
  {
    "text": "West Caldwell",
    "value": "west caldwell"
  },
  {
    "text": "West Cape May",
    "value": "west cape may"
  },
  {
    "text": "West Carrollton City",
    "value": "west carrollton city"
  },
  {
    "text": "West Carson",
    "value": "west carson"
  },
  {
    "text": "West Carthage",
    "value": "west carthage"
  },
  {
    "text": "West Charleston",
    "value": "west charleston"
  },
  {
    "text": "West Chatham",
    "value": "west chatham"
  },
  {
    "text": "West Chazy",
    "value": "west chazy"
  },
  {
    "text": "West Chester",
    "value": "west chester"
  },
  {
    "text": "West Chesterfield",
    "value": "west chesterfield"
  },
  {
    "text": "West Chicago",
    "value": "west chicago"
  },
  {
    "text": "West College Corner",
    "value": "west college corner"
  },
  {
    "text": "West Columbia",
    "value": "west columbia"
  },
  {
    "text": "West Concord",
    "value": "west concord"
  },
  {
    "text": "West Conshohocken",
    "value": "west conshohocken"
  },
  {
    "text": "West Coon Rapids",
    "value": "west coon rapids"
  },
  {
    "text": "West Corinth",
    "value": "west corinth"
  },
  {
    "text": "West Cornwall",
    "value": "west cornwall"
  },
  {
    "text": "West Covina",
    "value": "west covina"
  },
  {
    "text": "West Coxsackie",
    "value": "west coxsackie"
  },
  {
    "text": "West Creek",
    "value": "west creek"
  },
  {
    "text": "West Crossett",
    "value": "west crossett"
  },
  {
    "text": "West Danville",
    "value": "west danville"
  },
  {
    "text": "West Decatur",
    "value": "west decatur"
  },
  {
    "text": "West Deer",
    "value": "west deer"
  },
  {
    "text": "West Dennis",
    "value": "west dennis"
  },
  {
    "text": "West Deptford Township",
    "value": "west deptford township"
  },
  {
    "text": "West Des Moines",
    "value": "west des moines"
  },
  {
    "text": "West Dover",
    "value": "west dover"
  },
  {
    "text": "West Dummerston",
    "value": "west dummerston"
  },
  {
    "text": "West Dundee",
    "value": "west dundee"
  },
  {
    "text": "West Easton",
    "value": "west easton"
  },
  {
    "text": "West Edmeston",
    "value": "west edmeston"
  },
  {
    "text": "West Elizabeth",
    "value": "west elizabeth"
  },
  {
    "text": "West Elkridge",
    "value": "west elkridge"
  },
  {
    "text": "West Elkton",
    "value": "west elkton"
  },
  {
    "text": "West End",
    "value": "west end"
  },
  {
    "text": "West Enfield",
    "value": "west enfield"
  },
  {
    "text": "West Fairlee",
    "value": "west fairlee"
  },
  {
    "text": "West Falls",
    "value": "west falls"
  },
  {
    "text": "West Falmouth",
    "value": "west falmouth"
  },
  {
    "text": "West Fargo",
    "value": "west fargo"
  },
  {
    "text": "West Farmington",
    "value": "west farmington"
  },
  {
    "text": "West Finley",
    "value": "west finley"
  },
  {
    "text": "West Fork",
    "value": "west fork"
  },
  {
    "text": "West Forks",
    "value": "west forks"
  },
  {
    "text": "West Frankfort",
    "value": "west frankfort"
  },
  {
    "text": "West Friendship",
    "value": "west friendship"
  },
  {
    "text": "West Fulton",
    "value": "west fulton"
  },
  {
    "text": "West Glacier",
    "value": "west glacier"
  },
  {
    "text": "West Glover",
    "value": "west glover"
  },
  {
    "text": "West Goshen",
    "value": "west goshen"
  },
  {
    "text": "West Granby",
    "value": "west granby"
  },
  {
    "text": "West Green",
    "value": "west green"
  },
  {
    "text": "West Greenwich",
    "value": "west greenwich"
  },
  {
    "text": "West Groton",
    "value": "west groton"
  },
  {
    "text": "West Grove",
    "value": "west grove"
  },
  {
    "text": "West Halifax",
    "value": "west halifax"
  },
  {
    "text": "West Hamlin",
    "value": "west hamlin"
  },
  {
    "text": "West Harrison",
    "value": "west harrison"
  },
  {
    "text": "West Hartford",
    "value": "west hartford"
  },
  {
    "text": "West Hartland",
    "value": "west hartland"
  },
  {
    "text": "West Hatfield",
    "value": "west hatfield"
  },
  {
    "text": "West Hattiesburg",
    "value": "west hattiesburg"
  },
  {
    "text": "West Haven",
    "value": "west haven"
  },
  {
    "text": "West Haverstraw",
    "value": "west haverstraw"
  },
  {
    "text": "West Hazleton",
    "value": "west hazleton"
  },
  {
    "text": "West Helena",
    "value": "west helena"
  },
  {
    "text": "West Hempstead",
    "value": "west hempstead"
  },
  {
    "text": "West Henrietta",
    "value": "west henrietta"
  },
  {
    "text": "West Hills",
    "value": "west hills"
  },
  {
    "text": "West Hollywood",
    "value": "west hollywood"
  },
  {
    "text": "West Homestead",
    "value": "west homestead"
  },
  {
    "text": "West Hurley",
    "value": "west hurley"
  },
  {
    "text": "West Ishpeming",
    "value": "west ishpeming"
  },
  {
    "text": "West Islip",
    "value": "west islip"
  },
  {
    "text": "West Jefferson",
    "value": "west jefferson"
  },
  {
    "text": "West Jordan",
    "value": "west jordan"
  },
  {
    "text": "West Kill",
    "value": "west kill"
  },
  {
    "text": "West Kingston",
    "value": "west kingston"
  },
  {
    "text": "West Kittanning",
    "value": "west kittanning"
  },
  {
    "text": "West Lafayette",
    "value": "west lafayette"
  },
  {
    "text": "West Lake Hills",
    "value": "west lake hills"
  },
  {
    "text": "West Lawn",
    "value": "west lawn"
  },
  {
    "text": "West Lebanon",
    "value": "west lebanon"
  },
  {
    "text": "West Leyden",
    "value": "west leyden"
  },
  {
    "text": "West Liberty",
    "value": "west liberty"
  },
  {
    "text": "West Linn",
    "value": "west linn"
  },
  {
    "text": "West Livingston",
    "value": "west livingston"
  },
  {
    "text": "West Long Branch",
    "value": "west long branch"
  },
  {
    "text": "West Manchester",
    "value": "west manchester"
  },
  {
    "text": "West Mansfield",
    "value": "west mansfield"
  },
  {
    "text": "West Marion",
    "value": "west marion"
  },
  {
    "text": "West McLean",
    "value": "west mclean"
  },
  {
    "text": "West Medford",
    "value": "west medford"
  },
  {
    "text": "West Melbourne",
    "value": "west melbourne"
  },
  {
    "text": "West Memphis",
    "value": "west memphis"
  },
  {
    "text": "West Menlo Park",
    "value": "west menlo park"
  },
  {
    "text": "West Miami",
    "value": "west miami"
  },
  {
    "text": "West Middlesex",
    "value": "west middlesex"
  },
  {
    "text": "West Mifflin",
    "value": "west mifflin"
  },
  {
    "text": "West Milford",
    "value": "west milford"
  },
  {
    "text": "West Milton",
    "value": "west milton"
  },
  {
    "text": "West Milwaukee",
    "value": "west milwaukee"
  },
  {
    "text": "West Mineral",
    "value": "west mineral"
  },
  {
    "text": "West Monroe",
    "value": "west monroe"
  },
  {
    "text": "West New York",
    "value": "west new york"
  },
  {
    "text": "West Newbury",
    "value": "west newbury"
  },
  {
    "text": "West Newfield",
    "value": "west newfield"
  },
  {
    "text": "West Newton",
    "value": "west newton"
  },
  {
    "text": "West Norriton",
    "value": "west norriton"
  },
  {
    "text": "West Nyack",
    "value": "west nyack"
  },
  {
    "text": "West Ocean City",
    "value": "west ocean city"
  },
  {
    "text": "West Olive",
    "value": "west olive"
  },
  {
    "text": "West Orange",
    "value": "west orange"
  },
  {
    "text": "West Ossipee",
    "value": "west ossipee"
  },
  {
    "text": "West Paducah",
    "value": "west paducah"
  },
  {
    "text": "West Palm Beach",
    "value": "west palm beach"
  },
  {
    "text": "West Paris",
    "value": "west paris"
  },
  {
    "text": "West Park",
    "value": "west park"
  },
  {
    "text": "West Pawlet",
    "value": "west pawlet"
  },
  {
    "text": "West Peoria",
    "value": "west peoria"
  },
  {
    "text": "West Perrine",
    "value": "west perrine"
  },
  {
    "text": "West Peterborough",
    "value": "west peterborough"
  },
  {
    "text": "West Pittsburg",
    "value": "west pittsburg"
  },
  {
    "text": "West Pittston",
    "value": "west pittston"
  },
  {
    "text": "West Plains",
    "value": "west plains"
  },
  {
    "text": "West Pleasant View",
    "value": "west pleasant view"
  },
  {
    "text": "West Point",
    "value": "west point"
  },
  {
    "text": "West Portsmouth",
    "value": "west portsmouth"
  },
  {
    "text": "West Puente Valley",
    "value": "west puente valley"
  },
  {
    "text": "West Rancho Dominguez",
    "value": "west rancho dominguez"
  },
  {
    "text": "West Reading",
    "value": "west reading"
  },
  {
    "text": "West Richland",
    "value": "west richland"
  },
  {
    "text": "West Ridge",
    "value": "west ridge"
  },
  {
    "text": "West River",
    "value": "west river"
  },
  {
    "text": "West Rockport",
    "value": "west rockport"
  },
  {
    "text": "West Roxbury",
    "value": "west roxbury"
  },
  {
    "text": "West Rupert",
    "value": "west rupert"
  },
  {
    "text": "West Rutland",
    "value": "west rutland"
  },
  {
    "text": "West Sacramento",
    "value": "west sacramento"
  },
  {
    "text": "West Saint Paul",
    "value": "west saint paul"
  },
  {
    "text": "West Salem",
    "value": "west salem"
  },
  {
    "text": "West Salisbury",
    "value": "west salisbury"
  },
  {
    "text": "West Sand Lake",
    "value": "west sand lake"
  },
  {
    "text": "West Sayville",
    "value": "west sayville"
  },
  {
    "text": "West Seneca",
    "value": "west seneca"
  },
  {
    "text": "West Shokan",
    "value": "west shokan"
  },
  {
    "text": "West Side",
    "value": "west side"
  },
  {
    "text": "West Simsbury",
    "value": "west simsbury"
  },
  {
    "text": "West Somerset",
    "value": "west somerset"
  },
  {
    "text": "West Springfield",
    "value": "west springfield"
  },
  {
    "text": "West Stewartstown",
    "value": "west stewartstown"
  },
  {
    "text": "West Stockbridge",
    "value": "west stockbridge"
  },
  {
    "text": "West Suffield",
    "value": "west suffield"
  },
  {
    "text": "West Sunbury",
    "value": "west sunbury"
  },
  {
    "text": "West Swanzey",
    "value": "west swanzey"
  },
  {
    "text": "West Terre Haute",
    "value": "west terre haute"
  },
  {
    "text": "West Tisbury",
    "value": "west tisbury"
  },
  {
    "text": "West Topsham",
    "value": "west topsham"
  },
  {
    "text": "West Townsend",
    "value": "west townsend"
  },
  {
    "text": "West Townshend",
    "value": "west townshend"
  },
  {
    "text": "West Union",
    "value": "west union"
  },
  {
    "text": "West Unity",
    "value": "west unity"
  },
  {
    "text": "West University Place",
    "value": "west university place"
  },
  {
    "text": "West Valley",
    "value": "west valley"
  },
  {
    "text": "West Valley City",
    "value": "west valley city"
  },
  {
    "text": "West Van Lear",
    "value": "west van lear"
  },
  {
    "text": "West View",
    "value": "west view"
  },
  {
    "text": "West Wardsboro",
    "value": "west wardsboro"
  },
  {
    "text": "West Wareham",
    "value": "west wareham"
  },
  {
    "text": "West Warren",
    "value": "west warren"
  },
  {
    "text": "West Warwick",
    "value": "west warwick"
  },
  {
    "text": "West Wendover",
    "value": "west wendover"
  },
  {
    "text": "West Whittier-Los Nietos",
    "value": "west whittier-los nietos"
  },
  {
    "text": "West Winfield",
    "value": "west winfield"
  },
  {
    "text": "West Wyoming",
    "value": "west wyoming"
  },
  {
    "text": "West Yarmouth",
    "value": "west yarmouth"
  },
  {
    "text": "West Yellowstone",
    "value": "west yellowstone"
  },
  {
    "text": "West York",
    "value": "west york"
  },
  {
    "text": "West and East Lealman",
    "value": "west and east lealman"
  },
  {
    "text": "Westboro",
    "value": "westboro"
  },
  {
    "text": "Westborough",
    "value": "westborough"
  },
  {
    "text": "Westbrook",
    "value": "westbrook"
  },
  {
    "text": "Westbrookville",
    "value": "westbrookville"
  },
  {
    "text": "Westbury",
    "value": "westbury"
  },
  {
    "text": "Westby",
    "value": "westby"
  },
  {
    "text": "Westchase",
    "value": "westchase"
  },
  {
    "text": "Westchester",
    "value": "westchester"
  },
  {
    "text": "Westcliffe",
    "value": "westcliffe"
  },
  {
    "text": "Westcreek",
    "value": "westcreek"
  },
  {
    "text": "Westerlo",
    "value": "westerlo"
  },
  {
    "text": "Westerly",
    "value": "westerly"
  },
  {
    "text": "Western",
    "value": "western"
  },
  {
    "text": "Western Grove",
    "value": "western grove"
  },
  {
    "text": "Western Springs",
    "value": "western springs"
  },
  {
    "text": "Westernport",
    "value": "westernport"
  },
  {
    "text": "Westernville",
    "value": "westernville"
  },
  {
    "text": "Westerville",
    "value": "westerville"
  },
  {
    "text": "Westfield",
    "value": "westfield"
  },
  {
    "text": "Westfield Center",
    "value": "westfield center"
  },
  {
    "text": "Westfir",
    "value": "westfir"
  },
  {
    "text": "Westford",
    "value": "westford"
  },
  {
    "text": "Westgate",
    "value": "westgate"
  },
  {
    "text": "Westhampton",
    "value": "westhampton"
  },
  {
    "text": "Westhampton Beach",
    "value": "westhampton beach"
  },
  {
    "text": "Westhaven-Moonstone",
    "value": "westhaven-moonstone"
  },
  {
    "text": "Westhoff",
    "value": "westhoff"
  },
  {
    "text": "Westhope",
    "value": "westhope"
  },
  {
    "text": "Westlake",
    "value": "westlake"
  },
  {
    "text": "Westlake Village",
    "value": "westlake village"
  },
  {
    "text": "Westland",
    "value": "westland"
  },
  {
    "text": "Westley",
    "value": "westley"
  },
  {
    "text": "Westminster",
    "value": "westminster"
  },
  {
    "text": "Westminster Station",
    "value": "westminster station"
  },
  {
    "text": "Westmont",
    "value": "westmont"
  },
  {
    "text": "Westmoreland",
    "value": "westmoreland"
  },
  {
    "text": "Westmoreland City",
    "value": "westmoreland city"
  },
  {
    "text": "Westmorland",
    "value": "westmorland"
  },
  {
    "text": "Weston",
    "value": "weston"
  },
  {
    "text": "Weston Lakes",
    "value": "weston lakes"
  },
  {
    "text": "Weston Mills",
    "value": "weston mills"
  },
  {
    "text": "Westover",
    "value": "westover"
  },
  {
    "text": "Westphalia",
    "value": "westphalia"
  },
  {
    "text": "Westpoint",
    "value": "westpoint"
  },
  {
    "text": "Westport",
    "value": "westport"
  },
  {
    "text": "Westside",
    "value": "westside"
  },
  {
    "text": "Westtown",
    "value": "westtown"
  },
  {
    "text": "Westvale",
    "value": "westvale"
  },
  {
    "text": "Westview",
    "value": "westview"
  },
  {
    "text": "Westville",
    "value": "westville"
  },
  {
    "text": "Westwego",
    "value": "westwego"
  },
  {
    "text": "Westwood",
    "value": "westwood"
  },
  {
    "text": "Wethersfield",
    "value": "wethersfield"
  },
  {
    "text": "Wetmore",
    "value": "wetmore"
  },
  {
    "text": "Wetumka",
    "value": "wetumka"
  },
  {
    "text": "Wetumpka",
    "value": "wetumpka"
  },
  {
    "text": "Wever",
    "value": "wever"
  },
  {
    "text": "Wevertown",
    "value": "wevertown"
  },
  {
    "text": "Wewahitchka",
    "value": "wewahitchka"
  },
  {
    "text": "Wewoka",
    "value": "wewoka"
  },
  {
    "text": "Wexford",
    "value": "wexford"
  },
  {
    "text": "Weyauwega",
    "value": "weyauwega"
  },
  {
    "text": "Weyerhaeuser",
    "value": "weyerhaeuser"
  },
  {
    "text": "Weyers Cave",
    "value": "weyers cave"
  },
  {
    "text": "Weymouth",
    "value": "weymouth"
  },
  {
    "text": "Whaleyville",
    "value": "whaleyville"
  },
  {
    "text": "Wharncliffe",
    "value": "wharncliffe"
  },
  {
    "text": "Wharton",
    "value": "wharton"
  },
  {
    "text": "What Cheer",
    "value": "what cheer"
  },
  {
    "text": "Whately",
    "value": "whately"
  },
  {
    "text": "Whatley",
    "value": "whatley"
  },
  {
    "text": "Wheat Ridge",
    "value": "wheat ridge"
  },
  {
    "text": "Wheatfield",
    "value": "wheatfield"
  },
  {
    "text": "Wheatland",
    "value": "wheatland"
  },
  {
    "text": "Wheatland Center",
    "value": "wheatland center"
  },
  {
    "text": "Wheatley",
    "value": "wheatley"
  },
  {
    "text": "Wheatley Heights",
    "value": "wheatley heights"
  },
  {
    "text": "Wheaton",
    "value": "wheaton"
  },
  {
    "text": "Wheaton-Glenmont",
    "value": "wheaton-glenmont"
  },
  {
    "text": "Wheeler",
    "value": "wheeler"
  },
  {
    "text": "Wheelersburg",
    "value": "wheelersburg"
  },
  {
    "text": "Wheeling",
    "value": "wheeling"
  },
  {
    "text": "Wheelwright",
    "value": "wheelwright"
  },
  {
    "text": "Whigham",
    "value": "whigham"
  },
  {
    "text": "Whippany",
    "value": "whippany"
  },
  {
    "text": "Whipple",
    "value": "whipple"
  },
  {
    "text": "Whiskeytown",
    "value": "whiskeytown"
  },
  {
    "text": "Whispering Pines",
    "value": "whispering pines"
  },
  {
    "text": "Whitakers",
    "value": "whitakers"
  },
  {
    "text": "White",
    "value": "white"
  },
  {
    "text": "White Bear Lake",
    "value": "white bear lake"
  },
  {
    "text": "White Bird",
    "value": "white bird"
  },
  {
    "text": "White Bluff",
    "value": "white bluff"
  },
  {
    "text": "White Castle",
    "value": "white castle"
  },
  {
    "text": "White Center",
    "value": "white center"
  },
  {
    "text": "White City",
    "value": "white city"
  },
  {
    "text": "White Cloud",
    "value": "white cloud"
  },
  {
    "text": "White Deer",
    "value": "white deer"
  },
  {
    "text": "White Earth",
    "value": "white earth"
  },
  {
    "text": "White Hall",
    "value": "white hall"
  },
  {
    "text": "White Haven",
    "value": "white haven"
  },
  {
    "text": "White Heath",
    "value": "white heath"
  },
  {
    "text": "White Hills",
    "value": "white hills"
  },
  {
    "text": "White House",
    "value": "white house"
  },
  {
    "text": "White Lake",
    "value": "white lake"
  },
  {
    "text": "White Marsh",
    "value": "white marsh"
  },
  {
    "text": "White Mills",
    "value": "white mills"
  },
  {
    "text": "White Mountain Lake",
    "value": "white mountain lake"
  },
  {
    "text": "White Oak",
    "value": "white oak"
  },
  {
    "text": "White Owl",
    "value": "white owl"
  },
  {
    "text": "White Pigeon",
    "value": "white pigeon"
  },
  {
    "text": "White Pine",
    "value": "white pine"
  },
  {
    "text": "White Plains",
    "value": "white plains"
  },
  {
    "text": "White Post",
    "value": "white post"
  },
  {
    "text": "White River",
    "value": "white river"
  },
  {
    "text": "White River Junction",
    "value": "white river junction"
  },
  {
    "text": "White Rock",
    "value": "white rock"
  },
  {
    "text": "White Salmon",
    "value": "white salmon"
  },
  {
    "text": "White Sands",
    "value": "white sands"
  },
  {
    "text": "White Settlement",
    "value": "white settlement"
  },
  {
    "text": "White Springs",
    "value": "white springs"
  },
  {
    "text": "White Stone",
    "value": "white stone"
  },
  {
    "text": "White Sulphur Springs",
    "value": "white sulphur springs"
  },
  {
    "text": "White Swan",
    "value": "white swan"
  },
  {
    "text": "White Water",
    "value": "white water"
  },
  {
    "text": "Whiteface",
    "value": "whiteface"
  },
  {
    "text": "Whitefield",
    "value": "whitefield"
  },
  {
    "text": "Whitefish",
    "value": "whitefish"
  },
  {
    "text": "Whitefish Bay",
    "value": "whitefish bay"
  },
  {
    "text": "Whiteford",
    "value": "whiteford"
  },
  {
    "text": "Whitehall",
    "value": "whitehall"
  },
  {
    "text": "Whitehall Township",
    "value": "whitehall township"
  },
  {
    "text": "Whitehaven",
    "value": "whitehaven"
  },
  {
    "text": "Whitehouse",
    "value": "whitehouse"
  },
  {
    "text": "Whitehouse Station",
    "value": "whitehouse station"
  },
  {
    "text": "Whiteland",
    "value": "whiteland"
  },
  {
    "text": "Whitelaw",
    "value": "whitelaw"
  },
  {
    "text": "Whiteman Air Force Base",
    "value": "whiteman air force base"
  },
  {
    "text": "Whiteriver",
    "value": "whiteriver"
  },
  {
    "text": "Whites City",
    "value": "whites city"
  },
  {
    "text": "Whites Creek",
    "value": "whites creek"
  },
  {
    "text": "Whitesboro",
    "value": "whitesboro"
  },
  {
    "text": "Whitesburg",
    "value": "whitesburg"
  },
  {
    "text": "Whiteside",
    "value": "whiteside"
  },
  {
    "text": "Whitestone",
    "value": "whitestone"
  },
  {
    "text": "Whitestown",
    "value": "whitestown"
  },
  {
    "text": "Whitesville",
    "value": "whitesville"
  },
  {
    "text": "Whitethorn",
    "value": "whitethorn"
  },
  {
    "text": "Whitetop",
    "value": "whitetop"
  },
  {
    "text": "Whiteville",
    "value": "whiteville"
  },
  {
    "text": "Whitewater",
    "value": "whitewater"
  },
  {
    "text": "Whitewood",
    "value": "whitewood"
  },
  {
    "text": "Whitewright",
    "value": "whitewright"
  },
  {
    "text": "Whitfield",
    "value": "whitfield"
  },
  {
    "text": "Whiting",
    "value": "whiting"
  },
  {
    "text": "Whitingham",
    "value": "whitingham"
  },
  {
    "text": "Whitinsville",
    "value": "whitinsville"
  },
  {
    "text": "Whitlash",
    "value": "whitlash"
  },
  {
    "text": "Whitley City",
    "value": "whitley city"
  },
  {
    "text": "Whitleyville",
    "value": "whitleyville"
  },
  {
    "text": "Whitman",
    "value": "whitman"
  },
  {
    "text": "Whitmer",
    "value": "whitmer"
  },
  {
    "text": "Whitmire",
    "value": "whitmire"
  },
  {
    "text": "Whitmore",
    "value": "whitmore"
  },
  {
    "text": "Whitmore Lake",
    "value": "whitmore lake"
  },
  {
    "text": "Whitney",
    "value": "whitney"
  },
  {
    "text": "Whitney Point",
    "value": "whitney point"
  },
  {
    "text": "Whitsett",
    "value": "whitsett"
  },
  {
    "text": "Whittaker",
    "value": "whittaker"
  },
  {
    "text": "Whittemore",
    "value": "whittemore"
  },
  {
    "text": "Whittier",
    "value": "whittier"
  },
  {
    "text": "Whittington",
    "value": "whittington"
  },
  {
    "text": "Whitwell",
    "value": "whitwell"
  },
  {
    "text": "Wibaux",
    "value": "wibaux"
  },
  {
    "text": "Wichita",
    "value": "wichita"
  },
  {
    "text": "Wichita Falls",
    "value": "wichita falls"
  },
  {
    "text": "Wickatunk",
    "value": "wickatunk"
  },
  {
    "text": "Wickenburg",
    "value": "wickenburg"
  },
  {
    "text": "Wickes",
    "value": "wickes"
  },
  {
    "text": "Wickett",
    "value": "wickett"
  },
  {
    "text": "Wickliffe",
    "value": "wickliffe"
  },
  {
    "text": "Wicomico Church",
    "value": "wicomico church"
  },
  {
    "text": "Wiconisco",
    "value": "wiconisco"
  },
  {
    "text": "Wideman",
    "value": "wideman"
  },
  {
    "text": "Widen",
    "value": "widen"
  },
  {
    "text": "Widener",
    "value": "widener"
  },
  {
    "text": "Wiergate",
    "value": "wiergate"
  },
  {
    "text": "Wiggins",
    "value": "wiggins"
  },
  {
    "text": "Wikieup",
    "value": "wikieup"
  },
  {
    "text": "Wilber",
    "value": "wilber"
  },
  {
    "text": "Wilberforce",
    "value": "wilberforce"
  },
  {
    "text": "Wilbraham",
    "value": "wilbraham"
  },
  {
    "text": "Wilbur",
    "value": "wilbur"
  },
  {
    "text": "Wilburn",
    "value": "wilburn"
  },
  {
    "text": "Wilburton",
    "value": "wilburton"
  },
  {
    "text": "Wilcoe",
    "value": "wilcoe"
  },
  {
    "text": "Wilcox",
    "value": "wilcox"
  },
  {
    "text": "Wild Horse",
    "value": "wild horse"
  },
  {
    "text": "Wild Rose",
    "value": "wild rose"
  },
  {
    "text": "Wilder",
    "value": "wilder"
  },
  {
    "text": "Wildersville",
    "value": "wildersville"
  },
  {
    "text": "Wilderville",
    "value": "wilderville"
  },
  {
    "text": "Wildomar",
    "value": "wildomar"
  },
  {
    "text": "Wildorado",
    "value": "wildorado"
  },
  {
    "text": "Wildrose",
    "value": "wildrose"
  },
  {
    "text": "Wildwood",
    "value": "wildwood"
  },
  {
    "text": "Wildwood Crest",
    "value": "wildwood crest"
  },
  {
    "text": "Wiley",
    "value": "wiley"
  },
  {
    "text": "Wilkes-Barre",
    "value": "wilkes-barre"
  },
  {
    "text": "Wilkesboro",
    "value": "wilkesboro"
  },
  {
    "text": "Wilkeson",
    "value": "wilkeson"
  },
  {
    "text": "Wilkesville",
    "value": "wilkesville"
  },
  {
    "text": "Wilkinsburg",
    "value": "wilkinsburg"
  },
  {
    "text": "Wilkinson",
    "value": "wilkinson"
  },
  {
    "text": "Willacoochee",
    "value": "willacoochee"
  },
  {
    "text": "Willamina",
    "value": "willamina"
  },
  {
    "text": "Willard",
    "value": "willard"
  },
  {
    "text": "Willards",
    "value": "willards"
  },
  {
    "text": "Willcox",
    "value": "willcox"
  },
  {
    "text": "Willernie",
    "value": "willernie"
  },
  {
    "text": "Williams",
    "value": "williams"
  },
  {
    "text": "Williams Bay",
    "value": "williams bay"
  },
  {
    "text": "Williamsburg",
    "value": "williamsburg"
  },
  {
    "text": "Williamsfield",
    "value": "williamsfield"
  },
  {
    "text": "Williamson",
    "value": "williamson"
  },
  {
    "text": "Williamsport",
    "value": "williamsport"
  },
  {
    "text": "Williamston",
    "value": "williamston"
  },
  {
    "text": "Williamstown",
    "value": "williamstown"
  },
  {
    "text": "Williamsville",
    "value": "williamsville"
  },
  {
    "text": "Williamsville Station",
    "value": "williamsville station"
  },
  {
    "text": "Williford",
    "value": "williford"
  },
  {
    "text": "Willimantic",
    "value": "willimantic"
  },
  {
    "text": "Willingboro",
    "value": "willingboro"
  },
  {
    "text": "Willington",
    "value": "willington"
  },
  {
    "text": "Willington Hill",
    "value": "willington hill"
  },
  {
    "text": "Willis",
    "value": "willis"
  },
  {
    "text": "Willisburg",
    "value": "willisburg"
  },
  {
    "text": "Williston",
    "value": "williston"
  },
  {
    "text": "Williston Park",
    "value": "williston park"
  },
  {
    "text": "Willisville",
    "value": "willisville"
  },
  {
    "text": "Willits",
    "value": "willits"
  },
  {
    "text": "Willmar",
    "value": "willmar"
  },
  {
    "text": "Willoughby",
    "value": "willoughby"
  },
  {
    "text": "Willoughby Hills",
    "value": "willoughby hills"
  },
  {
    "text": "Willow",
    "value": "willow"
  },
  {
    "text": "Willow City",
    "value": "willow city"
  },
  {
    "text": "Willow Creek",
    "value": "willow creek"
  },
  {
    "text": "Willow Grove",
    "value": "willow grove"
  },
  {
    "text": "Willow Hill",
    "value": "willow hill"
  },
  {
    "text": "Willow Island",
    "value": "willow island"
  },
  {
    "text": "Willow Lake",
    "value": "willow lake"
  },
  {
    "text": "Willow Park",
    "value": "willow park"
  },
  {
    "text": "Willow River",
    "value": "willow river"
  },
  {
    "text": "Willow Spring",
    "value": "willow spring"
  },
  {
    "text": "Willow Springs",
    "value": "willow springs"
  },
  {
    "text": "Willow Street",
    "value": "willow street"
  },
  {
    "text": "Willow Valley",
    "value": "willow valley"
  },
  {
    "text": "Willow Wood",
    "value": "willow wood"
  },
  {
    "text": "Willowbrook",
    "value": "willowbrook"
  },
  {
    "text": "Willowick",
    "value": "willowick"
  },
  {
    "text": "Willows",
    "value": "willows"
  },
  {
    "text": "Wills Point",
    "value": "wills point"
  },
  {
    "text": "Willsboro",
    "value": "willsboro"
  },
  {
    "text": "Willseyville",
    "value": "willseyville"
  },
  {
    "text": "Willshire",
    "value": "willshire"
  },
  {
    "text": "Wilmar",
    "value": "wilmar"
  },
  {
    "text": "Wilmer",
    "value": "wilmer"
  },
  {
    "text": "Wilmerding",
    "value": "wilmerding"
  },
  {
    "text": "Wilmette",
    "value": "wilmette"
  },
  {
    "text": "Wilmington",
    "value": "wilmington"
  },
  {
    "text": "Wilmington Island",
    "value": "wilmington island"
  },
  {
    "text": "Wilmington Manor",
    "value": "wilmington manor"
  },
  {
    "text": "Wilmont",
    "value": "wilmont"
  },
  {
    "text": "Wilmore",
    "value": "wilmore"
  },
  {
    "text": "Wilmot",
    "value": "wilmot"
  },
  {
    "text": "Wilsall",
    "value": "wilsall"
  },
  {
    "text": "Wilsey",
    "value": "wilsey"
  },
  {
    "text": "Wilseyville",
    "value": "wilseyville"
  },
  {
    "text": "Wilson",
    "value": "wilson"
  },
  {
    "text": "Wilsondale",
    "value": "wilsondale"
  },
  {
    "text": "Wilsons",
    "value": "wilsons"
  },
  {
    "text": "Wilsons Mills",
    "value": "wilsons mills"
  },
  {
    "text": "Wilsonville",
    "value": "wilsonville"
  },
  {
    "text": "Wilton",
    "value": "wilton"
  },
  {
    "text": "Wilton Manors",
    "value": "wilton manors"
  },
  {
    "text": "Wimauma",
    "value": "wimauma"
  },
  {
    "text": "Wimberley",
    "value": "wimberley"
  },
  {
    "text": "Wimbledon",
    "value": "wimbledon"
  },
  {
    "text": "Winamac",
    "value": "winamac"
  },
  {
    "text": "Winburne",
    "value": "winburne"
  },
  {
    "text": "Winchendon",
    "value": "winchendon"
  },
  {
    "text": "Winchester",
    "value": "winchester"
  },
  {
    "text": "Winchester Center",
    "value": "winchester center"
  },
  {
    "text": "Wind Gap",
    "value": "wind gap"
  },
  {
    "text": "Wind Lake",
    "value": "wind lake"
  },
  {
    "text": "Wind Point",
    "value": "wind point"
  },
  {
    "text": "Wind Ridge",
    "value": "wind ridge"
  },
  {
    "text": "Windber",
    "value": "windber"
  },
  {
    "text": "Windcrest",
    "value": "windcrest"
  },
  {
    "text": "Winder",
    "value": "winder"
  },
  {
    "text": "Windermere",
    "value": "windermere"
  },
  {
    "text": "Windfall",
    "value": "windfall"
  },
  {
    "text": "Windham",
    "value": "windham"
  },
  {
    "text": "Windham Center",
    "value": "windham center"
  },
  {
    "text": "Windom",
    "value": "windom"
  },
  {
    "text": "Window Rock",
    "value": "window rock"
  },
  {
    "text": "Windsor",
    "value": "windsor"
  },
  {
    "text": "Windsor Heights",
    "value": "windsor heights"
  },
  {
    "text": "Windsor Locks",
    "value": "windsor locks"
  },
  {
    "text": "Windsor Mill",
    "value": "windsor mill"
  },
  {
    "text": "Windthorst",
    "value": "windthorst"
  },
  {
    "text": "Windy Hills",
    "value": "windy hills"
  },
  {
    "text": "Windyville",
    "value": "windyville"
  },
  {
    "text": "Winesburg",
    "value": "winesburg"
  },
  {
    "text": "Winfield",
    "value": "winfield"
  },
  {
    "text": "Winfred",
    "value": "winfred"
  },
  {
    "text": "Wing",
    "value": "wing"
  },
  {
    "text": "Wingate",
    "value": "wingate"
  },
  {
    "text": "Wingdale",
    "value": "wingdale"
  },
  {
    "text": "Winger",
    "value": "winger"
  },
  {
    "text": "Wingett Run",
    "value": "wingett run"
  },
  {
    "text": "Wingina",
    "value": "wingina"
  },
  {
    "text": "Wingo",
    "value": "wingo"
  },
  {
    "text": "Winifred",
    "value": "winifred"
  },
  {
    "text": "Winifrede",
    "value": "winifrede"
  },
  {
    "text": "Wink",
    "value": "wink"
  },
  {
    "text": "Winkelman",
    "value": "winkelman"
  },
  {
    "text": "Winlock",
    "value": "winlock"
  },
  {
    "text": "Winn",
    "value": "winn"
  },
  {
    "text": "Winnabow",
    "value": "winnabow"
  },
  {
    "text": "Winnebago",
    "value": "winnebago"
  },
  {
    "text": "Winneconne",
    "value": "winneconne"
  },
  {
    "text": "Winnemucca",
    "value": "winnemucca"
  },
  {
    "text": "Winner",
    "value": "winner"
  },
  {
    "text": "Winnetka",
    "value": "winnetka"
  },
  {
    "text": "Winnetoon",
    "value": "winnetoon"
  },
  {
    "text": "Winnett",
    "value": "winnett"
  },
  {
    "text": "Winnfield",
    "value": "winnfield"
  },
  {
    "text": "Winnie",
    "value": "winnie"
  },
  {
    "text": "Winnsboro",
    "value": "winnsboro"
  },
  {
    "text": "Winona",
    "value": "winona"
  },
  {
    "text": "Winona Lake",
    "value": "winona lake"
  },
  {
    "text": "Winooski",
    "value": "winooski"
  },
  {
    "text": "Winside",
    "value": "winside"
  },
  {
    "text": "Winslow",
    "value": "winslow"
  },
  {
    "text": "Winslow Township",
    "value": "winslow township"
  },
  {
    "text": "Winsted",
    "value": "winsted"
  },
  {
    "text": "Winston",
    "value": "winston"
  },
  {
    "text": "Winston-Salem",
    "value": "winston-salem"
  },
  {
    "text": "Winter",
    "value": "winter"
  },
  {
    "text": "Winter Beach",
    "value": "winter beach"
  },
  {
    "text": "Winter Garden",
    "value": "winter garden"
  },
  {
    "text": "Winter Gardens",
    "value": "winter gardens"
  },
  {
    "text": "Winter Harbor",
    "value": "winter harbor"
  },
  {
    "text": "Winter Haven",
    "value": "winter haven"
  },
  {
    "text": "Winter Park",
    "value": "winter park"
  },
  {
    "text": "Winter Springs",
    "value": "winter springs"
  },
  {
    "text": "Winterhaven",
    "value": "winterhaven"
  },
  {
    "text": "Winterport",
    "value": "winterport"
  },
  {
    "text": "Winters",
    "value": "winters"
  },
  {
    "text": "Winterset",
    "value": "winterset"
  },
  {
    "text": "Wintersville",
    "value": "wintersville"
  },
  {
    "text": "Winterthur",
    "value": "winterthur"
  },
  {
    "text": "Winterville",
    "value": "winterville"
  },
  {
    "text": "Winthrop",
    "value": "winthrop"
  },
  {
    "text": "Winthrop Center",
    "value": "winthrop center"
  },
  {
    "text": "Winthrop Harbor",
    "value": "winthrop harbor"
  },
  {
    "text": "Winton",
    "value": "winton"
  },
  {
    "text": "Wiota",
    "value": "wiota"
  },
  {
    "text": "Wirt",
    "value": "wirt"
  },
  {
    "text": "Wirtz",
    "value": "wirtz"
  },
  {
    "text": "Wiscasset",
    "value": "wiscasset"
  },
  {
    "text": "Wisconsin Dells",
    "value": "wisconsin dells"
  },
  {
    "text": "Wisconsin Rapids",
    "value": "wisconsin rapids"
  },
  {
    "text": "Wisdom",
    "value": "wisdom"
  },
  {
    "text": "Wise",
    "value": "wise"
  },
  {
    "text": "Wise River",
    "value": "wise river"
  },
  {
    "text": "Wishek",
    "value": "wishek"
  },
  {
    "text": "Wishon",
    "value": "wishon"
  },
  {
    "text": "Wishram",
    "value": "wishram"
  },
  {
    "text": "Wisner",
    "value": "wisner"
  },
  {
    "text": "Wister",
    "value": "wister"
  },
  {
    "text": "Withamsville",
    "value": "withamsville"
  },
  {
    "text": "Withee",
    "value": "withee"
  },
  {
    "text": "Witherbee",
    "value": "witherbee"
  },
  {
    "text": "Witmer",
    "value": "witmer"
  },
  {
    "text": "Witt",
    "value": "witt"
  },
  {
    "text": "Witten",
    "value": "witten"
  },
  {
    "text": "Wittenberg",
    "value": "wittenberg"
  },
  {
    "text": "Witter",
    "value": "witter"
  },
  {
    "text": "Wittman",
    "value": "wittman"
  },
  {
    "text": "Wittmann",
    "value": "wittmann"
  },
  {
    "text": "Witts Springs",
    "value": "witts springs"
  },
  {
    "text": "Wixom",
    "value": "wixom"
  },
  {
    "text": "Woburn",
    "value": "woburn"
  },
  {
    "text": "Woden",
    "value": "woden"
  },
  {
    "text": "Wofford Heights",
    "value": "wofford heights"
  },
  {
    "text": "Wolbach",
    "value": "wolbach"
  },
  {
    "text": "Wolcott",
    "value": "wolcott"
  },
  {
    "text": "Wolcottville",
    "value": "wolcottville"
  },
  {
    "text": "Wolf",
    "value": "wolf"
  },
  {
    "text": "Wolf Creek",
    "value": "wolf creek"
  },
  {
    "text": "Wolf Lake",
    "value": "wolf lake"
  },
  {
    "text": "Wolf Point",
    "value": "wolf point"
  },
  {
    "text": "Wolf Trap",
    "value": "wolf trap"
  },
  {
    "text": "Wolfcreek",
    "value": "wolfcreek"
  },
  {
    "text": "Wolfe",
    "value": "wolfe"
  },
  {
    "text": "Wolfe City",
    "value": "wolfe city"
  },
  {
    "text": "Wolfeboro",
    "value": "wolfeboro"
  },
  {
    "text": "Wolfeboro Falls",
    "value": "wolfeboro falls"
  },
  {
    "text": "Wolfforth",
    "value": "wolfforth"
  },
  {
    "text": "Wolford",
    "value": "wolford"
  },
  {
    "text": "Wolsey",
    "value": "wolsey"
  },
  {
    "text": "Wolverine",
    "value": "wolverine"
  },
  {
    "text": "Wolverine Lake",
    "value": "wolverine lake"
  },
  {
    "text": "Wolverton",
    "value": "wolverton"
  },
  {
    "text": "Womelsdorf",
    "value": "womelsdorf"
  },
  {
    "text": "Wonder Lake",
    "value": "wonder lake"
  },
  {
    "text": "Wonewoc",
    "value": "wonewoc"
  },
  {
    "text": "Wood",
    "value": "wood"
  },
  {
    "text": "Wood Dale",
    "value": "wood dale"
  },
  {
    "text": "Wood Lake",
    "value": "wood lake"
  },
  {
    "text": "Wood River",
    "value": "wood river"
  },
  {
    "text": "Wood River Junction",
    "value": "wood river junction"
  },
  {
    "text": "Wood Village",
    "value": "wood village"
  },
  {
    "text": "Wood-Ridge",
    "value": "wood-ridge"
  },
  {
    "text": "Woodacre",
    "value": "woodacre"
  },
  {
    "text": "Woodberry Forest",
    "value": "woodberry forest"
  },
  {
    "text": "Woodbine",
    "value": "woodbine"
  },
  {
    "text": "Woodbourne",
    "value": "woodbourne"
  },
  {
    "text": "Woodbridge",
    "value": "woodbridge"
  },
  {
    "text": "Woodburn",
    "value": "woodburn"
  },
  {
    "text": "Woodbury",
    "value": "woodbury"
  },
  {
    "text": "Woodbury Heights",
    "value": "woodbury heights"
  },
  {
    "text": "Woodcliff Lake",
    "value": "woodcliff lake"
  },
  {
    "text": "Woodfield",
    "value": "woodfield"
  },
  {
    "text": "Woodfin",
    "value": "woodfin"
  },
  {
    "text": "Woodford",
    "value": "woodford"
  },
  {
    "text": "Woodgate",
    "value": "woodgate"
  },
  {
    "text": "Woodhaven",
    "value": "woodhaven"
  },
  {
    "text": "Woodhull",
    "value": "woodhull"
  },
  {
    "text": "Woodinville",
    "value": "woodinville"
  },
  {
    "text": "Woodlake",
    "value": "woodlake"
  },
  {
    "text": "Woodland",
    "value": "woodland"
  },
  {
    "text": "Woodland Heights",
    "value": "woodland heights"
  },
  {
    "text": "Woodland Hills",
    "value": "woodland hills"
  },
  {
    "text": "Woodland Mills",
    "value": "woodland mills"
  },
  {
    "text": "Woodland Park",
    "value": "woodland park"
  },
  {
    "text": "Woodlane",
    "value": "woodlane"
  },
  {
    "text": "Woodlawn",
    "value": "woodlawn"
  },
  {
    "text": "Woodleaf",
    "value": "woodleaf"
  },
  {
    "text": "Woodlyn",
    "value": "woodlyn"
  },
  {
    "text": "Woodman",
    "value": "woodman"
  },
  {
    "text": "Woodmere",
    "value": "woodmere"
  },
  {
    "text": "Woodmoor",
    "value": "woodmoor"
  },
  {
    "text": "Woodridge",
    "value": "woodridge"
  },
  {
    "text": "Woodrow",
    "value": "woodrow"
  },
  {
    "text": "Woodruff",
    "value": "woodruff"
  },
  {
    "text": "Woods Cross",
    "value": "woods cross"
  },
  {
    "text": "Woods Hole",
    "value": "woods hole"
  },
  {
    "text": "Woodsboro",
    "value": "woodsboro"
  },
  {
    "text": "Woodsfield",
    "value": "woodsfield"
  },
  {
    "text": "Woodside",
    "value": "woodside"
  },
  {
    "text": "Woodson",
    "value": "woodson"
  },
  {
    "text": "Woodson Terrace",
    "value": "woodson terrace"
  },
  {
    "text": "Woodstock",
    "value": "woodstock"
  },
  {
    "text": "Woodstock Valley",
    "value": "woodstock valley"
  },
  {
    "text": "Woodston",
    "value": "woodston"
  },
  {
    "text": "Woodstown",
    "value": "woodstown"
  },
  {
    "text": "Woodsville",
    "value": "woodsville"
  },
  {
    "text": "Woodville",
    "value": "woodville"
  },
  {
    "text": "Woodward",
    "value": "woodward"
  },
  {
    "text": "Woodway",
    "value": "woodway"
  },
  {
    "text": "Woodworth",
    "value": "woodworth"
  },
  {
    "text": "Woody",
    "value": "woody"
  },
  {
    "text": "Woody Creek",
    "value": "woody creek"
  },
  {
    "text": "Woolford",
    "value": "woolford"
  },
  {
    "text": "Woolrich",
    "value": "woolrich"
  },
  {
    "text": "Woolstock",
    "value": "woolstock"
  },
  {
    "text": "Woolwich",
    "value": "woolwich"
  },
  {
    "text": "Woolwich Township",
    "value": "woolwich township"
  },
  {
    "text": "Woolwine",
    "value": "woolwine"
  },
  {
    "text": "Woonsocket",
    "value": "woonsocket"
  },
  {
    "text": "Wooster",
    "value": "wooster"
  },
  {
    "text": "Woosung",
    "value": "woosung"
  },
  {
    "text": "Wooton",
    "value": "wooton"
  },
  {
    "text": "Worcester",
    "value": "worcester"
  },
  {
    "text": "Worden",
    "value": "worden"
  },
  {
    "text": "Worland",
    "value": "worland"
  },
  {
    "text": "Worley",
    "value": "worley"
  },
  {
    "text": "Wormleysburg",
    "value": "wormleysburg"
  },
  {
    "text": "Worth",
    "value": "worth"
  },
  {
    "text": "Wortham",
    "value": "wortham"
  },
  {
    "text": "Worthing",
    "value": "worthing"
  },
  {
    "text": "Worthington",
    "value": "worthington"
  },
  {
    "text": "Worthington Center",
    "value": "worthington center"
  },
  {
    "text": "Worthington Springs",
    "value": "worthington springs"
  },
  {
    "text": "Worthville",
    "value": "worthville"
  },
  {
    "text": "Worton",
    "value": "worton"
  },
  {
    "text": "Wounded Knee",
    "value": "wounded knee"
  },
  {
    "text": "Wrangell",
    "value": "wrangell"
  },
  {
    "text": "Wray",
    "value": "wray"
  },
  {
    "text": "Wren",
    "value": "wren"
  },
  {
    "text": "Wrens",
    "value": "wrens"
  },
  {
    "text": "Wrenshall",
    "value": "wrenshall"
  },
  {
    "text": "Wrentham",
    "value": "wrentham"
  },
  {
    "text": "Wright",
    "value": "wright"
  },
  {
    "text": "Wright City",
    "value": "wright city"
  },
  {
    "text": "Wright-Patterson Air Force Base",
    "value": "wright-patterson air force base"
  },
  {
    "text": "Wrightstown",
    "value": "wrightstown"
  },
  {
    "text": "Wrightsville",
    "value": "wrightsville"
  },
  {
    "text": "Wrightsville Beach",
    "value": "wrightsville beach"
  },
  {
    "text": "Wrightwood",
    "value": "wrightwood"
  },
  {
    "text": "Wurtsboro",
    "value": "wurtsboro"
  },
  {
    "text": "Wyaconda",
    "value": "wyaconda"
  },
  {
    "text": "Wyalusing",
    "value": "wyalusing"
  },
  {
    "text": "Wyandanch",
    "value": "wyandanch"
  },
  {
    "text": "Wyandotte",
    "value": "wyandotte"
  },
  {
    "text": "Wyanet",
    "value": "wyanet"
  },
  {
    "text": "Wyano",
    "value": "wyano"
  },
  {
    "text": "Wyarno",
    "value": "wyarno"
  },
  {
    "text": "Wyatt",
    "value": "wyatt"
  },
  {
    "text": "Wyckoff",
    "value": "wyckoff"
  },
  {
    "text": "Wycombe",
    "value": "wycombe"
  },
  {
    "text": "Wye Mills",
    "value": "wye mills"
  },
  {
    "text": "Wykoff",
    "value": "wykoff"
  },
  {
    "text": "Wyldwood",
    "value": "wyldwood"
  },
  {
    "text": "Wylie",
    "value": "wylie"
  },
  {
    "text": "Wylliesburg",
    "value": "wylliesburg"
  },
  {
    "text": "Wymore",
    "value": "wymore"
  },
  {
    "text": "Wynantskill",
    "value": "wynantskill"
  },
  {
    "text": "Wyncote",
    "value": "wyncote"
  },
  {
    "text": "Wyndmere",
    "value": "wyndmere"
  },
  {
    "text": "Wyndmoor",
    "value": "wyndmoor"
  },
  {
    "text": "Wynne",
    "value": "wynne"
  },
  {
    "text": "Wynnewood",
    "value": "wynnewood"
  },
  {
    "text": "Wynona",
    "value": "wynona"
  },
  {
    "text": "Wynot",
    "value": "wynot"
  },
  {
    "text": "Wyocena",
    "value": "wyocena"
  },
  {
    "text": "Wyola",
    "value": "wyola"
  },
  {
    "text": "Wyoming",
    "value": "wyoming"
  },
  {
    "text": "Wyomissing",
    "value": "wyomissing"
  },
  {
    "text": "Wysox",
    "value": "wysox"
  },
  {
    "text": "Wytheville",
    "value": "wytheville"
  },
  {
    "text": "Wytopitlock",
    "value": "wytopitlock"
  },
  {
    "text": "Xenia",
    "value": "xenia"
  },
  {
    "text": "Yachats",
    "value": "yachats"
  },
  {
    "text": "Yacolt",
    "value": "yacolt"
  },
  {
    "text": "Yadkinville",
    "value": "yadkinville"
  },
  {
    "text": "Yakima",
    "value": "yakima"
  },
  {
    "text": "Yakutat",
    "value": "yakutat"
  },
  {
    "text": "Yalaha",
    "value": "yalaha"
  },
  {
    "text": "Yale",
    "value": "yale"
  },
  {
    "text": "Yamhill",
    "value": "yamhill"
  },
  {
    "text": "Yampa",
    "value": "yampa"
  },
  {
    "text": "Yancey",
    "value": "yancey"
  },
  {
    "text": "Yanceyville",
    "value": "yanceyville"
  },
  {
    "text": "Yankeetown",
    "value": "yankeetown"
  },
  {
    "text": "Yankton",
    "value": "yankton"
  },
  {
    "text": "Yantic",
    "value": "yantic"
  },
  {
    "text": "Yantis",
    "value": "yantis"
  },
  {
    "text": "Yaphank",
    "value": "yaphank"
  },
  {
    "text": "Yardley",
    "value": "yardley"
  },
  {
    "text": "Yardville",
    "value": "yardville"
  },
  {
    "text": "Yarmouth",
    "value": "yarmouth"
  },
  {
    "text": "Yarmouth Port",
    "value": "yarmouth port"
  },
  {
    "text": "Yarnell",
    "value": "yarnell"
  },
  {
    "text": "Yarrow Point",
    "value": "yarrow point"
  },
  {
    "text": "Yatahey",
    "value": "yatahey"
  },
  {
    "text": "Yates Center",
    "value": "yates center"
  },
  {
    "text": "Yates City",
    "value": "yates city"
  },
  {
    "text": "Yatesboro",
    "value": "yatesboro"
  },
  {
    "text": "Yatesville",
    "value": "yatesville"
  },
  {
    "text": "Yawkey",
    "value": "yawkey"
  },
  {
    "text": "Yazoo City",
    "value": "yazoo city"
  },
  {
    "text": "Yeaddiss",
    "value": "yeaddiss"
  },
  {
    "text": "Yeadon",
    "value": "yeadon"
  },
  {
    "text": "Yeagertown",
    "value": "yeagertown"
  },
  {
    "text": "Yellow Pine",
    "value": "yellow pine"
  },
  {
    "text": "Yellow Spring",
    "value": "yellow spring"
  },
  {
    "text": "Yellow Springs",
    "value": "yellow springs"
  },
  {
    "text": "Yellowstone National Park",
    "value": "yellowstone national park"
  },
  {
    "text": "Yellowstone National Park County (historical)",
    "value": "yellowstone national park county (historical)"
  },
  {
    "text": "Yellville",
    "value": "yellville"
  },
  {
    "text": "Yelm",
    "value": "yelm"
  },
  {
    "text": "Yemassee",
    "value": "yemassee"
  },
  {
    "text": "Yeoman",
    "value": "yeoman"
  },
  {
    "text": "Yerington",
    "value": "yerington"
  },
  {
    "text": "Yerkes",
    "value": "yerkes"
  },
  {
    "text": "Yermo",
    "value": "yermo"
  },
  {
    "text": "Yettem",
    "value": "yettem"
  },
  {
    "text": "Yoakum",
    "value": "yoakum"
  },
  {
    "text": "Yoder",
    "value": "yoder"
  },
  {
    "text": "Yoe",
    "value": "yoe"
  },
  {
    "text": "Yolo",
    "value": "yolo"
  },
  {
    "text": "Yoncalla",
    "value": "yoncalla"
  },
  {
    "text": "Yonkers",
    "value": "yonkers"
  },
  {
    "text": "Yorba Linda",
    "value": "yorba linda"
  },
  {
    "text": "York",
    "value": "york"
  },
  {
    "text": "York Beach",
    "value": "york beach"
  },
  {
    "text": "York Harbor",
    "value": "york harbor"
  },
  {
    "text": "York Haven",
    "value": "york haven"
  },
  {
    "text": "York Springs",
    "value": "york springs"
  },
  {
    "text": "York Village",
    "value": "york village"
  },
  {
    "text": "Yorklyn",
    "value": "yorklyn"
  },
  {
    "text": "Yorkshire",
    "value": "yorkshire"
  },
  {
    "text": "Yorktown",
    "value": "yorktown"
  },
  {
    "text": "Yorktown Heights",
    "value": "yorktown heights"
  },
  {
    "text": "Yorkville",
    "value": "yorkville"
  },
  {
    "text": "Yosemite",
    "value": "yosemite"
  },
  {
    "text": "Yosemite National Park",
    "value": "yosemite national park"
  },
  {
    "text": "Yosemite Valley",
    "value": "yosemite valley"
  },
  {
    "text": "Yosemite Village",
    "value": "yosemite village"
  },
  {
    "text": "Young",
    "value": "young"
  },
  {
    "text": "Young America",
    "value": "young america"
  },
  {
    "text": "Young Harris",
    "value": "young harris"
  },
  {
    "text": "Youngstown",
    "value": "youngstown"
  },
  {
    "text": "Youngsville",
    "value": "youngsville"
  },
  {
    "text": "Youngtown",
    "value": "youngtown"
  },
  {
    "text": "Youngwood",
    "value": "youngwood"
  },
  {
    "text": "Yountville",
    "value": "yountville"
  },
  {
    "text": "Ypsilanti",
    "value": "ypsilanti"
  },
  {
    "text": "Yreka",
    "value": "yreka"
  },
  {
    "text": "Yuba City",
    "value": "yuba city"
  },
  {
    "text": "Yucaipa",
    "value": "yucaipa"
  },
  {
    "text": "Yucca",
    "value": "yucca"
  },
  {
    "text": "Yucca Valley",
    "value": "yucca valley"
  },
  {
    "text": "Yukon",
    "value": "yukon"
  },
  {
    "text": "Yulan",
    "value": "yulan"
  },
  {
    "text": "Yulee",
    "value": "yulee"
  },
  {
    "text": "Yuma",
    "value": "yuma"
  },
  {
    "text": "Yutan",
    "value": "yutan"
  },
  {
    "text": "Zachary",
    "value": "zachary"
  },
  {
    "text": "Zahl",
    "value": "zahl"
  },
  {
    "text": "Zalma",
    "value": "zalma"
  },
  {
    "text": "Zamora",
    "value": "zamora"
  },
  {
    "text": "Zanesfield",
    "value": "zanesfield"
  },
  {
    "text": "Zanesville",
    "value": "zanesville"
  },
  {
    "text": "Zap",
    "value": "zap"
  },
  {
    "text": "Zapata",
    "value": "zapata"
  },
  {
    "text": "Zavalla",
    "value": "zavalla"
  },
  {
    "text": "Zearing",
    "value": "zearing"
  },
  {
    "text": "Zebulon",
    "value": "zebulon"
  },
  {
    "text": "Zeeland",
    "value": "zeeland"
  },
  {
    "text": "Zeigler",
    "value": "zeigler"
  },
  {
    "text": "Zelienople",
    "value": "zelienople"
  },
  {
    "text": "Zellwood",
    "value": "zellwood"
  },
  {
    "text": "Zenda",
    "value": "zenda"
  },
  {
    "text": "Zephyr",
    "value": "zephyr"
  },
  {
    "text": "Zephyr Cove",
    "value": "zephyr cove"
  },
  {
    "text": "Zephyrhills",
    "value": "zephyrhills"
  },
  {
    "text": "Zieglerville",
    "value": "zieglerville"
  },
  {
    "text": "Zillah",
    "value": "zillah"
  },
  {
    "text": "Zilwaukee",
    "value": "zilwaukee"
  },
  {
    text: "Zimmerman",
    "value": "zimmerman"
  },
  {
    "text": "Zion",
    "value": "zion"
  },
  {
    "text": "Zion Grove",
    "value": "zion grove"
  },
  {
    "text": "Zionhill",
    "value": "zionhill"
  },
  {
    "text": "Zionsville",
    "value": "zionsville"
  },
  {
    "text": "Zionville",
    "value": "zionville"
  },
  {
    "text": "Zirconia",
    "value": "zirconia"
  },
  {
    "text": "Zoar",
    "value": "zoar"
  },
  {
    "text": "Zolfo Springs",
    "value": "zolfo springs"
  },
  {
    "text": "Zortman",
    "value": "zortman"
  },
  {
    "text": "Zumbro Falls",
    "value": "zumbro falls"
  },
  {
    "text": "Zumbrota",
    "value": "zumbrota"
  },
  {
    "text": "Zuni",
    "value": "zuni"
  },
  {
    "text": "Zuni Pueblo",
    "value": "zuni pueblo"
  },
  {
    "text": "Zurich",
    "value": "zurich"
  },
  {
    "text": "Zwingle",
    "value": "zwingle"
  },
  {
    "text": "Zwolle",
    "value": "zwolle"
  }
]
